
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireffde"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireffde"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lMF6r", function(module, exports) {
$parcel$export(module.exports, "default", () => $5094596093709eb2$export$2e2bcd8739ae039);

var $el791 = parcelRequire("el791");
const $5094596093709eb2$var$fontFamily = `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`;
const $5094596093709eb2$var$codeFontFamily = `ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace`;
/* TODO body line height should be 1.25rem */ const $5094596093709eb2$var$_default_1 = (0, $el791.default)`
  body,
  html {
    height: 100%;
    width: 100%;
  }

  body,
	[data-subtree-theme] {
		background-color: ${"var(--ds-surface, #fff)"};
		color: ${"var(--ds-text, #172B4D)"};
		font: ${`var(--ds-font-body, ${`normal 400 14px/1.42857142857143 ${$5094596093709eb2$var$fontFamily}`})`};
	}

	body {
		-ms-overflow-style: -ms-autohiding-scrollbar;
		text-decoration-skip-ink: auto;
	}

  /* Default margins */
  p,
  ul,
  ol,
  dl,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  blockquote,
  pre,
  form,
  table {
    margin: ${"var(--ds-space-150, 12px)"} 0 0 0;
  }

  /* Links */
  a {
    color: ${"var(--ds-link, #0052CC)"};
    text-decoration: none;
  }
  a:hover {
    color: ${"var(--ds-link, #0065FF)"};
    text-decoration: underline;
  }
  a:active {
    color: ${"var(--ds-link-pressed, #0747A6)"};
  }
  a:focus-visible {
    outline: ${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #2684FF)"};
    outline-offset: ${"var(--ds-space-025, 2px)"};
  }
  @supports not selector(*:focus-visible) {
    a:focus {
      outline: ${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4C9AFF)"};
      outline-offset: ${"var(--ds-space-025, 2px)"};
    }
  }
  /* Headings */
  h1 {
    font: ${`var(--ds-font-heading-xlarge, ${`600 2.0714285714285716em/1.103448275862069 ${$5094596093709eb2$var$fontFamily}`})`};
    color: ${"var(--ds-text, #292A2E)"};
    margin-top: ${"var(--ds-space-500, 40px)"};
  }
  h2 {
    font: ${`var(--ds-font-heading-large, ${`500 1.7142857142857142em/1.1666666666666667 ${$5094596093709eb2$var$fontFamily}`})`};
    color: ${"var(--ds-text, #292A2E)"};
    margin-top: ${"var(--ds-space-500, 40px)"};
  }
  h3 {
    font: ${`var(--ds-font-heading-medium, ${`500 1.4285714285714286em/1.2 ${$5094596093709eb2$var$fontFamily}`})`};
    color: ${"var(--ds-text, #292A2E)"};
    margin-top: 28px;
  }
  h4 {
    font: ${`var(--ds-font-heading-small, ${`600 1.1428571428571428em/1.25 ${$5094596093709eb2$var$fontFamily}`})`};
    color: ${"var(--ds-text, #292A2E)"};
    margin-top: ${"var(--ds-space-300, 24px)"};
  }
  h5 {
    font: ${`var(--ds-font-heading-xsmall, ${`600 1em/1.1428571428571428 ${$5094596093709eb2$var$fontFamily}`})`};
    color: ${"var(--ds-text, #292A2E)"};
    margin-top: ${"var(--ds-space-200, 16px)"};
  }
  h6 {
    font: ${`var(--ds-font-heading-xxsmall, ${`600 0.8571428571428571em/1.3333333333333333 ${$5094596093709eb2$var$fontFamily}`})`};
    color: ${"var(--ds-text, #292A2E)"};
    margin-top: ${"var(--ds-space-250, 20px)"};
    text-transform: uppercase;
  }

  /* Lists */
  ul,
  ol,
  dl {
    padding-left: ${"var(--ds-space-500, 40px)"};
  }

  dd,
  dd + dt,
  li + li {
    margin-top: ${"var(--ds-space-050, 4px)"};
  }

  ul ul:not(:first-child),
	ul style:first-child ~ * + ul,
  ol ul:not(:first-child),
	ol style:first-child ~ * + ul,
  ul ol:not(:first-child),
	ul style:first-child ~ * + ol,
  ol ol:not(:first-child),
	ol style:first-child ~ * + ol {
    margin-top: ${"var(--ds-space-050, 4px)"};
  }

  /* remove top margin for first element */
  p:first-child,
  style:first-child + p,
  ul:first-child,
  style:first-child + ul,
  ol:first-child,
  style:first-child + ol,
  dl:first-child,
  style:first-child + dl,
  h1:first-child,
  style:first-child + h1,
  h2:first-child,
  style:first-child + h2,
  h3:first-child,
  style:first-child + h3,
  h4:first-child,
  style:first-child + h4,
  h5:first-child,
  style:first-child + h5,
  h6:first-child,
  style:first-child + h6,
  blockquote:first-child,
  style:first-child + blockquote,
  pre:first-child,
  style:first-child + pre,
  form:first-child,
  style:first-child + form,
  table:first-child,
  style:first-child + table {
    margin-top: 0;
  }

  /* Quotes */
  blockquote,
  q {
    color: inherit;
  }
  blockquote {
    border: none;
    padding-left: ${"var(--ds-space-500, 40px)"};
  }
  [dir='rtl'] blockquote {
    padding-left: 0;
    padding-right: ${"var(--ds-space-500, 40px)"};
  }

  blockquote::before,
  q::before {
    content: '\\201C';
  }

  blockquote::after,
  q::after {
    content: '\\201D';
  }

  blockquote::before {
    float: left;
    /* to keep the quotes left of any child elements like blockquote > p */
    margin-left: -1em;
    text-align: right;
    width: 1em;
  }
  [dir='rtl'] blockquote::before {
    float: right;
    margin-right: -1em;
    text-align: left;
  }

  blockquote > :last-child {
    display: inline-block; /* so the quotes added via pseudos follow it immediately. */
  }

  /* Other typographical elements */
  small {
    font: ${`var(--ds-font-body-small, ${`normal 400 11px/16px ${$5094596093709eb2$var$fontFamily}`})`};
  }

  code,
  kbd {
    font-family: ${`var(--ds-font-family-code, ${`${$5094596093709eb2$var$codeFontFamily}`})`};
  }

  var,
  address,
  dfn,
  cite {
    font-style: italic;
  }

  abbr {
    border-bottom: ${"var(--ds-border-width, 1px)"} ${"var(--ds-border, #ccc)"} dotted;
    cursor: help;
  }

  @supports (color-scheme: dark) and (color-scheme: light) {
    [data-color-mode="light"] {
      color-scheme: light;
    }
    [data-color-mode="dark"] {
      color-scheme: dark;
    }
  }
`;
var $5094596093709eb2$export$2e2bcd8739ae039 = $5094596093709eb2$var$_default_1;

});
parcelRegister("el791", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b62ad063cc50854$export$2e2bcd8739ae039);
/**
 * The below code is inspired by the css function in styled components
 * https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/types.js
 */ function $3b62ad063cc50854$export$2e2bcd8739ae039(styles, ...interpolations) {
    return $3b62ad063cc50854$var$flatten($3b62ad063cc50854$var$interleave(styles, interpolations)).join('');
}
function $3b62ad063cc50854$var$interleave(strings, interpolations) {
    const result = [
        strings[0]
    ];
    for(let i = 0; i < interpolations.length; i++)result.push(interpolations[i], strings[i + 1]);
    return result;
}
function $3b62ad063cc50854$var$flatten(chunks, executionContext = {
    theme: {
        __ATLASKIT_THEME__: {
            mode: 'light'
        }
    }
}) {
    return chunks.reduce((ruleSet, chunk)=>{
        /* Remove falsey values */ if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
        /* Flatten ruleSet */ if (Array.isArray(chunk)) {
            ruleSet.push(...$3b62ad063cc50854$var$flatten(chunk, executionContext));
            return ruleSet;
        }
        /* Either execute or defer the function */ if (typeof chunk === 'function') {
            if (executionContext) {
                const nextChunk = chunk(executionContext);
                ruleSet.push(...$3b62ad063cc50854$var$flatten([
                    nextChunk
                ], executionContext));
            } else ruleSet.push(chunk);
            return ruleSet;
        }
        // TODO: Fix bug in lint rule, this shouldn't be an error!
        ruleSet.push($3b62ad063cc50854$var$isPlainObject(chunk) ? $3b62ad063cc50854$var$objToCss(chunk) : chunk.toString());
        return ruleSet;
    }, []);
}
function $3b62ad063cc50854$var$isPlainObject(x) {
    // TODO: Fix bug in lint rule, this shouldn't be an error!
    return typeof x === 'object' && x.constructor === Object;
}
function $3b62ad063cc50854$var$hyphenate(value) {
    const uppercasePattern = /([A-Z])/g;
    return value.replace(uppercasePattern, '-$1').toLowerCase();
}
function $3b62ad063cc50854$var$objToCss(obj, prevKey) {
    const css = Object.keys(obj).filter((key)=>{
        const chunk = obj[key];
        return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
    }).map((key)=>{
        if ($3b62ad063cc50854$var$isPlainObject(obj[key])) return $3b62ad063cc50854$var$objToCss(obj[key], key);
        return `${$3b62ad063cc50854$var$hyphenate(key)}: ${obj[key]};`;
    }).join(' ');
    return prevKey ? `${prevKey} {
    ${css}
  }` : css;
}

});


parcelRegister("gpIDL", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2b2387d83759390$export$2e2bcd8739ae039);

var $fqz3q = parcelRequire("fqz3q");

var $el791 = parcelRequire("el791");
const $e2b2387d83759390$var$_default_1 = (0, $el791.default)`
  /* IE11 and some older browsers don't support these elements yet and treat them as display: inline; */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section {
    display: block;
  }

  /* Suppress the ugly broken image styling in Firefox */
  @-moz-document url-prefix() {
    img {
      font-size: 0;
    }
    img:-moz-broken {
      font-size: inherit;
    }
  }

/*
  Chrome 83.0.4103.61 introduced a new user-agent style that broke all buttons for us. This default override reverts it.
  chrome user agent added this => font: 400 13.3333px Arial;
*/
button {
  font-family: inherit;
}

${(0, $fqz3q.default)}
`;
var $e2b2387d83759390$export$2e2bcd8739ae039 = $e2b2387d83759390$var$_default_1;

});
parcelRegister("fqz3q", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8defff2ef4867b3$export$2e2bcd8739ae039);

var $el791 = parcelRequire("el791");
const $e8defff2ef4867b3$var$scrollbarStyles = (0, $el791.default)`/*
 * Feature-gated harmonised scrollbar appearance.
 * Visibility and width remain browser managed.
 */
:root[data-scrollbar-harmonisation] {
  scrollbar-color: ${"var(--ds-border-input, #8C8F97)"} ${"var(--ds-elevation-surface-current, #FFFFFF)"};
}

:root[data-scrollbar-harmonisation] * {
  scrollbar-color: ${"var(--ds-border-input, #8C8F97)"} ${"var(--ds-elevation-surface-current, #FFFFFF)"};
}

:root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent],
:root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent] * {
  scrollbar-color: ${"var(--ds-border-input, #8C8F97)"} transparent;
}

:root[data-scrollbar-harmonisation]::-webkit-scrollbar-track,
:root[data-scrollbar-harmonisation]::-webkit-scrollbar-corner,
:root[data-scrollbar-harmonisation] *::-webkit-scrollbar-track,
:root[data-scrollbar-harmonisation] *::-webkit-scrollbar-corner {
  background-color: ${"var(--ds-elevation-surface-current, #FFFFFF)"};
  border: 0;
}

:root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent]::-webkit-scrollbar-track,
:root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent]::-webkit-scrollbar-corner,
:root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent] *::-webkit-scrollbar-track,
:root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent] *::-webkit-scrollbar-corner {
  background-color: transparent;
}

:root[data-scrollbar-harmonisation]::-webkit-scrollbar-thumb,
:root[data-scrollbar-harmonisation] *::-webkit-scrollbar-thumb {
  background-color: ${"var(--ds-border-input, #8C8F97)"};
}

@media (forced-colors: active) {
  :root[data-scrollbar-harmonisation],
  :root[data-scrollbar-harmonisation] *,
  :root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent],
  :root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent] * {
    scrollbar-color: auto;
  }

  :root[data-scrollbar-harmonisation]::-webkit-scrollbar-track,
  :root[data-scrollbar-harmonisation]::-webkit-scrollbar-thumb,
  :root[data-scrollbar-harmonisation]::-webkit-scrollbar-corner,
  :root[data-scrollbar-harmonisation] *::-webkit-scrollbar-track,
  :root[data-scrollbar-harmonisation] *::-webkit-scrollbar-thumb,
  :root[data-scrollbar-harmonisation] *::-webkit-scrollbar-corner,
  :root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent]::-webkit-scrollbar-track,
  :root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent]::-webkit-scrollbar-thumb,
  :root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent]::-webkit-scrollbar-corner,
  :root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent] *::-webkit-scrollbar-track,
  :root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent] *::-webkit-scrollbar-thumb,
  :root[data-scrollbar-harmonisation][data-scrollbar-harmonisation-transparent] *::-webkit-scrollbar-corner {
    background-color: revert;
    border: revert;
  }
}`;
var $e8defff2ef4867b3$export$2e2bcd8739ae039 = $e8defff2ef4867b3$var$scrollbarStyles;

});


parcelRegister("iaNM3", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a2492dd68dbea96$export$2e2bcd8739ae039);

var $el791 = parcelRequire("el791");
const $1a2492dd68dbea96$var$_default_1 = (0, $el791.default)`
  html,
  body,
  p,
  div,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ul,
  ol,
  dl,
  img,
  pre,
  form,
  fieldset {
    margin: 0;
    padding: 0;
  }
  img,
  fieldset {
    border: 0;
  }
`;
var $1a2492dd68dbea96$export$2e2bcd8739ae039 = $1a2492dd68dbea96$var$_default_1;

});

parcelRegister("6Zw1b", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ad6fed1d50490$export$2e2bcd8739ae039);

var $el791 = parcelRequire("el791");
const $989ad6fed1d50490$var$_default_1 = (0, $el791.default)`
  table {
    border-collapse: collapse;
    width: 100%;
  }

  thead,
  tbody,
  tfoot {
    border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #DFE1E6)"};
  }

  td,
  th {
    border: none;
    padding: ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"};
    text-align: left;
  }

  th {
    vertical-align: top;
  }

  td:first-child,
	style:first-child + td,
  th:first-child,
	style:first-child + th {
    padding-left: 0;
  }

  td:last-child,
  th:last-child {
    padding-right: 0;
  }

  caption {
    font: ${"var(--ds-font-heading-medium, 500 1.4285714285714286em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
    letter-spacing: -0.008em;
    color: ${"var(--ds-text, #292A2E)"};
    margin-top: 28px;
    margin-bottom: ${"var(--ds-space-100, 8px)"};
    text-align: left;
  }
`;
var $989ad6fed1d50490$export$2e2bcd8739ae039 = $989ad6fed1d50490$var$_default_1;

});

parcelRegister("eMGcJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e89ce3838c76a0d3$export$2e2bcd8739ae039);

var $el791 = parcelRequire("el791");
const $e89ce3838c76a0d3$var$_default_1 = (0, $el791.default)`
  .assistive {
    border: 0 !important;
    clip: rect(1px, 1px, 1px, 1px) !important;
    height: 1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    width: 1px !important;
    white-space: nowrap !important;
  }
`;
var $e89ce3838c76a0d3$export$2e2bcd8739ae039 = $e89ce3838c76a0d3$var$_default_1;

});

parcelRegister("7y4ZL", function(module, exports) {
var $57ef9555778ad8e8$var$core = module.exports = {
    version: '2.6.2'
};
if (typeof __e == 'number') __e = $57ef9555778ad8e8$var$core; // eslint-disable-line no-undef

});

parcelRegister("vr8t0", function(module, exports) {

var $6CKsg = parcelRequire("6CKsg");

var $8ZvAE = parcelRequire("8ZvAE");

module.exports = (parcelRequire("leD2I")) ? function(object, key, value) {
    return $6CKsg.f(object, key, $8ZvAE(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("6CKsg", function(module, exports) {
$parcel$export(module.exports, "f", () => $4d2a53aa12d0495d$export$2d1720544b23b823, (v) => $4d2a53aa12d0495d$export$2d1720544b23b823 = v);
var $4d2a53aa12d0495d$export$2d1720544b23b823;

var $58lSR = parcelRequire("58lSR");

var $7hv51 = parcelRequire("7hv51");

var $iuwIe = parcelRequire("iuwIe");
var $4d2a53aa12d0495d$var$dP = Object.defineProperty;

$4d2a53aa12d0495d$export$2d1720544b23b823 = (parcelRequire("leD2I")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $58lSR(O);
    P = $iuwIe(P, true);
    $58lSR(Attributes);
    if ($7hv51) try {
        return $4d2a53aa12d0495d$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("58lSR", function(module, exports) {

var $f87WO = parcelRequire("f87WO");
module.exports = function(it) {
    if (!$f87WO(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("f87WO", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("7hv51", function(module, exports) {



module.exports = !(parcelRequire("leD2I")) && !(parcelRequire("7clcL"))(function() {
    return Object.defineProperty((parcelRequire("8jcSC"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("leD2I", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("7clcL"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("7clcL", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("8jcSC", function(module, exports) {

var $f87WO = parcelRequire("f87WO");

var $iR5RQ = parcelRequire("iR5RQ");
var $60ca16c46b62dd73$require$document = $iR5RQ.document;
// typeof document.createElement is 'object' in old IE
var $60ca16c46b62dd73$var$is = $f87WO($60ca16c46b62dd73$require$document) && $f87WO($60ca16c46b62dd73$require$document.createElement);
module.exports = function(it) {
    return $60ca16c46b62dd73$var$is ? $60ca16c46b62dd73$require$document.createElement(it) : {};
};

});
parcelRegister("iR5RQ", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $dba1ba626859a249$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $dba1ba626859a249$var$global; // eslint-disable-line no-undef

});



parcelRegister("iuwIe", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $f87WO = parcelRequire("f87WO");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$f87WO(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$f87WO(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$f87WO(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$f87WO(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("8ZvAE", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("if6L8", function(module, exports) {

var $iR5RQ = parcelRequire("iR5RQ");

var $vr8t0 = parcelRequire("vr8t0");

var $ezZa4 = parcelRequire("ezZa4");

var $d47edefa2355a2df$var$SRC = (parcelRequire("cVGL6"))('src');
var $d47edefa2355a2df$var$TO_STRING = 'toString';
var $d47edefa2355a2df$var$$toString = Function[$d47edefa2355a2df$var$TO_STRING];
var $d47edefa2355a2df$var$TPL = ('' + $d47edefa2355a2df$var$$toString).split($d47edefa2355a2df$var$TO_STRING);

(parcelRequire("7y4ZL")).inspectSource = function(it) {
    return $d47edefa2355a2df$var$$toString.call(it);
};
(module.exports = function(O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) $ezZa4(val, 'name') || $vr8t0(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) $ezZa4(val, $d47edefa2355a2df$var$SRC) || $vr8t0(val, $d47edefa2355a2df$var$SRC, O[key] ? '' + O[key] : $d47edefa2355a2df$var$TPL.join(String(key)));
    if (O === $iR5RQ) O[key] = val;
    else if (!safe) {
        delete O[key];
        $vr8t0(O, key, val);
    } else if (O[key]) O[key] = val;
    else $vr8t0(O, key, val);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, $d47edefa2355a2df$var$TO_STRING, function toString() {
    return typeof this == 'function' && this[$d47edefa2355a2df$var$SRC] || $d47edefa2355a2df$var$$toString.call(this);
});

});
parcelRegister("ezZa4", function(module, exports) {
var $a9d3c6f3fc786458$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $a9d3c6f3fc786458$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("cVGL6", function(module, exports) {
var $969bf9e42913fc81$var$id = 0;
var $969bf9e42913fc81$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$969bf9e42913fc81$var$id + $969bf9e42913fc81$var$px).toString(36));
};

});


parcelRegister("h2gZM", function(module, exports) {
// optional / simple context binding

var $fHwTO = parcelRequire("fHwTO");
module.exports = function(fn, that, length) {
    $fHwTO(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("fHwTO", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("5HVL6", function(module, exports) {
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';

var $1Wq2M = parcelRequire("1Wq2M");

var $jQEhC = parcelRequire("jQEhC");

var $217we = parcelRequire("217we");
module.exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $1Wq2M(this);
    var length = $217we(O.length);
    var aLen = arguments.length;
    var index = $jQEhC(aLen > 1 ? arguments[1] : undefined, length);
    var end = aLen > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $jQEhC(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};

});
parcelRegister("1Wq2M", function(module, exports) {
// 7.1.13 ToObject(argument)

var $fSXfQ = parcelRequire("fSXfQ");
module.exports = function(it) {
    return Object($fSXfQ(it));
};

});
parcelRegister("fSXfQ", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("jQEhC", function(module, exports) {

var $jrCQV = parcelRequire("jrCQV");
var $e7321f1227c5858e$var$max = Math.max;
var $e7321f1227c5858e$var$min = Math.min;
module.exports = function(index, length) {
    index = $jrCQV(index);
    return index < 0 ? $e7321f1227c5858e$var$max(index + length, 0) : $e7321f1227c5858e$var$min(index, length);
};

});
parcelRegister("jrCQV", function(module, exports) {
// 7.1.4 ToInteger
var $e27ead495db0db88$var$ceil = Math.ceil;
var $e27ead495db0db88$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $e27ead495db0db88$var$floor : $e27ead495db0db88$var$ceil)(it);
};

});


parcelRegister("217we", function(module, exports) {
// 7.1.15 ToLength

var $jrCQV = parcelRequire("jrCQV");
var $178181d98c36f2e1$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $178181d98c36f2e1$var$min($jrCQV(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});


parcelRegister("04hvK", function(module, exports) {
// 22.1.3.31 Array.prototype[@@unscopables]

var $00cdf5259b68e4b7$var$UNSCOPABLES = (parcelRequire("jZx91"))('unscopables');
var $00cdf5259b68e4b7$var$ArrayProto = Array.prototype;

if ($00cdf5259b68e4b7$var$ArrayProto[$00cdf5259b68e4b7$var$UNSCOPABLES] == undefined) (parcelRequire("vr8t0"))($00cdf5259b68e4b7$var$ArrayProto, $00cdf5259b68e4b7$var$UNSCOPABLES, {});
module.exports = function(key) {
    $00cdf5259b68e4b7$var$ArrayProto[$00cdf5259b68e4b7$var$UNSCOPABLES][key] = true;
};

});
parcelRegister("jZx91", function(module, exports) {

var $e8dd6ca597a2192f$var$store = (parcelRequire("cxkBF"))('wks');

var $cVGL6 = parcelRequire("cVGL6");

var $iR5RQ = parcelRequire("iR5RQ");
var $e8dd6ca597a2192f$require$Symbol = $iR5RQ.Symbol;
var $e8dd6ca597a2192f$var$USE_SYMBOL = typeof $e8dd6ca597a2192f$require$Symbol == 'function';
var $e8dd6ca597a2192f$var$$exports = module.exports = function(name) {
    return $e8dd6ca597a2192f$var$store[name] || ($e8dd6ca597a2192f$var$store[name] = $e8dd6ca597a2192f$var$USE_SYMBOL && $e8dd6ca597a2192f$require$Symbol[name] || ($e8dd6ca597a2192f$var$USE_SYMBOL ? $e8dd6ca597a2192f$require$Symbol : $cVGL6)('Symbol.' + name));
};
$e8dd6ca597a2192f$var$$exports.store = $e8dd6ca597a2192f$var$store;

});
parcelRegister("cxkBF", function(module, exports) {

var $7y4ZL = parcelRequire("7y4ZL");

var $iR5RQ = parcelRequire("iR5RQ");
var $92088d278d3b8ac2$var$SHARED = '__core-js_shared__';
var $92088d278d3b8ac2$var$store = $iR5RQ[$92088d278d3b8ac2$var$SHARED] || ($iR5RQ[$92088d278d3b8ac2$var$SHARED] = {});

(module.exports = function(key, value) {
    return $92088d278d3b8ac2$var$store[key] || ($92088d278d3b8ac2$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $7y4ZL.version,
    mode: (parcelRequire("ckEMC")) ? 'pure' : 'global',
    copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("ckEMC", function(module, exports) {
module.exports = false;

});




parcelRegister("13ySl", function(module, exports) {
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex

var $h2gZM = parcelRequire("h2gZM");

var $7LajF = parcelRequire("7LajF");

var $1Wq2M = parcelRequire("1Wq2M");

var $217we = parcelRequire("217we");

var $eAY0l = parcelRequire("eAY0l");
module.exports = function(TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || $eAY0l;
    return function($this, callbackfn, that) {
        var O = $1Wq2M($this);
        var self = $7LajF(O);
        var f = $h2gZM(callbackfn, that, 3);
        var length = $217we(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            val = self[index];
            res = f(val, index, O);
            if (TYPE) {
                if (IS_MAP) result[index] = res; // map
                else if (res) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return val; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        result.push(val); // filter
                }
                else if (IS_EVERY) return false; // every
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
};

});
parcelRegister("7LajF", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $3rACp = parcelRequire("3rACp");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $3rACp(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("3rACp", function(module, exports) {
var $28204c62106d3f48$var$toString = {}.toString;
module.exports = function(it) {
    return $28204c62106d3f48$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("eAY0l", function(module, exports) {
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)

var $g5m9L = parcelRequire("g5m9L");
module.exports = function(original, length) {
    return new ($g5m9L(original))(length);
};

});
parcelRegister("g5m9L", function(module, exports) {

var $f87WO = parcelRequire("f87WO");

var $jpcQD = parcelRequire("jpcQD");

var $bb5e4ccb3566b735$var$SPECIES = (parcelRequire("jZx91"))('species');
module.exports = function(original) {
    var C;
    if ($jpcQD(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || $jpcQD(C.prototype))) C = undefined;
        if ($f87WO(C)) {
            C = C[$bb5e4ccb3566b735$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? Array : C;
};

});
parcelRegister("jpcQD", function(module, exports) {
// 7.2.2 IsArray(argument)

var $3rACp = parcelRequire("3rACp");
module.exports = Array.isArray || function isArray(arg) {
    return $3rACp(arg) == 'Array';
};

});




parcelRegister("hkQtO", function(module, exports) {

var $jrCQV = parcelRequire("jrCQV");

var $fSXfQ = parcelRequire("fSXfQ");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($fSXfQ(that));
        var i = $jrCQV(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("41dFV", function(module, exports) {
'use strict';

var $ckEMC = parcelRequire("ckEMC");

var $j1pco = parcelRequire("j1pco");

var $if6L8 = parcelRequire("if6L8");

var $vr8t0 = parcelRequire("vr8t0");

var $8grU2 = parcelRequire("8grU2");

var $3B2Xw = parcelRequire("3B2Xw");

var $fYbBX = parcelRequire("fYbBX");

var $7LGMk = parcelRequire("7LGMk");

var $2ed1dd03d5089303$var$ITERATOR = (parcelRequire("jZx91"))('iterator');
var $2ed1dd03d5089303$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $2ed1dd03d5089303$var$FF_ITERATOR = '@@iterator';
var $2ed1dd03d5089303$var$KEYS = 'keys';
var $2ed1dd03d5089303$var$VALUES = 'values';
var $2ed1dd03d5089303$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $3B2Xw(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$2ed1dd03d5089303$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $2ed1dd03d5089303$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $2ed1dd03d5089303$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $2ed1dd03d5089303$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$2ed1dd03d5089303$var$ITERATOR] || proto[$2ed1dd03d5089303$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $7LGMk($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $fYbBX(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$ckEMC && typeof IteratorPrototype[$2ed1dd03d5089303$var$ITERATOR] != 'function') $vr8t0(IteratorPrototype, $2ed1dd03d5089303$var$ITERATOR, $2ed1dd03d5089303$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $2ed1dd03d5089303$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$ckEMC || FORCED) && ($2ed1dd03d5089303$var$BUGGY || VALUES_BUG || !proto[$2ed1dd03d5089303$var$ITERATOR])) $vr8t0(proto, $2ed1dd03d5089303$var$ITERATOR, $default);
    // Plug for library
    $8grU2[NAME] = $default;
    $8grU2[TAG] = $2ed1dd03d5089303$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($2ed1dd03d5089303$var$VALUES),
            keys: IS_SET ? $default : getMethod($2ed1dd03d5089303$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $if6L8(proto, key, methods[key]);
        } else $j1pco($j1pco.P + $j1pco.F * ($2ed1dd03d5089303$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("j1pco", function(module, exports) {

var $iR5RQ = parcelRequire("iR5RQ");

var $7y4ZL = parcelRequire("7y4ZL");

var $vr8t0 = parcelRequire("vr8t0");

var $if6L8 = parcelRequire("if6L8");

var $h2gZM = parcelRequire("h2gZM");
var $dd91a84e4bf913b2$var$PROTOTYPE = 'prototype';
var $dd91a84e4bf913b2$var$$export = function(type, name, source) {
    var IS_FORCED = type & $dd91a84e4bf913b2$var$$export.F;
    var IS_GLOBAL = type & $dd91a84e4bf913b2$var$$export.G;
    var IS_STATIC = type & $dd91a84e4bf913b2$var$$export.S;
    var IS_PROTO = type & $dd91a84e4bf913b2$var$$export.P;
    var IS_BIND = type & $dd91a84e4bf913b2$var$$export.B;
    var target = IS_GLOBAL ? $iR5RQ : IS_STATIC ? $iR5RQ[name] || ($iR5RQ[name] = {}) : ($iR5RQ[name] || {})[$dd91a84e4bf913b2$var$PROTOTYPE];
    var exports = IS_GLOBAL ? $7y4ZL : $7y4ZL[name] || ($7y4ZL[name] = {});
    var expProto = exports[$dd91a84e4bf913b2$var$PROTOTYPE] || (exports[$dd91a84e4bf913b2$var$PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        // export native or passed
        out = (own ? target : source)[key];
        // bind timers to global for call from export context
        exp = IS_BIND && own ? $h2gZM(out, $iR5RQ) : IS_PROTO && typeof out == 'function' ? $h2gZM(Function.call, out) : out;
        // extend global
        if (target) $if6L8(target, key, out, type & $dd91a84e4bf913b2$var$$export.U);
        // export
        if (exports[key] != out) $vr8t0(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
};
$iR5RQ.core = $7y4ZL;
// type bitmap
$dd91a84e4bf913b2$var$$export.F = 1; // forced
$dd91a84e4bf913b2$var$$export.G = 2; // global
$dd91a84e4bf913b2$var$$export.S = 4; // static
$dd91a84e4bf913b2$var$$export.P = 8; // proto
$dd91a84e4bf913b2$var$$export.B = 16; // bind
$dd91a84e4bf913b2$var$$export.W = 32; // wrap
$dd91a84e4bf913b2$var$$export.U = 64; // safe
$dd91a84e4bf913b2$var$$export.R = 128; // real proto method for `library`
module.exports = $dd91a84e4bf913b2$var$$export;

});

parcelRegister("8grU2", function(module, exports) {
module.exports = {};

});

parcelRegister("3B2Xw", function(module, exports) {
'use strict';

var $f48dC = parcelRequire("f48dC");

var $8ZvAE = parcelRequire("8ZvAE");

var $fYbBX = parcelRequire("fYbBX");
var $29e71f66cfebd2e5$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("vr8t0"))($29e71f66cfebd2e5$var$IteratorPrototype, (parcelRequire("jZx91"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $f48dC($29e71f66cfebd2e5$var$IteratorPrototype, {
        next: $8ZvAE(1, next)
    });
    $fYbBX(Constructor, NAME + ' Iterator');
};

});
parcelRegister("f48dC", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $58lSR = parcelRequire("58lSR");

var $3D2LJ = parcelRequire("3D2LJ");

var $lrEQJ = parcelRequire("lrEQJ");

var $02d49b4541fe7240$var$IE_PROTO = (parcelRequire("jgdwB"))('IE_PROTO');
var $02d49b4541fe7240$var$Empty = function() {};
var $02d49b4541fe7240$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $02d49b4541fe7240$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("8jcSC"))('iframe');
    var i = $lrEQJ.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("iXC9j")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $02d49b4541fe7240$var$createDict = iframeDocument.F;
    while(i--)delete $02d49b4541fe7240$var$createDict[$02d49b4541fe7240$var$PROTOTYPE][$lrEQJ[i]];
    return $02d49b4541fe7240$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $02d49b4541fe7240$var$Empty[$02d49b4541fe7240$var$PROTOTYPE] = $58lSR(O);
        result = new $02d49b4541fe7240$var$Empty();
        $02d49b4541fe7240$var$Empty[$02d49b4541fe7240$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$02d49b4541fe7240$var$IE_PROTO] = O;
    } else result = $02d49b4541fe7240$var$createDict();
    return Properties === undefined ? result : $3D2LJ(result, Properties);
};

});
parcelRegister("3D2LJ", function(module, exports) {

var $6CKsg = parcelRequire("6CKsg");

var $58lSR = parcelRequire("58lSR");

var $2mdEd = parcelRequire("2mdEd");

module.exports = (parcelRequire("leD2I")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $58lSR(O);
    var keys = $2mdEd(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$6CKsg.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("2mdEd", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $92WJJ = parcelRequire("92WJJ");

var $lrEQJ = parcelRequire("lrEQJ");
module.exports = Object.keys || function keys(O) {
    return $92WJJ(O, $lrEQJ);
};

});
parcelRegister("92WJJ", function(module, exports) {

var $ezZa4 = parcelRequire("ezZa4");

var $3dpeK = parcelRequire("3dpeK");

var $6961dcd8ba257f44$var$arrayIndexOf = (parcelRequire("fHwaf"))(false);

var $6961dcd8ba257f44$var$IE_PROTO = (parcelRequire("jgdwB"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $3dpeK(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $6961dcd8ba257f44$var$IE_PROTO) $ezZa4(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($ezZa4(O, key = names[i++])) ~$6961dcd8ba257f44$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("3dpeK", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $7LajF = parcelRequire("7LajF");

var $fSXfQ = parcelRequire("fSXfQ");
module.exports = function(it) {
    return $7LajF($fSXfQ(it));
};

});

parcelRegister("fHwaf", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $3dpeK = parcelRequire("3dpeK");

var $217we = parcelRequire("217we");

var $jQEhC = parcelRequire("jQEhC");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $3dpeK($this);
        var length = $217we(O.length);
        var index = $jQEhC(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});

parcelRegister("jgdwB", function(module, exports) {

var $e05a00ae6f4ff195$var$shared = (parcelRequire("cxkBF"))('keys');

var $cVGL6 = parcelRequire("cVGL6");
module.exports = function(key) {
    return $e05a00ae6f4ff195$var$shared[key] || ($e05a00ae6f4ff195$var$shared[key] = $cVGL6(key));
};

});


parcelRegister("lrEQJ", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("iXC9j", function(module, exports) {

var $iR5RQ = parcelRequire("iR5RQ");
var $dcdb5457d7abaeb2$require$document = $iR5RQ.document;
module.exports = $dcdb5457d7abaeb2$require$document && $dcdb5457d7abaeb2$require$document.documentElement;

});


parcelRegister("fYbBX", function(module, exports) {

var $6CKsg = parcelRequire("6CKsg");
var $ba05775f16419962$require$def = $6CKsg.f;

var $ezZa4 = parcelRequire("ezZa4");

var $ba05775f16419962$var$TAG = (parcelRequire("jZx91"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$ezZa4(it = stat ? it : it.prototype, $ba05775f16419962$var$TAG)) $ba05775f16419962$require$def(it, $ba05775f16419962$var$TAG, {
        configurable: true,
        value: tag
    });
};

});


parcelRegister("7LGMk", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $ezZa4 = parcelRequire("ezZa4");

var $1Wq2M = parcelRequire("1Wq2M");

var $5a7e1b154d6a9824$var$IE_PROTO = (parcelRequire("jgdwB"))('IE_PROTO');
var $5a7e1b154d6a9824$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $1Wq2M(O);
    if ($ezZa4(O, $5a7e1b154d6a9824$var$IE_PROTO)) return O[$5a7e1b154d6a9824$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $5a7e1b154d6a9824$var$ObjectProto : null;
};

});


parcelRegister("8fqBw", function(module, exports) {

var $60145c8066d143ae$var$ITERATOR = (parcelRequire("jZx91"))('iterator');
var $60145c8066d143ae$var$SAFE_CLOSING = false;
try {
    var $60145c8066d143ae$var$riter = [
        7
    ][$60145c8066d143ae$var$ITERATOR]();
    $60145c8066d143ae$var$riter['return'] = function() {
        $60145c8066d143ae$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($60145c8066d143ae$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$60145c8066d143ae$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$60145c8066d143ae$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$60145c8066d143ae$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});

parcelRegister("75rkt", function(module, exports) {
'use strict';

var $iR5RQ = parcelRequire("iR5RQ");

var $j1pco = parcelRequire("j1pco");

var $if6L8 = parcelRequire("if6L8");

var $1PH8x = parcelRequire("1PH8x");

var $7Z8vr = parcelRequire("7Z8vr");

var $j61VM = parcelRequire("j61VM");

var $9rpke = parcelRequire("9rpke");

var $f87WO = parcelRequire("f87WO");

var $7clcL = parcelRequire("7clcL");

var $8fqBw = parcelRequire("8fqBw");

var $fYbBX = parcelRequire("fYbBX");

var $ldNTA = parcelRequire("ldNTA");
module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = $iR5RQ[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};
    var fixMethod = function(KEY) {
        var fn = proto[KEY];
        $if6L8(proto, KEY, KEY == 'delete' ? function(a) {
            return IS_WEAK && !$f87WO(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'has' ? function has(a) {
            return IS_WEAK && !$f87WO(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'get' ? function get(a) {
            return IS_WEAK && !$f87WO(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'add' ? function add(a) {
            fn.call(this, a === 0 ? 0 : a);
            return this;
        } : function set(a, b) {
            fn.call(this, a === 0 ? 0 : a, b);
            return this;
        });
    };
    if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !$7clcL(function() {
        new C().entries().next();
    }))) {
        // create collection constructor
        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
        $1PH8x(C.prototype, methods);
        $7Z8vr.NEED = true;
    } else {
        var instance = new C();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $7clcL(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        var ACCEPT_ITERABLES = $8fqBw(function(iter) {
            new C(iter);
        }); // eslint-disable-line no-new
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $7clcL(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new C();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            C = wrapper(function(target, iterable) {
                $9rpke(target, C, NAME);
                var that = $ldNTA(new Base(), target, C);
                if (iterable != undefined) $j61VM(iterable, IS_MAP, that[ADDER], that);
                return that;
            });
            C.prototype = proto;
            proto.constructor = C;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && proto.clear) delete proto.clear;
    }
    $fYbBX(C, NAME);
    O[NAME] = C;
    $j1pco($j1pco.G + $j1pco.W + $j1pco.F * (C != Base), O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
};

});
parcelRegister("1PH8x", function(module, exports) {

var $if6L8 = parcelRequire("if6L8");
module.exports = function(target, src, safe) {
    for(var key in src)$if6L8(target, key, src[key], safe);
    return target;
};

});

parcelRegister("7Z8vr", function(module, exports) {

var $5d04d4094e7ccc9a$var$META = (parcelRequire("cVGL6"))('meta');

var $f87WO = parcelRequire("f87WO");

var $ezZa4 = parcelRequire("ezZa4");

var $6CKsg = parcelRequire("6CKsg");
var $5d04d4094e7ccc9a$require$setDesc = $6CKsg.f;
var $5d04d4094e7ccc9a$var$id = 0;
var $5d04d4094e7ccc9a$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $5d04d4094e7ccc9a$var$FREEZE = !(parcelRequire("7clcL"))(function() {
    return $5d04d4094e7ccc9a$var$isExtensible(Object.preventExtensions({}));
});
var $5d04d4094e7ccc9a$var$setMeta = function(it) {
    $5d04d4094e7ccc9a$require$setDesc(it, $5d04d4094e7ccc9a$var$META, {
        value: {
            i: 'O' + ++$5d04d4094e7ccc9a$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $5d04d4094e7ccc9a$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$f87WO(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$ezZa4(it, $5d04d4094e7ccc9a$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$5d04d4094e7ccc9a$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $5d04d4094e7ccc9a$var$setMeta(it);
    // return object ID
    }
    return it[$5d04d4094e7ccc9a$var$META].i;
};
var $5d04d4094e7ccc9a$var$getWeak = function(it, create) {
    if (!$ezZa4(it, $5d04d4094e7ccc9a$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$5d04d4094e7ccc9a$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $5d04d4094e7ccc9a$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$5d04d4094e7ccc9a$var$META].w;
};
// add metadata on freeze-family methods calling
var $5d04d4094e7ccc9a$var$onFreeze = function(it) {
    if ($5d04d4094e7ccc9a$var$FREEZE && $5d04d4094e7ccc9a$var$meta.NEED && $5d04d4094e7ccc9a$var$isExtensible(it) && !$ezZa4(it, $5d04d4094e7ccc9a$var$META)) $5d04d4094e7ccc9a$var$setMeta(it);
    return it;
};
var $5d04d4094e7ccc9a$var$meta = module.exports = {
    KEY: $5d04d4094e7ccc9a$var$META,
    NEED: false,
    fastKey: $5d04d4094e7ccc9a$var$fastKey,
    getWeak: $5d04d4094e7ccc9a$var$getWeak,
    onFreeze: $5d04d4094e7ccc9a$var$onFreeze
};

});

parcelRegister("j61VM", function(module, exports) {

var $h2gZM = parcelRequire("h2gZM");

var $h5z5G = parcelRequire("h5z5G");

var $1zRzE = parcelRequire("1zRzE");

var $58lSR = parcelRequire("58lSR");

var $217we = parcelRequire("217we");

var $hqd6k = parcelRequire("hqd6k");
var $de7013501b96d677$var$BREAK = {};
var $de7013501b96d677$var$RETURN = {};
var $de7013501b96d677$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $hqd6k(iterable);
    var f = $h2gZM(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($1zRzE(iterFn)) for(length = $217we(iterable.length); length > index; index++){
        result = entries ? f($58lSR(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $de7013501b96d677$var$BREAK || result === $de7013501b96d677$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $h5z5G(iterator, f, step.value, entries);
        if (result === $de7013501b96d677$var$BREAK || result === $de7013501b96d677$var$RETURN) return result;
    }
};
$de7013501b96d677$var$exports.BREAK = $de7013501b96d677$var$BREAK;
$de7013501b96d677$var$exports.RETURN = $de7013501b96d677$var$RETURN;

});
parcelRegister("h5z5G", function(module, exports) {
// call something on iterator step with safe closing on error

var $58lSR = parcelRequire("58lSR");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($58lSR(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $58lSR(ret.call(iterator));
        throw e;
    }
};

});

parcelRegister("1zRzE", function(module, exports) {
// check on default Array iterator

var $8grU2 = parcelRequire("8grU2");

var $12629e057ae60833$var$ITERATOR = (parcelRequire("jZx91"))('iterator');
var $12629e057ae60833$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($8grU2.Array === it || $12629e057ae60833$var$ArrayProto[$12629e057ae60833$var$ITERATOR] === it);
};

});

parcelRegister("hqd6k", function(module, exports) {

var $l6l01 = parcelRequire("l6l01");

var $caef06f90483f131$var$ITERATOR = (parcelRequire("jZx91"))('iterator');

var $8grU2 = parcelRequire("8grU2");

module.exports = (parcelRequire("7y4ZL")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$caef06f90483f131$var$ITERATOR] || it['@@iterator'] || $8grU2[$l6l01(it)];
};

});
parcelRegister("l6l01", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $3rACp = parcelRequire("3rACp");

var $f5ca72885a0f802a$var$TAG = (parcelRequire("jZx91"))('toStringTag');
// ES3 wrong here
var $f5ca72885a0f802a$var$ARG = $3rACp(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $f5ca72885a0f802a$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $f5ca72885a0f802a$var$tryGet(O = Object(it), $f5ca72885a0f802a$var$TAG)) == 'string' ? T : $f5ca72885a0f802a$var$ARG ? $3rACp(O) : (B = $3rACp(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});



parcelRegister("9rpke", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("ldNTA", function(module, exports) {

var $f87WO = parcelRequire("f87WO");

var $e9vmz = parcelRequire("e9vmz");
var $f73184167a859c71$require$setPrototypeOf = $e9vmz.set;
module.exports = function(that, target, C) {
    var S = target.constructor;
    var P;
    if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && $f87WO(P) && $f73184167a859c71$require$setPrototypeOf) $f73184167a859c71$require$setPrototypeOf(that, P);
    return that;
};

});
parcelRegister("e9vmz", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $f87WO = parcelRequire("f87WO");

var $58lSR = parcelRequire("58lSR");
var $a4da3bfdfe19a6ef$var$check = function(O, proto) {
    $58lSR(O);
    if (!$f87WO(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("h2gZM"))(Function.call, (parcelRequire("iRN5J")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $a4da3bfdfe19a6ef$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $a4da3bfdfe19a6ef$var$check
};

});
parcelRegister("iRN5J", function(module, exports) {
$parcel$export(module.exports, "f", () => $dbc341c08e052fa5$export$2d1720544b23b823, (v) => $dbc341c08e052fa5$export$2d1720544b23b823 = v);
var $dbc341c08e052fa5$export$2d1720544b23b823;

var $a5uW9 = parcelRequire("a5uW9");

var $8ZvAE = parcelRequire("8ZvAE");

var $3dpeK = parcelRequire("3dpeK");

var $iuwIe = parcelRequire("iuwIe");

var $ezZa4 = parcelRequire("ezZa4");

var $7hv51 = parcelRequire("7hv51");
var $dbc341c08e052fa5$var$gOPD = Object.getOwnPropertyDescriptor;

$dbc341c08e052fa5$export$2d1720544b23b823 = (parcelRequire("leD2I")) ? $dbc341c08e052fa5$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $3dpeK(O);
    P = $iuwIe(P, true);
    if ($7hv51) try {
        return $dbc341c08e052fa5$var$gOPD(O, P);
    } catch (e) {}
    if ($ezZa4(O, P)) return $8ZvAE(!$a5uW9.f.call(O, P), O[P]);
};

});
parcelRegister("a5uW9", function(module, exports) {
$parcel$export(module.exports, "f", () => $75825e6ee0d8ff0d$export$2d1720544b23b823, (v) => $75825e6ee0d8ff0d$export$2d1720544b23b823 = v);
var $75825e6ee0d8ff0d$export$2d1720544b23b823;
$75825e6ee0d8ff0d$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});





parcelRegister("kVqBO", function(module, exports) {
// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $l6l01 = parcelRequire("l6l01");

var $2rTkK = parcelRequire("2rTkK");
module.exports = function(NAME) {
    return function toJSON() {
        if ($l6l01(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
        return $2rTkK(this);
    };
};

});
parcelRegister("2rTkK", function(module, exports) {

var $j61VM = parcelRequire("j61VM");
module.exports = function(iter, ITERATOR) {
    var result = [];
    $j61VM(iter, false, result.push, result, ITERATOR);
    return result;
};

});


parcelRegister("bUsrR", function(module, exports) {
'use strict';

var $j1pco = parcelRequire("j1pco");
module.exports = function(COLLECTION) {
    $j1pco($j1pco.S, COLLECTION, {
        of: function of() {
            var length = arguments.length;
            var A = new Array(length);
            while(length--)A[length] = arguments[length];
            return new this(A);
        }
    });
};

});

parcelRegister("c79nm", function(module, exports) {
'use strict';

var $j1pco = parcelRequire("j1pco");

var $fHwTO = parcelRequire("fHwTO");

var $h2gZM = parcelRequire("h2gZM");

var $j61VM = parcelRequire("j61VM");
module.exports = function(COLLECTION) {
    $j1pco($j1pco.S, COLLECTION, {
        from: function from(source /* , mapFn, thisArg */ ) {
            var mapFn = arguments[1];
            var mapping, A, n, cb;
            $fHwTO(this);
            mapping = mapFn !== undefined;
            if (mapping) $fHwTO(mapFn);
            if (source == undefined) return new this();
            A = [];
            if (mapping) {
                n = 0;
                cb = $h2gZM(mapFn, arguments[2], 2);
                $j61VM(source, false, function(nextItem) {
                    A.push(cb(nextItem, n++));
                });
            } else $j61VM(source, false, A.push, A);
            return new this(A);
        }
    });
};

});

parcelRegister("9Uv0U", function(module, exports) {
'use strict';

var $2mdEd = parcelRequire("2mdEd");

var $ldWiL = parcelRequire("ldWiL");

var $a5uW9 = parcelRequire("a5uW9");

var $1Wq2M = parcelRequire("1Wq2M");

var $7LajF = parcelRequire("7LajF");
var $737166aa4f781af4$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$737166aa4f781af4$var$$assign || (parcelRequire("7clcL"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $737166aa4f781af4$var$$assign({}, A)[S] != 7 || Object.keys($737166aa4f781af4$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $1Wq2M(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $ldWiL.f;
    var isEnum = $a5uW9.f;
    while(aLen > index){
        var S = $7LajF(arguments[index++]);
        var keys = getSymbols ? $2mdEd(S).concat(getSymbols(S)) : $2mdEd(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j)if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    }
    return T;
} : $737166aa4f781af4$var$$assign;

});
parcelRegister("ldWiL", function(module, exports) {
$parcel$export(module.exports, "f", () => $f738095ba57bdc39$export$2d1720544b23b823, (v) => $f738095ba57bdc39$export$2d1720544b23b823 = v);
var $f738095ba57bdc39$export$2d1720544b23b823;
$f738095ba57bdc39$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});


parcelRegister("hm18H", function(module, exports) {

var $2mdEd = parcelRequire("2mdEd");

var $3dpeK = parcelRequire("3dpeK");

var $a5uW9 = parcelRequire("a5uW9");
var $ca255ffcbc93b941$require$isEnum = $a5uW9.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $3dpeK(it);
        var keys = $2mdEd(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i)if ($ca255ffcbc93b941$require$isEnum.call(O, key = keys[i++])) result.push(isEntries ? [
            key,
            O[key]
        ] : O[key]);
        return result;
    };
};

});

parcelRegister("2GCTx", function(module, exports) {

var $1f4dacb648e7c79f$var$MATCH = (parcelRequire("jZx91"))('match');
module.exports = function(KEY) {
    var re = /./;
    try {
        '/./'[KEY](re);
    } catch (e) {
        try {
            re[$1f4dacb648e7c79f$var$MATCH] = false;
            return !'/./'[KEY](re);
        } catch (f) {}
    }
    return true;
};

});

parcelRegister("cUEwJ", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $966a26ca8d09dee7$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $966a26ca8d09dee7$var$global; // eslint-disable-line no-undef

});

parcelRegister("i9PqC", function(module, exports) {
var $d380f5d7a0bd8112$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $d380f5d7a0bd8112$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("gvp2l", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("d6gmi"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("d6gmi", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("7UCsS", function(module, exports) {

var $cUEwJ = parcelRequire("cUEwJ");

var $ktrQW = parcelRequire("ktrQW");

var $6G6JS = parcelRequire("6G6JS");

var $2niSg = parcelRequire("2niSg");

var $i2qD6 = parcelRequire("i2qD6");
var $5c2b99ac917288a0$var$PROTOTYPE = 'prototype';
var $5c2b99ac917288a0$var$$export = function(type, name, source) {
    var IS_FORCED = type & $5c2b99ac917288a0$var$$export.F;
    var IS_GLOBAL = type & $5c2b99ac917288a0$var$$export.G;
    var IS_STATIC = type & $5c2b99ac917288a0$var$$export.S;
    var IS_PROTO = type & $5c2b99ac917288a0$var$$export.P;
    var IS_BIND = type & $5c2b99ac917288a0$var$$export.B;
    var target = IS_GLOBAL ? $cUEwJ : IS_STATIC ? $cUEwJ[name] || ($cUEwJ[name] = {}) : ($cUEwJ[name] || {})[$5c2b99ac917288a0$var$PROTOTYPE];
    var exports = IS_GLOBAL ? $ktrQW : $ktrQW[name] || ($ktrQW[name] = {});
    var expProto = exports[$5c2b99ac917288a0$var$PROTOTYPE] || (exports[$5c2b99ac917288a0$var$PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        // export native or passed
        out = (own ? target : source)[key];
        // bind timers to global for call from export context
        exp = IS_BIND && own ? $i2qD6(out, $cUEwJ) : IS_PROTO && typeof out == 'function' ? $i2qD6(Function.call, out) : out;
        // extend global
        if (target) $2niSg(target, key, out, type & $5c2b99ac917288a0$var$$export.U);
        // export
        if (exports[key] != out) $6G6JS(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
};
$cUEwJ.core = $ktrQW;
// type bitmap
$5c2b99ac917288a0$var$$export.F = 1; // forced
$5c2b99ac917288a0$var$$export.G = 2; // global
$5c2b99ac917288a0$var$$export.S = 4; // static
$5c2b99ac917288a0$var$$export.P = 8; // proto
$5c2b99ac917288a0$var$$export.B = 16; // bind
$5c2b99ac917288a0$var$$export.W = 32; // wrap
$5c2b99ac917288a0$var$$export.U = 64; // safe
$5c2b99ac917288a0$var$$export.R = 128; // real proto method for `library`
module.exports = $5c2b99ac917288a0$var$$export;

});
parcelRegister("ktrQW", function(module, exports) {
var $ee7c1f13abd0b07f$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $ee7c1f13abd0b07f$var$core; // eslint-disable-line no-undef

});

parcelRegister("6G6JS", function(module, exports) {

var $1w421 = parcelRequire("1w421");

var $jPGz2 = parcelRequire("jPGz2");

module.exports = (parcelRequire("gvp2l")) ? function(object, key, value) {
    return $1w421.f(object, key, $jPGz2(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("1w421", function(module, exports) {
$parcel$export(module.exports, "f", () => $11abe830ebd8b833$export$2d1720544b23b823, (v) => $11abe830ebd8b833$export$2d1720544b23b823 = v);
var $11abe830ebd8b833$export$2d1720544b23b823;

var $9bg2N = parcelRequire("9bg2N");

var $1z3dl = parcelRequire("1z3dl");

var $hFD9L = parcelRequire("hFD9L");
var $11abe830ebd8b833$var$dP = Object.defineProperty;

$11abe830ebd8b833$export$2d1720544b23b823 = (parcelRequire("gvp2l")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $9bg2N(O);
    P = $hFD9L(P, true);
    $9bg2N(Attributes);
    if ($1z3dl) try {
        return $11abe830ebd8b833$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("9bg2N", function(module, exports) {

var $5ehF7 = parcelRequire("5ehF7");
module.exports = function(it) {
    if (!$5ehF7(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("5ehF7", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("1z3dl", function(module, exports) {



module.exports = !(parcelRequire("gvp2l")) && !(parcelRequire("d6gmi"))(function() {
    return Object.defineProperty((parcelRequire("aMQD1"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("aMQD1", function(module, exports) {

var $5ehF7 = parcelRequire("5ehF7");

var $cUEwJ = parcelRequire("cUEwJ");
var $7da735f7bbcb74b3$require$document = $cUEwJ.document;
// typeof document.createElement is 'object' in old IE
var $7da735f7bbcb74b3$var$is = $5ehF7($7da735f7bbcb74b3$require$document) && $5ehF7($7da735f7bbcb74b3$require$document.createElement);
module.exports = function(it) {
    return $7da735f7bbcb74b3$var$is ? $7da735f7bbcb74b3$require$document.createElement(it) : {};
};

});


parcelRegister("hFD9L", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $5ehF7 = parcelRequire("5ehF7");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$5ehF7(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$5ehF7(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$5ehF7(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$5ehF7(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("jPGz2", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("2niSg", function(module, exports) {

var $cUEwJ = parcelRequire("cUEwJ");

var $6G6JS = parcelRequire("6G6JS");

var $i9PqC = parcelRequire("i9PqC");

var $1bac5ec614dd304c$var$SRC = (parcelRequire("7bg9a"))('src');

var $1y7Gq = parcelRequire("1y7Gq");
var $1bac5ec614dd304c$var$TO_STRING = 'toString';
var $1bac5ec614dd304c$var$TPL = ('' + $1y7Gq).split($1bac5ec614dd304c$var$TO_STRING);

(parcelRequire("ktrQW")).inspectSource = function(it) {
    return $1y7Gq.call(it);
};
(module.exports = function(O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) $i9PqC(val, 'name') || $6G6JS(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) $i9PqC(val, $1bac5ec614dd304c$var$SRC) || $6G6JS(val, $1bac5ec614dd304c$var$SRC, O[key] ? '' + O[key] : $1bac5ec614dd304c$var$TPL.join(String(key)));
    if (O === $cUEwJ) O[key] = val;
    else if (!safe) {
        delete O[key];
        $6G6JS(O, key, val);
    } else if (O[key]) O[key] = val;
    else $6G6JS(O, key, val);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, $1bac5ec614dd304c$var$TO_STRING, function toString() {
    return typeof this == 'function' && this[$1bac5ec614dd304c$var$SRC] || $1y7Gq.call(this);
});

});
parcelRegister("7bg9a", function(module, exports) {
var $53a615e36a71fbee$var$id = 0;
var $53a615e36a71fbee$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$53a615e36a71fbee$var$id + $53a615e36a71fbee$var$px).toString(36));
};

});

parcelRegister("1y7Gq", function(module, exports) {

module.exports = (parcelRequire("7Ebfd"))('native-function-to-string', Function.toString);

});
parcelRegister("7Ebfd", function(module, exports) {

var $ktrQW = parcelRequire("ktrQW");

var $cUEwJ = parcelRequire("cUEwJ");
var $5914fdbc75d96b75$var$SHARED = '__core-js_shared__';
var $5914fdbc75d96b75$var$store = $cUEwJ[$5914fdbc75d96b75$var$SHARED] || ($cUEwJ[$5914fdbc75d96b75$var$SHARED] = {});

(module.exports = function(key, value) {
    return $5914fdbc75d96b75$var$store[key] || ($5914fdbc75d96b75$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $ktrQW.version,
    mode: (parcelRequire("6VDEP")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("6VDEP", function(module, exports) {
module.exports = false;

});




parcelRegister("i2qD6", function(module, exports) {
// optional / simple context binding

var $ekEf9 = parcelRequire("ekEf9");
module.exports = function(fn, that, length) {
    $ekEf9(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("ekEf9", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});



parcelRegister("5MNda", function(module, exports) {

var $1w421 = parcelRequire("1w421");
var $43679bca2d80e90b$require$def = $1w421.f;

var $i9PqC = parcelRequire("i9PqC");

var $43679bca2d80e90b$var$TAG = (parcelRequire("5zj8I"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$i9PqC(it = stat ? it : it.prototype, $43679bca2d80e90b$var$TAG)) $43679bca2d80e90b$require$def(it, $43679bca2d80e90b$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("5zj8I", function(module, exports) {

var $40df115ac576b504$var$store = (parcelRequire("7Ebfd"))('wks');

var $7bg9a = parcelRequire("7bg9a");

var $cUEwJ = parcelRequire("cUEwJ");
var $40df115ac576b504$require$Symbol = $cUEwJ.Symbol;
var $40df115ac576b504$var$USE_SYMBOL = typeof $40df115ac576b504$require$Symbol == 'function';
var $40df115ac576b504$var$$exports = module.exports = function(name) {
    return $40df115ac576b504$var$store[name] || ($40df115ac576b504$var$store[name] = $40df115ac576b504$var$USE_SYMBOL && $40df115ac576b504$require$Symbol[name] || ($40df115ac576b504$var$USE_SYMBOL ? $40df115ac576b504$require$Symbol : $7bg9a)('Symbol.' + name));
};
$40df115ac576b504$var$$exports.store = $40df115ac576b504$var$store;

});


parcelRegister("29gH0", function(module, exports) {

var $cUEwJ = parcelRequire("cUEwJ");

var $ktrQW = parcelRequire("ktrQW");

var $6VDEP = parcelRequire("6VDEP");

var $cDLhd = parcelRequire("cDLhd");

var $1w421 = parcelRequire("1w421");
var $19095ede6bb1bd2c$require$defineProperty = $1w421.f;
module.exports = function(name) {
    var $Symbol = $ktrQW.Symbol || ($ktrQW.Symbol = $6VDEP ? {} : $cUEwJ.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $19095ede6bb1bd2c$require$defineProperty($Symbol, name, {
        value: $cDLhd.f(name)
    });
};

});
parcelRegister("cDLhd", function(module, exports) {
$parcel$export(module.exports, "f", () => $933dccb707440d69$export$2d1720544b23b823, (v) => $933dccb707440d69$export$2d1720544b23b823 = v);
var $933dccb707440d69$export$2d1720544b23b823;

$933dccb707440d69$export$2d1720544b23b823 = (parcelRequire("5zj8I"));

});


parcelRegister("5jKhD", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $8t6Im = parcelRequire("8t6Im");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $8t6Im(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("8t6Im", function(module, exports) {
var $62a63d8260e118d5$var$toString = {}.toString;
module.exports = function(it) {
    return $62a63d8260e118d5$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("i2jbf", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $e6Osc = parcelRequire("e6Osc");

var $75R4e = parcelRequire("75R4e");

var $ktL0p = parcelRequire("ktL0p");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $e6Osc($this);
        var length = $75R4e(O.length);
        var index = $ktL0p(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("e6Osc", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $5jKhD = parcelRequire("5jKhD");

var $1esYK = parcelRequire("1esYK");
module.exports = function(it) {
    return $5jKhD($1esYK(it));
};

});
parcelRegister("1esYK", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("75R4e", function(module, exports) {
// 7.1.15 ToLength

var $lelYU = parcelRequire("lelYU");
var $52a22a190b566d9b$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $52a22a190b566d9b$var$min($lelYU(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("lelYU", function(module, exports) {
// 7.1.4 ToInteger
var $f74bf4da743369d2$var$ceil = Math.ceil;
var $f74bf4da743369d2$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $f74bf4da743369d2$var$floor : $f74bf4da743369d2$var$ceil)(it);
};

});


parcelRegister("ktL0p", function(module, exports) {

var $lelYU = parcelRequire("lelYU");
var $ee8afa6b76433f3c$var$max = Math.max;
var $ee8afa6b76433f3c$var$min = Math.min;
module.exports = function(index, length) {
    index = $lelYU(index);
    return index < 0 ? $ee8afa6b76433f3c$var$max(index + length, 0) : $ee8afa6b76433f3c$var$min(index, length);
};

});


parcelRegister("hSsWC", function(module, exports) {

var $d03dee8ebfbed29a$var$shared = (parcelRequire("7Ebfd"))('keys');

var $7bg9a = parcelRequire("7bg9a");
module.exports = function(key) {
    return $d03dee8ebfbed29a$var$shared[key] || ($d03dee8ebfbed29a$var$shared[key] = $7bg9a(key));
};

});

parcelRegister("jLhL5", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});

parcelRegister("4OvuN", function(module, exports) {
$parcel$export(module.exports, "f", () => $381443596839d6f4$export$2d1720544b23b823, (v) => $381443596839d6f4$export$2d1720544b23b823 = v);
var $381443596839d6f4$export$2d1720544b23b823;
$381443596839d6f4$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("8D3Ey", function(module, exports) {
// 7.2.2 IsArray(argument)

var $8t6Im = parcelRequire("8t6Im");
module.exports = Array.isArray || function isArray(arg) {
    return $8t6Im(arg) == 'Array';
};

});

parcelRegister("87N8x", function(module, exports) {
// 7.1.13 ToObject(argument)

var $1esYK = parcelRequire("1esYK");
module.exports = function(it) {
    return Object($1esYK(it));
};

});

parcelRegister("9hnGd", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $9bg2N = parcelRequire("9bg2N");

var $44tfH = parcelRequire("44tfH");

var $jLhL5 = parcelRequire("jLhL5");

var $6c1811f19651a6b5$var$IE_PROTO = (parcelRequire("hSsWC"))('IE_PROTO');
var $6c1811f19651a6b5$var$Empty = function() {};
var $6c1811f19651a6b5$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $6c1811f19651a6b5$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("aMQD1"))('iframe');
    var i = $jLhL5.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("e9oLT")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $6c1811f19651a6b5$var$createDict = iframeDocument.F;
    while(i--)delete $6c1811f19651a6b5$var$createDict[$6c1811f19651a6b5$var$PROTOTYPE][$jLhL5[i]];
    return $6c1811f19651a6b5$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $6c1811f19651a6b5$var$Empty[$6c1811f19651a6b5$var$PROTOTYPE] = $9bg2N(O);
        result = new $6c1811f19651a6b5$var$Empty();
        $6c1811f19651a6b5$var$Empty[$6c1811f19651a6b5$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$6c1811f19651a6b5$var$IE_PROTO] = O;
    } else result = $6c1811f19651a6b5$var$createDict();
    return Properties === undefined ? result : $44tfH(result, Properties);
};

});
parcelRegister("44tfH", function(module, exports) {

var $1w421 = parcelRequire("1w421");

var $9bg2N = parcelRequire("9bg2N");

var $abZqb = parcelRequire("abZqb");

module.exports = (parcelRequire("gvp2l")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $9bg2N(O);
    var keys = $abZqb(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$1w421.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("abZqb", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $ldHjy = parcelRequire("ldHjy");

var $jLhL5 = parcelRequire("jLhL5");
module.exports = Object.keys || function keys(O) {
    return $ldHjy(O, $jLhL5);
};

});
parcelRegister("ldHjy", function(module, exports) {

var $i9PqC = parcelRequire("i9PqC");

var $e6Osc = parcelRequire("e6Osc");

var $f72c693355e3f66b$var$arrayIndexOf = (parcelRequire("i2jbf"))(false);

var $f72c693355e3f66b$var$IE_PROTO = (parcelRequire("hSsWC"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $e6Osc(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $f72c693355e3f66b$var$IE_PROTO) $i9PqC(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($i9PqC(O, key = names[i++])) ~$f72c693355e3f66b$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});



parcelRegister("e9oLT", function(module, exports) {

var $cUEwJ = parcelRequire("cUEwJ");
var $a4d51f10fcc2ff81$require$document = $cUEwJ.document;
module.exports = $a4d51f10fcc2ff81$require$document && $a4d51f10fcc2ff81$require$document.documentElement;

});


parcelRegister("9fHtC", function(module, exports) {
$parcel$export(module.exports, "f", () => $6bc73d5322bc922f$export$2d1720544b23b823, (v) => $6bc73d5322bc922f$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $6bc73d5322bc922f$export$2d1720544b23b823;

var $e6Osc = parcelRequire("e6Osc");

var $dQVrJ = parcelRequire("dQVrJ");
var $6bc73d5322bc922f$require$gOPN = $dQVrJ.f;
var $6bc73d5322bc922f$var$toString = {}.toString;
var $6bc73d5322bc922f$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $6bc73d5322bc922f$var$getWindowNames = function(it) {
    try {
        return $6bc73d5322bc922f$require$gOPN(it);
    } catch (e) {
        return $6bc73d5322bc922f$var$windowNames.slice();
    }
};
$6bc73d5322bc922f$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $6bc73d5322bc922f$var$windowNames && $6bc73d5322bc922f$var$toString.call(it) == '[object Window]' ? $6bc73d5322bc922f$var$getWindowNames(it) : $6bc73d5322bc922f$require$gOPN($e6Osc(it));
};

});
parcelRegister("dQVrJ", function(module, exports) {
$parcel$export(module.exports, "f", () => $a15cb1522fd79f61$export$2d1720544b23b823, (v) => $a15cb1522fd79f61$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $a15cb1522fd79f61$export$2d1720544b23b823;

var $ldHjy = parcelRequire("ldHjy");

var $a15cb1522fd79f61$var$hiddenKeys = (parcelRequire("jLhL5")).concat('length', 'prototype');
$a15cb1522fd79f61$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $ldHjy(O, $a15cb1522fd79f61$var$hiddenKeys);
};

});


parcelRegister("clqre", function(module, exports) {
$parcel$export(module.exports, "f", () => $8fcbf44331e3bbca$export$2d1720544b23b823, (v) => $8fcbf44331e3bbca$export$2d1720544b23b823 = v);
var $8fcbf44331e3bbca$export$2d1720544b23b823;

var $4OvuN = parcelRequire("4OvuN");

var $jPGz2 = parcelRequire("jPGz2");

var $e6Osc = parcelRequire("e6Osc");

var $hFD9L = parcelRequire("hFD9L");

var $i9PqC = parcelRequire("i9PqC");

var $1z3dl = parcelRequire("1z3dl");
var $8fcbf44331e3bbca$var$gOPD = Object.getOwnPropertyDescriptor;

$8fcbf44331e3bbca$export$2d1720544b23b823 = (parcelRequire("gvp2l")) ? $8fcbf44331e3bbca$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $e6Osc(O);
    P = $hFD9L(P, true);
    if ($1z3dl) try {
        return $8fcbf44331e3bbca$var$gOPD(O, P);
    } catch (e) {}
    if ($i9PqC(O, P)) return $jPGz2(!$4OvuN.f.call(O, P), O[P]);
};

});

parcelRegister("7Q2IA", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $7UCsS = parcelRequire("7UCsS");

var $ktrQW = parcelRequire("ktrQW");

var $d6gmi = parcelRequire("d6gmi");
module.exports = function(KEY, exec) {
    var fn = ($ktrQW.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $7UCsS($7UCsS.S + $7UCsS.F * $d6gmi(function() {
        fn(1);
    }), 'Object', exp);
};

});

parcelRegister("hQ3EZ", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $i9PqC = parcelRequire("i9PqC");

var $87N8x = parcelRequire("87N8x");

var $cfca21ce7c348e34$var$IE_PROTO = (parcelRequire("hSsWC"))('IE_PROTO');
var $cfca21ce7c348e34$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $87N8x(O);
    if ($i9PqC(O, $cfca21ce7c348e34$var$IE_PROTO)) return O[$cfca21ce7c348e34$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $cfca21ce7c348e34$var$ObjectProto : null;
};

});

parcelRegister("kr8PN", function(module, exports) {
'use strict';

var $gvp2l = parcelRequire("gvp2l");

var $abZqb = parcelRequire("abZqb");

var $62w6m = parcelRequire("62w6m");

var $4OvuN = parcelRequire("4OvuN");

var $87N8x = parcelRequire("87N8x");

var $5jKhD = parcelRequire("5jKhD");
var $ee0d2e9c0236bb58$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$ee0d2e9c0236bb58$var$$assign || (parcelRequire("d6gmi"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $ee0d2e9c0236bb58$var$$assign({}, A)[S] != 7 || Object.keys($ee0d2e9c0236bb58$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $87N8x(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $62w6m.f;
    var isEnum = $4OvuN.f;
    while(aLen > index){
        var S = $5jKhD(arguments[index++]);
        var keys = getSymbols ? $abZqb(S).concat(getSymbols(S)) : $abZqb(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$gvp2l || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $ee0d2e9c0236bb58$var$$assign;

});
parcelRegister("62w6m", function(module, exports) {
$parcel$export(module.exports, "f", () => $465bd4b33ae6a6d1$export$2d1720544b23b823, (v) => $465bd4b33ae6a6d1$export$2d1720544b23b823 = v);
var $465bd4b33ae6a6d1$export$2d1720544b23b823;
$465bd4b33ae6a6d1$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});


parcelRegister("etufX", function(module, exports) {
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

});

parcelRegister("gALmc", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $5ehF7 = parcelRequire("5ehF7");

var $9bg2N = parcelRequire("9bg2N");
var $c144be3f5caecd8d$var$check = function(O, proto) {
    $9bg2N(O);
    if (!$5ehF7(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("i2qD6"))(Function.call, (parcelRequire("clqre")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $c144be3f5caecd8d$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $c144be3f5caecd8d$var$check
};

});

parcelRegister("d4Dmo", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $8t6Im = parcelRequire("8t6Im");

var $984a2e35adb85bbf$var$TAG = (parcelRequire("5zj8I"))('toStringTag');
// ES3 wrong here
var $984a2e35adb85bbf$var$ARG = $8t6Im(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $984a2e35adb85bbf$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $984a2e35adb85bbf$var$tryGet(O = Object(it), $984a2e35adb85bbf$var$TAG)) == 'string' ? T : $984a2e35adb85bbf$var$ARG ? $8t6Im(O) : (B = $8t6Im(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});

parcelRegister("1iNAj", function(module, exports) {
'use strict';

var $ekEf9 = parcelRequire("ekEf9");

var $5ehF7 = parcelRequire("5ehF7");

var $8KdzC = parcelRequire("8KdzC");
var $0f2def5ab181c7a9$var$arraySlice = [].slice;
var $0f2def5ab181c7a9$var$factories = {};
var $0f2def5ab181c7a9$var$construct = function(F, len, args) {
    if (!(len in $0f2def5ab181c7a9$var$factories)) {
        for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
        // eslint-disable-next-line no-new-func
        $0f2def5ab181c7a9$var$factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
    }
    return $0f2def5ab181c7a9$var$factories[len](F, args);
};
module.exports = Function.bind || function bind(that /* , ...args */ ) {
    var fn = $ekEf9(this);
    var partArgs = $0f2def5ab181c7a9$var$arraySlice.call(arguments, 1);
    var bound = function() {
        var args = partArgs.concat($0f2def5ab181c7a9$var$arraySlice.call(arguments));
        return this instanceof bound ? $0f2def5ab181c7a9$var$construct(fn, args.length, args) : $8KdzC(fn, args, that);
    };
    if ($5ehF7(fn.prototype)) bound.prototype = fn.prototype;
    return bound;
};

});
parcelRegister("8KdzC", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("3JQ2K", function(module, exports) {

var $7UCsS = parcelRequire("7UCsS");

var $1esYK = parcelRequire("1esYK");

var $d6gmi = parcelRequire("d6gmi");

var $UqiYA = parcelRequire("UqiYA");
var $2b8df1c9e83dbd66$var$space = '[' + $UqiYA + ']';
var $2b8df1c9e83dbd66$var$non = '\u200b\u0085';
var $2b8df1c9e83dbd66$var$ltrim = RegExp('^' + $2b8df1c9e83dbd66$var$space + $2b8df1c9e83dbd66$var$space + '*');
var $2b8df1c9e83dbd66$var$rtrim = RegExp($2b8df1c9e83dbd66$var$space + $2b8df1c9e83dbd66$var$space + '*$');
var $2b8df1c9e83dbd66$var$exporter = function(KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = $d6gmi(function() {
        return !!$UqiYA[KEY]() || $2b8df1c9e83dbd66$var$non[KEY]() != $2b8df1c9e83dbd66$var$non;
    });
    var fn = exp[KEY] = FORCE ? exec($2b8df1c9e83dbd66$var$trim) : $UqiYA[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    $7UCsS($7UCsS.P + $7UCsS.F * FORCE, 'String', exp);
};
// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var $2b8df1c9e83dbd66$var$trim = $2b8df1c9e83dbd66$var$exporter.trim = function(string, TYPE) {
    string = String($1esYK(string));
    if (TYPE & 1) string = string.replace($2b8df1c9e83dbd66$var$ltrim, '');
    if (TYPE & 2) string = string.replace($2b8df1c9e83dbd66$var$rtrim, '');
    return string;
};
module.exports = $2b8df1c9e83dbd66$var$exporter;

});
parcelRegister("UqiYA", function(module, exports) {
module.exports = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

});


parcelRegister("bvdTC", function(module, exports) {
'use strict';

var $lelYU = parcelRequire("lelYU");

var $1esYK = parcelRequire("1esYK");
module.exports = function repeat(count) {
    var str = String($1esYK(this));
    var res = '';
    var n = $lelYU(count);
    if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) res += str;
    return res;
};

});

parcelRegister("3bkJs", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $5ehF7 = parcelRequire("5ehF7");
var $25127b240c8b6ee4$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$5ehF7(it) && isFinite(it) && $25127b240c8b6ee4$var$floor(it) === it;
};

});

parcelRegister("3zATn", function(module, exports) {
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
    return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

});

parcelRegister("fLy9c", function(module, exports) {
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
    // eslint-disable-next-line no-self-compare
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

});

parcelRegister("3eQaZ", function(module, exports) {
// 20.2.2.16 Math.fround(x)

var $fLy9c = parcelRequire("fLy9c");
var $25bb270a4b0c5c07$var$pow = Math.pow;
var $25bb270a4b0c5c07$var$EPSILON = $25bb270a4b0c5c07$var$pow(2, -52);
var $25bb270a4b0c5c07$var$EPSILON32 = $25bb270a4b0c5c07$var$pow(2, -23);
var $25bb270a4b0c5c07$var$MAX32 = $25bb270a4b0c5c07$var$pow(2, 127) * (2 - $25bb270a4b0c5c07$var$EPSILON32);
var $25bb270a4b0c5c07$var$MIN32 = $25bb270a4b0c5c07$var$pow(2, -126);
var $25bb270a4b0c5c07$var$roundTiesToEven = function(n) {
    return n + 1 / $25bb270a4b0c5c07$var$EPSILON - 1 / $25bb270a4b0c5c07$var$EPSILON;
};
module.exports = Math.fround || function fround(x) {
    var $abs = Math.abs(x);
    var $sign = $fLy9c(x);
    var a, result;
    if ($abs < $25bb270a4b0c5c07$var$MIN32) return $sign * $25bb270a4b0c5c07$var$roundTiesToEven($abs / $25bb270a4b0c5c07$var$MIN32 / $25bb270a4b0c5c07$var$EPSILON32) * $25bb270a4b0c5c07$var$MIN32 * $25bb270a4b0c5c07$var$EPSILON32;
    a = (1 + $25bb270a4b0c5c07$var$EPSILON32 / $25bb270a4b0c5c07$var$EPSILON) * $abs;
    result = a - (a - $abs);
    // eslint-disable-next-line no-self-compare
    if (result > $25bb270a4b0c5c07$var$MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
};

});

parcelRegister("9yOH3", function(module, exports) {

var $lelYU = parcelRequire("lelYU");

var $1esYK = parcelRequire("1esYK");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($1esYK(that));
        var i = $lelYU(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("d5llS", function(module, exports) {
'use strict';

var $6VDEP = parcelRequire("6VDEP");

var $7UCsS = parcelRequire("7UCsS");

var $2niSg = parcelRequire("2niSg");

var $6G6JS = parcelRequire("6G6JS");

var $llfnB = parcelRequire("llfnB");

var $k6qlJ = parcelRequire("k6qlJ");

var $5MNda = parcelRequire("5MNda");

var $hQ3EZ = parcelRequire("hQ3EZ");

var $986c4e0a93e40d7a$var$ITERATOR = (parcelRequire("5zj8I"))('iterator');
var $986c4e0a93e40d7a$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $986c4e0a93e40d7a$var$FF_ITERATOR = '@@iterator';
var $986c4e0a93e40d7a$var$KEYS = 'keys';
var $986c4e0a93e40d7a$var$VALUES = 'values';
var $986c4e0a93e40d7a$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $k6qlJ(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$986c4e0a93e40d7a$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $986c4e0a93e40d7a$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $986c4e0a93e40d7a$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $986c4e0a93e40d7a$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$986c4e0a93e40d7a$var$ITERATOR] || proto[$986c4e0a93e40d7a$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $hQ3EZ($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $5MNda(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$6VDEP && typeof IteratorPrototype[$986c4e0a93e40d7a$var$ITERATOR] != 'function') $6G6JS(IteratorPrototype, $986c4e0a93e40d7a$var$ITERATOR, $986c4e0a93e40d7a$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $986c4e0a93e40d7a$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$6VDEP || FORCED) && ($986c4e0a93e40d7a$var$BUGGY || VALUES_BUG || !proto[$986c4e0a93e40d7a$var$ITERATOR])) $6G6JS(proto, $986c4e0a93e40d7a$var$ITERATOR, $default);
    // Plug for library
    $llfnB[NAME] = $default;
    $llfnB[TAG] = $986c4e0a93e40d7a$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($986c4e0a93e40d7a$var$VALUES),
            keys: IS_SET ? $default : getMethod($986c4e0a93e40d7a$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $2niSg(proto, key, methods[key]);
        } else $7UCsS($7UCsS.P + $7UCsS.F * ($986c4e0a93e40d7a$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("llfnB", function(module, exports) {
module.exports = {};

});

parcelRegister("k6qlJ", function(module, exports) {
'use strict';

var $9hnGd = parcelRequire("9hnGd");

var $jPGz2 = parcelRequire("jPGz2");

var $5MNda = parcelRequire("5MNda");
var $ea28cea12f0a9967$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("6G6JS"))($ea28cea12f0a9967$var$IteratorPrototype, (parcelRequire("5zj8I"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $9hnGd($ea28cea12f0a9967$var$IteratorPrototype, {
        next: $jPGz2(1, next)
    });
    $5MNda(Constructor, NAME + ' Iterator');
};

});


parcelRegister("1a9F2", function(module, exports) {

var $0d8e3811453bc5ec$var$MATCH = (parcelRequire("5zj8I"))('match');
module.exports = function(KEY) {
    var re = /./;
    try {
        '/./'[KEY](re);
    } catch (e) {
        try {
            re[$0d8e3811453bc5ec$var$MATCH] = false;
            return !'/./'[KEY](re);
        } catch (f) {}
    }
    return true;
};

});

parcelRegister("66lIJ", function(module, exports) {

var $7UCsS = parcelRequire("7UCsS");

var $d6gmi = parcelRequire("d6gmi");

var $1esYK = parcelRequire("1esYK");
var $471426d4300e7362$var$quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var $471426d4300e7362$var$createHTML = function(string, tag, attribute, value) {
    var S = String($1esYK(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace($471426d4300e7362$var$quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec) {
    var O = {};
    O[NAME] = exec($471426d4300e7362$var$createHTML);
    $7UCsS($7UCsS.P + $7UCsS.F * $d6gmi(function() {
        var test = ''[NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
    }), 'String', O);
};

});

parcelRegister("7KNJF", function(module, exports) {
'use strict';

var $9bg2N = parcelRequire("9bg2N");

var $hFD9L = parcelRequire("hFD9L");
var $5a5368b9a2525d47$var$NUMBER = 'number';
module.exports = function(hint) {
    if (hint !== 'string' && hint !== $5a5368b9a2525d47$var$NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
    return $hFD9L($9bg2N(this), hint != $5a5368b9a2525d47$var$NUMBER);
};

});

parcelRegister("dMVvs", function(module, exports) {
// check on default Array iterator

var $llfnB = parcelRequire("llfnB");

var $a09c5da594760674$var$ITERATOR = (parcelRequire("5zj8I"))('iterator');
var $a09c5da594760674$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($llfnB.Array === it || $a09c5da594760674$var$ArrayProto[$a09c5da594760674$var$ITERATOR] === it);
};

});

parcelRegister("bHyyq", function(module, exports) {

var $d4Dmo = parcelRequire("d4Dmo");

var $884e839833e49df1$var$ITERATOR = (parcelRequire("5zj8I"))('iterator');

var $llfnB = parcelRequire("llfnB");

module.exports = (parcelRequire("ktrQW")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$884e839833e49df1$var$ITERATOR] || it['@@iterator'] || $llfnB[$d4Dmo(it)];
};

});

parcelRegister("3YVTs", function(module, exports) {

var $2e63e2284102f7bf$var$ITERATOR = (parcelRequire("5zj8I"))('iterator');
var $2e63e2284102f7bf$var$SAFE_CLOSING = false;
try {
    var $2e63e2284102f7bf$var$riter = [
        7
    ][$2e63e2284102f7bf$var$ITERATOR]();
    $2e63e2284102f7bf$var$riter['return'] = function() {
        $2e63e2284102f7bf$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($2e63e2284102f7bf$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$2e63e2284102f7bf$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$2e63e2284102f7bf$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$2e63e2284102f7bf$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});

parcelRegister("cezhV", function(module, exports) {
'use strict';

var $d6gmi = parcelRequire("d6gmi");
module.exports = function(method, arg) {
    return !!method && $d6gmi(function() {
        // eslint-disable-next-line no-useless-call
        arg ? method.call(null, function() {}, 1) : method.call(null);
    });
};

});

parcelRegister("gXweJ", function(module, exports) {
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex

var $i2qD6 = parcelRequire("i2qD6");

var $5jKhD = parcelRequire("5jKhD");

var $87N8x = parcelRequire("87N8x");

var $75R4e = parcelRequire("75R4e");

var $k7f9c = parcelRequire("k7f9c");
module.exports = function(TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || $k7f9c;
    return function($this, callbackfn, that) {
        var O = $87N8x($this);
        var self = $5jKhD(O);
        var f = $i2qD6(callbackfn, that, 3);
        var length = $75R4e(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            val = self[index];
            res = f(val, index, O);
            if (TYPE) {
                if (IS_MAP) result[index] = res; // map
                else if (res) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return val; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        result.push(val); // filter
                }
                else if (IS_EVERY) return false; // every
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
};

});
parcelRegister("k7f9c", function(module, exports) {
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)

var $gVcMX = parcelRequire("gVcMX");
module.exports = function(original, length) {
    return new ($gVcMX(original))(length);
};

});
parcelRegister("gVcMX", function(module, exports) {

var $5ehF7 = parcelRequire("5ehF7");

var $8D3Ey = parcelRequire("8D3Ey");

var $c51be3c4b34d73db$var$SPECIES = (parcelRequire("5zj8I"))('species');
module.exports = function(original) {
    var C;
    if ($8D3Ey(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || $8D3Ey(C.prototype))) C = undefined;
        if ($5ehF7(C)) {
            C = C[$c51be3c4b34d73db$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? Array : C;
};

});



parcelRegister("fRAkt", function(module, exports) {
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';

var $87N8x = parcelRequire("87N8x");

var $ktL0p = parcelRequire("ktL0p");

var $75R4e = parcelRequire("75R4e");
module.exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
    var O = $87N8x(this);
    var len = $75R4e(O.length);
    var to = $ktL0p(target, len);
    var from = $ktL0p(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = Math.min((end === undefined ? len : $ktL0p(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
    }
    while(count-- > 0){
        if (from in O) O[to] = O[from];
        else delete O[to];
        to += inc;
        from += inc;
    }
    return O;
};

});

parcelRegister("kz0tg", function(module, exports) {
// 22.1.3.31 Array.prototype[@@unscopables]

var $ef877114b5daea9a$var$UNSCOPABLES = (parcelRequire("5zj8I"))('unscopables');
var $ef877114b5daea9a$var$ArrayProto = Array.prototype;

if ($ef877114b5daea9a$var$ArrayProto[$ef877114b5daea9a$var$UNSCOPABLES] == undefined) (parcelRequire("6G6JS"))($ef877114b5daea9a$var$ArrayProto, $ef877114b5daea9a$var$UNSCOPABLES, {});
module.exports = function(key) {
    $ef877114b5daea9a$var$ArrayProto[$ef877114b5daea9a$var$UNSCOPABLES][key] = true;
};

});

parcelRegister("e50fk", function(module, exports) {
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';

var $87N8x = parcelRequire("87N8x");

var $ktL0p = parcelRequire("ktL0p");

var $75R4e = parcelRequire("75R4e");
module.exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $87N8x(this);
    var length = $75R4e(O.length);
    var aLen = arguments.length;
    var index = $ktL0p(aLen > 1 ? arguments[1] : undefined, length);
    var end = aLen > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $ktL0p(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};

});

parcelRegister("7hk0b", function(module, exports) {
'use strict';

var $cUEwJ = parcelRequire("cUEwJ");

var $1w421 = parcelRequire("1w421");

var $gvp2l = parcelRequire("gvp2l");

var $54c9a2ec547eb798$var$SPECIES = (parcelRequire("5zj8I"))('species');
module.exports = function(KEY) {
    var C = $cUEwJ[KEY];
    if ($gvp2l && C && !C[$54c9a2ec547eb798$var$SPECIES]) $1w421.f(C, $54c9a2ec547eb798$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("7V9Gt", function(module, exports) {
'use strict';

var $kz0tg = parcelRequire("kz0tg");

var $kRzZI = parcelRequire("kRzZI");

var $llfnB = parcelRequire("llfnB");

var $e6Osc = parcelRequire("e6Osc");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("d5llS"))(Array, 'Array', function(iterated, kind) {
    this._t = $e6Osc(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $kRzZI(1);
    }
    if (kind == 'keys') return $kRzZI(0, index);
    if (kind == 'values') return $kRzZI(0, O[index]);
    return $kRzZI(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$llfnB.Arguments = $llfnB.Array;
$kz0tg('keys');
$kz0tg('values');
$kz0tg('entries');

});
parcelRegister("kRzZI", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});


parcelRegister("lzkzv", function(module, exports) {
'use strict';

var $9bg2N = parcelRequire("9bg2N");
module.exports = function() {
    var that = $9bg2N(this);
    var result = '';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.unicode) result += 'u';
    if (that.sticky) result += 'y';
    return result;
};

});

parcelRegister("706FM", function(module, exports) {
'use strict';
parcelRequire("lvnpq");

var $2niSg = parcelRequire("2niSg");

var $6G6JS = parcelRequire("6G6JS");

var $d6gmi = parcelRequire("d6gmi");

var $1esYK = parcelRequire("1esYK");

var $5zj8I = parcelRequire("5zj8I");

var $fn7Kz = parcelRequire("fn7Kz");
var $518db58fdb43b18c$var$SPECIES = $5zj8I('species');
var $518db58fdb43b18c$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$d6gmi(function() {
    // #replace needs built-in support for named groups.
    // #match works fine because it just return the exec results, even if it has
    // a "grops" property.
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    return ''.replace(re, '$<a>') !== '7';
});
var $518db58fdb43b18c$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function() {
    // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = 'ab'.split(re);
    return result.length === 2 && result[0] === 'a' && result[1] === 'b';
}();
module.exports = function(KEY, length, exec) {
    var SYMBOL = $5zj8I(KEY);
    var DELEGATES_TO_SYMBOL = !$d6gmi(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !$d6gmi(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        re.exec = function() {
            execCalled = true;
            return null;
        };
        if (KEY === 'split') {
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$518db58fdb43b18c$var$SPECIES] = function() {
                return re;
            };
        }
        re[SYMBOL]('');
        return !execCalled;
    }) : undefined;
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !$518db58fdb43b18c$var$REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !$518db58fdb43b18c$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
        var nativeRegExpMethod = /./[SYMBOL];
        var fns = exec($1esYK, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
            if (regexp.exec === $fn7Kz) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: nativeRegExpMethod.call(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: nativeMethod.call(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        var strfn = fns[0];
        var rxfn = fns[1];
        $2niSg(String.prototype, KEY, strfn);
        $6G6JS(RegExp.prototype, SYMBOL, length == 2 ? function(string, arg) {
            return rxfn.call(string, this, arg);
        } : function(string) {
            return rxfn.call(string, this);
        });
    }
};

});
parcelRegister("lvnpq", function(module, exports) {
'use strict';

var $fn7Kz = parcelRequire("fn7Kz");

(parcelRequire("7UCsS"))({
    target: 'RegExp',
    proto: true,
    forced: $fn7Kz !== /./.exec
}, {
    exec: $fn7Kz
});

});
parcelRegister("fn7Kz", function(module, exports) {
'use strict';

var $lzkzv = parcelRequire("lzkzv");
var $b30f040761123e4b$var$nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var $b30f040761123e4b$var$nativeReplace = String.prototype.replace;
var $b30f040761123e4b$var$patchedExec = $b30f040761123e4b$var$nativeExec;
var $b30f040761123e4b$var$LAST_INDEX = 'lastIndex';
var $b30f040761123e4b$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/, re2 = /b*/g;
    $b30f040761123e4b$var$nativeExec.call(re1, 'a');
    $b30f040761123e4b$var$nativeExec.call(re2, 'a');
    return re1[$b30f040761123e4b$var$LAST_INDEX] !== 0 || re2[$b30f040761123e4b$var$LAST_INDEX] !== 0;
}();
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $b30f040761123e4b$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $b30f040761123e4b$var$PATCH = $b30f040761123e4b$var$UPDATES_LAST_INDEX_WRONG || $b30f040761123e4b$var$NPCG_INCLUDED;
if ($b30f040761123e4b$var$PATCH) $b30f040761123e4b$var$patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    if ($b30f040761123e4b$var$NPCG_INCLUDED) reCopy = new RegExp('^' + re.source + '$(?!\\s)', $lzkzv.call(re));
    if ($b30f040761123e4b$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re[$b30f040761123e4b$var$LAST_INDEX];
    match = $b30f040761123e4b$var$nativeExec.call(re, str);
    if ($b30f040761123e4b$var$UPDATES_LAST_INDEX_WRONG && match) re[$b30f040761123e4b$var$LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    if ($b30f040761123e4b$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    // eslint-disable-next-line no-loop-func
    $b30f040761123e4b$var$nativeReplace.call(match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    return match;
};
module.exports = $b30f040761123e4b$var$patchedExec;

});



parcelRegister("kubSZ", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $9bg2N = parcelRequire("9bg2N");

var $ekEf9 = parcelRequire("ekEf9");

var $ee9fd44ccd52bf16$var$SPECIES = (parcelRequire("5zj8I"))('species');
module.exports = function(O, D) {
    var C = $9bg2N(O).constructor;
    var S;
    return C === undefined || (S = $9bg2N(C)[$ee9fd44ccd52bf16$var$SPECIES]) == undefined ? D : $ekEf9(S);
};

});

parcelRegister("eEs8C", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("4Je1X", function(module, exports) {

var $cUEwJ = parcelRequire("cUEwJ");

var $b4G1J = parcelRequire("b4G1J");
var $37163f98b8827871$require$macrotask = $b4G1J.set;
var $37163f98b8827871$var$Observer = $cUEwJ.MutationObserver || $cUEwJ.WebKitMutationObserver;
var $37163f98b8827871$var$process = $cUEwJ.process;
var $37163f98b8827871$var$Promise = $cUEwJ.Promise;

var $37163f98b8827871$var$isNode = (parcelRequire("8t6Im"))($37163f98b8827871$var$process) == 'process';
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($37163f98b8827871$var$isNode && (parent = $37163f98b8827871$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($37163f98b8827871$var$isNode) notify = function() {
        $37163f98b8827871$var$process.nextTick(flush);
    };
    else if ($37163f98b8827871$var$Observer && !($cUEwJ.navigator && $cUEwJ.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new $37163f98b8827871$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($37163f98b8827871$var$Promise && $37163f98b8827871$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $37163f98b8827871$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $37163f98b8827871$require$macrotask.call($cUEwJ, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});
parcelRegister("b4G1J", function(module, exports) {

var $i2qD6 = parcelRequire("i2qD6");

var $8KdzC = parcelRequire("8KdzC");

var $e9oLT = parcelRequire("e9oLT");

var $aMQD1 = parcelRequire("aMQD1");

var $cUEwJ = parcelRequire("cUEwJ");
var $8100ab1b867d19c0$var$process = $cUEwJ.process;
var $8100ab1b867d19c0$var$setTask = $cUEwJ.setImmediate;
var $8100ab1b867d19c0$var$clearTask = $cUEwJ.clearImmediate;
var $8100ab1b867d19c0$var$MessageChannel = $cUEwJ.MessageChannel;
var $8100ab1b867d19c0$var$Dispatch = $cUEwJ.Dispatch;
var $8100ab1b867d19c0$var$counter = 0;
var $8100ab1b867d19c0$var$queue = {};
var $8100ab1b867d19c0$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $8100ab1b867d19c0$var$defer, $8100ab1b867d19c0$var$channel, $8100ab1b867d19c0$var$port;
var $8100ab1b867d19c0$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($8100ab1b867d19c0$var$queue.hasOwnProperty(id)) {
        var fn = $8100ab1b867d19c0$var$queue[id];
        delete $8100ab1b867d19c0$var$queue[id];
        fn();
    }
};
var $8100ab1b867d19c0$var$listener = function(event) {
    $8100ab1b867d19c0$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$8100ab1b867d19c0$var$setTask || !$8100ab1b867d19c0$var$clearTask) {
    $8100ab1b867d19c0$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $8100ab1b867d19c0$var$queue[++$8100ab1b867d19c0$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $8KdzC(typeof fn == 'function' ? fn : Function(fn), args);
        };
        $8100ab1b867d19c0$var$defer($8100ab1b867d19c0$var$counter);
        return $8100ab1b867d19c0$var$counter;
    };
    $8100ab1b867d19c0$var$clearTask = function clearImmediate(id) {
        delete $8100ab1b867d19c0$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("8t6Im"))($8100ab1b867d19c0$var$process) == 'process') $8100ab1b867d19c0$var$defer = function(id) {
        $8100ab1b867d19c0$var$process.nextTick($i2qD6($8100ab1b867d19c0$var$run, id, 1));
    };
    else if ($8100ab1b867d19c0$var$Dispatch && $8100ab1b867d19c0$var$Dispatch.now) $8100ab1b867d19c0$var$defer = function(id) {
        $8100ab1b867d19c0$var$Dispatch.now($i2qD6($8100ab1b867d19c0$var$run, id, 1));
    };
    else if ($8100ab1b867d19c0$var$MessageChannel) {
        $8100ab1b867d19c0$var$channel = new $8100ab1b867d19c0$var$MessageChannel();
        $8100ab1b867d19c0$var$port = $8100ab1b867d19c0$var$channel.port2;
        $8100ab1b867d19c0$var$channel.port1.onmessage = $8100ab1b867d19c0$var$listener;
        $8100ab1b867d19c0$var$defer = $i2qD6($8100ab1b867d19c0$var$port.postMessage, $8100ab1b867d19c0$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($cUEwJ.addEventListener && typeof postMessage == 'function' && !$cUEwJ.importScripts) {
        $8100ab1b867d19c0$var$defer = function(id) {
            $cUEwJ.postMessage(id + '', '*');
        };
        $cUEwJ.addEventListener('message', $8100ab1b867d19c0$var$listener, false);
    // IE8-
    } else if ($8100ab1b867d19c0$var$ONREADYSTATECHANGE in $aMQD1('script')) $8100ab1b867d19c0$var$defer = function(id) {
        $e9oLT.appendChild($aMQD1('script'))[$8100ab1b867d19c0$var$ONREADYSTATECHANGE] = function() {
            $e9oLT.removeChild(this);
            $8100ab1b867d19c0$var$run.call(id);
        };
    };
    else $8100ab1b867d19c0$var$defer = function(id) {
        setTimeout($i2qD6($8100ab1b867d19c0$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $8100ab1b867d19c0$var$setTask,
    clear: $8100ab1b867d19c0$var$clearTask
};

});


parcelRegister("edFiS", function(module, exports) {

var $2niSg = parcelRequire("2niSg");
module.exports = function(target, src, safe) {
    for(var key in src)$2niSg(target, key, src[key], safe);
    return target;
};

});

parcelRegister("infE6", function(module, exports) {
'use strict';

var $cUEwJ = parcelRequire("cUEwJ");

var $7UCsS = parcelRequire("7UCsS");

var $2niSg = parcelRequire("2niSg");

var $edFiS = parcelRequire("edFiS");

var $7p9t8 = parcelRequire("7p9t8");

var $2b8La = parcelRequire("2b8La");

var $eEs8C = parcelRequire("eEs8C");

var $5ehF7 = parcelRequire("5ehF7");

var $d6gmi = parcelRequire("d6gmi");

var $3YVTs = parcelRequire("3YVTs");

var $5MNda = parcelRequire("5MNda");

var $1EHqA = parcelRequire("1EHqA");
module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = $cUEwJ[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};
    var fixMethod = function(KEY) {
        var fn = proto[KEY];
        $2niSg(proto, KEY, KEY == 'delete' ? function(a) {
            return IS_WEAK && !$5ehF7(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'has' ? function has(a) {
            return IS_WEAK && !$5ehF7(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'get' ? function get(a) {
            return IS_WEAK && !$5ehF7(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'add' ? function add(a) {
            fn.call(this, a === 0 ? 0 : a);
            return this;
        } : function set(a, b) {
            fn.call(this, a === 0 ? 0 : a, b);
            return this;
        });
    };
    if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !$d6gmi(function() {
        new C().entries().next();
    }))) {
        // create collection constructor
        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
        $edFiS(C.prototype, methods);
        $7p9t8.NEED = true;
    } else {
        var instance = new C();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $d6gmi(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        var ACCEPT_ITERABLES = $3YVTs(function(iter) {
            new C(iter);
        }); // eslint-disable-line no-new
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $d6gmi(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new C();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            C = wrapper(function(target, iterable) {
                $eEs8C(target, C, NAME);
                var that = $1EHqA(new Base(), target, C);
                if (iterable != undefined) $2b8La(iterable, IS_MAP, that[ADDER], that);
                return that;
            });
            C.prototype = proto;
            proto.constructor = C;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && proto.clear) delete proto.clear;
    }
    $5MNda(C, NAME);
    O[NAME] = C;
    $7UCsS($7UCsS.G + $7UCsS.W + $7UCsS.F * (C != Base), O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
};

});
parcelRegister("7p9t8", function(module, exports) {

var $5642368d434444c0$var$META = (parcelRequire("7bg9a"))('meta');

var $5ehF7 = parcelRequire("5ehF7");

var $i9PqC = parcelRequire("i9PqC");

var $1w421 = parcelRequire("1w421");
var $5642368d434444c0$require$setDesc = $1w421.f;
var $5642368d434444c0$var$id = 0;
var $5642368d434444c0$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $5642368d434444c0$var$FREEZE = !(parcelRequire("d6gmi"))(function() {
    return $5642368d434444c0$var$isExtensible(Object.preventExtensions({}));
});
var $5642368d434444c0$var$setMeta = function(it) {
    $5642368d434444c0$require$setDesc(it, $5642368d434444c0$var$META, {
        value: {
            i: 'O' + ++$5642368d434444c0$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $5642368d434444c0$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$5ehF7(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$i9PqC(it, $5642368d434444c0$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$5642368d434444c0$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $5642368d434444c0$var$setMeta(it);
    // return object ID
    }
    return it[$5642368d434444c0$var$META].i;
};
var $5642368d434444c0$var$getWeak = function(it, create) {
    if (!$i9PqC(it, $5642368d434444c0$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$5642368d434444c0$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $5642368d434444c0$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$5642368d434444c0$var$META].w;
};
// add metadata on freeze-family methods calling
var $5642368d434444c0$var$onFreeze = function(it) {
    if ($5642368d434444c0$var$FREEZE && $5642368d434444c0$var$meta.NEED && $5642368d434444c0$var$isExtensible(it) && !$i9PqC(it, $5642368d434444c0$var$META)) $5642368d434444c0$var$setMeta(it);
    return it;
};
var $5642368d434444c0$var$meta = module.exports = {
    KEY: $5642368d434444c0$var$META,
    NEED: false,
    fastKey: $5642368d434444c0$var$fastKey,
    getWeak: $5642368d434444c0$var$getWeak,
    onFreeze: $5642368d434444c0$var$onFreeze
};

});

parcelRegister("2b8La", function(module, exports) {

var $i2qD6 = parcelRequire("i2qD6");

var $g3ACS = parcelRequire("g3ACS");

var $dMVvs = parcelRequire("dMVvs");

var $9bg2N = parcelRequire("9bg2N");

var $75R4e = parcelRequire("75R4e");

var $bHyyq = parcelRequire("bHyyq");
var $1963675eccf8ae32$var$BREAK = {};
var $1963675eccf8ae32$var$RETURN = {};
var $1963675eccf8ae32$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $bHyyq(iterable);
    var f = $i2qD6(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($dMVvs(iterFn)) for(length = $75R4e(iterable.length); length > index; index++){
        result = entries ? f($9bg2N(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $1963675eccf8ae32$var$BREAK || result === $1963675eccf8ae32$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $g3ACS(iterator, f, step.value, entries);
        if (result === $1963675eccf8ae32$var$BREAK || result === $1963675eccf8ae32$var$RETURN) return result;
    }
};
$1963675eccf8ae32$var$exports.BREAK = $1963675eccf8ae32$var$BREAK;
$1963675eccf8ae32$var$exports.RETURN = $1963675eccf8ae32$var$RETURN;

});
parcelRegister("g3ACS", function(module, exports) {
// call something on iterator step with safe closing on error

var $9bg2N = parcelRequire("9bg2N");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($9bg2N(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $9bg2N(ret.call(iterator));
        throw e;
    }
};

});


parcelRegister("1EHqA", function(module, exports) {

var $5ehF7 = parcelRequire("5ehF7");

var $gALmc = parcelRequire("gALmc");
var $134b36b58cc044ce$require$setPrototypeOf = $gALmc.set;
module.exports = function(that, target, C) {
    var S = target.constructor;
    var P;
    if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && $5ehF7(P) && $134b36b58cc044ce$require$setPrototypeOf) $134b36b58cc044ce$require$setPrototypeOf(that, P);
    return that;
};

});


parcelRegister("fvN4d", function(module, exports) {
'use strict';

var $cUEwJ = parcelRequire("cUEwJ");

var $b4afcff02061b043$var$each = (parcelRequire("gXweJ"))(0);

var $2niSg = parcelRequire("2niSg");

var $7p9t8 = parcelRequire("7p9t8");

var $kr8PN = parcelRequire("kr8PN");

var $4TFbT = parcelRequire("4TFbT");

var $5ehF7 = parcelRequire("5ehF7");

var $i8KhX = parcelRequire("i8KhX");

var $i8KhX = parcelRequire("i8KhX");
var $b4afcff02061b043$var$IS_IE11 = !$cUEwJ.ActiveXObject && 'ActiveXObject' in $cUEwJ;
var $b4afcff02061b043$var$WEAK_MAP = 'WeakMap';
var $b4afcff02061b043$var$getWeak = $7p9t8.getWeak;
var $b4afcff02061b043$var$isExtensible = Object.isExtensible;
var $b4afcff02061b043$var$uncaughtFrozenStore = $4TFbT.ufstore;
var $b4afcff02061b043$var$InternalMap;
var $b4afcff02061b043$var$wrapper = function(get) {
    return function WeakMap() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
};
var $b4afcff02061b043$var$methods = {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key) {
        if ($5ehF7(key)) {
            var data = $b4afcff02061b043$var$getWeak(key);
            if (data === true) return $b4afcff02061b043$var$uncaughtFrozenStore($i8KhX(this, $b4afcff02061b043$var$WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
        }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value) {
        return $4TFbT.def($i8KhX(this, $b4afcff02061b043$var$WEAK_MAP), key, value);
    }
};

// 23.3 WeakMap Objects
var $b4afcff02061b043$var$$WeakMap = module.exports = (parcelRequire("infE6"))($b4afcff02061b043$var$WEAK_MAP, $b4afcff02061b043$var$wrapper, $b4afcff02061b043$var$methods, $4TFbT, true, true);
// IE11 WeakMap frozen keys fix
if ($i8KhX && $b4afcff02061b043$var$IS_IE11) {
    $b4afcff02061b043$var$InternalMap = $4TFbT.getConstructor($b4afcff02061b043$var$wrapper, $b4afcff02061b043$var$WEAK_MAP);
    $kr8PN($b4afcff02061b043$var$InternalMap.prototype, $b4afcff02061b043$var$methods);
    $7p9t8.NEED = true;
    $b4afcff02061b043$var$each([
        'delete',
        'has',
        'get',
        'set'
    ], function(key) {
        var proto = $b4afcff02061b043$var$$WeakMap.prototype;
        var method = proto[key];
        $2niSg(proto, key, function(a, b) {
            // store frozen objects on internal weakmap shim
            if ($5ehF7(a) && !$b4afcff02061b043$var$isExtensible(a)) {
                if (!this._f) this._f = new $b4afcff02061b043$var$InternalMap();
                var result = this._f[key](a, b);
                return key == 'set' ? this : result;
            // store all the rest on native weakmap
            }
            return method.call(this, a, b);
        });
    });
}

});
parcelRegister("4TFbT", function(module, exports) {
'use strict';

var $edFiS = parcelRequire("edFiS");

var $7p9t8 = parcelRequire("7p9t8");
var $390c401e88275dcb$require$getWeak = $7p9t8.getWeak;

var $9bg2N = parcelRequire("9bg2N");

var $5ehF7 = parcelRequire("5ehF7");

var $eEs8C = parcelRequire("eEs8C");

var $2b8La = parcelRequire("2b8La");

var $gXweJ = parcelRequire("gXweJ");

var $i9PqC = parcelRequire("i9PqC");

var $i8KhX = parcelRequire("i8KhX");
var $390c401e88275dcb$var$arrayFind = $gXweJ(5);
var $390c401e88275dcb$var$arrayFindIndex = $gXweJ(6);
var $390c401e88275dcb$var$id = 0;
// fallback for uncaught frozen keys
var $390c401e88275dcb$var$uncaughtFrozenStore = function(that) {
    return that._l || (that._l = new $390c401e88275dcb$var$UncaughtFrozenStore());
};
var $390c401e88275dcb$var$UncaughtFrozenStore = function() {
    this.a = [];
};
var $390c401e88275dcb$var$findUncaughtFrozen = function(store, key) {
    return $390c401e88275dcb$var$arrayFind(store.a, function(it) {
        return it[0] === key;
    });
};
$390c401e88275dcb$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $390c401e88275dcb$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$390c401e88275dcb$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $390c401e88275dcb$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.a.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $390c401e88275dcb$var$arrayFindIndex(this.a, function(it) {
            return it[0] === key;
        });
        if (~index) this.a.splice(index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $eEs8C(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $390c401e88275dcb$var$id++; // collection id
            that._l = undefined; // leak store for uncaught frozen objects
            if (iterable != undefined) $2b8La(iterable, IS_MAP, that[ADDER], that);
        });
        $edFiS(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            'delete': function(key) {
                if (!$5ehF7(key)) return false;
                var data = $390c401e88275dcb$require$getWeak(key);
                if (data === true) return $390c401e88275dcb$var$uncaughtFrozenStore($i8KhX(this, NAME))['delete'](key);
                return data && $i9PqC(data, this._i) && delete data[this._i];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
                if (!$5ehF7(key)) return false;
                var data = $390c401e88275dcb$require$getWeak(key);
                if (data === true) return $390c401e88275dcb$var$uncaughtFrozenStore($i8KhX(this, NAME)).has(key);
                return data && $i9PqC(data, this._i);
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var data = $390c401e88275dcb$require$getWeak($9bg2N(key), true);
        if (data === true) $390c401e88275dcb$var$uncaughtFrozenStore(that).set(key, value);
        else data[that._i] = value;
        return that;
    },
    ufstore: $390c401e88275dcb$var$uncaughtFrozenStore
};

});
parcelRegister("i8KhX", function(module, exports) {

var $5ehF7 = parcelRequire("5ehF7");
module.exports = function(it, TYPE) {
    if (!$5ehF7(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
};

});



parcelRegister("7W5f9", function(module, exports) {

var $cUEwJ = parcelRequire("cUEwJ");

var $6G6JS = parcelRequire("6G6JS");

var $7bg9a = parcelRequire("7bg9a");
var $5c720463617fa064$var$TYPED = $7bg9a('typed_array');
var $5c720463617fa064$var$VIEW = $7bg9a('view');
var $5c720463617fa064$var$ABV = !!($cUEwJ.ArrayBuffer && $cUEwJ.DataView);
var $5c720463617fa064$var$CONSTR = $5c720463617fa064$var$ABV;
var $5c720463617fa064$var$i = 0;
var $5c720463617fa064$var$l = 9;
var $5c720463617fa064$var$Typed;
var $5c720463617fa064$var$TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
while($5c720463617fa064$var$i < $5c720463617fa064$var$l)if ($5c720463617fa064$var$Typed = $cUEwJ[$5c720463617fa064$var$TypedArrayConstructors[$5c720463617fa064$var$i++]]) {
    $6G6JS($5c720463617fa064$var$Typed.prototype, $5c720463617fa064$var$TYPED, true);
    $6G6JS($5c720463617fa064$var$Typed.prototype, $5c720463617fa064$var$VIEW, true);
} else $5c720463617fa064$var$CONSTR = false;
module.exports = {
    ABV: $5c720463617fa064$var$ABV,
    CONSTR: $5c720463617fa064$var$CONSTR,
    TYPED: $5c720463617fa064$var$TYPED,
    VIEW: $5c720463617fa064$var$VIEW
};

});

parcelRegister("lFMTj", function(module, exports) {
'use strict';

var $cUEwJ = parcelRequire("cUEwJ");

var $gvp2l = parcelRequire("gvp2l");

var $6VDEP = parcelRequire("6VDEP");

var $7W5f9 = parcelRequire("7W5f9");

var $6G6JS = parcelRequire("6G6JS");

var $edFiS = parcelRequire("edFiS");

var $d6gmi = parcelRequire("d6gmi");

var $eEs8C = parcelRequire("eEs8C");

var $lelYU = parcelRequire("lelYU");

var $75R4e = parcelRequire("75R4e");

var $2n7Gn = parcelRequire("2n7Gn");

var $dQVrJ = parcelRequire("dQVrJ");
var $fc735a1761b643bf$require$gOPN = $dQVrJ.f;

var $1w421 = parcelRequire("1w421");
var $fc735a1761b643bf$require$dP = $1w421.f;

var $e50fk = parcelRequire("e50fk");

var $5MNda = parcelRequire("5MNda");
var $fc735a1761b643bf$var$ARRAY_BUFFER = 'ArrayBuffer';
var $fc735a1761b643bf$var$DATA_VIEW = 'DataView';
var $fc735a1761b643bf$var$PROTOTYPE = 'prototype';
var $fc735a1761b643bf$var$WRONG_LENGTH = 'Wrong length!';
var $fc735a1761b643bf$var$WRONG_INDEX = 'Wrong index!';
var $fc735a1761b643bf$var$$ArrayBuffer = $cUEwJ[$fc735a1761b643bf$var$ARRAY_BUFFER];
var $fc735a1761b643bf$var$$DataView = $cUEwJ[$fc735a1761b643bf$var$DATA_VIEW];
var $fc735a1761b643bf$var$Math = $cUEwJ.Math;
var $fc735a1761b643bf$var$RangeError = $cUEwJ.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var $fc735a1761b643bf$var$Infinity1 = $cUEwJ.Infinity;
var $fc735a1761b643bf$var$BaseBuffer = $fc735a1761b643bf$var$$ArrayBuffer;
var $fc735a1761b643bf$var$abs = $fc735a1761b643bf$var$Math.abs;
var $fc735a1761b643bf$var$pow = $fc735a1761b643bf$var$Math.pow;
var $fc735a1761b643bf$var$floor = $fc735a1761b643bf$var$Math.floor;
var $fc735a1761b643bf$var$log = $fc735a1761b643bf$var$Math.log;
var $fc735a1761b643bf$var$LN2 = $fc735a1761b643bf$var$Math.LN2;
var $fc735a1761b643bf$var$BUFFER = 'buffer';
var $fc735a1761b643bf$var$BYTE_LENGTH = 'byteLength';
var $fc735a1761b643bf$var$BYTE_OFFSET = 'byteOffset';
var $fc735a1761b643bf$var$$BUFFER = $gvp2l ? '_b' : $fc735a1761b643bf$var$BUFFER;
var $fc735a1761b643bf$var$$LENGTH = $gvp2l ? '_l' : $fc735a1761b643bf$var$BYTE_LENGTH;
var $fc735a1761b643bf$var$$OFFSET = $gvp2l ? '_o' : $fc735a1761b643bf$var$BYTE_OFFSET;
// IEEE754 conversions based on https://github.com/feross/ieee754
function $fc735a1761b643bf$var$packIEEE754(value, mLen, nBytes) {
    var buffer = new Array(nBytes);
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? $fc735a1761b643bf$var$pow(2, -24) - $fc735a1761b643bf$var$pow(2, -77) : 0;
    var i = 0;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    var e, m, c;
    value = $fc735a1761b643bf$var$abs(value);
    // eslint-disable-next-line no-self-compare
    if (value != value || value === Infinity) {
        // eslint-disable-next-line no-self-compare
        m = value != value ? 1 : 0;
        e = eMax;
    } else {
        e = $fc735a1761b643bf$var$floor($fc735a1761b643bf$var$log(value) / $fc735a1761b643bf$var$LN2);
        if (value * (c = $fc735a1761b643bf$var$pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * $fc735a1761b643bf$var$pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * $fc735a1761b643bf$var$pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * $fc735a1761b643bf$var$pow(2, eBias - 1) * $fc735a1761b643bf$var$pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
    buffer[--i] |= s * 128;
    return buffer;
}
function $fc735a1761b643bf$var$unpackIEEE754(buffer, mLen, nBytes) {
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = eLen - 7;
    var i = nBytes - 1;
    var s = buffer[i--];
    var e = s & 127;
    var m;
    s >>= 7;
    for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : s ? -Infinity : Infinity;
    else {
        m = m + $fc735a1761b643bf$var$pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * $fc735a1761b643bf$var$pow(2, e - mLen);
}
function $fc735a1761b643bf$var$unpackI32(bytes) {
    return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function $fc735a1761b643bf$var$packI8(it) {
    return [
        it & 0xff
    ];
}
function $fc735a1761b643bf$var$packI16(it) {
    return [
        it & 0xff,
        it >> 8 & 0xff
    ];
}
function $fc735a1761b643bf$var$packI32(it) {
    return [
        it & 0xff,
        it >> 8 & 0xff,
        it >> 16 & 0xff,
        it >> 24 & 0xff
    ];
}
function $fc735a1761b643bf$var$packF64(it) {
    return $fc735a1761b643bf$var$packIEEE754(it, 52, 8);
}
function $fc735a1761b643bf$var$packF32(it) {
    return $fc735a1761b643bf$var$packIEEE754(it, 23, 4);
}
function $fc735a1761b643bf$var$addGetter(C, key, internal) {
    $fc735a1761b643bf$require$dP(C[$fc735a1761b643bf$var$PROTOTYPE], key, {
        get: function() {
            return this[internal];
        }
    });
}
function $fc735a1761b643bf$var$get(view, bytes, index, isLittleEndian) {
    var numIndex = +index;
    var intIndex = $2n7Gn(numIndex);
    if (intIndex + bytes > view[$fc735a1761b643bf$var$$LENGTH]) throw $fc735a1761b643bf$var$RangeError($fc735a1761b643bf$var$WRONG_INDEX);
    var store = view[$fc735a1761b643bf$var$$BUFFER]._b;
    var start = intIndex + view[$fc735a1761b643bf$var$$OFFSET];
    var pack = store.slice(start, start + bytes);
    return isLittleEndian ? pack : pack.reverse();
}
function $fc735a1761b643bf$var$set(view, bytes, index, conversion, value, isLittleEndian) {
    var numIndex = +index;
    var intIndex = $2n7Gn(numIndex);
    if (intIndex + bytes > view[$fc735a1761b643bf$var$$LENGTH]) throw $fc735a1761b643bf$var$RangeError($fc735a1761b643bf$var$WRONG_INDEX);
    var store = view[$fc735a1761b643bf$var$$BUFFER]._b;
    var start = intIndex + view[$fc735a1761b643bf$var$$OFFSET];
    var pack = conversion(+value);
    for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}
if (!$7W5f9.ABV) {
    $fc735a1761b643bf$var$$ArrayBuffer = function ArrayBuffer(length) {
        $eEs8C(this, $fc735a1761b643bf$var$$ArrayBuffer, $fc735a1761b643bf$var$ARRAY_BUFFER);
        var byteLength = $2n7Gn(length);
        this._b = $e50fk.call(new Array(byteLength), 0);
        this[$fc735a1761b643bf$var$$LENGTH] = byteLength;
    };
    $fc735a1761b643bf$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $eEs8C(this, $fc735a1761b643bf$var$$DataView, $fc735a1761b643bf$var$DATA_VIEW);
        $eEs8C(buffer, $fc735a1761b643bf$var$$ArrayBuffer, $fc735a1761b643bf$var$DATA_VIEW);
        var bufferLength = buffer[$fc735a1761b643bf$var$$LENGTH];
        var offset = $lelYU(byteOffset);
        if (offset < 0 || offset > bufferLength) throw $fc735a1761b643bf$var$RangeError('Wrong offset!');
        byteLength = byteLength === undefined ? bufferLength - offset : $75R4e(byteLength);
        if (offset + byteLength > bufferLength) throw $fc735a1761b643bf$var$RangeError($fc735a1761b643bf$var$WRONG_LENGTH);
        this[$fc735a1761b643bf$var$$BUFFER] = buffer;
        this[$fc735a1761b643bf$var$$OFFSET] = offset;
        this[$fc735a1761b643bf$var$$LENGTH] = byteLength;
    };
    if ($gvp2l) {
        $fc735a1761b643bf$var$addGetter($fc735a1761b643bf$var$$ArrayBuffer, $fc735a1761b643bf$var$BYTE_LENGTH, '_l');
        $fc735a1761b643bf$var$addGetter($fc735a1761b643bf$var$$DataView, $fc735a1761b643bf$var$BUFFER, '_b');
        $fc735a1761b643bf$var$addGetter($fc735a1761b643bf$var$$DataView, $fc735a1761b643bf$var$BYTE_LENGTH, '_l');
        $fc735a1761b643bf$var$addGetter($fc735a1761b643bf$var$$DataView, $fc735a1761b643bf$var$BYTE_OFFSET, '_o');
    }
    $edFiS($fc735a1761b643bf$var$$DataView[$fc735a1761b643bf$var$PROTOTYPE], {
        getInt8: function getInt8(byteOffset) {
            return $fc735a1761b643bf$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $fc735a1761b643bf$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $fc735a1761b643bf$var$get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $fc735a1761b643bf$var$get(this, 2, byteOffset, arguments[1]);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $fc735a1761b643bf$var$unpackI32($fc735a1761b643bf$var$get(this, 4, byteOffset, arguments[1]));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $fc735a1761b643bf$var$unpackI32($fc735a1761b643bf$var$get(this, 4, byteOffset, arguments[1])) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $fc735a1761b643bf$var$unpackIEEE754($fc735a1761b643bf$var$get(this, 4, byteOffset, arguments[1]), 23, 4);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $fc735a1761b643bf$var$unpackIEEE754($fc735a1761b643bf$var$get(this, 8, byteOffset, arguments[1]), 52, 8);
        },
        setInt8: function setInt8(byteOffset, value) {
            $fc735a1761b643bf$var$set(this, 1, byteOffset, $fc735a1761b643bf$var$packI8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $fc735a1761b643bf$var$set(this, 1, byteOffset, $fc735a1761b643bf$var$packI8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $fc735a1761b643bf$var$set(this, 2, byteOffset, $fc735a1761b643bf$var$packI16, value, arguments[2]);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $fc735a1761b643bf$var$set(this, 2, byteOffset, $fc735a1761b643bf$var$packI16, value, arguments[2]);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $fc735a1761b643bf$var$set(this, 4, byteOffset, $fc735a1761b643bf$var$packI32, value, arguments[2]);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $fc735a1761b643bf$var$set(this, 4, byteOffset, $fc735a1761b643bf$var$packI32, value, arguments[2]);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $fc735a1761b643bf$var$set(this, 4, byteOffset, $fc735a1761b643bf$var$packF32, value, arguments[2]);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $fc735a1761b643bf$var$set(this, 8, byteOffset, $fc735a1761b643bf$var$packF64, value, arguments[2]);
        }
    });
} else {
    if (!$d6gmi(function() {
        $fc735a1761b643bf$var$$ArrayBuffer(1);
    }) || !$d6gmi(function() {
        new $fc735a1761b643bf$var$$ArrayBuffer(-1); // eslint-disable-line no-new
    }) || $d6gmi(function() {
        new $fc735a1761b643bf$var$$ArrayBuffer(); // eslint-disable-line no-new
        new $fc735a1761b643bf$var$$ArrayBuffer(1.5); // eslint-disable-line no-new
        new $fc735a1761b643bf$var$$ArrayBuffer(NaN); // eslint-disable-line no-new
        return $fc735a1761b643bf$var$$ArrayBuffer.name != $fc735a1761b643bf$var$ARRAY_BUFFER;
    })) {
        $fc735a1761b643bf$var$$ArrayBuffer = function ArrayBuffer(length) {
            $eEs8C(this, $fc735a1761b643bf$var$$ArrayBuffer);
            return new $fc735a1761b643bf$var$BaseBuffer($2n7Gn(length));
        };
        var $fc735a1761b643bf$var$ArrayBufferProto = $fc735a1761b643bf$var$$ArrayBuffer[$fc735a1761b643bf$var$PROTOTYPE] = $fc735a1761b643bf$var$BaseBuffer[$fc735a1761b643bf$var$PROTOTYPE];
        for(var $fc735a1761b643bf$var$keys = $fc735a1761b643bf$require$gOPN($fc735a1761b643bf$var$BaseBuffer), $fc735a1761b643bf$var$j = 0, $fc735a1761b643bf$var$key; $fc735a1761b643bf$var$keys.length > $fc735a1761b643bf$var$j;)if (!(($fc735a1761b643bf$var$key = $fc735a1761b643bf$var$keys[$fc735a1761b643bf$var$j++]) in $fc735a1761b643bf$var$$ArrayBuffer)) $6G6JS($fc735a1761b643bf$var$$ArrayBuffer, $fc735a1761b643bf$var$key, $fc735a1761b643bf$var$BaseBuffer[$fc735a1761b643bf$var$key]);
        if (!$6VDEP) $fc735a1761b643bf$var$ArrayBufferProto.constructor = $fc735a1761b643bf$var$$ArrayBuffer;
    }
    // iOS Safari 7.x bug
    var $fc735a1761b643bf$var$view = new $fc735a1761b643bf$var$$DataView(new $fc735a1761b643bf$var$$ArrayBuffer(2));
    var $fc735a1761b643bf$var$$setInt8 = $fc735a1761b643bf$var$$DataView[$fc735a1761b643bf$var$PROTOTYPE].setInt8;
    $fc735a1761b643bf$var$view.setInt8(0, 2147483648);
    $fc735a1761b643bf$var$view.setInt8(1, 2147483649);
    if ($fc735a1761b643bf$var$view.getInt8(0) || !$fc735a1761b643bf$var$view.getInt8(1)) $edFiS($fc735a1761b643bf$var$$DataView[$fc735a1761b643bf$var$PROTOTYPE], {
        setInt8: function setInt8(byteOffset, value) {
            $fc735a1761b643bf$var$$setInt8.call(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $fc735a1761b643bf$var$$setInt8.call(this, byteOffset, value << 24 >> 24);
        }
    }, true);
}
$5MNda($fc735a1761b643bf$var$$ArrayBuffer, $fc735a1761b643bf$var$ARRAY_BUFFER);
$5MNda($fc735a1761b643bf$var$$DataView, $fc735a1761b643bf$var$DATA_VIEW);
$6G6JS($fc735a1761b643bf$var$$DataView[$fc735a1761b643bf$var$PROTOTYPE], $7W5f9.VIEW, true);
module.exports[$fc735a1761b643bf$var$ARRAY_BUFFER] = $fc735a1761b643bf$var$$ArrayBuffer;
module.exports[$fc735a1761b643bf$var$DATA_VIEW] = $fc735a1761b643bf$var$$DataView;

});
parcelRegister("2n7Gn", function(module, exports) {
// https://tc39.github.io/ecma262/#sec-toindex

var $lelYU = parcelRequire("lelYU");

var $75R4e = parcelRequire("75R4e");
module.exports = function(it) {
    if (it === undefined) return 0;
    var number = $lelYU(it);
    var length = $75R4e(number);
    if (number !== length) throw RangeError('Wrong length!');
    return length;
};

});


parcelRegister("aFUiK", function(module, exports) {
'use strict';







































if ((parcelRequire("gvp2l"))) {
    var $7c5967fd507782b8$var$LIBRARY = (parcelRequire("6VDEP"));
    var $7c5967fd507782b8$var$global = (parcelRequire("cUEwJ"));
    var $7c5967fd507782b8$var$fails = (parcelRequire("d6gmi"));
    var $7c5967fd507782b8$var$$export = (parcelRequire("7UCsS"));
    var $7c5967fd507782b8$var$$typed = (parcelRequire("7W5f9"));
    var $7c5967fd507782b8$var$$buffer = (parcelRequire("lFMTj"));
    var $7c5967fd507782b8$var$ctx = (parcelRequire("i2qD6"));
    var $7c5967fd507782b8$var$anInstance = (parcelRequire("eEs8C"));
    var $7c5967fd507782b8$var$propertyDesc = (parcelRequire("jPGz2"));
    var $7c5967fd507782b8$var$hide = (parcelRequire("6G6JS"));
    var $7c5967fd507782b8$var$redefineAll = (parcelRequire("edFiS"));
    var $7c5967fd507782b8$var$toInteger = (parcelRequire("lelYU"));
    var $7c5967fd507782b8$var$toLength = (parcelRequire("75R4e"));
    var $7c5967fd507782b8$var$toIndex = (parcelRequire("2n7Gn"));
    var $7c5967fd507782b8$var$toAbsoluteIndex = (parcelRequire("ktL0p"));
    var $7c5967fd507782b8$var$toPrimitive = (parcelRequire("hFD9L"));
    var $7c5967fd507782b8$var$has = (parcelRequire("i9PqC"));
    var $7c5967fd507782b8$var$classof = (parcelRequire("d4Dmo"));
    var $7c5967fd507782b8$var$isObject = (parcelRequire("5ehF7"));
    var $7c5967fd507782b8$var$toObject = (parcelRequire("87N8x"));
    var $7c5967fd507782b8$var$isArrayIter = (parcelRequire("dMVvs"));
    var $7c5967fd507782b8$var$create = (parcelRequire("9hnGd"));
    var $7c5967fd507782b8$var$getPrototypeOf = (parcelRequire("hQ3EZ"));
    var $7c5967fd507782b8$var$gOPN = (parcelRequire("dQVrJ")).f;
    var $7c5967fd507782b8$var$getIterFn = (parcelRequire("bHyyq"));
    var $7c5967fd507782b8$var$uid = (parcelRequire("7bg9a"));
    var $7c5967fd507782b8$var$wks = (parcelRequire("5zj8I"));
    var $7c5967fd507782b8$var$createArrayMethod = (parcelRequire("gXweJ"));
    var $7c5967fd507782b8$var$createArrayIncludes = (parcelRequire("i2jbf"));
    var $7c5967fd507782b8$var$speciesConstructor = (parcelRequire("kubSZ"));
    var $7c5967fd507782b8$var$ArrayIterators = (parcelRequire("7V9Gt"));
    var $7c5967fd507782b8$var$Iterators = (parcelRequire("llfnB"));
    var $7c5967fd507782b8$var$$iterDetect = (parcelRequire("3YVTs"));
    var $7c5967fd507782b8$var$setSpecies = (parcelRequire("7hk0b"));
    var $7c5967fd507782b8$var$arrayFill = (parcelRequire("e50fk"));
    var $7c5967fd507782b8$var$arrayCopyWithin = (parcelRequire("fRAkt"));
    var $7c5967fd507782b8$var$$DP = (parcelRequire("1w421"));
    var $7c5967fd507782b8$var$$GOPD = (parcelRequire("clqre"));
    var $7c5967fd507782b8$var$dP = $7c5967fd507782b8$var$$DP.f;
    var $7c5967fd507782b8$var$gOPD = $7c5967fd507782b8$var$$GOPD.f;
    var $7c5967fd507782b8$var$RangeError = $7c5967fd507782b8$var$global.RangeError;
    var $7c5967fd507782b8$var$TypeError = $7c5967fd507782b8$var$global.TypeError;
    var $7c5967fd507782b8$var$Uint8Array = $7c5967fd507782b8$var$global.Uint8Array;
    var $7c5967fd507782b8$var$ARRAY_BUFFER = 'ArrayBuffer';
    var $7c5967fd507782b8$var$SHARED_BUFFER = 'Shared' + $7c5967fd507782b8$var$ARRAY_BUFFER;
    var $7c5967fd507782b8$var$BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
    var $7c5967fd507782b8$var$PROTOTYPE = 'prototype';
    var $7c5967fd507782b8$var$ArrayProto = Array[$7c5967fd507782b8$var$PROTOTYPE];
    var $7c5967fd507782b8$var$$ArrayBuffer = $7c5967fd507782b8$var$$buffer.ArrayBuffer;
    var $7c5967fd507782b8$var$$DataView = $7c5967fd507782b8$var$$buffer.DataView;
    var $7c5967fd507782b8$var$arrayForEach = $7c5967fd507782b8$var$createArrayMethod(0);
    var $7c5967fd507782b8$var$arrayFilter = $7c5967fd507782b8$var$createArrayMethod(2);
    var $7c5967fd507782b8$var$arraySome = $7c5967fd507782b8$var$createArrayMethod(3);
    var $7c5967fd507782b8$var$arrayEvery = $7c5967fd507782b8$var$createArrayMethod(4);
    var $7c5967fd507782b8$var$arrayFind = $7c5967fd507782b8$var$createArrayMethod(5);
    var $7c5967fd507782b8$var$arrayFindIndex = $7c5967fd507782b8$var$createArrayMethod(6);
    var $7c5967fd507782b8$var$arrayIncludes = $7c5967fd507782b8$var$createArrayIncludes(true);
    var $7c5967fd507782b8$var$arrayIndexOf = $7c5967fd507782b8$var$createArrayIncludes(false);
    var $7c5967fd507782b8$var$arrayValues = $7c5967fd507782b8$var$ArrayIterators.values;
    var $7c5967fd507782b8$var$arrayKeys = $7c5967fd507782b8$var$ArrayIterators.keys;
    var $7c5967fd507782b8$var$arrayEntries = $7c5967fd507782b8$var$ArrayIterators.entries;
    var $7c5967fd507782b8$var$arrayLastIndexOf = $7c5967fd507782b8$var$ArrayProto.lastIndexOf;
    var $7c5967fd507782b8$var$arrayReduce = $7c5967fd507782b8$var$ArrayProto.reduce;
    var $7c5967fd507782b8$var$arrayReduceRight = $7c5967fd507782b8$var$ArrayProto.reduceRight;
    var $7c5967fd507782b8$var$arrayJoin = $7c5967fd507782b8$var$ArrayProto.join;
    var $7c5967fd507782b8$var$arraySort = $7c5967fd507782b8$var$ArrayProto.sort;
    var $7c5967fd507782b8$var$arraySlice = $7c5967fd507782b8$var$ArrayProto.slice;
    var $7c5967fd507782b8$var$arrayToString = $7c5967fd507782b8$var$ArrayProto.toString;
    var $7c5967fd507782b8$var$arrayToLocaleString = $7c5967fd507782b8$var$ArrayProto.toLocaleString;
    var $7c5967fd507782b8$var$ITERATOR = $7c5967fd507782b8$var$wks('iterator');
    var $7c5967fd507782b8$var$TAG = $7c5967fd507782b8$var$wks('toStringTag');
    var $7c5967fd507782b8$var$TYPED_CONSTRUCTOR = $7c5967fd507782b8$var$uid('typed_constructor');
    var $7c5967fd507782b8$var$DEF_CONSTRUCTOR = $7c5967fd507782b8$var$uid('def_constructor');
    var $7c5967fd507782b8$var$ALL_CONSTRUCTORS = $7c5967fd507782b8$var$$typed.CONSTR;
    var $7c5967fd507782b8$var$TYPED_ARRAY = $7c5967fd507782b8$var$$typed.TYPED;
    var $7c5967fd507782b8$var$VIEW = $7c5967fd507782b8$var$$typed.VIEW;
    var $7c5967fd507782b8$var$WRONG_LENGTH = 'Wrong length!';
    var $7c5967fd507782b8$var$$map = $7c5967fd507782b8$var$createArrayMethod(1, function(O, length) {
        return $7c5967fd507782b8$var$allocate($7c5967fd507782b8$var$speciesConstructor(O, O[$7c5967fd507782b8$var$DEF_CONSTRUCTOR]), length);
    });
    var $7c5967fd507782b8$var$LITTLE_ENDIAN = $7c5967fd507782b8$var$fails(function() {
        // eslint-disable-next-line no-undef
        return new $7c5967fd507782b8$var$Uint8Array(new Uint16Array([
            1
        ]).buffer)[0] === 1;
    });
    var $7c5967fd507782b8$var$FORCED_SET = !!$7c5967fd507782b8$var$Uint8Array && !!$7c5967fd507782b8$var$Uint8Array[$7c5967fd507782b8$var$PROTOTYPE].set && $7c5967fd507782b8$var$fails(function() {
        new $7c5967fd507782b8$var$Uint8Array(1).set({});
    });
    var $7c5967fd507782b8$var$toOffset = function(it, BYTES) {
        var offset = $7c5967fd507782b8$var$toInteger(it);
        if (offset < 0 || offset % BYTES) throw $7c5967fd507782b8$var$RangeError('Wrong offset!');
        return offset;
    };
    var $7c5967fd507782b8$var$validate = function(it) {
        if ($7c5967fd507782b8$var$isObject(it) && $7c5967fd507782b8$var$TYPED_ARRAY in it) return it;
        throw $7c5967fd507782b8$var$TypeError(it + ' is not a typed array!');
    };
    var $7c5967fd507782b8$var$allocate = function(C, length) {
        if (!($7c5967fd507782b8$var$isObject(C) && $7c5967fd507782b8$var$TYPED_CONSTRUCTOR in C)) throw $7c5967fd507782b8$var$TypeError('It is not a typed array constructor!');
        return new C(length);
    };
    var $7c5967fd507782b8$var$speciesFromList = function(O, list) {
        return $7c5967fd507782b8$var$fromList($7c5967fd507782b8$var$speciesConstructor(O, O[$7c5967fd507782b8$var$DEF_CONSTRUCTOR]), list);
    };
    var $7c5967fd507782b8$var$fromList = function(C, list) {
        var index = 0;
        var length = list.length;
        var result = $7c5967fd507782b8$var$allocate(C, length);
        while(length > index)result[index] = list[index++];
        return result;
    };
    var $7c5967fd507782b8$var$addGetter = function(it, key, internal) {
        $7c5967fd507782b8$var$dP(it, key, {
            get: function() {
                return this._d[internal];
            }
        });
    };
    var $7c5967fd507782b8$var$$from = function from(source /* , mapfn, thisArg */ ) {
        var O = $7c5967fd507782b8$var$toObject(source);
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var iterFn = $7c5967fd507782b8$var$getIterFn(O);
        var i, length, values, result, step, iterator;
        if (iterFn != undefined && !$7c5967fd507782b8$var$isArrayIter(iterFn)) {
            for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++)values.push(step.value);
            O = values;
        }
        if (mapping && aLen > 2) mapfn = $7c5967fd507782b8$var$ctx(mapfn, arguments[2], 2);
        for(i = 0, length = $7c5967fd507782b8$var$toLength(O.length), result = $7c5967fd507782b8$var$allocate(this, length); length > i; i++)result[i] = mapping ? mapfn(O[i], i) : O[i];
        return result;
    };
    var $7c5967fd507782b8$var$$of = function of() {
        var index = 0;
        var length = arguments.length;
        var result = $7c5967fd507782b8$var$allocate(this, length);
        while(length > index)result[index] = arguments[index++];
        return result;
    };
    // iOS Safari 6.x fails here
    var $7c5967fd507782b8$var$TO_LOCALE_BUG = !!$7c5967fd507782b8$var$Uint8Array && $7c5967fd507782b8$var$fails(function() {
        $7c5967fd507782b8$var$arrayToLocaleString.call(new $7c5967fd507782b8$var$Uint8Array(1));
    });
    var $7c5967fd507782b8$var$$toLocaleString = function toLocaleString() {
        return $7c5967fd507782b8$var$arrayToLocaleString.apply($7c5967fd507782b8$var$TO_LOCALE_BUG ? $7c5967fd507782b8$var$arraySlice.call($7c5967fd507782b8$var$validate(this)) : $7c5967fd507782b8$var$validate(this), arguments);
    };
    var $7c5967fd507782b8$var$proto = {
        copyWithin: function copyWithin(target, start /* , end */ ) {
            return $7c5967fd507782b8$var$arrayCopyWithin.call($7c5967fd507782b8$var$validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
        },
        every: function every(callbackfn /* , thisArg */ ) {
            return $7c5967fd507782b8$var$arrayEvery($7c5967fd507782b8$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        fill: function fill(value /* , start, end */ ) {
            return $7c5967fd507782b8$var$arrayFill.apply($7c5967fd507782b8$var$validate(this), arguments);
        },
        filter: function filter(callbackfn /* , thisArg */ ) {
            return $7c5967fd507782b8$var$speciesFromList(this, $7c5967fd507782b8$var$arrayFilter($7c5967fd507782b8$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
        },
        find: function find(predicate /* , thisArg */ ) {
            return $7c5967fd507782b8$var$arrayFind($7c5967fd507782b8$var$validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        findIndex: function findIndex(predicate /* , thisArg */ ) {
            return $7c5967fd507782b8$var$arrayFindIndex($7c5967fd507782b8$var$validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        forEach: function forEach(callbackfn /* , thisArg */ ) {
            $7c5967fd507782b8$var$arrayForEach($7c5967fd507782b8$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        indexOf: function indexOf(searchElement /* , fromIndex */ ) {
            return $7c5967fd507782b8$var$arrayIndexOf($7c5967fd507782b8$var$validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        includes: function includes(searchElement /* , fromIndex */ ) {
            return $7c5967fd507782b8$var$arrayIncludes($7c5967fd507782b8$var$validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        join: function join(separator) {
            return $7c5967fd507782b8$var$arrayJoin.apply($7c5967fd507782b8$var$validate(this), arguments);
        },
        lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */ ) {
            return $7c5967fd507782b8$var$arrayLastIndexOf.apply($7c5967fd507782b8$var$validate(this), arguments);
        },
        map: function map(mapfn /* , thisArg */ ) {
            return $7c5967fd507782b8$var$$map($7c5967fd507782b8$var$validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        reduce: function reduce(callbackfn /* , initialValue */ ) {
            return $7c5967fd507782b8$var$arrayReduce.apply($7c5967fd507782b8$var$validate(this), arguments);
        },
        reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
            return $7c5967fd507782b8$var$arrayReduceRight.apply($7c5967fd507782b8$var$validate(this), arguments);
        },
        reverse: function reverse() {
            var that = this;
            var length = $7c5967fd507782b8$var$validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while(index < middle){
                value = that[index];
                that[index++] = that[--length];
                that[length] = value;
            }
            return that;
        },
        some: function some(callbackfn /* , thisArg */ ) {
            return $7c5967fd507782b8$var$arraySome($7c5967fd507782b8$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        sort: function sort(comparefn) {
            return $7c5967fd507782b8$var$arraySort.call($7c5967fd507782b8$var$validate(this), comparefn);
        },
        subarray: function subarray(begin, end) {
            var O = $7c5967fd507782b8$var$validate(this);
            var length = O.length;
            var $begin = $7c5967fd507782b8$var$toAbsoluteIndex(begin, length);
            return new ($7c5967fd507782b8$var$speciesConstructor(O, O[$7c5967fd507782b8$var$DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, $7c5967fd507782b8$var$toLength((end === undefined ? length : $7c5967fd507782b8$var$toAbsoluteIndex(end, length)) - $begin));
        }
    };
    var $7c5967fd507782b8$var$$slice = function slice(start, end) {
        return $7c5967fd507782b8$var$speciesFromList(this, $7c5967fd507782b8$var$arraySlice.call($7c5967fd507782b8$var$validate(this), start, end));
    };
    var $7c5967fd507782b8$var$$set = function set(arrayLike /* , offset */ ) {
        $7c5967fd507782b8$var$validate(this);
        var offset = $7c5967fd507782b8$var$toOffset(arguments[1], 1);
        var length = this.length;
        var src = $7c5967fd507782b8$var$toObject(arrayLike);
        var len = $7c5967fd507782b8$var$toLength(src.length);
        var index = 0;
        if (len + offset > length) throw $7c5967fd507782b8$var$RangeError($7c5967fd507782b8$var$WRONG_LENGTH);
        while(index < len)this[offset + index] = src[index++];
    };
    var $7c5967fd507782b8$var$$iterators = {
        entries: function entries() {
            return $7c5967fd507782b8$var$arrayEntries.call($7c5967fd507782b8$var$validate(this));
        },
        keys: function keys() {
            return $7c5967fd507782b8$var$arrayKeys.call($7c5967fd507782b8$var$validate(this));
        },
        values: function values() {
            return $7c5967fd507782b8$var$arrayValues.call($7c5967fd507782b8$var$validate(this));
        }
    };
    var $7c5967fd507782b8$var$isTAIndex = function(target, key) {
        return $7c5967fd507782b8$var$isObject(target) && target[$7c5967fd507782b8$var$TYPED_ARRAY] && typeof key != 'symbol' && key in target && String(+key) == String(key);
    };
    var $7c5967fd507782b8$var$$getDesc = function getOwnPropertyDescriptor(target, key) {
        return $7c5967fd507782b8$var$isTAIndex(target, key = $7c5967fd507782b8$var$toPrimitive(key, true)) ? $7c5967fd507782b8$var$propertyDesc(2, target[key]) : $7c5967fd507782b8$var$gOPD(target, key);
    };
    var $7c5967fd507782b8$var$$setDesc = function defineProperty(target, key, desc) {
        if ($7c5967fd507782b8$var$isTAIndex(target, key = $7c5967fd507782b8$var$toPrimitive(key, true)) && $7c5967fd507782b8$var$isObject(desc) && $7c5967fd507782b8$var$has(desc, 'value') && !$7c5967fd507782b8$var$has(desc, 'get') && !$7c5967fd507782b8$var$has(desc, 'set') && !desc.configurable && (!$7c5967fd507782b8$var$has(desc, 'writable') || desc.writable) && (!$7c5967fd507782b8$var$has(desc, 'enumerable') || desc.enumerable)) {
            target[key] = desc.value;
            return target;
        }
        return $7c5967fd507782b8$var$dP(target, key, desc);
    };
    if (!$7c5967fd507782b8$var$ALL_CONSTRUCTORS) {
        $7c5967fd507782b8$var$$GOPD.f = $7c5967fd507782b8$var$$getDesc;
        $7c5967fd507782b8$var$$DP.f = $7c5967fd507782b8$var$$setDesc;
    }
    $7c5967fd507782b8$var$$export($7c5967fd507782b8$var$$export.S + $7c5967fd507782b8$var$$export.F * !$7c5967fd507782b8$var$ALL_CONSTRUCTORS, 'Object', {
        getOwnPropertyDescriptor: $7c5967fd507782b8$var$$getDesc,
        defineProperty: $7c5967fd507782b8$var$$setDesc
    });
    if ($7c5967fd507782b8$var$fails(function() {
        $7c5967fd507782b8$var$arrayToString.call({});
    })) $7c5967fd507782b8$var$arrayToString = $7c5967fd507782b8$var$arrayToLocaleString = function toString() {
        return $7c5967fd507782b8$var$arrayJoin.call(this);
    };
    var $7c5967fd507782b8$var$$TypedArrayPrototype$ = $7c5967fd507782b8$var$redefineAll({}, $7c5967fd507782b8$var$proto);
    $7c5967fd507782b8$var$redefineAll($7c5967fd507782b8$var$$TypedArrayPrototype$, $7c5967fd507782b8$var$$iterators);
    $7c5967fd507782b8$var$hide($7c5967fd507782b8$var$$TypedArrayPrototype$, $7c5967fd507782b8$var$ITERATOR, $7c5967fd507782b8$var$$iterators.values);
    $7c5967fd507782b8$var$redefineAll($7c5967fd507782b8$var$$TypedArrayPrototype$, {
        slice: $7c5967fd507782b8$var$$slice,
        set: $7c5967fd507782b8$var$$set,
        constructor: function() {},
        toString: $7c5967fd507782b8$var$arrayToString,
        toLocaleString: $7c5967fd507782b8$var$$toLocaleString
    });
    $7c5967fd507782b8$var$addGetter($7c5967fd507782b8$var$$TypedArrayPrototype$, 'buffer', 'b');
    $7c5967fd507782b8$var$addGetter($7c5967fd507782b8$var$$TypedArrayPrototype$, 'byteOffset', 'o');
    $7c5967fd507782b8$var$addGetter($7c5967fd507782b8$var$$TypedArrayPrototype$, 'byteLength', 'l');
    $7c5967fd507782b8$var$addGetter($7c5967fd507782b8$var$$TypedArrayPrototype$, 'length', 'e');
    $7c5967fd507782b8$var$dP($7c5967fd507782b8$var$$TypedArrayPrototype$, $7c5967fd507782b8$var$TAG, {
        get: function() {
            return this[$7c5967fd507782b8$var$TYPED_ARRAY];
        }
    });
    // eslint-disable-next-line max-statements
    module.exports = function(KEY, BYTES, wrapper, CLAMPED) {
        CLAMPED = !!CLAMPED;
        var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
        var GETTER = 'get' + KEY;
        var SETTER = 'set' + KEY;
        var TypedArray = $7c5967fd507782b8$var$global[NAME];
        var Base = TypedArray || {};
        var TAC = TypedArray && $7c5967fd507782b8$var$getPrototypeOf(TypedArray);
        var FORCED = !TypedArray || !$7c5967fd507782b8$var$$typed.ABV;
        var O = {};
        var TypedArrayPrototype = TypedArray && TypedArray[$7c5967fd507782b8$var$PROTOTYPE];
        var getter = function(that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, $7c5967fd507782b8$var$LITTLE_ENDIAN);
        };
        var setter = function(that, index, value) {
            var data = that._d;
            if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
            data.v[SETTER](index * BYTES + data.o, value, $7c5967fd507782b8$var$LITTLE_ENDIAN);
        };
        var addElement = function(that, index) {
            $7c5967fd507782b8$var$dP(that, index, {
                get: function() {
                    return getter(this, index);
                },
                set: function(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (FORCED) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
                $7c5967fd507782b8$var$anInstance(that, TypedArray, NAME, '_d');
                var index = 0;
                var offset = 0;
                var buffer, byteLength, length, klass;
                if (!$7c5967fd507782b8$var$isObject(data)) {
                    length = $7c5967fd507782b8$var$toIndex(data);
                    byteLength = length * BYTES;
                    buffer = new $7c5967fd507782b8$var$$ArrayBuffer(byteLength);
                } else if (data instanceof $7c5967fd507782b8$var$$ArrayBuffer || (klass = $7c5967fd507782b8$var$classof(data)) == $7c5967fd507782b8$var$ARRAY_BUFFER || klass == $7c5967fd507782b8$var$SHARED_BUFFER) {
                    buffer = data;
                    offset = $7c5967fd507782b8$var$toOffset($offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw $7c5967fd507782b8$var$RangeError($7c5967fd507782b8$var$WRONG_LENGTH);
                        byteLength = $len - offset;
                        if (byteLength < 0) throw $7c5967fd507782b8$var$RangeError($7c5967fd507782b8$var$WRONG_LENGTH);
                    } else {
                        byteLength = $7c5967fd507782b8$var$toLength($length) * BYTES;
                        if (byteLength + offset > $len) throw $7c5967fd507782b8$var$RangeError($7c5967fd507782b8$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($7c5967fd507782b8$var$TYPED_ARRAY in data) return $7c5967fd507782b8$var$fromList(TypedArray, data);
                else return $7c5967fd507782b8$var$$from.call(TypedArray, data);
                $7c5967fd507782b8$var$hide(that, '_d', {
                    b: buffer,
                    o: offset,
                    l: byteLength,
                    e: length,
                    v: new $7c5967fd507782b8$var$$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            TypedArrayPrototype = TypedArray[$7c5967fd507782b8$var$PROTOTYPE] = $7c5967fd507782b8$var$create($7c5967fd507782b8$var$$TypedArrayPrototype$);
            $7c5967fd507782b8$var$hide(TypedArrayPrototype, 'constructor', TypedArray);
        } else if (!$7c5967fd507782b8$var$fails(function() {
            TypedArray(1);
        }) || !$7c5967fd507782b8$var$fails(function() {
            new TypedArray(-1); // eslint-disable-line no-new
        }) || !$7c5967fd507782b8$var$$iterDetect(function(iter) {
            new TypedArray(); // eslint-disable-line no-new
            new TypedArray(null); // eslint-disable-line no-new
            new TypedArray(1.5); // eslint-disable-line no-new
            new TypedArray(iter); // eslint-disable-line no-new
        }, true)) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
                $7c5967fd507782b8$var$anInstance(that, TypedArray, NAME);
                var klass;
                // `ws` module bug, temporarily remove validation length for Uint8Array
                // https://github.com/websockets/ws/pull/645
                if (!$7c5967fd507782b8$var$isObject(data)) return new Base($7c5967fd507782b8$var$toIndex(data));
                if (data instanceof $7c5967fd507782b8$var$$ArrayBuffer || (klass = $7c5967fd507782b8$var$classof(data)) == $7c5967fd507782b8$var$ARRAY_BUFFER || klass == $7c5967fd507782b8$var$SHARED_BUFFER) return $length !== undefined ? new Base(data, $7c5967fd507782b8$var$toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, $7c5967fd507782b8$var$toOffset($offset, BYTES)) : new Base(data);
                if ($7c5967fd507782b8$var$TYPED_ARRAY in data) return $7c5967fd507782b8$var$fromList(TypedArray, data);
                return $7c5967fd507782b8$var$$from.call(TypedArray, data);
            });
            $7c5967fd507782b8$var$arrayForEach(TAC !== Function.prototype ? $7c5967fd507782b8$var$gOPN(Base).concat($7c5967fd507782b8$var$gOPN(TAC)) : $7c5967fd507782b8$var$gOPN(Base), function(key) {
                if (!(key in TypedArray)) $7c5967fd507782b8$var$hide(TypedArray, key, Base[key]);
            });
            TypedArray[$7c5967fd507782b8$var$PROTOTYPE] = TypedArrayPrototype;
            if (!$7c5967fd507782b8$var$LIBRARY) TypedArrayPrototype.constructor = TypedArray;
        }
        var $nativeIterator = TypedArrayPrototype[$7c5967fd507782b8$var$ITERATOR];
        var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
        var $iterator = $7c5967fd507782b8$var$$iterators.values;
        $7c5967fd507782b8$var$hide(TypedArray, $7c5967fd507782b8$var$TYPED_CONSTRUCTOR, true);
        $7c5967fd507782b8$var$hide(TypedArrayPrototype, $7c5967fd507782b8$var$TYPED_ARRAY, NAME);
        $7c5967fd507782b8$var$hide(TypedArrayPrototype, $7c5967fd507782b8$var$VIEW, true);
        $7c5967fd507782b8$var$hide(TypedArrayPrototype, $7c5967fd507782b8$var$DEF_CONSTRUCTOR, TypedArray);
        if (CLAMPED ? new TypedArray(1)[$7c5967fd507782b8$var$TAG] != NAME : !($7c5967fd507782b8$var$TAG in TypedArrayPrototype)) $7c5967fd507782b8$var$dP(TypedArrayPrototype, $7c5967fd507782b8$var$TAG, {
            get: function() {
                return NAME;
            }
        });
        O[NAME] = TypedArray;
        $7c5967fd507782b8$var$$export($7c5967fd507782b8$var$$export.G + $7c5967fd507782b8$var$$export.W + $7c5967fd507782b8$var$$export.F * (TypedArray != Base), O);
        $7c5967fd507782b8$var$$export($7c5967fd507782b8$var$$export.S, NAME, {
            BYTES_PER_ELEMENT: BYTES
        });
        $7c5967fd507782b8$var$$export($7c5967fd507782b8$var$$export.S + $7c5967fd507782b8$var$$export.F * $7c5967fd507782b8$var$fails(function() {
            Base.of.call(TypedArray, 1);
        }), NAME, {
            from: $7c5967fd507782b8$var$$from,
            of: $7c5967fd507782b8$var$$of
        });
        if (!($7c5967fd507782b8$var$BYTES_PER_ELEMENT in TypedArrayPrototype)) $7c5967fd507782b8$var$hide(TypedArrayPrototype, $7c5967fd507782b8$var$BYTES_PER_ELEMENT, BYTES);
        $7c5967fd507782b8$var$$export($7c5967fd507782b8$var$$export.P, NAME, $7c5967fd507782b8$var$proto);
        $7c5967fd507782b8$var$setSpecies(NAME);
        $7c5967fd507782b8$var$$export($7c5967fd507782b8$var$$export.P + $7c5967fd507782b8$var$$export.F * $7c5967fd507782b8$var$FORCED_SET, NAME, {
            set: $7c5967fd507782b8$var$$set
        });
        $7c5967fd507782b8$var$$export($7c5967fd507782b8$var$$export.P + $7c5967fd507782b8$var$$export.F * !CORRECT_ITER_NAME, NAME, $7c5967fd507782b8$var$$iterators);
        if (!$7c5967fd507782b8$var$LIBRARY && TypedArrayPrototype.toString != $7c5967fd507782b8$var$arrayToString) TypedArrayPrototype.toString = $7c5967fd507782b8$var$arrayToString;
        $7c5967fd507782b8$var$$export($7c5967fd507782b8$var$$export.P + $7c5967fd507782b8$var$$export.F * $7c5967fd507782b8$var$fails(function() {
            new TypedArray(1).slice();
        }), NAME, {
            slice: $7c5967fd507782b8$var$$slice
        });
        $7c5967fd507782b8$var$$export($7c5967fd507782b8$var$$export.P + $7c5967fd507782b8$var$$export.F * ($7c5967fd507782b8$var$fails(function() {
            return [
                1,
                2
            ].toLocaleString() != new TypedArray([
                1,
                2
            ]).toLocaleString();
        }) || !$7c5967fd507782b8$var$fails(function() {
            TypedArrayPrototype.toLocaleString.call([
                1,
                2
            ]);
        })), NAME, {
            toLocaleString: $7c5967fd507782b8$var$$toLocaleString
        });
        $7c5967fd507782b8$var$Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
        if (!$7c5967fd507782b8$var$LIBRARY && !CORRECT_ITER_NAME) $7c5967fd507782b8$var$hide(TypedArrayPrototype, $7c5967fd507782b8$var$ITERATOR, $iterator);
    };
} else module.exports = function() {};

});

parcelRegister("1KRuL", function(module, exports) {
// all object keys, includes non-enumerable and symbols

var $dQVrJ = parcelRequire("dQVrJ");

var $62w6m = parcelRequire("62w6m");

var $9bg2N = parcelRequire("9bg2N");

var $cUEwJ = parcelRequire("cUEwJ");
var $14739553e9567bb5$require$Reflect = $cUEwJ.Reflect;
module.exports = $14739553e9567bb5$require$Reflect && $14739553e9567bb5$require$Reflect.ownKeys || function ownKeys(it) {
    var keys = $dQVrJ.f($9bg2N(it));
    var getSymbols = $62w6m.f;
    return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

});

parcelRegister("fWpbL", function(module, exports) {

var $gvp2l = parcelRequire("gvp2l");

var $abZqb = parcelRequire("abZqb");

var $e6Osc = parcelRequire("e6Osc");

var $4OvuN = parcelRequire("4OvuN");
var $b9afcfc07a22778e$require$isEnum = $4OvuN.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $e6Osc(it);
        var keys = $abZqb(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$gvp2l || $b9afcfc07a22778e$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});

parcelRegister("bDLIM", function(module, exports) {
'use strict';



// Forced replacement prototype accessors methods
module.exports = (parcelRequire("6VDEP")) || !(parcelRequire("d6gmi"))(function() {
    var K = Math.random();
    // In FF throws only define methods
    // eslint-disable-next-line no-undef, no-useless-call
    __defineSetter__.call(null, K, function() {});
    delete (parcelRequire("cUEwJ"))[K];
});

});

parcelRegister("lQsUY", function(module, exports) {
// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $d4Dmo = parcelRequire("d4Dmo");

var $cjLYT = parcelRequire("cjLYT");
module.exports = function(NAME) {
    return function toJSON() {
        if ($d4Dmo(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
        return $cjLYT(this);
    };
};

});
parcelRegister("cjLYT", function(module, exports) {

var $2b8La = parcelRequire("2b8La");
module.exports = function(iter, ITERATOR) {
    var result = [];
    $2b8La(iter, false, result.push, result, ITERATOR);
    return result;
};

});


parcelRegister("7p3q1", function(module, exports) {
'use strict';

var $7UCsS = parcelRequire("7UCsS");
module.exports = function(COLLECTION) {
    $7UCsS($7UCsS.S, COLLECTION, {
        of: function of() {
            var length = arguments.length;
            var A = new Array(length);
            while(length--)A[length] = arguments[length];
            return new this(A);
        }
    });
};

});

parcelRegister("8h2Oa", function(module, exports) {
'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $ekEf9 = parcelRequire("ekEf9");

var $i2qD6 = parcelRequire("i2qD6");

var $2b8La = parcelRequire("2b8La");
module.exports = function(COLLECTION) {
    $7UCsS($7UCsS.S, COLLECTION, {
        from: function from(source /* , mapFn, thisArg */ ) {
            var mapFn = arguments[1];
            var mapping, A, n, cb;
            $ekEf9(this);
            mapping = mapFn !== undefined;
            if (mapping) $ekEf9(mapFn);
            if (source == undefined) return new this();
            A = [];
            if (mapping) {
                n = 0;
                cb = $i2qD6(mapFn, arguments[2], 2);
                $2b8La(source, false, function(nextItem) {
                    A.push(cb(nextItem, n++));
                });
            } else $2b8La(source, false, A.push, A);
            return new this(A);
        }
    });
};

});

parcelRegister("9GrGy", function(module, exports) {
// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
    if (arguments.length === 0 || x != x || inLow != inLow || inHigh != inHigh || outLow != outLow || outHigh != outHigh) return NaN;
    if (x === Infinity || x === -Infinity) return x;
    return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

});

parcelRegister("c3V8e", function(module, exports) {
module.exports = function(regExp, replace) {
    var replacer = replace === Object(replace) ? function(part) {
        return replace[part];
    } : replace;
    return function(it) {
        return String(it).replace(regExp, replacer);
    };
};

});

parcelRegister("9zHsy", function(module, exports) {
$parcel$export(module.exports, "enable", () => $6f891819a3151ddc$export$d7c4a0dd6a4567e5, (v) => $6f891819a3151ddc$export$d7c4a0dd6a4567e5 = v);
var $6f891819a3151ddc$export$e20fbacbb41798b;
var $6f891819a3151ddc$export$d7c4a0dd6a4567e5;
'use strict';

var $4MCJ5 = parcelRequire("4MCJ5");
var $6f891819a3151ddc$var$DEFAULT_WHITELIST = [
    ReferenceError,
    TypeError,
    RangeError
];
var $6f891819a3151ddc$var$enabled = false;
$6f891819a3151ddc$export$e20fbacbb41798b = $6f891819a3151ddc$var$disable;
function $6f891819a3151ddc$var$disable() {
    $6f891819a3151ddc$var$enabled = false;
    $4MCJ5._47 = null;
    $4MCJ5._71 = null;
}
$6f891819a3151ddc$export$d7c4a0dd6a4567e5 = $6f891819a3151ddc$var$enable;
function $6f891819a3151ddc$var$enable(options) {
    options = options || {};
    if ($6f891819a3151ddc$var$enabled) $6f891819a3151ddc$var$disable();
    $6f891819a3151ddc$var$enabled = true;
    var id = 0;
    var displayId = 0;
    var rejections = {};
    $4MCJ5._47 = function(promise) {
        if (promise._83 === 2 && // IS REJECTED
        rejections[promise._56]) {
            if (rejections[promise._56].logged) onHandled(promise._56);
            else clearTimeout(rejections[promise._56].timeout);
            delete rejections[promise._56];
        }
    };
    $4MCJ5._71 = function(promise, err) {
        if (promise._75 === 0) {
            promise._56 = id++;
            rejections[promise._56] = {
                displayId: null,
                error: err,
                timeout: setTimeout(onUnhandled.bind(null, promise._56), // For reference errors and type errors, this almost always
                // means the programmer made a mistake, so log them after just
                // 100ms
                // otherwise, wait 2 seconds to see if they get handled
                $6f891819a3151ddc$var$matchWhitelist(err, $6f891819a3151ddc$var$DEFAULT_WHITELIST) ? 100 : 2000),
                logged: false
            };
        }
    };
    function onUnhandled(id) {
        if (options.allRejections || $6f891819a3151ddc$var$matchWhitelist(rejections[id].error, options.whitelist || $6f891819a3151ddc$var$DEFAULT_WHITELIST)) {
            rejections[id].displayId = displayId++;
            if (options.onUnhandled) {
                rejections[id].logged = true;
                options.onUnhandled(rejections[id].displayId, rejections[id].error);
            } else {
                rejections[id].logged = true;
                $6f891819a3151ddc$var$logError(rejections[id].displayId, rejections[id].error);
            }
        }
    }
    function onHandled(id) {
        if (rejections[id].logged) {
            if (options.onHandled) options.onHandled(rejections[id].displayId, rejections[id].error);
            else if (!rejections[id].onUnhandled) {
                console.warn('Promise Rejection Handled (id: ' + rejections[id].displayId + '):');
                console.warn('  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' + rejections[id].displayId + '.');
            }
        }
    }
}
function $6f891819a3151ddc$var$logError(id, error) {
    console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
    var errStr = (error && (error.stack || error)) + '';
    errStr.split('\n').forEach(function(line) {
        console.warn('  ' + line);
    });
}
function $6f891819a3151ddc$var$matchWhitelist(error, list) {
    return list.some(function(cls) {
        return error instanceof cls;
    });
}

});
parcelRegister("4MCJ5", function(module, exports) {
'use strict';

var $4BS97 = parcelRequire("4BS97");
function $37b9af5c8ae29af7$var$noop() {}
// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable
// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.
// to avoid using try/catch inside critical functions, we
// extract them to here.
var $37b9af5c8ae29af7$var$LAST_ERROR = null;
var $37b9af5c8ae29af7$var$IS_ERROR = {};
function $37b9af5c8ae29af7$var$getThen(obj) {
    try {
        return obj.then;
    } catch (ex) {
        $37b9af5c8ae29af7$var$LAST_ERROR = ex;
        return $37b9af5c8ae29af7$var$IS_ERROR;
    }
}
function $37b9af5c8ae29af7$var$tryCallOne(fn, a) {
    try {
        return fn(a);
    } catch (ex) {
        $37b9af5c8ae29af7$var$LAST_ERROR = ex;
        return $37b9af5c8ae29af7$var$IS_ERROR;
    }
}
function $37b9af5c8ae29af7$var$tryCallTwo(fn, a, b) {
    try {
        fn(a, b);
    } catch (ex) {
        $37b9af5c8ae29af7$var$LAST_ERROR = ex;
        return $37b9af5c8ae29af7$var$IS_ERROR;
    }
}
module.exports = $37b9af5c8ae29af7$var$Promise;
function $37b9af5c8ae29af7$var$Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('Promise constructor\'s argument is not a function');
    this._75 = 0;
    this._83 = 0;
    this._18 = null;
    this._38 = null;
    if (fn === $37b9af5c8ae29af7$var$noop) return;
    $37b9af5c8ae29af7$var$doResolve(fn, this);
}
$37b9af5c8ae29af7$var$Promise._47 = null;
$37b9af5c8ae29af7$var$Promise._71 = null;
$37b9af5c8ae29af7$var$Promise._44 = $37b9af5c8ae29af7$var$noop;
$37b9af5c8ae29af7$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    if (this.constructor !== $37b9af5c8ae29af7$var$Promise) return $37b9af5c8ae29af7$var$safeThen(this, onFulfilled, onRejected);
    var res = new $37b9af5c8ae29af7$var$Promise($37b9af5c8ae29af7$var$noop);
    $37b9af5c8ae29af7$var$handle(this, new $37b9af5c8ae29af7$var$Handler(onFulfilled, onRejected, res));
    return res;
};
function $37b9af5c8ae29af7$var$safeThen(self, onFulfilled, onRejected) {
    return new self.constructor(function(resolve, reject) {
        var res = new $37b9af5c8ae29af7$var$Promise($37b9af5c8ae29af7$var$noop);
        res.then(resolve, reject);
        $37b9af5c8ae29af7$var$handle(self, new $37b9af5c8ae29af7$var$Handler(onFulfilled, onRejected, res));
    });
}
function $37b9af5c8ae29af7$var$handle(self, deferred) {
    while(self._83 === 3)self = self._18;
    if ($37b9af5c8ae29af7$var$Promise._47) $37b9af5c8ae29af7$var$Promise._47(self);
    if (self._83 === 0) {
        if (self._75 === 0) {
            self._75 = 1;
            self._38 = deferred;
            return;
        }
        if (self._75 === 1) {
            self._75 = 2;
            self._38 = [
                self._38,
                deferred
            ];
            return;
        }
        self._38.push(deferred);
        return;
    }
    $37b9af5c8ae29af7$var$handleResolved(self, deferred);
}
function $37b9af5c8ae29af7$var$handleResolved(self, deferred) {
    $4BS97(function() {
        var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            if (self._83 === 1) $37b9af5c8ae29af7$var$resolve(deferred.promise, self._18);
            else $37b9af5c8ae29af7$var$reject(deferred.promise, self._18);
            return;
        }
        var ret = $37b9af5c8ae29af7$var$tryCallOne(cb, self._18);
        if (ret === $37b9af5c8ae29af7$var$IS_ERROR) $37b9af5c8ae29af7$var$reject(deferred.promise, $37b9af5c8ae29af7$var$LAST_ERROR);
        else $37b9af5c8ae29af7$var$resolve(deferred.promise, ret);
    });
}
function $37b9af5c8ae29af7$var$resolve(self, newValue) {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self) return $37b9af5c8ae29af7$var$reject(self, new TypeError('A promise cannot be resolved with itself.'));
    if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = $37b9af5c8ae29af7$var$getThen(newValue);
        if (then === $37b9af5c8ae29af7$var$IS_ERROR) return $37b9af5c8ae29af7$var$reject(self, $37b9af5c8ae29af7$var$LAST_ERROR);
        if (then === self.then && newValue instanceof $37b9af5c8ae29af7$var$Promise) {
            self._83 = 3;
            self._18 = newValue;
            $37b9af5c8ae29af7$var$finale(self);
            return;
        } else if (typeof then === 'function') {
            $37b9af5c8ae29af7$var$doResolve(then.bind(newValue), self);
            return;
        }
    }
    self._83 = 1;
    self._18 = newValue;
    $37b9af5c8ae29af7$var$finale(self);
}
function $37b9af5c8ae29af7$var$reject(self, newValue) {
    self._83 = 2;
    self._18 = newValue;
    if ($37b9af5c8ae29af7$var$Promise._71) $37b9af5c8ae29af7$var$Promise._71(self, newValue);
    $37b9af5c8ae29af7$var$finale(self);
}
function $37b9af5c8ae29af7$var$finale(self) {
    if (self._75 === 1) {
        $37b9af5c8ae29af7$var$handle(self, self._38);
        self._38 = null;
    }
    if (self._75 === 2) {
        for(var i = 0; i < self._38.length; i++)$37b9af5c8ae29af7$var$handle(self, self._38[i]);
        self._38 = null;
    }
}
function $37b9af5c8ae29af7$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $37b9af5c8ae29af7$var$doResolve(fn, promise) {
    var done = false;
    var res = $37b9af5c8ae29af7$var$tryCallTwo(fn, function(value) {
        if (done) return;
        done = true;
        $37b9af5c8ae29af7$var$resolve(promise, value);
    }, function(reason) {
        if (done) return;
        done = true;
        $37b9af5c8ae29af7$var$reject(promise, reason);
    });
    if (!done && res === $37b9af5c8ae29af7$var$IS_ERROR) {
        done = true;
        $37b9af5c8ae29af7$var$reject(promise, $37b9af5c8ae29af7$var$LAST_ERROR);
    }
}

});
parcelRegister("4BS97", function(module, exports) {
"use strict";
// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = $35b49e6496390434$var$rawAsap;
function $35b49e6496390434$var$rawAsap(task) {
    if (!$35b49e6496390434$var$queue.length) {
        $35b49e6496390434$var$requestFlush();
        $35b49e6496390434$var$flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    $35b49e6496390434$var$queue[$35b49e6496390434$var$queue.length] = task;
}
var $35b49e6496390434$var$queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var $35b49e6496390434$var$flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var $35b49e6496390434$var$requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var $35b49e6496390434$var$index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var $35b49e6496390434$var$capacity = 1024;
// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function $35b49e6496390434$var$flush() {
    while($35b49e6496390434$var$index < $35b49e6496390434$var$queue.length){
        var currentIndex = $35b49e6496390434$var$index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        $35b49e6496390434$var$index = $35b49e6496390434$var$index + 1;
        $35b49e6496390434$var$queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if ($35b49e6496390434$var$index > $35b49e6496390434$var$capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for(var scan = 0, newLength = $35b49e6496390434$var$queue.length - $35b49e6496390434$var$index; scan < newLength; scan++)$35b49e6496390434$var$queue[scan] = $35b49e6496390434$var$queue[scan + $35b49e6496390434$var$index];
            $35b49e6496390434$var$queue.length -= $35b49e6496390434$var$index;
            $35b49e6496390434$var$index = 0;
        }
    }
    $35b49e6496390434$var$queue.length = 0;
    $35b49e6496390434$var$index = 0;
    $35b49e6496390434$var$flushing = false;
}
// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ var $35b49e6496390434$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
var $35b49e6496390434$var$BrowserMutationObserver = $35b49e6496390434$var$scope.MutationObserver || $35b49e6496390434$var$scope.WebKitMutationObserver;
// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof $35b49e6496390434$var$BrowserMutationObserver === "function") $35b49e6496390434$var$requestFlush = $35b49e6496390434$var$makeRequestCallFromMutationObserver($35b49e6496390434$var$flush);
else $35b49e6496390434$var$requestFlush = $35b49e6496390434$var$makeRequestCallFromTimer($35b49e6496390434$var$flush);
// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
$35b49e6496390434$var$rawAsap.requestFlush = $35b49e6496390434$var$requestFlush;
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function $35b49e6496390434$var$makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new $35b49e6496390434$var$BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
function $35b49e6496390434$var$makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
$35b49e6496390434$var$rawAsap.makeRequestCallFromTimer = $35b49e6496390434$var$makeRequestCallFromTimer; // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

});



parcelRegister("dyyZn", function(module, exports) {
'use strict';

var $4MCJ5 = parcelRequire("4MCJ5");
module.exports = $4MCJ5;
/* Static Functions */ var $9de9976b2e0c6e8f$var$TRUE = $9de9976b2e0c6e8f$var$valuePromise(true);
var $9de9976b2e0c6e8f$var$FALSE = $9de9976b2e0c6e8f$var$valuePromise(false);
var $9de9976b2e0c6e8f$var$NULL = $9de9976b2e0c6e8f$var$valuePromise(null);
var $9de9976b2e0c6e8f$var$UNDEFINED = $9de9976b2e0c6e8f$var$valuePromise(undefined);
var $9de9976b2e0c6e8f$var$ZERO = $9de9976b2e0c6e8f$var$valuePromise(0);
var $9de9976b2e0c6e8f$var$EMPTYSTRING = $9de9976b2e0c6e8f$var$valuePromise('');
function $9de9976b2e0c6e8f$var$valuePromise(value) {
    var p = new $4MCJ5($4MCJ5._44);
    p._83 = 1;
    p._18 = value;
    return p;
}
$4MCJ5.resolve = function(value) {
    if (value instanceof $4MCJ5) return value;
    if (value === null) return $9de9976b2e0c6e8f$var$NULL;
    if (value === undefined) return $9de9976b2e0c6e8f$var$UNDEFINED;
    if (value === true) return $9de9976b2e0c6e8f$var$TRUE;
    if (value === false) return $9de9976b2e0c6e8f$var$FALSE;
    if (value === 0) return $9de9976b2e0c6e8f$var$ZERO;
    if (value === '') return $9de9976b2e0c6e8f$var$EMPTYSTRING;
    if (typeof value === 'object' || typeof value === 'function') try {
        var then = value.then;
        if (typeof then === 'function') return new $4MCJ5(then.bind(value));
    } catch (ex) {
        return new $4MCJ5(function(resolve, reject) {
            reject(ex);
        });
    }
    return $9de9976b2e0c6e8f$var$valuePromise(value);
};
$4MCJ5.all = function(arr) {
    var args = Array.prototype.slice.call(arr);
    return new $4MCJ5(function(resolve, reject) {
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                if (val instanceof $4MCJ5 && val.then === $4MCJ5.prototype.then) {
                    while(val._83 === 3)val = val._18;
                    if (val._83 === 1) return res(i, val._18);
                    if (val._83 === 2) reject(val._18);
                    val.then(function(val) {
                        res(i, val);
                    }, reject);
                    return;
                } else {
                    var then = val.then;
                    if (typeof then === 'function') {
                        var p = new $4MCJ5(then.bind(val));
                        p.then(function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
            }
            args[i] = val;
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$4MCJ5.reject = function(value) {
    return new $4MCJ5(function(resolve, reject) {
        reject(value);
    });
};
$4MCJ5.race = function(values) {
    return new $4MCJ5(function(resolve, reject) {
        values.forEach(function(value) {
            $4MCJ5.resolve(value).then(resolve, reject);
        });
    });
};
/* Prototype Methods */ $4MCJ5.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};

});

parcelRegister("gjpYn", function(module, exports) {
$parcel$export(module.exports, "matchPath", () => $be02915ca9e2ee0d$export$81336c211d5ff295);
$parcel$export(module.exports, "generatePath", () => $be02915ca9e2ee0d$export$82476f982757e71e);
$parcel$export(module.exports, "RouteContext", () => $be02915ca9e2ee0d$export$aac280ed165a4397);
$parcel$export(module.exports, "useHref", () => $be02915ca9e2ee0d$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useLocation", () => $be02915ca9e2ee0d$export$45d76561a5302f2b);
$parcel$export(module.exports, "useMatch", () => $be02915ca9e2ee0d$export$6c330e8992e8a295);
$parcel$export(module.exports, "useNavigate", () => $be02915ca9e2ee0d$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $be02915ca9e2ee0d$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "Navigate", () => $be02915ca9e2ee0d$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $be02915ca9e2ee0d$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $be02915ca9e2ee0d$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $be02915ca9e2ee0d$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "BrowserRouter", () => $be02915ca9e2ee0d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $be02915ca9e2ee0d$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "useLinkClickHandler", () => $be02915ca9e2ee0d$export$67621102c14d847);
$parcel$export(module.exports, "useSearchParams", () => $be02915ca9e2ee0d$export$f1a78c17382fe22a);
/**
 * react-router v7.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lE8gv = parcelRequire("lE8gv");
var $be02915ca9e2ee0d$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/react-router/dist/development/chunk-EVOBXE3Y.mjs"
});
var $be02915ca9e2ee0d$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $be02915ca9e2ee0d$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $be02915ca9e2ee0d$var$__typeError("Cannot " + msg);
var $be02915ca9e2ee0d$var$__privateGet = (obj, member, getter)=>($be02915ca9e2ee0d$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $be02915ca9e2ee0d$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $be02915ca9e2ee0d$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $be02915ca9e2ee0d$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($be02915ca9e2ee0d$export$e19cd5f9376f8cee || {});
var $be02915ca9e2ee0d$var$PopStateEventType = "popstate";
function $be02915ca9e2ee0d$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $be02915ca9e2ee0d$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.unstable_mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, unstable_mask) {
        let location = $be02915ca9e2ee0d$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, unstable_mask);
        $be02915ca9e2ee0d$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $be02915ca9e2ee0d$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $be02915ca9e2ee0d$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $be02915ca9e2ee0d$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $be02915ca9e2ee0d$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $be02915ca9e2ee0d$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $be02915ca9e2ee0d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $be02915ca9e2ee0d$export$fe53371bee54353d(to);
    }
    return $be02915ca9e2ee0d$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $be02915ca9e2ee0d$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $be02915ca9e2ee0d$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $be02915ca9e2ee0d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $be02915ca9e2ee0d$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $be02915ca9e2ee0d$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $be02915ca9e2ee0d$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $be02915ca9e2ee0d$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $be02915ca9e2ee0d$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $be02915ca9e2ee0d$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $be02915ca9e2ee0d$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.unstable_mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $be02915ca9e2ee0d$var$createLocation(current, to, state = null, key, unstable_mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $be02915ca9e2ee0d$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $be02915ca9e2ee0d$var$createKey(),
        unstable_mask: unstable_mask
    };
    return location;
}
function $be02915ca9e2ee0d$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $be02915ca9e2ee0d$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $be02915ca9e2ee0d$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $be02915ca9e2ee0d$var$isLocation(to) ? to : $be02915ca9e2ee0d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $be02915ca9e2ee0d$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $be02915ca9e2ee0d$var$isLocation(to) ? to : $be02915ca9e2ee0d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $be02915ca9e2ee0d$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $be02915ca9e2ee0d$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($be02915ca9e2ee0d$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($be02915ca9e2ee0d$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $be02915ca9e2ee0d$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $be02915ca9e2ee0d$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $be02915ca9e2ee0d$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $be02915ca9e2ee0d$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $be02915ca9e2ee0d$var$_map;
var $be02915ca9e2ee0d$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $be02915ca9e2ee0d$var$__privateAdd(this, $be02915ca9e2ee0d$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($be02915ca9e2ee0d$var$__privateGet(this, $be02915ca9e2ee0d$var$_map).has(context)) return $be02915ca9e2ee0d$var$__privateGet(this, $be02915ca9e2ee0d$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $be02915ca9e2ee0d$var$__privateGet(this, $be02915ca9e2ee0d$var$_map).set(context, value);
    }
};
$be02915ca9e2ee0d$var$_map = new WeakMap();
var $be02915ca9e2ee0d$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $be02915ca9e2ee0d$var$isUnsupportedLazyRouteObjectKey(key) {
    return $be02915ca9e2ee0d$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $be02915ca9e2ee0d$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $be02915ca9e2ee0d$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $be02915ca9e2ee0d$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $be02915ca9e2ee0d$var$isIndexRoute(route) {
    return route.index === true;
}
function $be02915ca9e2ee0d$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $be02915ca9e2ee0d$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $be02915ca9e2ee0d$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($be02915ca9e2ee0d$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $be02915ca9e2ee0d$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $be02915ca9e2ee0d$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $be02915ca9e2ee0d$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $be02915ca9e2ee0d$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $be02915ca9e2ee0d$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $be02915ca9e2ee0d$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $be02915ca9e2ee0d$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $be02915ca9e2ee0d$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $be02915ca9e2ee0d$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $be02915ca9e2ee0d$var$flattenRoutes(routes);
    $be02915ca9e2ee0d$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $be02915ca9e2ee0d$var$decodePath(pathname);
        matches = $be02915ca9e2ee0d$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $be02915ca9e2ee0d$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $be02915ca9e2ee0d$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $be02915ca9e2ee0d$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $be02915ca9e2ee0d$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $be02915ca9e2ee0d$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $be02915ca9e2ee0d$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $be02915ca9e2ee0d$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $be02915ca9e2ee0d$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $be02915ca9e2ee0d$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $be02915ca9e2ee0d$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $be02915ca9e2ee0d$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $be02915ca9e2ee0d$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $be02915ca9e2ee0d$var$paramRe = /^:[\w-]+$/;
var $be02915ca9e2ee0d$var$dynamicSegmentValue = 3;
var $be02915ca9e2ee0d$var$indexRouteValue = 2;
var $be02915ca9e2ee0d$var$emptySegmentValue = 1;
var $be02915ca9e2ee0d$var$staticSegmentValue = 10;
var $be02915ca9e2ee0d$var$splatPenalty = -2;
var $be02915ca9e2ee0d$var$isSplat = (s)=>s === "*";
function $be02915ca9e2ee0d$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($be02915ca9e2ee0d$var$isSplat)) initialScore += $be02915ca9e2ee0d$var$splatPenalty;
    if (index) initialScore += $be02915ca9e2ee0d$var$indexRouteValue;
    return segments.filter((s)=>!$be02915ca9e2ee0d$var$isSplat(s)).reduce((score, segment)=>score + ($be02915ca9e2ee0d$var$paramRe.test(segment) ? $be02915ca9e2ee0d$var$dynamicSegmentValue : segment === "" ? $be02915ca9e2ee0d$var$emptySegmentValue : $be02915ca9e2ee0d$var$staticSegmentValue), initialScore);
}
function $be02915ca9e2ee0d$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $be02915ca9e2ee0d$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $be02915ca9e2ee0d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $be02915ca9e2ee0d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $be02915ca9e2ee0d$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $be02915ca9e2ee0d$var$normalizePathname($be02915ca9e2ee0d$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $be02915ca9e2ee0d$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $be02915ca9e2ee0d$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $be02915ca9e2ee0d$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $be02915ca9e2ee0d$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $be02915ca9e2ee0d$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $be02915ca9e2ee0d$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $be02915ca9e2ee0d$var$compilePath(path, caseSensitive = false, end = true) {
    $be02915ca9e2ee0d$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $be02915ca9e2ee0d$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $be02915ca9e2ee0d$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $be02915ca9e2ee0d$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $be02915ca9e2ee0d$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $be02915ca9e2ee0d$var$joinPaths([
        basename,
        pathname
    ]);
}
var $be02915ca9e2ee0d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $be02915ca9e2ee0d$var$isAbsoluteUrl = (url)=>$be02915ca9e2ee0d$var$ABSOLUTE_URL_REGEX.test(url);
function $be02915ca9e2ee0d$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $be02915ca9e2ee0d$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $be02915ca9e2ee0d$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $be02915ca9e2ee0d$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $be02915ca9e2ee0d$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $be02915ca9e2ee0d$var$normalizeSearch(search),
        hash: $be02915ca9e2ee0d$var$normalizeHash(hash)
    };
}
function $be02915ca9e2ee0d$var$resolvePathname(relativePath, fromPathname) {
    let segments = $be02915ca9e2ee0d$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $be02915ca9e2ee0d$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $be02915ca9e2ee0d$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $be02915ca9e2ee0d$var$getResolveToMatches(matches) {
    let pathMatches = $be02915ca9e2ee0d$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $be02915ca9e2ee0d$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $be02915ca9e2ee0d$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $be02915ca9e2ee0d$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $be02915ca9e2ee0d$var$getInvalidPathError("?", "pathname", "search", to));
        $be02915ca9e2ee0d$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $be02915ca9e2ee0d$var$getInvalidPathError("#", "pathname", "hash", to));
        $be02915ca9e2ee0d$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $be02915ca9e2ee0d$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $be02915ca9e2ee0d$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $be02915ca9e2ee0d$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
var $be02915ca9e2ee0d$var$joinPaths = (paths)=>$be02915ca9e2ee0d$var$removeDoubleSlashes(paths.join("/"));
var $be02915ca9e2ee0d$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $be02915ca9e2ee0d$var$normalizePathname = (pathname)=>$be02915ca9e2ee0d$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $be02915ca9e2ee0d$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $be02915ca9e2ee0d$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $be02915ca9e2ee0d$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $be02915ca9e2ee0d$export$4051a07651545597(data2, init) {
    return new $be02915ca9e2ee0d$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $be02915ca9e2ee0d$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $be02915ca9e2ee0d$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $be02915ca9e2ee0d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $be02915ca9e2ee0d$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $be02915ca9e2ee0d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $be02915ca9e2ee0d$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $be02915ca9e2ee0d$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $be02915ca9e2ee0d$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $be02915ca9e2ee0d$var$joinPaths(parts) || "/";
}
var $be02915ca9e2ee0d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $be02915ca9e2ee0d$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$be02915ca9e2ee0d$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($be02915ca9e2ee0d$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $be02915ca9e2ee0d$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $be02915ca9e2ee0d$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $be02915ca9e2ee0d$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $be02915ca9e2ee0d$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $be02915ca9e2ee0d$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $be02915ca9e2ee0d$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$be02915ca9e2ee0d$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $be02915ca9e2ee0d$var$wrapImpl(aggregated[key], original, (...args)=>$be02915ca9e2ee0d$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$be02915ca9e2ee0d$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$be02915ca9e2ee0d$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $be02915ca9e2ee0d$var$wrapImpl(aggregated.middleware, original, (...args)=>$be02915ca9e2ee0d$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$be02915ca9e2ee0d$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $be02915ca9e2ee0d$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$be02915ca9e2ee0d$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $be02915ca9e2ee0d$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $be02915ca9e2ee0d$export$fe53371bee54353d(to) : ".",
                ...$be02915ca9e2ee0d$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$be02915ca9e2ee0d$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$be02915ca9e2ee0d$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $be02915ca9e2ee0d$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$be02915ca9e2ee0d$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$be02915ca9e2ee0d$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $be02915ca9e2ee0d$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $be02915ca9e2ee0d$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $be02915ca9e2ee0d$var$getReadonlyRequest(request),
            context: context != null ? $be02915ca9e2ee0d$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $be02915ca9e2ee0d$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $be02915ca9e2ee0d$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $be02915ca9e2ee0d$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $be02915ca9e2ee0d$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $be02915ca9e2ee0d$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $be02915ca9e2ee0d$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $be02915ca9e2ee0d$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $be02915ca9e2ee0d$var$getReadonlyContext(context)
    };
}
function $be02915ca9e2ee0d$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $be02915ca9e2ee0d$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $be02915ca9e2ee0d$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $be02915ca9e2ee0d$var$getReadonlyContext(context) {
    if ($be02915ca9e2ee0d$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $be02915ca9e2ee0d$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $be02915ca9e2ee0d$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $be02915ca9e2ee0d$var$objectProtoNames;
}
// lib/router/router.ts
var $be02915ca9e2ee0d$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $be02915ca9e2ee0d$var$validMutationMethods = new Set($be02915ca9e2ee0d$var$validMutationMethodsArr);
var $be02915ca9e2ee0d$var$validRequestMethodsArr = [
    "GET",
    ...$be02915ca9e2ee0d$var$validMutationMethodsArr
];
var $be02915ca9e2ee0d$var$validRequestMethods = new Set($be02915ca9e2ee0d$var$validRequestMethodsArr);
var $be02915ca9e2ee0d$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $be02915ca9e2ee0d$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $be02915ca9e2ee0d$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $be02915ca9e2ee0d$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $be02915ca9e2ee0d$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $be02915ca9e2ee0d$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $be02915ca9e2ee0d$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $be02915ca9e2ee0d$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $be02915ca9e2ee0d$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $be02915ca9e2ee0d$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $be02915ca9e2ee0d$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$be02915ca9e2ee0d$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $be02915ca9e2ee0d$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $be02915ca9e2ee0d$var$defaultDataStrategyWithMiddleware;
    let future = {
        unstable_passThroughRequests: false,
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $be02915ca9e2ee0d$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $be02915ca9e2ee0d$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $be02915ca9e2ee0d$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$be02915ca9e2ee0d$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $be02915ca9e2ee0d$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $be02915ca9e2ee0d$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $be02915ca9e2ee0d$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $be02915ca9e2ee0d$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $be02915ca9e2ee0d$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$be02915ca9e2ee0d$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $be02915ca9e2ee0d$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $be02915ca9e2ee0d$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $be02915ca9e2ee0d$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $be02915ca9e2ee0d$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $be02915ca9e2ee0d$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $be02915ca9e2ee0d$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $be02915ca9e2ee0d$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $be02915ca9e2ee0d$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.unstable_mask) {
            let partialPath = typeof opts.unstable_mask === "string" ? $be02915ca9e2ee0d$export$8ccf933b0513f8d0(opts.unstable_mask) : {
                ...state.location.unstable_mask,
                ...opts.unstable_mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $be02915ca9e2ee0d$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $be02915ca9e2ee0d$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $be02915ca9e2ee0d$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.unstable_defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $be02915ca9e2ee0d$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $be02915ca9e2ee0d$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $be02915ca9e2ee0d$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $be02915ca9e2ee0d$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $be02915ca9e2ee0d$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $be02915ca9e2ee0d$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $be02915ca9e2ee0d$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $be02915ca9e2ee0d$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($be02915ca9e2ee0d$var$isErrorResult(result) && $be02915ca9e2ee0d$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $be02915ca9e2ee0d$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $be02915ca9e2ee0d$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$be02915ca9e2ee0d$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $be02915ca9e2ee0d$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $be02915ca9e2ee0d$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $be02915ca9e2ee0d$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $be02915ca9e2ee0d$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $be02915ca9e2ee0d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $be02915ca9e2ee0d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($be02915ca9e2ee0d$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $be02915ca9e2ee0d$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($be02915ca9e2ee0d$var$isErrorResult(result)) {
            let boundaryMatch = $be02915ca9e2ee0d$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $be02915ca9e2ee0d$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $be02915ca9e2ee0d$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $be02915ca9e2ee0d$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $be02915ca9e2ee0d$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $be02915ca9e2ee0d$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $be02915ca9e2ee0d$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$be02915ca9e2ee0d$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $be02915ca9e2ee0d$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $be02915ca9e2ee0d$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $be02915ca9e2ee0d$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$be02915ca9e2ee0d$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $be02915ca9e2ee0d$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $be02915ca9e2ee0d$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $be02915ca9e2ee0d$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $be02915ca9e2ee0d$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $be02915ca9e2ee0d$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $be02915ca9e2ee0d$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $be02915ca9e2ee0d$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.unstable_defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $be02915ca9e2ee0d$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $be02915ca9e2ee0d$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $be02915ca9e2ee0d$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $be02915ca9e2ee0d$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $be02915ca9e2ee0d$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $be02915ca9e2ee0d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($be02915ca9e2ee0d$var$isRedirectResult(actionResult) || $be02915ca9e2ee0d$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $be02915ca9e2ee0d$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($be02915ca9e2ee0d$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $be02915ca9e2ee0d$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $be02915ca9e2ee0d$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($be02915ca9e2ee0d$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $be02915ca9e2ee0d$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $be02915ca9e2ee0d$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $be02915ca9e2ee0d$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $be02915ca9e2ee0d$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $be02915ca9e2ee0d$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $be02915ca9e2ee0d$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $be02915ca9e2ee0d$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $be02915ca9e2ee0d$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $be02915ca9e2ee0d$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $be02915ca9e2ee0d$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $be02915ca9e2ee0d$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $be02915ca9e2ee0d$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $be02915ca9e2ee0d$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $be02915ca9e2ee0d$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $be02915ca9e2ee0d$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $be02915ca9e2ee0d$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $be02915ca9e2ee0d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $be02915ca9e2ee0d$var$getDoneFetcher(void 0));
            return;
        }
        if ($be02915ca9e2ee0d$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $be02915ca9e2ee0d$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($be02915ca9e2ee0d$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $be02915ca9e2ee0d$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $be02915ca9e2ee0d$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $be02915ca9e2ee0d$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $be02915ca9e2ee0d$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($be02915ca9e2ee0d$var$isAbsoluteUrl(location)) {
                const url = $be02915ca9e2ee0d$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $be02915ca9e2ee0d$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $be02915ca9e2ee0d$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($be02915ca9e2ee0d$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $be02915ca9e2ee0d$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $be02915ca9e2ee0d$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $be02915ca9e2ee0d$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$be02915ca9e2ee0d$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($be02915ca9e2ee0d$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $be02915ca9e2ee0d$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $be02915ca9e2ee0d$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $be02915ca9e2ee0d$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $be02915ca9e2ee0d$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $be02915ca9e2ee0d$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $be02915ca9e2ee0d$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $be02915ca9e2ee0d$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $be02915ca9e2ee0d$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $be02915ca9e2ee0d$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $be02915ca9e2ee0d$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $be02915ca9e2ee0d$export$386d57f03f0b2883;
        $be02915ca9e2ee0d$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $be02915ca9e2ee0d$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $be02915ca9e2ee0d$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $be02915ca9e2ee0d$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $be02915ca9e2ee0d$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$be02915ca9e2ee0d$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $be02915ca9e2ee0d$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $be02915ca9e2ee0d$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $be02915ca9e2ee0d$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $be02915ca9e2ee0d$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $be02915ca9e2ee0d$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $be02915ca9e2ee0d$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $be02915ca9e2ee0d$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $be02915ca9e2ee0d$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $be02915ca9e2ee0d$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $be02915ca9e2ee0d$export$3336b097a6fbc59a(routes, opts) {
    $be02915ca9e2ee0d$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $be02915ca9e2ee0d$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        unstable_passThroughRequests: false,
        // unused in static handler
        ...opts?.future
    };
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$be02915ca9e2ee0d$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $be02915ca9e2ee0d$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, unstable_normalizePath: unstable_normalizePath } = {}) {
        let normalizePath = unstable_normalizePath || $be02915ca9e2ee0d$var$defaultNormalizePath;
        let method = request.method;
        let location = $be02915ca9e2ee0d$var$createLocation("", normalizePath(request), null, "default");
        let matches = $be02915ca9e2ee0d$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $be02915ca9e2ee0d$export$b8d3e69d4b3eff04();
        if (!$be02915ca9e2ee0d$var$isValidMethod(method) && method !== "HEAD") {
            let error = $be02915ca9e2ee0d$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $be02915ca9e2ee0d$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $be02915ca9e2ee0d$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $be02915ca9e2ee0d$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $be02915ca9e2ee0d$export$f5708dca728d7177(requestContext instanceof $be02915ca9e2ee0d$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $be02915ca9e2ee0d$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $be02915ca9e2ee0d$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_url: $be02915ca9e2ee0d$var$createDataFunctionUrl(request, location),
                    unstable_pattern: $be02915ca9e2ee0d$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($be02915ca9e2ee0d$export$6e80290866a84dd4(error)) return error;
                    if ($be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $be02915ca9e2ee0d$export$f2680fa305b734ca(error.status, error.statusText, await $be02915ca9e2ee0d$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($be02915ca9e2ee0d$export$e0163cfdf7bc9cfa(error)) error = $be02915ca9e2ee0d$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $be02915ca9e2ee0d$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $be02915ca9e2ee0d$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $be02915ca9e2ee0d$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $be02915ca9e2ee0d$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $be02915ca9e2ee0d$export$f5708dca728d7177($be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, unstable_normalizePath: unstable_normalizePath } = {}) {
        let normalizePath = unstable_normalizePath || $be02915ca9e2ee0d$var$defaultNormalizePath;
        let method = request.method;
        let location = $be02915ca9e2ee0d$var$createLocation("", normalizePath(request), null, "default");
        let matches = $be02915ca9e2ee0d$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $be02915ca9e2ee0d$export$b8d3e69d4b3eff04();
        if (!$be02915ca9e2ee0d$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $be02915ca9e2ee0d$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $be02915ca9e2ee0d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $be02915ca9e2ee0d$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $be02915ca9e2ee0d$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $be02915ca9e2ee0d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $be02915ca9e2ee0d$export$f5708dca728d7177(requestContext instanceof $be02915ca9e2ee0d$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $be02915ca9e2ee0d$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $be02915ca9e2ee0d$var$runServerMiddlewarePipeline({
                request: request,
                unstable_url: $be02915ca9e2ee0d$var$createDataFunctionUrl(request, location),
                unstable_pattern: $be02915ca9e2ee0d$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($be02915ca9e2ee0d$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($be02915ca9e2ee0d$var$dataWithResponseInitToResponse(error));
                if ($be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $be02915ca9e2ee0d$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($be02915ca9e2ee0d$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $be02915ca9e2ee0d$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($be02915ca9e2ee0d$var$isDataStrategyResult(e) && $be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($be02915ca9e2ee0d$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $be02915ca9e2ee0d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $be02915ca9e2ee0d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $be02915ca9e2ee0d$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($be02915ca9e2ee0d$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($be02915ca9e2ee0d$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($be02915ca9e2ee0d$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $be02915ca9e2ee0d$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $be02915ca9e2ee0d$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($be02915ca9e2ee0d$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $be02915ca9e2ee0d$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $be02915ca9e2ee0d$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $be02915ca9e2ee0d$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $be02915ca9e2ee0d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $be02915ca9e2ee0d$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $be02915ca9e2ee0d$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $be02915ca9e2ee0d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $be02915ca9e2ee0d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $be02915ca9e2ee0d$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $be02915ca9e2ee0d$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $be02915ca9e2ee0d$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $be02915ca9e2ee0d$var$callDataStrategyImpl(dataStrategy || $be02915ca9e2ee0d$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($be02915ca9e2ee0d$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $be02915ca9e2ee0d$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($be02915ca9e2ee0d$export$e0163cfdf7bc9cfa(result.result)) throw $be02915ca9e2ee0d$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $be02915ca9e2ee0d$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $be02915ca9e2ee0d$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $be02915ca9e2ee0d$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $be02915ca9e2ee0d$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $be02915ca9e2ee0d$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $be02915ca9e2ee0d$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $be02915ca9e2ee0d$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $be02915ca9e2ee0d$var$resolveTo(to ? to : ".", $be02915ca9e2ee0d$var$getResolveToMatches(contextualMatches), $be02915ca9e2ee0d$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $be02915ca9e2ee0d$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $be02915ca9e2ee0d$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $be02915ca9e2ee0d$export$fe53371bee54353d(path);
}
function $be02915ca9e2ee0d$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$be02915ca9e2ee0d$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$be02915ca9e2ee0d$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $be02915ca9e2ee0d$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $be02915ca9e2ee0d$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $be02915ca9e2ee0d$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$be02915ca9e2ee0d$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$be02915ca9e2ee0d$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $be02915ca9e2ee0d$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $be02915ca9e2ee0d$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $be02915ca9e2ee0d$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $be02915ca9e2ee0d$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $be02915ca9e2ee0d$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($be02915ca9e2ee0d$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $be02915ca9e2ee0d$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $be02915ca9e2ee0d$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $be02915ca9e2ee0d$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $be02915ca9e2ee0d$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $be02915ca9e2ee0d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $be02915ca9e2ee0d$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $be02915ca9e2ee0d$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$be02915ca9e2ee0d$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $be02915ca9e2ee0d$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($be02915ca9e2ee0d$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $be02915ca9e2ee0d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($be02915ca9e2ee0d$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $be02915ca9e2ee0d$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $be02915ca9e2ee0d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $be02915ca9e2ee0d$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $be02915ca9e2ee0d$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $be02915ca9e2ee0d$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $be02915ca9e2ee0d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $be02915ca9e2ee0d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($be02915ca9e2ee0d$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $be02915ca9e2ee0d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $be02915ca9e2ee0d$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $be02915ca9e2ee0d$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$be02915ca9e2ee0d$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $be02915ca9e2ee0d$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $be02915ca9e2ee0d$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $be02915ca9e2ee0d$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $be02915ca9e2ee0d$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $be02915ca9e2ee0d$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$be02915ca9e2ee0d$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $be02915ca9e2ee0d$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $be02915ca9e2ee0d$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $be02915ca9e2ee0d$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$be02915ca9e2ee0d$var$isSameRoute(aChild, bChild))) ?? false;
}
var $be02915ca9e2ee0d$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $be02915ca9e2ee0d$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $be02915ca9e2ee0d$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $be02915ca9e2ee0d$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $be02915ca9e2ee0d$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $be02915ca9e2ee0d$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $be02915ca9e2ee0d$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $be02915ca9e2ee0d$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $be02915ca9e2ee0d$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $be02915ca9e2ee0d$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $be02915ca9e2ee0d$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $be02915ca9e2ee0d$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $be02915ca9e2ee0d$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $be02915ca9e2ee0d$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $be02915ca9e2ee0d$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $be02915ca9e2ee0d$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $be02915ca9e2ee0d$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $be02915ca9e2ee0d$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $be02915ca9e2ee0d$var$isNonNullable(value) {
    return value !== void 0;
}
function $be02915ca9e2ee0d$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $be02915ca9e2ee0d$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($be02915ca9e2ee0d$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $be02915ca9e2ee0d$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $be02915ca9e2ee0d$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $be02915ca9e2ee0d$var$defaultDataStrategy(args);
    return $be02915ca9e2ee0d$var$runClientMiddlewarePipeline(args, ()=>$be02915ca9e2ee0d$var$defaultDataStrategy(args));
}
function $be02915ca9e2ee0d$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $be02915ca9e2ee0d$var$runMiddlewarePipeline(args, handler, processResult, $be02915ca9e2ee0d$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $be02915ca9e2ee0d$export$e0163cfdf7bc9cfa(result) ? $be02915ca9e2ee0d$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $be02915ca9e2ee0d$var$runClientMiddlewarePipeline(args, handler) {
    return $be02915ca9e2ee0d$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($be02915ca9e2ee0d$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $be02915ca9e2ee0d$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $be02915ca9e2ee0d$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $be02915ca9e2ee0d$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $be02915ca9e2ee0d$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $be02915ca9e2ee0d$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $be02915ca9e2ee0d$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $be02915ca9e2ee0d$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $be02915ca9e2ee0d$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $be02915ca9e2ee0d$var$loadLazyRoute(match.route, $be02915ca9e2ee0d$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $be02915ca9e2ee0d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $be02915ca9e2ee0d$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $be02915ca9e2ee0d$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $be02915ca9e2ee0d$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $be02915ca9e2ee0d$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$be02915ca9e2ee0d$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($be02915ca9e2ee0d$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $be02915ca9e2ee0d$var$callLoaderOrAction({
                request: request,
                path: path,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $be02915ca9e2ee0d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $be02915ca9e2ee0d$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $be02915ca9e2ee0d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $be02915ca9e2ee0d$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $be02915ca9e2ee0d$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_url: $be02915ca9e2ee0d$var$createDataFunctionUrl(request, path),
        unstable_pattern: $be02915ca9e2ee0d$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $be02915ca9e2ee0d$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $be02915ca9e2ee0d$var$callLoaderOrAction({ request: request, path: path, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $be02915ca9e2ee0d$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_url: $be02915ca9e2ee0d$var$createDataFunctionUrl(request, path),
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $be02915ca9e2ee0d$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $be02915ca9e2ee0d$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $be02915ca9e2ee0d$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $be02915ca9e2ee0d$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $be02915ca9e2ee0d$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $be02915ca9e2ee0d$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($be02915ca9e2ee0d$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $be02915ca9e2ee0d$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $be02915ca9e2ee0d$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $be02915ca9e2ee0d$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($be02915ca9e2ee0d$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $be02915ca9e2ee0d$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $be02915ca9e2ee0d$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$be02915ca9e2ee0d$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $be02915ca9e2ee0d$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $be02915ca9e2ee0d$export$30ab200a1a0a2def = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $be02915ca9e2ee0d$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($be02915ca9e2ee0d$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if ($be02915ca9e2ee0d$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $be02915ca9e2ee0d$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $be02915ca9e2ee0d$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($be02915ca9e2ee0d$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $be02915ca9e2ee0d$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($be02915ca9e2ee0d$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $be02915ca9e2ee0d$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $be02915ca9e2ee0d$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $be02915ca9e2ee0d$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $be02915ca9e2ee0d$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $be02915ca9e2ee0d$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $be02915ca9e2ee0d$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $be02915ca9e2ee0d$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $be02915ca9e2ee0d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $be02915ca9e2ee0d$export$f5708dca728d7177(!$be02915ca9e2ee0d$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($be02915ca9e2ee0d$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $be02915ca9e2ee0d$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $be02915ca9e2ee0d$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $be02915ca9e2ee0d$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $be02915ca9e2ee0d$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $be02915ca9e2ee0d$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $be02915ca9e2ee0d$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($be02915ca9e2ee0d$var$isErrorResult(result)) {
            let boundaryMatch = $be02915ca9e2ee0d$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($be02915ca9e2ee0d$var$isRedirectResult(result)) $be02915ca9e2ee0d$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $be02915ca9e2ee0d$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $be02915ca9e2ee0d$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $be02915ca9e2ee0d$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $be02915ca9e2ee0d$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $be02915ca9e2ee0d$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $be02915ca9e2ee0d$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $be02915ca9e2ee0d$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $be02915ca9e2ee0d$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $be02915ca9e2ee0d$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $be02915ca9e2ee0d$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($be02915ca9e2ee0d$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $be02915ca9e2ee0d$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $be02915ca9e2ee0d$export$8ccf933b0513f8d0(path) : path;
    return $be02915ca9e2ee0d$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $be02915ca9e2ee0d$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $be02915ca9e2ee0d$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $be02915ca9e2ee0d$var$dataWithResponseInitToErrorResponse(data2) {
    return new $be02915ca9e2ee0d$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $be02915ca9e2ee0d$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $be02915ca9e2ee0d$var$isDataStrategyResult(value));
}
function $be02915ca9e2ee0d$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $be02915ca9e2ee0d$var$isRedirectDataStrategyResult(result) {
    return $be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(result.result) && $be02915ca9e2ee0d$var$redirectStatusCodes.has(result.result.status);
}
function $be02915ca9e2ee0d$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $be02915ca9e2ee0d$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $be02915ca9e2ee0d$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $be02915ca9e2ee0d$export$794b2760043cf8cd(statusCode) {
    return $be02915ca9e2ee0d$var$redirectStatusCodes.has(statusCode);
}
function $be02915ca9e2ee0d$export$6e80290866a84dd4(result) {
    return $be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(result) && $be02915ca9e2ee0d$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $be02915ca9e2ee0d$var$isValidMethod(method) {
    return $be02915ca9e2ee0d$var$validRequestMethods.has(method.toUpperCase());
}
function $be02915ca9e2ee0d$export$cbae47800eb95bc3(method) {
    return $be02915ca9e2ee0d$var$validMutationMethods.has(method.toUpperCase());
}
function $be02915ca9e2ee0d$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $be02915ca9e2ee0d$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $be02915ca9e2ee0d$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $be02915ca9e2ee0d$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $be02915ca9e2ee0d$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $be02915ca9e2ee0d$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $be02915ca9e2ee0d$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $be02915ca9e2ee0d$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $be02915ca9e2ee0d$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $be02915ca9e2ee0d$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $be02915ca9e2ee0d$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $be02915ca9e2ee0d$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($be02915ca9e2ee0d$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $be02915ca9e2ee0d$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($be02915ca9e2ee0d$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $be02915ca9e2ee0d$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $be02915ca9e2ee0d$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $be02915ca9e2ee0d$export$2eeee58951ff3c1c = $lE8gv.createContext(null);
$be02915ca9e2ee0d$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $be02915ca9e2ee0d$export$315e3ffb01f217 = $lE8gv.createContext(null);
$be02915ca9e2ee0d$export$315e3ffb01f217.displayName = "DataRouterState";
var $be02915ca9e2ee0d$export$717f757c655223f1 = $lE8gv.createContext(false);
function $be02915ca9e2ee0d$var$useIsRSCRouterContext() {
    return $lE8gv.useContext($be02915ca9e2ee0d$export$717f757c655223f1);
}
var $be02915ca9e2ee0d$export$3681f408decb40d1 = $lE8gv.createContext({
    isTransitioning: false
});
$be02915ca9e2ee0d$export$3681f408decb40d1.displayName = "ViewTransition";
var $be02915ca9e2ee0d$export$cb3f1df1bef00a39 = $lE8gv.createContext(/* @__PURE__ */ new Map());
$be02915ca9e2ee0d$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $be02915ca9e2ee0d$var$AwaitContext = $lE8gv.createContext(null);
$be02915ca9e2ee0d$var$AwaitContext.displayName = "Await";
var $be02915ca9e2ee0d$export$2666c20e15407622 = (props)=>$lE8gv.createElement($be02915ca9e2ee0d$var$AwaitContext.Provider, props);
var $be02915ca9e2ee0d$export$3044ab7fdabeaee6 = $lE8gv.createContext(null);
$be02915ca9e2ee0d$export$3044ab7fdabeaee6.displayName = "Navigation";
var $be02915ca9e2ee0d$export$e6a44b110a0c44d3 = $lE8gv.createContext(null);
$be02915ca9e2ee0d$export$e6a44b110a0c44d3.displayName = "Location";
var $be02915ca9e2ee0d$export$aac280ed165a4397 = $lE8gv.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$be02915ca9e2ee0d$export$aac280ed165a4397.displayName = "Route";
var $be02915ca9e2ee0d$var$RouteErrorContext = $lE8gv.createContext(null);
$be02915ca9e2ee0d$var$RouteErrorContext.displayName = "RouteError";
var $be02915ca9e2ee0d$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $be02915ca9e2ee0d$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $be02915ca9e2ee0d$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $be02915ca9e2ee0d$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $be02915ca9e2ee0d$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$be02915ca9e2ee0d$var$ERROR_DIGEST_BASE}:${$be02915ca9e2ee0d$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $be02915ca9e2ee0d$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$be02915ca9e2ee0d$var$ERROR_DIGEST_BASE}:${$be02915ca9e2ee0d$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $be02915ca9e2ee0d$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $be02915ca9e2ee0d$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $be02915ca9e2ee0d$export$f5708dca728d7177($be02915ca9e2ee0d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $be02915ca9e2ee0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $be02915ca9e2ee0d$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $be02915ca9e2ee0d$export$9c954a9d03d32f4a() {
    return $lE8gv.useContext($be02915ca9e2ee0d$export$e6a44b110a0c44d3) != null;
}
function $be02915ca9e2ee0d$export$45d76561a5302f2b() {
    $be02915ca9e2ee0d$export$f5708dca728d7177($be02915ca9e2ee0d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $lE8gv.useContext($be02915ca9e2ee0d$export$e6a44b110a0c44d3).location;
}
function $be02915ca9e2ee0d$export$1b3f31771c5d07c() {
    return $lE8gv.useContext($be02915ca9e2ee0d$export$e6a44b110a0c44d3).navigationType;
}
function $be02915ca9e2ee0d$export$6c330e8992e8a295(pattern) {
    $be02915ca9e2ee0d$export$f5708dca728d7177($be02915ca9e2ee0d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    return $lE8gv.useMemo(()=>$be02915ca9e2ee0d$export$81336c211d5ff295(pattern, $be02915ca9e2ee0d$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $be02915ca9e2ee0d$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $be02915ca9e2ee0d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6).static;
    if (!isStatic) $lE8gv.useLayoutEffect(cb);
}
function $be02915ca9e2ee0d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $lE8gv.useContext($be02915ca9e2ee0d$export$aac280ed165a4397);
    return isDataRoute ? $be02915ca9e2ee0d$var$useNavigateStable() : $be02915ca9e2ee0d$var$useNavigateUnstable();
}
function $be02915ca9e2ee0d$var$useNavigateUnstable() {
    $be02915ca9e2ee0d$export$f5708dca728d7177($be02915ca9e2ee0d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $lE8gv.useContext($be02915ca9e2ee0d$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    let { matches: matches } = $lE8gv.useContext($be02915ca9e2ee0d$export$aac280ed165a4397);
    let { pathname: locationPathname } = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($be02915ca9e2ee0d$var$getResolveToMatches(matches));
    let activeRef = $lE8gv.useRef(false);
    $be02915ca9e2ee0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lE8gv.useCallback((to, options = {})=>{
        $be02915ca9e2ee0d$var$warning(activeRef.current, $be02915ca9e2ee0d$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $be02915ca9e2ee0d$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $be02915ca9e2ee0d$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $be02915ca9e2ee0d$var$OutletContext = $lE8gv.createContext(null);
function $be02915ca9e2ee0d$export$4138103a3ae699cc() {
    return $lE8gv.useContext($be02915ca9e2ee0d$var$OutletContext);
}
function $be02915ca9e2ee0d$export$a3be3530d8e40d0b(context) {
    let outlet = $lE8gv.useContext($be02915ca9e2ee0d$export$aac280ed165a4397).outlet;
    return $lE8gv.useMemo(()=>outlet && /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $be02915ca9e2ee0d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $lE8gv.useContext($be02915ca9e2ee0d$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $be02915ca9e2ee0d$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $lE8gv.useContext($be02915ca9e2ee0d$export$aac280ed165a4397);
    let { pathname: locationPathname } = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($be02915ca9e2ee0d$var$getResolveToMatches(matches));
    return $lE8gv.useMemo(()=>$be02915ca9e2ee0d$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $be02915ca9e2ee0d$export$5d3fca4a98652595(routes, locationArg) {
    return $be02915ca9e2ee0d$var$useRoutesImpl(routes, locationArg);
}
function $be02915ca9e2ee0d$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $be02915ca9e2ee0d$export$f5708dca728d7177($be02915ca9e2ee0d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $lE8gv.useContext($be02915ca9e2ee0d$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($be02915ca9e2ee0d$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $be02915ca9e2ee0d$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $be02915ca9e2ee0d$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $be02915ca9e2ee0d$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $be02915ca9e2ee0d$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($be02915ca9e2ee0d$export$945fecf35a8ef089) {
        $be02915ca9e2ee0d$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $be02915ca9e2ee0d$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $be02915ca9e2ee0d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $be02915ca9e2ee0d$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $be02915ca9e2ee0d$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                unstable_mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $be02915ca9e2ee0d$var$DefaultErrorComponent() {
    let error = $be02915ca9e2ee0d$export$ed527bf60f6e05f2();
    let message = $be02915ca9e2ee0d$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($be02915ca9e2ee0d$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, /* @__PURE__ */ $lE8gv.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $lE8gv.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $lE8gv.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $lE8gv.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, /* @__PURE__ */ $lE8gv.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $lE8gv.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $lE8gv.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $be02915ca9e2ee0d$var$defaultErrorElement = /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$DefaultErrorComponent, null);
var $be02915ca9e2ee0d$var$RenderErrorBoundary = class extends $lE8gv.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $be02915ca9e2ee0d$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$be02915ca9e2ee0d$var$RenderErrorBoundary.contextType = $be02915ca9e2ee0d$export$717f757c655223f1;
var $be02915ca9e2ee0d$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $be02915ca9e2ee0d$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $be02915ca9e2ee0d$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $be02915ca9e2ee0d$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $be02915ca9e2ee0d$var$parseToInfo(redirect2.location, basename);
            if ($be02915ca9e2ee0d$var$isBrowser && !$be02915ca9e2ee0d$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $be02915ca9e2ee0d$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $lE8gv.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $be02915ca9e2ee0d$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $lE8gv.useContext($be02915ca9e2ee0d$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $be02915ca9e2ee0d$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $be02915ca9e2ee0d$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $be02915ca9e2ee0d$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $be02915ca9e2ee0d$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $be02915ca9e2ee0d$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $lE8gv.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $be02915ca9e2ee0d$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $be02915ca9e2ee0d$var$useDataRouterContext(hookName) {
    let ctx = $lE8gv.useContext($be02915ca9e2ee0d$export$2eeee58951ff3c1c);
    $be02915ca9e2ee0d$export$f5708dca728d7177(ctx, $be02915ca9e2ee0d$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $be02915ca9e2ee0d$var$useDataRouterState(hookName) {
    let state = $lE8gv.useContext($be02915ca9e2ee0d$export$315e3ffb01f217);
    $be02915ca9e2ee0d$export$f5708dca728d7177(state, $be02915ca9e2ee0d$var$getDataRouterConsoleError(hookName));
    return state;
}
function $be02915ca9e2ee0d$var$useRouteContext(hookName) {
    let route = $lE8gv.useContext($be02915ca9e2ee0d$export$aac280ed165a4397);
    $be02915ca9e2ee0d$export$f5708dca728d7177(route, $be02915ca9e2ee0d$var$getDataRouterConsoleError(hookName));
    return route;
}
function $be02915ca9e2ee0d$var$useCurrentRouteId(hookName) {
    let route = $be02915ca9e2ee0d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $be02915ca9e2ee0d$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $be02915ca9e2ee0d$var$useRouteId() {
    return $be02915ca9e2ee0d$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $be02915ca9e2ee0d$export$d0fd4b7106de2769() {
    let state = $be02915ca9e2ee0d$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $be02915ca9e2ee0d$export$600dc272ed516c15() {
    let dataRouterContext = $be02915ca9e2ee0d$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $be02915ca9e2ee0d$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $lE8gv.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $lE8gv.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $be02915ca9e2ee0d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $be02915ca9e2ee0d$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $lE8gv.useMemo(()=>matches.map((m)=>$be02915ca9e2ee0d$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $be02915ca9e2ee0d$export$1448a5050d252c4d() {
    let state = $be02915ca9e2ee0d$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $be02915ca9e2ee0d$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $be02915ca9e2ee0d$export$fd5d37484eab868d(routeId) {
    let state = $be02915ca9e2ee0d$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $be02915ca9e2ee0d$export$fdc00f3f26066d5e() {
    let state = $be02915ca9e2ee0d$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $be02915ca9e2ee0d$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $be02915ca9e2ee0d$export$ed527bf60f6e05f2() {
    let error = $lE8gv.useContext($be02915ca9e2ee0d$var$RouteErrorContext);
    let state = $be02915ca9e2ee0d$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $be02915ca9e2ee0d$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $be02915ca9e2ee0d$export$78a72ddb39bdd145() {
    let value = $lE8gv.useContext($be02915ca9e2ee0d$var$AwaitContext);
    return value?._data;
}
function $be02915ca9e2ee0d$export$17f53340677d5831() {
    let value = $lE8gv.useContext($be02915ca9e2ee0d$var$AwaitContext);
    return value?._error;
}
var $be02915ca9e2ee0d$var$blockerId = 0;
function $be02915ca9e2ee0d$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $be02915ca9e2ee0d$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $be02915ca9e2ee0d$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $lE8gv.useState("");
    let blockerFunction = $lE8gv.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $be02915ca9e2ee0d$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $be02915ca9e2ee0d$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $lE8gv.useEffect(()=>{
        let key = String(++$be02915ca9e2ee0d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $lE8gv.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $be02915ca9e2ee0d$export$386d57f03f0b2883;
}
function $be02915ca9e2ee0d$var$useNavigateStable() {
    let { router: router } = $be02915ca9e2ee0d$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $be02915ca9e2ee0d$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $lE8gv.useRef(false);
    $be02915ca9e2ee0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lE8gv.useCallback(async (to, options = {})=>{
        $be02915ca9e2ee0d$var$warning(activeRef.current, $be02915ca9e2ee0d$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $be02915ca9e2ee0d$var$alreadyWarned = {};
function $be02915ca9e2ee0d$var$warningOnce(key, cond, message) {
    if (!cond && !$be02915ca9e2ee0d$var$alreadyWarned[key]) {
        $be02915ca9e2ee0d$var$alreadyWarned[key] = true;
        $be02915ca9e2ee0d$var$warning(false, message);
    }
}
function $be02915ca9e2ee0d$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $be02915ca9e2ee0d$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $be02915ca9e2ee0d$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $be02915ca9e2ee0d$var$alreadyWarned2 = {};
function $be02915ca9e2ee0d$export$5b28268982f175ba(condition, message) {
    if (!condition && !$be02915ca9e2ee0d$var$alreadyWarned2[message]) {
        $be02915ca9e2ee0d$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $be02915ca9e2ee0d$var$USE_OPTIMISTIC = "useOptimistic";
var $be02915ca9e2ee0d$var$useOptimisticImpl = $lE8gv[$be02915ca9e2ee0d$var$USE_OPTIMISTIC];
var $be02915ca9e2ee0d$var$stableUseOptimisticSetter = ()=>void 0;
function $be02915ca9e2ee0d$var$useOptimisticSafe(val) {
    if ($be02915ca9e2ee0d$var$useOptimisticImpl) return $be02915ca9e2ee0d$var$useOptimisticImpl(val);
    else return [
        val,
        $be02915ca9e2ee0d$var$stableUseOptimisticSetter
    ];
}
function $be02915ca9e2ee0d$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($be02915ca9e2ee0d$export$945fecf35a8ef089) {
            if (route.element) $be02915ca9e2ee0d$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $lE8gv.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($be02915ca9e2ee0d$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $be02915ca9e2ee0d$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $lE8gv.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($be02915ca9e2ee0d$export$945fecf35a8ef089) {
            if (route.errorElement) $be02915ca9e2ee0d$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $lE8gv.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $be02915ca9e2ee0d$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $be02915ca9e2ee0d$export$f30f7e456d254e83(routes, opts) {
    return $be02915ca9e2ee0d$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $be02915ca9e2ee0d$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $be02915ca9e2ee0d$export$e2fd2c03906469db,
        mapRouteProperties: $be02915ca9e2ee0d$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $be02915ca9e2ee0d$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $be02915ca9e2ee0d$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, unstable_useTransitions: unstable_useTransitions }) {
    let unstable_rsc = $be02915ca9e2ee0d$var$useIsRSCRouterContext();
    unstable_useTransitions = unstable_rsc || unstable_useTransitions;
    let [_state, setStateImpl] = $lE8gv.useState(router.state);
    let [state, setOptimisticState] = $be02915ca9e2ee0d$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $lE8gv.useState();
    let [vtContext, setVtContext] = $lE8gv.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $lE8gv.useState();
    let [transition, setTransition] = $lE8gv.useState();
    let [interruption, setInterruption] = $lE8gv.useState();
    let fetcherData = $lE8gv.useRef(/* @__PURE__ */ new Map());
    let setState = $lE8gv.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $be02915ca9e2ee0d$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $be02915ca9e2ee0d$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $be02915ca9e2ee0d$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $lE8gv.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$be02915ca9e2ee0d$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        onError
    ]);
    $lE8gv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let initialized = state.initialized;
    $lE8gv.useLayoutEffect(()=>{
        if (!initialized && router.state.initialized) setState(router.state, {
            deletedFetchers: [],
            flushSync: false,
            newErrors: null
        });
    }, [
        initialized,
        setState,
        router.state
    ]);
    $lE8gv.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $be02915ca9e2ee0d$var$Deferred());
    }, [
        vtContext
    ]);
    $lE8gv.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $lE8gv.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$be02915ca9e2ee0d$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $lE8gv.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $lE8gv.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $lE8gv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lE8gv.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $be02915ca9e2ee0d$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $be02915ca9e2ee0d$var$MemoizedDataRoutes = $lE8gv.memo($be02915ca9e2ee0d$var$DataRoutes);
function $be02915ca9e2ee0d$var$DataRoutes({ routes: routes, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $be02915ca9e2ee0d$var$useRoutesImpl(routes, void 0, {
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $be02915ca9e2ee0d$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $lE8gv.useRef();
    if (historyRef.current == null) historyRef.current = $be02915ca9e2ee0d$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lE8gv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $lE8gv.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $lE8gv.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $lE8gv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $be02915ca9e2ee0d$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $be02915ca9e2ee0d$export$f5708dca728d7177($be02915ca9e2ee0d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    $be02915ca9e2ee0d$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $lE8gv.useContext($be02915ca9e2ee0d$export$aac280ed165a4397);
    let { pathname: locationPathname } = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let navigate = $be02915ca9e2ee0d$export$9770f232ac06a008();
    let path = $be02915ca9e2ee0d$var$resolveTo(to, $be02915ca9e2ee0d$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $lE8gv.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $be02915ca9e2ee0d$export$910ae8079b2c2852(props) {
    return $be02915ca9e2ee0d$export$a3be3530d8e40d0b(props.context);
}
function $be02915ca9e2ee0d$export$e7b0ac011bb776c6(props) {
    $be02915ca9e2ee0d$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $be02915ca9e2ee0d$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $be02915ca9e2ee0d$export$f5708dca728d7177(!$be02915ca9e2ee0d$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $lE8gv.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $be02915ca9e2ee0d$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", unstable_mask: unstable_mask } = locationProp;
    let locationContext = $lE8gv.useMemo(()=>{
        let trailingPathname = $be02915ca9e2ee0d$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                unstable_mask: unstable_mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        unstable_mask
    ]);
    $be02915ca9e2ee0d$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $be02915ca9e2ee0d$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $be02915ca9e2ee0d$export$5d3fca4a98652595($be02915ca9e2ee0d$export$16da398f5434bdec(children), location);
}
function $be02915ca9e2ee0d$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $lE8gv.useContext($be02915ca9e2ee0d$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $lE8gv.useContext($be02915ca9e2ee0d$export$315e3ffb01f217);
    let onError = $lE8gv.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $be02915ca9e2ee0d$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$ResolveAwait, null, children));
}
var $be02915ca9e2ee0d$var$AwaitErrorBoundary = class extends $lE8gv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $be02915ca9e2ee0d$var$ResolveAwait({ children: children }) {
    let data2 = $be02915ca9e2ee0d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, toRender);
}
function $be02915ca9e2ee0d$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $lE8gv.Children.forEach(children, (element, index)=>{
        if (!$lE8gv.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $lE8gv.Fragment) {
            routes.push.apply(routes, $be02915ca9e2ee0d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $be02915ca9e2ee0d$export$f5708dca728d7177(element.type === $be02915ca9e2ee0d$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $be02915ca9e2ee0d$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $be02915ca9e2ee0d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $be02915ca9e2ee0d$export$9b5b6d122dea0c88 = $be02915ca9e2ee0d$export$16da398f5434bdec;
function $be02915ca9e2ee0d$export$daf73786167a7f72(matches) {
    return $be02915ca9e2ee0d$var$_renderMatches(matches);
}
function $be02915ca9e2ee0d$var$useRouteComponentProps() {
    return {
        params: $be02915ca9e2ee0d$export$99eaa27ddbbb95ef(),
        loaderData: $be02915ca9e2ee0d$export$1448a5050d252c4d(),
        actionData: $be02915ca9e2ee0d$export$fdc00f3f26066d5e(),
        matches: $be02915ca9e2ee0d$export$2378eb7f5ff86053()
    };
}
function $be02915ca9e2ee0d$export$6c4f3826290c37af({ children: children }) {
    const props = $be02915ca9e2ee0d$var$useRouteComponentProps();
    return $lE8gv.cloneElement(children, props);
}
function $be02915ca9e2ee0d$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $be02915ca9e2ee0d$var$useRouteComponentProps();
        return $lE8gv.createElement(Component4, props);
    };
}
function $be02915ca9e2ee0d$var$useHydrateFallbackProps() {
    return {
        params: $be02915ca9e2ee0d$export$99eaa27ddbbb95ef(),
        loaderData: $be02915ca9e2ee0d$export$1448a5050d252c4d(),
        actionData: $be02915ca9e2ee0d$export$fdc00f3f26066d5e()
    };
}
function $be02915ca9e2ee0d$export$f8cff34f39c1932a({ children: children }) {
    const props = $be02915ca9e2ee0d$var$useHydrateFallbackProps();
    return $lE8gv.cloneElement(children, props);
}
function $be02915ca9e2ee0d$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $be02915ca9e2ee0d$var$useHydrateFallbackProps();
        return $lE8gv.createElement(HydrateFallback, props);
    };
}
function $be02915ca9e2ee0d$var$useErrorBoundaryProps() {
    return {
        params: $be02915ca9e2ee0d$export$99eaa27ddbbb95ef(),
        loaderData: $be02915ca9e2ee0d$export$1448a5050d252c4d(),
        actionData: $be02915ca9e2ee0d$export$fdc00f3f26066d5e(),
        error: $be02915ca9e2ee0d$export$ed527bf60f6e05f2()
    };
}
function $be02915ca9e2ee0d$export$e5afde5c4b6d747b({ children: children }) {
    const props = $be02915ca9e2ee0d$var$useErrorBoundaryProps();
    return $lE8gv.cloneElement(children, props);
}
function $be02915ca9e2ee0d$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $be02915ca9e2ee0d$var$useErrorBoundaryProps();
        return $lE8gv.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $be02915ca9e2ee0d$var$defaultMethod = "get";
var $be02915ca9e2ee0d$var$defaultEncType = "application/x-www-form-urlencoded";
function $be02915ca9e2ee0d$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $be02915ca9e2ee0d$var$isButtonElement(object) {
    return $be02915ca9e2ee0d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $be02915ca9e2ee0d$var$isFormElement(object) {
    return $be02915ca9e2ee0d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $be02915ca9e2ee0d$var$isInputElement(object) {
    return $be02915ca9e2ee0d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $be02915ca9e2ee0d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $be02915ca9e2ee0d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$be02915ca9e2ee0d$var$isModifiedEvent(event);
}
function $be02915ca9e2ee0d$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $be02915ca9e2ee0d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $be02915ca9e2ee0d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $be02915ca9e2ee0d$var$_formDataSupportsSubmitter = null;
function $be02915ca9e2ee0d$var$isFormDataSubmitterSupported() {
    if ($be02915ca9e2ee0d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $be02915ca9e2ee0d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $be02915ca9e2ee0d$var$_formDataSupportsSubmitter = true;
    }
    return $be02915ca9e2ee0d$var$_formDataSupportsSubmitter;
}
var $be02915ca9e2ee0d$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $be02915ca9e2ee0d$var$getFormEncType(encType) {
    if (encType != null && !$be02915ca9e2ee0d$var$supportedFormEncTypes.has(encType)) {
        $be02915ca9e2ee0d$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$be02915ca9e2ee0d$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $be02915ca9e2ee0d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($be02915ca9e2ee0d$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $be02915ca9e2ee0d$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $be02915ca9e2ee0d$var$defaultMethod;
        encType = $be02915ca9e2ee0d$var$getFormEncType(target.getAttribute("enctype")) || $be02915ca9e2ee0d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($be02915ca9e2ee0d$var$isButtonElement(target) || $be02915ca9e2ee0d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $be02915ca9e2ee0d$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $be02915ca9e2ee0d$var$defaultMethod;
        encType = $be02915ca9e2ee0d$var$getFormEncType(target.getAttribute("formenctype")) || $be02915ca9e2ee0d$var$getFormEncType(form.getAttribute("enctype")) || $be02915ca9e2ee0d$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$be02915ca9e2ee0d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($be02915ca9e2ee0d$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $be02915ca9e2ee0d$var$defaultMethod;
        action = null;
        encType = $be02915ca9e2ee0d$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $be02915ca9e2ee0d$var$HOLE = -1;
var $be02915ca9e2ee0d$var$NAN = -2;
var $be02915ca9e2ee0d$var$NEGATIVE_INFINITY = -3;
var $be02915ca9e2ee0d$var$NEGATIVE_ZERO = -4;
var $be02915ca9e2ee0d$var$NULL = -5;
var $be02915ca9e2ee0d$var$POSITIVE_INFINITY = -6;
var $be02915ca9e2ee0d$var$UNDEFINED = -7;
var $be02915ca9e2ee0d$var$TYPE_BIGINT = "B";
var $be02915ca9e2ee0d$var$TYPE_DATE = "D";
var $be02915ca9e2ee0d$var$TYPE_ERROR = "E";
var $be02915ca9e2ee0d$var$TYPE_MAP = "M";
var $be02915ca9e2ee0d$var$TYPE_NULL_OBJECT = "N";
var $be02915ca9e2ee0d$var$TYPE_PROMISE = "P";
var $be02915ca9e2ee0d$var$TYPE_REGEXP = "R";
var $be02915ca9e2ee0d$var$TYPE_SET = "S";
var $be02915ca9e2ee0d$var$TYPE_SYMBOL = "Y";
var $be02915ca9e2ee0d$var$TYPE_URL = "U";
var $be02915ca9e2ee0d$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $be02915ca9e2ee0d$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $be02915ca9e2ee0d$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $be02915ca9e2ee0d$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $be02915ca9e2ee0d$var$TIME_LIMIT_MS = 1;
var $be02915ca9e2ee0d$var$getNow = ()=>Date.now();
var $be02915ca9e2ee0d$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $be02915ca9e2ee0d$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $be02915ca9e2ee0d$var$UNDEFINED;
    if (input === null) return $be02915ca9e2ee0d$var$NULL;
    if (Number.isNaN(input)) return $be02915ca9e2ee0d$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $be02915ca9e2ee0d$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $be02915ca9e2ee0d$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $be02915ca9e2ee0d$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $be02915ca9e2ee0d$var$stringify.call(this, stack);
    return index;
}
async function $be02915ca9e2ee0d$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $be02915ca9e2ee0d$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $be02915ca9e2ee0d$var$UNDEFINED;
        if (value === null) return $be02915ca9e2ee0d$var$NULL;
        if (Number.isNaN(value)) return $be02915ca9e2ee0d$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $be02915ca9e2ee0d$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $be02915ca9e2ee0d$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $be02915ca9e2ee0d$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $be02915ca9e2ee0d$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $be02915ca9e2ee0d$var$TIME_LIMIT_MS) {
            await $be02915ca9e2ee0d$var$yieldToMain();
            lastYieldTime = $be02915ca9e2ee0d$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$be02915ca9e2ee0d$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$be02915ca9e2ee0d$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$be02915ca9e2ee0d$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $be02915ca9e2ee0d$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$be02915ca9e2ee0d$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$be02915ca9e2ee0d$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$be02915ca9e2ee0d$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$be02915ca9e2ee0d$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$be02915ca9e2ee0d$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$be02915ca9e2ee0d$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$be02915ca9e2ee0d$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$be02915ca9e2ee0d$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$be02915ca9e2ee0d$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$be02915ca9e2ee0d$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($be02915ca9e2ee0d$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $be02915ca9e2ee0d$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $be02915ca9e2ee0d$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $be02915ca9e2ee0d$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $be02915ca9e2ee0d$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $be02915ca9e2ee0d$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $be02915ca9e2ee0d$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $be02915ca9e2ee0d$var$hydrate.call(this, startIndex);
}
function $be02915ca9e2ee0d$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $be02915ca9e2ee0d$var$UNDEFINED:
                set(void 0);
                continue;
            case $be02915ca9e2ee0d$var$NULL:
                set(null);
                continue;
            case $be02915ca9e2ee0d$var$NAN:
                set(NaN);
                continue;
            case $be02915ca9e2ee0d$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $be02915ca9e2ee0d$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $be02915ca9e2ee0d$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $be02915ca9e2ee0d$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $be02915ca9e2ee0d$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $be02915ca9e2ee0d$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $be02915ca9e2ee0d$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $be02915ca9e2ee0d$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $be02915ca9e2ee0d$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $be02915ca9e2ee0d$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $be02915ca9e2ee0d$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $be02915ca9e2ee0d$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $be02915ca9e2ee0d$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $be02915ca9e2ee0d$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $be02915ca9e2ee0d$var$globalObj && $be02915ca9e2ee0d$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $be02915ca9e2ee0d$var$globalObj && typeof $be02915ca9e2ee0d$var$globalObj[errorType] === "function" ? new $be02915ca9e2ee0d$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $be02915ca9e2ee0d$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $be02915ca9e2ee0d$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $be02915ca9e2ee0d$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $be02915ca9e2ee0d$var$Deferred2();
    const reader = readable.pipeThrough($be02915ca9e2ee0d$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $be02915ca9e2ee0d$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $be02915ca9e2ee0d$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $be02915ca9e2ee0d$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $be02915ca9e2ee0d$var$unflatten.call(this, line)
    };
}
async function $be02915ca9e2ee0d$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $be02915ca9e2ee0d$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $be02915ca9e2ee0d$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $be02915ca9e2ee0d$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $be02915ca9e2ee0d$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $be02915ca9e2ee0d$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $be02915ca9e2ee0d$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $be02915ca9e2ee0d$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$be02915ca9e2ee0d$var$TYPE_PROMISE}${deferredId}:[["${$be02915ca9e2ee0d$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$be02915ca9e2ee0d$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$be02915ca9e2ee0d$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $be02915ca9e2ee0d$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$be02915ca9e2ee0d$var$TYPE_ERROR}${deferredId}:[["${$be02915ca9e2ee0d$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$be02915ca9e2ee0d$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$be02915ca9e2ee0d$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $be02915ca9e2ee0d$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $be02915ca9e2ee0d$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $be02915ca9e2ee0d$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $be02915ca9e2ee0d$export$4cf11838cdc2a8a8(html) {
    return html.replace($be02915ca9e2ee0d$var$ESCAPE_REGEX, (match)=>$be02915ca9e2ee0d$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $be02915ca9e2ee0d$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $be02915ca9e2ee0d$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $be02915ca9e2ee0d$var$SingleFetchNoResultError = class extends Error {
};
var $be02915ca9e2ee0d$export$ae9272e641ead836 = 202;
var $be02915ca9e2ee0d$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $be02915ca9e2ee0d$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $lE8gv.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$be02915ca9e2ee0d$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, scriptTag, /* @__PURE__ */ $lE8gv.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, scriptTag, /* @__PURE__ */ $lE8gv.createElement($lE8gv.Suspense, null, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $be02915ca9e2ee0d$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $be02915ca9e2ee0d$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $be02915ca9e2ee0d$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $be02915ca9e2ee0d$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $be02915ca9e2ee0d$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $be02915ca9e2ee0d$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $be02915ca9e2ee0d$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $be02915ca9e2ee0d$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $be02915ca9e2ee0d$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $be02915ca9e2ee0d$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $be02915ca9e2ee0d$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $be02915ca9e2ee0d$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($be02915ca9e2ee0d$export$3f1eb41d9a6a6a27(result.result) || $be02915ca9e2ee0d$export$972111febbeef05b(result.result) || $be02915ca9e2ee0d$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $be02915ca9e2ee0d$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $be02915ca9e2ee0d$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $be02915ca9e2ee0d$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $be02915ca9e2ee0d$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$be02915ca9e2ee0d$var$createDeferred2());
    let singleFetchDfd = $be02915ca9e2ee0d$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $be02915ca9e2ee0d$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $be02915ca9e2ee0d$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $be02915ca9e2ee0d$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $be02915ca9e2ee0d$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $be02915ca9e2ee0d$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $be02915ca9e2ee0d$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $be02915ca9e2ee0d$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $be02915ca9e2ee0d$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $be02915ca9e2ee0d$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $be02915ca9e2ee0d$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $be02915ca9e2ee0d$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$be02915ca9e2ee0d$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$be02915ca9e2ee0d$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $be02915ca9e2ee0d$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $be02915ca9e2ee0d$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $be02915ca9e2ee0d$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $be02915ca9e2ee0d$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $be02915ca9e2ee0d$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $be02915ca9e2ee0d$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($be02915ca9e2ee0d$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $be02915ca9e2ee0d$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $be02915ca9e2ee0d$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($be02915ca9e2ee0d$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$be02915ca9e2ee0d$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $be02915ca9e2ee0d$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $be02915ca9e2ee0d$export$4023ad4ecd4126a2(body, global) {
    return $be02915ca9e2ee0d$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $be02915ca9e2ee0d$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $be02915ca9e2ee0d$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$be02915ca9e2ee0d$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $be02915ca9e2ee0d$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $be02915ca9e2ee0d$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $be02915ca9e2ee0d$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $be02915ca9e2ee0d$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $be02915ca9e2ee0d$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $be02915ca9e2ee0d$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $be02915ca9e2ee0d$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $be02915ca9e2ee0d$var$getModuleLinkHrefs(matches, manifest);
    return $be02915ca9e2ee0d$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $be02915ca9e2ee0d$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $be02915ca9e2ee0d$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $be02915ca9e2ee0d$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($be02915ca9e2ee0d$var$prefetchStyleLink));
}
async function $be02915ca9e2ee0d$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$be02915ca9e2ee0d$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$be02915ca9e2ee0d$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$be02915ca9e2ee0d$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($be02915ca9e2ee0d$var$prefetchStyleLink));
}
async function $be02915ca9e2ee0d$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $be02915ca9e2ee0d$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $be02915ca9e2ee0d$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $be02915ca9e2ee0d$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $be02915ca9e2ee0d$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $be02915ca9e2ee0d$var$dedupeLinkDescriptors(links.flat(1).filter($be02915ca9e2ee0d$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $be02915ca9e2ee0d$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $be02915ca9e2ee0d$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $be02915ca9e2ee0d$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $be02915ca9e2ee0d$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $be02915ca9e2ee0d$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $be02915ca9e2ee0d$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$be02915ca9e2ee0d$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($be02915ca9e2ee0d$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $be02915ca9e2ee0d$var$_isPreloadSupported;
function $be02915ca9e2ee0d$var$isPreloadSupported() {
    if ($be02915ca9e2ee0d$var$_isPreloadSupported !== void 0) return $be02915ca9e2ee0d$var$_isPreloadSupported;
    let el = document.createElement("link");
    $be02915ca9e2ee0d$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $be02915ca9e2ee0d$var$_isPreloadSupported;
}
function $be02915ca9e2ee0d$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $be02915ca9e2ee0d$export$945fecf35a8ef089 ? /* @__PURE__ */ $lE8gv.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $be02915ca9e2ee0d$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $be02915ca9e2ee0d$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $be02915ca9e2ee0d$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $be02915ca9e2ee0d$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$RemixRootDefaultErrorBoundary, {
            error: $be02915ca9e2ee0d$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $lE8gv.createElement(routeModule.Layout, null, /* @__PURE__ */ $lE8gv.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $lE8gv.createElement(routeModule.Layout, null, /* @__PURE__ */ $lE8gv.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $lE8gv.createElement(routeModule.Layout, null, /* @__PURE__ */ $lE8gv.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $be02915ca9e2ee0d$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $be02915ca9e2ee0d$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $be02915ca9e2ee0d$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$be02915ca9e2ee0d$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $be02915ca9e2ee0d$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $be02915ca9e2ee0d$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $be02915ca9e2ee0d$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $be02915ca9e2ee0d$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $be02915ca9e2ee0d$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $be02915ca9e2ee0d$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $be02915ca9e2ee0d$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $be02915ca9e2ee0d$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $be02915ca9e2ee0d$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $be02915ca9e2ee0d$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $be02915ca9e2ee0d$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $be02915ca9e2ee0d$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $be02915ca9e2ee0d$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$be02915ca9e2ee0d$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $be02915ca9e2ee0d$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern, unstable_url: unstable_url }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $be02915ca9e2ee0d$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            unstable_url: unstable_url,
                            async serverLoader () {
                                $be02915ca9e2ee0d$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $be02915ca9e2ee0d$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern, unstable_url: unstable_url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $be02915ca9e2ee0d$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $be02915ca9e2ee0d$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        unstable_url: unstable_url,
                        async serverAction () {
                            $be02915ca9e2ee0d$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $be02915ca9e2ee0d$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $be02915ca9e2ee0d$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $be02915ca9e2ee0d$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $be02915ca9e2ee0d$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $be02915ca9e2ee0d$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $be02915ca9e2ee0d$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $be02915ca9e2ee0d$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $be02915ca9e2ee0d$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $be02915ca9e2ee0d$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $be02915ca9e2ee0d$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $be02915ca9e2ee0d$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $be02915ca9e2ee0d$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $be02915ca9e2ee0d$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $be02915ca9e2ee0d$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $be02915ca9e2ee0d$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $be02915ca9e2ee0d$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $be02915ca9e2ee0d$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $be02915ca9e2ee0d$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $be02915ca9e2ee0d$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $be02915ca9e2ee0d$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $be02915ca9e2ee0d$var$nextPaths = /* @__PURE__ */ new Set();
var $be02915ca9e2ee0d$var$discoveredPathsMaxSize = 1e3;
var $be02915ca9e2ee0d$var$discoveredPaths = /* @__PURE__ */ new Set();
var $be02915ca9e2ee0d$var$URL_LIMIT = 7680;
function $be02915ca9e2ee0d$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $be02915ca9e2ee0d$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $be02915ca9e2ee0d$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $be02915ca9e2ee0d$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$be02915ca9e2ee0d$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($be02915ca9e2ee0d$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $be02915ca9e2ee0d$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $be02915ca9e2ee0d$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $be02915ca9e2ee0d$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $lE8gv.useEffect(()=>{
        if (!$be02915ca9e2ee0d$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$be02915ca9e2ee0d$var$discoveredPaths.has(pathname)) $be02915ca9e2ee0d$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($be02915ca9e2ee0d$var$nextPaths.keys()).filter((path)=>{
                if ($be02915ca9e2ee0d$var$discoveredPaths.has(path)) {
                    $be02915ca9e2ee0d$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $be02915ca9e2ee0d$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $be02915ca9e2ee0d$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $be02915ca9e2ee0d$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $be02915ca9e2ee0d$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $be02915ca9e2ee0d$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $be02915ca9e2ee0d$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($be02915ca9e2ee0d$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $be02915ca9e2ee0d$var$URL_LIMIT) {
        $be02915ca9e2ee0d$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($be02915ca9e2ee0d$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($be02915ca9e2ee0d$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($be02915ca9e2ee0d$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$be02915ca9e2ee0d$var$addToFifoQueue(p, $be02915ca9e2ee0d$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $be02915ca9e2ee0d$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $be02915ca9e2ee0d$var$addToFifoQueue(path, queue) {
    if (queue.size >= $be02915ca9e2ee0d$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $be02915ca9e2ee0d$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $be02915ca9e2ee0d$var$useDataRouterContext2() {
    let context = $lE8gv.useContext($be02915ca9e2ee0d$export$2eeee58951ff3c1c);
    $be02915ca9e2ee0d$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $be02915ca9e2ee0d$var$useDataRouterStateContext() {
    let context = $lE8gv.useContext($be02915ca9e2ee0d$export$315e3ffb01f217);
    $be02915ca9e2ee0d$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $be02915ca9e2ee0d$export$208d6a3bc3aa62bd = $lE8gv.createContext(void 0);
$be02915ca9e2ee0d$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $be02915ca9e2ee0d$var$useFrameworkContext() {
    let context = $lE8gv.useContext($be02915ca9e2ee0d$export$208d6a3bc3aa62bd);
    $be02915ca9e2ee0d$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $be02915ca9e2ee0d$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $lE8gv.useContext($be02915ca9e2ee0d$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $lE8gv.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $lE8gv.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $lE8gv.useRef(null);
    $lE8gv.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $lE8gv.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $be02915ca9e2ee0d$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $be02915ca9e2ee0d$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $be02915ca9e2ee0d$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $be02915ca9e2ee0d$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $be02915ca9e2ee0d$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $be02915ca9e2ee0d$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $be02915ca9e2ee0d$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$be02915ca9e2ee0d$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $be02915ca9e2ee0d$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $be02915ca9e2ee0d$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $be02915ca9e2ee0d$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $be02915ca9e2ee0d$var$useDataRouterStateContext();
    let matches = $be02915ca9e2ee0d$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $lE8gv.useMemo(()=>$be02915ca9e2ee0d$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $lE8gv.createElement("style", {
        [$be02915ca9e2ee0d$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $lE8gv.createElement("link", {
        [$be02915ca9e2ee0d$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$be02915ca9e2ee0d$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $lE8gv.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $be02915ca9e2ee0d$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $be02915ca9e2ee0d$var$useIsRSCRouterContext();
    let { router: router } = $be02915ca9e2ee0d$var$useDataRouterContext2();
    let matches = $lE8gv.useMemo(()=>$be02915ca9e2ee0d$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (rsc) return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $be02915ca9e2ee0d$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $be02915ca9e2ee0d$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $lE8gv.useState([]);
    $lE8gv.useEffect(()=>{
        let interrupted = false;
        $be02915ca9e2ee0d$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $be02915ca9e2ee0d$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let { future: future } = $be02915ca9e2ee0d$var$useFrameworkContext();
    let { basename: basename } = $be02915ca9e2ee0d$var$useDataRouterContext2();
    let dataHrefs = $lE8gv.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $be02915ca9e2ee0d$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $lE8gv.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $be02915ca9e2ee0d$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $be02915ca9e2ee0d$var$useFrameworkContext();
    let { basename: basename } = $be02915ca9e2ee0d$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $be02915ca9e2ee0d$var$useDataRouterStateContext();
    let newMatchesForData = $lE8gv.useMemo(()=>$be02915ca9e2ee0d$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $lE8gv.useMemo(()=>$be02915ca9e2ee0d$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $lE8gv.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $be02915ca9e2ee0d$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $lE8gv.useMemo(()=>$be02915ca9e2ee0d$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $be02915ca9e2ee0d$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $lE8gv.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $lE8gv.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $lE8gv.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $be02915ca9e2ee0d$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $be02915ca9e2ee0d$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $be02915ca9e2ee0d$var$useDataRouterStateContext();
    let location = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let _matches = $be02915ca9e2ee0d$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$be02915ca9e2ee0d$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $lE8gv.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $lE8gv.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $lE8gv.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $lE8gv.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $be02915ca9e2ee0d$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $lE8gv.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $be02915ca9e2ee0d$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $be02915ca9e2ee0d$var$isHydrated = false;
function $be02915ca9e2ee0d$export$3be068dde909e563() {
    $be02915ca9e2ee0d$var$isHydrated = true;
}
function $be02915ca9e2ee0d$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $be02915ca9e2ee0d$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $be02915ca9e2ee0d$var$useDataRouterContext2();
    let { matches: routerMatches } = $be02915ca9e2ee0d$var$useDataRouterStateContext();
    let isRSCRouterContext = $be02915ca9e2ee0d$var$useIsRSCRouterContext();
    let enableFogOfWar = $be02915ca9e2ee0d$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $be02915ca9e2ee0d$var$getActiveMatches(routerMatches, null, isSpaMode);
    $lE8gv.useEffect(()=>{
        $be02915ca9e2ee0d$export$3be068dde909e563();
    }, []);
    let initialScripts = $lE8gv.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $be02915ca9e2ee0d$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($be02915ca9e2ee0d$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, /* @__PURE__ */ $lE8gv.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $lE8gv.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $be02915ca9e2ee0d$var$isHydrated || isRSCRouterContext ? [] : $be02915ca9e2ee0d$var$dedupe(manifest.entry.imports.concat($be02915ca9e2ee0d$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $be02915ca9e2ee0d$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $be02915ca9e2ee0d$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $lE8gv.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $lE8gv.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $lE8gv.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $lE8gv.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $be02915ca9e2ee0d$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $be02915ca9e2ee0d$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $be02915ca9e2ee0d$export$32e57f52df4b6e34 = class extends $lE8gv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $be02915ca9e2ee0d$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $lE8gv.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($be02915ca9e2ee0d$export$972111febbeef05b(error)) return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $lE8gv.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $be02915ca9e2ee0d$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $lE8gv.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $lE8gv.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $be02915ca9e2ee0d$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $be02915ca9e2ee0d$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $lE8gv.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $lE8gv.createElement("head", null, /* @__PURE__ */ $lE8gv.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $lE8gv.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $lE8gv.createElement("title", null, title)), /* @__PURE__ */ $lE8gv.createElement("body", null, /* @__PURE__ */ $lE8gv.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$ff0bf87698939488, null) : null)));
}
var $be02915ca9e2ee0d$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($be02915ca9e2ee0d$var$isBrowser2) window.__reactRouterVersion = "7.14.2";
} catch (e) {}
function $be02915ca9e2ee0d$export$1f3f55432a00e06d(routes, opts) {
    return $be02915ca9e2ee0d$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $be02915ca9e2ee0d$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $be02915ca9e2ee0d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $be02915ca9e2ee0d$export$9269a41d8c4635e,
        hydrationRouteProperties: $be02915ca9e2ee0d$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $be02915ca9e2ee0d$export$1ba7ed8a3a7b3765(routes, opts) {
    return $be02915ca9e2ee0d$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $be02915ca9e2ee0d$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $be02915ca9e2ee0d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $be02915ca9e2ee0d$export$9269a41d8c4635e,
        hydrationRouteProperties: $be02915ca9e2ee0d$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $be02915ca9e2ee0d$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $be02915ca9e2ee0d$var$deserializeErrors(state.errors)
    };
    return state;
}
function $be02915ca9e2ee0d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $be02915ca9e2ee0d$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $be02915ca9e2ee0d$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $lE8gv.useRef();
    if (historyRef.current == null) historyRef.current = $be02915ca9e2ee0d$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lE8gv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $lE8gv.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $lE8gv.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $lE8gv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $be02915ca9e2ee0d$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $lE8gv.useRef();
    if (historyRef.current == null) historyRef.current = $be02915ca9e2ee0d$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lE8gv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $lE8gv.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $lE8gv.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $lE8gv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $be02915ca9e2ee0d$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $lE8gv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $lE8gv.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $lE8gv.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $lE8gv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
$be02915ca9e2ee0d$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $be02915ca9e2ee0d$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $be02915ca9e2ee0d$export$a6c7ac8248d6e38a = $lE8gv.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, unstable_mask: unstable_mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, unstable_useTransitions: unstable_useTransitions } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $be02915ca9e2ee0d$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $be02915ca9e2ee0d$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $be02915ca9e2ee0d$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let maskedHref = null;
    if (unstable_mask) {
        let resolved = $be02915ca9e2ee0d$var$resolveTo(unstable_mask, [], location.unstable_mask ? location.unstable_mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $be02915ca9e2ee0d$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $be02915ca9e2ee0d$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $be02915ca9e2ee0d$export$67621102c14d847(to, {
        replace: replace2,
        unstable_mask: unstable_mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $lE8gv.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $be02915ca9e2ee0d$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, link, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$be02915ca9e2ee0d$export$a6c7ac8248d6e38a.displayName = "Link";
var $be02915ca9e2ee0d$export$b0d92dbee9b5b60d = $lE8gv.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $be02915ca9e2ee0d$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let routerState = $lE8gv.useContext($be02915ca9e2ee0d$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $be02915ca9e2ee0d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $be02915ca9e2ee0d$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$be02915ca9e2ee0d$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $be02915ca9e2ee0d$export$a7fed597f4b8afd8 = $lE8gv.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $be02915ca9e2ee0d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    let submit = $be02915ca9e2ee0d$export$47c85c6e3a081d3();
    let formAction = $be02915ca9e2ee0d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $be02915ca9e2ee0d$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
            });
        if (unstable_useTransitions && navigate !== false) $lE8gv.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $lE8gv.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$be02915ca9e2ee0d$export$a7fed597f4b8afd8.displayName = "Form";
function $be02915ca9e2ee0d$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $lE8gv.useContext($be02915ca9e2ee0d$export$208d6a3bc3aa62bd);
    let { basename: basename } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    let location = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let matches = $be02915ca9e2ee0d$export$2378eb7f5ff86053();
    $be02915ca9e2ee0d$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $lE8gv.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $be02915ca9e2ee0d$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $lE8gv.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$be02915ca9e2ee0d$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $be02915ca9e2ee0d$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$be02915ca9e2ee0d$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$be02915ca9e2ee0d$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $be02915ca9e2ee0d$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $be02915ca9e2ee0d$var$useDataRouterContext3(hookName) {
    let ctx = $lE8gv.useContext($be02915ca9e2ee0d$export$2eeee58951ff3c1c);
    $be02915ca9e2ee0d$export$f5708dca728d7177(ctx, $be02915ca9e2ee0d$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $be02915ca9e2ee0d$var$useDataRouterState2(hookName) {
    let state = $lE8gv.useContext($be02915ca9e2ee0d$export$315e3ffb01f217);
    $be02915ca9e2ee0d$export$f5708dca728d7177(state, $be02915ca9e2ee0d$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $be02915ca9e2ee0d$export$67621102c14d847(to, { target: target, replace: replaceProp, unstable_mask: unstable_mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $be02915ca9e2ee0d$export$9770f232ac06a008();
    let location = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let path = $be02915ca9e2ee0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $lE8gv.useCallback((event)=>{
        if ($be02915ca9e2ee0d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $be02915ca9e2ee0d$export$fe53371bee54353d(location) === $be02915ca9e2ee0d$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    unstable_mask: unstable_mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
                });
            if (unstable_useTransitions) $lE8gv.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        unstable_mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_defaultShouldRevalidate,
        unstable_useTransitions
    ]);
}
function $be02915ca9e2ee0d$export$f1a78c17382fe22a(defaultInit) {
    $be02915ca9e2ee0d$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $lE8gv.useRef($be02915ca9e2ee0d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $lE8gv.useRef(false);
    let location = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let searchParams = $lE8gv.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $be02915ca9e2ee0d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $be02915ca9e2ee0d$export$9770f232ac06a008();
    let setSearchParams = $lE8gv.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $be02915ca9e2ee0d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $be02915ca9e2ee0d$var$fetcherId = 0;
var $be02915ca9e2ee0d$var$getUniqueFetcherId = ()=>`__${String(++$be02915ca9e2ee0d$var$fetcherId)}__`;
function $be02915ca9e2ee0d$export$47c85c6e3a081d3() {
    let { router: router } = $be02915ca9e2ee0d$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    let currentRouteId = $be02915ca9e2ee0d$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $lE8gv.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $be02915ca9e2ee0d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $be02915ca9e2ee0d$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $be02915ca9e2ee0d$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    let routeContext = $lE8gv.useContext($be02915ca9e2ee0d$export$aac280ed165a4397);
    $be02915ca9e2ee0d$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$be02915ca9e2ee0d$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $be02915ca9e2ee0d$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $be02915ca9e2ee0d$export$fe53371bee54353d(path);
}
function $be02915ca9e2ee0d$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $be02915ca9e2ee0d$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $be02915ca9e2ee0d$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $lE8gv.useContext($be02915ca9e2ee0d$export$cb3f1df1bef00a39);
    let route = $lE8gv.useContext($be02915ca9e2ee0d$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $be02915ca9e2ee0d$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $be02915ca9e2ee0d$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $be02915ca9e2ee0d$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $lE8gv.useId();
    let [fetcherKey, setFetcherKey] = $lE8gv.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $lE8gv.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $lE8gv.useCallback(async (href, opts)=>{
        $be02915ca9e2ee0d$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $be02915ca9e2ee0d$export$47c85c6e3a081d3();
    let submit = $lE8gv.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $lE8gv.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $lE8gv.useMemo(()=>{
        let FetcherForm2 = $lE8gv.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $be02915ca9e2ee0d$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $lE8gv.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $be02915ca9e2ee0d$export$fa996778a3a31087() {
    let state = $be02915ca9e2ee0d$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $be02915ca9e2ee0d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $be02915ca9e2ee0d$var$savedScrollPositions = {};
function $be02915ca9e2ee0d$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $be02915ca9e2ee0d$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $be02915ca9e2ee0d$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $be02915ca9e2ee0d$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $be02915ca9e2ee0d$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $lE8gv.useContext($be02915ca9e2ee0d$export$3044ab7fdabeaee6);
    let location = $be02915ca9e2ee0d$export$45d76561a5302f2b();
    let matches = $be02915ca9e2ee0d$export$2378eb7f5ff86053();
    let navigation = $be02915ca9e2ee0d$export$d0fd4b7106de2769();
    $lE8gv.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $be02915ca9e2ee0d$var$usePageHide($lE8gv.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $be02915ca9e2ee0d$var$getScrollRestorationKey(location, matches, basename, getKey);
            $be02915ca9e2ee0d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $be02915ca9e2ee0d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($be02915ca9e2ee0d$var$savedScrollPositions));
        } catch (error) {
            $be02915ca9e2ee0d$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $lE8gv.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $be02915ca9e2ee0d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $be02915ca9e2ee0d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $lE8gv.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($be02915ca9e2ee0d$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$be02915ca9e2ee0d$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $lE8gv.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $be02915ca9e2ee0d$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $be02915ca9e2ee0d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $lE8gv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $be02915ca9e2ee0d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $lE8gv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $be02915ca9e2ee0d$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $be02915ca9e2ee0d$export$b273b3273281a049(when);
    $lE8gv.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $lE8gv.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $be02915ca9e2ee0d$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $lE8gv.useContext($be02915ca9e2ee0d$export$3681f408decb40d1);
    $be02915ca9e2ee0d$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $be02915ca9e2ee0d$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $be02915ca9e2ee0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $be02915ca9e2ee0d$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $be02915ca9e2ee0d$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $be02915ca9e2ee0d$export$81336c211d5ff295(path.pathname, nextPath) != null || $be02915ca9e2ee0d$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $be02915ca9e2ee0d$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $be02915ca9e2ee0d$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        unstable_mask: void 0
    };
    let staticNavigator = $be02915ca9e2ee0d$var$getStatelessNavigator();
    return /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $be02915ca9e2ee0d$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $be02915ca9e2ee0d$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $be02915ca9e2ee0d$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $be02915ca9e2ee0d$var$serializeErrors(context.errors)
        };
        let json = $be02915ca9e2ee0d$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $lE8gv.createElement($lE8gv.Fragment, null, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $lE8gv.createElement($be02915ca9e2ee0d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $lE8gv.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $be02915ca9e2ee0d$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($be02915ca9e2ee0d$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $be02915ca9e2ee0d$var$getStatelessNavigator() {
    return {
        createHref: $be02915ca9e2ee0d$var$createHref,
        encodeLocation: $be02915ca9e2ee0d$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $be02915ca9e2ee0d$export$69163f0b72ec60d9(routes, opts) {
    return $be02915ca9e2ee0d$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $be02915ca9e2ee0d$export$9269a41d8c4635e
    });
}
function $be02915ca9e2ee0d$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $be02915ca9e2ee0d$export$87cb1a9238dc3fba(routes, $be02915ca9e2ee0d$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                unstable_passThroughRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $be02915ca9e2ee0d$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $be02915ca9e2ee0d$var$createHref,
        encodeLocation: $be02915ca9e2ee0d$var$encodeLocation,
        getFetcher () {
            return $be02915ca9e2ee0d$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $be02915ca9e2ee0d$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $be02915ca9e2ee0d$var$createHref(to) {
    return typeof to === "string" ? to : $be02915ca9e2ee0d$export$fe53371bee54353d(to);
}
function $be02915ca9e2ee0d$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $be02915ca9e2ee0d$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $be02915ca9e2ee0d$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $be02915ca9e2ee0d$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;

});

parcelRegister("4EIqd", function(module, exports) {
$parcel$export(module.exports, "ROOT_ROUTES", () => $2c332a3e2cc3e958$export$1a87fab77ff24e8b);

var $dabDX = parcelRequire("dabDX");

var $4nP55 = parcelRequire("4nP55");

var $1tKKH = parcelRequire("1tKKH");

var $7sG1y = parcelRequire("7sG1y");

// hint: Do not webpackPreload or  webpackPrefetch any page
// why: we have preloader
// hint: add /* webpackMode: "eager" */ to those roots, which shall not be split
// roots
const $2c332a3e2cc3e958$var$RequestGate = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("7KyMT")), ({ ShadowItRequestGate: Page })=>Page);

const $2c332a3e2cc3e958$var$OrgPickerSwitcher = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("lN73Y")), ({ OrgPickerSwitcher: Page })=>Page);

const $2c332a3e2cc3e958$var$CreateOrganizationPage = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("inEZM")), ({ CreateOrganizationPage: Page })=>Page);

const $2c332a3e2cc3e958$var$Error404Page = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("gt8bZ")), ({ Error404Page: Page })=>Page);

const $2c332a3e2cc3e958$var$OrgRoutes = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("8zyfx")), ({ OrgRoutes: Page })=>Page);

const $2c332a3e2cc3e958$var$CreateWithRovoPreviewRoute = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("cWV9s")), ({ CreateWithRovoPreviewRoute: Page })=>Page);

const $2c332a3e2cc3e958$var$SiteRoutes = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("4I9s9")), ({ SiteRoutes: Page })=>Page);

const $2c332a3e2cc3e958$var$Dashboard = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("hZGBl")), ({ Dashboard: Page })=>Page);

const $2c332a3e2cc3e958$var$OrgOptIn = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("51elL")), ({ OrgOptIn: Page })=>Page);

const $2c332a3e2cc3e958$var$DspDeeplink = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("6xvhN")), ({ DspDeeplink: Page })=>Page);

const $2c332a3e2cc3e958$var$DataClassificationDeeplink = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("dtdll")), ({ DataClassificationDeeplink: Page })=>Page);

const $2c332a3e2cc3e958$var$GuardAlertsDeeplink = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("1NyM0")), ({ GuardAlertsDeeplink: Page })=>Page);

const $2c332a3e2cc3e958$var$DataScanDeeplink = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("4WCnI")), ({ DataScanDeeplink: Page })=>Page);

const $2c332a3e2cc3e958$var$GuardUserActivityDeeplink = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("5qkmM")), ({ GuardUserActivityDeeplink: Page })=>Page);

const $2c332a3e2cc3e958$var$GuardContentScanningDeeplink = (0, $1tKKH.PickPageLoader)(async ()=>(parcelRequire("2zbF3")), ({ GuardContentScanningDeeplink: Page })=>Page);
const $2c332a3e2cc3e958$export$1a87fab77ff24e8b = {
    '/product-request-workflow/*': {
        importer: $2c332a3e2cc3e958$var$RequestGate,
        navigation: false,
        name: (0, $7sG1y.RouteNames).TOP_ROUTE_SHADOW_IT_REQUEST_GATE
    },
    '/atlassian-access': {
        importer: $2c332a3e2cc3e958$var$OrgPickerSwitcher,
        navigation: true,
        name: (0, $7sG1y.RouteNames).TOP_ROUTE_ORG_PICKER_ATLASSIAN_ACCESS
    },
    '/atlassian-guard': {
        importer: $2c332a3e2cc3e958$var$OrgPickerSwitcher,
        navigation: true,
        name: (0, $7sG1y.RouteNames).TOP_ROUTE_ORG_PICKER_ATLASSIAN_GUARD
    },
    '/atlassian-guard-premium': {
        importer: $2c332a3e2cc3e958$var$OrgPickerSwitcher,
        navigation: true,
        name: (0, $7sG1y.RouteNames).TOP_ROUTE_ORG_PICKER_ATLASSIAN_GUARD_PREMIUM
    },
    // Deeplink feature gate uses fg() inside page components (not here): module-level fg() runs before FeatureGatesInitialization.
    // exact: false so paths still match with query params (e.g. ?bifrost-override= for branch preview).
    '/data-security-policies': {
        importer: $2c332a3e2cc3e958$var$DspDeeplink,
        navigation: true,
        exact: false
    },
    '/data-classification': {
        importer: $2c332a3e2cc3e958$var$DataClassificationDeeplink,
        navigation: true,
        exact: false
    },
    '/guard-alerts': {
        importer: $2c332a3e2cc3e958$var$GuardAlertsDeeplink,
        navigation: true,
        exact: false
    },
    '/data-scan': {
        importer: $2c332a3e2cc3e958$var$DataScanDeeplink,
        navigation: true,
        exact: false
    },
    '/guard-user-activity': {
        importer: $2c332a3e2cc3e958$var$GuardUserActivityDeeplink,
        navigation: true,
        exact: false
    },
    '/guard-content-scanning': {
        importer: $2c332a3e2cc3e958$var$GuardContentScanningDeeplink,
        navigation: true,
        exact: false
    },
    '/o/create': !(0, $dabDX.isFeatureEnabled)((0, $4nP55.ADMINHUB), (0, $4nP55.ADMINHUB_ORG_CREATE)) ? {
        importer: $2c332a3e2cc3e958$var$Error404Page,
        navigation: true
    } : {
        importer: $2c332a3e2cc3e958$var$CreateOrganizationPage,
        navigation: false
    },
    '/o/:orgId/policies/create-with-rovo-preview': {
        importer: $2c332a3e2cc3e958$var$CreateWithRovoPreviewRoute,
        navigation: false
    },
    // Single catch-all for org; /o/:orgId/idp/:idpId is handled by org-routes path="idp/:idpId/*"
    // so the index route only runs for the true org root (/o/:orgId).
    '/o/:orgId/*': {
        importer: $2c332a3e2cc3e958$var$OrgRoutes,
        navigation: true
    },
    // Use single catch-all for site so that pathname "remaining" after /s/:cloudId is non-empty for JSM paths
    // (e.g. .../idp/basicDirectoryId). Otherwise an index route in SiteRoutes would match and redirect to /users.
    '/s/:cloudId/*': {
        importer: $2c332a3e2cc3e958$var$SiteRoutes,
        navigation: true
    },
    '/': {
        importer: $2c332a3e2cc3e958$var$Dashboard,
        navigation: true,
        exact: true,
        name: (0, $7sG1y.RouteNames).TOP_ROUTE_DASHBOARD
    },
    '/cloud-first-create-a-migration/:orgId?': {
        importer: $2c332a3e2cc3e958$var$OrgOptIn,
        navigation: true
    },
    '*': {
        importer: $2c332a3e2cc3e958$var$Error404Page,
        navigation: true
    }
};

});
parcelRegister("dabDX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $iaBtp = parcelRequire("iaBtp");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $iaBtp.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $iaBtp.isFeatureEnabled;
    }
});

});
parcelRegister("iaBtp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $68vW8 = parcelRequire("68vW8");
var $bvb28 = parcelRequire("bvb28");
var $2o9oC = parcelRequire("2o9oC");

var $aO8rL = parcelRequire("aO8rL");

var $7K1MF = parcelRequire("7K1MF");

var $17jnY = parcelRequire("17jnY");

var $khCKG = parcelRequire("khCKG");
const $d3a63a97c8859376$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $d3a63a97c8859376$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $d3a63a97c8859376$var$getBoundaryKey();
    return (0, $7K1MF.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $d3a63a97c8859376$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function $d3a63a97c8859376$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $17jnY.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $d3a63a97c8859376$var$getBoundaryKey();
    const aemResult = (0, $7K1MF.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    // Keep predicate evaluation deferred until AEM or an explicit fallback resolves the feature as enabled.
    const isAllowedForCurrentOffering = ()=>{
        const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
        return predicate ? predicate() : true;
    };
    if (!aemResult) {
        const metadata = (0, $7K1MF.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if ($d3a63a97c8859376$var$shouldEnableForIcPreRelease(metadata, boundaryKey)) return isAllowedForCurrentOffering();
        if ((0, $khCKG.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        if (metadata && metadata.auditPhase) return $d3a63a97c8859376$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    return isAllowedForCurrentOffering();
}
module.exports.isFeatureEnabled = $d3a63a97c8859376$var$isFeatureEnabled;
/** Enables IC pre-release features only for the pre-release isolation context. */ function $d3a63a97c8859376$var$shouldEnableForIcPreRelease(metadata, boundaryKey) {
    return boundaryKey === $7K1MF.ISOLATED_CLOUD_COMMERCIAL_KEY && (0, $2o9oC.isolationContextId)() === "ic-dr6" && metadata !== undefined && metadata.preRelease === true;
}
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $d3a63a97c8859376$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $khCKG.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $7K1MF.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $khCKG.isSSR)() && localStorage.getItem(`${$d3a63a97c8859376$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $d3a63a97c8859376$var$shouldEnableForAudit;
function $d3a63a97c8859376$var$getBoundaryKey() {
    if ((0, $68vW8.isFedrampModerate)()) return $7K1MF.FED_MOD_KEY;
    if ((0, $bvb28.isIsolatedCloud)()) return $7K1MF.ISOLATED_CLOUD_COMMERCIAL_KEY;
    if ((0, $aO8rL.isGoogleCloudPlatform)()) return $7K1MF.GOOGLE_CLOUD_PLATFORM_KEY;
    return $7K1MF.COMMERCIAL_KEY;
}
function $d3a63a97c8859376$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$d3a63a97c8859376$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $d3a63a97c8859376$var$configureAuditState;
function $d3a63a97c8859376$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$d3a63a97c8859376$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $d3a63a97c8859376$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $d3a63a97c8859376$var$isFeatureEnabled,
    overrideFeature: $17jnY.overrideFeature,
    clearFeatureOverride: $17jnY.clearFeatureOverride,
    clearAllOverrides: $17jnY.clearAllOverrides,
    configureAuditState: $d3a63a97c8859376$var$configureAuditState,
    clearAuditState: $d3a63a97c8859376$var$clearAuditState
};

});
parcelRegister("68vW8", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $086eb35d79b45c72$export$104cb891a6e90b3a);

var $1qCUB = parcelRequire("1qCUB");

var $arA9d = parcelRequire("arA9d");
function $086eb35d79b45c72$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInFedramp ?? false;
    const atlCtxCookieValues = (0, $arA9d.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $1qCUB.FEDRAMP_MODERATE);
}

});
parcelRegister("1qCUB", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $42beac1ca0ac7f25$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $42beac1ca0ac7f25$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $42beac1ca0ac7f25$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $42beac1ca0ac7f25$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $42beac1ca0ac7f25$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $42beac1ca0ac7f25$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $42beac1ca0ac7f25$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $42beac1ca0ac7f25$export$a0ffa0598c95dfb7);
$parcel$export(module.exports, "BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER", () => $42beac1ca0ac7f25$export$74814ca8786924c3);
$parcel$export(module.exports, "CLOUD_SERVICE_PROVIDER_GCP", () => $42beac1ca0ac7f25$export$b61e047ddcc35726);
const $42beac1ca0ac7f25$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $42beac1ca0ac7f25$export$f005e2e9f707cb5f = 'commercial';
const $42beac1ca0ac7f25$export$17b81a3d6c98013c = 'isolated-cloud';
const $42beac1ca0ac7f25$export$a739cd5aac835909 = 'staging';
const $42beac1ca0ac7f25$export$42dd0cdd351a4a9 = 'prod';
const $42beac1ca0ac7f25$export$404582bc18fe4d9e = 'dev';
const $42beac1ca0ac7f25$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $42beac1ca0ac7f25$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $42beac1ca0ac7f25$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $42beac1ca0ac7f25$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $42beac1ca0ac7f25$export$b61e047ddcc35726 = 'GCP';
const $42beac1ca0ac7f25$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("arA9d", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $2695906d06c1c2e0$export$3fa7b7af96286cc9);

var $1qCUB = parcelRequire("1qCUB");

var $b9JWX = parcelRequire("b9JWX");
function $2695906d06c1c2e0$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = (0, $b9JWX.getRawCookieValue)((0, $1qCUB.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = (0, $b9JWX.getRawCookieValue)((0, $1qCUB.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = (0, $b9JWX.getRawCookieValue)((0, $1qCUB.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("b9JWX", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $459688e15ceabd51$export$aa09aab30a92256c);
function $459688e15ceabd51$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}

});



parcelRegister("bvb28", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $b49ac1613c50d148$export$9186ccba8effc5de);

var $48h13 = parcelRequire("48h13");

var $arA9d = parcelRequire("arA9d");
function $b49ac1613c50d148$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInIC ?? false;
    const atlCtxCookieValues = (0, $arA9d.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $48h13.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("48h13", function(module, exports) {
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $7152f9276d23c8d7$export$d8347b4aae768c2d);

var $1qCUB = parcelRequire("1qCUB");
const $7152f9276d23c8d7$export$d8347b4aae768c2d = [
    (0, $1qCUB.COMMERCIAL)
];

});


parcelRegister("2o9oC", function(module, exports) {
$parcel$export(module.exports, "isolationContextId", () => $ac45d9e44fcc7fc6$export$839b022803d38d4d);

var $arA9d = parcelRequire("arA9d");

var $bvb28 = parcelRequire("bvb28");
function $ac45d9e44fcc7fc6$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return (0, $bvb28.isIsolatedCloud)() ? globalThis.ssrContext?.icName : undefined;
    const atlCtxCookieValues = (0, $arA9d.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}

});

parcelRegister("aO8rL", function(module, exports) {
$parcel$export(module.exports, "isGoogleCloudPlatform", () => $bd6cb796aaa7773f$export$d62bd105df52518a);

var $1qCUB = parcelRequire("1qCUB");

var $b9JWX = parcelRequire("b9JWX");
function $bd6cb796aaa7773f$export$d62bd105df52518a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInGCP ?? false;
    try {
        const cookies = globalThis.document.cookie;
        const cloudServiceProvider = (0, $b9JWX.getRawCookieValue)((0, $1qCUB.BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER), cookies);
        return cloudServiceProvider === (0, $1qCUB.CLOUD_SERVICE_PROVIDER_GCP);
    } catch (e) {
        return false;
    }
}

});

parcelRegister("7K1MF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GOOGLE_CLOUD_PLATFORM_KEY = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $gKQg9 = parcelRequire("gKQg9");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $gKQg9.isEnvironmentBlockEnabledForBoundary;
    }
});

var $gKQg9 = parcelRequire("gKQg9");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $gKQg9.isFeatureEnabledForBoundary;
    }
});

var $gKQg9 = parcelRequire("gKQg9");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $gKQg9.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $lCzhw = parcelRequire("lCzhw");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $lCzhw.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $lCzhw.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $lCzhw.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $lCzhw.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $lCzhw.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "GOOGLE_CLOUD_PLATFORM_KEY", {
    enumerable: true,
    get: function() {
        return $lCzhw.GOOGLE_CLOUD_PLATFORM_KEY;
    }
});

});
parcelRegister("gKQg9", function(module, exports) {
"use strict";
var $c3297ae3c777452c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $c3297ae3c777452c$var$sdk_data_json_1 = $c3297ae3c777452c$var$__importDefault((parcelRequire("6PkCV")));
const $c3297ae3c777452c$var$aemEnvironmentBlockData = $c3297ae3c777452c$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $c3297ae3c777452c$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($c3297ae3c777452c$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $c3297ae3c777452c$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $c3297ae3c777452c$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $c3297ae3c777452c$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $c3297ae3c777452c$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $c3297ae3c777452c$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $c3297ae3c777452c$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($c3297ae3c777452c$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $c3297ae3c777452c$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$c3297ae3c777452c$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $c3297ae3c777452c$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $c3297ae3c777452c$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $c3297ae3c777452c$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$c3297ae3c777452c$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $c3297ae3c777452c$var$getFeatureAvailabilityMetadataForBoundary;
function $c3297ae3c777452c$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $c3297ae3c777452c$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$c3297ae3c777452c$var$toofferingShortKeyId(boundaryKey)] === true;
}

});
parcelRegister("6PkCV", function(module, exports) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"cc\":\"commercial-cloud\",\"gcp\":\"google-cloud-platform\",\"ic\":\"isolated-cloud-commercial\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-api-token-and-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"adminhub-api-token-controls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-atlassian-guard-standard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-billing-preview\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-byok\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-disaster-recovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-findings\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-footprint\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-local-transcript-upload\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-login-customisation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-portfolio-insights\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-saml-sso\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-sdp-policy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-searchbar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-security-checklist\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-site-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-team-site-assignment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"assets-data-manager-client-tools-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"assets-data-manager-ui\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"assets-data-manager\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"assets-iris\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"assets-recent-items\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"assets-reports\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"assets-rovo-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"assets-service-registry\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"assets-software-catalog\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-assets\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"bitbucket-development-events-and-status\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-merge-queue\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-slack-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-ssh-key-validation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"pipelines\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"chat\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"confluence-anonymous-access\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-canvas-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"confluence-canvas-relay\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-content-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-create-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"confluence-editing-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-edition-awareness\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-editor-offline-storage\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-embedded-pages\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-legacy-collaborative-editor\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"confluence-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-page-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-page-tree\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-premium-onboarding\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-presenter-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-questions-native-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-recap\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-remix\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-single-space-guests\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-view-page\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-whiteboards-browser-network-compatibility-check\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"confluence-whiteboards\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"core-confluence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"moved-to-monolith-awaiting-deprecation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"customer-service-management-ai-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"dx\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"feedback\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"focus\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"asks-and-planning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"goals\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"guard-premium-atlassian-guard-premium-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"guard-premium-full-site-security-scanning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"home\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"basic-home-experience\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":true}},\"home-cross-app-create\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-dashboard-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"home-ms-teams-and-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-rerouting-services\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"home-where-you-work\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"jira\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"issue-transition-customisation-for-srb\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jcma-x2c\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jcma\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-ai-issue-classification\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-ai-planner\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-ai-snippet\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-development-hub\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-issue-centric-deployments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-lead-time-for-changes-dxe\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-figma-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-github-workflows\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-global-issue-create-smart-fields\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-goals-nav\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-individual-capacity-planning\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-invite-people\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-jinx-blue-green-jql-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-planned-deprecated-jira-services\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-plans\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-project\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-quickstart-pages\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-search-investigation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"jira-share\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-smart-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-space-dashboard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-spreadsheets-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-synced-blocks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"modern-issue-transition-connect-app-fields\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"jira-align\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"jira-service-management-help-center\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-ai-core-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-ai-ops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-approvals\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-assets-vertical\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"jsm-automation-playbook\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-canned-responses\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-case-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-jira-event-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-chat-ops-ic-custom-apps\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-slack-and-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-chat\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-cloud-megatron\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-customer-account-directory\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-deprecated-incident-timeline\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-halp-admin-panel\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-help-center-change-password\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-help-center-password-login\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-sign-up\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-hr-employee-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-conference-calls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-issue\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-lightweight-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-live-chat\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-multi-language-support\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-ops-gatekeeper\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-conference-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-project-creation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-request-type-template\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-sidebar-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-solution-composer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-support-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jsm-workforce-management-and-smart-routing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-workforce\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-automation-actions\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-bitbucket-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-internal-ops\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"opsgenie-onboarding\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-postmortem\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-url-shortener\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-web-apps\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"loom-ai-evaluation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-agent-playground\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-ai-app-availability\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-browser-extension-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-chat-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"rovo-dev-agents\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"statuspage\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"teams-directory-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"teams-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"unified-profile\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"trello\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"trello-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ai-safety\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"anti-abuse-classification\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"file-scanner-content-moderation-api\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{}},\"atlassian-new-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-analytics-chart-export\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-rovo-skills\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"core-atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}}}},\"automation-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"admin-experience-connector\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-barrel-next-gen\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-barrel\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-network-and-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"automation-platform-actions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"automation-platform-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-sieve\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-provisioner\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-automation-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"central-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"agentic-runtime-session-execution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"ai-3p-connections\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"ai-3p-lifecycle\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"ai-3p-permissions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"alta\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"convo-ai-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"convo-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"gen-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai-tecton\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"knowledge-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform-supporting-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-chat-send-message\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-chat-ui\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"cloud-to-data-center-connection-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"code-assist\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"userbase-merge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"commerce-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"core-commerce-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"orcs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"org-policy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"druid\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"link-paste-anonymization\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"plato-data-lake-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"plato-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"socrates-demux\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"starrocks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"customer-facing-observability\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"aggregated-support-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"ecosystem-forge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"dac-get-help-widget\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"developer-atlassian-community\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"docs-atlassian-com\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"ecosystem-oauth\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"ecosystem-outbound-auth-flow\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"expression-playground\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"forge-ac-checker-fedramp\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-ac-checker\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"forge-app-client-events\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-apps-bff\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"forge-cli\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"forge-developer-console\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-entity-storage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-mcp-server\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"forge-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-remote-capabilities\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-runtime-logs-api\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-sql-storage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"forge-storage-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"ui-extensibility\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"export-control-compliance\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"auto-provisioning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"bxp-signup\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"cross-flow\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"feedback-collection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"growth-content-generation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"growth-unified-profile\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"guard-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cross-domain-attribute-service\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"identity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"authz-consistency-checker\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-identity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-cache\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"identity-core-post-m4\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-deprecated-for-gcp-m5\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"identity-gsuite-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-microsoft-azure-ad-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"identity-mobile-integrity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-userbase-merge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-virality\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"suspicious-login-blocking\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"learning-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"marketplace\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"marketplace-amkt-fe-server\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"marketplace-app-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ai-powered-migration-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"app-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"brie\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"c2c-middleware-assistant\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"continuous-import-export-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"core-migrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"dare-app-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"data-center-to-cloud-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"external-data-sync\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"file-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"lio-synthetic-consumer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"media-migration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"migration-admin-ui\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"sandbox-promotion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"monolith-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"units-icons\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"post-office-rml-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"external-user-directory-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"gitlab-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"google-workspace-apps-integrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"sign-in-with-slack-usage-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"reporting-lines\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-reporting-lines\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"search-identity-dare-isolated\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"search-identity-user-validator\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"user-search-indexing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"xpsearch-forward-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"xpsearch-memory\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"xpsearch-workflows\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-cloud-offering-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"atlassian-third-party-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"core-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"linking-platform-cdn\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"linking-platform-user-preferences\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"smartlinks-datasource-ari-collection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"smartlinks-support-portal-fedramp\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"stakeholder-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"collaboration-graph\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"core-teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"mcp-collaboration-graph\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"usage-based-pricing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{\"core-usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"atlassian-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-secure-sandbox-platform\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-workflow-platform-temporal\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kamino-ingestion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"kamino-portal\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{\"core-batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"browser-remote-update-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"artifact-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"deployment-gating\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"deployments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kitt-source-control\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"racs-refapp-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"racs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"secrets\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"change-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"change-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"experimentation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"feature-flag\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"flag-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"cloud-governance-and-inventory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-cell-provisioning\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"cloud-telemetry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"compliance-posture-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"configuration-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"config-registry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"consent-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"core-network-automation-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-network\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"fedramp-network\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"core-network-automation-telemetry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cna-theia\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"cna-theid\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"cpg-federal\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"data-policy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"icg-commercial\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"icg-ic\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-data-lake-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-center-diagnostics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"eureka-cdp\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"phoenix-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"queuing-platform\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"streamhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"streaming-processing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"streaming-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"topic-osb\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"emperor-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"hydra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"pii-mapper\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"postgres-telemetry-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"telemetry-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"detection-and-response-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"region-failover-orchestration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"edge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"edge-diagnostics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"edge-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"edge-sliver-refapp-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"envoy-partitions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cryptor-ref-client\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"cryptor\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kms-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"environment-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"em-l3-astra-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"error-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"sentry-opsgenie-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"event-demux\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"flight-deck-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"gasv3\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"analytics-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"gasv3-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"golden-ami\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"rapid-investigation-framework\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"internal-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"airlock-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlaskube\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"customer-data-plane-pc-archetypes\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}},\"kitt-fleet-platform-infra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"kitt-fleet\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"logging-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"management-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"media-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"metrics-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"network-extension-routing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"observability-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"opensearch\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{}},\"per-tenant-loop\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"performance-testing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"public-backend-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-public-backend-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"heimdall-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"hofund-platform-tester\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"relational-database-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"homa\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"postgresql\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"test-product\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"release-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"release-tracks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"wiremock\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"security-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"service-authentication\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"identity-provider\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"poco\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"rollcall\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"slauth\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"service-mesh\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"sp-ref-kitt-consumer-archetype\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"sp-ref-kitt-provider\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"shard-and-cell-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cell-routing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"raptor-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"shard-lifecycle-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"slauth-auth-slack-notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-directory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-governance\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"static-app-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cookie-reference-app\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"ssr-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"static-app-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"statsig\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-statsig-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"targeting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"tdp-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tdp-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"telemetry-processing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"alkemia-engine\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tenant-context\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"tcs-control\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"tcs-ref-client\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"tenant-lifecycle\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"tenant-data-destroyer\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"tenant-passivation-removal\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"testing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"polliwhirl\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"testing-platform-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{}},\"tracing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"vector-database\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"violation-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"volt-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"volt-platform-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"workplace-infra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}}}}");

});


parcelRegister("lCzhw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.GOOGLE_CLOUD_PLATFORM_KEY = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.GOOGLE_CLOUD_PLATFORM_KEY = "google-cloud-platform";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY,
    module.exports.GOOGLE_CLOUD_PLATFORM_KEY
];
var $fbd883c5f2a7626c$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($fbd883c5f2a7626c$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $fbd883c5f2a7626c$var$UnderAuditPhase = {}));

});


parcelRegister("17jnY", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $0d057b7705451d4f$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $0d057b7705451d4f$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $0d057b7705451d4f$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $0d057b7705451d4f$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $0d057b7705451d4f$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$0d057b7705451d4f$var$isBrowserEnvironment()) return null;
    const map = $0d057b7705451d4f$var$getOverridesMap();
    const key = $0d057b7705451d4f$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $0d057b7705451d4f$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $0d057b7705451d4f$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$0d057b7705451d4f$var$isBrowserEnvironment()) return;
    const map = $0d057b7705451d4f$var$getOverridesMap();
    map[$0d057b7705451d4f$var$buildKey(environmentBlockName, featureName)] = value;
    $0d057b7705451d4f$var$setOverridesMap(map);
}
module.exports.overrideFeature = $0d057b7705451d4f$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $0d057b7705451d4f$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$0d057b7705451d4f$var$isBrowserEnvironment()) return;
    const map = $0d057b7705451d4f$var$getOverridesMap();
    delete map[$0d057b7705451d4f$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $0d057b7705451d4f$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $0d057b7705451d4f$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $0d057b7705451d4f$var$clearAllOverrides() {
    if (!$0d057b7705451d4f$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $0d057b7705451d4f$var$clearAllOverrides;

});

parcelRegister("khCKG", function(module, exports) {

var $kUjzi = parcelRequire("kUjzi");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $ec437487d6b4d271$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $kUjzi !== "undefined" && $kUjzi && $kUjzi.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $ec437487d6b4d271$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $ec437487d6b4d271$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.") || host.endsWith(".atlassian-stg-fedm.net") || host.endsWith(".atlassian-stg-fedm.com")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $ec437487d6b4d271$var$getEnvironmentType;

});



parcelRegister("4nP55", function(module, exports) {
$parcel$export(module.exports, "ADMINHUB", () => $adba6285acb6f8c4$export$3dd1f603beda3f87);
$parcel$export(module.exports, "ADMINHUB_ACCESS_REQUESTS", () => $adba6285acb6f8c4$export$382b986cdad7dc9f);
$parcel$export(module.exports, "ADMINHUB_ADD_PRODUCT", () => $adba6285acb6f8c4$export$b6b6bb39e2ac581a);
$parcel$export(module.exports, "ADMINHUB_ADMIN_INSIGHTS", () => $adba6285acb6f8c4$export$ab4f414d9a316a3f);
$parcel$export(module.exports, "ADMINHUB_AI_ENABLED_APPS", () => $adba6285acb6f8c4$export$fc066f4bccd328c0);
$parcel$export(module.exports, "ADMINHUB_API_TOKEN_CONTROLS", () => $adba6285acb6f8c4$export$8bfae94a3804ecb3);
$parcel$export(module.exports, "ADMINHUB_APP_REQUESTS", () => $adba6285acb6f8c4$export$e6e1bd77260fadbd);
$parcel$export(module.exports, "ADMINHUB_APP_UPDATES", () => $adba6285acb6f8c4$export$977c4efbf15e7247);
$parcel$export(module.exports, "ADMINHUB_APPLICATION_TUNNELS", () => $adba6285acb6f8c4$export$eff29abf2160997b);
$parcel$export(module.exports, "ADMINHUB_ATLASSIAN_INTELLIGENCE", () => $adba6285acb6f8c4$export$8d04439d0796e44);
$parcel$export(module.exports, "ADMINHUB_AUDIT_LOG", () => $adba6285acb6f8c4$export$56f29aff19fb9c96);
$parcel$export(module.exports, "ADMINHUB_AUTHENTICATION_POLICIES", () => $adba6285acb6f8c4$export$b93b430602bf644);
$parcel$export(module.exports, "ADMINHUB_AUTOMATIONS", () => $adba6285acb6f8c4$export$32736263f8f7fd56);
$parcel$export(module.exports, "ADMINHUB_BACKUP_AND_RESTORE", () => $adba6285acb6f8c4$export$76a46b249d1c1da9);
$parcel$export(module.exports, "ADMINHUB_BILLING_CONSOLE", () => $adba6285acb6f8c4$export$7e28dbacc98edce4);
$parcel$export(module.exports, "ADMINHUB_BILLING_PREVIEW", () => $adba6285acb6f8c4$export$4f90e4185f23544e);
$parcel$export(module.exports, "ADMINHUB_CODE_INTELLIGENCE", () => $adba6285acb6f8c4$export$dee07b680e10331e);
$parcel$export(module.exports, "ADMINHUB_CONNECTED_EMOJI", () => $adba6285acb6f8c4$export$91f24716d52f1f8b);
$parcel$export(module.exports, "ADMINHUB_CONNECTED_SOURCES", () => $adba6285acb6f8c4$export$587d6059d4e1b932);
$parcel$export(module.exports, "ADMINHUB_CONNECTOR_PROTECTION", () => $adba6285acb6f8c4$export$c1e621744855eb90);
$parcel$export(module.exports, "ADMINHUB_CONTACTS", () => $adba6285acb6f8c4$export$25101a6038ee350b);
$parcel$export(module.exports, "ADMINHUB_CUSTOM_DOMAIN_EMAIL_NOTIFICATION", () => $adba6285acb6f8c4$export$74fd8b1f5f30407c);
$parcel$export(module.exports, "ADMINHUB_CUSTOM_DOMAINS", () => $adba6285acb6f8c4$export$52239572762b3aa9);
$parcel$export(module.exports, "ADMINHUB_DATA_RESIDENCY", () => $adba6285acb6f8c4$export$70d6c21f42406b5b);
$parcel$export(module.exports, "ADMINHUB_DATA_TRANSFER", () => $adba6285acb6f8c4$export$246642b411dabb23);
$parcel$export(module.exports, "ADMINHUB_DELTA_MIGRATIONS", () => $adba6285acb6f8c4$export$99d442334ae1fabb);
$parcel$export(module.exports, "ADMINHUB_DISASTER_RECOVERY", () => $adba6285acb6f8c4$export$2f493a13f73e0e00);
$parcel$export(module.exports, "ADMINHUB_DISCOVER_APPS_SHADOW_IT", () => $adba6285acb6f8c4$export$3664f6e049b7819e);
$parcel$export(module.exports, "ADMINHUB_DISCOVER_NEW_PRODUCTS", () => $adba6285acb6f8c4$export$d697ebd75d794a2b);
$parcel$export(module.exports, "ADMINHUB_ENABLE_USER_MERGE", () => $adba6285acb6f8c4$export$4d8f5bc4a1d69f84);
$parcel$export(module.exports, "ADMINHUB_ENCRYPTION", () => $adba6285acb6f8c4$export$bd485a8ba26f6110);
$parcel$export(module.exports, "ADMINHUB_ENVIRONMENTS", () => $adba6285acb6f8c4$export$ed8aaefe9f16bd79);
$parcel$export(module.exports, "ADMINHUB_EXPERIMENT_CONTROLS", () => $adba6285acb6f8c4$export$ef745c2fe499facc);
$parcel$export(module.exports, "ADMINHUB_EXTERNAL_USER_SECURITY", () => $adba6285acb6f8c4$export$c9e4bf0ce98ed454);
$parcel$export(module.exports, "ADMINHUB_FINDINGS", () => $adba6285acb6f8c4$export$87ef10192359ea0f);
$parcel$export(module.exports, "ADMINHUB_FOOTPRINT", () => $adba6285acb6f8c4$export$65aac8f5f81cec09);
$parcel$export(module.exports, "ADMINHUB_FREEZE_WINDOWS", () => $adba6285acb6f8c4$export$de35d8f99bdedf98);
$parcel$export(module.exports, "ADMINHUB_HIPAA_COMPLIANCE", () => $adba6285acb6f8c4$export$7a54f371799cdbc);
$parcel$export(module.exports, "ADMINHUB_JSM_SCIM", () => $adba6285acb6f8c4$export$ce6d30031498d984);
$parcel$export(module.exports, "ADMINHUB_LINK_BITBUCKET", () => $adba6285acb6f8c4$export$b2d968d65055d8e4);
$parcel$export(module.exports, "ADMINHUB_LLM", () => $adba6285acb6f8c4$export$1f5fbd31dd0c60c7);
$parcel$export(module.exports, "ADMINHUB_LOCAL_TRANSCRIPT_UPLOAD", () => $adba6285acb6f8c4$export$4ac660fdfba418);
$parcel$export(module.exports, "ADMINHUB_LOGIN_CUSTOMISATION", () => $adba6285acb6f8c4$export$7c2c5fa21419b16d);
$parcel$export(module.exports, "ADMINHUB_MANAGED_ACCOUNTS_EXPORT", () => $adba6285acb6f8c4$export$72ac34d64f60a029);
$parcel$export(module.exports, "ADMINHUB_MARKETPLACE_APPS", () => $adba6285acb6f8c4$export$baa4d73f3a7a03a7);
$parcel$export(module.exports, "ADMINHUB_MOBILE_APP_POLICY", () => $adba6285acb6f8c4$export$303916639468e7b1);
$parcel$export(module.exports, "ADMINHUB_ORG_CREATE", () => $adba6285acb6f8c4$export$b1f7c72de07bfe17);
$parcel$export(module.exports, "ADMINHUB_ORG_DELETION", () => $adba6285acb6f8c4$export$23929eaa2806614b);
$parcel$export(module.exports, "ADMINHUB_PERFORMANCE_MONITORING", () => $adba6285acb6f8c4$export$24e2ce273f9991bc);
$parcel$export(module.exports, "ADMINHUB_PLATFORM_USAGE", () => $adba6285acb6f8c4$export$17492477531fbab6);
$parcel$export(module.exports, "ADMINHUB_POLICIES", () => $adba6285acb6f8c4$export$bbed3ce655eee571);
$parcel$export(module.exports, "ADMINHUB_PRODUCT_INSIGHTS", () => $adba6285acb6f8c4$export$ee496550426c523e);
$parcel$export(module.exports, "ADMINHUB_PRODUCT_LINKS", () => $adba6285acb6f8c4$export$97dda98051f11fa);
$parcel$export(module.exports, "ADMINHUB_PRODUCT_RECOMMENDATION", () => $adba6285acb6f8c4$export$28332e31e14f3f06);
$parcel$export(module.exports, "ADMINHUB_PRODUCT_URLS", () => $adba6285acb6f8c4$export$abeda268b2df1677);
$parcel$export(module.exports, "ADMINHUB_RELEASE_TRACKS", () => $adba6285acb6f8c4$export$aec116c107feb8ce);
$parcel$export(module.exports, "ADMINHUB_REVAMPED_ORGANIZATION_OVERVIEW", () => $adba6285acb6f8c4$export$f36300e6fa5d5a3d);
$parcel$export(module.exports, "ADMINHUB_ROVO_ACCESS", () => $adba6285acb6f8c4$export$7581e7b563f5b080);
$parcel$export(module.exports, "ADMINHUB_ROVO_CHAT_PROTECTION", () => $adba6285acb6f8c4$export$affa86afcb070f56);
$parcel$export(module.exports, "ADMINHUB_ROVO_INSIGHTS", () => $adba6285acb6f8c4$export$7e54b8a4db924f9);
$parcel$export(module.exports, "ADMINHUB_ROVO_MCP_SERVER", () => $adba6285acb6f8c4$export$48e9a8f737578cd5);
$parcel$export(module.exports, "ADMINHUB_ROVO_SETTINGS", () => $adba6285acb6f8c4$export$d46157d88a7ed278);
$parcel$export(module.exports, "ADMINHUB_SANDBOX", () => $adba6285acb6f8c4$export$cf35cfd259758efb);
$parcel$export(module.exports, "ADMINHUB_SDP_POLICY", () => $adba6285acb6f8c4$export$1b31fc4b11c64f40);
$parcel$export(module.exports, "ADMINHUB_SECURITY_CHECKLIST", () => $adba6285acb6f8c4$export$914452d44ff907da);
$parcel$export(module.exports, "ADMINHUB_SIGNUP", () => $adba6285acb6f8c4$export$7adf222fc89d47e5);
$parcel$export(module.exports, "ADMINHUB_SITE_RENAME", () => $adba6285acb6f8c4$export$61c84c7218095444);
$parcel$export(module.exports, "ADMINHUB_SITE_TRANSFER", () => $adba6285acb6f8c4$export$7d0af474d439f3a1);
$parcel$export(module.exports, "ADMINHUB_SYSTEM_HEALTH", () => $adba6285acb6f8c4$export$ac3efa5d355979c9);
$parcel$export(module.exports, "ADMINHUB_TEAM_SITE_ASSIGNMENT", () => $adba6285acb6f8c4$export$bd4789d802c0d12f);
$parcel$export(module.exports, "ADMINHUB_TEAMS", () => $adba6285acb6f8c4$export$aacaede363d82c5a);
$parcel$export(module.exports, "ADMINHUB_TEAMWORK_GRAPH_CLI", () => $adba6285acb6f8c4$export$45ff40527561f6fb);
$parcel$export(module.exports, "ADMINHUB_UNITS", () => $adba6285acb6f8c4$export$d443b4632dc5f1bb);
$parcel$export(module.exports, "ADMINHUB_USER_ACCESS_INVITES", () => $adba6285acb6f8c4$export$318f68f6dae7de06);
$parcel$export(module.exports, "ADMINHUB_USER_ACCESS_SETTINGS", () => $adba6285acb6f8c4$export$69ac5974370e45ce);
$parcel$export(module.exports, "ADMINHUB_USER_CONNECTED_APPS", () => $adba6285acb6f8c4$export$6368ca96b9b1f5d1);
$parcel$export(module.exports, "ADMINHUB_USER_COUNTS", () => $adba6285acb6f8c4$export$a4aead3075a8f99);
$parcel$export(module.exports, "ADMINHUB_USER_LAST_ACTIVE_TIMESTAMP", () => $adba6285acb6f8c4$export$f7698bcdb4725ee2);
$parcel$export(module.exports, "ADMINHUB_WORKSPACES_TABLE_PLANS", () => $adba6285acb6f8c4$export$3d1ed75135ca0b59);
$parcel$export(module.exports, "isPreProdIsolatedCloud", () => $adba6285acb6f8c4$export$b34089be9fede38c);
$parcel$export(module.exports, "isIsolationContextIn", () => $adba6285acb6f8c4$export$9ef5723f2e88a7e3);
$parcel$export(module.exports, "CUSTOM_DOMAIN_EMAIL_NOTIFICATION_ISOLATION_CONTEXTS", () => $adba6285acb6f8c4$export$73d11c055dc7fa4);

var $2o9oC = parcelRequire("2o9oC");
const $adba6285acb6f8c4$export$3dd1f603beda3f87 = 'adminhub';
const $adba6285acb6f8c4$export$382b986cdad7dc9f = 'adminhub-access-requests';
const $adba6285acb6f8c4$export$b6b6bb39e2ac581a = 'adminhub-add-product';
const $adba6285acb6f8c4$export$ab4f414d9a316a3f = 'adminhub-admin-insights';
const $adba6285acb6f8c4$export$fc066f4bccd328c0 = 'adminhub-ai-enabled-apps';
const $adba6285acb6f8c4$export$8bfae94a3804ecb3 = 'adminhub-api-token-controls';
const $adba6285acb6f8c4$export$e6e1bd77260fadbd = 'adminhub-app-requests';
const $adba6285acb6f8c4$export$977c4efbf15e7247 = 'adminhub-app-updates';
const $adba6285acb6f8c4$export$eff29abf2160997b = 'adminhub-application-tunnels';
const $adba6285acb6f8c4$export$8d04439d0796e44 = 'adminhub-atlassian-intelligence';
const $adba6285acb6f8c4$export$56f29aff19fb9c96 = 'adminhub-audit-log';
const $adba6285acb6f8c4$export$b93b430602bf644 = 'adminhub-authentication-policies';
const $adba6285acb6f8c4$export$32736263f8f7fd56 = 'adminhub-automations';
const $adba6285acb6f8c4$export$76a46b249d1c1da9 = 'adminhub-backup-and-restore';
const $adba6285acb6f8c4$export$7e28dbacc98edce4 = 'adminhub-billing-console';
const $adba6285acb6f8c4$export$4f90e4185f23544e = 'adminhub-billing-preview';
const $adba6285acb6f8c4$export$dee07b680e10331e = 'adminhub-code-intelligence';
const $adba6285acb6f8c4$export$91f24716d52f1f8b = 'adminhub-connected-emoji';
const $adba6285acb6f8c4$export$587d6059d4e1b932 = 'adminhub-connected-sources';
const $adba6285acb6f8c4$export$c1e621744855eb90 = 'adminhub-connector-protection';
const $adba6285acb6f8c4$export$25101a6038ee350b = 'adminhub-contacts';
const $adba6285acb6f8c4$export$74fd8b1f5f30407c = 'adminhub-custom-domain-email-notification';
const $adba6285acb6f8c4$export$52239572762b3aa9 = 'adminhub-custom-domains';
const $adba6285acb6f8c4$export$ef717b19ead9db42 = 'adminhub-data-management';
const $adba6285acb6f8c4$export$70d6c21f42406b5b = 'adminhub-data-residency';
const $adba6285acb6f8c4$export$246642b411dabb23 = 'adminhub-data-transfer';
const $adba6285acb6f8c4$export$99d442334ae1fabb = 'adminhub-delta-migrations';
const $adba6285acb6f8c4$export$2f493a13f73e0e00 = 'adminhub-disaster-recovery';
const $adba6285acb6f8c4$export$3664f6e049b7819e = 'adminhub-discover-apps-shadow-it';
const $adba6285acb6f8c4$export$d697ebd75d794a2b = 'adminhub-discover-new-products';
const $adba6285acb6f8c4$export$4d8f5bc4a1d69f84 = 'adminhub-enable-user-merge';
const $adba6285acb6f8c4$export$bd485a8ba26f6110 = 'adminhub-encryption';
const $adba6285acb6f8c4$export$ed8aaefe9f16bd79 = 'adminhub-environments';
const $adba6285acb6f8c4$export$ef745c2fe499facc = 'adminhub-experiment-controls';
const $adba6285acb6f8c4$export$c9e4bf0ce98ed454 = 'adminhub-external-user-security';
const $adba6285acb6f8c4$export$87ef10192359ea0f = 'adminhub-findings';
const $adba6285acb6f8c4$export$65aac8f5f81cec09 = 'adminhub-footprint';
const $adba6285acb6f8c4$export$de35d8f99bdedf98 = 'adminhub-freeze-windows';
const $adba6285acb6f8c4$export$ed41de86c12da2be = 'adminhub-help';
const $adba6285acb6f8c4$export$7a54f371799cdbc = 'adminhub-hippa-compliance';
const $adba6285acb6f8c4$export$ce6d30031498d984 = 'adminhub-jsm-scim';
const $adba6285acb6f8c4$export$b2d968d65055d8e4 = 'adminhub-link-bitbucket';
const $adba6285acb6f8c4$export$1f5fbd31dd0c60c7 = 'adminhub-llm';
const $adba6285acb6f8c4$export$4ac660fdfba418 = 'adminhub-local-transcript-upload';
const $adba6285acb6f8c4$export$7c2c5fa21419b16d = 'adminhub-login-customisation';
const $adba6285acb6f8c4$export$72ac34d64f60a029 = 'adminhub-managed-accounts-export';
const $adba6285acb6f8c4$export$baa4d73f3a7a03a7 = 'adminhub-marketplace-apps';
const $adba6285acb6f8c4$export$660c7d655cadd376 = 'adminhub-mcp-settings';
const $adba6285acb6f8c4$export$303916639468e7b1 = 'adminhub-mobile-app-policy';
const $adba6285acb6f8c4$export$47e65d4c2cde3a5e = 'adminhub-nested-side-navigation';
const $adba6285acb6f8c4$export$b1f7c72de07bfe17 = 'adminhub-org-create';
const $adba6285acb6f8c4$export$23929eaa2806614b = 'adminhub-org-deletion';
const $adba6285acb6f8c4$export$24e2ce273f9991bc = 'adminhub-performance-monitoring';
const $adba6285acb6f8c4$export$17492477531fbab6 = 'adminhub-platform-usage';
const $adba6285acb6f8c4$export$bbed3ce655eee571 = 'adminhub-policies';
const $adba6285acb6f8c4$export$ee496550426c523e = 'adminhub-product-insights';
const $adba6285acb6f8c4$export$97dda98051f11fa = 'adminhub-product-links';
const $adba6285acb6f8c4$export$28332e31e14f3f06 = 'adminhub-product-recommendation';
const $adba6285acb6f8c4$export$abeda268b2df1677 = 'adminhub-product-urls';
const $adba6285acb6f8c4$export$aec116c107feb8ce = 'adminhub-release-tracks';
const $adba6285acb6f8c4$export$f36300e6fa5d5a3d = 'adminhub-revamped-organization-overview';
const $adba6285acb6f8c4$export$7581e7b563f5b080 = 'adminhub-rovo-access';
const $adba6285acb6f8c4$export$affa86afcb070f56 = 'adminhub-rovo-chat-protection';
const $adba6285acb6f8c4$export$7e54b8a4db924f9 = 'adminhub-rovo-insights';
const $adba6285acb6f8c4$export$48e9a8f737578cd5 = 'adminhub-rovo-mcp-server';
const $adba6285acb6f8c4$export$d46157d88a7ed278 = 'adminhub-rovo-settings';
const $adba6285acb6f8c4$export$cf35cfd259758efb = 'adminhub-sandbox';
const $adba6285acb6f8c4$export$1b31fc4b11c64f40 = 'adminhub-sdp-policy';
const $adba6285acb6f8c4$export$914452d44ff907da = 'adminhub-security-checklist';
const $adba6285acb6f8c4$export$7adf222fc89d47e5 = 'adminhub-signup';
const $adba6285acb6f8c4$export$61c84c7218095444 = 'adminhub-site-rename';
const $adba6285acb6f8c4$export$7d0af474d439f3a1 = 'adminhub-site-transfer';
const $adba6285acb6f8c4$export$ac3efa5d355979c9 = 'adminhub-system-health';
const $adba6285acb6f8c4$export$bd4789d802c0d12f = 'adminhub-team-site-assignment';
const $adba6285acb6f8c4$export$aacaede363d82c5a = 'adminhub-teams';
const $adba6285acb6f8c4$export$45ff40527561f6fb = 'adminhub-teamwork-graph-cli';
const $adba6285acb6f8c4$export$d443b4632dc5f1bb = 'adminhub-units';
const $adba6285acb6f8c4$export$318f68f6dae7de06 = 'adminhub-user-access-invites';
const $adba6285acb6f8c4$export$69ac5974370e45ce = 'adminhub-user-access-settings';
const $adba6285acb6f8c4$export$6368ca96b9b1f5d1 = 'adminhub-user-connected-apps';
const $adba6285acb6f8c4$export$a4aead3075a8f99 = 'adminhub-user-counts';
const $adba6285acb6f8c4$export$f7698bcdb4725ee2 = 'adminhub-user-last-active-timestamp';
const $adba6285acb6f8c4$export$3d1ed75135ca0b59 = 'adminhub-workspaces-table-plans';
function $adba6285acb6f8c4$export$b34089be9fede38c() {
    return (0, $2o9oC.isolationContextId)() === 'ic-dr6';
}
function $adba6285acb6f8c4$export$9ef5723f2e88a7e3(contextIds) {
    const currentContextId = (0, $2o9oC.isolationContextId)();
    return !!currentContextId && contextIds.includes(currentContextId);
}
const $adba6285acb6f8c4$export$73d11c055dc7fa4 = [
    'ic-dr6',
    'ic-em8',
    'ic-9la'
];

});

parcelRegister("1tKKH", function(module, exports) {
$parcel$export(module.exports, "PickLoader", () => $008b7bfff013c761$export$6fc47b2f8011876c);
$parcel$export(module.exports, "PickPageLoader", () => $008b7bfff013c761$export$5a9270c3e43b1ab9);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $j0x4s = parcelRequire("j0x4s");

var $gT0mJ = parcelRequire("gT0mJ");
var $4C3il = parcelRequire("4C3il");

var $6s1Je = parcelRequire("6s1Je");
const $008b7bfff013c761$var$peformanceMark = "\uD83D\uDE9B\uD83E\uDD1A pick loader";
function $008b7bfff013c761$export$6fc47b2f8011876c(importer, pick, options = {}) {
    let firstInvocationTime = 0;
    let firstRenderTime = 0;
    const LoadableComponent = (0, $4C3il.withAnalyticsClient)((0, (/*@__PURE__*/$parcel$interopDefault($j0x4s)))({
        loader: importer,
        loading: (0, $6s1Je.PageLoading),
        ...options,
        render (lib, { analyticsClient: analyticsClient, ...props }) {
            const Component = pick(lib);
            if (!firstRenderTime) {
                firstRenderTime = Date.now();
                const duration = firstRenderTime - firstInvocationTime;
                // eslint-disable-next-line no-console
                console.timeEnd($008b7bfff013c761$var$peformanceMark);
                // send analytics event
                analyticsClient.sendOperationalEvent({
                    data: {
                        action: (0, $gT0mJ.OperationalAction).Triggered,
                        actionSubject: (0, $gT0mJ.OperationalSubject).PickLoader,
                        actionSubjectId: 'pick-loader',
                        source: 'loader',
                        attributes: {
                            duration: duration
                        }
                    }
                });
            }
            return /*#__PURE__*/ (0, $kOwiQ.jsx)(Component, {
                ...props
            });
        }
    }));
    const loader = (props)=>{
        if (!firstInvocationTime) {
            firstInvocationTime = Date.now();
            // eslint-disable-next-line no-console
            console.time($008b7bfff013c761$var$peformanceMark);
        }
        return /*#__PURE__*/ (0, $kOwiQ.jsx)(LoadableComponent, {
            ...props
        });
    };
    loader.preload = importer;
    return loader;
}
function $008b7bfff013c761$export$5a9270c3e43b1ab9(importer, pick) {
    return $008b7bfff013c761$export$6fc47b2f8011876c(importer, pick, {
        loading: (0, $6s1Je.FullPageLoading)
    });
}

});
parcelRegister("kOwiQ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("esvxF"));

});
parcelRegister("esvxF", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $02b76bf6f37cd94d$export$ffb0004e005737fa, (v) => $02b76bf6f37cd94d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $02b76bf6f37cd94d$export$34b9dba7ce09269b, (v) => $02b76bf6f37cd94d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $02b76bf6f37cd94d$export$25062201e9e25d76, (v) => $02b76bf6f37cd94d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $02b76bf6f37cd94d$export$ffb0004e005737fa;
var $02b76bf6f37cd94d$export$34b9dba7ce09269b;
var $02b76bf6f37cd94d$export$25062201e9e25d76;
'use strict';

var $lE8gv = parcelRequire("lE8gv");
var $02b76bf6f37cd94d$var$k = Symbol.for("react.element"), $02b76bf6f37cd94d$var$l = Symbol.for("react.fragment"), $02b76bf6f37cd94d$var$m = Object.prototype.hasOwnProperty, $02b76bf6f37cd94d$var$n = $lE8gv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $02b76bf6f37cd94d$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $02b76bf6f37cd94d$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$02b76bf6f37cd94d$var$m.call(a, b) && !$02b76bf6f37cd94d$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $02b76bf6f37cd94d$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $02b76bf6f37cd94d$var$n.current
    };
}
$02b76bf6f37cd94d$export$ffb0004e005737fa = $02b76bf6f37cd94d$var$l;
$02b76bf6f37cd94d$export$34b9dba7ce09269b = $02b76bf6f37cd94d$var$q;
$02b76bf6f37cd94d$export$25062201e9e25d76 = $02b76bf6f37cd94d$var$q;

});


parcelRegister("j0x4s", function(module, exports) {
"use strict";
var $dd67ab9585b84a69$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $dd67ab9585b84a69$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dd67ab9585b84a69$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $dd67ab9585b84a69$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $lE8gv = parcelRequire("lE8gv");

var $dzGx9 = parcelRequire("dzGx9");
var $dd67ab9585b84a69$var$ALL_INITIALIZERS = [];
var $dd67ab9585b84a69$var$READY_INITIALIZERS = [];
function $dd67ab9585b84a69$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $dd67ab9585b84a69$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $dd67ab9585b84a69$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $dd67ab9585b84a69$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $dd67ab9585b84a69$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $dd67ab9585b84a69$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $dd67ab9585b84a69$var$render(loaded, props) {
    return $lE8gv.createElement($dd67ab9585b84a69$var$resolve(loaded), props);
}
function $dd67ab9585b84a69$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $dd67ab9585b84a69$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $dd67ab9585b84a69$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $dd67ab9585b84a69$var$READY_INITIALIZERS.push(function() {
        if ($dd67ab9585b84a69$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $dd67ab9585b84a69$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $dd67ab9585b84a69$var$_classCallCheck(this, LoadableComponent);
            var _this = $dd67ab9585b84a69$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        // renamed from componentWillMount See https://fb.me/react-unsafe-component-lifecycles
        LoadableComponent.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $lE8gv.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($lE8gv.Component), _class.contextTypes = {
        loadable: $dzGx9.shape({
            report: $dzGx9.func.isRequired
        })
    }, _temp;
}
function $dd67ab9585b84a69$var$Loadable(opts) {
    return $dd67ab9585b84a69$var$createLoadableComponent($dd67ab9585b84a69$var$load, opts);
}
function $dd67ab9585b84a69$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $dd67ab9585b84a69$var$createLoadableComponent($dd67ab9585b84a69$var$loadMap, opts);
}
$dd67ab9585b84a69$var$Loadable.Map = $dd67ab9585b84a69$var$LoadableMap;
var $dd67ab9585b84a69$var$Capture = function(_React$Component2) {
    $dd67ab9585b84a69$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $dd67ab9585b84a69$var$_classCallCheck(this, Capture);
        return $dd67ab9585b84a69$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $lE8gv.Children.only(this.props.children);
    };
    return Capture;
}($lE8gv.Component);
$dd67ab9585b84a69$var$Capture.propTypes = {
    report: $dzGx9.func.isRequired
};
$dd67ab9585b84a69$var$Capture.childContextTypes = {
    loadable: $dzGx9.shape({
        report: $dzGx9.func.isRequired
    }).isRequired
};
$dd67ab9585b84a69$var$Loadable.Capture = $dd67ab9585b84a69$var$Capture;
function $dd67ab9585b84a69$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $dd67ab9585b84a69$var$flushInitializers(initializers);
    });
}
$dd67ab9585b84a69$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $dd67ab9585b84a69$var$flushInitializers($dd67ab9585b84a69$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$dd67ab9585b84a69$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $dd67ab9585b84a69$var$flushInitializers($dd67ab9585b84a69$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $dd67ab9585b84a69$var$Loadable;

});
parcelRegister("dzGx9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9e1f8993e76ac721$var$ReactIs, $9e1f8993e76ac721$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("fDJRo"))();

});
parcelRegister("fDJRo", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $Q0p0P = parcelRequire("Q0p0P");
function $b62e126d7a838ac8$var$emptyFunction() {}
function $b62e126d7a838ac8$var$emptyFunctionWithReset() {}
$b62e126d7a838ac8$var$emptyFunctionWithReset.resetWarningCache = $b62e126d7a838ac8$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $Q0p0P) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $b62e126d7a838ac8$var$emptyFunctionWithReset,
        resetWarningCache: $b62e126d7a838ac8$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("Q0p0P", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $09c52b5b69898741$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $09c52b5b69898741$var$ReactPropTypesSecret;

});




parcelRegister("gT0mJ", function(module, exports) {
$parcel$export(module.exports, "Action", () => $156ec9a2f3d8f0c2$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "TrackAction", () => $156ec9a2f3d8f0c2$export$c455e5af75ef0346);
$parcel$export(module.exports, "ActionSubject", () => $156ec9a2f3d8f0c2$export$7f97440769de1377);
$parcel$export(module.exports, "TrackActionSubject", () => $156ec9a2f3d8f0c2$export$5b6897e82598b599);
$parcel$export(module.exports, "Source", () => $156ec9a2f3d8f0c2$export$1d2df86270c81ecb);
$parcel$export(module.exports, "OperationalAction", () => $156ec9a2f3d8f0c2$export$be7aa9bbc93021ef);
$parcel$export(module.exports, "OperationalSubject", () => $156ec9a2f3d8f0c2$export$a95ec09d18401fbe);
$parcel$export(module.exports, "CapabilitySubject", () => $156ec9a2f3d8f0c2$export$ea60622c812e6739);
// past tense verbs describing the action
var $156ec9a2f3d8f0c2$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["Cancelled"] = "cancelled";
    Action["Clicked"] = "clicked";
    Action["Submitted"] = "submitted";
    Action["Closed"] = "closed";
    Action["Typed"] = "typed";
    Action["Searched"] = "searched";
    Action["Created"] = "created";
    Action["Updated"] = "updated";
    Action["Deleted"] = "deleted";
    Action["Invited"] = "invited";
    Action["Selected"] = "selected";
    Action["Focused"] = "focused";
    Action["Blurred"] = "blurred";
    Action["Viewed"] = "viewed";
    Action["Shown"] = "shown";
    Action["Displayed"] = "displayed";
    Action["Hidden"] = "hidden";
    Action["Hovered"] = "hovered";
    Action["Entered"] = "entered";
    Action["Switched"] = "switched";
    Action["Dwelled"] = "dwelled";
    Action["Toggled"] = "toggled";
    Action["Pressed"] = "pressed";
    Action["Pasted"] = "pasted";
    Action["Copy"] = "copy";
    Action["Changed"] = "changed";
    Action["Fetch"] = "fetch";
    Action["Fetched"] = "fetched";
    Action["Cleared"] = "cleared";
    Action["Opened"] = "opened";
    Action["Scrolled"] = "scrolled";
    Action["Moved"] = "moved";
    return Action;
}({});
var $156ec9a2f3d8f0c2$export$c455e5af75ef0346 = /*#__PURE__*/ function(TrackAction) {
    TrackAction["Clicked"] = "clicked";
    TrackAction["Canceled"] = "canceled";
    TrackAction["BackClicked"] = "backClicked";
    TrackAction["Closed"] = "closed";
    TrackAction["ConnectionFailed"] = "connectionFailed";
    TrackAction["ConnectionSuccess"] = "connectionSuccess";
    TrackAction["Created"] = "created";
    TrackAction["CreationFailed"] = "creationFailed";
    TrackAction["Edited"] = "edited";
    TrackAction["EditFailed"] = "editFailed";
    TrackAction["Updated"] = "updated";
    TrackAction["Activated"] = "activated";
    TrackAction["Linked"] = "linked";
    TrackAction["DefaultGroupUpdated"] = "defaultGroupUpdated";
    TrackAction["Added"] = "added";
    TrackAction["Deactivated"] = "deactivated";
    TrackAction["Deleted"] = "deleted";
    TrackAction["Dismissed"] = "dismissed";
    TrackAction["SetTrait"] = "setTrait";
    TrackAction["Duplicated"] = "duplicated";
    TrackAction["CanceledDeletion"] = "canceledDeletion";
    TrackAction["Changed"] = "changed";
    TrackAction["ChangeFailed"] = "changeFailed";
    TrackAction["Submitted"] = "submitted";
    TrackAction["Approved"] = "approved";
    TrackAction["Denied"] = "denied";
    TrackAction["Invited"] = "invited";
    TrackAction["InvitedGuest"] = "invitedGuest";
    TrackAction["Reset"] = "reset";
    TrackAction["Resent"] = "resent";
    TrackAction["ResumeDismissed"] = "resumeDismissed";
    TrackAction["Impersonated"] = "impersonated";
    TrackAction["Imported"] = "imported";
    TrackAction["KeyRegenerated"] = "keyRegenerated";
    TrackAction["Regenerated"] = "regenerated";
    TrackAction["ChangedProductAccess"] = "changedProductAccess";
    TrackAction["Toggled"] = "toggled";
    TrackAction["Granted"] = "granted";
    TrackAction["GrantedProductAccess"] = "grantedProductAccess";
    TrackAction["Revoked"] = "revoked";
    TrackAction["RevokedProductAccess"] = "revokedProductAccess";
    TrackAction["Saved"] = "saved";
    TrackAction["Sent"] = "sent";
    TrackAction["AddedToGroup"] = "addedToGroup";
    TrackAction["AddedUsers"] = "addedUsers";
    TrackAction["Exposed"] = "exposed";
    TrackAction["Downloaded"] = "downloaded";
    TrackAction["Migrated"] = "migrated";
    TrackAction["BulkMigrated"] = "bulkMigrated";
    TrackAction["BulkSelectionLimit"] = "bulkSelectionLimit";
    TrackAction["BulkDeleted"] = "bulkDeleted";
    TrackAction["Verified"] = "verified";
    TrackAction["Claimed"] = "claimed";
    TrackAction["Unclaimed"] = "unclaimed";
    TrackAction["Mismatched"] = "mismatched";
    TrackAction["Connected"] = "connected";
    TrackAction["Selected"] = "selected";
    TrackAction["SyncStarted"] = "syncStarted";
    TrackAction["SyncFinished"] = "syncFinished";
    TrackAction["Synced"] = "synced";
    TrackAction["GroupsUpdated"] = "groupsUpdated";
    TrackAction["Disconnected"] = "disconnected";
    TrackAction["Enabled"] = "enabled";
    TrackAction["Disabled"] = "disabled";
    TrackAction["SettingsUpdated"] = "settingsUpdated";
    TrackAction["Exported"] = "exported";
    TrackAction["ExportFailed"] = "exportFailed";
    TrackAction["ClonedData"] = "clonedData";
    TrackAction["ClonedSelectiveData"] = "clonedSelectiveData";
    TrackAction["Completed"] = "completed";
    TrackAction["Converted"] = "converted";
    TrackAction["Reached"] = "reached";
    TrackAction["RemoveMember"] = "removeMember";
    TrackAction["RemoveFromOrg"] = "removedFromOrg";
    TrackAction["PromptPassword"] = "promptedResetPassword";
    TrackAction["PasswordReset"] = "passwordReset";
    TrackAction["DescriptionUpdated"] = "descriptionUpdated";
    TrackAction["RemoveProduct"] = "removeProduct";
    TrackAction["AddProduct"] = "addProduct";
    TrackAction["AddProductFailed"] = "addProductFailed";
    TrackAction["Restored"] = "restored";
    TrackAction["RemovedDomain"] = "removedDomain";
    TrackAction["Removed"] = "removed";
    TrackAction["Reactivated"] = "reactivated";
    TrackAction["Subscribed"] = "subscribed";
    TrackAction["Unsubscribed"] = "unsubscribed";
    TrackAction["UsersUpdated"] = "usersUpdated";
    TrackAction["Started"] = "started";
    TrackAction["Searched"] = "searched";
    TrackAction["SessionReset"] = "sessionReset";
    TrackAction["RuleUpdated"] = "ruleUpdated";
    TrackAction["Upload"] = "Upload";
    TrackAction["OptedIntoExperiments"] = "optedIntoExperiments";
    TrackAction["OptedOutOfExperiments"] = "optedOutOfExperiments";
    TrackAction["UploadFailure"] = "uploadFailure";
    TrackAction["Checked"] = "checked";
    TrackAction["Triggered"] = "triggered";
    TrackAction["Queried"] = "queried";
    TrackAction["Finished"] = "finished";
    TrackAction["RemovedUser"] = "removedUser";
    TrackAction["Errored"] = "errored";
    TrackAction["UserlistDownloaded"] = "userList downloaded";
    TrackAction["ManagedAccountsDownloaded"] = "managedAccounts downloaded";
    TrackAction["ParseFailure"] = "parseFailure";
    TrackAction["Authenticated"] = "authenticated";
    TrackAction["Succeeded"] = "succeeded";
    TrackAction["Accepted"] = "accepted";
    TrackAction["Declined"] = "declined";
    TrackAction["DisconnectionFailed"] = "disconnectionFailed";
    TrackAction["Recommendation"] = "recommendation";
    TrackAction["Redirected"] = "redirected";
    TrackAction["Renamed"] = "renamed";
    TrackAction["AddedGroupToAgentProfile"] = "addedGroupToAgentProfile";
    TrackAction["AddedDefaultAccessToAgentProfile"] = "addedDefaultAccessToAgentProfile";
    TrackAction["RemovedGroupToAgent"] = "removedGroupToAgent";
    TrackAction["AddedGroupToAgent"] = "addedGroupToAgent";
    TrackAction["RemovedAppToAgent"] = "removedAppToAgent";
    TrackAction["AddedAppToAgent"] = "addedAppToAgent";
    TrackAction["Evaluated"] = "evaluated";
    TrackAction["Viewed"] = "viewed";
    TrackAction["Failed"] = "failed";
    TrackAction["StateChanged"] = "stateChanged";
    TrackAction["Redacted"] = "redacted";
    TrackAction["DeletedAttachment"] = "deletedAttachment";
    TrackAction["MarkedFalsePositive"] = "markedFalsePositive";
    TrackAction["Reverted"] = "reverted";
    return TrackAction;
}({});
var $156ec9a2f3d8f0c2$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    ActionSubject["Table"] = "table";
    ActionSubject["Button"] = "button";
    ActionSubject["Form"] = "form";
    ActionSubject["Link"] = "link";
    ActionSubject["AppSwitcherDropdown"] = "appSwitcherDropdown";
    ActionSubject["AppSwitcherItem"] = "appSwitcherItem";
    ActionSubject["Organization"] = "organization";
    ActionSubject["OrganizationSelectorItem"] = "organizationSelectorItem";
    ActionSubject["BillingSelectorItem"] = "billingSelectorItem";
    ActionSubject["Border"] = "border";
    ActionSubject["HelpSelectorItem"] = "helpSelectorItem";
    ActionSubject["Dialog"] = "dialog";
    ActionSubject["Datepicker"] = "datepicker";
    ActionSubject["Field"] = "field";
    ActionSubject["NavigationItem"] = "navigationItem";
    ActionSubject["Toggle"] = "toggle";
    ActionSubject["Checkbox"] = "checkbox";
    ActionSubject["DropListItem"] = "dropListItem";
    ActionSubject["DropListTrigger"] = "dropListTrigger";
    ActionSubject["RadioButton"] = "radioButton";
    ActionSubject["Radio"] = "radio";
    ActionSubject["TextField"] = "textField";
    ActionSubject["Text"] = "text";
    ActionSubject["Badge"] = "badge";
    ActionSubject["Dropdown"] = "dropdown";
    ActionSubject["DropdownItem"] = "dropdownItem";
    ActionSubject["SelectItem"] = "selectItem";
    ActionSubject["Error"] = "error";
    ActionSubject["Chart"] = "chart";
    ActionSubject["Page"] = "page";
    ActionSubject["Card"] = "card";
    ActionSubject["Tooltip"] = "tooltip";
    ActionSubject["Icon"] = "icon";
    ActionSubject["NotificationModal"] = "notificationModal";
    ActionSubject["Notification"] = "notification";
    ActionSubject["MenuItem"] = "menuItem";
    ActionSubject["UserPicker"] = "userPicker";
    ActionSubject["Accordion"] = "accordion";
    ActionSubject["Tab"] = "tab";
    ActionSubject["Modal"] = "modal";
    ActionSubject["Flag"] = "flag";
    ActionSubject["IphSideBar"] = "iphSideBar";
    ActionSubject["Input"] = "input";
    ActionSubject["SearchResult"] = "searchResult";
    ActionSubject["CallToAction"] = "callToAction";
    ActionSubject["ResendInvite"] = "resendInvite";
    ActionSubject["DisimssButton"] = "dismissButton";
    ActionSubject["EmptyTable"] = "emptyTable";
    ActionSubject["Row"] = "row";
    ActionSubject["Option"] = "option";
    ActionSubject["FilterController"] = "filterController";
    ActionSubject["Banner"] = "banner";
    ActionSubject["Spotlight"] = "spotlight";
    ActionSubject["Content"] = "content";
    ActionSubject["ContentLink"] = "content-link";
    ActionSubject["ScrollContainer"] = "scrollContainer";
    return ActionSubject;
}({});
var $156ec9a2f3d8f0c2$export$5b6897e82598b599 = /*#__PURE__*/ function(TrackActionSubject) {
    TrackActionSubject["Button"] = "button";
    TrackActionSubject["CsmPhoneNumberPurchaseFlow"] = "csmPhoneNumberPurchaseFlow";
    TrackActionSubject["CsmPhoneNumberInventory"] = "csmPhoneNumberInventory";
    TrackActionSubject["Page"] = "page";
    TrackActionSubject["BulkSelectionLimit"] = "bulkSelectionLimit";
    TrackActionSubject["Customer"] = "customer";
    TrackActionSubject["DeletedCustomer"] = "deletedCustomer";
    TrackActionSubject["Dropdown"] = "dropdown";
    TrackActionSubject["Group"] = "group";
    TrackActionSubject["GroupName"] = "groupname";
    TrackActionSubject["Groups"] = "groups";
    TrackActionSubject["Member"] = "member";
    TrackActionSubject["Form"] = "form";
    TrackActionSubject["Token"] = "token";
    TrackActionSubject["User"] = "user";
    TrackActionSubject["Unit"] = "unit";
    TrackActionSubject["UnitEndUserLaunch"] = "unitEndUserLaunch";
    TrackActionSubject["UnitName"] = "unitName";
    TrackActionSubject["UnitDescription"] = "unitDescription";
    TrackActionSubject["UnitIcon"] = "unitIcon";
    TrackActionSubject["AddedDefaultAccessToAgentProfile"] = "addedDefaultAccessToAgentProfile";
    TrackActionSubject["LandingProduct"] = "landingProduct";
    TrackActionSubject["UserList"] = "userList";
    TrackActionSubject["UserPassword"] = "userPassword";
    TrackActionSubject["UserProvisioning"] = "userProvisioning";
    TrackActionSubject["Invitation"] = "invitation";
    TrackActionSubject["ProductAccess"] = "productAccess";
    TrackActionSubject["Organization"] = "organization";
    TrackActionSubject["CustomDomain"] = "customDomain";
    TrackActionSubject["AdminApiKey"] = "adminApiKey";
    TrackActionSubject["ApiKey"] = "userApiKeys";
    TrackActionSubject["Checkbox"] = "checkbox";
    TrackActionSubject["UserPermission"] = "userPermission";
    TrackActionSubject["SiteAccess"] = "siteAccess";
    TrackActionSubject["OrgAccess"] = "orgAccess";
    TrackActionSubject["OrgAdmin"] = "orgAdmin";
    TrackActionSubject["UserSiteAdminRole"] = "userSiteAdminRole";
    TrackActionSubject["SuggestChanges"] = "suggestChanges";
    TrackActionSubject["OrgAdminAccess"] = "orgAdminAccess";
    TrackActionSubject["Feature"] = "feature";
    TrackActionSubject["JiraSpaceInviteAssignments"] = "jiraSpaceInviteAssignments";
    TrackActionSubject["NewUserAccess"] = "newUserAccess";
    TrackActionSubject["InviteUrlLinkToggled"] = "inviteUrlLinkToggled";
    TrackActionSubject["InviteUrlLinkRegenerated"] = "inviteUrlLinkRegenerated";
    TrackActionSubject["Domain"] = "domain";
    TrackActionSubject["MemberApiToken"] = "memberApiToken";
    TrackActionSubject["OktaAccount"] = "oktaAccount";
    TrackActionSubject["Accounts"] = "accounts";
    TrackActionSubject["SessionDuration"] = "sessionDuration";
    TrackActionSubject["SiteUrl"] = "siteUrl";
    TrackActionSubject["FeatureFlag"] = "featureFlag";
    TrackActionSubject["Origin"] = "origin";
    TrackActionSubject["ApprovedDomains"] = "approvedDomainsSettings";
    TrackActionSubject["UserInvite"] = "userInvitesSettings";
    TrackActionSubject["InviteLinks"] = "inviteLinksSettings";
    TrackActionSubject["AccessRequests"] = "accessRequestsSettings";
    TrackActionSubject["OrgGSuiteAccount"] = "orgGSuiteAccount";
    TrackActionSubject["SiteGSuiteAccount"] = "siteGSuiteAccount";
    TrackActionSubject["Sandbox"] = "sandbox";
    TrackActionSubject["SandboxResetProducts"] = "sandboxResetProducts";
    TrackActionSubject["TwoStepVerification"] = "twoStepVerification";
    TrackActionSubject["ThirdPartyAccounts"] = "thirdPartyAccounts";
    TrackActionSubject["ReleaseTracks"] = "releaseTracks";
    TrackActionSubject["DataSecurityPolicies"] = "dataSecurityPolicy";
    TrackActionSubject["IpAllowlist"] = "allowlist";
    TrackActionSubject["ExternalSitePolicy"] = "externalSitesPolicy";
    TrackActionSubject["MobileDevicePolicy"] = "mobileDevicePolicy";
    TrackActionSubject["AuthPolicy"] = "authPolicy";
    TrackActionSubject["AuthPolicyType"] = "authPolicyType";
    TrackActionSubject["MembersAuthPolicy"] = "membersAuthPolicy";
    TrackActionSubject["CmkPolicy"] = "cmkPolicy";
    TrackActionSubject["Instance"] = "instance";
    TrackActionSubject["DataResidency"] = "dataResidency";
    TrackActionSubject["DataResidencyApps"] = "dataResidencyApps";
    TrackActionSubject["UserInviteSetting"] = "userInviteSetting";
    TrackActionSubject["NotAllowedNoteSetting"] = "notAllowedNoteSetting";
    TrackActionSubject["ForgeLogsPreview"] = "forgeLogsPreview";
    TrackActionSubject["DisableForgeLogsAccess"] = "disableForgeLogsAccess";
    TrackActionSubject["EnableForgeLogsAccess"] = "enableForgeLogsAccess";
    TrackActionSubject["ApprovedDomain"] = "approvedDomain";
    TrackActionSubject["AccessSetting"] = "accessSetting";
    TrackActionSubject["plan"] = "plan";
    TrackActionSubject["EmailAddress"] = "emailAddress";
    TrackActionSubject["ApplicationTunnel"] = "applicationTunnel";
    TrackActionSubject["AuditLogActivitySettings"] = "auditLogActivitySettings";
    TrackActionSubject["AuditLogQueryParameters"] = "auditLogQueryParameters";
    TrackActionSubject["IdentityProvider"] = "identityProvider";
    TrackActionSubject["SamlConfiguration"] = "samlConfiguration";
    TrackActionSubject["SamlAssertionEncryption"] = "samlAssertionEncryption";
    TrackActionSubject["SlackConnect"] = "slackConnect";
    TrackActionSubject["OSyncAccount"] = "oSyncAccount";
    TrackActionSubject["ExternalUsers"] = "externalUsers";
    TrackActionSubject["ExternalUserPolicy"] = "externalUserPolicy";
    TrackActionSubject["ClaimManagedAccounts"] = "claimManagedAccounts";
    TrackActionSubject["UnclaimManagedAccounts"] = "unclaimManagedAccounts";
    TrackActionSubject["ProductUpdatesFilter"] = "productUpdatesFilter";
    TrackActionSubject["ProductUpdatesEmailSubsciption"] = "productUpdatesEmailSubsciption";
    TrackActionSubject["MemberSessionToken"] = "memberSessionToken";
    TrackActionSubject["MemberOauthToken"] = "memberOauthToken";
    TrackActionSubject["SelectiveClaimSetting"] = "selectiveClaimSetting";
    TrackActionSubject["SelectiveAccounts"] = "selectiveAccounts";
    TrackActionSubject["SelectiveDomain"] = "selectiveDomain";
    TrackActionSubject["ActiveUsersByProduct"] = "activeUsersByProduct";
    TrackActionSubject["ApiTokenPolicies"] = "apiTokenPolicies";
    TrackActionSubject["ProductActivation"] = "productActivation";
    TrackActionSubject["ProductRequest"] = "productRequest";
    TrackActionSubject["EmailNotification"] = "emailNotification";
    TrackActionSubject["ProductSetting"] = "productSetting";
    TrackActionSubject["ProductStatus"] = "productStatus";
    TrackActionSubject["SearchNoResults"] = "searchNoResults";
    TrackActionSubject["SearchDropdownEntry"] = "searchDropdownEntry";
    TrackActionSubject["SearchDropdownNoAction"] = "searchDropdownNoAction";
    TrackActionSubject["SearchSomeResults"] = "searchSomeResults";
    TrackActionSubject["SearchErrorEncountered"] = "searchErrorEncountered";
    TrackActionSubject["SiteFilter"] = "siteFilter";
    TrackActionSubject["HipaaCompliance"] = "hipaaCompliance";
    TrackActionSubject["BaaSignIn"] = "baaSignIn";
    TrackActionSubject["AccessTrial"] = "accessTrial";
    TrackActionSubject["DataClassificationLevel"] = "dataClassificationLevel";
    TrackActionSubject["UserApiTokens"] = "userApiTokens";
    TrackActionSubject["DiscoveredProducts"] = "discoveredProducts";
    TrackActionSubject["Townsquare"] = "townsquare";
    TrackActionSubject["RovoBeta"] = "rovoBeta";
    TrackActionSubject["MigrationTask"] = "migrationTask";
    TrackActionSubject["MigrationJob"] = "migrationJob";
    TrackActionSubject["ServerToCloudTask"] = "serverToCloudTask";
    TrackActionSubject["ReportFilter"] = "reportFilter";
    TrackActionSubject["OrganizationSetting"] = "organizationSetting";
    TrackActionSubject["ZipFile"] = "zipFile";
    TrackActionSubject["RovoSearchConnection"] = "rovoSearchConnection";
    TrackActionSubject["RovoSearchConnectionDraft"] = "rovoSearchConnectionDraft";
    TrackActionSubject["AgpStandardSignup"] = "guardStandardTrial";
    TrackActionSubject["AgpPremiumSignup"] = "guardPremiumTrial";
    TrackActionSubject["AdminSearchNavigation"] = "adminSearchNavigation";
    TrackActionSubject["Eligibility"] = "eligibility";
    TrackActionSubject["RovoSearchPin"] = "rovoSearchPin";
    TrackActionSubject["RovoSmartlinksSetting"] = "rovoSmartlinksSetting";
    TrackActionSubject["RovoSearchPinKeyPhrase"] = "rovoSearchPinKeyPhrase";
    TrackActionSubject["RovoGA"] = "rovoGA";
    TrackActionSubject["RovoSite"] = "rovoSite";
    TrackActionSubject["RovoChatSite"] = "rovoChatSite";
    TrackActionSubject["AIRemovedSurvey"] = "atlassianIntelligenceRemovedSurvey";
    TrackActionSubject["AIRemovedSurveyVariant"] = "submittedAIRemovedSurveyTrackEventVariant";
    TrackActionSubject["AIRemovedSurveyControl"] = "submittedAIRemovedSurveyTrackEventControl";
    TrackActionSubject["AdminConfidenceSurvey"] = "adminConfidenceSurvey";
    TrackActionSubject["DataContributionSurvey"] = "dataContributionSurvey";
    TrackActionSubject["Team"] = "team";
    TrackActionSubject["TeamName"] = "teamName";
    TrackActionSubject["TeamProfileName"] = "teamProfileName";
    TrackActionSubject["RovoConnector"] = "rovoConnector";
    TrackActionSubject["RovoConnectorSetup"] = "rovoConnectorSetup";
    TrackActionSubject["RovoConnectorExitSurvey"] = "rovoConnectorExitSurvey";
    TrackActionSubject["RelatedArticles"] = "relatedArticles";
    TrackActionSubject["ContactSupport"] = "contactSupport";
    TrackActionSubject["SearchResults"] = "searchResults";
    TrackActionSubject["PlanDraft"] = "planDraft";
    TrackActionSubject["Checks"] = "checks";
    TrackActionSubject["Export"] = "export";
    TrackActionSubject["RemovalUser"] = "removalUser";
    TrackActionSubject["GoalsAndProjectsSetting"] = "goalsAndProjectsSetting";
    TrackActionSubject["RovoSearchBookmarkImportSubmission"] = "rovoSearchBookmarkImportSubmission";
    TrackActionSubject["TWGActionsConfiguration"] = "twgActionsConfiguration";
    TrackActionSubject["TWGAppContainer"] = "twgAppContainer";
    TrackActionSubject["TWGConnector"] = "twgConnector";
    TrackActionSubject["TwgCliAllowDefaultPerms"] = "twgCliAllowDefaultPerms";
    TrackActionSubject["TwgCliPermission"] = "twgCliPermission";
    TrackActionSubject["RovoBookmarkSuggestion"] = "rovoBookmarkSuggestion";
    TrackActionSubject["RovoAccessApp"] = "rovoAccessApp";
    TrackActionSubject["ALQLQuery"] = "ALQLQuery";
    TrackActionSubject["FreezeWindowCreateFreezeWindow"] = "freezeWindowCreateFreezeWindow";
    TrackActionSubject["ProvisionCollection"] = "provisionCollection";
    TrackActionSubject["ProvisionServiceCollectionUplift"] = "provisionServiceCollectionUplift";
    TrackActionSubject["CollectionTrial"] = "collectionTrial";
    TrackActionSubject["ServiceAccountCredential"] = "serviceAccountCredential";
    TrackActionSubject["ServiceAccount"] = "serviceAccount";
    TrackActionSubject["MCPServer"] = "mcpServer";
    TrackActionSubject["MCPServerTool"] = "mcpServerTool";
    TrackActionSubject["MCPDomain"] = "mcpDomain";
    TrackActionSubject["MCPPermission"] = "mcpPermission";
    TrackActionSubject["AtlassianSupportedMCPDomains"] = "atlassianSupportedMCPDomains";
    TrackActionSubject["MCPHeadlessAuth"] = "mcpHeadlessAuth";
    TrackActionSubject["MCPA2A"] = "mcpA2A";
    TrackActionSubject["AppUninstall"] = "appUninstall";
    TrackActionSubject["TeamCreateDialog"] = "teamCreateDialog";
    TrackActionSubject["TeamInvitation"] = "teamInvitation";
    TrackActionSubject["TeamProfileDescription"] = "teamProfileDescription";
    TrackActionSubject["TeamMember"] = "teamMember";
    TrackActionSubject["JoinRequest"] = "joinRequest";
    TrackActionSubject["OverageLimit"] = "overageLimit";
    TrackActionSubject["AssignGroupAiAccess"] = "assignGroupAiAccess";
    TrackActionSubject["RemoveGroupAiAccess"] = "removeGroupAiAccess";
    TrackActionSubject["EnableAutomaticAiAccess"] = "enableAutomaticAiAccess";
    TrackActionSubject["DisableAutomaticAiAccess"] = "disableAutomaticAiAccess";
    TrackActionSubject["ProvisionStandaloneCollectionApp"] = "provisionStandaloneCollectionApp";
    TrackActionSubject["AppActivation"] = "appActivation";
    TrackActionSubject["SmartSettingsModalWrapperChecks"] = "smartSettingsModalWrapperChecks";
    TrackActionSubject["SmartSettingsRecommendations"] = "smartSettingsRecommendations";
    TrackActionSubject["DaNudgeCandidateProducts"] = "daNudgeCandidateProducts";
    TrackActionSubject["DaNudgeDomain"] = "twcDaNudgeDomainDismissedTapTrait";
    TrackActionSubject["ExportMeterUsageDetails"] = "exportMeterUsageDetails";
    TrackActionSubject["ExportRovoUsageDetails"] = "exportRovoUsageDetails";
    TrackActionSubject["ExportAgentsDetails"] = "exportAgentsDetails";
    TrackActionSubject["ContextualRACollaborators"] = "contextualRACollaborators";
    TrackActionSubject["SidepanelProfile"] = "sidepanelUserProfile";
    TrackActionSubject["Import"] = "import";
    TrackActionSubject["GovernanceManagerPosture"] = "governanceManagerPosture";
    TrackActionSubject["GovernanceManagerScope"] = "governanceManagerScope";
    TrackActionSubject["GovernanceManagerRefresh"] = "governanceManagerRefresh";
    TrackActionSubject["GovernanceManagerM2Error"] = "governanceManagerM2Error";
    TrackActionSubject["GovernanceManagerRegression"] = "governanceManagerRegression";
    TrackActionSubject["DspControl"] = "dspControl";
    TrackActionSubject["DspControlOverride"] = "dspControlOverride";
    TrackActionSubject["DspCustomAppControl"] = "dspCustomAppControl";
    TrackActionSubject["ClassificationRules"] = "classificationRules";
    TrackActionSubject["TwgPlatformCapabilityGlobalSetting"] = "twgPlatformCapabilityGlobalSetting";
    TrackActionSubject["AvailableSeatsMonthly"] = "available_seats_monthly";
    TrackActionSubject["ShowAvailableSeats"] = "show_available_seats";
    TrackActionSubject["SandboxDeploymentEntities"] = "sandboxDeploymentEntities";
    TrackActionSubject["ConditionalAccessPolicy"] = "conditionalAccessPolicy";
    TrackActionSubject["UnifiedPolicy"] = "unifiedPolicy";
    TrackActionSubject["SdpViolationRemediation"] = "sdpViolationRemediation";
    TrackActionSubject["CommerceExperienceUrl"] = "commerceExperienceUrl";
    TrackActionSubject["TwcUserInterceptEligibility"] = "twcUserInterceptEligibility";
    TrackActionSubject["TwcUserInterceptModal"] = "twcUserInterceptModal";
    TrackActionSubject["RankRaByMl"] = "rankRaByMl";
    TrackActionSubject["TwgMentionSignal"] = "twgMentionSignal";
    TrackActionSubject["TwgConfluenceSignal"] = "twgConfluenceSignal";
    TrackActionSubject["TwgLoomSignal"] = "twgLoomSignal";
    TrackActionSubject["TwgQuerySignal"] = "twgQuerySignal";
    TrackActionSubject["CodeContextConnection"] = "codeContextConnection";
    TrackActionSubject["TwgJiraSignal"] = "twgJiraSignal";
    TrackActionSubject["ActorsList"] = "actorsList";
    TrackActionSubject["Workload"] = "workload";
    TrackActionSubject["Findings"] = "findings";
    return TrackActionSubject;
}({});
var $156ec9a2f3d8f0c2$export$1d2df86270c81ecb = /*#__PURE__*/ function(Source) {
    Source["BillEstimate"] = "billEstimate";
    Source["BillHistory"] = "billHistory";
    Source["BillOverview"] = "billOverview";
    Source["DiscoverNewProducts"] = "discoverNewProducts";
    Source["ManageSubscriptions"] = "manageSubscriptions";
    Source["PaymentDetails"] = "paymentDetails";
    Source["AdminSearchDialog"] = "adminSearchDialog";
    return Source;
}({});
var $156ec9a2f3d8f0c2$export$be7aa9bbc93021ef = /*#__PURE__*/ function(OperationalAction) {
    OperationalAction["Fetched"] = "fetched";
    OperationalAction["Exposed"] = "exposed";
    OperationalAction["Triggered"] = "triggered";
    OperationalAction["Failed"] = "failed";
    OperationalAction["Succeeded"] = "succeeded";
    OperationalAction["Aborted"] = "aborted";
    OperationalAction["Started"] = "started";
    OperationalAction["Changed"] = "changed";
    OperationalAction["Done"] = "done";
    OperationalAction["Exceeded"] = "exceeded";
    OperationalAction["Deleted"] = "deleted";
    OperationalAction["Connected"] = "connected";
    OperationalAction["Viewed"] = "viewed";
    OperationalAction["Evaluated"] = "evaluated";
    OperationalAction["Error"] = "error";
    OperationalAction["Collected"] = "collected";
    OperationalAction["TaskAbort"] = "taskAbort";
    OperationalAction["TaskStart"] = "taskStart";
    OperationalAction["TaskSuccess"] = "taskSuccess";
    OperationalAction["TaskFail"] = "taskFail";
    OperationalAction["Measured"] = "measured";
    return OperationalAction;
}({});
var $156ec9a2f3d8f0c2$export$a95ec09d18401fbe = /*#__PURE__*/ function(OperationalSubject) {
    OperationalSubject["AuthorizationOutcome"] = "authorizationOutcome";
    OperationalSubject["ConnectorDisconnectionOutcome"] = "connectorDisconnectionOutcome";
    OperationalSubject["OnConnectorCreationFormSubmitOutcome"] = "onConnectorCreationFormSubmitOutcome";
    OperationalSubject["GraphqlResponseSize"] = "graphqlResponseSize";
    OperationalSubject["GraphqlSever"] = "graphqlServer";
    OperationalSubject["Experiment"] = "experiment";
    OperationalSubject["SiteUrlError"] = "siteUrlError";
    OperationalSubject["ParentOrgQuery"] = "parentOrgQuery";
    OperationalSubject["SiteQuery"] = "siteQuery";
    OperationalSubject["DeeplinkedAccessRequest"] = "deeplinkedAccessRequest";
    OperationalSubject["ProductAccess"] = "productAccess";
    OperationalSubject["IdentityProvider"] = "identityProvider";
    OperationalSubject["Circle"] = "circle";
    OperationalSubject["PickLoader"] = "pick-loader";
    OperationalSubject["Feature"] = "feature";
    OperationalSubject["JiraSpaceInviteOperation"] = "jiraSpaceInviteOperation";
    OperationalSubject["UpgradeToMove"] = "upgradeToMove";
    OperationalSubject["Context"] = "context";
    OperationalSubject["Navigation"] = "navigation";
    OperationalSubject["UserLicense"] = "userLicense";
    OperationalSubject["SlackImportSucceeded"] = "slackImportSucceeded";
    OperationalSubject["InviteUsers"] = "inviteUsers";
    OperationalSubject["ThirdPartyIntegration"] = "thirdPartyIntegration";
    OperationalSubject["ThirdPartyUsers"] = "thirdPartyUsers";
    OperationalSubject["LoadRecaptchaEnterprise"] = "loadRecaptchaEnterprise";
    OperationalSubject["UserInviteLoadRecaptcha"] = "userInviteLoadRecaptcha";
    OperationalSubject["SiteSelectionDropdownError"] = "siteSelectionDropdownError";
    OperationalSubject["FetchNotification"] = "fetchNotification";
    OperationalSubject["MarkNotificationGroupAsRead"] = "markNotificationGroupAsRead";
    OperationalSubject["InvalidAuditLogsUGCPolicy"] = "invalidAuditLogsUGCPolicy";
    OperationalSubject["UgcPolicySave"] = "ugcPolicySave";
    OperationalSubject["PendingAccessRequests"] = "pendingAccessRequests";
    OperationalSubject["OrgPolicies"] = "orgPolicies";
    OperationalSubject["RovoSearchPinFetch"] = "rovoSearchPinFetch";
    OperationalSubject["RovoSearchPinAdd"] = "rovoSearchPinAdd";
    OperationalSubject["RovoSearchPinEdit"] = "rovoSearchPinEdit";
    OperationalSubject["RovoSmartlinksSettingSave"] = "rovoSmartlinksSettingSave";
    OperationalSubject["RovoSearchPinDelete"] = "rovoSearchPinDelete";
    OperationalSubject["RovoAccessAdd"] = "rovoAccessAdd";
    OperationalSubject["RovoAccessRemove"] = "rovoAccessRemove";
    OperationalSubject["GraphQL"] = "graphql";
    OperationalSubject["SearchError"] = "searchError";
    OperationalSubject["RelatedArticlesError"] = "relatedArticlesError";
    OperationalSubject["ArticleFetchError"] = "articleFetchError";
    OperationalSubject["SiteUsersNumber"] = "siteUsersNumber";
    OperationalSubject["ManualUpgradeDataFetch"] = "manualUpgradeDataFetch";
    OperationalSubject["ManualUpgradeBannerRender"] = "manualUpgradeBannerRender";
    OperationalSubject["ReleaseControlsChangeDelay"] = "releaseControlsChangeDelay";
    OperationalSubject["DeferRolloutOptIn"] = "deferRolloutOptIn";
    OperationalSubject["UsersStatsDataFetch"] = "usersStatsDataFetch";
    OperationalSubject["UsersLastActiveDataFetch"] = "usersLastActiveDataFetch";
    OperationalSubject["Experience"] = "experience";
    OperationalSubject["PageLoad"] = "pageLoad";
    OperationalSubject["UpdateUserConsent"] = "updateUserConsent";
    OperationalSubject["ActivitySettingsSync"] = "activitySettingsSync";
    OperationalSubject["JsmGpEndDataFetch"] = "jsmGpEndDataFetch";
    OperationalSubject["UpliftEligibilityCheck"] = "upliftEligibilityCheck";
    OperationalSubject["ServcoUpliftProvisioning"] = "servcoUpliftProvisioning";
    OperationalSubject["ServcoUpliftSiteSelectFailed"] = "servcoUpliftSiteSelectFailed";
    OperationalSubject["ServcoUpliftEmptySiteSelectionTable"] = "servcoUpliftEmptySiteSelectionTable";
    OperationalSubject["SmartSettingsModalWrapperRender"] = "smartSettingsModalWrapperRender";
    OperationalSubject["SmartSettingsAccessSettingsUpdate"] = "smartSettingsAccessSettingsUpdate";
    OperationalSubject["SmartSettingsEligibilityFetch"] = "smartSettingsEligibilityFetch";
    OperationalSubject["GovernanceManagerFrameworksFetch"] = "governanceManagerFrameworksFetch";
    OperationalSubject["GovernanceManagerSitesMappingsFetch"] = "governanceManagerSitesMappingsFetch";
    OperationalSubject["GovernanceManagerScopeSave"] = "governanceManagerScopeSave";
    OperationalSubject["GovernanceManagerSiteStatusFetch"] = "governanceManagerSiteStatusFetch";
    OperationalSubject["AddCollection"] = "addCollection";
    OperationalSubject["TwcUserInterceptModalOverviewRender"] = "twcUserInterceptModalOverviewRender";
    OperationalSubject["CsmRegulatoryBundlesFetch"] = "csmRegulatoryBundlesFetch";
    OperationalSubject["CsmRegulatoryBundleDelete"] = "csmRegulatoryBundleDelete";
    OperationalSubject["CsmRegulatoryBundleInitialize"] = "csmRegulatoryBundleInitialize";
    OperationalSubject["CsmRegulatoryBundleResume"] = "csmRegulatoryBundleResume";
    OperationalSubject["CsmRegulatoryBundleAvailableCountriesFetch"] = "csmRegulatoryBundleAvailableCountriesFetch";
    OperationalSubject["CsmConsentFetch"] = "csmConsentFetch";
    OperationalSubject["CsmConsentGrant"] = "csmConsentGrant";
    OperationalSubject["CsmPhoneNumberInventoryFetch"] = "csmPhoneNumberInventoryFetch";
    OperationalSubject["CsmPhoneNumberCountriesFetch"] = "csmPhoneNumberCountriesFetch";
    OperationalSubject["CsmAvailablePhoneNumbersSearch"] = "csmAvailablePhoneNumbersSearch";
    OperationalSubject["CsmRegisteredAddressesFetch"] = "csmRegisteredAddressesFetch";
    OperationalSubject["CsmRegisteredAddressCreate"] = "csmRegisteredAddressCreate";
    OperationalSubject["CsmPhoneNumberPurchase"] = "csmPhoneNumberPurchase";
    OperationalSubject["CsmWhatsAppSendersFetch"] = "csmWhatsAppSendersFetch";
    OperationalSubject["CsmWhatsAppWabaLink"] = "csmWhatsAppWabaLink";
    OperationalSubject["CsmWhatsAppWabaUnlink"] = "csmWhatsAppWabaUnlink";
    OperationalSubject["CsmWhatsAppEmbeddedSignup"] = "csmWhatsAppEmbeddedSignup";
    OperationalSubject["CsmWhatsAppNumberAdd"] = "csmWhatsAppNumberAdd";
    OperationalSubject["CsmWhatsAppNumberDelete"] = "csmWhatsAppNumberDelete";
    OperationalSubject["CsmPhoneNumberEnable"] = "csmPhoneNumberEnable";
    OperationalSubject["CsmPhoneNumberDisable"] = "csmPhoneNumberDisable";
    OperationalSubject["CsmPhoneNumberDelete"] = "csmPhoneNumberDelete";
    OperationalSubject["ActorsListLoad"] = "actorsListLoad";
    OperationalSubject["CustomAgentMcpSetting"] = "customAgentMcpSetting";
    return OperationalSubject;
}({});
var $156ec9a2f3d8f0c2$export$ea60622c812e6739 = /*#__PURE__*/ function(CapabilitySubject) {
    CapabilitySubject["UnitCreated"] = "unitCreated";
    CapabilitySubject["UnitActivated"] = "unitActivated";
    CapabilitySubject["UnitEndUserLaunchActivated"] = "unitEndUserLaunchActivated";
    CapabilitySubject["UnitNameUpdated"] = "unitNameUpdated";
    CapabilitySubject["UnitDescriptionUpdated"] = "unitDescriptionUpdated";
    CapabilitySubject["UnitIconUpdated"] = "unitIconUpdated";
    CapabilitySubject["UnitExplicitConnectionsTableViewed"] = "unitExplicitConnectionsTableViewed";
    CapabilitySubject["UnitImplicitConnectionsTableViewed"] = "unitImplicitConnectionsTableViewed";
    CapabilitySubject["DomainsViewed"] = "domainsViewed";
    CapabilitySubject["OrgInsightsViewed"] = "orgInsightsViewed";
    CapabilitySubject["RovoInsightsViewed"] = "rovoInsightsViewed";
    CapabilitySubject["ManagedAccountDetailsViewed"] = "managedAccountDetailsViewed";
    CapabilitySubject["ManagedAccountsViewed"] = "managedAccountsViewed";
    CapabilitySubject["AuditLogViewed"] = "auditLogViewed";
    CapabilitySubject["ManagedAccountPasswordReset"] = "managedAccountPasswordReset";
    CapabilitySubject["SiteAccountsViewed"] = "siteAccountsViewed";
    CapabilitySubject["TwoStepVerificationEnabled"] = "twoStepVerificationEnabled";
    CapabilitySubject["TwoStepVerificationDisabled"] = "twoStepVerificationDisabled";
    CapabilitySubject["SamlConfigured"] = "samlConfigured";
    CapabilitySubject["ManagedAccountApiTokenRevoked"] = "managedAccountApiTokenRevoked";
    CapabilitySubject["ManagedAccountDeactivated"] = "managedAccountDeactivated";
    CapabilitySubject["ManagedAccountDeleted"] = "managedAccountDeleted";
    CapabilitySubject["ManagedAccountEdited"] = "managedAccountEdited";
    CapabilitySubject["ManagedAccountResetPassword"] = "managedAccountResetPassword";
    CapabilitySubject["DomainVerified"] = "domainVerified";
    CapabilitySubject["IpAllowlistCreated"] = "ipAllowlistCreated";
    CapabilitySubject["IpAllowlistUpdated"] = "ipAllowlistUpdated";
    CapabilitySubject["IpAllowlistDeleted"] = "ipAllowlistDeleted";
    CapabilitySubject["MobileSecurityCreated"] = "mobileSecurityPolicyCreated";
    CapabilitySubject["MobileSecurityUpdated"] = "mobileSecurityPolicyUpdated";
    CapabilitySubject["MobileSecurityDeleted"] = "mobileSecurityPolicyDeleted";
    CapabilitySubject["DataResidencyViewed"] = "dataResidencyViewed";
    CapabilitySubject["DataResidencyChanged"] = "dataResidencyChanged";
    CapabilitySubject["DataResidencyCanceled"] = "dataResidencyCanceled";
    CapabilitySubject["ReleaseTracksViewed"] = "releaseTracksViewed";
    CapabilitySubject["ReleaseTrackChanged"] = "releaseTrackChanged";
    CapabilitySubject["ReleaseTracksChangelogsViewed"] = "releaseTracksChangelogsViewed";
    CapabilitySubject["SandboxesViewed"] = "sandboxesViewed";
    CapabilitySubject["AuthPolicyDeleted"] = "authPolicyDeleted";
    CapabilitySubject["AuthPolicyDefaultPolicyChanged"] = "authPolicyDefaultPolicyChanged";
    CapabilitySubject["AuthPolicyCreated"] = "authPolicyCreated";
    CapabilitySubject["AuthPolicyMembersTabViewed"] = "authPolicyMembersTabViewed";
    CapabilitySubject["AuthPoliciesListPageViewed"] = "authPoliciesListPageViewed";
    CapabilitySubject["AuthPolicySettingsTabViewed"] = "authPolicySettingsTabViewed";
    CapabilitySubject["AuthPolicyAddMembers"] = "authPolicyAddMembers";
    CapabilitySubject["AuthPolicyAddMembersWithCSV"] = "authPolicyAddMembersWithCSV";
    CapabilitySubject["AuthPolicyUpdated"] = "authPolicyUpdated";
    CapabilitySubject["AddProductCreated"] = "addProductCreated";
    CapabilitySubject["AuthPoliciesEnabledChecked"] = "authPoliciesEnabledChecked";
    CapabilitySubject["AuthPolicyTaskPollingCompleted"] = "authPolicyTaskPollingCompleted";
    CapabilitySubject["DiscoveredProductsViewed"] = "discoveredProductsViewed";
    CapabilitySubject["AuthPolicyMembersExportInitiated"] = "authPolicyMembersExportInitiated";
    CapabilitySubject["ExportDownloaded"] = "exportDownloaded";
    CapabilitySubject["AuthPolicyResetSessions"] = "authPolicyResetSessions";
    CapabilitySubject["OrgInviteUser"] = "orgInviteUser";
    CapabilitySubject["OrgGrantProductAccessUserDetails"] = "orgGrantProductAccessUserDetails";
    CapabilitySubject["AuditLogActivitySettingsViewed"] = "auditLogActivitySettingsViewed";
    CapabilitySubject["AuditLogActivitySettingsChanged"] = "auditLogActivitySettingsChanged";
    CapabilitySubject["IdentityProviderCreated"] = "identityProviderCreated";
    CapabilitySubject["OrgGroupDetailsViewed"] = "orgGroupDetailsViewed";
    CapabilitySubject["OrgRevokeProductAccessGroupDetails"] = "orgRevokeProductAccessGroupDetails";
    CapabilitySubject["OrgRemoveUserFromGroup"] = "orgRemoveUserFromGroup";
    CapabilitySubject["OrgAssignPlatformRole"] = "orgAssignPlatformRole";
    CapabilitySubject["OrgAddUserToGroupModal"] = "orgAddUserToGroupModal";
    CapabilitySubject["GroupListViewed"] = "groupListViewed";
    CapabilitySubject["OrgGrantProductAccessGroupDetails"] = "orgGrantProductAccessGroupDetails";
    CapabilitySubject["DirectoryGrantProductAccessGroupDetails"] = "directoryGrantProductAccessGroupDetails";
    CapabilitySubject["IdentityProviderDeleted"] = "identityProviderDeleted";
    CapabilitySubject["OrgProductDetailsViewed"] = "orgProductDetailsViewed";
    CapabilitySubject["OrgUserListViewed"] = "orgUserListViewed";
    CapabilitySubject["OrgRevokeProductAccessUserDetails"] = "orgRevokeProductAccessUserDetails";
    CapabilitySubject["OrgRevokePlatformRole"] = "orgRevokePlatformRole";
    CapabilitySubject["OrgCreateGroup"] = "orgCreateGroup";
    CapabilitySubject["UserDetailsViewed"] = "userDetailsViewed";
    CapabilitySubject["OrgDeleteGroup"] = "orgDeleteGroup";
    CapabilitySubject["ExternalUserExportInitiated"] = "externalUsersExportInitiated";
    CapabilitySubject["ExternalUserPolicyCreated"] = "externalUserPolicyCreated";
    CapabilitySubject["ExternalUserPolicyUpdated"] = "externalUserPolicyUpdated";
    CapabilitySubject["ExternalUserApiTokenPolicyUpdated"] = "externalUserApiTokenPolicyUpdated";
    CapabilitySubject["OrgImpersonateUser"] = "orgImpersonateUser";
    CapabilitySubject["OrgRemoveUser"] = "orgRemoveUser";
    CapabilitySubject["AddUserToGroupDetails"] = "addUserToGroupDetails";
    CapabilitySubject["OrgActivateUser"] = "orgActivateUser";
    CapabilitySubject["OrgDeactivateUser"] = "orgDeactivateUser";
    CapabilitySubject["OrgUpdateGroupAsDefault"] = "orgUpdateGroupAsDefault";
    CapabilitySubject["LicenseUtilizationViewed"] = "licenseUtilizationViewed";
    CapabilitySubject["OrgPromptResetPassword"] = "orgPromptResetPassword";
    CapabilitySubject["OrgAddGroupToProductDetails"] = "orgAddGroupToProductDetails";
    CapabilitySubject["OrgSuggestChangesToUserDetails"] = "orgSuggestChangesToUserDetails";
    CapabilitySubject["ContactsViewed"] = "contactsViewed";
    CapabilitySubject["ProductUpdatesViewed"] = "productUpdatesViewed";
    CapabilitySubject["ProductUpdateDetailsViewed"] = "productUpdateDetailsViewed";
    CapabilitySubject["ProductUpdatesEmailSubscribe"] = "productUpdatesEmailSubscribe";
    CapabilitySubject["ProductUpdatesReleaseDatesViewed"] = "productUpdatesReleaseDatesViewed";
    CapabilitySubject["UserConnectedAppsViewed"] = "singleAppListingUserConnectedAppsViewed";
    CapabilitySubject["UserConnectedAppsDetailsPageViewed"] = "userConnectedAppsDetailsPageViewed";
    CapabilitySubject["UserConnectedAppsUpdateConsentScreen"] = "userConnectedAppUpdateConsentScreen";
    CapabilitySubject["ManagedAccountSessionTokenRevoked"] = "managedAccountSessionTokenRevoked";
    CapabilitySubject["WorkspacesViewed"] = "workspacesViewed";
    CapabilitySubject["OpsgenieJSMMerged"] = "opsgenieJSMMerged";
    CapabilitySubject["OrgBillingPreviewViewed"] = "orgBillingPreviewViewed";
    CapabilitySubject["OrgBillingPreviewGroupedBySiteViewed"] = "orgBillingPreviewGroupedBySiteViewed";
    CapabilitySubject["OrgBillingPreviewV2"] = "orgBillingPreviewV2";
    CapabilitySubject["SiteBillingPreviewV2"] = "siteBillingPreviewV2";
    CapabilitySubject["SiteBillingPreviewViewed"] = "siteBillingPreviewViewed";
    CapabilitySubject["apiTokenPolicyUpdated"] = "apiTokenPolicyUpdated";
    CapabilitySubject["FeatureGatesClientInitialized"] = "featureGatesClientInitialized";
    CapabilitySubject["ExternalUserPolicySessionReset"] = "externalUserPolicySessionReset";
    CapabilitySubject["ExternalUserPolicySessionDurationUpdated"] = "externalUserPolicySessionDurationUpdated";
    CapabilitySubject["DataSecurityPoliciesPublicLinksRuleUpdated"] = "dataSecurityPoliciesPublicLinksRuleUpdated";
    CapabilitySubject["rovoActivatedSitesViewed"] = "rovoActivatedSitesViewed";
    CapabilitySubject["rovoConnectorsTableLoaded"] = "rovoConnectorsTableLoaded";
    CapabilitySubject["thirdPartyConnectorViewed"] = "thirdPartyConnectorViewed";
    CapabilitySubject["ExperimentControlsToggleOptIn"] = "ExperimentControlsToggleOptIn";
    CapabilitySubject["ExperimentControlsPageViewed"] = "ExperimentControlsPageViewed";
    CapabilitySubject["ALQLQueryCreated"] = "ALQLQueryCreated";
    CapabilitySubject["AuditLogBasicQuery"] = "AuditLogBasicQuery";
    CapabilitySubject["AuditLogAsyncQueryListQuery"] = "AuditLogAsyncQueryListQuery";
    CapabilitySubject["AuditLogActorFilterQueryUUL"] = "AuditLogActorFilterQueryUUL";
    CapabilitySubject["AuditLogActorFilterQuery"] = "AuditLogActorFilterQuery";
    CapabilitySubject["AuditLogMultipleWebhooksAdd"] = "AuditLogMultipleWebhooksAdd";
    CapabilitySubject["AuditLogMultipleWebhooksEdit"] = "AuditLogMultipleWebhooksEdit";
    CapabilitySubject["AppAuditLogEventExclusionSettingsUpdated"] = "AppAuditLogEventExclusionSettingsUpdated";
    CapabilitySubject["DynamicBannerQuery"] = "DynamicBannerQuery";
    CapabilitySubject["ScheduleRestore"] = "ScheduleRestore";
    CapabilitySubject["StartRestore"] = "StartRestore";
    CapabilitySubject["ImportStorage"] = "ImportStorage";
    CapabilitySubject["IdleConfluencesQuery"] = "IdleConfluencesQuery";
    CapabilitySubject["SmartSettingsEligibilityCheck"] = "smartSettingsEligibilityCheck";
    return CapabilitySubject;
}({});

});

parcelRegister("4C3il", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsClient", () => $a73ad9e427890653$export$d1e7d486652fda19);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $7eoj5 = parcelRequire("7eoj5");
function $a73ad9e427890653$export$d1e7d486652fda19(WrappedComponent) {
    return class extends $lE8gv.Component {
        static{
            this.WrappedComponent = WrappedComponent;
        }
        render() {
            return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $7eoj5.NewAnalyticsContext).Consumer, {
                children: this.wrappedComponentRenderer
            });
        }
        constructor(...args){
            super(...args), this.wrappedComponentRenderer = (analyticsClient)=>/*#__PURE__*/ (0, $kOwiQ.jsx)(WrappedComponent, {
                    ...this.props,
                    analyticsClient: analyticsClient
                });
        }
    };
}

});
parcelRegister("7eoj5", function(module, exports) {
$parcel$export(module.exports, "NewAnalyticsContext", () => $50e48ad54dfdf81c$export$99c84c2ceea332b5);

var $lE8gv = parcelRequire("lE8gv");
const $50e48ad54dfdf81c$var$noop = ()=>undefined;
const $50e48ad54dfdf81c$export$99c84c2ceea332b5 = /*#__PURE__*/ $lE8gv.createContext({
    init: $50e48ad54dfdf81c$var$noop,
    initOriginTracingHandlers: $50e48ad54dfdf81c$var$noop,
    setOrgId: $50e48ad54dfdf81c$var$noop,
    sendScreenEvent: $50e48ad54dfdf81c$var$noop,
    sendTrackEvent: $50e48ad54dfdf81c$var$noop,
    sendUIEvent: $50e48ad54dfdf81c$var$noop,
    sendOperationalEvent: $50e48ad54dfdf81c$var$noop,
    getAnalyticsWebClient: $50e48ad54dfdf81c$var$noop
});

});


parcelRegister("6s1Je", function(module, exports) {
$parcel$export(module.exports, "PageLoading", () => $e927733f43d1ca06$export$a89b8b542bf88e85);
$parcel$export(module.exports, "FullPageLoading", () => $e927733f43d1ca06$export$83b49688eb2dfed6);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $4Qx8e = parcelRequire("4Qx8e");
var $b1WJB = parcelRequire("b1WJB");

var $dsB9C = parcelRequire("dsB9C");

var $afn8r = parcelRequire("afn8r");

var $fFqfL = parcelRequire("fFqfL");

var $i1RX2 = parcelRequire("i1RX2");

var $dvhTw = parcelRequire("dvhTw");

var $jYOvc = parcelRequire("jYOvc");

var $dJ5dT = parcelRequire("dJ5dT");

var $8xAuu = parcelRequire("8xAuu");
const $e927733f43d1ca06$var$messages = (0, $4Qx8e.defineMessages)({
    retry: {
        id: 'common.loading.page-loading.retry',
        defaultMessage: 'Retry',
        description: 'Retry message for a generic error'
    }
});
const $e927733f43d1ca06$var$InternalPageLoadingImpl = (props)=>{
    if (props.error || props.timedOut) {
        props.showFlag({
            autoDismiss: true,
            icon: (0, $i1RX2.createErrorIcon)(),
            id: 'react-loadable-error',
            title: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $b1WJB.default), {
                ...(0, $dvhTw.errorFlagMessages).title
            }),
            description: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $b1WJB.default), {
                ...(0, $dvhTw.errorFlagMessages).description
            })
        });
        return props.onError || null;
    } else if (props.pastDelay) // Display spinner or nothing
    return props.onLoading || null;
    return null;
};
const $e927733f43d1ca06$export$aa172153780dbd5e = (props)=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $dJ5dT.default), {
        name: "page-loading",
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)($e927733f43d1ca06$var$InternalPageLoadingImpl, {
            ...props
        })
    });
const $e927733f43d1ca06$export$c429d70c9febdc70 = (props)=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $dJ5dT.default), {
        name: "page-loading-full",
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)($e927733f43d1ca06$var$InternalPageLoadingImpl, {
            ...props,
            onError: /*#__PURE__*/ (0, $kOwiQ.jsxs)($lE8gv.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $afn8r.default), {
                        size: "xlarge",
                        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $dvhTw.GenericErrorMessage), {})
                    }),
                    /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $fFqfL.Text), {
                        as: "p",
                        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $dsB9C.default), {
                            onClick: props.retry,
                            children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $b1WJB.default), {
                                ...$e927733f43d1ca06$var$messages.retry
                            })
                        })
                    })
                ]
            }),
            onLoading: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $8xAuu.FullPageSkeleton), {
                id: "page-loading",
                collapsedNav: true
            })
        })
    });
const $e927733f43d1ca06$export$a89b8b542bf88e85 = (0, $jYOvc.withFlag)($e927733f43d1ca06$export$aa172153780dbd5e);
const $e927733f43d1ca06$export$83b49688eb2dfed6 = (0, $jYOvc.withFlag)($e927733f43d1ca06$export$c429d70c9febdc70);

});
parcelRegister("4Qx8e", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $3875b808eec4abbf$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $3875b808eec4abbf$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $3875b808eec4abbf$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedTime", () => $3875b808eec4abbf$export$5b390a54f8a846f7);
$parcel$export(module.exports, "FormattedNumber", () => $3875b808eec4abbf$export$db80edc1e6b2f63d);
$parcel$export(module.exports, "FormattedList", () => $3875b808eec4abbf$export$f52b44e459e6e71d);
$parcel$export(module.exports, "FormattedDisplayName", () => $3875b808eec4abbf$export$c2336ea5aaab92fa);
$parcel$export(module.exports, "FormattedDateParts", () => $3875b808eec4abbf$export$7fdc7d2c91ce149b);
$parcel$export(module.exports, "FormattedTimeParts", () => $3875b808eec4abbf$export$ec35873761676c2a);
$parcel$export(module.exports, "createIntlCache", () => (parcelRequire("2oTn3")).createIntlCache);
$parcel$export(module.exports, "InvalidConfigError", () => (parcelRequire("cyePY")).InvalidConfigError);
$parcel$export(module.exports, "MessageFormatError", () => (parcelRequire("cyePY")).MessageFormatError);
$parcel$export(module.exports, "MissingDataError", () => (parcelRequire("cyePY")).MissingDataError);
$parcel$export(module.exports, "MissingTranslationError", () => (parcelRequire("cyePY")).MissingTranslationError);
$parcel$export(module.exports, "ReactIntlError", () => (parcelRequire("cyePY")).IntlError);
$parcel$export(module.exports, "ReactIntlErrorCode", () => (parcelRequire("cyePY")).IntlErrorCode);
$parcel$export(module.exports, "UnsupportedFormatterError", () => (parcelRequire("cyePY")).UnsupportedFormatterError);
$parcel$export(module.exports, "createIntl", () => (parcelRequire("2Ahkp")).createIntl);
$parcel$export(module.exports, "FormattedDateTimeRange", () => (parcelRequire("jnRAN")).default);
$parcel$export(module.exports, "FormattedMessage", () => (parcelRequire("b1WJB")).default);
$parcel$export(module.exports, "FormattedPlural", () => (parcelRequire("jStMN")).default);
$parcel$export(module.exports, "FormattedRelativeTime", () => (parcelRequire("dRwNn")).default);
$parcel$export(module.exports, "injectIntl", () => (parcelRequire("eE0yt")).default);
$parcel$export(module.exports, "IntlContext", () => (parcelRequire("eE0yt")).Context);
$parcel$export(module.exports, "IntlProvider", () => (parcelRequire("dDntd")).default);
$parcel$export(module.exports, "RawIntlProvider", () => (parcelRequire("eE0yt")).Provider);
$parcel$export(module.exports, "useIntl", () => (parcelRequire("cEINl")).default);
$parcel$export(module.exports, "FormattedListParts", () => (parcelRequire("3hA98")).FormattedListParts);
$parcel$export(module.exports, "FormattedNumberParts", () => (parcelRequire("3hA98")).FormattedNumberParts);

var $3hA98 = parcelRequire("3hA98");

var $2Ahkp = parcelRequire("2Ahkp");

var $jnRAN = parcelRequire("jnRAN");

var $eE0yt = parcelRequire("eE0yt");

var $b1WJB = parcelRequire("b1WJB");

var $jStMN = parcelRequire("jStMN");

var $dDntd = parcelRequire("dDntd");

var $dRwNn = parcelRequire("dRwNn");

var $cEINl = parcelRequire("cEINl");

var $2oTn3 = parcelRequire("2oTn3");
var $cyePY = parcelRequire("cyePY");
function $3875b808eec4abbf$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $3875b808eec4abbf$export$747d244ee58120dd(msg) {
    return msg;
}
var $3875b808eec4abbf$export$40ae3194919d16b = (0, $3hA98.createFormattedComponent)('formatDate');
var $3875b808eec4abbf$export$5b390a54f8a846f7 = (0, $3hA98.createFormattedComponent)('formatTime');
var $3875b808eec4abbf$export$db80edc1e6b2f63d = (0, $3hA98.createFormattedComponent)('formatNumber');
var $3875b808eec4abbf$export$f52b44e459e6e71d = (0, $3hA98.createFormattedComponent)('formatList');
var $3875b808eec4abbf$export$c2336ea5aaab92fa = (0, $3hA98.createFormattedComponent)('formatDisplayName');
var $3875b808eec4abbf$export$7fdc7d2c91ce149b = (0, $3hA98.createFormattedDateTimePartsComponent)('formatDate');
var $3875b808eec4abbf$export$ec35873761676c2a = (0, $3hA98.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("3hA98", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $263eff8793d5352a$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $263eff8793d5352a$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $263eff8793d5352a$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $263eff8793d5352a$export$b37e14176d001dec);

var $hAGHN = parcelRequire("hAGHN");

var $lE8gv = parcelRequire("lE8gv");

var $cEINl = parcelRequire("cEINl");
var $263eff8793d5352a$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($263eff8793d5352a$var$DisplayName || ($263eff8793d5352a$var$DisplayName = {}));
var $263eff8793d5352a$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($263eff8793d5352a$var$DisplayNameParts || ($263eff8793d5352a$var$DisplayNameParts = {}));
var $263eff8793d5352a$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $cEINl.default)();
    var value = props.value, children = props.children, formatProps = (0, $hAGHN.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$263eff8793d5352a$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $263eff8793d5352a$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $cEINl.default)();
    var value = props.value, children = props.children, formatProps = (0, $hAGHN.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$263eff8793d5352a$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $263eff8793d5352a$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $cEINl.default)();
        var value = props.value, children = props.children, formatProps = (0, $hAGHN.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $263eff8793d5352a$var$DisplayNameParts[name];
    return ComponentParts;
}
function $263eff8793d5352a$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $cEINl.default)();
        var value = props.value, children = props.children, formatProps = (0, $hAGHN.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $lE8gv.Fragment;
        return $lE8gv.createElement(Text, null, formattedValue);
    };
    Component.displayName = $263eff8793d5352a$var$DisplayName[name];
    return Component;
}

});
parcelRegister("cEINl", function(module, exports) {
$parcel$export(module.exports, "default", () => $936bf7c55f2778af$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");

var $23DKV = parcelRequire("23DKV");

var $eE0yt = parcelRequire("eE0yt");
function $936bf7c55f2778af$export$2e2bcd8739ae039() {
    var intl = $lE8gv.useContext((0, $eE0yt.Context));
    (0, $23DKV.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("23DKV", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $17fab34a0a6e97da$export$f5708dca728d7177);
$parcel$export(module.exports, "invariantIntlContext", () => $17fab34a0a6e97da$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $17fab34a0a6e97da$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "toKeyedReactNodeArray", () => $17fab34a0a6e97da$export$d2fd241e0b53c057);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $17fab34a0a6e97da$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $17fab34a0a6e97da$export$d36bdfa510afb180);

var $hAGHN = parcelRequire("hAGHN");

var $lE8gv = parcelRequire("lE8gv");

var $2oTn3 = parcelRequire("2oTn3");
function $17fab34a0a6e97da$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $17fab34a0a6e97da$export$45c4bbf6e55bba1f(intl) {
    $17fab34a0a6e97da$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $17fab34a0a6e97da$export$b52f8d6fc0d47415 = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, (0, $2oTn3.DEFAULT_INTL_CONFIG)), {
    textComponent: $lE8gv.Fragment
});
var $17fab34a0a6e97da$var$toKeyedReactNode = function(reactNode, key) {
    return $lE8gv.isValidElement(reactNode) ? $lE8gv.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var $17fab34a0a6e97da$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $lE8gv.Children.map(children, $17fab34a0a6e97da$var$toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $17fab34a0a6e97da$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($17fab34a0a6e97da$export$d2fd241e0b53c057(parts));
    };
}
function $17fab34a0a6e97da$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("2oTn3", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $1bf8c62aed029ad2$export$f5708dca728d7177);
$parcel$export(module.exports, "filterProps", () => $1bf8c62aed029ad2$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $1bf8c62aed029ad2$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $1bf8c62aed029ad2$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $1bf8c62aed029ad2$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $1bf8c62aed029ad2$export$4ee1db8ce44a209b);

var $hAGHN = parcelRequire("hAGHN");

var $fMhIs = parcelRequire("fMhIs");
parcelRequire("4r6Ix");
var $dkzrm = parcelRequire("dkzrm");

var $cyePY = parcelRequire("cyePY");
function $1bf8c62aed029ad2$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $1bf8c62aed029ad2$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $1bf8c62aed029ad2$var$defaultErrorHandler = function(error) {};
var $1bf8c62aed029ad2$var$defaultWarnHandler = function(warning) {};
var $1bf8c62aed029ad2$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $1bf8c62aed029ad2$var$defaultErrorHandler,
    onWarn: $1bf8c62aed029ad2$var$defaultWarnHandler
};
function $1bf8c62aed029ad2$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $1bf8c62aed029ad2$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $1bf8c62aed029ad2$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $1bf8c62aed029ad2$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $fMhIs.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $hAGHN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $1bf8c62aed029ad2$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $fMhIs.strategies).variadic
    });
    var getNumberFormat = (0, $fMhIs.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $hAGHN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $1bf8c62aed029ad2$var$createFastMemoizeCache(cache.number),
        strategy: (0, $fMhIs.strategies).variadic
    });
    var getPluralRules = (0, $fMhIs.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $hAGHN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $1bf8c62aed029ad2$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $fMhIs.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $fMhIs.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $dkzrm.IntlMessageFormat)(message, locales, overrideFormats, (0, $hAGHN.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $1bf8c62aed029ad2$var$createFastMemoizeCache(cache.message),
            strategy: (0, $fMhIs.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $fMhIs.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $hAGHN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $1bf8c62aed029ad2$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $fMhIs.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $fMhIs.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $hAGHN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $1bf8c62aed029ad2$var$createFastMemoizeCache(cache.list),
            strategy: (0, $fMhIs.strategies).variadic
        }),
        getDisplayNames: (0, $fMhIs.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $hAGHN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $1bf8c62aed029ad2$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $fMhIs.strategies).variadic
        })
    };
}
function $1bf8c62aed029ad2$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $cyePY.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("fMhIs", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $b7c914bad12754c4$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $b7c914bad12754c4$export$c5491a8691a23b9e);
//
// Main
//
function $b7c914bad12754c4$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $b7c914bad12754c4$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $b7c914bad12754c4$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $b7c914bad12754c4$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $b7c914bad12754c4$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $b7c914bad12754c4$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $b7c914bad12754c4$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $b7c914bad12754c4$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $b7c914bad12754c4$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $b7c914bad12754c4$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $b7c914bad12754c4$var$monadic : $b7c914bad12754c4$var$variadic;
    return $b7c914bad12754c4$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $b7c914bad12754c4$var$strategyVariadic(fn, options) {
    return $b7c914bad12754c4$var$assemble(fn, this, $b7c914bad12754c4$var$variadic, options.cache.create(), options.serializer);
}
function $b7c914bad12754c4$var$strategyMonadic(fn, options) {
    return $b7c914bad12754c4$var$assemble(fn, this, $b7c914bad12754c4$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $b7c914bad12754c4$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $b7c914bad12754c4$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $b7c914bad12754c4$var$cacheDefault = {
    create: function create() {
        return new $b7c914bad12754c4$var$ObjectWithoutPrototypeCache();
    }
};
var $b7c914bad12754c4$export$c5491a8691a23b9e = {
    variadic: $b7c914bad12754c4$var$strategyVariadic,
    monadic: $b7c914bad12754c4$var$strategyMonadic
};

});

parcelRegister("4r6Ix", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("8RsfL")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("8RsfL")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("8DVvT")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("dkzrm")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $dkzrm = parcelRequire("dkzrm");
parcelRequire("8RsfL");
parcelRequire("8DVvT");
var $33aee4fd44db80de$export$2e2bcd8739ae039 = (0, $dkzrm.IntlMessageFormat);

});
parcelRegister("dkzrm", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $9b48a25100b2450d$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $hAGHN = parcelRequire("hAGHN");

var $fMhIs = parcelRequire("fMhIs");

var $lnKw8 = parcelRequire("lnKw8");

var $8DVvT = parcelRequire("8DVvT");
// -- MessageFormat --------------------------------------------------------
function $9b48a25100b2450d$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $hAGHN.__assign)((0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $9b48a25100b2450d$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $9b48a25100b2450d$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $hAGHN.__assign)({}, defaultConfig));
}
function $9b48a25100b2450d$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $9b48a25100b2450d$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $fMhIs.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $hAGHN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9b48a25100b2450d$var$createFastMemoizeCache(cache.number),
            strategy: (0, $fMhIs.strategies).variadic
        }),
        getDateTimeFormat: (0, $fMhIs.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $hAGHN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9b48a25100b2450d$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $fMhIs.strategies).variadic
        }),
        getPluralRules: (0, $fMhIs.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $hAGHN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9b48a25100b2450d$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $fMhIs.strategies).variadic
        })
    };
}
var $9b48a25100b2450d$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $8DVvT.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $8DVvT.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $hAGHN.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $9b48a25100b2450d$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $9b48a25100b2450d$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $lnKw8.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("lnKw8", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("4ItHS")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("4ItHS")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("4ItHS")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("4ItHS")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("4ItHS")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("4ItHS")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("4ItHS")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("4ItHS")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("4ItHS")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("4ItHS")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("4ItHS")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("4ItHS")).TYPE);
$parcel$export(module.exports, "parse", () => $f90fd4558b7e8bc1$export$98e6a39c04603d36);

var $hAGHN = parcelRequire("hAGHN");

var $kpqjN = parcelRequire("kpqjN");

var $ilpJr = parcelRequire("ilpJr");

var $4ItHS = parcelRequire("4ItHS");

var $jhH2T = parcelRequire("jhH2T");
function $f90fd4558b7e8bc1$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $4ItHS.isSelectElement)(el) || (0, $4ItHS.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $f90fd4558b7e8bc1$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $4ItHS.isNumberElement)(el) && (0, $4ItHS.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $4ItHS.isDateElement)(el) || (0, $4ItHS.isTimeElement)(el)) && (0, $4ItHS.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $4ItHS.isTagElement)(el)) $f90fd4558b7e8bc1$var$pruneLocation(el.children);
    });
}
function $f90fd4558b7e8bc1$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $hAGHN.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $ilpJr.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $kpqjN.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $f90fd4558b7e8bc1$var$pruneLocation(result.val);
    return result.val;
}
var $f90fd4558b7e8bc1$export$d3c1bfa0f7d806e9 = (0, $ilpJr.Parser);

});
parcelRegister("kpqjN", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $edba8eb5e5df33a6$export$896afd8541959ee5);
var $edba8eb5e5df33a6$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($edba8eb5e5df33a6$export$896afd8541959ee5 || ($edba8eb5e5df33a6$export$896afd8541959ee5 = {}));

});

parcelRegister("ilpJr", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $d5ae25f5ccf112bd$export$7acfa6ed01010e37);

var $hAGHN = parcelRequire("hAGHN");

var $kpqjN = parcelRequire("kpqjN");

var $4ItHS = parcelRequire("4ItHS");

var $6DE1H = parcelRequire("6DE1H");
parcelRequire("lkDdN");
var $fkvGr = parcelRequire("fkvGr");
var $3Swrn = parcelRequire("3Swrn");

var $e7w7R = parcelRequire("e7w7R");
var $d5ae25f5ccf112bd$var$_a;
var $d5ae25f5ccf112bd$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $6DE1H.SPACE_SEPARATOR_REGEX).source, "*"));
var $d5ae25f5ccf112bd$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $6DE1H.SPACE_SEPARATOR_REGEX).source, "*$"));
function $d5ae25f5ccf112bd$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $d5ae25f5ccf112bd$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $d5ae25f5ccf112bd$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $d5ae25f5ccf112bd$var$hasNativeFromEntries = !!Object.fromEntries;
var $d5ae25f5ccf112bd$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $d5ae25f5ccf112bd$var$hasTrimStart = !!String.prototype.trimStart;
var $d5ae25f5ccf112bd$var$hasTrimEnd = !!String.prototype.trimEnd;
var $d5ae25f5ccf112bd$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $d5ae25f5ccf112bd$var$isSafeInteger = $d5ae25f5ccf112bd$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $d5ae25f5ccf112bd$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $d5ae25f5ccf112bd$var$re = $d5ae25f5ccf112bd$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $d5ae25f5ccf112bd$var$REGEX_SUPPORTS_U_AND_Y = (($d5ae25f5ccf112bd$var$_a = $d5ae25f5ccf112bd$var$re.exec('a')) === null || $d5ae25f5ccf112bd$var$_a === void 0 ? void 0 : $d5ae25f5ccf112bd$var$_a[0]) === 'a';
} catch (_) {
    $d5ae25f5ccf112bd$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $d5ae25f5ccf112bd$var$startsWith = $d5ae25f5ccf112bd$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $d5ae25f5ccf112bd$var$fromCodePoint = $d5ae25f5ccf112bd$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $d5ae25f5ccf112bd$var$fromEntries = // native
$d5ae25f5ccf112bd$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $d5ae25f5ccf112bd$var$codePointAt = $d5ae25f5ccf112bd$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $d5ae25f5ccf112bd$var$trimStart = $d5ae25f5ccf112bd$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($d5ae25f5ccf112bd$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $d5ae25f5ccf112bd$var$trimEnd = $d5ae25f5ccf112bd$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($d5ae25f5ccf112bd$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $d5ae25f5ccf112bd$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $d5ae25f5ccf112bd$var$matchIdentifierAtIndex;
if ($d5ae25f5ccf112bd$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $d5ae25f5ccf112bd$var$IDENTIFIER_PREFIX_RE_1 = $d5ae25f5ccf112bd$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $d5ae25f5ccf112bd$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $d5ae25f5ccf112bd$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $d5ae25f5ccf112bd$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$d5ae25f5ccf112bd$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $d5ae25f5ccf112bd$var$codePointAt(s, index);
        if (c === undefined || $d5ae25f5ccf112bd$var$_isWhiteSpace(c) || $d5ae25f5ccf112bd$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $d5ae25f5ccf112bd$var$fromCodePoint.apply(void 0, match);
};
var $d5ae25f5ccf112bd$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $4ItHS.TYPE).pound,
                    location: $d5ae25f5ccf112bd$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $kpqjN.ErrorKind).UNMATCHED_CLOSING_TAG, $d5ae25f5ccf112bd$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $d5ae25f5ccf112bd$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $4ItHS.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $d5ae25f5ccf112bd$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$d5ae25f5ccf112bd$var$_isAlpha(this.char())) return this.error((0, $kpqjN.ErrorKind).INVALID_TAG, $d5ae25f5ccf112bd$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $kpqjN.ErrorKind).UNMATCHED_CLOSING_TAG, $d5ae25f5ccf112bd$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $kpqjN.ErrorKind).INVALID_TAG, $d5ae25f5ccf112bd$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $4ItHS.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $d5ae25f5ccf112bd$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $kpqjN.ErrorKind).UNCLOSED_TAG, $d5ae25f5ccf112bd$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $kpqjN.ErrorKind).INVALID_TAG, $d5ae25f5ccf112bd$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $d5ae25f5ccf112bd$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $d5ae25f5ccf112bd$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $4ItHS.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$d5ae25f5ccf112bd$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $d5ae25f5ccf112bd$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $d5ae25f5ccf112bd$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $kpqjN.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $kpqjN.ErrorKind).EMPTY_ARGUMENT, $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $kpqjN.ErrorKind).MALFORMED_ARGUMENT, $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $kpqjN.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $4ItHS.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $kpqjN.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $kpqjN.ErrorKind).MALFORMED_ARGUMENT, $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $d5ae25f5ccf112bd$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $d5ae25f5ccf112bd$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $kpqjN.ErrorKind).EXPECT_ARGUMENT_TYPE, $d5ae25f5ccf112bd$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $d5ae25f5ccf112bd$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $kpqjN.ErrorKind).EXPECT_ARGUMENT_STYLE, $d5ae25f5ccf112bd$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $d5ae25f5ccf112bd$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $d5ae25f5ccf112bd$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $d5ae25f5ccf112bd$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $4ItHS.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $kpqjN.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $e7w7R.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $4ItHS.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $fkvGr.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $4ItHS.TYPE).date : (0, $4ItHS.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $4ItHS.TYPE).number : argType === 'date' ? (0, $4ItHS.TYPE).date : (0, $4ItHS.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $kpqjN.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $d5ae25f5ccf112bd$var$createLocation(typeEndPosition_1, (0, $hAGHN.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $kpqjN.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $d5ae25f5ccf112bd$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $kpqjN.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $kpqjN.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $4ItHS.TYPE).select,
                        value: value,
                        options: $d5ae25f5ccf112bd$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $4ItHS.TYPE).plural,
                        value: value,
                        options: $d5ae25f5ccf112bd$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $kpqjN.ErrorKind).INVALID_ARGUMENT_TYPE, $d5ae25f5ccf112bd$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $kpqjN.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $kpqjN.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $d5ae25f5ccf112bd$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $3Swrn.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $kpqjN.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $4ItHS.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $3Swrn.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $kpqjN.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $kpqjN.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $d5ae25f5ccf112bd$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $kpqjN.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $kpqjN.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $kpqjN.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $kpqjN.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $d5ae25f5ccf112bd$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $d5ae25f5ccf112bd$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $kpqjN.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $kpqjN.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $d5ae25f5ccf112bd$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $kpqjN.ErrorKind).MISSING_OTHER_CLAUSE, $d5ae25f5ccf112bd$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $d5ae25f5ccf112bd$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$d5ae25f5ccf112bd$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $d5ae25f5ccf112bd$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($d5ae25f5ccf112bd$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $d5ae25f5ccf112bd$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $d5ae25f5ccf112bd$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $d5ae25f5ccf112bd$var$_isAlphaOrSlash(codepoint) {
    return $d5ae25f5ccf112bd$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $d5ae25f5ccf112bd$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $d5ae25f5ccf112bd$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $d5ae25f5ccf112bd$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("4ItHS", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $36f250a06815b4b9$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $36f250a06815b4b9$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $36f250a06815b4b9$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $36f250a06815b4b9$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $36f250a06815b4b9$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $36f250a06815b4b9$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $36f250a06815b4b9$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $36f250a06815b4b9$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $36f250a06815b4b9$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $36f250a06815b4b9$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $36f250a06815b4b9$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $36f250a06815b4b9$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $36f250a06815b4b9$export$7680c41f1a55f4cf);
var $36f250a06815b4b9$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($36f250a06815b4b9$export$b87f371cbc396fcf || ($36f250a06815b4b9$export$b87f371cbc396fcf = {}));
var $36f250a06815b4b9$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($36f250a06815b4b9$export$906452485466fa53 || ($36f250a06815b4b9$export$906452485466fa53 = {}));
function $36f250a06815b4b9$export$cfa10c5697238752(el) {
    return el.type === $36f250a06815b4b9$export$b87f371cbc396fcf.literal;
}
function $36f250a06815b4b9$export$4f55724281bdfaf9(el) {
    return el.type === $36f250a06815b4b9$export$b87f371cbc396fcf.argument;
}
function $36f250a06815b4b9$export$e11187b219e191e1(el) {
    return el.type === $36f250a06815b4b9$export$b87f371cbc396fcf.number;
}
function $36f250a06815b4b9$export$32d811605da75f40(el) {
    return el.type === $36f250a06815b4b9$export$b87f371cbc396fcf.date;
}
function $36f250a06815b4b9$export$34ec46f596b1702f(el) {
    return el.type === $36f250a06815b4b9$export$b87f371cbc396fcf.time;
}
function $36f250a06815b4b9$export$dcfe1c11d168b5a1(el) {
    return el.type === $36f250a06815b4b9$export$b87f371cbc396fcf.select;
}
function $36f250a06815b4b9$export$6c796d116f0a4fbc(el) {
    return el.type === $36f250a06815b4b9$export$b87f371cbc396fcf.plural;
}
function $36f250a06815b4b9$export$c0ece297bdd0c082(el) {
    return el.type === $36f250a06815b4b9$export$b87f371cbc396fcf.pound;
}
function $36f250a06815b4b9$export$5c83de34745812b(el) {
    return el.type === $36f250a06815b4b9$export$b87f371cbc396fcf.tag;
}
function $36f250a06815b4b9$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $36f250a06815b4b9$export$906452485466fa53.number);
}
function $36f250a06815b4b9$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $36f250a06815b4b9$export$906452485466fa53.dateTime);
}
function $36f250a06815b4b9$export$f0ac572c1121c662(value) {
    return {
        type: $36f250a06815b4b9$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $36f250a06815b4b9$export$425e864b0ba114f1(value, style) {
    return {
        type: $36f250a06815b4b9$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("6DE1H", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $4d556f0794388759$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $4d556f0794388759$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $4d556f0794388759$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("lkDdN", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("fkvGr")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("3Swrn")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("3Swrn")).parseNumberSkeletonFromString);
parcelRequire("fkvGr");
parcelRequire("3Swrn");

});
parcelRegister("fkvGr", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $b2914cf5e15bdeb3$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $b2914cf5e15bdeb3$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $b2914cf5e15bdeb3$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($b2914cf5e15bdeb3$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("3Swrn", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $2d2f944532c5390e$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $2d2f944532c5390e$export$47c6f8480bda3e11);

var $hAGHN = parcelRequire("hAGHN");

var $8M8RQ = parcelRequire("8M8RQ");
function $2d2f944532c5390e$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $8M8RQ.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $2d2f944532c5390e$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $2d2f944532c5390e$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $2d2f944532c5390e$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $2d2f944532c5390e$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $2d2f944532c5390e$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $2d2f944532c5390e$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($2d2f944532c5390e$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $2d2f944532c5390e$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $2d2f944532c5390e$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$2d2f944532c5390e$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $2d2f944532c5390e$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $2d2f944532c5390e$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $2d2f944532c5390e$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $2d2f944532c5390e$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $hAGHN.__assign)((0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, all), $2d2f944532c5390e$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $hAGHN.__assign)((0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, all), $2d2f944532c5390e$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($2d2f944532c5390e$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($2d2f944532c5390e$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($2d2f944532c5390e$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($2d2f944532c5390e$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, result), $2d2f944532c5390e$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($2d2f944532c5390e$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, result), $2d2f944532c5390e$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $2d2f944532c5390e$var$parseSign(token.stem);
        if (signOpts) result = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $2d2f944532c5390e$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("8M8RQ", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $6639af55bab6b225$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $6639af55bab6b225$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("e7w7R", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $a47aa3ab9caa0662$export$29c5368be8904d27);

var $aKILk = parcelRequire("aKILk");
function $a47aa3ab9caa0662$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $a47aa3ab9caa0662$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $a47aa3ab9caa0662$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $aKILk.timeData)[regionTag || ''] || (0, $aKILk.timeData)[languageTag || ''] || (0, $aKILk.timeData)["".concat(languageTag, "-001")] || (0, $aKILk.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("aKILk", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $7d40ec2053c6646e$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $7d40ec2053c6646e$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("jhH2T", function(module, exports) {

var $hAGHN = parcelRequire("hAGHN");

var $4ItHS = parcelRequire("4ItHS");
function $e0a0fed74a5f906b$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $hAGHN.__spreadArray)([], obj.map($e0a0fed74a5f906b$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $e0a0fed74a5f906b$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $e0a0fed74a5f906b$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $e0a0fed74a5f906b$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $e0a0fed74a5f906b$export$be5687ba8bbdf416((0, $hAGHN.__spreadArray)((0, $hAGHN.__spreadArray)((0, $hAGHN.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $e0a0fed74a5f906b$var$isPluralOrSelectElement(el) {
    return (0, $4ItHS.isPluralElement)(el) || (0, $4ItHS.isSelectElement)(el);
}
function $e0a0fed74a5f906b$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($e0a0fed74a5f906b$var$isPluralOrSelectElement(el)) return true;
        if ((0, $4ItHS.isTagElement)(el)) return $e0a0fed74a5f906b$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $e0a0fed74a5f906b$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($e0a0fed74a5f906b$var$isPluralOrSelectElement(el)) return [
            $e0a0fed74a5f906b$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $4ItHS.isTagElement)(el) && $e0a0fed74a5f906b$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $e0a0fed74a5f906b$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $4ItHS.isArgumentElement)(el) || (0, $4ItHS.isDateElement)(el) || (0, $4ItHS.isTimeElement)(el) || (0, $4ItHS.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $4ItHS.isPluralElement)(el) || (0, $4ItHS.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $e0a0fed74a5f906b$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $4ItHS.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $e0a0fed74a5f906b$var$collectVariables(el.children, vars);
        }
    });
}
function $e0a0fed74a5f906b$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $e0a0fed74a5f906b$var$collectVariables(a, aVars);
    $e0a0fed74a5f906b$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $4ItHS.TYPE)[type], " vs ").concat((0, $4ItHS.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("8DVvT", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $64ae94358181ec96$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $64ae94358181ec96$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $64ae94358181ec96$export$275d4a3bb5f66fda);
parcelRequire("lnKw8");
var $4ItHS = parcelRequire("4ItHS");

var $8RsfL = parcelRequire("8RsfL");
var $64ae94358181ec96$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($64ae94358181ec96$export$49694c2877b44c57 || ($64ae94358181ec96$export$49694c2877b44c57 = {}));
function $64ae94358181ec96$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $64ae94358181ec96$export$49694c2877b44c57.literal || part.type !== $64ae94358181ec96$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $64ae94358181ec96$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $64ae94358181ec96$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $4ItHS.isLiteralElement)(els[0])) return [
        {
            type: $64ae94358181ec96$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $4ItHS.isLiteralElement)(el)) {
            result.push({
                type: $64ae94358181ec96$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $4ItHS.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $64ae94358181ec96$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $8RsfL.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $4ItHS.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $64ae94358181ec96$export$49694c2877b44c57.literal : $64ae94358181ec96$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $4ItHS.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $4ItHS.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $64ae94358181ec96$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4ItHS.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $4ItHS.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $64ae94358181ec96$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4ItHS.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $4ItHS.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $64ae94358181ec96$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4ItHS.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$64ae94358181ec96$export$df0c12a2d414a163(formatFn)) throw new (0, $8RsfL.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $64ae94358181ec96$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $64ae94358181ec96$export$49694c2877b44c57.literal : $64ae94358181ec96$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $4ItHS.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $8RsfL.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $64ae94358181ec96$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $4ItHS.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $8RsfL.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $8RsfL.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $8RsfL.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $64ae94358181ec96$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $64ae94358181ec96$var$mergeLiteral(result);
}

});
parcelRegister("8RsfL", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $6739307b7e291cd7$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $6739307b7e291cd7$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $6739307b7e291cd7$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $6739307b7e291cd7$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $6739307b7e291cd7$export$8bfc137e4d23fdf0);

var $hAGHN = parcelRequire("hAGHN");
var $6739307b7e291cd7$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($6739307b7e291cd7$export$d4e71bc0b80dc0fb || ($6739307b7e291cd7$export$d4e71bc0b80dc0fb = {}));
var $6739307b7e291cd7$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $6739307b7e291cd7$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $6739307b7e291cd7$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($6739307b7e291cd7$export$7369836851cc1329);
var $6739307b7e291cd7$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $6739307b7e291cd7$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($6739307b7e291cd7$export$7369836851cc1329);
var $6739307b7e291cd7$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $6739307b7e291cd7$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($6739307b7e291cd7$export$7369836851cc1329);

});




parcelRegister("cyePY", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $92342b60a66daf2f$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $92342b60a66daf2f$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $92342b60a66daf2f$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $92342b60a66daf2f$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $92342b60a66daf2f$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $92342b60a66daf2f$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $92342b60a66daf2f$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $92342b60a66daf2f$export$2ddcb436d0aa3688);

var $hAGHN = parcelRequire("hAGHN");
var $92342b60a66daf2f$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($92342b60a66daf2f$export$557d6acb76e8a244 || ($92342b60a66daf2f$export$557d6acb76e8a244 = {}));
var $92342b60a66daf2f$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $92342b60a66daf2f$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $92342b60a66daf2f$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($92342b60a66daf2f$export$c016d36112f6ddf8);
var $92342b60a66daf2f$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $92342b60a66daf2f$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($92342b60a66daf2f$export$c016d36112f6ddf8);
var $92342b60a66daf2f$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $92342b60a66daf2f$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($92342b60a66daf2f$export$c016d36112f6ddf8);
var $92342b60a66daf2f$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $92342b60a66daf2f$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($92342b60a66daf2f$export$c016d36112f6ddf8);
var $92342b60a66daf2f$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($92342b60a66daf2f$export$e3b7eee1dbc44895);
var $92342b60a66daf2f$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $92342b60a66daf2f$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($92342b60a66daf2f$export$c016d36112f6ddf8);

});



parcelRegister("eE0yt", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $aa953b4f7f3ac3c7$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $aa953b4f7f3ac3c7$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $aa953b4f7f3ac3c7$export$2e2bcd8739ae039);

var $hAGHN = parcelRequire("hAGHN");

var $3d4zD = parcelRequire("3d4zD");

var $lE8gv = parcelRequire("lE8gv");

var $23DKV = parcelRequire("23DKV");
function $aa953b4f7f3ac3c7$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $aa953b4f7f3ac3c7$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $lE8gv.createContext(null)) : $lE8gv.createContext(null);
var $aa953b4f7f3ac3c7$var$IntlConsumer = $aa953b4f7f3ac3c7$var$IntlContext.Consumer, $aa953b4f7f3ac3c7$var$IntlProvider = $aa953b4f7f3ac3c7$var$IntlContext.Provider;
var $aa953b4f7f3ac3c7$export$2881499e37b75b9a = $aa953b4f7f3ac3c7$var$IntlProvider;
var $aa953b4f7f3ac3c7$export$841858b892ce1f4c = $aa953b4f7f3ac3c7$var$IntlContext;
function $aa953b4f7f3ac3c7$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $lE8gv.createElement($aa953b4f7f3ac3c7$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $23DKV.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $lE8gv.createElement(WrappedComponent, (0, $hAGHN.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($aa953b4f7f3ac3c7$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($3d4zD)))(// @ts-expect-error
    $lE8gv.forwardRef(function(props, ref) {
        return $lE8gv.createElement(WithIntl, (0, $hAGHN.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3d4zD)))(WithIntl, WrappedComponent);
}

});
parcelRegister("3d4zD", function(module, exports) {
'use strict';

var $km47W = parcelRequire("km47W");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $256622459ebc98f1$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $256622459ebc98f1$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $256622459ebc98f1$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $256622459ebc98f1$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $256622459ebc98f1$var$TYPE_STATICS = {};
$256622459ebc98f1$var$TYPE_STATICS[$km47W.ForwardRef] = $256622459ebc98f1$var$FORWARD_REF_STATICS;
$256622459ebc98f1$var$TYPE_STATICS[$km47W.Memo] = $256622459ebc98f1$var$MEMO_STATICS;
function $256622459ebc98f1$var$getStatics(component) {
    // React v16.11 and below
    if ($km47W.isMemo(component)) return $256622459ebc98f1$var$MEMO_STATICS;
     // React v16.12 and above
    return $256622459ebc98f1$var$TYPE_STATICS[component['$$typeof']] || $256622459ebc98f1$var$REACT_STATICS;
}
var $256622459ebc98f1$var$defineProperty = Object.defineProperty;
var $256622459ebc98f1$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $256622459ebc98f1$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $256622459ebc98f1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $256622459ebc98f1$var$getPrototypeOf = Object.getPrototypeOf;
var $256622459ebc98f1$var$objectPrototype = Object.prototype;
function $256622459ebc98f1$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($256622459ebc98f1$var$objectPrototype) {
            var inheritedComponent = $256622459ebc98f1$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $256622459ebc98f1$var$objectPrototype) $256622459ebc98f1$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $256622459ebc98f1$var$getOwnPropertyNames(sourceComponent);
        if ($256622459ebc98f1$var$getOwnPropertySymbols) keys = keys.concat($256622459ebc98f1$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $256622459ebc98f1$var$getStatics(targetComponent);
        var sourceStatics = $256622459ebc98f1$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$256622459ebc98f1$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $256622459ebc98f1$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $256622459ebc98f1$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $256622459ebc98f1$var$hoistNonReactStatics;

});
parcelRegister("km47W", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aureA"));

});
parcelRegister("aureA", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $7a31d4dfca516014$export$2b8d127b894957b9, (v) => $7a31d4dfca516014$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $7a31d4dfca516014$export$cea3a54a6425200c, (v) => $7a31d4dfca516014$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $7a31d4dfca516014$export$a7c73072b1a182ae, (v) => $7a31d4dfca516014$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $7a31d4dfca516014$export$9f27bc3417b4524d, (v) => $7a31d4dfca516014$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $7a31d4dfca516014$export$db77ccec0bb4ccac, (v) => $7a31d4dfca516014$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $7a31d4dfca516014$export$8392c0c9d3dcbd35, (v) => $7a31d4dfca516014$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $7a31d4dfca516014$export$ffb0004e005737fa, (v) => $7a31d4dfca516014$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $7a31d4dfca516014$export$b624eff549462981, (v) => $7a31d4dfca516014$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $7a31d4dfca516014$export$7897aa7841a5380c, (v) => $7a31d4dfca516014$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $7a31d4dfca516014$export$602eac185826482c, (v) => $7a31d4dfca516014$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $7a31d4dfca516014$export$e2c29f18771995cb, (v) => $7a31d4dfca516014$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $7a31d4dfca516014$export$5f8d39834fd61797, (v) => $7a31d4dfca516014$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7a31d4dfca516014$export$74bf444e3cd11ea5, (v) => $7a31d4dfca516014$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $7a31d4dfca516014$export$92387174baf9b227, (v) => $7a31d4dfca516014$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $7a31d4dfca516014$export$ec112efeb987d9c6, (v) => $7a31d4dfca516014$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $7a31d4dfca516014$export$b706b080d889d2c9, (v) => $7a31d4dfca516014$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $7a31d4dfca516014$export$5be5a87408f70ddc, (v) => $7a31d4dfca516014$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $7a31d4dfca516014$export$45a5e7f76e0caa8d, (v) => $7a31d4dfca516014$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $7a31d4dfca516014$export$455c2e768291efa6, (v) => $7a31d4dfca516014$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $7a31d4dfca516014$export$9522e17588c12572, (v) => $7a31d4dfca516014$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $7a31d4dfca516014$export$2110ac352bb060b9, (v) => $7a31d4dfca516014$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $7a31d4dfca516014$export$56885ab8b9c456ab, (v) => $7a31d4dfca516014$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $7a31d4dfca516014$export$d927fcb6adf8f9de, (v) => $7a31d4dfca516014$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $7a31d4dfca516014$export$b82d16f27459e05a, (v) => $7a31d4dfca516014$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $7a31d4dfca516014$export$522c17b4f5e123e8, (v) => $7a31d4dfca516014$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $7a31d4dfca516014$export$1aabd8a0274ecfd6, (v) => $7a31d4dfca516014$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $7a31d4dfca516014$export$9b621391a187a31a, (v) => $7a31d4dfca516014$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $7a31d4dfca516014$export$f5bbd400c2f4426f, (v) => $7a31d4dfca516014$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7a31d4dfca516014$export$2b8d127b894957b9;
var $7a31d4dfca516014$export$cea3a54a6425200c;
var $7a31d4dfca516014$export$a7c73072b1a182ae;
var $7a31d4dfca516014$export$9f27bc3417b4524d;
var $7a31d4dfca516014$export$db77ccec0bb4ccac;
var $7a31d4dfca516014$export$8392c0c9d3dcbd35;
var $7a31d4dfca516014$export$ffb0004e005737fa;
var $7a31d4dfca516014$export$b624eff549462981;
var $7a31d4dfca516014$export$7897aa7841a5380c;
var $7a31d4dfca516014$export$602eac185826482c;
var $7a31d4dfca516014$export$e2c29f18771995cb;
var $7a31d4dfca516014$export$5f8d39834fd61797;
var $7a31d4dfca516014$export$74bf444e3cd11ea5;
var $7a31d4dfca516014$export$92387174baf9b227;
var $7a31d4dfca516014$export$ec112efeb987d9c6;
var $7a31d4dfca516014$export$b706b080d889d2c9;
var $7a31d4dfca516014$export$5be5a87408f70ddc;
var $7a31d4dfca516014$export$45a5e7f76e0caa8d;
var $7a31d4dfca516014$export$455c2e768291efa6;
var $7a31d4dfca516014$export$9522e17588c12572;
var $7a31d4dfca516014$export$2110ac352bb060b9;
var $7a31d4dfca516014$export$56885ab8b9c456ab;
var $7a31d4dfca516014$export$d927fcb6adf8f9de;
var $7a31d4dfca516014$export$b82d16f27459e05a;
var $7a31d4dfca516014$export$522c17b4f5e123e8;
var $7a31d4dfca516014$export$1aabd8a0274ecfd6;
var $7a31d4dfca516014$export$9b621391a187a31a;
var $7a31d4dfca516014$export$f5bbd400c2f4426f;
'use strict';
var $7a31d4dfca516014$var$b = "function" === typeof Symbol && Symbol.for, $7a31d4dfca516014$var$c = $7a31d4dfca516014$var$b ? Symbol.for("react.element") : 60103, $7a31d4dfca516014$var$d = $7a31d4dfca516014$var$b ? Symbol.for("react.portal") : 60106, $7a31d4dfca516014$var$e = $7a31d4dfca516014$var$b ? Symbol.for("react.fragment") : 60107, $7a31d4dfca516014$var$f = $7a31d4dfca516014$var$b ? Symbol.for("react.strict_mode") : 60108, $7a31d4dfca516014$var$g = $7a31d4dfca516014$var$b ? Symbol.for("react.profiler") : 60114, $7a31d4dfca516014$var$h = $7a31d4dfca516014$var$b ? Symbol.for("react.provider") : 60109, $7a31d4dfca516014$var$k = $7a31d4dfca516014$var$b ? Symbol.for("react.context") : 60110, $7a31d4dfca516014$var$l = $7a31d4dfca516014$var$b ? Symbol.for("react.async_mode") : 60111, $7a31d4dfca516014$var$m = $7a31d4dfca516014$var$b ? Symbol.for("react.concurrent_mode") : 60111, $7a31d4dfca516014$var$n = $7a31d4dfca516014$var$b ? Symbol.for("react.forward_ref") : 60112, $7a31d4dfca516014$var$p = $7a31d4dfca516014$var$b ? Symbol.for("react.suspense") : 60113, $7a31d4dfca516014$var$q = $7a31d4dfca516014$var$b ? Symbol.for("react.suspense_list") : 60120, $7a31d4dfca516014$var$r = $7a31d4dfca516014$var$b ? Symbol.for("react.memo") : 60115, $7a31d4dfca516014$var$t = $7a31d4dfca516014$var$b ? Symbol.for("react.lazy") : 60116, $7a31d4dfca516014$var$v = $7a31d4dfca516014$var$b ? Symbol.for("react.block") : 60121, $7a31d4dfca516014$var$w = $7a31d4dfca516014$var$b ? Symbol.for("react.fundamental") : 60117, $7a31d4dfca516014$var$x = $7a31d4dfca516014$var$b ? Symbol.for("react.responder") : 60118, $7a31d4dfca516014$var$y = $7a31d4dfca516014$var$b ? Symbol.for("react.scope") : 60119;
function $7a31d4dfca516014$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $7a31d4dfca516014$var$c:
                switch(a = a.type, a){
                    case $7a31d4dfca516014$var$l:
                    case $7a31d4dfca516014$var$m:
                    case $7a31d4dfca516014$var$e:
                    case $7a31d4dfca516014$var$g:
                    case $7a31d4dfca516014$var$f:
                    case $7a31d4dfca516014$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7a31d4dfca516014$var$k:
                            case $7a31d4dfca516014$var$n:
                            case $7a31d4dfca516014$var$t:
                            case $7a31d4dfca516014$var$r:
                            case $7a31d4dfca516014$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $7a31d4dfca516014$var$d:
                return u;
        }
    }
}
function $7a31d4dfca516014$var$A(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$m;
}
$7a31d4dfca516014$export$2b8d127b894957b9 = $7a31d4dfca516014$var$l;
$7a31d4dfca516014$export$cea3a54a6425200c = $7a31d4dfca516014$var$m;
$7a31d4dfca516014$export$a7c73072b1a182ae = $7a31d4dfca516014$var$k;
$7a31d4dfca516014$export$9f27bc3417b4524d = $7a31d4dfca516014$var$h;
$7a31d4dfca516014$export$db77ccec0bb4ccac = $7a31d4dfca516014$var$c;
$7a31d4dfca516014$export$8392c0c9d3dcbd35 = $7a31d4dfca516014$var$n;
$7a31d4dfca516014$export$ffb0004e005737fa = $7a31d4dfca516014$var$e;
$7a31d4dfca516014$export$b624eff549462981 = $7a31d4dfca516014$var$t;
$7a31d4dfca516014$export$7897aa7841a5380c = $7a31d4dfca516014$var$r;
$7a31d4dfca516014$export$602eac185826482c = $7a31d4dfca516014$var$d;
$7a31d4dfca516014$export$e2c29f18771995cb = $7a31d4dfca516014$var$g;
$7a31d4dfca516014$export$5f8d39834fd61797 = $7a31d4dfca516014$var$f;
$7a31d4dfca516014$export$74bf444e3cd11ea5 = $7a31d4dfca516014$var$p;
$7a31d4dfca516014$export$92387174baf9b227 = function(a) {
    return $7a31d4dfca516014$var$A(a) || $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$l;
};
$7a31d4dfca516014$export$ec112efeb987d9c6 = $7a31d4dfca516014$var$A;
$7a31d4dfca516014$export$b706b080d889d2c9 = function(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$k;
};
$7a31d4dfca516014$export$5be5a87408f70ddc = function(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$h;
};
$7a31d4dfca516014$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7a31d4dfca516014$var$c;
};
$7a31d4dfca516014$export$455c2e768291efa6 = function(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$n;
};
$7a31d4dfca516014$export$9522e17588c12572 = function(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$e;
};
$7a31d4dfca516014$export$2110ac352bb060b9 = function(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$t;
};
$7a31d4dfca516014$export$56885ab8b9c456ab = function(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$r;
};
$7a31d4dfca516014$export$d927fcb6adf8f9de = function(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$d;
};
$7a31d4dfca516014$export$b82d16f27459e05a = function(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$g;
};
$7a31d4dfca516014$export$522c17b4f5e123e8 = function(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$f;
};
$7a31d4dfca516014$export$1aabd8a0274ecfd6 = function(a) {
    return $7a31d4dfca516014$var$z(a) === $7a31d4dfca516014$var$p;
};
$7a31d4dfca516014$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7a31d4dfca516014$var$e || a === $7a31d4dfca516014$var$m || a === $7a31d4dfca516014$var$g || a === $7a31d4dfca516014$var$f || a === $7a31d4dfca516014$var$p || a === $7a31d4dfca516014$var$q || "object" === typeof a && null !== a && (a.$$typeof === $7a31d4dfca516014$var$t || a.$$typeof === $7a31d4dfca516014$var$r || a.$$typeof === $7a31d4dfca516014$var$h || a.$$typeof === $7a31d4dfca516014$var$k || a.$$typeof === $7a31d4dfca516014$var$n || a.$$typeof === $7a31d4dfca516014$var$w || a.$$typeof === $7a31d4dfca516014$var$x || a.$$typeof === $7a31d4dfca516014$var$y || a.$$typeof === $7a31d4dfca516014$var$v);
};
$7a31d4dfca516014$export$f5bbd400c2f4426f = $7a31d4dfca516014$var$z;

});






parcelRegister("2Ahkp", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $1e1c628fed7e749f$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hAGHN = parcelRequire("hAGHN");

var $h1Jug = parcelRequire("h1Jug");
var $eW6Q1 = parcelRequire("eW6Q1");

var $8DVvT = parcelRequire("8DVvT");

var $23DKV = parcelRequire("23DKV");
function $1e1c628fed7e749f$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $8DVvT.isFormatXMLElementFn)(v) ? (0, $23DKV.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $1e1c628fed7e749f$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $1e1c628fed7e749f$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $eW6Q1.formatMessage).apply(void 0, (0, $hAGHN.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $23DKV.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var $1e1c628fed7e749f$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $hAGHN.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $1e1c628fed7e749f$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $h1Jug.createIntl)((0, $hAGHN.__assign)((0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, (0, $23DKV.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, coreIntl), {
        formatMessage: $1e1c628fed7e749f$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $1e1c628fed7e749f$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("h1Jug", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $c655d0775992c9b5$export$7e4cbedfdd7b4c0d);

var $hAGHN = parcelRequire("hAGHN");

var $lIb0S = parcelRequire("lIb0S");

var $7cOQN = parcelRequire("7cOQN");

var $cyePY = parcelRequire("cyePY");

var $edpHA = parcelRequire("edpHA");

var $eW6Q1 = parcelRequire("eW6Q1");

var $iABZw = parcelRequire("iABZw");

var $ltGDX = parcelRequire("ltGDX");

var $dHc7N = parcelRequire("dHc7N");

var $2oTn3 = parcelRequire("2oTn3");
function $c655d0775992c9b5$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $c655d0775992c9b5$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $c655d0775992c9b5$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $c655d0775992c9b5$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $2oTn3.createFormatters)(cache);
    var resolvedConfig = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, (0, $2oTn3.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $cyePY.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $cyePY.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $cyePY.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $c655d0775992c9b5$var$verifyConfigMessages(resolvedConfig);
    return (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $iABZw.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $iABZw.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $dHc7N.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $lIb0S.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $lIb0S.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $lIb0S.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $lIb0S.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $lIb0S.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $ltGDX.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $eW6Q1.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $eW6Q1.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $edpHA.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $edpHA.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $7cOQN.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("lIb0S", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $fce64006fa78e509$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $fce64006fa78e509$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $fce64006fa78e509$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $fce64006fa78e509$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $fce64006fa78e509$export$af6e5d7a5c73edeb);

var $hAGHN = parcelRequire("hAGHN");

var $cyePY = parcelRequire("cyePY");

var $2oTn3 = parcelRequire("2oTn3");
var $fce64006fa78e509$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $fce64006fa78e509$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $2oTn3.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $2oTn3.filterProps)(options, $fce64006fa78e509$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $fce64006fa78e509$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $fce64006fa78e509$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $cyePY.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $fce64006fa78e509$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $fce64006fa78e509$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $cyePY.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $fce64006fa78e509$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $fce64006fa78e509$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $cyePY.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $fce64006fa78e509$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $fce64006fa78e509$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $cyePY.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $fce64006fa78e509$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $fce64006fa78e509$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $cyePY.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("7cOQN", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $53f11944704cab55$export$62fe1a4d9e891fa2);

var $2oTn3 = parcelRequire("2oTn3");

var $8RsfL = parcelRequire("8RsfL");

var $cyePY = parcelRequire("cyePY");
var $53f11944704cab55$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $53f11944704cab55$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $8RsfL.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $8RsfL.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $2oTn3.filterProps)(options, $53f11944704cab55$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $cyePY.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});

parcelRegister("edpHA", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $a596377750362751$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $a596377750362751$export$6f284aad1934db69);

var $hAGHN = parcelRequire("hAGHN");

var $8RsfL = parcelRequire("8RsfL");

var $cyePY = parcelRequire("cyePY");

var $2oTn3 = parcelRequire("2oTn3");
var $a596377750362751$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $a596377750362751$var$now = Date.now();
function $a596377750362751$var$generateToken(i) {
    return "".concat($a596377750362751$var$now, "_").concat(i, "_").concat($a596377750362751$var$now);
}
function $a596377750362751$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $a596377750362751$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $a596377750362751$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $8RsfL.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $8RsfL.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $2oTn3.filterProps)(options, $a596377750362751$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $a596377750362751$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $cyePY.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("eW6Q1", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $adfbc957df8b0057$export$25868d1e8e76735f);

var $hAGHN = parcelRequire("hAGHN");
parcelRequire("lnKw8");
var $4ItHS = parcelRequire("4ItHS");
parcelRequire("4r6Ix");
var $dkzrm = parcelRequire("dkzrm");

var $cyePY = parcelRequire("cyePY");

var $2oTn3 = parcelRequire("2oTn3");
function $adfbc957df8b0057$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $hAGHN.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $adfbc957df8b0057$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $adfbc957df8b0057$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $dkzrm.IntlMessageFormat).formats;
    return (0, $hAGHN.__assign)((0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, mfFormats), f1), {
        date: $adfbc957df8b0057$var$deepMergeOptions($adfbc957df8b0057$var$setTimeZoneInOptions(mfFormats.date, timeZone), $adfbc957df8b0057$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $adfbc957df8b0057$var$deepMergeOptions($adfbc957df8b0057$var$setTimeZoneInOptions(mfFormats.time, timeZone), $adfbc957df8b0057$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $adfbc957df8b0057$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $2oTn3.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $4ItHS.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $hAGHN.__assign)((0, $hAGHN.__assign)({}, defaultRichTextElements), values || {});
    formats = $adfbc957df8b0057$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $adfbc957df8b0057$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $cyePY.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $cyePY.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $hAGHN.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $cyePY.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $cyePY.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("iABZw", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $d8890f0f223e6c88$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $d8890f0f223e6c88$export$6871080848f10b2f);

var $cyePY = parcelRequire("cyePY");

var $2oTn3 = parcelRequire("2oTn3");
var $d8890f0f223e6c88$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $d8890f0f223e6c88$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $2oTn3.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $2oTn3.filterProps)(options, $d8890f0f223e6c88$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $d8890f0f223e6c88$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $d8890f0f223e6c88$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $cyePY.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $d8890f0f223e6c88$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $d8890f0f223e6c88$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $cyePY.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("ltGDX", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $fa2d628278544460$export$bbbd05c900f3568d);

var $8RsfL = parcelRequire("8RsfL");

var $cyePY = parcelRequire("cyePY");

var $2oTn3 = parcelRequire("2oTn3");
var $fa2d628278544460$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $fa2d628278544460$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $8RsfL.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $8RsfL.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $2oTn3.filterProps)(options, $fa2d628278544460$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $cyePY.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("dHc7N", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $9f88b23c61c83284$export$b4ea3b48dcf921f6);

var $2oTn3 = parcelRequire("2oTn3");

var $8RsfL = parcelRequire("8RsfL");

var $cyePY = parcelRequire("cyePY");
var $9f88b23c61c83284$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $9f88b23c61c83284$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $2oTn3.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $2oTn3.filterProps)(options, $9f88b23c61c83284$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $9f88b23c61c83284$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $8RsfL.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $8RsfL.ErrorCode).MISSING_INTL_API));
    try {
        return $9f88b23c61c83284$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $cyePY.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});



parcelRegister("jnRAN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1c9bca6c57a3ccc$export$2e2bcd8739ae039);

var $hAGHN = parcelRequire("hAGHN");

var $lE8gv = parcelRequire("lE8gv");

var $cEINl = parcelRequire("cEINl");
var $e1c9bca6c57a3ccc$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $cEINl.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $hAGHN.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $lE8gv.Fragment;
    return $lE8gv.createElement(Text, null, formattedValue);
};
$e1c9bca6c57a3ccc$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $e1c9bca6c57a3ccc$export$2e2bcd8739ae039 = $e1c9bca6c57a3ccc$var$FormattedDateTimeRange;

});

parcelRegister("b1WJB", function(module, exports) {
$parcel$export(module.exports, "default", () => $807d592b6a038768$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hAGHN = parcelRequire("hAGHN");

var $lE8gv = parcelRequire("lE8gv");

var $23DKV = parcelRequire("23DKV");

var $cEINl = parcelRequire("cEINl");
function $807d592b6a038768$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $hAGHN.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $hAGHN.__rest)(nextProps, [
        "values"
    ]);
    return (0, $23DKV.shallowEqual)(nextValues, values) && (0, $23DKV.shallowEqual)(otherProps, nextOtherProps);
}
function $807d592b6a038768$var$FormattedMessage(props) {
    var intl = (0, $cEINl.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $lE8gv.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $lE8gv.createElement(Component, null, nodes);
    return $lE8gv.createElement($lE8gv.Fragment, null, nodes);
}
$807d592b6a038768$var$FormattedMessage.displayName = 'FormattedMessage';
var $807d592b6a038768$var$MemoizedFormattedMessage = $lE8gv.memo($807d592b6a038768$var$FormattedMessage, $807d592b6a038768$var$areEqual);
$807d592b6a038768$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $807d592b6a038768$export$2e2bcd8739ae039 = $807d592b6a038768$var$MemoizedFormattedMessage;

});

parcelRegister("jStMN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e78a2a5b674dd385$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $lE8gv = parcelRequire("lE8gv");

var $cEINl = parcelRequire("cEINl");
var $e78a2a5b674dd385$var$FormattedPlural = function(props) {
    var _a = (0, $cEINl.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $lE8gv.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$e78a2a5b674dd385$var$FormattedPlural.displayName = 'FormattedPlural';
var $e78a2a5b674dd385$export$2e2bcd8739ae039 = $e78a2a5b674dd385$var$FormattedPlural;

});

parcelRegister("dDntd", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ed11f8f1d7303cf$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hAGHN = parcelRequire("hAGHN");

var $2oTn3 = parcelRequire("2oTn3");

var $lE8gv = parcelRequire("lE8gv");

var $23DKV = parcelRequire("23DKV");

var $2Ahkp = parcelRequire("2Ahkp");

var $eE0yt = parcelRequire("eE0yt");
function $9ed11f8f1d7303cf$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $9ed11f8f1d7303cf$var$IntlProvider = /** @class */ function(_super) {
    (0, $hAGHN.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $2oTn3.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $2Ahkp.createIntl)($9ed11f8f1d7303cf$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $9ed11f8f1d7303cf$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $9ed11f8f1d7303cf$var$processIntlConfig(props);
        if (!(0, $23DKV.shallowEqual)(prevConfig, config)) return {
            intl: (0, $2Ahkp.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $23DKV.invariantIntlContext)(this.state.intl);
        return $lE8gv.createElement((0, $eE0yt.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $23DKV.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($lE8gv.PureComponent);
var $9ed11f8f1d7303cf$export$2e2bcd8739ae039 = $9ed11f8f1d7303cf$var$IntlProvider;

});

parcelRegister("dRwNn", function(module, exports) {
$parcel$export(module.exports, "default", () => $a179aa15c9c3afe2$export$2e2bcd8739ae039);

var $hAGHN = parcelRequire("hAGHN");

var $lE8gv = parcelRequire("lE8gv");

var $23DKV = parcelRequire("23DKV");

var $cEINl = parcelRequire("cEINl");
var $a179aa15c9c3afe2$var$MINUTE = 60;
var $a179aa15c9c3afe2$var$HOUR = 3600;
var $a179aa15c9c3afe2$var$DAY = 86400;
function $a179aa15c9c3afe2$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $a179aa15c9c3afe2$var$MINUTE) return 'second';
    if (absValue < $a179aa15c9c3afe2$var$HOUR) return 'minute';
    if (absValue < $a179aa15c9c3afe2$var$DAY) return 'hour';
    return 'day';
}
function $a179aa15c9c3afe2$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $a179aa15c9c3afe2$var$MINUTE;
        case 'hour':
            return $a179aa15c9c3afe2$var$HOUR;
        default:
            return $a179aa15c9c3afe2$var$DAY;
    }
}
function $a179aa15c9c3afe2$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $a179aa15c9c3afe2$var$MINUTE;
        default:
            return value * $a179aa15c9c3afe2$var$HOUR;
    }
}
var $a179aa15c9c3afe2$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $a179aa15c9c3afe2$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $a179aa15c9c3afe2$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $a179aa15c9c3afe2$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $cEINl.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $hAGHN.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $lE8gv.createElement(Text, null, formattedRelativeTime);
    return $lE8gv.createElement($lE8gv.Fragment, null, formattedRelativeTime);
};
var $a179aa15c9c3afe2$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $hAGHN.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $23DKV.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $a179aa15c9c3afe2$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $lE8gv.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $lE8gv.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $lE8gv.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($a179aa15c9c3afe2$var$canIncrement(unit) ? $a179aa15c9c3afe2$var$valueToSeconds(value, unit) : 0);
    }
    $lE8gv.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$a179aa15c9c3afe2$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $a179aa15c9c3afe2$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $a179aa15c9c3afe2$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($a179aa15c9c3afe2$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $a179aa15c9c3afe2$var$selectUnit(currentValueInSeconds);
        var unitDuration = $a179aa15c9c3afe2$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $lE8gv.createElement($a179aa15c9c3afe2$var$SimpleFormattedRelativeTime, (0, $hAGHN.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$a179aa15c9c3afe2$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $a179aa15c9c3afe2$export$2e2bcd8739ae039 = $a179aa15c9c3afe2$var$FormattedRelativeTime;

});


parcelRegister("dsB9C", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $26e1f8f63c84d6b9$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $jDc63 = parcelRequire("jDc63");

var $ik5Jo = parcelRequire("ik5Jo");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $26e1f8f63c84d6b9$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $jDc63.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $ik5Jo.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$26e1f8f63c84d6b9$var$LoadingButton.displayName = 'LoadingButton';
var $26e1f8f63c84d6b9$export$2e2bcd8739ae039 = $26e1f8f63c84d6b9$var$LoadingButton;

});
parcelRegister("jDc63", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7ab1eda0a5c8b53e$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $6esjp = parcelRequire("6esjp");

var $jYNYi = parcelRequire("jYNYi");

var $eQ9iz = parcelRequire("eQ9iz");

var $9T5IV = parcelRequire("9T5IV");
const $7ab1eda0a5c8b53e$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $7ab1eda0a5c8b53e$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $6esjp.default), onMouseUp: providedOnMouseUp = (0, $6esjp.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $9T5IV.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $lE8gv.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $lE8gv.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($7ab1eda0a5c8b53e$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $lE8gv.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($7ab1eda0a5c8b53e$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $lE8gv.useMemo)(()=>(0, $eQ9iz.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $jYNYi.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$7ab1eda0a5c8b53e$var$Button.displayName = 'Button';
var $7ab1eda0a5c8b53e$export$2e2bcd8739ae039 = $7ab1eda0a5c8b53e$var$Button;

});
parcelRegister("6esjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a1a4fabcacb40f9$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $1a1a4fabcacb40f9$export$2e2bcd8739ae039() {}

});

parcelRegister("jYNYi", function(module, exports) {
$parcel$export(module.exports, "default", () => $114487aee9ebddd8$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-deprecated-imports, @atlaskit/platform/no-direct-document-usage -- Preserve old-button behavior while focus-ring usage is reviewed separately. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lE8gv = parcelRequire("lE8gv");

var $2ED8z = parcelRequire("2ED8z");

var $lC4HT = parcelRequire("lC4HT");

var $6esjp = parcelRequire("6esjp");

var $9oEM9 = parcelRequire("9oEM9");

var $4XQkK = parcelRequire("4XQkK");

var $dMSHp = parcelRequire("dMSHp");

var $5rLnZ = parcelRequire("5rLnZ");

var $48VL9 = parcelRequire("48VL9");

var $arZmL = parcelRequire("arZmL");

var $1f9sc = parcelRequire("1f9sc");

var $eyLlK = parcelRequire("eyLlK");

var $2FFxg = parcelRequire("2FFxg");
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $114487aee9ebddd8$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ const $114487aee9ebddd8$var$iconBeforeSpacingFixStyle = (0, $2ED8z.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
const $114487aee9ebddd8$var$iconAfterSpacingFixStyle = (0, $2ED8z.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
const $114487aee9ebddd8$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $eyLlK.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $114487aee9ebddd8$var$getChildren = (children, childrenStyles)=>{
    if ((0, $eyLlK.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $2ED8z.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $114487aee9ebddd8$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $6esjp.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $6esjp.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $lE8gv.useRef)();
    const setRef = (0, $lE8gv.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $9oEM9.default)(ourRef, autoFocus);
    const interactionContext = (0, $lE8gv.useContext)((0, $dMSHp.default));
    const handleClick = (0, $lE8gv.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $lC4HT.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $lE8gv.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $lE8gv.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = (0, $2ED8z.css)((0, $arZmL.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $2ED8z.jsx)((0, $4XQkK.default), null, /*#__PURE__*/ (0, $2ED8z.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $114487aee9ebddd8$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $5rLnZ.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $2ED8z.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1f9sc.getIconStyle)({
                spacing: spacing
            }),
            $114487aee9ebddd8$var$getSpacingFix(children, $114487aee9ebddd8$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $114487aee9ebddd8$var$getChildren(children, [
        fadeStyles,
        (0, $48VL9.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $2ED8z.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1f9sc.getIconStyle)({
                spacing: spacing
            }),
            $114487aee9ebddd8$var$getSpacingFix(children, $114487aee9ebddd8$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $2ED8z.jsx)("span", {
        css: [
            (0, $2FFxg.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$114487aee9ebddd8$export$2e2bcd8739ae039 = $114487aee9ebddd8$var$ButtonBase;

});
parcelRegister("2ED8z", function(module, exports) {
$parcel$export(module.exports, "createElement", () => $1eedad0556ad05aa$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "Global", () => $1eedad0556ad05aa$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $1eedad0556ad05aa$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $1eedad0556ad05aa$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $1eedad0556ad05aa$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $1eedad0556ad05aa$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "CacheProvider", () => (parcelRequire("86JFX")).C);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("86JFX")).T);
$parcel$export(module.exports, "ThemeProvider", () => (parcelRequire("86JFX")).a);
$parcel$export(module.exports, "__unsafe_useEmotionCache", () => (parcelRequire("86JFX"))._);
$parcel$export(module.exports, "useTheme", () => (parcelRequire("86JFX")).u);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("86JFX")).w);
$parcel$export(module.exports, "withTheme", () => (parcelRequire("86JFX")).b);

var $86JFX = parcelRequire("86JFX");

var $lE8gv = parcelRequire("lE8gv");

var $3xRFZ = parcelRequire("3xRFZ");

var $iDJnh = parcelRequire("iDJnh");

var $6Zuix = parcelRequire("6Zuix");
parcelRequire("1r0qK");
parcelRequire("fisuc");
parcelRequire("82208");

parcelRequire("3d4zD");
var $1eedad0556ad05aa$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $86JFX.h).call(props, 'css')) return $lE8gv.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $86JFX.E);
    createElementArgArray[1] = (0, $86JFX.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $lE8gv.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($1eedad0556ad05aa$export$c8a8987d4410bf2d || ($1eedad0556ad05aa$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $1eedad0556ad05aa$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $86JFX.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $6Zuix.serializeStyles)([
        styles
    ], undefined, $lE8gv.useContext((0, $86JFX.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $lE8gv.useRef();
    (0, $iDJnh.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $iDJnh.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $3xRFZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $1eedad0556ad05aa$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $6Zuix.serializeStyles)(args);
}
function $1eedad0556ad05aa$export$d25ddfdf17c3ad3e() {
    var insertable = $1eedad0556ad05aa$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $1eedad0556ad05aa$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $1eedad0556ad05aa$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $3xRFZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $1eedad0556ad05aa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $iDJnh.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $3xRFZ.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $1eedad0556ad05aa$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $86JFX.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $86JFX.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $6Zuix.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $3xRFZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $86JFX.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $1eedad0556ad05aa$var$merge(cache.registered, css, $1eedad0556ad05aa$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $lE8gv.useContext((0, $86JFX.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $lE8gv.createElement($lE8gv.Fragment, null, /*#__PURE__*/ $lE8gv.createElement($1eedad0556ad05aa$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("86JFX", function(module, exports) {
$parcel$export(module.exports, "i", () => $5e72508457f4d0ed$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $5e72508457f4d0ed$export$e7094788287c5e9b);
$parcel$export(module.exports, "_", () => $5e72508457f4d0ed$export$71511d61b312f219);
$parcel$export(module.exports, "w", () => $5e72508457f4d0ed$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $5e72508457f4d0ed$export$971d5caa766a69d7);
$parcel$export(module.exports, "u", () => $5e72508457f4d0ed$export$3b14a55fb2447963);
$parcel$export(module.exports, "a", () => $5e72508457f4d0ed$export$407448d2b89b1813);
$parcel$export(module.exports, "b", () => $5e72508457f4d0ed$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $5e72508457f4d0ed$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $5e72508457f4d0ed$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $5e72508457f4d0ed$export$a9c23c6ac3fc3eca);

var $lE8gv = parcelRequire("lE8gv");

var $1r0qK = parcelRequire("1r0qK");

var $fisuc = parcelRequire("fisuc");

var $82208 = parcelRequire("82208");

var $5DCCj = parcelRequire("5DCCj");

var $3xRFZ = parcelRequire("3xRFZ");

var $6Zuix = parcelRequire("6Zuix");

var $iDJnh = parcelRequire("iDJnh");
var $5e72508457f4d0ed$export$23f2a1d2818174ef = false;
var $5e72508457f4d0ed$var$EmotionCacheContext = /* #__PURE__ */ $lE8gv.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $1r0qK.default)({
    key: 'css'
}) : null);
var $5e72508457f4d0ed$export$e7094788287c5e9b = $5e72508457f4d0ed$var$EmotionCacheContext.Provider;
var $5e72508457f4d0ed$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $lE8gv.useContext)($5e72508457f4d0ed$var$EmotionCacheContext);
};
var $5e72508457f4d0ed$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $lE8gv.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $lE8gv.useContext)($5e72508457f4d0ed$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $5e72508457f4d0ed$export$971d5caa766a69d7 = /* #__PURE__ */ $lE8gv.createContext({});
var $5e72508457f4d0ed$export$3b14a55fb2447963 = function useTheme() {
    return $lE8gv.useContext($5e72508457f4d0ed$export$971d5caa766a69d7);
};
var $5e72508457f4d0ed$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $fisuc.default)({}, outerTheme, theme);
};
var $5e72508457f4d0ed$var$createCacheWithTheme = /* #__PURE__ */ (0, $82208.default)(function(outerTheme) {
    return (0, $82208.default)(function(theme) {
        return $5e72508457f4d0ed$var$getTheme(outerTheme, theme);
    });
});
var $5e72508457f4d0ed$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $lE8gv.useContext($5e72508457f4d0ed$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $5e72508457f4d0ed$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $lE8gv.createElement($5e72508457f4d0ed$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $5e72508457f4d0ed$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $lE8gv.forwardRef(function render(props, ref) {
        var theme = $lE8gv.useContext($5e72508457f4d0ed$export$971d5caa766a69d7);
        return /*#__PURE__*/ $lE8gv.createElement(Component, (0, $fisuc.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $5DCCj.default)(WithTheme, Component);
}
var $5e72508457f4d0ed$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $5e72508457f4d0ed$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $5e72508457f4d0ed$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($5e72508457f4d0ed$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$5e72508457f4d0ed$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $5e72508457f4d0ed$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3xRFZ.registerStyles)(cache, serialized, isStringTag);
    (0, $iDJnh.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3xRFZ.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $5e72508457f4d0ed$var$Emotion = /* #__PURE__ */ $5e72508457f4d0ed$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$5e72508457f4d0ed$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $3xRFZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $6Zuix.serializeStyles)(registeredStyles, undefined, $lE8gv.useContext($5e72508457f4d0ed$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($5e72508457f4d0ed$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $5e72508457f4d0ed$var$typePropName && !$5e72508457f4d0ed$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $lE8gv.createElement($lE8gv.Fragment, null, /*#__PURE__*/ $lE8gv.createElement($5e72508457f4d0ed$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $lE8gv.createElement(WrappedComponent, newProps));
});
var $5e72508457f4d0ed$export$a9c23c6ac3fc3eca = $5e72508457f4d0ed$var$Emotion;

});
parcelRegister("1r0qK", function(module, exports) {
$parcel$export(module.exports, "default", () => $10b8a58af4b48bdf$export$2e2bcd8739ae039);

var $6KRLn = parcelRequire("6KRLn");

var $k7Xp9 = parcelRequire("k7Xp9");
var $72Cr0 = parcelRequire("72Cr0");
var $dvKyk = parcelRequire("dvKyk");
var $aHQfh = parcelRequire("aHQfh");
var $fibtN = parcelRequire("fibtN");
var $g8Xdk = parcelRequire("g8Xdk");
parcelRequire("82208");
parcelRequire("873tQ");
var $10b8a58af4b48bdf$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $k7Xp9.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $k7Xp9.token)(character)) break;
        (0, $k7Xp9.next)();
    }
    return (0, $k7Xp9.slice)(begin, (0, $k7Xp9.position));
};
var $10b8a58af4b48bdf$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $k7Xp9.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $k7Xp9.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $10b8a58af4b48bdf$var$identifierWithPointTracking((0, $k7Xp9.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $k7Xp9.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $k7Xp9.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $72Cr0.from)(character);
    }
    while (character = (0, $k7Xp9.next)());
    return parsed;
};
var $10b8a58af4b48bdf$var$getRules = function getRules(value, points) {
    return (0, $k7Xp9.dealloc)($10b8a58af4b48bdf$var$toRules((0, $k7Xp9.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $10b8a58af4b48bdf$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $10b8a58af4b48bdf$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$10b8a58af4b48bdf$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $10b8a58af4b48bdf$var$fixedElements.set(element, true);
    var points = [];
    var rules = $10b8a58af4b48bdf$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $10b8a58af4b48bdf$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $10b8a58af4b48bdf$var$prefix(value, length) {
    switch((0, $72Cr0.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $aHQfh.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $aHQfh.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MOZ) + value + (0, $aHQfh.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + value + value;
        // order
        case 6165:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $aHQfh.WEBKIT) + value + (0, $72Cr0.replace)(value, /(\w+).+(:[^]+)/, (0, $aHQfh.WEBKIT) + 'box-$1$2' + (0, $aHQfh.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + 'flex-item-' + (0, $72Cr0.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + 'flex-line-pack' + (0, $72Cr0.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $aHQfh.WEBKIT) + 'box-' + (0, $72Cr0.replace)(value, '-grow', '') + (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $aHQfh.WEBKIT) + (0, $72Cr0.replace)(value, /([^-])(transform)/g, '$1' + (0, $aHQfh.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $72Cr0.replace)((0, $72Cr0.replace)((0, $72Cr0.replace)(value, /(zoom-|grab)/, (0, $aHQfh.WEBKIT) + '$1'), /(image-set)/, (0, $aHQfh.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $72Cr0.replace)(value, /(image-set\([^]*)/, (0, $aHQfh.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $72Cr0.replace)((0, $72Cr0.replace)(value, /(.+:)(flex-)?(.*)/, (0, $aHQfh.WEBKIT) + 'box-pack:$3' + (0, $aHQfh.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $aHQfh.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $72Cr0.replace)(value, /(.+)-inline(.+)/, (0, $aHQfh.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $72Cr0.strlen)(value) - 1 - length > 6) switch((0, $72Cr0.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $72Cr0.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $72Cr0.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $aHQfh.WEBKIT) + '$2-$3' + '$1' + (0, $aHQfh.MOZ) + ((0, $72Cr0.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $72Cr0.indexof)(value, 'stretch') ? $10b8a58af4b48bdf$var$prefix((0, $72Cr0.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $72Cr0.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $72Cr0.charat)(value, (0, $72Cr0.strlen)(value) - 3 - (~(0, $72Cr0.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $72Cr0.replace)(value, ':', ':' + (0, $aHQfh.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $72Cr0.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $aHQfh.WEBKIT) + ((0, $72Cr0.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $aHQfh.WEBKIT) + '$2$3' + '$1' + (0, $aHQfh.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $72Cr0.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + value + value;
    }
    return value;
}
var $10b8a58af4b48bdf$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $aHQfh.DECLARATION:
                element["return"] = $10b8a58af4b48bdf$var$prefix(element.value, element.length);
                break;
            case 0, $aHQfh.KEYFRAMES:
                return (0, $g8Xdk.serialize)([
                    (0, $k7Xp9.copy)(element, {
                        value: (0, $72Cr0.replace)(element.value, '@', '@' + (0, $aHQfh.WEBKIT))
                    })
                ], callback);
            case 0, $aHQfh.RULESET:
                if (element.length) return (0, $72Cr0.combine)(element.props, function(value) {
                    switch((0, $72Cr0.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $g8Xdk.serialize)([
                                (0, $k7Xp9.copy)(element, {
                                    props: [
                                        (0, $72Cr0.replace)(value, /:(read-\w+)/, ':' + (0, $aHQfh.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $g8Xdk.serialize)([
                                (0, $k7Xp9.copy)(element, {
                                    props: [
                                        (0, $72Cr0.replace)(value, /:(plac\w+)/, ':' + (0, $aHQfh.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $k7Xp9.copy)(element, {
                                    props: [
                                        (0, $72Cr0.replace)(value, /:(plac\w+)/, ':' + (0, $aHQfh.MOZ) + '$1')
                                    ]
                                }),
                                (0, $k7Xp9.copy)(element, {
                                    props: [
                                        (0, $72Cr0.replace)(value, /:(plac\w+)/, (0, $aHQfh.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $10b8a58af4b48bdf$var$defaultStylisPlugins = [
    $10b8a58af4b48bdf$var$prefixer
];
var $10b8a58af4b48bdf$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $10b8a58af4b48bdf$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $10b8a58af4b48bdf$var$compat,
        $10b8a58af4b48bdf$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $g8Xdk.stringify),
        (0, $fibtN.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fibtN.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $g8Xdk.serialize)((0, $dvKyk.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $6KRLn.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("6KRLn", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $4eb0be375283a440$export$9d753cd7ae895cce);
var $4eb0be375283a440$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $4eb0be375283a440$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $4eb0be375283a440$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $4eb0be375283a440$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$4eb0be375283a440$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($4eb0be375283a440$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $4eb0be375283a440$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("k7Xp9", function(module, exports) {
$parcel$export(module.exports, "position", () => $03c80a7e68b5a559$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $03c80a7e68b5a559$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $03c80a7e68b5a559$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $03c80a7e68b5a559$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $03c80a7e68b5a559$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $03c80a7e68b5a559$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $03c80a7e68b5a559$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $03c80a7e68b5a559$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $03c80a7e68b5a559$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $03c80a7e68b5a559$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $03c80a7e68b5a559$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $03c80a7e68b5a559$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $03c80a7e68b5a559$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $03c80a7e68b5a559$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $03c80a7e68b5a559$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $03c80a7e68b5a559$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $03c80a7e68b5a559$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $03c80a7e68b5a559$export$4254d4e2b3745c4c);

var $72Cr0 = parcelRequire("72Cr0");
var $03c80a7e68b5a559$export$53f1d5ea8de3d7c = 1;
var $03c80a7e68b5a559$export$4e0c71f277ca26b3 = 1;
var $03c80a7e68b5a559$export$f24224f1c91d8156 = 0;
var $03c80a7e68b5a559$export$5880b8b5730aff45 = 0;
var $03c80a7e68b5a559$export$c0306caf338ac095 = 0;
var $03c80a7e68b5a559$export$30a86d91af8ff6e6 = '';
function $03c80a7e68b5a559$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $03c80a7e68b5a559$export$53f1d5ea8de3d7c,
        column: $03c80a7e68b5a559$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $03c80a7e68b5a559$export$784d13d8ee351f07(root, props) {
    return (0, $72Cr0.assign)($03c80a7e68b5a559$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $03c80a7e68b5a559$export$eba6f6f03b0a92e7() {
    return $03c80a7e68b5a559$export$c0306caf338ac095;
}
function $03c80a7e68b5a559$export$232faf9add678146() {
    $03c80a7e68b5a559$export$c0306caf338ac095 = $03c80a7e68b5a559$export$5880b8b5730aff45 > 0 ? (0, $72Cr0.charat)($03c80a7e68b5a559$export$30a86d91af8ff6e6, --$03c80a7e68b5a559$export$5880b8b5730aff45) : 0;
    if ($03c80a7e68b5a559$export$4e0c71f277ca26b3--, $03c80a7e68b5a559$export$c0306caf338ac095 === 10) $03c80a7e68b5a559$export$4e0c71f277ca26b3 = 1, $03c80a7e68b5a559$export$53f1d5ea8de3d7c--;
    return $03c80a7e68b5a559$export$c0306caf338ac095;
}
function $03c80a7e68b5a559$export$48cfd1e771a65c4f() {
    $03c80a7e68b5a559$export$c0306caf338ac095 = $03c80a7e68b5a559$export$5880b8b5730aff45 < $03c80a7e68b5a559$export$f24224f1c91d8156 ? (0, $72Cr0.charat)($03c80a7e68b5a559$export$30a86d91af8ff6e6, $03c80a7e68b5a559$export$5880b8b5730aff45++) : 0;
    if ($03c80a7e68b5a559$export$4e0c71f277ca26b3++, $03c80a7e68b5a559$export$c0306caf338ac095 === 10) $03c80a7e68b5a559$export$4e0c71f277ca26b3 = 1, $03c80a7e68b5a559$export$53f1d5ea8de3d7c++;
    return $03c80a7e68b5a559$export$c0306caf338ac095;
}
function $03c80a7e68b5a559$export$4d3fb11e950abb9e() {
    return (0, $72Cr0.charat)($03c80a7e68b5a559$export$30a86d91af8ff6e6, $03c80a7e68b5a559$export$5880b8b5730aff45);
}
function $03c80a7e68b5a559$export$e88cb2efb12ae807() {
    return $03c80a7e68b5a559$export$5880b8b5730aff45;
}
function $03c80a7e68b5a559$export$58adb3bec8346d0f(begin, end) {
    return (0, $72Cr0.substr)($03c80a7e68b5a559$export$30a86d91af8ff6e6, begin, end);
}
function $03c80a7e68b5a559$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $03c80a7e68b5a559$export$2de70f21292aac9e(value) {
    return $03c80a7e68b5a559$export$53f1d5ea8de3d7c = $03c80a7e68b5a559$export$4e0c71f277ca26b3 = 1, $03c80a7e68b5a559$export$f24224f1c91d8156 = (0, $72Cr0.strlen)($03c80a7e68b5a559$export$30a86d91af8ff6e6 = value), $03c80a7e68b5a559$export$5880b8b5730aff45 = 0, [];
}
function $03c80a7e68b5a559$export$45918ac1574455b1(value) {
    return $03c80a7e68b5a559$export$30a86d91af8ff6e6 = '', value;
}
function $03c80a7e68b5a559$export$410ac95b9ec204b8(type) {
    return (0, $72Cr0.trim)($03c80a7e68b5a559$export$58adb3bec8346d0f($03c80a7e68b5a559$export$5880b8b5730aff45 - 1, $03c80a7e68b5a559$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $03c80a7e68b5a559$export$660b2ee2d4fb4eff(value) {
    return $03c80a7e68b5a559$export$45918ac1574455b1($03c80a7e68b5a559$export$5f8c09e3ae6f64e1($03c80a7e68b5a559$export$2de70f21292aac9e(value)));
}
function $03c80a7e68b5a559$export$7af1228ff777d175(type) {
    while($03c80a7e68b5a559$export$c0306caf338ac095 = $03c80a7e68b5a559$export$4d3fb11e950abb9e())if ($03c80a7e68b5a559$export$c0306caf338ac095 < 33) $03c80a7e68b5a559$export$48cfd1e771a65c4f();
    else break;
    return $03c80a7e68b5a559$export$9e1725a4cfeada27(type) > 2 || $03c80a7e68b5a559$export$9e1725a4cfeada27($03c80a7e68b5a559$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $03c80a7e68b5a559$export$5f8c09e3ae6f64e1(children) {
    while($03c80a7e68b5a559$export$48cfd1e771a65c4f())switch($03c80a7e68b5a559$export$9e1725a4cfeada27($03c80a7e68b5a559$export$c0306caf338ac095)){
        case 0:
            (0, $72Cr0.append)($03c80a7e68b5a559$export$c2ab62c7bf24634($03c80a7e68b5a559$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $72Cr0.append)($03c80a7e68b5a559$export$410ac95b9ec204b8($03c80a7e68b5a559$export$c0306caf338ac095), children);
            break;
        default:
            (0, $72Cr0.append)((0, $72Cr0.from)($03c80a7e68b5a559$export$c0306caf338ac095), children);
    }
    return children;
}
function $03c80a7e68b5a559$export$955ba06d119e085e(index, count) {
    while(--count && $03c80a7e68b5a559$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($03c80a7e68b5a559$export$c0306caf338ac095 < 48 || $03c80a7e68b5a559$export$c0306caf338ac095 > 102 || $03c80a7e68b5a559$export$c0306caf338ac095 > 57 && $03c80a7e68b5a559$export$c0306caf338ac095 < 65 || $03c80a7e68b5a559$export$c0306caf338ac095 > 70 && $03c80a7e68b5a559$export$c0306caf338ac095 < 97) break;
    return $03c80a7e68b5a559$export$58adb3bec8346d0f(index, $03c80a7e68b5a559$export$e88cb2efb12ae807() + (count < 6 && $03c80a7e68b5a559$export$4d3fb11e950abb9e() == 32 && $03c80a7e68b5a559$export$48cfd1e771a65c4f() == 32));
}
function $03c80a7e68b5a559$export$c889f2fcc19dbf12(type) {
    while($03c80a7e68b5a559$export$48cfd1e771a65c4f())switch($03c80a7e68b5a559$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $03c80a7e68b5a559$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $03c80a7e68b5a559$export$c889f2fcc19dbf12($03c80a7e68b5a559$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $03c80a7e68b5a559$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $03c80a7e68b5a559$export$48cfd1e771a65c4f();
            break;
    }
    return $03c80a7e68b5a559$export$5880b8b5730aff45;
}
function $03c80a7e68b5a559$export$4254d4e2b3745c4c(type, index) {
    while($03c80a7e68b5a559$export$48cfd1e771a65c4f())// //
    if (type + $03c80a7e68b5a559$export$c0306caf338ac095 === 57) break;
    else if (type + $03c80a7e68b5a559$export$c0306caf338ac095 === 84 && $03c80a7e68b5a559$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $03c80a7e68b5a559$export$58adb3bec8346d0f(index, $03c80a7e68b5a559$export$5880b8b5730aff45 - 1) + '*' + (0, $72Cr0.from)(type === 47 ? type : $03c80a7e68b5a559$export$48cfd1e771a65c4f());
}
function $03c80a7e68b5a559$export$c2ab62c7bf24634(index) {
    while(!$03c80a7e68b5a559$export$9e1725a4cfeada27($03c80a7e68b5a559$export$4d3fb11e950abb9e()))$03c80a7e68b5a559$export$48cfd1e771a65c4f();
    return $03c80a7e68b5a559$export$58adb3bec8346d0f(index, $03c80a7e68b5a559$export$5880b8b5730aff45);
}

});
parcelRegister("72Cr0", function(module, exports) {
$parcel$export(module.exports, "abs", () => $5206889e78c671b2$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $5206889e78c671b2$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $5206889e78c671b2$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $5206889e78c671b2$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $5206889e78c671b2$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $5206889e78c671b2$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $5206889e78c671b2$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $5206889e78c671b2$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $5206889e78c671b2$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $5206889e78c671b2$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $5206889e78c671b2$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $5206889e78c671b2$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $5206889e78c671b2$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $5206889e78c671b2$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $5206889e78c671b2$export$2335f513bbd82c6d = Math.abs;
var $5206889e78c671b2$export$6788812c4e6611e6 = String.fromCharCode;
var $5206889e78c671b2$export$e6e34fd1f2686227 = Object.assign;
function $5206889e78c671b2$export$d6af199866bfb566(value, length) {
    return $5206889e78c671b2$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $5206889e78c671b2$export$a9db5e087081082d(value, 0)) << 2 ^ $5206889e78c671b2$export$a9db5e087081082d(value, 1)) << 2 ^ $5206889e78c671b2$export$a9db5e087081082d(value, 2)) << 2 ^ $5206889e78c671b2$export$a9db5e087081082d(value, 3) : 0;
}
function $5206889e78c671b2$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $5206889e78c671b2$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $5206889e78c671b2$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $5206889e78c671b2$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $5206889e78c671b2$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $5206889e78c671b2$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $5206889e78c671b2$export$36776f635604f274(value) {
    return value.length;
}
function $5206889e78c671b2$export$f9084667e487ed46(value) {
    return value.length;
}
function $5206889e78c671b2$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $5206889e78c671b2$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("dvKyk", function(module, exports) {
$parcel$export(module.exports, "compile", () => $9d6247fcbaa018a9$export$ef7acd7185315e22);

var $aHQfh = parcelRequire("aHQfh");

var $72Cr0 = parcelRequire("72Cr0");

var $k7Xp9 = parcelRequire("k7Xp9");
function $9d6247fcbaa018a9$export$ef7acd7185315e22(value) {
    return (0, $k7Xp9.dealloc)($9d6247fcbaa018a9$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $k7Xp9.alloc)(value), 0, [
        0
    ], value));
}
function $9d6247fcbaa018a9$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $k7Xp9.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $72Cr0.charat)(characters, length - 1) == 58) {
                if ((0, $72Cr0.indexof)(characters += (0, $72Cr0.replace)((0, $k7Xp9.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $k7Xp9.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $k7Xp9.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $k7Xp9.escaping)((0, $k7Xp9.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $k7Xp9.peek)()){
                case 42:
                case 47:
                    (0, $72Cr0.append)($9d6247fcbaa018a9$export$4a34f930e789283c((0, $k7Xp9.commenter)((0, $k7Xp9.next)(), (0, $k7Xp9.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $72Cr0.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $72Cr0.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $72Cr0.strlen)(characters) - length) (0, $72Cr0.append)(property > 32 ? $9d6247fcbaa018a9$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $9d6247fcbaa018a9$export$f8483753829ec8f3((0, $72Cr0.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $72Cr0.append)(reference = $9d6247fcbaa018a9$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $9d6247fcbaa018a9$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $72Cr0.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $9d6247fcbaa018a9$export$98e6a39c04603d36(value, reference, reference, rule && (0, $72Cr0.append)($9d6247fcbaa018a9$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $9d6247fcbaa018a9$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $72Cr0.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $k7Xp9.prev)() == 125) continue;
            }
            switch(characters += (0, $72Cr0.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $72Cr0.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $k7Xp9.peek)() === 45) characters += (0, $k7Xp9.delimit)((0, $k7Xp9.next)());
                    atrule = (0, $k7Xp9.peek)(), offset = length = (0, $72Cr0.strlen)(type = characters += (0, $k7Xp9.identifier)((0, $k7Xp9.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $72Cr0.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $9d6247fcbaa018a9$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $72Cr0.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $72Cr0.substr)(value, post + 1, post = (0, $72Cr0.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $72Cr0.trim)(j > 0 ? rule[x] + ' ' + y : (0, $72Cr0.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $k7Xp9.node)(value, root, parent, offset === 0 ? (0, $aHQfh.RULESET) : type, props, children, length);
}
function $9d6247fcbaa018a9$export$4a34f930e789283c(value, root, parent) {
    return (0, $k7Xp9.node)(value, root, parent, (0, $aHQfh.COMMENT), (0, $72Cr0.from)((0, $k7Xp9.char)()), (0, $72Cr0.substr)(value, 2, -2), 0);
}
function $9d6247fcbaa018a9$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $k7Xp9.node)(value, root, parent, (0, $aHQfh.DECLARATION), (0, $72Cr0.substr)(value, 0, length), (0, $72Cr0.substr)(value, length + 1, -1), length);
}

});
parcelRegister("aHQfh", function(module, exports) {
$parcel$export(module.exports, "MS", () => $7cb6725fc8005013$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $7cb6725fc8005013$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $7cb6725fc8005013$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $7cb6725fc8005013$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $7cb6725fc8005013$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $7cb6725fc8005013$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $7cb6725fc8005013$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $7cb6725fc8005013$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $7cb6725fc8005013$export$d773506282b3cfe6);
var $7cb6725fc8005013$export$71ad59f2e432cfe8 = '-ms-';
var $7cb6725fc8005013$export$2c0f367103c8d01c = '-moz-';
var $7cb6725fc8005013$export$39dfd62a25e0fe93 = '-webkit-';
var $7cb6725fc8005013$export$a29989082612d0d9 = 'comm';
var $7cb6725fc8005013$export$aa3a2e812ca8570d = 'rule';
var $7cb6725fc8005013$export$527d108ccf083c2b = 'decl';
var $7cb6725fc8005013$export$d3d35020fa5b54f0 = '@page';
var $7cb6725fc8005013$export$500415a86c544f73 = '@media';
var $7cb6725fc8005013$export$a763edbf796b780a = '@import';
var $7cb6725fc8005013$export$2790aeb8b4e5c826 = '@charset';
var $7cb6725fc8005013$export$1cc683e23b84b133 = '@viewport';
var $7cb6725fc8005013$export$9447a5efea57e862 = '@supports';
var $7cb6725fc8005013$export$ef011b4e114b1fba = '@document';
var $7cb6725fc8005013$export$6aad947bda0f3f46 = '@namespace';
var $7cb6725fc8005013$export$b44a8529a35fcb60 = '@keyframes';
var $7cb6725fc8005013$export$2c16de31893252e6 = '@font-face';
var $7cb6725fc8005013$export$3d846dd52e150c6f = '@counter-style';
var $7cb6725fc8005013$export$22314bfbb57653fe = '@font-feature-values';
var $7cb6725fc8005013$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("fibtN", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $b22171097ceaed4c$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $b22171097ceaed4c$export$38bcb760f1d4871c);

var $aHQfh = parcelRequire("aHQfh");

var $72Cr0 = parcelRequire("72Cr0");

var $k7Xp9 = parcelRequire("k7Xp9");

var $g8Xdk = parcelRequire("g8Xdk");

var $1z1iS = parcelRequire("1z1iS");
function $b22171097ceaed4c$export$5a7767152ae0305f(collection) {
    var length = (0, $72Cr0.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $b22171097ceaed4c$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $b22171097ceaed4c$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $aHQfh.DECLARATION:
                element.return = (0, $1z1iS.prefix)(element.value, element.length, children);
                return;
            case 0, $aHQfh.KEYFRAMES:
                return (0, $g8Xdk.serialize)([
                    (0, $k7Xp9.copy)(element, {
                        value: (0, $72Cr0.replace)(element.value, '@', '@' + (0, $aHQfh.WEBKIT))
                    })
                ], callback);
            case 0, $aHQfh.RULESET:
                if (element.length) return (0, $72Cr0.combine)(element.props, function(value) {
                    switch((0, $72Cr0.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $g8Xdk.serialize)([
                                (0, $k7Xp9.copy)(element, {
                                    props: [
                                        (0, $72Cr0.replace)(value, /:(read-\w+)/, ':' + (0, $aHQfh.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $g8Xdk.serialize)([
                                (0, $k7Xp9.copy)(element, {
                                    props: [
                                        (0, $72Cr0.replace)(value, /:(plac\w+)/, ':' + (0, $aHQfh.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $k7Xp9.copy)(element, {
                                    props: [
                                        (0, $72Cr0.replace)(value, /:(plac\w+)/, ':' + (0, $aHQfh.MOZ) + '$1')
                                    ]
                                }),
                                (0, $k7Xp9.copy)(element, {
                                    props: [
                                        (0, $72Cr0.replace)(value, /:(plac\w+)/, (0, $aHQfh.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $b22171097ceaed4c$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $aHQfh.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $72Cr0.combine)((0, $k7Xp9.tokenize)(value), function(value, index, children) {
                    switch((0, $72Cr0.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $72Cr0.substr)(value, 1, (0, $72Cr0.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $72Cr0.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $72Cr0.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $72Cr0.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("g8Xdk", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $bc0b53579fb3b3c3$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $bc0b53579fb3b3c3$export$fac44ee5b035f737);

var $aHQfh = parcelRequire("aHQfh");

var $72Cr0 = parcelRequire("72Cr0");
function $bc0b53579fb3b3c3$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $72Cr0.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $bc0b53579fb3b3c3$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $aHQfh.LAYER:
            if (element.children.length) break;
        case 0, $aHQfh.IMPORT:
        case 0, $aHQfh.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $aHQfh.COMMENT:
            return '';
        case 0, $aHQfh.KEYFRAMES:
            return element.return = element.value + '{' + $bc0b53579fb3b3c3$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $aHQfh.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $72Cr0.strlen)(children = $bc0b53579fb3b3c3$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("1z1iS", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $123a12271c48e384$export$82e9f45cca5ba907);

var $aHQfh = parcelRequire("aHQfh");

var $72Cr0 = parcelRequire("72Cr0");
function $123a12271c48e384$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $72Cr0.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $aHQfh.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $aHQfh.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $aHQfh.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MOZ) + value + (0, $aHQfh.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $72Cr0.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + value + value;
        // order
        case 6165:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $aHQfh.WEBKIT) + value + (0, $72Cr0.replace)(value, /(\w+).+(:[^]+)/, (0, $aHQfh.WEBKIT) + 'box-$1$2' + (0, $aHQfh.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + 'flex-item-' + (0, $72Cr0.replace)(value, /flex-|-self/g, '') + (!(0, $72Cr0.match)(value, /flex-|baseline/) ? (0, $aHQfh.MS) + 'grid-row-' + (0, $72Cr0.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + 'flex-line-pack' + (0, $72Cr0.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $aHQfh.WEBKIT) + 'box-' + (0, $72Cr0.replace)(value, '-grow', '') + (0, $aHQfh.WEBKIT) + value + (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $aHQfh.WEBKIT) + (0, $72Cr0.replace)(value, /([^-])(transform)/g, '$1' + (0, $aHQfh.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $72Cr0.replace)((0, $72Cr0.replace)((0, $72Cr0.replace)(value, /(zoom-|grab)/, (0, $aHQfh.WEBKIT) + '$1'), /(image-set)/, (0, $aHQfh.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $72Cr0.replace)(value, /(image-set\([^]*)/, (0, $aHQfh.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $72Cr0.replace)((0, $72Cr0.replace)(value, /(.+:)(flex-)?(.*)/, (0, $aHQfh.WEBKIT) + 'box-pack:$3' + (0, $aHQfh.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $aHQfh.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $72Cr0.match)(value, /flex-|baseline/)) return (0, $aHQfh.MS) + 'grid-column-align' + (0, $72Cr0.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $72Cr0.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $72Cr0.indexof)(value + (children = children[length].value), 'span') ? value : (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, '-start', '') + value + (0, $aHQfh.MS) + 'grid-row-span:' + (~(0, $72Cr0.indexof)(children, 'span') ? (0, $72Cr0.match)(children, /\d+/) : +(0, $72Cr0.match)(children, /\d+/) - +(0, $72Cr0.match)(value, /\d+/)) + ';';
            return (0, $aHQfh.MS) + (0, $72Cr0.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $72Cr0.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $aHQfh.MS) + (0, $72Cr0.replace)((0, $72Cr0.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $72Cr0.replace)(value, /(.+)-inline(.+)/, (0, $aHQfh.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $72Cr0.strlen)(value) - 1 - length > 6) switch((0, $72Cr0.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $72Cr0.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $72Cr0.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $aHQfh.WEBKIT) + '$2-$3' + '$1' + (0, $aHQfh.MOZ) + ((0, $72Cr0.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $72Cr0.indexof)(value, 'stretch') ? $123a12271c48e384$export$82e9f45cca5ba907((0, $72Cr0.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $72Cr0.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $aHQfh.MS) + a + ':' + b + f + (c ? (0, $aHQfh.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $72Cr0.charat)(value, length + 6) === 121) return (0, $72Cr0.replace)(value, ':', ':' + (0, $aHQfh.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $72Cr0.charat)(value, (0, $72Cr0.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $72Cr0.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $aHQfh.WEBKIT) + ((0, $72Cr0.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $aHQfh.WEBKIT) + '$2$3' + '$1' + (0, $aHQfh.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $72Cr0.replace)(value, ':', ':' + (0, $aHQfh.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $72Cr0.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("82208", function(module, exports) {
$parcel$export(module.exports, "default", () => $018252d6c4e4b80f$export$2e2bcd8739ae039);
var $018252d6c4e4b80f$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("873tQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e81ad51faac62c8$export$2e2bcd8739ae039);
function $5e81ad51faac62c8$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("fisuc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b22ea237bfa86118$export$2e2bcd8739ae039);
function $b22ea237bfa86118$export$2e2bcd8739ae039() {
    return $b22ea237bfa86118$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b22ea237bfa86118$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("5DCCj", function(module, exports) {
$parcel$export(module.exports, "default", () => $41ae8cc492943d4a$export$2e2bcd8739ae039);

var $3d4zD = parcelRequire("3d4zD");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $41ae8cc492943d4a$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3d4zD)))(targetComponent, sourceComponent);
};

});

parcelRegister("3xRFZ", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $294e1723a8ef07bf$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $294e1723a8ef07bf$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $294e1723a8ef07bf$export$6f077d94b33a01aa);
var $294e1723a8ef07bf$var$isBrowser = true;
function $294e1723a8ef07bf$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $294e1723a8ef07bf$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $294e1723a8ef07bf$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $294e1723a8ef07bf$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $294e1723a8ef07bf$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("6Zuix", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $516ff1261ccc2e80$export$6321afa313b251b5);

var $39RHG = parcelRequire("39RHG");

var $e4R4l = parcelRequire("e4R4l");

var $873tQ = parcelRequire("873tQ");
var $516ff1261ccc2e80$var$isDevelopment = false;
var $516ff1261ccc2e80$var$hyphenateRegex = /[A-Z]|^ms/g;
var $516ff1261ccc2e80$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $516ff1261ccc2e80$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $516ff1261ccc2e80$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $516ff1261ccc2e80$var$processStyleName = /* #__PURE__ */ (0, $873tQ.default)(function(styleName) {
    return $516ff1261ccc2e80$var$isCustomProperty(styleName) ? styleName : styleName.replace($516ff1261ccc2e80$var$hyphenateRegex, '-$&').toLowerCase();
});
var $516ff1261ccc2e80$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($516ff1261ccc2e80$var$animationRegex, function(match, p1, p2) {
                $516ff1261ccc2e80$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $516ff1261ccc2e80$var$cursor
                };
                return p1;
            });
    }
    if ((0, $e4R4l.default)[key] !== 1 && !$516ff1261ccc2e80$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $516ff1261ccc2e80$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $516ff1261ccc2e80$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $516ff1261ccc2e80$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $516ff1261ccc2e80$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $516ff1261ccc2e80$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $516ff1261ccc2e80$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $516ff1261ccc2e80$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $516ff1261ccc2e80$var$cursor;
                var result = interpolation(mergedProps);
                $516ff1261ccc2e80$var$cursor = previousCursor;
                return $516ff1261ccc2e80$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $516ff1261ccc2e80$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $516ff1261ccc2e80$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($516ff1261ccc2e80$var$isProcessableValue(asString)) string += $516ff1261ccc2e80$var$processStyleName(key) + ":" + $516ff1261ccc2e80$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $516ff1261ccc2e80$var$isDevelopment) throw new Error($516ff1261ccc2e80$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($516ff1261ccc2e80$var$isProcessableValue(value[_i])) string += $516ff1261ccc2e80$var$processStyleName(key) + ":" + $516ff1261ccc2e80$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $516ff1261ccc2e80$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $516ff1261ccc2e80$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $516ff1261ccc2e80$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $516ff1261ccc2e80$var$cursor;
function $516ff1261ccc2e80$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $516ff1261ccc2e80$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $516ff1261ccc2e80$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $516ff1261ccc2e80$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $516ff1261ccc2e80$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $516ff1261ccc2e80$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $39RHG.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $516ff1261ccc2e80$var$cursor
    };
}

});
parcelRegister("39RHG", function(module, exports) {
$parcel$export(module.exports, "default", () => $24cbdec2840f844d$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $24cbdec2840f844d$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("e4R4l", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3fa9ace82d8dfb3$export$2e2bcd8739ae039);
var $a3fa9ace82d8dfb3$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("iDJnh", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $d91f10f594427c42$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $d91f10f594427c42$export$811a713a7276cb9d);

var $lE8gv = parcelRequire("lE8gv");
var $d91f10f594427c42$var$syncFallback = function syncFallback(create) {
    return create();
};
var $d91f10f594427c42$var$useInsertionEffect = false;
var $d91f10f594427c42$export$db21c7ffa21794e7 = $d91f10f594427c42$var$useInsertionEffect || $d91f10f594427c42$var$syncFallback;
var $d91f10f594427c42$export$811a713a7276cb9d = $d91f10f594427c42$var$useInsertionEffect || $lE8gv.useLayoutEffect;

});



parcelRegister("lC4HT", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $7776ea3aa64d544f$export$a4687b0234b40e28);

var $lE8gv = parcelRequire("lE8gv");

var $3p8Bc = parcelRequire("3p8Bc");

var $2gQ9a = parcelRequire("2gQ9a");
function $7776ea3aa64d544f$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $3p8Bc.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $2gQ9a.useTrackedRef)(analyticsData);
    const fnRef = (0, $2gQ9a.useTrackedRef)(fn);
    const handler = (0, $lE8gv.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("3p8Bc", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $33d23b541a1ee04f$export$5bf35293e545f20c);

var $4IxEn = parcelRequire("4IxEn");

var $iE3Lj = parcelRequire("iE3Lj");

var $6Emoq = parcelRequire("6Emoq");
function $33d23b541a1ee04f$export$5bf35293e545f20c() {
    const analyticsContext = (0, $6Emoq.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $4IxEn.useCallbackOne)((payload)=>{
        return new (0, $iE3Lj.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("4IxEn", function(module, exports) {
$parcel$export(module.exports, "useMemoOne", () => $36f55fb9077d5907$export$b6feb8998cd9b342);
$parcel$export(module.exports, "useCallbackOne", () => $36f55fb9077d5907$export$33752cf3ee811995);

var $lE8gv = parcelRequire("lE8gv");
function $36f55fb9077d5907$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $36f55fb9077d5907$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $lE8gv.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $lE8gv.useRef)(true);
    var committed = (0, $lE8gv.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $36f55fb9077d5907$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $lE8gv.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $36f55fb9077d5907$export$33752cf3ee811995(callback, inputs) {
    return $36f55fb9077d5907$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $36f55fb9077d5907$export$1538c33de8887b59 = $36f55fb9077d5907$export$b6feb8998cd9b342;
var $36f55fb9077d5907$export$35808ee640e87ca7 = $36f55fb9077d5907$export$33752cf3ee811995;

});

parcelRegister("iE3Lj", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af57856939921dc$export$2e2bcd8739ae039);
/// <reference types="node" />

var $2EWql = parcelRequire("2EWql");
class $0af57856939921dc$export$2e2bcd8739ae039 extends (0, $2EWql.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            const payload = $0af57856939921dc$var$clonePayload(this.payload);
            return new $0af57856939921dc$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>{
                try {
                    handler(this, channel);
                } catch (e) {}
            });
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}
const $0af57856939921dc$var$clonePayload = (payload)=>{
    try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return {
            ...payload
        };
    }
};

});
parcelRegister("2EWql", function(module, exports) {
$parcel$export(module.exports, "default", () => $37a764b7876c731f$export$2e2bcd8739ae039);
class $37a764b7876c731f$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $37a764b7876c731f$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});


parcelRegister("6Emoq", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $f9232120895956c7$export$d1f587f82ad51c4);

var $lE8gv = parcelRequire("lE8gv");

var $gwlrk = parcelRequire("gwlrk");
const $f9232120895956c7$export$d1f587f82ad51c4 = ()=>{
    return (0, $lE8gv.useContext)((0, $gwlrk.default));
};

});
parcelRegister("gwlrk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c07043fa285175dc$export$2e2bcd8739ae039);

var $3FkVb = parcelRequire("3FkVb");
var $c07043fa285175dc$export$2e2bcd8739ae039 //# sourceMappingURL=index.js.map
 = (0, $3FkVb.default);

});
parcelRegister("3FkVb", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ab56df6952b82fb$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");
var $2ab56df6952b82fb$var$AnalyticsNextContext = (0, $lE8gv.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $2ab56df6952b82fb$export$2e2bcd8739ae039 //# sourceMappingURL=context.js.map
 = $2ab56df6952b82fb$var$AnalyticsNextContext;

});




parcelRegister("2gQ9a", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $7a320c357f5dad65$export$1d27a74659855e44);

var $lE8gv = parcelRequire("lE8gv");
const $7a320c357f5dad65$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $lE8gv.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("9oEM9", function(module, exports) {
$parcel$export(module.exports, "default", () => $753267613a425ea2$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");
function $753267613a425ea2$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $lE8gv.useRef)(true);
    (0, $lE8gv.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("4XQkK", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6a0a1f6e384a08b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $lE8gv = parcelRequire("lE8gv");

var $2ED8z = parcelRequire("2ED8z");
const $c6a0a1f6e384a08b$var$BORDER_WIDTH = 2;
const $c6a0a1f6e384a08b$var$baseFocusOutsideStyles = (0, $2ED8z.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: $c6a0a1f6e384a08b$var$BORDER_WIDTH
});
const $c6a0a1f6e384a08b$var$baseInsetStyles = (0, $2ED8z.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$c6a0a1f6e384a08b$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $c6a0a1f6e384a08b$var$focusRingStyles = (0, $2ED8z.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $c6a0a1f6e384a08b$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $c6a0a1f6e384a08b$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $c6a0a1f6e384a08b$var$insetFocusRingStyles = (0, $2ED8z.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $c6a0a1f6e384a08b$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $c6a0a1f6e384a08b$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ const $c6a0a1f6e384a08b$var$FocusRing = /*#__PURE__*/ (0, $lE8gv.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $c6a0a1f6e384a08b$var$baseInsetStyles : $c6a0a1f6e384a08b$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $c6a0a1f6e384a08b$var$insetFocusRingStyles : $c6a0a1f6e384a08b$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $2ED8z.jsx)((0, $2ED8z.ClassNames), null, ({ css: css, cx: cx })=>(0, $lE8gv.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $lE8gv.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$c6a0a1f6e384a08b$var$FocusRing.displayName = 'FocusRing';
var $c6a0a1f6e384a08b$export$2e2bcd8739ae039 = $c6a0a1f6e384a08b$var$FocusRing;

});

parcelRegister("5rLnZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffd000ae1e29a373$export$2e2bcd8739ae039);
function $ffd000ae1e29a373$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $ffd000ae1e29a373$var$tabKeyCode = 9;
function $ffd000ae1e29a373$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $ffd000ae1e29a373$var$tabKeyCode) return;
    $ffd000ae1e29a373$var$abort(event);
}
const $ffd000ae1e29a373$var$block = {
    onMouseDownCapture: $ffd000ae1e29a373$var$abort,
    onMouseUpCapture: $ffd000ae1e29a373$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $ffd000ae1e29a373$var$onKey,
    onKeyUpCapture: $ffd000ae1e29a373$var$onKey,
    onTouchStartCapture: $ffd000ae1e29a373$var$abort,
    onTouchEndCapture: $ffd000ae1e29a373$var$abort,
    onPointerDownCapture: $ffd000ae1e29a373$var$abort,
    onPointerUpCapture: $ffd000ae1e29a373$var$abort,
    onClickCapture: $ffd000ae1e29a373$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $ffd000ae1e29a373$var$abort
};
const $ffd000ae1e29a373$var$doNotBlock = {};
function $ffd000ae1e29a373$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $ffd000ae1e29a373$var$doNotBlock : $ffd000ae1e29a373$var$block;
}

});

parcelRegister("48VL9", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $6cc1c7dd01f524e8$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2ED8z = parcelRequire("2ED8z");
function $6cc1c7dd01f524e8$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return (0, $2ED8z.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("arZmL", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $7332cc75b31fa3f8$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2ED8z = parcelRequire("2ED8z");
function $7332cc75b31fa3f8$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return (0, $2ED8z.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("1f9sc", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $9d3b72252c6f8e62$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2ED8z = parcelRequire("2ED8z");
function $9d3b72252c6f8e62$export$864eea3f4ec3368f({ spacing: spacing }) {
    return (0, $2ED8z.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("eyLlK", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $1281b2b95717c8b7$export$20bbd2efb0d734c4);

var $lE8gv = parcelRequire("lE8gv");

var $kagwH = parcelRequire("kagwH");
const $1281b2b95717c8b7$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $lE8gv.isValidElement)(children) && children.type === (0, $kagwH.default);
};

});
parcelRegister("kagwH", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b0df0d32885fe60$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $7b0df0d32885fe60$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $7b0df0d32885fe60$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $l2NkF.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
$7b0df0d32885fe60$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $7b0df0d32885fe60$export$2e2bcd8739ae039 = $7b0df0d32885fe60$var$VisuallyHidden;

});
parcelRegister("l2NkF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5200d43adbcca00$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $f5200d43adbcca00$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $f5200d43adbcca00$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $f5200d43adbcca00$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
} //# sourceMappingURL=ax.js.map

});



parcelRegister("2FFxg", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $5c3519041dd70412$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $5c3519041dd70412$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("eQ9iz", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $ee1cb811a11089cc$export$955358618f994a11);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $fBWTV = parcelRequire("fBWTV");
const $ee1cb811a11089cc$var$gridSize = 8;
const $ee1cb811a11089cc$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $ee1cb811a11089cc$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $ee1cb811a11089cc$var$lineHeights = {
    default: $ee1cb811a11089cc$var$heights.default,
    compact: $ee1cb811a11089cc$var$heights.compact,
    none: 'inherit'
};
const $ee1cb811a11089cc$var$padding = {
    // 10px gutter
    default: `0 ${$ee1cb811a11089cc$var$gridSize + $ee1cb811a11089cc$var$gridSize / 4}px`,
    compact: `0 ${$ee1cb811a11089cc$var$gridSize + $ee1cb811a11089cc$var$gridSize / 4}px`,
    none: '0'
};
const $ee1cb811a11089cc$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$ee1cb811a11089cc$var$gridSize / 4}px`,
    default: `0 ${$ee1cb811a11089cc$var$gridSize / 4}px`,
    none: '0'
};
const $ee1cb811a11089cc$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $ee1cb811a11089cc$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $ee1cb811a11089cc$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$ee1cb811a11089cc$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)",
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)",
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    textDecoration: 'none'
};
const $ee1cb811a11089cc$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    },
    textDecoration: 'none'
};
const $ee1cb811a11089cc$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    },
    textDecoration: 'none'
};
const $ee1cb811a11089cc$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    },
    textDecoration: 'none'
};
const $ee1cb811a11089cc$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    },
    textDecoration: 'none'
};
const $ee1cb811a11089cc$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)",
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)",
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    },
    textDecoration: 'none'
};
const $ee1cb811a11089cc$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    },
    textDecoration: 'none'
};
const $ee1cb811a11089cc$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$ee1cb811a11089cc$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $ee1cb811a11089cc$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $ee1cb811a11089cc$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseAppearanceStyles = {
        ...appearance === 'default' && $ee1cb811a11089cc$var$defaultStyles,
        ...appearance === 'primary' && $ee1cb811a11089cc$var$primaryStyles,
        ...appearance === 'link' && $ee1cb811a11089cc$var$linkStyles,
        ...appearance === 'subtle' && $ee1cb811a11089cc$var$subtleStyles,
        ...appearance === 'subtle-link' && $ee1cb811a11089cc$var$subtleLinkStyles,
        ...appearance === 'warning' && $ee1cb811a11089cc$var$warningStyles,
        ...appearance === 'danger' && $ee1cb811a11089cc$var$dangerStyles
    };
    const appearanceStyles = appearance === 'default' && (0, $fBWTV.fg)('platform-dst-tokens-finesse') ? {
        ...baseAppearanceStyles,
        '&:hover': {
            ...baseAppearanceStyles['&:hover'],
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        '&:active': {
            ...baseAppearanceStyles['&:active'],
            background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
        }
    } : baseAppearanceStyles;
    const activeStyles = appearanceStyles['&:active'];
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-medium, 6px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: `${"var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"}, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)`,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $ee1cb811a11089cc$var$heights[spacing],
        lineHeight: $ee1cb811a11089cc$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $ee1cb811a11089cc$var$singleIconPadding[spacing] : $ee1cb811a11089cc$var$padding[spacing],
        verticalAlign: $ee1cb811a11089cc$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $ee1cb811a11089cc$var$selectedStyles : {
            ...appearanceStyles,
            ...activeStyles && {
                '&:active': {
                    ...activeStyles,
                    transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
                }
            },
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $ee1cb811a11089cc$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $ee1cb811a11089cc$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $ee1cb811a11089cc$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                }
            },
            ...$ee1cb811a11089cc$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}

});
parcelRegister("fBWTV", function(module, exports) {
$parcel$export(module.exports, "fg", () => $922eaba8ca939fc1$export$b40ec24ac8275656);

var $ktjjM = parcelRequire("ktjjM");
function $922eaba8ca939fc1$export$b40ec24ac8275656(name) {
    return (0, $ktjjM.resolveBooleanFlag)(name);
}

});
parcelRegister("ktjjM", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $df261128bb7b30ca$export$6333b6aff9fc6275);

var $gOTZH = parcelRequire("gOTZH");

var $hWnsZ = parcelRequire("hWnsZ");

var $ayXd8 = parcelRequire("ayXd8");

var $kM3WO = parcelRequire("kM3WO");

var $gtz9b = parcelRequire("gtz9b");

var $45X2s = parcelRequire("45X2s");
const $df261128bb7b30ca$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $ayXd8.ENV_ENABLE_PLATFORM_FF) || (0, $kM3WO.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $df261128bb7b30ca$export$6333b6aff9fc6275(flagKey) {
    if ($df261128bb7b30ca$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $hWnsZ.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $45X2s.pkgName), flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ((0, $gtz9b.globalVar)[0, $45X2s.PFF_GLOBAL_KEY]?.booleanResolver === undefined || (0, $gtz9b.globalVar)[0, $45X2s.PFF_GLOBAL_KEY]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $gOTZH.default).checkGate(flagKey);
        const result = (0, $gtz9b.globalVar)[0, $45X2s.PFF_GLOBAL_KEY]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("hWnsZ", function(module, exports) {
$parcel$export(module.exports, "debug", () => $fdb9e162ef4fb77e$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $fdb9e162ef4fb77e$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $fdb9e162ef4fb77e$var$DEBUG_MODE = !$fdb9e162ef4fb77e$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $fdb9e162ef4fb77e$export$1c9f709888824e05 = (...args)=>{
    if (!$fdb9e162ef4fb77e$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});

parcelRegister("ayXd8", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $8efb1a56d7c58dac$export$b574c24e1e6490f5);

var $45X2s = parcelRequire("45X2s");
const $8efb1a56d7c58dac$export$b574c24e1e6490f5 = (0, $45X2s.hasProcessEnv) ? false : false;

});
parcelRegister("45X2s", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $f9967b840e1f62dd$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $f9967b840e1f62dd$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $f9967b840e1f62dd$export$75f4a1454eff2805);

var $kUjzi = parcelRequire("kUjzi");
const $f9967b840e1f62dd$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $f9967b840e1f62dd$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
const $f9967b840e1f62dd$export$75f4a1454eff2805 = typeof $kUjzi !== 'undefined' && typeof $kUjzi.env !== 'undefined';

});


parcelRegister("kM3WO", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $9f002c5a68ff68f6$export$92f8b531feaeb23d);

var $45X2s = parcelRequire("45X2s");
const $9f002c5a68ff68f6$export$92f8b531feaeb23d = (0, $45X2s.hasProcessEnv) ? false : false;

});

parcelRegister("gtz9b", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $85149f50e577f514$export$54ea85357b4e0159);

var $45X2s = parcelRequire("45X2s");
const $85149f50e577f514$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $85149f50e577f514$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$85149f50e577f514$export$54ea85357b4e0159[0, $45X2s.PFF_GLOBAL_KEY] = $85149f50e577f514$export$54ea85357b4e0159[0, $45X2s.PFF_GLOBAL_KEY] || $85149f50e577f514$var$DEFAULT_PFF_GLOBAL;

});




parcelRegister("9T5IV", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd95de992c8e5aa9$export$2e2bcd8739ae039);

var $eyLlK = parcelRequire("eyLlK");
function $bd95de992c8e5aa9$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $eyLlK.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("ik5Jo", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd74ad769eee2a07$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $4zqUT = parcelRequire("4zqUT");
function $bd74ad769eee2a07$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $bd74ad769eee2a07$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $4zqUT.default), {
        size: size,
        label: ", Loading",
        appearance: $bd74ad769eee2a07$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("4zqUT", function(module, exports) {
$parcel$export(module.exports, "default", () => $013ace767fc853ca$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");

var $lE8gv = parcelRequire("lE8gv");

var $dMSHp = parcelRequire("dMSHp");

var $eY1d0 = parcelRequire("eY1d0");
/**
 * Returns the appropriate circle stroke color.
 */ function $013ace767fc853ca$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $013ace767fc853ca$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $013ace767fc853ca$var$loadIn = null;
const $013ace767fc853ca$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $013ace767fc853ca$var$useLayoutEffect = typeof window === 'undefined' ? (0, $lE8gv.useEffect) : (0, $lE8gv.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $013ace767fc853ca$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $eY1d0.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $013ace767fc853ca$var$getStrokeColor(appearance);
    const context = (0, $lE8gv.useContext)((0, $dMSHp.default));
    $013ace767fc853ca$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $l2NkF.default)([
            $013ace767fc853ca$var$styles.wrapperStyles,
            $013ace767fc853ca$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $l2NkF.default)([
                $013ace767fc853ca$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $kOwiQ.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $l2NkF.default)([
                    $013ace767fc853ca$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $013ace767fc853ca$export$2e2bcd8739ae039 = $013ace767fc853ca$var$Spinner;

});
parcelRegister("eY1d0", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $160c1cc57e202da4$export$4e9f1640bbe7a1a8);
const $160c1cc57e202da4$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("afn8r", function(module, exports) {
$parcel$export(module.exports, "default", () => $8218ecc6d74a610a$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $jDb5C = parcelRequire("jDb5C");

var $aCcmK = parcelRequire("aCcmK");

var $2vunV = parcelRequire("2vunV");

var $kUjzi = parcelRequire("kUjzi");
const $8218ecc6d74a610a$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $8218ecc6d74a610a$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $8218ecc6d74a610a$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $8218ecc6d74a610a$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ const $8218ecc6d74a610a$var$useColor = (colorProp)=>{
    const surface = (0, $jDb5C.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $aCcmK.inverseColorMap).hasOwnProperty(surface)) return (0, $aCcmK.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $8218ecc6d74a610a$var$Heading = /*#__PURE__*/ (0, $lE8gv.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $kUjzi;
    const [hLevel, inferredElement] = (0, $2vunV.useHeading)($8218ecc6d74a610a$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $8218ecc6d74a610a$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $l2NkF.default)([
            $8218ecc6d74a610a$var$styles.reset,
            $8218ecc6d74a610a$var$headingSizeStyles[size],
            $8218ecc6d74a610a$var$headingColorStyles[color]
        ]),
        children: children
    });
});
var $8218ecc6d74a610a$export$2e2bcd8739ae039 = $8218ecc6d74a610a$var$Heading;

});
parcelRegister("jDb5C", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $24b8cd8fe760b305$export$1aeb4f6b93c4540d);

var $lE8gv = parcelRequire("lE8gv");

var $8bHO1 = parcelRequire("8bHO1");
const $24b8cd8fe760b305$export$1aeb4f6b93c4540d = ()=>{
    return (0, $lE8gv.useContext)((0, $8bHO1.SurfaceContext));
};
(0, $8bHO1.SurfaceContext).displayName = 'SurfaceProvider';

});
parcelRegister("8bHO1", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $898181183f3087ef$export$1ca2a26fecb070ae);

var $lE8gv = parcelRequire("lE8gv");
const $898181183f3087ef$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $lE8gv.createContext)('elevation.surface');

});


parcelRegister("aCcmK", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", () => $9f08e3cf837d5944$export$2185ce37f9bdd963);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f941eca1bf309f7088207fc024b707>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $9f08e3cf837d5944$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};

});

parcelRegister("2vunV", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $900ca3c4db4fd3c7$export$97a37b1befbbf9b1);

var $hTd0h = parcelRequire("hTd0h");
const $900ca3c4db4fd3c7$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = (0, $hTd0h.useHeadingLevel)();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

});
parcelRegister("hTd0h", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $a8545e557f130a41$export$6a64a1e2d0bbbf75);

var $lE8gv = parcelRequire("lE8gv");

var $9vDcd = parcelRequire("9vDcd");
const $a8545e557f130a41$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $lE8gv.useContext)((0, $9vDcd.HeadingLevelContext));
};

});
parcelRegister("9vDcd", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $cec912cd99ddd8f5$export$d1fa8a19e192bc63);

var $lE8gv = parcelRequire("lE8gv");
const $cec912cd99ddd8f5$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $lE8gv.createContext)(0);

});




parcelRegister("fFqfL", function(module, exports) {
$parcel$export(module.exports, "Text", () => $f80264698f449321$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "default", () => $f80264698f449321$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lE8gv = parcelRequire("lE8gv");

var $2ED8z = parcelRequire("2ED8z");

var $9n6tr = parcelRequire("9n6tr");

var $4sB4E = parcelRequire("4sB4E");

var $jDb5C = parcelRequire("jDb5C");

var $9v2dO = parcelRequire("9v2dO");

var $aCcmK = parcelRequire("aCcmK");

var $4fe0F = parcelRequire("4fe0F");

var $e2DQ0 = parcelRequire("e2DQ0");

var $kH7Y1 = parcelRequire("kH7Y1");
const $f80264698f449321$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $f80264698f449321$var$resetStyles = (0, $2ED8z.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
const $f80264698f449321$var$strongStyles = (0, $2ED8z.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
const $f80264698f449321$var$emStyles = (0, $2ED8z.css)({
    fontStyle: 'italic'
});
const $f80264698f449321$var$textAlignMap = {
    center: (0, $2ED8z.css)({
        textAlign: 'center'
    }),
    end: (0, $2ED8z.css)({
        textAlign: 'end'
    }),
    start: (0, $2ED8z.css)({
        textAlign: 'start'
    })
};
const $f80264698f449321$var$truncationStyles = (0, $2ED8z.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
const $f80264698f449321$var$wordBreakMap = {
    breakAll: (0, $2ED8z.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $f80264698f449321$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $jDb5C.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $aCcmK.inverseColorMap).hasOwnProperty(surface)) return (0, $aCcmK.inverseColorMap)[surface];
    return 'color.text';
};
const $f80264698f449321$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $lE8gv.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $9n6tr.default)($f80264698f449321$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $9v2dO.useHasTextAncestor)();
    const color = $f80264698f449321$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $2ED8z.jsx)(Component, {
        ref: ref,
        css: [
            $f80264698f449321$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $e2DQ0.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $4fe0F.textColorStylesMap)[color],
            maxLines && $f80264698f449321$var$truncationStyles,
            maxLines === 1 && $f80264698f449321$var$wordBreakMap.breakAll,
            align && $f80264698f449321$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $kH7Y1.textWeightStylesMap)[weight],
            Component === 'em' && $f80264698f449321$var$emStyles,
            Component === 'strong' && $f80264698f449321$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $2ED8z.jsx)((0, $4sB4E.HasTextAncestorProvider), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f80264698f449321$export$2e2bcd8739ae039 = $f80264698f449321$export$5f1af8db9871e1d6;

});
parcelRegister("9n6tr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d2b4897f3f8ddaa$export$2e2bcd8739ae039);
var $6d2b4897f3f8ddaa$var$isProduction = true;
var $6d2b4897f3f8ddaa$var$prefix = 'Invariant failed';
function $6d2b4897f3f8ddaa$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($6d2b4897f3f8ddaa$var$isProduction) throw new Error($6d2b4897f3f8ddaa$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($6d2b4897f3f8ddaa$var$prefix, ": ").concat(provided) : $6d2b4897f3f8ddaa$var$prefix;
    throw new Error(value);
}

});

parcelRegister("4sB4E", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorProvider", () => $6cc567cb39295cd4$export$ae933c6cbe5643ad);

var $4Nw99 = parcelRequire("4Nw99");
const $6cc567cb39295cd4$export$ae933c6cbe5643ad = (0, $4Nw99.HasTextAncestorContext).Provider;

});
parcelRegister("4Nw99", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorContext", () => $84f20a0d5dd829c3$export$19538d0bfc69c6e0);

var $lE8gv = parcelRequire("lE8gv");
const $84f20a0d5dd829c3$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $lE8gv.createContext)(false);

});


parcelRegister("9v2dO", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $59785b708eed499d$export$9322276ec105d055);

var $lE8gv = parcelRequire("lE8gv");

var $4Nw99 = parcelRequire("4Nw99");
const $59785b708eed499d$export$9322276ec105d055 = ()=>(0, $lE8gv.useContext)((0, $4Nw99.HasTextAncestorContext));

});

parcelRegister("4fe0F", function(module, exports) {
$parcel$export(module.exports, "textColorStylesMap", () => $157e402dd40fcacb$export$3a1bcba60b23d7f0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $7HGpH = parcelRequire("7HGpH");

var $4Cucp = parcelRequire("4Cucp");
const $157e402dd40fcacb$export$3a1bcba60b23d7f0 = (0, $7HGpH.getSerializedStylesMap)('color', (0, $4Cucp.textColorMap));

});
parcelRegister("7HGpH", function(module, exports) {
$parcel$export(module.exports, "getSerializedStylesMap", () => $f9c3c1bdf798f347$export$ca0f9c2de39ffed7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2ED8z = parcelRequire("2ED8z");
const $f9c3c1bdf798f347$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, tokenName)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = (0, $2ED8z.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[tokenName]
        });
        return emotionSpacingMap;
    }, {});
};

});

parcelRegister("4Cucp", function(module, exports) {
$parcel$export(module.exports, "textColorMap", () => $2eb14108c10f6659$export$8473307aa00d6ea1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c49ded1370dd9125e2572ecce0dec81>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $2eb14108c10f6659$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};

});


parcelRegister("e2DQ0", function(module, exports) {
$parcel$export(module.exports, "textSizeStylesMap", () => $278561354b0b95b2$export$219d364c0da35ae4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $7HGpH = parcelRequire("7HGpH");

var $3BUku = parcelRequire("3BUku");
const $278561354b0b95b2$export$219d364c0da35ae4 = (0, $7HGpH.getSerializedStylesMap)('font', (0, $3BUku.textSizeMap));

});
parcelRegister("3BUku", function(module, exports) {
$parcel$export(module.exports, "textSizeMap", () => $7ecb4fa8938f4a67$export$236bfe3a33ef1292);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6fd3eebcc815c6c62e80e08d3ca4f843>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $7ecb4fa8938f4a67$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});


parcelRegister("kH7Y1", function(module, exports) {
$parcel$export(module.exports, "textWeightStylesMap", () => $0d75fd0f66264466$export$38845ca010b93505);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $7HGpH = parcelRequire("7HGpH");

var $5i2gI = parcelRequire("5i2gI");
const $0d75fd0f66264466$export$38845ca010b93505 = (0, $7HGpH.getSerializedStylesMap)('fontWeight', (0, $5i2gI.textWeightMap));

});
parcelRegister("5i2gI", function(module, exports) {
$parcel$export(module.exports, "textWeightMap", () => $543a9ab001ebc98d$export$855cfd311192d666);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8120a44c21b94ee961979aa2a9470314>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $543a9ab001ebc98d$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};

});



parcelRegister("i1RX2", function(module, exports) {
$parcel$export(module.exports, "createErrorIcon", () => $ee4e4d0d002e0759$export$a155cf4c16741a55);
$parcel$export(module.exports, "createDangerIcon", () => $ee4e4d0d002e0759$export$2d89e9611bb77dd1);
$parcel$export(module.exports, "createRhombusErrorIcon", () => $ee4e4d0d002e0759$export$88cd2ab1efbb8fe4);
$parcel$export(module.exports, "createSuccessIcon", () => $ee4e4d0d002e0759$export$84844ae538823a45);
$parcel$export(module.exports, "createErrorCrossIcon", () => $ee4e4d0d002e0759$export$b5050240ebc5ec7a);
$parcel$export(module.exports, "createInfoIcon", () => $ee4e4d0d002e0759$export$e883ccfbe47a146);

var $lE8gv = parcelRequire("lE8gv");

var $c2QZy = parcelRequire("c2QZy");

var $lwdf7 = parcelRequire("lwdf7");

var $dRZAB = parcelRequire("dRZAB");

var $1hMfY = parcelRequire("1hMfY");

var $cFQqg = parcelRequire("cFQqg");
const $ee4e4d0d002e0759$export$a155cf4c16741a55 = ()=>$lE8gv.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFQqg))), {
        label: '',
        color: "var(--ds-icon-warning, #E06C00)"
    });
const $ee4e4d0d002e0759$export$2d89e9611bb77dd1 = ()=>$lE8gv.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFQqg))), {
        label: '',
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
const $ee4e4d0d002e0759$export$88cd2ab1efbb8fe4 = ()=>$lE8gv.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lwdf7))), {
        label: '',
        color: "var(--ds-icon-danger, #C9372C)",
        testId: 'adminhub-error-package-rombus-error-icon'
    });
const $ee4e4d0d002e0759$export$84844ae538823a45 = ()=>$lE8gv.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1hMfY))), {
        label: '',
        color: "var(--ds-icon-success, #6A9A23)",
        testId: 'adminhub-error-package-success-icon'
    });
const $ee4e4d0d002e0759$export$b5050240ebc5ec7a = ()=>$lE8gv.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2QZy))), {
        label: '',
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
const $ee4e4d0d002e0759$export$e883ccfbe47a146 = ()=>$lE8gv.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dRZAB))), {
        label: '',
        color: "var(--ds-icon-brand, #1868DB)"
    });

});
parcelRegister("c2QZy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23550e9a9f6f237ba15b0b9afdf2850e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c4ec6fce0402be4$var$_react = $8c4ec6fce0402be4$var$_interopRequireDefault((parcelRequire("lE8gv")));

var $8c4ec6fce0402be4$var$_iconNew = $8c4ec6fce0402be4$var$_interopRequireDefault((parcelRequire("1jPqJ")));
function $8c4ec6fce0402be4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross-circle
 * Usage guidance:
 * Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c4ec6fce0402be4$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $8c4ec6fce0402be4$var$_react.default.createElement($8c4ec6fce0402be4$var$_iconNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 6.94L5.03 3.97 3.97 5.03 6.94 8l-2.97 2.97 1.06 1.06L8 9.06l2.97 2.97 1.06-1.06L9.06 8l2.97-2.97-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$8c4ec6fce0402be4$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $8c4ec6fce0402be4$var$_default = module.exports.default = $8c4ec6fce0402be4$var$CrossCircleIcon;

});
parcelRegister("1jPqJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", () => $9e7a0d98902035f8$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $9e7a0d98902035f8$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $9e7a0d98902035f8$var$svgStyles = null;
const $9e7a0d98902035f8$var$iconStyles = null;
const $9e7a0d98902035f8$var$smallIconStyles = null;
const $9e7a0d98902035f8$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $9e7a0d98902035f8$var$baseHcmStyles = null;
const $9e7a0d98902035f8$var$scaleSize = null;
const $9e7a0d98902035f8$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $9e7a0d98902035f8$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $9e7a0d98902035f8$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const $9e7a0d98902035f8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $lE8gv.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $9e7a0d98902035f8$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $l2NkF.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)("svg", {
            fill: "none",
            // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $l2NkF.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $9e7a0d98902035f8$var$coreSizeSmall[spacing] : $9e7a0d98902035f8$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9e7a0d98902035f8$export$2e2bcd8739ae039 = $9e7a0d98902035f8$export$f04a61298a47a40f;

});


parcelRegister("lwdf7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3cfa183fa168ea8c7cf286e27765b6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $faa6dbdeaeef65ff$var$_react = $faa6dbdeaeef65ff$var$_interopRequireDefault((parcelRequire("lE8gv")));

var $faa6dbdeaeef65ff$var$_iconNew = $faa6dbdeaeef65ff$var$_interopRequireDefault((parcelRequire("1jPqJ")));
function $faa6dbdeaeef65ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $faa6dbdeaeef65ff$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $faa6dbdeaeef65ff$var$_react.default.createElement($faa6dbdeaeef65ff$var$_iconNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$faa6dbdeaeef65ff$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $faa6dbdeaeef65ff$var$_default = module.exports.default = $faa6dbdeaeef65ff$var$StatusErrorIcon;

});

parcelRegister("dRZAB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::341f1a6f1df1c6bee81376e850857e59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a18ffffba371c098$var$_react = $a18ffffba371c098$var$_interopRequireDefault((parcelRequire("lE8gv")));

var $a18ffffba371c098$var$_iconNew = $a18ffffba371c098$var$_interopRequireDefault((parcelRequire("1jPqJ")));
function $a18ffffba371c098$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a18ffffba371c098$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $a18ffffba371c098$var$_react.default.createElement($a18ffffba371c098$var$_iconNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$a18ffffba371c098$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $a18ffffba371c098$var$_default = module.exports.default = $a18ffffba371c098$var$StatusInformationIcon;

});

parcelRegister("1hMfY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fec260a5beb0e93db2111df1ab9a2e97>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0efccfb872722472$var$_react = $0efccfb872722472$var$_interopRequireDefault((parcelRequire("lE8gv")));

var $0efccfb872722472$var$_iconNew = $0efccfb872722472$var$_interopRequireDefault((parcelRequire("1jPqJ")));
function $0efccfb872722472$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-success
 * Usage guidance:
 * Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0efccfb872722472$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $0efccfb872722472$var$_react.default.createElement($0efccfb872722472$var$_iconNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$0efccfb872722472$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $0efccfb872722472$var$_default = module.exports.default = $0efccfb872722472$var$StatusSuccessIcon;

});

parcelRegister("cFQqg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd90c08a28534c92e68f27855e77fa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93a1fa6a2e14f597$var$_react = $93a1fa6a2e14f597$var$_interopRequireDefault((parcelRequire("lE8gv")));

var $93a1fa6a2e14f597$var$_iconNew = $93a1fa6a2e14f597$var$_interopRequireDefault((parcelRequire("1jPqJ")));
function $93a1fa6a2e14f597$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93a1fa6a2e14f597$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $93a1fa6a2e14f597$var$_react.default.createElement($93a1fa6a2e14f597$var$_iconNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$93a1fa6a2e14f597$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $93a1fa6a2e14f597$var$_default = module.exports.default = $93a1fa6a2e14f597$var$StatusWarningIcon;

});


parcelRegister("dvhTw", function(module, exports) {
$parcel$export(module.exports, "errorFlagMessages", () => $7c8cae663a34dfdc$export$889413494ace092f);
$parcel$export(module.exports, "GenericErrorMessage", () => $7c8cae663a34dfdc$export$4a2e9d0212a9b553);
$parcel$export(module.exports, "GenericError", () => $7c8cae663a34dfdc$export$7d465be8efa67280);
/* eslint-disable max-classes-per-file */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $4Qx8e = parcelRequire("4Qx8e");
var $b1WJB = parcelRequire("b1WJB");
var $cEINl = parcelRequire("cEINl");

var $hddPc = parcelRequire("hddPc");

var $iH1Ax = parcelRequire("iH1Ax");
const $7c8cae663a34dfdc$export$889413494ace092f = (0, $4Qx8e.defineMessages)({
    title: {
        id: 'common.generic-error.title',
        defaultMessage: 'Something went wrong',
        description: 'Generic error message title'
    },
    description: {
        id: 'common.generic-error.description',
        defaultMessage: 'Try again later.',
        description: 'Generic error message description'
    }
});
const $7c8cae663a34dfdc$var$errorMessages = (0, $4Qx8e.defineMessages)({
    error: {
        id: 'common.generic-error',
        defaultMessage: 'Something went wrong. Try again later.',
        description: 'Generic error message'
    }
});
const $7c8cae663a34dfdc$export$4a2e9d0212a9b553 = ()=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $b1WJB.default), {
        ...$7c8cae663a34dfdc$var$errorMessages.error
    });
const $7c8cae663a34dfdc$export$7d465be8efa67280 = ({ header: header, headingLevel: headingLevel, description: description, primaryAction: primaryAction, testId: testId = 'generic-error' })=>{
    const { formatMessage: formatMessage } = (0, $cEINl.default)();
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $hddPc.default), {
        testId: testId,
        renderImage: ()=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $iH1Ax.IllustrationComponent), {
                illustrationKey: "ErrorColor",
                width: 160,
                height: 160,
                alt: ""
            }),
        header: header || formatMessage($7c8cae663a34dfdc$export$889413494ace092f.title),
        description: description || formatMessage($7c8cae663a34dfdc$export$889413494ace092f.description),
        width: "wide",
        headingLevel: headingLevel,
        primaryAction: primaryAction
    });
};

});
parcelRegister("hddPc", function(module, exports) {
$parcel$export(module.exports, "default", () => $622a982ea3a045b2$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $eGBt5 = parcelRequire("eGBt5");

var $afn8r = parcelRequire("afn8r");

var $7Ql7y = parcelRequire("7Ql7y");

var $gD6VI = parcelRequire("gD6VI");

var $4zqUT = parcelRequire("4zqUT");

var $juGF6 = parcelRequire("juGF6");

var $l2ESc = parcelRequire("l2ESc");

var $lHUh6 = parcelRequire("lHUh6");

var $f8w0h = parcelRequire("f8w0h");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $622a982ea3a045b2$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $juGF6.default), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $eGBt5.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $f8w0h.default), {
                children: isLoading && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $4zqUT.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $l2ESc.default), {
        testId: testId,
        width: width || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $lHUh6.default), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $7Ql7y.Box), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $afn8r.default), {
                    size: headingSize,
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $7Ql7y.Box), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $gD6VI.Text), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
var $622a982ea3a045b2$export$2e2bcd8739ae039 = $622a982ea3a045b2$var$EmptyState;

});
parcelRegister("eGBt5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $82369abdb508eb9a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lE8gv = parcelRequire("lE8gv");

var $2ED8z = parcelRequire("2ED8z");
const $82369abdb508eb9a$var$buttonGroupStyles = (0, $2ED8z.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        flex: '1 0 auto'
    }
});
function $82369abdb508eb9a$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $2ED8z.jsx)("div", {
        css: $82369abdb508eb9a$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $2ED8z.jsx)((0, $lE8gv.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("7Ql7y", function(module, exports) {
$parcel$export(module.exports, "Box", () => $59130c1f7c6a91d4$export$e71c4d32a2263218);
/* box.tsx generated by @compiled/babel-plugin v3.0.2 */ /* box.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $8bHO1 = parcelRequire("8bHO1");
const $59130c1f7c6a91d4$var$baseStyles = null;
const $59130c1f7c6a91d4$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $59130c1f7c6a91d4$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $59130c1f7c6a91d4$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $59130c1f7c6a91d4$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $59130c1f7c6a91d4$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $59130c1f7c6a91d4$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $59130c1f7c6a91d4$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
const $59130c1f7c6a91d4$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $lE8gv.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $kOwiQ.jsx)(Component, {
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $l2NkF.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $59130c1f7c6a91d4$var$backgroundColorMap[backgroundColor],
            backgroundColor && $59130c1f7c6a91d4$var$isSurfaceToken(backgroundColor) && $59130c1f7c6a91d4$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $59130c1f7c6a91d4$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $59130c1f7c6a91d4$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $59130c1f7c6a91d4$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $59130c1f7c6a91d4$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $8bHO1.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
function $59130c1f7c6a91d4$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $59130c1f7c6a91d4$var$setSurfaceTokenMap;
}

});

parcelRegister("gD6VI", function(module, exports) {
$parcel$export(module.exports, "Text", () => $269860c4e5b2ae71$export$5f1af8db9871e1d6);
/* text.tsx generated by @compiled/babel-plugin v3.0.2 */ /* text.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $9n6tr = parcelRequire("9n6tr");

var $4sB4E = parcelRequire("4sB4E");

var $jDb5C = parcelRequire("jDb5C");

var $9v2dO = parcelRequire("9v2dO");
const $269860c4e5b2ae71$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $269860c4e5b2ae71$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $jDb5C.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($269860c4e5b2ae71$var$inverseColorMap.hasOwnProperty(surface)) return $269860c4e5b2ae71$var$inverseColorMap[surface];
    return 'color.text';
};
const $269860c4e5b2ae71$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $269860c4e5b2ae71$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
const $269860c4e5b2ae71$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $269860c4e5b2ae71$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $269860c4e5b2ae71$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $269860c4e5b2ae71$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $lE8gv.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $9n6tr.default)($269860c4e5b2ae71$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $9v2dO.useHasTextAncestor)();
    const color = $269860c4e5b2ae71$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $kOwiQ.jsx)(Component, {
        id: id,
        className: (0, $l2NkF.default)([
            $269860c4e5b2ae71$var$styles.root,
            size && $269860c4e5b2ae71$var$fontSizeMap[size],
            color && $269860c4e5b2ae71$var$textColorMap[color],
            maxLines && $269860c4e5b2ae71$var$styles.truncation,
            maxLines === 1 && $269860c4e5b2ae71$var$styles.breakAll,
            align && $269860c4e5b2ae71$var$styles[`textAlign.${align}`],
            weight && $269860c4e5b2ae71$var$fontWeightMap[weight],
            Component === 'em' && $269860c4e5b2ae71$var$styles['as.em'],
            Component === 'strong' && $269860c4e5b2ae71$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $4sB4E.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});

});

parcelRegister("juGF6", function(module, exports) {
$parcel$export(module.exports, "default", () => $001e47ba164c4d6b$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $001e47ba164c4d6b$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $001e47ba164c4d6b$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        className: (0, $l2NkF.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]),
        children: children
    });
var $001e47ba164c4d6b$export$2e2bcd8739ae039 = $001e47ba164c4d6b$var$ActionsContainer;

});

parcelRegister("l2ESc", function(module, exports) {
$parcel$export(module.exports, "default", () => $7530cdc8c67d5ffb$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $7530cdc8c67d5ffb$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $7530cdc8c67d5ffb$var$wideContainerStyles = null;
const $7530cdc8c67d5ffb$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $7530cdc8c67d5ffb$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        "data-testid": testId,
        className: (0, $l2NkF.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ]),
        children: children
    });
var $7530cdc8c67d5ffb$export$2e2bcd8739ae039 = $7530cdc8c67d5ffb$var$Container;

});

parcelRegister("lHUh6", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ebb9dc417bc6296$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $5ebb9dc417bc6296$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $5ebb9dc417bc6296$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $5ebb9dc417bc6296$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $5ebb9dc417bc6296$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("img", {
        style: {
            [$5ebb9dc417bc6296$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$5ebb9dc417bc6296$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $l2NkF.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $5ebb9dc417bc6296$export$2e2bcd8739ae039 = $5ebb9dc417bc6296$var$Image;

});

parcelRegister("f8w0h", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cd1f76128b00295$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $8cd1f76128b00295$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $8cd1f76128b00295$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        className: (0, $l2NkF.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]),
        children: children
    });
var $8cd1f76128b00295$export$2e2bcd8739ae039 = $8cd1f76128b00295$var$SpinnerContainer;

});


parcelRegister("iH1Ax", function(module, exports) {
$parcel$export(module.exports, "Illustration", () => $66bddb2e5bc8c2f8$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "IllustrationComponent", () => $66bddb2e5bc8c2f8$export$785d3703e302bc58);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $iu0Vg = parcelRequire("iu0Vg");

var $ctuWl = parcelRequire("ctuWl");

var $eD8vk = parcelRequire("eD8vk");

var $rJiEz = parcelRequire("rJiEz");
const $66bddb2e5bc8c2f8$var$rootStyles = (0, $eD8vk.xcss)({
    display: 'block',
    maxWidth: '100%',
    height: 'auto',
    objectFit: 'contain',
    objectPosition: 'center'
});
const $66bddb2e5bc8c2f8$var$fillStyles = (0, $eD8vk.xcss)({
    position: 'absolute',
    inset: 'space.0',
    width: '100%',
    height: '100%'
});
const $66bddb2e5bc8c2f8$var$autoDarkStyles = (0, $eD8vk.xcss)({
    filter: 'invert(1) hue-rotate(180deg)'
});
const $66bddb2e5bc8c2f8$export$75e378065cb7d6c0 = ({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps })=>{
    const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $ctuWl.Box), {
        xcss: [
            $66bddb2e5bc8c2f8$var$rootStyles,
            ...fill ? [
                $66bddb2e5bc8c2f8$var$fillStyles
            ] : [],
            ...isDarkMode && srcDark === srcLight && autoDark ? [
                $66bddb2e5bc8c2f8$var$autoDarkStyles
            ] : []
        ],
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $iu0Vg.default), {
            src: isDarkMode && srcDark ? srcDark : srcLight,
            srcDark: srcDark,
            alt: alt,
            testId: testId,
            ...imgProps
        })
    });
};
function $66bddb2e5bc8c2f8$export$d43c2e2ca9b2c105({ ...props }) {
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($66bddb2e5bc8c2f8$export$75e378065cb7d6c0, {
        ...props
    });
}
const $66bddb2e5bc8c2f8$export$785d3703e302bc58 = ({ illustrationKey: illustrationKey, ...props })=>{
    const illustration = (0, $rJiEz.getIllustration)(illustrationKey);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($66bddb2e5bc8c2f8$export$d43c2e2ca9b2c105, {
        illustrationKey: illustrationKey,
        srcLight: illustration.light,
        srcDark: illustration.dark,
        ...props
    });
};
const $66bddb2e5bc8c2f8$export$60247ecb8593cd70 = Object.keys((0, $rJiEz.illustrationMap));

});
parcelRegister("iu0Vg", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb9e15a0615960da$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $6ny8k = parcelRequire("6ny8k");

var $d8P2U = parcelRequire("d8P2U");
const $fb9e15a0615960da$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $fb9e15a0615960da$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $lE8gv.useRef)(null);
    const providedColorMode = (0, $6ny8k.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $d8P2U.useThemeObserver)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $lE8gv.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $l2NkF.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("6ny8k", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $3b69a445c938cb59$export$ce91654eb9fea460);

var $lE8gv = parcelRequire("lE8gv");

var $eXiuK = parcelRequire("eXiuK");
function $3b69a445c938cb59$export$ce91654eb9fea460() {
    const value = (0, $lE8gv.useContext)((0, $eXiuK.ColorModeContext));
    return value;
}

});
parcelRegister("eXiuK", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $8734fea42b05dc85$export$49ddd74a6729fdb0);

var $lE8gv = parcelRequire("lE8gv");
const $8734fea42b05dc85$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $lE8gv.createContext)(undefined);

});


parcelRegister("d8P2U", function(module, exports) {
$parcel$export(module.exports, "useThemeObserver", () => $0fdc6e6b9defb717$export$3dd7971102e44fa8);
$parcel$export(module.exports, "default", () => $0fdc6e6b9defb717$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");

var $gDX2W = parcelRequire("gDX2W");

var $cE35U = parcelRequire("cE35U");
const $0fdc6e6b9defb717$export$3dd7971102e44fa8 = ()=>{
    const [theme, setTheme] = (0, $lE8gv.useState)((0, $gDX2W.getGlobalTheme)());
    (0, $lE8gv.useEffect)(()=>{
        const observer = new (0, $cE35U.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $0fdc6e6b9defb717$export$2e2bcd8739ae039 = $0fdc6e6b9defb717$export$3dd7971102e44fa8;

});
parcelRegister("gDX2W", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", () => $03d31100adf57497$export$813ecdf77207a053);

var $cdQaS = parcelRequire("cdQaS");

var $fq7Kt = parcelRequire("fq7Kt");

var $04yve = parcelRequire("04yve");
const $03d31100adf57497$export$813ecdf77207a053 = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $cdQaS.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $cdQaS.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $04yve.themeStringToObject)(theme),
        ...(0, $fq7Kt.isThemeColorMode)(colorMode) && {
            colorMode: colorMode
        }
    };
};

});
parcelRegister("cdQaS", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $8a03f995a8e1e1ec$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $8a03f995a8e1e1ec$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $8a03f995a8e1e1ec$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $8a03f995a8e1e1ec$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $8a03f995a8e1e1ec$export$352e418ed5b6193a);
$parcel$export(module.exports, "CSS_PREFIX", () => $8a03f995a8e1e1ec$export$6f0c6fb8c80fcc92);
$parcel$export(module.exports, "CSS_VAR_FULL", () => $8a03f995a8e1e1ec$export$4d0c7bbf80185957);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $8a03f995a8e1e1ec$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $8a03f995a8e1e1ec$export$9d7b58831ae93caa);
const $8a03f995a8e1e1ec$export$4ef52930e33717cd = 'data-theme';
const $8a03f995a8e1e1ec$export$cb374d25ded7f6ab = 'data-subtree-theme';
const $8a03f995a8e1e1ec$export$a00eac3f8684bcd0 = 'data-color-mode';
const $8a03f995a8e1e1ec$export$2112803007239c61 = 'data-contrast-mode';
const $8a03f995a8e1e1ec$export$352e418ed5b6193a = 'data-custom-theme';
const $8a03f995a8e1e1ec$export$6f0c6fb8c80fcc92 = 'ds';
const $8a03f995a8e1e1ec$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $8a03f995a8e1e1ec$export$dddac1532e822863 = `--${$8a03f995a8e1e1ec$export$6f0c6fb8c80fcc92}-token-not-found`;
const $8a03f995a8e1e1ec$export$9d7b58831ae93caa = `--${$8a03f995a8e1e1ec$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});

parcelRegister("fq7Kt", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", () => $1d2261346c29614f$export$fcfb1976c88f9f75);

var $6bTKL = parcelRequire("6bTKL");
const $1d2261346c29614f$export$fcfb1976c88f9f75 = (colorMode)=>{
    return (0, $6bTKL.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};

});
parcelRegister("6bTKL", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $18574dfb2db7a3d6$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ const $18574dfb2db7a3d6$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("04yve", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $18b761c0fe4772df$export$f19b488f7c0547ee);

var $9y6Bq = parcelRequire("9y6Bq");

var $2hQ83 = parcelRequire("2hQ83");

var $adI2s = parcelRequire("adI2s");
const $18b761c0fe4772df$var$customThemeOptions = 'UNSAFE_themeOptions';
const $18b761c0fe4772df$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && (0, $9y6Bq.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $adI2s.isThemeKind)(kind) && (0, $2hQ83.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $18b761c0fe4772df$var$customThemeOptions) try {
            themeObject[$18b761c0fe4772df$var$customThemeOptions] = JSON.parse(id);
        } catch  {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});
parcelRegister("9y6Bq", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $896ac0b46364a974$export$4a14e169b1de4ee7);
const $896ac0b46364a974$export$4a14e169b1de4ee7 = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("2hQ83", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $c6757aec502d01ca$export$ea35b8958c39dd07);

var $hNnJZ = parcelRequire("hNnJZ");
const $c6757aec502d01ca$export$ea35b8958c39dd07 = (themeId)=>{
    return (0, $hNnJZ.themeIds).find((id)=>id === themeId) !== undefined;
};

});
parcelRegister("hNnJZ", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $b7141e74d1e7d5e0$export$7d43e72a58e3283f);
const $b7141e74d1e7d5e0$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-dynamic',
    'UNSAFE-dynamic-dark',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'UNSAFE-typography',
    'motion'
];

});


parcelRegister("adI2s", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $4774a7e6f1212b80$export$958fa026be3a263e);
const $4774a7e6f1212b80$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const $4774a7e6f1212b80$export$958fa026be3a263e = (themeKind)=>{
    return $4774a7e6f1212b80$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};

});



parcelRegister("cE35U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ThemeMutationObserver", () => $2f7ff264d90c396f$export$b741a7c3bcb1c635);
$parcel$export(module.exports, "default", () => $2f7ff264d90c396f$export$2e2bcd8739ae039);

var $cdQaS = parcelRequire("cdQaS");

var $gDX2W = parcelRequire("gDX2W");
class $2f7ff264d90c396f$export$b741a7c3bcb1c635 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $2f7ff264d90c396f$export$b741a7c3bcb1c635.callbacks.add(callback);
    }
    observe() {
        if (!$2f7ff264d90c396f$export$b741a7c3bcb1c635.observer) {
            $2f7ff264d90c396f$export$b741a7c3bcb1c635.observer = new MutationObserver(()=>{
                const theme = (0, $gDX2W.getGlobalTheme)();
                $2f7ff264d90c396f$export$b741a7c3bcb1c635.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $2f7ff264d90c396f$export$b741a7c3bcb1c635.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $cdQaS.THEME_DATA_ATTRIBUTE),
                    (0, $cdQaS.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $2f7ff264d90c396f$export$b741a7c3bcb1c635.callbacks.delete(this.callback);
        if ($2f7ff264d90c396f$export$b741a7c3bcb1c635.callbacks.size === 0 && $2f7ff264d90c396f$export$b741a7c3bcb1c635.observer) {
            $2f7ff264d90c396f$export$b741a7c3bcb1c635.observer.disconnect();
            $2f7ff264d90c396f$export$b741a7c3bcb1c635.observer = null;
        }
    }
}
var $2f7ff264d90c396f$export$2e2bcd8739ae039 = $2f7ff264d90c396f$export$b741a7c3bcb1c635;

});



parcelRegister("ctuWl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Box", () => $82a72460ae8892f1$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $82a72460ae8892f1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lE8gv = parcelRequire("lE8gv");

var $2ED8z = parcelRequire("2ED8z");

var $8bHO1 = parcelRequire("8bHO1");

var $6LUAe = parcelRequire("6LUAe");

var $7bVKP = parcelRequire("7bVKP");

var $3FLu8 = parcelRequire("3FLu8");

var $2LmEv = parcelRequire("2LmEv");

var $S0mzO = parcelRequire("S0mzO");
const $82a72460ae8892f1$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $lE8gv.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $2LmEv.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $2ED8z.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $82a72460ae8892f1$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $6LUAe.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7bVKP.isSurfaceColorToken)(backgroundColor) && (0, $S0mzO.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $3FLu8.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $3FLu8.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $3FLu8.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $3FLu8.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $3FLu8.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $3FLu8.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $3FLu8.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $2ED8z.jsx)((0, $8bHO1.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$82a72460ae8892f1$export$2e2bcd8739ae039 = $82a72460ae8892f1$export$e71c4d32a2263218;
const $82a72460ae8892f1$var$baseStyles = (0, $2ED8z.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("6LUAe", function(module, exports) {
$parcel$export(module.exports, "backgroundColorStylesMap", () => $be97d2375b8ed7c4$export$e7af83bafe7f9e63);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $gjc3A = parcelRequire("gjc3A");

var $7HGpH = parcelRequire("7HGpH");
const $be97d2375b8ed7c4$export$e7af83bafe7f9e63 = (0, $7HGpH.getSerializedStylesMap)('backgroundColor', (0, $gjc3A.backgroundColorMap));

});
parcelRegister("gjc3A", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", () => $0b707b24ca773bb2$export$d1d79bf68ac056bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b9ffd6dcccead720baadbffd4a1648a>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $0b707b24ca773bb2$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});


parcelRegister("7bVKP", function(module, exports) {
$parcel$export(module.exports, "isSurfaceColorToken", () => $7a8cc8160778ef1b$export$5e65a44e5b6ecadb);

var $9oUn1 = parcelRequire("9oUn1");
const $7a8cc8160778ef1b$export$5e65a44e5b6ecadb = (color)=>(0, $9oUn1.surfaceColorMap)[color] !== undefined;

});
parcelRegister("9oUn1", function(module, exports) {
$parcel$export(module.exports, "surfaceColorMap", () => $3af9993b2fe9bcd8$export$41a358c9c2356760);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6c124f7044e82421c90bec6e00efe281>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $3af9993b2fe9bcd8$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};

});


parcelRegister("3FLu8", function(module, exports) {
$parcel$export(module.exports, "paddingStylesMap", () => $0f25649882268352$export$e615f061ca585a6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $35SSX = parcelRequire("35SSX");

var $jL6LT = parcelRequire("jL6LT");
const $0f25649882268352$export$e615f061ca585a6c = (0, $35SSX.createSpacingStylesMap)((0, $jL6LT.positiveSpaceMap), [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd'
]);

});
parcelRegister("35SSX", function(module, exports) {
$parcel$export(module.exports, "createSpacingStylesMap", () => $cfb6a6518c214665$export$f2bee1f59203ac70);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $7HGpH = parcelRequire("7HGpH");
const $cfb6a6518c214665$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
const $cfb6a6518c214665$export$f2bee1f59203ac70 = (tokenMap, properties)=>{
    return properties.reduce((styleMap, spacingProperty)=>{
        styleMap[spacingProperty] = (0, $7HGpH.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};

});

parcelRegister("jL6LT", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", () => $7c0a2354cbfd10a4$export$958d0ae7f2977ae4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f731f68889ddb15c3ca5eb9ba3b166e>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::4f610fa8bb46de944777a03e71c40303>>
 */ const $7c0a2354cbfd10a4$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});


parcelRegister("2LmEv", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $baef99ccf0cb030c$export$a9c84988c8f81f2d);
/* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ /* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("lE8gv");

var $dLZNc = parcelRequire("dLZNc");
const $baef99ccf0cb030c$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $baef99ccf0cb030c$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [(0, $dLZNc.uniqueSymbol)]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};

});
parcelRegister("dLZNc", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", () => $529e2aed140dd953$export$43e479c916cb4ada);
const $529e2aed140dd953$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});


parcelRegister("S0mzO", function(module, exports) {
$parcel$export(module.exports, "surfaceColorStylesMap", () => $c6b258457a39c197$export$ff257d957d48c421);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $cdQaS = parcelRequire("cdQaS");

var $7HGpH = parcelRequire("7HGpH");

var $9oUn1 = parcelRequire("9oUn1");
const $c6b258457a39c197$export$ff257d957d48c421 = (0, $7HGpH.getSerializedStylesMap)((0, $cdQaS.CURRENT_SURFACE_CSS_VAR), (0, $9oUn1.surfaceColorMap));

});


parcelRegister("eD8vk", function(module, exports) {
$parcel$export(module.exports, "xcss", () => $c1ff4c30beb942dc$export$f6c783d06584602c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2ED8z = parcelRequire("2ED8z");

var $iq5UK = parcelRequire("iq5UK");

var $dLZNc = parcelRequire("dLZNc");

var $kUjzi = parcelRequire("kUjzi");
const $c1ff4c30beb942dc$var$isSafeEnvToThrow = ()=>typeof $kUjzi === 'object' && typeof $kUjzi.env === 'object' && false;
const $c1ff4c30beb942dc$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $c1ff4c30beb942dc$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $c1ff4c30beb942dc$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($c1ff4c30beb942dc$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $c1ff4c30beb942dc$var$safeSelectors.test(key)) {
            styleObj[key] = $c1ff4c30beb942dc$var$transformStyles(value);
            return;
        }
        if ($c1ff4c30beb942dc$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($c1ff4c30beb942dc$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $iq5UK.tokensMap))) return;
        const tokenValue = (0, $iq5UK.tokensMap)[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $c1ff4c30beb942dc$var$baseXcss = (style)=>{
    const transformedStyles = $c1ff4c30beb942dc$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [(0, $dLZNc.uniqueSymbol)]: (0, $2ED8z.css)(transformedStyles)
    };
};
function $c1ff4c30beb942dc$export$f6c783d06584602c(style) {
    return $c1ff4c30beb942dc$var$baseXcss(style);
}

});
parcelRegister("iq5UK", function(module, exports) {
$parcel$export(module.exports, "tokensMap", () => $0a4973a3e6e99aa7$export$9a199fbafee0014e);

var $gY3Q1 = parcelRequire("gY3Q1");

var $gjc3A = parcelRequire("gjc3A");

var $92sly = parcelRequire("92sly");

var $1Y15G = parcelRequire("1Y15G");

var $dmfTv = parcelRequire("dmfTv");

var $a5lRi = parcelRequire("a5lRi");

var $i899G = parcelRequire("i899G");

var $hB3xz = parcelRequire("hB3xz");

var $fRuba = parcelRequire("fRuba");

var $baWIZ = parcelRequire("baWIZ");

var $1pLs4 = parcelRequire("1pLs4");

var $bY0tO = parcelRequire("bY0tO");

var $jL6LT = parcelRequire("jL6LT");

var $jADlm = parcelRequire("jADlm");

var $4Cucp = parcelRequire("4Cucp");
const $0a4973a3e6e99aa7$export$9a199fbafee0014e = {
    backgroundColor: (0, $gjc3A.backgroundColorMap),
    blockSize: (0, $a5lRi.dimensionMap),
    borderBlockColor: (0, $92sly.borderColorMap),
    borderBlockEndColor: (0, $92sly.borderColorMap),
    borderBlockEndWidth: (0, $dmfTv.borderWidthMap),
    borderBlockStartColor: (0, $92sly.borderColorMap),
    borderBlockStartWidth: (0, $dmfTv.borderWidthMap),
    borderBlockWidth: (0, $dmfTv.borderWidthMap),
    borderBottomColor: (0, $92sly.borderColorMap),
    borderBottomLeftRadius: (0, $1Y15G.borderRadiusMap),
    borderBottomRightRadius: (0, $1Y15G.borderRadiusMap),
    borderBottomWidth: (0, $dmfTv.borderWidthMap),
    borderColor: (0, $92sly.borderColorMap),
    borderEndEndRadius: (0, $1Y15G.borderRadiusMap),
    borderEndStartRadius: (0, $1Y15G.borderRadiusMap),
    borderInlineColor: (0, $92sly.borderColorMap),
    borderInlineEndColor: (0, $92sly.borderColorMap),
    borderInlineEndWidth: (0, $dmfTv.borderWidthMap),
    borderInlineStartColor: (0, $92sly.borderColorMap),
    borderInlineStartWidth: (0, $dmfTv.borderWidthMap),
    borderInlineWidth: (0, $dmfTv.borderWidthMap),
    borderLeftColor: (0, $92sly.borderColorMap),
    borderLeftWidth: (0, $dmfTv.borderWidthMap),
    borderRadius: (0, $1Y15G.borderRadiusMap),
    borderRightColor: (0, $92sly.borderColorMap),
    borderRightWidth: (0, $dmfTv.borderWidthMap),
    borderStartEndRadius: (0, $1Y15G.borderRadiusMap),
    borderStartStartRadius: (0, $1Y15G.borderRadiusMap),
    borderTopColor: (0, $92sly.borderColorMap),
    borderTopLeftRadius: (0, $1Y15G.borderRadiusMap),
    borderTopRightRadius: (0, $1Y15G.borderRadiusMap),
    borderTopWidth: (0, $dmfTv.borderWidthMap),
    borderWidth: (0, $dmfTv.borderWidthMap),
    bottom: (0, $gY3Q1.allSpaceMap),
    boxShadow: (0, $jADlm.shadowMap),
    color: (0, $4Cucp.textColorMap),
    columnGap: (0, $baWIZ.gapSpaceMap),
    font: (0, $i899G.fontMap),
    fontFamily: (0, $hB3xz.fontFamilyMap),
    fontWeight: (0, $fRuba.fontWeightMap),
    gap: (0, $baWIZ.gapSpaceMap),
    height: (0, $a5lRi.dimensionMap),
    inlineSize: (0, $a5lRi.dimensionMap),
    inset: (0, $gY3Q1.allSpaceMap),
    insetBlock: (0, $gY3Q1.allSpaceMap),
    insetBlockEnd: (0, $gY3Q1.allSpaceMap),
    insetBlockStart: (0, $gY3Q1.allSpaceMap),
    insetInline: (0, $gY3Q1.allSpaceMap),
    insetInlineEnd: (0, $gY3Q1.allSpaceMap),
    insetInlineStart: (0, $gY3Q1.allSpaceMap),
    left: (0, $gY3Q1.allSpaceMap),
    margin: (0, $gY3Q1.allSpaceMap),
    marginBlock: (0, $gY3Q1.allSpaceMap),
    marginBlockEnd: (0, $gY3Q1.allSpaceMap),
    marginBlockStart: (0, $gY3Q1.allSpaceMap),
    marginBottom: (0, $gY3Q1.allSpaceMap),
    marginInline: (0, $gY3Q1.allSpaceMap),
    marginInlineEnd: (0, $gY3Q1.allSpaceMap),
    marginInlineStart: (0, $gY3Q1.allSpaceMap),
    marginLeft: (0, $gY3Q1.allSpaceMap),
    marginRight: (0, $gY3Q1.allSpaceMap),
    marginTop: (0, $gY3Q1.allSpaceMap),
    maxBlockSize: (0, $a5lRi.dimensionMap),
    maxHeight: (0, $a5lRi.dimensionMap),
    maxInlineSize: (0, $a5lRi.dimensionMap),
    maxWidth: (0, $a5lRi.dimensionMap),
    minBlockSize: (0, $a5lRi.dimensionMap),
    minHeight: (0, $a5lRi.dimensionMap),
    minInlineSize: (0, $a5lRi.dimensionMap),
    minWidth: (0, $a5lRi.dimensionMap),
    opacity: (0, $bY0tO.opacityMap),
    outlineColor: (0, $92sly.borderColorMap),
    outlineOffset: (0, $gY3Q1.allSpaceMap),
    outlineWidth: (0, $dmfTv.borderWidthMap),
    padding: (0, $jL6LT.positiveSpaceMap),
    paddingBlock: (0, $jL6LT.positiveSpaceMap),
    paddingBlockEnd: (0, $jL6LT.positiveSpaceMap),
    paddingBlockStart: (0, $jL6LT.positiveSpaceMap),
    paddingBottom: (0, $jL6LT.positiveSpaceMap),
    paddingInline: (0, $jL6LT.positiveSpaceMap),
    paddingInlineEnd: (0, $jL6LT.positiveSpaceMap),
    paddingInlineStart: (0, $jL6LT.positiveSpaceMap),
    paddingLeft: (0, $jL6LT.positiveSpaceMap),
    paddingRight: (0, $jL6LT.positiveSpaceMap),
    paddingTop: (0, $jL6LT.positiveSpaceMap),
    right: (0, $gY3Q1.allSpaceMap),
    rowGap: (0, $baWIZ.gapSpaceMap),
    top: (0, $gY3Q1.allSpaceMap),
    width: (0, $a5lRi.dimensionMap),
    zIndex: (0, $1pLs4.layerMap)
};

});
parcelRegister("gY3Q1", function(module, exports) {
$parcel$export(module.exports, "allSpaceMap", () => $8d78b34a5aff568d$export$632685d741f3dbbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e8ad62e43cf88f8199d29d8608d6fdf>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::4f610fa8bb46de944777a03e71c40303>>
 */ const $8d78b34a5aff568d$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};

});

parcelRegister("92sly", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", () => $8cc6cc5e6db3b691$export$1531ad5bb3fbedac);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2852cd6e8656adbef1c6b8cb926235c9>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $8cc6cc5e6db3b691$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.input.search': "var(--ds-border-input-search, #0B120E24)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("1Y15G", function(module, exports) {
$parcel$export(module.exports, "borderRadiusMap", () => $927003fff16f0225$export$3c0a6c3e64bb180d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aac51b10fd4c84e2b653aff461a93b73>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $927003fff16f0225$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};

});

parcelRegister("dmfTv", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", () => $413c47654fee806a$export$e1b83c5210c471b8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cdb9fba904c3ac54bf1c429a821ffc2>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $413c47654fee806a$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("a5lRi", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $d68b3de6730e82e2$export$6ccdbebca2ee545f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e4616710c813452a5dda10e6c422716>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ const $d68b3de6730e82e2$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};

});

parcelRegister("i899G", function(module, exports) {
$parcel$export(module.exports, "fontMap", () => $3b036bfe954f9a11$export$6ffa317d5e70375);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9dc903b89132658c3e8db351b3cf92f>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $3b036bfe954f9a11$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("hB3xz", function(module, exports) {
$parcel$export(module.exports, "fontFamilyMap", () => $821519cc094dd376$export$3c7e9587132614b4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1bd05ea1282426e07fb0ae630b07823d>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $821519cc094dd376$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("fRuba", function(module, exports) {
$parcel$export(module.exports, "fontWeightMap", () => $db356300042ac117$export$303e322c6b1ed114);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::709c4cdac6e8ef806ec1e227c3e362d1>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $db356300042ac117$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};

});

parcelRegister("baWIZ", function(module, exports) {
$parcel$export(module.exports, "gapSpaceMap", () => $5d9ec1caec5dc097$export$ae2d66f16ab57ecd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98f62b1247503f86566cafdb2d4ea768>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::4f610fa8bb46de944777a03e71c40303>>
 */ const $5d9ec1caec5dc097$export$ae2d66f16ab57ecd = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.gap.large': "var(--ds-space-gap-large, 12px)",
    'space.gap.medium': "var(--ds-space-gap-medium, 8px)",
    'space.gap.small': "var(--ds-space-gap-small, 6px)",
    'space.gap.xlarge': "var(--ds-space-gap-xlarge, 16px)",
    'space.gap.xsmall': "var(--ds-space-gap-xsmall, 4px)",
    'space.gap.xxlarge': "var(--ds-space-gap-xxlarge, 24px)",
    'space.gap.xxsmall': "var(--ds-space-gap-xxsmall, 2px)"
};

});

parcelRegister("1pLs4", function(module, exports) {
$parcel$export(module.exports, "layerMap", () => $bc4752abbe917f1f$export$b5f31a7e431d2eab);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10940883f780b624bff6c0029b7ac6fd>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $bc4752abbe917f1f$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};

});

parcelRegister("bY0tO", function(module, exports) {
$parcel$export(module.exports, "opacityMap", () => $fc7544e5cacd5b34$export$daf94a976c798b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f768e44d85ca8256730a17510c4d3901>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $fc7544e5cacd5b34$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};

});

parcelRegister("jADlm", function(module, exports) {
$parcel$export(module.exports, "shadowMap", () => $e89678e235393dbb$export$7aff6e7ba39bb774);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::31f7af0716c25896201100f27266bca7>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $e89678e235393dbb$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};

});



parcelRegister("rJiEz", function(module, exports) {
$parcel$export(module.exports, "illustrationMap", () => $e8e71a58737b7abb$export$3baf7546f5f75a65);
$parcel$export(module.exports, "getIllustration", () => $e8e71a58737b7abb$export$6754ebb763d0f990);
const $e8e71a58737b7abb$export$3baf7546f5f75a65 = {
    Roadmap: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7jw212gilh0pq8s0hyul84fdi678bf3k.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0j3wjupcj175311cn17hjvu3505dfeui.svg'
    },
    LetterOpen: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0rq27e55o54h8b5712rj4y7w6pyw77k4.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3d1701i21867ve0bh5o0mbsj03713erf.svg'
    },
    ErrorStateSearchNoResults: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j6orj168ea4wt8pf7gmy3f34fvhe5dhf.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/duh2c4s6cuwgu70xrp0phjc8q6mb214q.svg'
    },
    AddUser: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/320g85q2c1i2bb3r68d03w53mfbgf80a.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b70i6y7u7xe1xl0tb6imq53e8jq76iul.svg'
    },
    AddTeam: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25k7w5wf47sb030idd3p8473kw6jx812.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/443ly120bio7a4626h3vu431o8af6v65.svg'
    },
    BasicsUserManagement: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x30s04076y6v8m351n3f1s8vtbb1fr28.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fy16p5y4vm63ojm2f244m21pb66l64wq.svg'
    },
    RefreshUpdate: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v2c0s81enc43u8c8yp1425nju6lm4hja.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o3nxb5ua68n5h1s67d6x0750a07y55co.svg'
    },
    EmptyStateDone: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8xyyd278180s44355m6ai1u0q36aedgu.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/77c3l22p8jr18230f77r34ud130xua44.svg'
    },
    ErrorStateSearch: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/h5b4hajdmg7555sxeguvler50nh26m2b.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k611370iv6do1622kj2wyto863oe82w8.svg'
    },
    DevOps: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p5xhuk78014yagtkpu4r6f0x1n5105dt.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x32yp5sb5q5340t3j57r24bv54vsfxdy.svg'
    },
    BasicsDone: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4fx5w8c7ygm211h3hk56gd063r12iuxx.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1p180c132m3w8pn6lwd050i5131qg7u5.svg'
    },
    BasicsMap: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k501d3mq2mr856ifm73xw0f54ld05hi5.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/80487c5lci30v652q126ob2v7lg5hxqm.svg'
    },
    BasicsCloud: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k87t038hjt8ug7b4e74hcxfjj725yh0a.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mt0g72401sly7i6817l0pmy50g7ux1gs.svg'
    },
    BasicsToolbox: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7bl2xobvtdl5l087p3ekiif3245mh5bq.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7b3hyne70j556m3386dq524lm8604054.svg'
    },
    BasicsIntegration: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i6h32pl6kgxhw4rnvv6032y2m2g12k58.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4vx3hb148215x8k2nmoo6c6i1d24ctm6.svg'
    },
    BasicsNetwork: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hkom1wq6850fkil8l387x661p5i618v6.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2718224l1o08ub15ckk8y40gkv4a0htm.svg'
    },
    BasicsTelescope: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7j80s288m4qhgsetie6sve68n2ej1405.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mfdrhx07ec534x8u6883a1g8304a5wkf.svg'
    },
    BasicsMigrations: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/02h181332ob0bb0h8y01dn463ac85650.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/e41m7730o4jx767sr3q0wqxy40q478d0.svg'
    },
    EmptyStateAddCard: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qxxv401l02xqijm865431t77jlj56o42.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/cs314684x4sdec707ruwgkw7s4l2j238.svg'
    },
    PurchaseSolutions: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1m6mj7is0crda1j8k4001pf33f5ayg3v.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4836vvm76sj7b5bk4nlnrlf2w7156ahp.svg'
    },
    BasicsToggle: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q5jk78i1638850vvywhnq3a88fkulcgg.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1ugf4n1b1obwy3x50o3cy7b1cb2ogvlt.svg'
    },
    Gear: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2054s3i80cnl0rj21onct4wni4503y2f.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pe4r106m14js5axb1104afiy6u86q1q7.svg'
    },
    Clipboard: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x261nhq5uvo03ck303l448ok54we4s40.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v6k72hphq6iy40h02b06x4tjn0pp1xg2.svg'
    },
    BasicsPadlockKey: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8mdy4ly4472iy7oe1so16p7n8tg0tq4j.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m780xv54x0c80rl10fj7st2827143du8.svg'
    },
    BasicsSafe: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/61515r0ky6w25rgox71ikg8xr8ews7c2.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/84gvg2c6ne2404470v8nhm20t50o141n.svg'
    },
    BasicsCompliance: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v02gk84pk8m4615us43275j34152ao8e.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/64px0476b1560y7213q21d838a5h536w.svg'
    },
    BasicsTracking: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/jw6pndhya20421lupo7fa1lrq838jjt6.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/720328508vo54hxd37g211kgq785r20l.svg'
    },
    BasicsGear: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b5fd2x7vyous80066drr052o0fv54jq7.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/42fqbi1p3krj77y4x35027s6bhykshj6.svg'
    },
    BasicsSearchDocuments: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/481u3aim7rr8i4ody7g8x73851400u66.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/86a33isl2idxkh3l7p0h577h02f66lq7.svg'
    },
    IdBadge: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/583882gc55qf4rc6r65e42x73o6y8050.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0kqc63x6c2g52f53c42543m284q2r01b.svg'
    },
    DataPrivacy: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/203264h64h0jjak63j4844s47b2d0hi4.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l33xi5x21ktjj23c6403663u6oy1g0bu.svg'
    },
    Firewall: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/88100e300go74n6bpg2xl2o2y42s85jh.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/54v6f06r1lefsgmppt70v086q5cy00ca.svg'
    },
    BasicsCalendar: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kaw757yfmx4x318281etb8x1x73tdnr1.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xuah062301y0cf7hg8f17tp7s6d1l17p.svg'
    },
    BasicsCaptureUsers: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wh17145204218s6k8ob72577fk02733b.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y5e147js1ix8263j84t6hd20m475lqs4.svg'
    },
    EmptyStateAddItem: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/457n14i63u567yex70d3f7whn3muk424.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4kc212md11dd2sf8p3br83cltr1l5pfl.svg'
    },
    BasicsPlatform: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/214yy1pd03tl403v5a2b52540y8001y1.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ngr7gg603m7xa7p387t5lp4346ocmn28.svg'
    },
    Coins: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/06fh24615yc78k4m6f425t5ubds7u2od.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vhu2f73mpr4umr41oku53wac1ymjjl7o.svg'
    },
    ErrorColor: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2e655j87263160n28qbq8w21442ap32e.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/027e8530v08n5no10q4531pn3bj2xff2.svg'
    },
    EmptyStateLinkProduct: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vw8wnk2l1ir45e3paqo112k1o7pe7651.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8o713f7rqa14ybt1h2p607p8q7trs07i.svg'
    },
    EmptyStateAddDomain: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5w8wk47o7bk5tnc0kaobgli411ewr670.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/24fyu3u2u7w1te42ey0kbp0vkw7my7o3.svg'
    },
    Target: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/td5b33i7s8eo54p44y0g8sc514qh3yt5.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eey6g3u233r4ed2od7vxfj5k8jpe00y6.svg'
    },
    Keys: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/78p40jv6as05i5igau72l3g786t60v6d.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l6s154tgi0x86c5d8fmbe8w25tappa8y.svg'
    },
    LegalSignature: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r1kv0fypxbw3b87dw51b1s87g3sbye7j.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4tvrp0lg435g3ul8qtf1k0mul2202ld2.svg'
    },
    Certificate: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/olc6ly6444j28201xvy1l47u875c7ni5.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/45mu552reqn43g0ll8247215v73357l2.svg'
    },
    Book: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/rgls54sa2ht127b36w6gtrn007hq540r.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ta66oqj1j4p06b78dj0lgsrnsrn7v8g0.svg'
    },
    Scalability: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/e43505bjv28k04y3p1op386fl3bbv635.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p51k45qsv122cmfk7l346kghiduaoai1.svg'
    },
    Launch: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mo4ruaiviisypd0843v5122af3058412.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ghd3w62kfhyuut0712ft7aml7r31rhea.svg'
    },
    Safe: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3tgmc31cmtkh1f15850ljn63ij8c780q.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/083e51o6yx24qd652c4516osh7l7m3xp.svg'
    },
    FileCabinet: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3s5fh384d6711v6v8nh25i62p87s3234.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0h181827yev84ha3143f8gwdv2211l4j.svg'
    },
    BasicsSearchFiles: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m06sfph6ghm12alyp2qbjduo138s717k.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/14ck50342nk275nrd1kb61i274071537.svg'
    },
    BasicsEncryption: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/34806iiapwi25t3e6prty1362w8q1q30.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/14ra46smb04xi65x078mu23je85p8gv7.svg'
    },
    BasicsUpload: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fgry4p8x7a41p0rgy602e2ihd8m3t1f2.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nvr5bibqhna6f8s62txcp74uy0l1a817.svg'
    },
    BasicsIntergrations: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3ej70r224drtwu8rp5rme5r8jca4b3t7.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g06n8681o6xlgg2m85166viix55trhvx.svg'
    },
    BasicsPadlock: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xm6yhtu41o0a72s0120656i5635i0psh.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3tk03r230nw0qj42m10hu78bb8g8v686.svg'
    },
    ErrorGeneral: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y57gh135brj0y5636ry8373s216388ll.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ma5w4y4y8fpe380ty61yb76737387358.svg'
    },
    GeneralSpeed: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s4whr5562p47uxh3e53w28c873hc02eg.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/f5k75b0e166640ia64560hf14644107x.svg'
    },
    GeneralFolder: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/uuxyrbe462u44513566nt718214bf703.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/745g31l520pn56wy4qge851et537of67.svg'
    },
    EmptyStateAddPage: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2mp148gy6fg4b7dhyw31cjj3261oej2v.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3h018oh050r4v4058l7544f5xxk4s6h5.svg'
    },
    CreditCard: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nh0bbp8rjwq8mk2r1w342ke3j24uoi02.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r1rn72wjhah5mfg5muyk81mactw8m5f6.svg'
    },
    PowerfulFeature: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2o22x8xvx8g8264iug346lp75n281520.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/67my2r0s61mbw76b5oxcyfs5s88k72q3.svg'
    },
    HourGlass: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y3mm3ad1u5kpvr68j3jb0e8e7d00o5r0.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/456r68qp3q717ln3q431n5gw0871gc27.svg'
    },
    ValueDiamond: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/55y50mimx1v7p7713d4k71v26o15u0ru.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ihgmiq546710w63n2u3yl453t36127sk.svg'
    },
    TeamValues: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d3rf5ch87s3xw25n8uw0jm3844171n0h.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/888g5f0t3480wi2soeu231gl2tu40uyh.svg'
    },
    RainIncident: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/icukl8b50y8ob6353w2o542843177n01.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q046fj32r665n7677ggmt554kpm27ven.svg'
    },
    PageBarChart: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5h2511y7u13g4pkjb0r5gbqdajts3a7p.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/575j1hj7237ocbtqr7c800ice3d50523.svg'
    },
    GlobalNetwork: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y0uarnxka84le10408im250c41v1xl7r.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/op3g5cwa212b37uechd58dmqysc2504v.svg'
    },
    Users: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v60acd80fl8007s5g101hh76yfb7ne7v.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4nqf045g7731f2lk1p78ktc8eq3j4qqr.svg'
    },
    FlagLogo: {
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12PK9.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT15WPF.svg'
    }
};
const $e8e71a58737b7abb$export$60247ecb8593cd70 = Object.keys($e8e71a58737b7abb$export$3baf7546f5f75a65);
const $e8e71a58737b7abb$export$6754ebb763d0f990 = (key)=>{
    const illustration = $e8e71a58737b7abb$export$3baf7546f5f75a65[key];
    if (typeof illustration === 'string') return {
        light: illustration,
        dark: illustration
    };
    return illustration;
};

});



parcelRegister("jYOvc", function(module, exports) {
$parcel$export(module.exports, "withFlag", () => $a21fc97b6b8a3c54$export$be038e46cb4d66a6);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $fvp0u = parcelRequire("fvp0u");
function $a21fc97b6b8a3c54$export$be038e46cb4d66a6(WrappedComponent) {
    return ({ ...props })=>{
        const show = (0, $fvp0u.Flags).showFlag;
        const hide = (0, $fvp0u.Flags).hideFlag;
        const hideStartingWith = (0, $fvp0u.Flags).hideFlagsStartingWith;
        return /*#__PURE__*/ (0, $kOwiQ.jsx)(WrappedComponent, {
            ...props,
            showFlag: show,
            hideFlag: hide,
            hideFlagsStartingWith: hideStartingWith
        });
    };
}

});
parcelRegister("fvp0u", function(module, exports) {
$parcel$export(module.exports, "Flags", () => $fd67ffd8d878c1aa$export$434ba092ed0eee4e);

var $lUWyH = parcelRequire("lUWyH");
(function(Flags) {
    Flags.reactiveVariables = {
        flags: (0, $lUWyH.makeVar)([])
    };
    Flags.showFlag = (newFlag)=>{
        const flagVar = Flags.reactiveVariables.flags;
        const hasFlag = flagVar().find((flag)=>flag.id === newFlag.id);
        if (hasFlag) return;
        flagVar([
            ...flagVar(),
            newFlag
        ]);
    };
    Flags.hideFlag = (flagId, skipOnClose)=>{
        const flagVar = Flags.reactiveVariables.flags;
        const newMap = flagVar().filter((flag)=>flag.id !== flagId);
        // Return if there are no flags found of that flag id.
        if (newMap.length === flagVar().length) return;
        // Calls "onClose" for flags that are being hidden, only if skipOnClose is not true.
        if (!skipOnClose) flagVar().forEach((flag)=>{
            if (flag.id === flagId && typeof flag.onClose === 'function') flag.onClose();
        });
        flagVar(newMap);
    };
    Flags.hideFlagsStartingWith = (prefix, skipOnClose)=>{
        const flagVar = Flags.reactiveVariables.flags;
        const newMap = flagVar().filter((flag)=>!flag.id.startsWith(prefix));
        // Return if there are no flags found of that flag id.
        if (newMap.length === flagVar().length) return;
        // Calls "onClose" for flags that are being hidden, only if skipOnClose is not true.
        if (!skipOnClose) flagVar().forEach((flag)=>{
            if (flag.id.startsWith(prefix) && typeof flag.onClose === 'function') flag.onClose();
        });
        flagVar(newMap);
    };
    Flags.updateFlag = (newFlag)=>{
        const flagVar = Flags.reactiveVariables.flags;
        const newMap = flagVar().map((flag)=>flag.id === newFlag.id ? newFlag : flag);
        flagVar(newMap);
    };
})($fd67ffd8d878c1aa$export$434ba092ed0eee4e || ($fd67ffd8d878c1aa$export$434ba092ed0eee4e = {}));
var $fd67ffd8d878c1aa$export$434ba092ed0eee4e;

});


parcelRegister("dJ5dT", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fb4317c1932202c$export$2e2bcd8739ae039);

var $fQlM1 = parcelRequire("fQlM1");
var $8fb4317c1932202c$export$2e2bcd8739ae039 = (0, $fQlM1.default);

});
parcelRegister("fQlM1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c9c38e614712fb0$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $90lFE = parcelRequire("90lFE");

var $aH2g5 = parcelRequire("aH2g5");

var $aFtZR = parcelRequire("aFtZR");

var $25z81 = parcelRequire("25z81");
const $5c9c38e614712fb0$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $lE8gv.useEffect) : (0, $lE8gv.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $5c9c38e614712fb0$var$useInteractionIdValue() {
    const interactionId = (0, $lE8gv.useContext)((0, $aFtZR.default));
    const [currentId, setCurrentId] = (0, $lE8gv.useState)(interactionId?.current || null);
    $5c9c38e614712fb0$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $25z81.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $5c9c38e614712fb0$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $90lFE.isUFOEnabled)();
    const currentInteractionId = $5c9c38e614712fb0$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $lE8gv.useContext)((0, $aH2g5.default));
    $5c9c38e614712fb0$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kOwiQ.Fragment), {
        children: children
    }) : null;
}

});
parcelRegister("90lFE", function(module, exports) {
$parcel$export(module.exports, "isFedrampOverrideActive", () => $5467259a58a60400$export$1133b5e2873baa7a);
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $5467259a58a60400$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $5467259a58a60400$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $5467259a58a60400$export$44487a86467333c3);
$parcel$export(module.exports, "getSelectorConfig", () => $5467259a58a60400$export$59e1f072477dfb48);
$parcel$export(module.exports, "isUFOEnabled", () => $5467259a58a60400$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $5467259a58a60400$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $5467259a58a60400$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $5467259a58a60400$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $5467259a58a60400$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $5467259a58a60400$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $5467259a58a60400$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $5467259a58a60400$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $5467259a58a60400$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $5467259a58a60400$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $5467259a58a60400$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $5467259a58a60400$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $5467259a58a60400$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $5467259a58a60400$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $5467259a58a60400$export$c681731847989445);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $68vW8 = parcelRequire("68vW8");

var $fBWTV = parcelRequire("fBWTV");
let $5467259a58a60400$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $5467259a58a60400$var$cachedIsFedrampModerate;
function $5467259a58a60400$var$detectIsFedrampModerate() {
    if ($5467259a58a60400$var$cachedIsFedrampModerate !== undefined) return $5467259a58a60400$var$cachedIsFedrampModerate;
    try {
        $5467259a58a60400$var$cachedIsFedrampModerate = (0, $68vW8.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $5467259a58a60400$var$cachedIsFedrampModerate = false;
    }
    return $5467259a58a60400$var$cachedIsFedrampModerate;
}
function $5467259a58a60400$export$89dc2b6be8cc261() {
    $5467259a58a60400$var$cachedIsFedrampModerate = undefined;
}
function $5467259a58a60400$export$1133b5e2873baa7a() {
    try {
        return $5467259a58a60400$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $5467259a58a60400$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $5467259a58a60400$export$f9bb3bb330fb9609 = 'fy26.04';
function $5467259a58a60400$export$2182e73d31080cbc() {
    return $5467259a58a60400$export$f9bb3bb330fb9609;
}
const $5467259a58a60400$export$d50dacda7fe6392b = 1000;
function $5467259a58a60400$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof enabledVCRevisions?.byExperience === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...enabledVCRevisions?.all ?? [],
            ...Object.values(byExperience).flat()
        ];
        $5467259a58a60400$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $5467259a58a60400$var$config = newConfig;
}
function $5467259a58a60400$export$44487a86467333c3() {
    return $5467259a58a60400$var$config;
}
function $5467259a58a60400$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    // 1. FedRAMP override always wins.
    if ($5467259a58a60400$var$detectIsFedrampModerate()) return $5467259a58a60400$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? $5467259a58a60400$var$config?.vc?.selectorConfig ?? defaultConfig;
}
function $5467259a58a60400$export$74bdb753f1cf4860() {
    // Default to enabled if config is not set or enabled is not explicitly false
    return $5467259a58a60400$var$config?.enabled !== false;
}
const $5467259a58a60400$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $5467259a58a60400$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$5467259a58a60400$var$config) return [];
        if ($5467259a58a60400$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $5467259a58a60400$var$config.vc ?? {};
            if ($5467259a58a60400$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions?.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $fBWTV.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($5467259a58a60400$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $5467259a58a60400$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $5467259a58a60400$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $5467259a58a60400$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $5467259a58a60400$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $5467259a58a60400$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $5467259a58a60400$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $5467259a58a60400$export$2d8f8d64dc343d7b() {
    if (!$5467259a58a60400$var$config) return undefined;
    try {
        const stats = $5467259a58a60400$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $5467259a58a60400$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$5467259a58a60400$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $5467259a58a60400$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $5467259a58a60400$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $5467259a58a60400$export$48f4e0d964030a96(name, interactionType) {
    return $5467259a58a60400$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $5467259a58a60400$export$9c69f5a724f05f38(name, interactionType) {
    return $5467259a58a60400$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $5467259a58a60400$export$1d459f020c06ae34(name, interactionType) {
    return $5467259a58a60400$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $5467259a58a60400$export$29b9ffb14861a1d(capability) {
    if ((0, $fBWTV.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$5467259a58a60400$var$config) return 0;
        const { capability: capabilityRate } = $5467259a58a60400$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $5467259a58a60400$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$5467259a58a60400$var$config) return 0;
        const gotConfig = $5467259a58a60400$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
const $5467259a58a60400$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $5467259a58a60400$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$5467259a58a60400$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $5467259a58a60400$var$config;
        if (typingMethod != null && $5467259a58a60400$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $5467259a58a60400$export$2d311b3fd18dcab1() {
    try {
        if (!$5467259a58a60400$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $5467259a58a60400$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $5467259a58a60400$export$4f4649ef27b6f5d6() {
    try {
        if (!$5467259a58a60400$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $5467259a58a60400$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $5467259a58a60400$export$b150ddad71c80d77() {
    try {
        if (!$5467259a58a60400$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $5467259a58a60400$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $5467259a58a60400$export$3c170167645a0eff() {
    try {
        if (!$5467259a58a60400$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $5467259a58a60400$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $5467259a58a60400$export$d6dc9444bd15f70f() {
    try {
        if (!$5467259a58a60400$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $5467259a58a60400$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $5467259a58a60400$export$20e8108b8ccdd0bd() {
    try {
        if (!$5467259a58a60400$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $5467259a58a60400$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $5467259a58a60400$export$2a8604960d7d23d9 = 60000;
function $5467259a58a60400$export$c681731847989445(ufoName) {
    try {
        if (!$5467259a58a60400$var$config) return $5467259a58a60400$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $5467259a58a60400$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $5467259a58a60400$export$2a8604960d7d23d9;
    } catch  {
        return $5467259a58a60400$export$2a8604960d7d23d9;
    }
}

});

parcelRegister("aFtZR", function(module, exports) {
$parcel$export(module.exports, "default", () => $98d2cddffdd465e7$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $lE8gv = parcelRequire("lE8gv");

var $aVB2V = parcelRequire("aVB2V");



// We use a context to allow modals to have their own lifecycle
const $98d2cddffdd465e7$var$interactionContext = (0, $lE8gv.createContext)((0, $aVB2V.default));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$98d2cddffdd465e7$export$2e2bcd8739ae039 = $98d2cddffdd465e7$var$interactionContext;

});
parcelRegister("aVB2V", function(module, exports) {
$parcel$export(module.exports, "default", () => $9868ff159e06200a$export$2e2bcd8739ae039);

var $25z81 = parcelRequire("25z81");
class $9868ff159e06200a$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        if (oldId !== newId) (0, $25z81.listeners).forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
const $9868ff159e06200a$var$initializeGlobalDefaultInteractionID = ()=>{
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    const instance = new $9868ff159e06200a$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $9868ff159e06200a$var$DefaultInteractionID = $9868ff159e06200a$var$initializeGlobalDefaultInteractionID();
var $9868ff159e06200a$export$2e2bcd8739ae039 = $9868ff159e06200a$var$DefaultInteractionID;

});
parcelRegister("25z81", function(module, exports) {
$parcel$export(module.exports, "listeners", () => $05927f942743bc3f$export$58bed631278dbc67);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $05927f942743bc3f$export$3e0c3023952f6774);
// Subscription system for interaction ID changes
const $05927f942743bc3f$export$58bed631278dbc67 = new Set();
const $05927f942743bc3f$export$3e0c3023952f6774 = (listener)=>{
    $05927f942743bc3f$export$58bed631278dbc67.add(listener);
    return ()=>{
        $05927f942743bc3f$export$58bed631278dbc67.delete(listener);
    };
};

});





parcelRegister("8xAuu", function(module, exports) {
$parcel$export(module.exports, "SkeletonBlock", () => $95ac24753d42cfe9$export$fa18745101116729);
$parcel$export(module.exports, "FullPageSkeleton", () => $95ac24753d42cfe9$export$83d86ad505d48b25);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $c42RO = parcelRequire("c42RO");

var $4zqUT = parcelRequire("4zqUT");

var $8kgy5 = parcelRequire("8kgy5");

var $6ivEq = parcelRequire("6ivEq");

var $dJ5dT = parcelRequire("dJ5dT");
const $95ac24753d42cfe9$var$SkeletonBlockImpl = (0, $c42RO.default).span`
	display: inline-block;
	border-radius: ${"var(--ds-radius-large, 8px)"};
	background-color: ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"};
	${({ widthPx: widthPx, heightPx: heightPx })=>(0, $c42RO.css)`
		width: ${widthPx}px;
		max-width: 100%;
		height: ${heightPx}px;
	`} &:not(:last-child) {
		margin-right: ${"var(--ds-space-200, 16px)"};
	}
`;
function $95ac24753d42cfe9$export$fa18745101116729(props) {
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($95ac24753d42cfe9$var$SkeletonBlockImpl, {
        ...props
    });
}
const $95ac24753d42cfe9$var$SkeletonWrapper = (0, $c42RO.default).div`
	height: 100vh;
	display: flex;
	flex-direction: column;
	position: relative;
`;
const $95ac24753d42cfe9$var$SpinnerWrapper = (0, $c42RO.default).div`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
`;
// this height isn't particularly tied to anything, but the whole thing looks nice with it. Design-approved
const $95ac24753d42cfe9$var$headingSkeletonHeightPx = 22;
const $95ac24753d42cfe9$var$TIME_TO_ERROR = 50000;
const $95ac24753d42cfe9$export$83d86ad505d48b25 = (props)=>{
    const isLazyLoadedPage = props.id === 'page-loading';
    const [shouldSendError, setShouldSendError] = $lE8gv.useState(true);
    $lE8gv.useEffect(()=>{
        if (isLazyLoadedPage) return undefined;
        const timeout = setTimeout(()=>{
            const loadedTooLongError = new Error(`Could not load page content after ${$95ac24753d42cfe9$var$TIME_TO_ERROR} milliseconds. page-id=${props.id}.`);
            if (shouldSendError) {
                (0, $6ivEq.monitoringClient).onError(loadedTooLongError);
                setShouldSendError(false);
            }
        }, $95ac24753d42cfe9$var$TIME_TO_ERROR);
        return ()=>{
            clearTimeout(timeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $dJ5dT.default), {
        name: "full-page-skeleton",
        children: /*#__PURE__*/ (0, $kOwiQ.jsxs)($95ac24753d42cfe9$var$SkeletonWrapper, {
            children: [
                /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $8kgy5.MainLayout), {
                    id: props.id,
                    pageType: "skeleton",
                    collapsedNav: props.collapsedNav,
                    isFullWidth: true,
                    breadcrumbs: props.breadcrumbs || /*#__PURE__*/ (0, $kOwiQ.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $kOwiQ.jsx)($95ac24753d42cfe9$export$fa18745101116729, {
                                widthPx: 40,
                                heightPx: 8
                            }),
                            /*#__PURE__*/ (0, $kOwiQ.jsx)($95ac24753d42cfe9$export$fa18745101116729, {
                                widthPx: 120,
                                heightPx: 8
                            })
                        ]
                    }),
                    title: props.title || /*#__PURE__*/ (0, $kOwiQ.jsx)($95ac24753d42cfe9$export$fa18745101116729, {
                        widthPx: 216,
                        heightPx: $95ac24753d42cfe9$var$headingSkeletonHeightPx
                    }),
                    description: props.description || /*#__PURE__*/ (0, $kOwiQ.jsxs)($lE8gv.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
                                children: /*#__PURE__*/ (0, $kOwiQ.jsx)($95ac24753d42cfe9$export$fa18745101116729, {
                                    widthPx: 504,
                                    heightPx: 11
                                })
                            }),
                            /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
                                children: /*#__PURE__*/ (0, $kOwiQ.jsx)($95ac24753d42cfe9$export$fa18745101116729, {
                                    widthPx: 336,
                                    heightPx: 11
                                })
                            })
                        ]
                    }),
                    testId: props.testId
                }),
                props.children ?? /*#__PURE__*/ (0, $kOwiQ.jsx)($95ac24753d42cfe9$var$SpinnerWrapper, {
                    "data-testid": "full-page-skeleton-spinner",
                    children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $4zqUT.default), {
                        size: "large",
                        interactionName: "full-page-skeleton-spinner"
                    })
                })
            ]
        })
    });
};

});
parcelRegister("c42RO", function(module, exports) {
$parcel$export(module.exports, "css", () => $8c881513edf36cac$export$dbf350e5966cf602);
$parcel$export(module.exports, "ThemeProvider", () => $8c881513edf36cac$export$d8964aec282183a3);
$parcel$export(module.exports, "default", () => $8c881513edf36cac$export$2e2bcd8739ae039);

var $eGX1d = parcelRequire("eGX1d");

var $lE8gv = parcelRequire("lE8gv");

var $6tEFg = parcelRequire("6tEFg");

var $kuGtH = parcelRequire("kuGtH");

var $dzGx9 = parcelRequire("dzGx9");

var $c7Q22 = parcelRequire("c7Q22");

var $9A6O3 = parcelRequire("9A6O3");

var $kUjzi = parcelRequire("kUjzi");
var $8c881513edf36cac$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $8c881513edf36cac$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $8c881513edf36cac$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $8c881513edf36cac$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $8c881513edf36cac$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $8c881513edf36cac$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $8c881513edf36cac$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var $8c881513edf36cac$var$isPlainObject = function(x) {
    return (typeof x === 'undefined' ? 'undefined' : $8c881513edf36cac$var$_typeof(x)) === 'object' && x.constructor === Object;
};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var $8c881513edf36cac$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $8c881513edf36cac$var$format() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c = void 0;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var $8c881513edf36cac$var$StyledComponentsError = function(_Error) {
    $8c881513edf36cac$var$inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        $8c881513edf36cac$var$classCallCheck(this, StyledComponentsError);
        for(var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)interpolations[_key2 - 1] = arguments[_key2];
        var _this;
        var _this = $8c881513edf36cac$var$possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
        return $8c881513edf36cac$var$possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var $8c881513edf36cac$var$objToCss = function objToCss(obj, prevKey) {
    var css = Object.keys(obj).filter(function(key) {
        var chunk = obj[key];
        return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
    }).map(function(key) {
        if ($8c881513edf36cac$var$isPlainObject(obj[key])) return objToCss(obj[key], key);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eGX1d)))(key) + ': ' + obj[key] + ';';
    }).join(' ');
    return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};
var $8c881513edf36cac$var$flatten = function flatten(chunks, executionContext) {
    return chunks.reduce(function(ruleSet, chunk) {
        /* Remove falsey values */ if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
        /* Flatten ruleSet */ if (Array.isArray(chunk)) {
            ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
            return ruleSet;
        }
        /* Handle other components */ if (chunk.hasOwnProperty('styledComponentId')) {
            // $FlowFixMe not sure how to make this pass
            ruleSet.push('.' + chunk.styledComponentId);
            return ruleSet;
        }
        /* Either execute or defer the function */ if (typeof chunk === 'function') {
            if (executionContext) {
                var nextChunk = chunk(executionContext);
                /* Throw if a React Element was given styles */ if ((0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).isValidElement(nextChunk)) {
                    var elementName = chunk.displayName || chunk.name;
                    throw new $8c881513edf36cac$var$StyledComponentsError(11, elementName);
                }
                ruleSet.push.apply(ruleSet, flatten([
                    nextChunk
                ], executionContext));
            } else ruleSet.push(chunk);
            return ruleSet;
        }
        /* Handle objects */ ruleSet.push(// $FlowFixMe have to add %checks somehow to isPlainObject
        $8c881513edf36cac$var$isPlainObject(chunk) ? $8c881513edf36cac$var$objToCss(chunk) : chunk.toString());
        return ruleSet;
    }, []);
};
// 
var $8c881513edf36cac$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var $8c881513edf36cac$var$stylisSplitter = new (0, (/*@__PURE__*/$parcel$interopDefault($6tEFg)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var $8c881513edf36cac$var$stylis = new (0, (/*@__PURE__*/$parcel$interopDefault($6tEFg)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var $8c881513edf36cac$var$parsingRules = [];
// eslint-disable-next-line consistent-return
var $8c881513edf36cac$var$returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = $8c881513edf36cac$var$parsingRules;
        $8c881513edf36cac$var$parsingRules = [];
        return parsedRules;
    }
};
var $8c881513edf36cac$var$parseRulesPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($kuGtH)))(function(rule) {
    $8c881513edf36cac$var$parsingRules.push(rule);
});
$8c881513edf36cac$var$stylis.use([
    $8c881513edf36cac$var$parseRulesPlugin,
    $8c881513edf36cac$var$returnRulesPlugin
]);
$8c881513edf36cac$var$stylisSplitter.use([
    $8c881513edf36cac$var$parseRulesPlugin,
    $8c881513edf36cac$var$returnRulesPlugin
]);
var $8c881513edf36cac$var$stringifyRules = function stringifyRules(rules, selector, prefix) {
    var flatCSS = rules.join('').replace($8c881513edf36cac$var$COMMENT_REGEX, ''); // replace JS comments
    var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
    return $8c881513edf36cac$var$stylis(prefix || !selector ? '' : selector, cssStr);
};
var $8c881513edf36cac$var$splitByRules = function splitByRules(css) {
    return $8c881513edf36cac$var$stylisSplitter('', css);
};
// 
function $8c881513edf36cac$export$7ba318d8d2f06c76(target) /* : %checks */ {
    return(// $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string');
}
// 
/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */ function $8c881513edf36cac$export$953e7e0c06f2f28b() {}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $8c881513edf36cac$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $8c881513edf36cac$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ var $8c881513edf36cac$var$generateAlphabeticName = function generateAlphabeticName(code) {
    var name = '';
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > $8c881513edf36cac$var$charsLength; x = Math.floor(x / $8c881513edf36cac$var$charsLength))name = $8c881513edf36cac$var$getAlphabeticChar(x % $8c881513edf36cac$var$charsLength) + name;
    return $8c881513edf36cac$var$getAlphabeticChar(x % $8c881513edf36cac$var$charsLength) + name;
};
// 
var $8c881513edf36cac$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $8c881513edf36cac$var$EMPTY_ARRAY = Object.freeze([]);
var $8c881513edf36cac$var$EMPTY_OBJECT = Object.freeze({});
// 
var $8c881513edf36cac$export$dbf350e5966cf602 = function(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if (typeof styles === 'function' || $8c881513edf36cac$var$isPlainObject(styles)) // $FlowFixMe
    return $8c881513edf36cac$var$flatten($8c881513edf36cac$var$interleave($8c881513edf36cac$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return $8c881513edf36cac$var$flatten($8c881513edf36cac$var$interleave(styles, interpolations));
};
// 
var $8c881513edf36cac$var$SC_ATTR = (typeof $kUjzi !== 'undefined' && undefined, 'data-styled-components');
var $8c881513edf36cac$var$SC_STREAM_ATTR = 'data-styled-streamed';
var $8c881513edf36cac$var$CONTEXT_KEY = '__styled-components-stylesheet__';
var $8c881513edf36cac$var$IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
var $8c881513edf36cac$var$DISABLE_SPEEDY = false;
// 
var $8c881513edf36cac$var$SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var $8c881513edf36cac$var$extractComps = function(maybeCSS) {
    var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace($8c881513edf36cac$var$SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
/* eslint-disable camelcase, no-undef */ var $8c881513edf36cac$var$getNonce = function() {
    return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
};
// 
// Helper to call a given function, only once
var $8c881513edf36cac$var$once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb();
        }
    };
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var $8c881513edf36cac$var$addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var $8c881513edf36cac$var$resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var $8c881513edf36cac$var$hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var $8c881513edf36cac$var$stringifyNames = function stringifyNames(names) {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(' ') + ' ';
    return str.trim();
};
/* clones the nested names dictionary */ var $8c881513edf36cac$var$cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = $8c881513edf36cac$var$_extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var $8c881513edf36cac$var$sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = document.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = document.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new $8c881513edf36cac$var$StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var $8c881513edf36cac$var$safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var $8c881513edf36cac$var$deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var $8c881513edf36cac$var$makeTextMarker = function makeTextMarker(id) {
    return '\n/* sc-component-id: ' + id + ' */\n';
};
/* add up all numbers in array up until and including the index */ var $8c881513edf36cac$var$addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var $8c881513edf36cac$var$makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var el = document.createElement('style');
    el.setAttribute($8c881513edf36cac$var$SC_ATTR, '');
    var nonce = $8c881513edf36cac$var$getNonce();
    if (nonce) el.setAttribute('nonce', nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(document.createTextNode(''));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new $8c881513edf36cac$var$StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var $8c881513edf36cac$var$wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = $8c881513edf36cac$var$getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            $8c881513edf36cac$var$SC_ATTR + '="' + $8c881513edf36cac$var$stringifyNames(names) + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(' ');
        return '<style ' + htmlAttr + '>' + css() + '</style>';
    };
};
/* takes a css factory function and outputs an element factory */ var $8c881513edf36cac$var$wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[$8c881513edf36cac$var$SC_ATTR] = $8c881513edf36cac$var$stringifyNames(names), _props);
        var nonce = $8c881513edf36cac$var$getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).createElement('style', $8c881513edf36cac$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var $8c881513edf36cac$var$getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var $8c881513edf36cac$var$makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        $8c881513edf36cac$var$resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = $8c881513edf36cac$var$sheetForTag(el);
        var insertIndex = $8c881513edf36cac$var$addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf('@import') !== -1) importRules.push(cssRule);
            else if ($8c881513edf36cac$var$safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        $8c881513edf36cac$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        var size = sizes[marker];
        var sheet = $8c881513edf36cac$var$sheetForTag(el);
        var removalIndex = $8c881513edf36cac$var$addUpUntilIndex(sizes, marker);
        $8c881513edf36cac$var$deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        $8c881513edf36cac$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var _sheetForTag = $8c881513edf36cac$var$sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += $8c881513edf36cac$var$makeTextMarker(id);
            var marker = markers[id];
            var end = $8c881513edf36cac$var$addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new $8c881513edf36cac$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $8c881513edf36cac$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $8c881513edf36cac$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $8c881513edf36cac$var$wrapAsElement(css, names),
        toHTML: $8c881513edf36cac$var$wrapAsHtmlTag(css, names)
    };
};
var $8c881513edf36cac$var$makeTextNode = function makeTextNode(id) {
    return document.createTextNode($8c881513edf36cac$var$makeTextMarker(id));
};
var $8c881513edf36cac$var$makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = $8c881513edf36cac$var$makeTextNode(id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf('@import') !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? '' : ' ';
                marker.appendData('' + rule + separator);
            }
        }
        $8c881513edf36cac$var$addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = $8c881513edf36cac$var$makeTextNode(id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        $8c881513edf36cac$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new $8c881513edf36cac$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $8c881513edf36cac$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $8c881513edf36cac$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $8c881513edf36cac$var$wrapAsElement(css, names),
        toHTML: $8c881513edf36cac$var$wrapAsHtmlTag(css, names)
    };
};
var $8c881513edf36cac$var$makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ''
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(' ');
        $8c881513edf36cac$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = '';
        $8c881513edf36cac$var$resetIdNames(names, id);
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += $8c881513edf36cac$var$makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = $8c881513edf36cac$var$cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTagInternal(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: $8c881513edf36cac$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $8c881513edf36cac$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: $8c881513edf36cac$var$wrapAsElement(css, names),
        toHTML: $8c881513edf36cac$var$wrapAsHtmlTag(css, names)
    };
    return tag;
};
var $8c881513edf36cac$var$makeServerTag = function makeServerTag() {
    return $8c881513edf36cac$var$makeServerTagInternal();
};
var $8c881513edf36cac$var$makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if ($8c881513edf36cac$var$IS_BROWSER && !forceServer) {
        var el = $8c881513edf36cac$var$makeStyleTag(target, tagEl, insertBefore);
        if ($8c881513edf36cac$var$DISABLE_SPEEDY) return $8c881513edf36cac$var$makeBrowserTag(el, getImportRuleTag);
        else return $8c881513edf36cac$var$makeSpeedyTag(el, getImportRuleTag);
    }
    return $8c881513edf36cac$var$makeServerTag();
};
/* wraps a given tag so that rehydration is performed once when necessary */ var $8c881513edf36cac$var$makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
    /* rehydration function that adds all rules to the new tag */ var rehydrate = $8c881513edf36cac$var$once(function() {
        /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
            var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
            var cssRules = $8c881513edf36cac$var$splitByRules(cssFromDOM);
            tag.insertRules(componentId, cssRules);
        }
        /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
            var el = els[_i];
            if (el.parentNode) el.parentNode.removeChild(el);
        }
    });
    if (immediateRehydration) rehydrate();
    return $8c881513edf36cac$var$_extends({}, tag, {
        /* add rehydration hook to insertion methods */ insertMarker: function insertMarker(id) {
            rehydrate();
            return tag.insertMarker(id);
        },
        insertRules: function insertRules(id, cssRules, name) {
            rehydrate();
            return tag.insertRules(id, cssRules, name);
        }
    });
};
// 
var $8c881513edf36cac$var$SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var $8c881513edf36cac$var$MAX_SIZE = void 0;
if ($8c881513edf36cac$var$IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ $8c881513edf36cac$var$MAX_SIZE = $8c881513edf36cac$var$DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ $8c881513edf36cac$var$MAX_SIZE = -1;
var $8c881513edf36cac$var$sheetRunningId = 0;
var $8c881513edf36cac$var$master = void 0;
var $8c881513edf36cac$var$StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $8c881513edf36cac$var$IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $8c881513edf36cac$var$classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = $8c881513edf36cac$var$makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        $8c881513edf36cac$var$sheetRunningId += 1;
        this.id = $8c881513edf36cac$var$sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate() {
        if (!$8c881513edf36cac$var$IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll('style[' + $8c881513edf36cac$var$SC_ATTR + ']');
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (nodesSize === 0) return this;
        for(var i = 0; i < nodesSize; i += 1){
            // $FlowFixMe: We can trust that all elements in this query are style elements
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute($8c881513edf36cac$var$SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute($8c881513edf36cac$var$SC_ATTR) || '').trim().split($8c881513edf36cac$var$SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0; j < elNamesSize; j += 1){
                var name = elNames[j];
                /* add rehydrated name to sheet to avoid readding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, $8c881513edf36cac$var$extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (extractedSize === 0) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        var rehydrationTag = $8c881513edf36cac$var$makeRehydrationTag(tag, els, extracted, isStreamed);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, $8c881513edf36cac$var$MAX_SIZE - extractedSize);
        this.tags.push(rehydrationTag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = rehydrationTag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $8c881513edf36cac$var$master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = $8c881513edf36cac$var$_extends({}, this.rehydratedNames);
        sheet.deferred = $8c881513edf36cac$var$_extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return $8c881513edf36cac$var$makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = $8c881513edf36cac$var$MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for injectGlobal to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join('');
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = 'sc-' + id + '-' + i;
            return (0, $lE8gv.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    $8c881513edf36cac$var$createClass(StyleSheet, null, [
        {
            key: 'master',
            get: function get$$1() {
                return $8c881513edf36cac$var$master || ($8c881513edf36cac$var$master = new StyleSheet().rehydrate());
            }
        },
        {
            key: 'instance',
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
var $8c881513edf36cac$var$_StyleSheetManager$ch;
var $8c881513edf36cac$export$a473771da2f0ff7c = function(_Component) {
    $8c881513edf36cac$var$inherits(StyleSheetManager, _Component);
    function StyleSheetManager() {
        $8c881513edf36cac$var$classCallCheck(this, StyleSheetManager);
        return $8c881513edf36cac$var$possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    StyleSheetManager.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[$8c881513edf36cac$var$CONTEXT_KEY] = this.sheetInstance, _ref;
    };
    StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
        if (this.props.sheet) this.sheetInstance = this.props.sheet;
        else if (this.props.target) this.sheetInstance = new $8c881513edf36cac$var$StyleSheet(this.props.target);
        else throw new $8c881513edf36cac$var$StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        /* eslint-disable react/prop-types */ // Flow v0.43.1 will report an error accessing the `children` property,
        // but v0.47.0 will not. It is necessary to use a type cast instead of
        // a "fixme" comment to satisfy both Flow versions.
        return (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).Children.only(this.props.children);
    };
    return StyleSheetManager;
}((0, $lE8gv.Component));
$8c881513edf36cac$export$a473771da2f0ff7c.childContextTypes = ($8c881513edf36cac$var$_StyleSheetManager$ch = {}, $8c881513edf36cac$var$_StyleSheetManager$ch[$8c881513edf36cac$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).instanceOf($8c881513edf36cac$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).instanceOf($8c881513edf36cac$export$ae8c7d15c8b89a20)
]).isRequired, $8c881513edf36cac$var$_StyleSheetManager$ch);
// 
var $8c881513edf36cac$export$ae8c7d15c8b89a20 = function() {
    function ServerStyleSheet() {
        $8c881513edf36cac$var$classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = $8c881513edf36cac$var$StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.closed = false;
    }
    ServerStyleSheet.prototype.complete = function complete() {
        if (!this.closed) {
            /* Remove closed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.closed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.closed) throw new $8c881513edf36cac$var$StyledComponentsError(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).createElement($8c881513edf36cac$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.complete();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.complete();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new $8c881513edf36cac$var$StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var $8c881513edf36cac$var$LIMIT = 200;
var $8c881513edf36cac$var$createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $8c881513edf36cac$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn('Over ' + $8c881513edf36cac$var$LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $8c881513edf36cac$var$determineTheme = function(props, fallbackTheme, defaultProps) {
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types */ var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
    /* eslint-enable */ return theme;
};
// 
var $8c881513edf36cac$var$escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var $8c881513edf36cac$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $8c881513edf36cac$var$escape(str) {
    return str// Replace all possible CSS selectors
    .replace($8c881513edf36cac$var$escapeRegex, '-')// Remove extraneous hyphens at the start and end
    .replace($8c881513edf36cac$var$dashesAtEnds, '');
}
// 
function $8c881513edf36cac$var$getComponentName(target) {
    return target.displayName || target.name || 'Component';
}
// 
function $8c881513edf36cac$var$isTag(target) /* : %checks */ {
    return typeof target === 'string';
}
// 
function $8c881513edf36cac$var$generateDisplayName(target) {
    return $8c881513edf36cac$var$isTag(target) ? 'styled.' + target : 'Styled(' + $8c881513edf36cac$var$getComponentName(target) + ')';
}
// 
/* eslint-disable max-len */ /**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */ /*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/ /* eslint-enable max-len */ var $8c881513edf36cac$var$ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */ var $8c881513edf36cac$var$ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var $8c881513edf36cac$var$ATTRIBUTE_NAME_CHAR = $8c881513edf36cac$var$ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var $8c881513edf36cac$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + $8c881513edf36cac$var$ATTRIBUTE_NAME_CHAR + ']*$'));
var $8c881513edf36cac$var$validAttr = function(name) {
    return $8c881513edf36cac$var$ATTRIBUTE_REGEX.test(name) || $8c881513edf36cac$var$isCustomAttribute(name.toLowerCase());
};
// 
function $8c881513edf36cac$var$hasInInheritanceChain(child, parent) {
    var target = child;
    while(target){
        target = Object.getPrototypeOf(target);
        if (target && target === parent) return true;
    }
    return false;
}
// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */ var $8c881513edf36cac$var$createBroadcast = function createBroadcast(initialState) {
    var listeners = {};
    var id = 0;
    var state = initialState;
    function publish(nextState) {
        state = nextState;
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(var key in listeners){
            var listener = listeners[key];
            if (listener === undefined) continue;
            listener(state);
        }
    }
    function subscribe(listener) {
        var currentId = id;
        listeners[currentId] = listener;
        id += 1;
        listener(state);
        return currentId;
    }
    function unsubscribe(unsubID) {
        listeners[unsubID] = undefined;
    }
    return {
        publish: publish,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $8c881513edf36cac$var$_contextShape, $8c881513edf36cac$var$_ThemeProvider$contex;
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var $8c881513edf36cac$var$CHANNEL = '__styled-components__';
var $8c881513edf36cac$var$CHANNEL_NEXT = $8c881513edf36cac$var$CHANNEL + 'next__';
var $8c881513edf36cac$var$CONTEXT_CHANNEL_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).shape({
    getTheme: (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).func,
    subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).func,
    unsubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).func
});
var $8c881513edf36cac$var$contextShape = ($8c881513edf36cac$var$_contextShape = {}, $8c881513edf36cac$var$_contextShape[$8c881513edf36cac$var$CHANNEL] = (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).func, $8c881513edf36cac$var$_contextShape[$8c881513edf36cac$var$CHANNEL_NEXT] = $8c881513edf36cac$var$CONTEXT_CHANNEL_SHAPE, $8c881513edf36cac$var$_contextShape);
var $8c881513edf36cac$var$warnChannelDeprecated = void 0;
var $8c881513edf36cac$var$isFunction = function isFunction(test) {
    return typeof test === 'function';
};
/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */ var $8c881513edf36cac$export$d8964aec282183a3 = function(_Component) {
    $8c881513edf36cac$var$inherits(ThemeProvider, _Component);
    function ThemeProvider() {
        $8c881513edf36cac$var$classCallCheck(this, ThemeProvider);
        var _this = $8c881513edf36cac$var$possibleConstructorReturn(this, _Component.call(this));
        _this.unsubscribeToOuterId = -1;
        _this.getTheme = _this.getTheme.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
        // with the outer theme
        var outerContext = this.context[$8c881513edf36cac$var$CHANNEL_NEXT];
        if (outerContext !== undefined) this.unsubscribeToOuterId = outerContext.subscribe(function(theme) {
            _this2.outerTheme = theme;
            if (_this2.broadcast !== undefined) _this2.publish(_this2.props.theme);
        });
        this.broadcast = $8c881513edf36cac$var$createBroadcast(this.getTheme());
    };
    ThemeProvider.prototype.getChildContext = function getChildContext() {
        var _this3 = this, _babelHelpers$extends;
        return $8c881513edf36cac$var$_extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[$8c881513edf36cac$var$CHANNEL_NEXT] = {
            getTheme: this.getTheme,
            subscribe: this.broadcast.subscribe,
            unsubscribe: this.broadcast.unsubscribe
        }, _babelHelpers$extends[$8c881513edf36cac$var$CHANNEL] = function(subscriber) {
            // Patch the old `subscribe` provide via `CHANNEL` for older clients.
            var unsubscribeId = _this3.broadcast.subscribe(subscriber);
            return function() {
                return _this3.broadcast.unsubscribe(unsubscribeId);
            };
        }, _babelHelpers$extends));
    };
    ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) this.publish(nextProps.theme);
    };
    ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeToOuterId !== -1) this.context[$8c881513edf36cac$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    };
    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
    ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;
        if ($8c881513edf36cac$var$isFunction(theme)) {
            var mergedTheme = theme(this.outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : $8c881513edf36cac$var$_typeof(theme)) !== 'object') throw new $8c881513edf36cac$var$StyledComponentsError(8);
        return $8c881513edf36cac$var$_extends({}, this.outerTheme, theme);
    };
    ThemeProvider.prototype.publish = function publish(theme) {
        this.broadcast.publish(this.getTheme(theme));
    };
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).Children.only(this.props.children);
    };
    return ThemeProvider;
}((0, $lE8gv.Component));
$8c881513edf36cac$export$d8964aec282183a3.childContextTypes = $8c881513edf36cac$var$contextShape;
$8c881513edf36cac$export$d8964aec282183a3.contextTypes = ($8c881513edf36cac$var$_ThemeProvider$contex = {}, $8c881513edf36cac$var$_ThemeProvider$contex[$8c881513edf36cac$var$CHANNEL_NEXT] = $8c881513edf36cac$var$CONTEXT_CHANNEL_SHAPE, $8c881513edf36cac$var$_ThemeProvider$contex);
var $8c881513edf36cac$var$_babelHelpers$extends;
// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var $8c881513edf36cac$var$STATIC_EXECUTION_CONTEXT = {};
var $8c881513edf36cac$var$modifiedContextShape = $8c881513edf36cac$var$_extends({}, $8c881513edf36cac$var$contextShape, ($8c881513edf36cac$var$_babelHelpers$extends = {}, $8c881513edf36cac$var$_babelHelpers$extends[$8c881513edf36cac$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).instanceOf($8c881513edf36cac$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($dzGx9))).instanceOf($8c881513edf36cac$export$ae8c7d15c8b89a20)
]), $8c881513edf36cac$var$_babelHelpers$extends));
var $8c881513edf36cac$var$identifiers = {};
/* We depend on components having unique IDs */ var $8c881513edf36cac$var$generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : $8c881513edf36cac$var$escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = ($8c881513edf36cac$var$identifiers[displayName] || 0) + 1;
    $8c881513edf36cac$var$identifiers[displayName] = nr;
    var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};
var $8c881513edf36cac$var$warnExtendDeprecated = function warnExtendDeprecated() {};
// $FlowFixMe
var $8c881513edf36cac$var$BaseStyledComponent = function(_Component) {
    $8c881513edf36cac$var$inherits(BaseStyledComponent, _Component);
    function BaseStyledComponent() {
        var _temp, _this, _ret;
        $8c881513edf36cac$var$classCallCheck(this, BaseStyledComponent);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8c881513edf36cac$var$possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.attrs = {}, _this.state = {
            theme: null,
            generatedClassName: ''
        }, _this.unsubscribeId = -1, _temp), $8c881513edf36cac$var$possibleConstructorReturn(_this, _ret);
    }
    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
        if (this.unsubscribeId !== -1) this.context[$8c881513edf36cac$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    };
    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
        var attrs = this.constructor.attrs;
        var context = $8c881513edf36cac$var$_extends({}, props, {
            theme: theme
        });
        if (attrs === undefined) return context;
        this.attrs = Object.keys(attrs).reduce(function(acc, key) {
            var attr = attrs[key];
            // eslint-disable-next-line no-param-reassign
            acc[key] = typeof attr === 'function' && !$8c881513edf36cac$var$hasInInheritanceChain(attr, (0, $lE8gv.Component)) ? attr(context) : attr;
            return acc;
        }, {});
        return $8c881513edf36cac$var$_extends({}, context, this.attrs);
    };
    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _constructor = this.constructor, attrs = _constructor.attrs, componentStyle = _constructor.componentStyle, warnTooManyClasses = _constructor.warnTooManyClasses;
        var styleSheet = this.context[$8c881513edf36cac$var$CONTEXT_KEY] || $8c881513edf36cac$var$StyleSheet.master;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && attrs === undefined) return componentStyle.generateAndInjectStyles($8c881513edf36cac$var$STATIC_EXECUTION_CONTEXT, styleSheet);
        else {
            var executionContext = this.buildExecutionContext(theme, props);
            var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
            return className;
        }
    };
    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var componentStyle = this.constructor.componentStyle;
        var styledContext = this.context[$8c881513edf36cac$var$CHANNEL_NEXT];
        // If this is a statically-styled component, we don't need to the theme
        // to generate or build styles.
        if (componentStyle.isStatic) {
            var generatedClassName = this.generateAndInjectStyles($8c881513edf36cac$var$STATIC_EXECUTION_CONTEXT, this.props);
            this.setState({
                generatedClassName: generatedClassName
            });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
        } else if (styledContext !== undefined) {
            var subscribe = styledContext.subscribe;
            this.unsubscribeId = subscribe(function(nextTheme) {
                // This will be called once immediately
                var theme = $8c881513edf36cac$var$determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
                var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
                _this2.setState({
                    theme: theme,
                    generatedClassName: generatedClassName
                });
            });
        } else {
            // eslint-disable-next-line react/prop-types
            var theme = this.props.theme || $8c881513edf36cac$var$EMPTY_OBJECT;
            var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
            this.setState({
                theme: theme,
                generatedClassName: _generatedClassName
            });
        }
    };
    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;
        // If this is a statically-styled component, we don't need to listen to
        // props changes to update styles
        var componentStyle = this.constructor.componentStyle;
        if (componentStyle.isStatic) return;
        this.setState(function(prevState) {
            var theme = $8c881513edf36cac$var$determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
            var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
            return {
                theme: theme,
                generatedClassName: generatedClassName
            };
        });
    };
    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unsubscribeFromContext();
    };
    BaseStyledComponent.prototype.render = function render() {
        // eslint-disable-next-line react/prop-types
        var innerRef = this.props.innerRef;
        var generatedClassName = this.state.generatedClassName;
        var _constructor2 = this.constructor, styledComponentId = _constructor2.styledComponentId, target = _constructor2.target;
        var isTargetTag = $8c881513edf36cac$var$isTag(target);
        var className = [
            // eslint-disable-next-line react/prop-types
            this.props.className,
            styledComponentId,
            this.attrs.className,
            generatedClassName
        ].filter(Boolean).join(' ');
        var baseProps = $8c881513edf36cac$var$_extends({}, this.attrs, {
            className: className
        });
        if ($8c881513edf36cac$export$7ba318d8d2f06c76(target)) baseProps.innerRef = innerRef;
        else baseProps.ref = innerRef;
        var propsForElement = baseProps;
        var key = void 0;
        for(key in this.props)// Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || $8c881513edf36cac$var$validAttr(key))) propsForElement[key] = key === 'style' && key in this.attrs ? $8c881513edf36cac$var$_extends({}, this.attrs[key], this.props[key]) : this.props[key];
        return (0, $lE8gv.createElement)(target, propsForElement);
    };
    return BaseStyledComponent;
}((0, $lE8gv.Component));
var $8c881513edf36cac$var$_StyledComponent = function(ComponentStyle, constructWithOptions) {
    var createStyledComponent = function createStyledComponent(target, options, rules) {
        var _options$isClass = options.isClass, isClass = _options$isClass === undefined ? !$8c881513edf36cac$var$isTag(target) : _options$isClass, _options$displayName = options.displayName, displayName = _options$displayName === undefined ? $8c881513edf36cac$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? $8c881513edf36cac$var$generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? $8c881513edf36cac$var$BaseStyledComponent : _options$ParentCompon, extendingRules = options.rules, attrs = options.attrs;
        var styledComponentId = options.displayName && options.componentId ? $8c881513edf36cac$var$escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
        var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
        var StyledComponent = function(_ParentComponent) {
            $8c881513edf36cac$var$inherits(StyledComponent, _ParentComponent);
            function StyledComponent() {
                $8c881513edf36cac$var$classCallCheck(this, StyledComponent);
                return $8c881513edf36cac$var$possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
            }
            StyledComponent.withComponent = function withComponent(tag) {
                var previousComponentId = options.componentId, optionsToCopy = $8c881513edf36cac$var$objectWithoutProperties(options, [
                    'componentId'
                ]);
                var newComponentId = previousComponentId && previousComponentId + '-' + ($8c881513edf36cac$var$isTag(tag) ? tag : $8c881513edf36cac$var$escape($8c881513edf36cac$var$getComponentName(tag)));
                var newOptions = $8c881513edf36cac$var$_extends({}, optionsToCopy, {
                    componentId: newComponentId,
                    ParentComponent: StyledComponent
                });
                return createStyledComponent(tag, newOptions, rules);
            };
            $8c881513edf36cac$var$createClass(StyledComponent, null, [
                {
                    key: 'extend',
                    get: function get$$1() {
                        var rulesFromOptions = options.rules, parentComponentId = options.componentId, optionsToCopy = $8c881513edf36cac$var$objectWithoutProperties(options, [
                            'rules',
                            'componentId'
                        ]);
                        var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
                        var newOptions = $8c881513edf36cac$var$_extends({}, optionsToCopy, {
                            rules: newRules,
                            parentComponentId: parentComponentId,
                            ParentComponent: StyledComponent
                        });
                        $8c881513edf36cac$var$warnExtendDeprecated();
                        return constructWithOptions(createStyledComponent, target, newOptions);
                    }
                }
            ]);
            return StyledComponent;
        }(ParentComponent);
        StyledComponent.attrs = attrs;
        StyledComponent.componentStyle = componentStyle;
        StyledComponent.contextTypes = $8c881513edf36cac$var$modifiedContextShape;
        StyledComponent.displayName = displayName;
        StyledComponent.styledComponentId = styledComponentId;
        StyledComponent.target = target;
        if (isClass) (0, (/*@__PURE__*/$parcel$interopDefault($c7Q22)))(StyledComponent, target, {
            // all SC-specific things should not be hoisted
            attrs: true,
            componentStyle: true,
            displayName: true,
            extend: true,
            styledComponentId: true,
            target: true,
            warnTooManyClasses: true,
            withComponent: true
        });
        return StyledComponent;
    };
    return createStyledComponent;
};
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $8c881513edf36cac$var$murmurhash(str) {
    var l = str.length | 0, h = l | 0, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
}
// 
var $8c881513edf36cac$var$areStylesCacheable = $8c881513edf36cac$var$IS_BROWSER;
var $8c881513edf36cac$var$isStaticRules = function isStaticRules(rules, attrs) {
    for(var i = 0, len = rules.length; i < len; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !isStaticRules(rule)) return false;
        else if (typeof rule === 'function' && !$8c881513edf36cac$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs !== undefined) // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in attrs){
        if (typeof attrs[key] === 'function') return false;
    }
    return true;
};
var $8c881513edf36cac$var$isHMREnabled = null && false;
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $8c881513edf36cac$var$_ComponentStyle = function(nameGenerator, flatten, stringifyRules) {
    /* combines hashStr (murmurhash) and nameGenerator for convenience */ var generateRuleHash = function generateRuleHash(str) {
        return nameGenerator($8c881513edf36cac$var$murmurhash(str));
    };
    var ComponentStyle = function() {
        function ComponentStyle(rules, attrs, componentId) {
            $8c881513edf36cac$var$classCallCheck(this, ComponentStyle);
            this.rules = rules;
            this.isStatic = !$8c881513edf36cac$var$isHMREnabled && $8c881513edf36cac$var$isStaticRules(rules, attrs);
            this.componentId = componentId;
            if (!$8c881513edf36cac$var$StyleSheet.master.hasId(componentId)) {
                var placeholder = [];
                $8c881513edf36cac$var$StyleSheet.master.deferredInject(componentId, placeholder);
            }
        }
        /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
            var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
            if ($8c881513edf36cac$var$areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
            var flatCSS = flatten(this.rules, executionContext);
            var name = generateRuleHash(this.componentId + flatCSS.join(''));
            if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
            this.lastClassName = name;
            return name;
        };
        ComponentStyle.generateName = function generateName(str) {
            return generateRuleHash(str);
        };
        return ComponentStyle;
    }();
    return ComponentStyle;
};
// 
// Thanks to ReactDOMFactories for this handy list!
var $8c881513edf36cac$var$domElements = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    // SVG
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// 
var $8c881513edf36cac$var$_styled = function(styledComponent, constructWithOptions) {
    var styled = function styled(tag) {
        return constructWithOptions(styledComponent, tag);
    };
    // Shorthands for all valid HTML Elements
    $8c881513edf36cac$var$domElements.forEach(function(domElement) {
        styled[domElement] = styled(domElement);
    });
    return styled;
};
// 
var $8c881513edf36cac$var$replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, '');
};
var $8c881513edf36cac$var$_keyframes = function(nameGenerator, stringifyRules, css) {
    return function() {
        var styleSheet = $8c881513edf36cac$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var name = nameGenerator($8c881513edf36cac$var$murmurhash($8c881513edf36cac$var$replaceWhitespace(JSON.stringify(rules))));
        var id = 'sc-keyframes-' + name;
        if (!styleSheet.hasNameForId(id, name)) styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
        return name;
    };
};
// 
var $8c881513edf36cac$var$_injectGlobal = function(stringifyRules, css) {
    var injectGlobal = function injectGlobal() {
        var styleSheet = $8c881513edf36cac$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var hash = $8c881513edf36cac$var$murmurhash(JSON.stringify(rules));
        var id = 'sc-global-' + hash;
        if (!styleSheet.hasId(id)) styleSheet.inject(id, stringifyRules(rules));
    };
    return injectGlobal;
};
// 
var $8c881513edf36cac$var$_constructWithOptions = function(css) {
    var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $8c881513edf36cac$var$EMPTY_OBJECT;
        if (!(0, $9A6O3.isValidElementType)(tag)) throw new $8c881513edf36cac$var$StyledComponentsError(1, String(tag));
        /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
        var templateFunction = function templateFunction() {
            return componentConstructor(tag, options, css.apply(undefined, arguments));
        };
        /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
            return constructWithOptions(componentConstructor, tag, $8c881513edf36cac$var$_extends({}, options, config));
        };
        templateFunction.attrs = function(attrs) {
            return constructWithOptions(componentConstructor, tag, $8c881513edf36cac$var$_extends({}, options, {
                attrs: $8c881513edf36cac$var$_extends({}, options.attrs || $8c881513edf36cac$var$EMPTY_OBJECT, attrs)
            }));
        };
        return templateFunction;
    };
    return constructWithOptions;
};
// 
var $8c881513edf36cac$export$e8748c6a27b910dc = function(Component$$1) {
    var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && // $FlowFixMe TODO: flow for prototype
    !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);
    // NOTE: We can't pass a ref to a stateless functional component
    var shouldSetInnerRef = $8c881513edf36cac$export$7ba318d8d2f06c76(Component$$1) || isStatelessFunctionalComponent;
    var WithTheme = function(_React$Component) {
        $8c881513edf36cac$var$inherits(WithTheme, _React$Component);
        function WithTheme() {
            var _temp, _this, _ret;
            $8c881513edf36cac$var$classCallCheck(this, WithTheme);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $8c881513edf36cac$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = $8c881513edf36cac$var$EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), $8c881513edf36cac$var$possibleConstructorReturn(_this, _ret);
        }
        // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
        WithTheme.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this;
            var defaultProps = this.constructor.defaultProps;
            var styledContext = this.context[$8c881513edf36cac$var$CHANNEL_NEXT];
            var themeProp = $8c881513edf36cac$var$determineTheme(this.props, undefined, defaultProps);
            if (styledContext === undefined && themeProp !== undefined) this.setState({
                theme: themeProp
            });
            else {
                var subscribe = styledContext.subscribe;
                this.unsubscribeId = subscribe(function(nextTheme) {
                    var theme = $8c881513edf36cac$var$determineTheme(_this2.props, nextTheme, defaultProps);
                    _this2.setState({
                        theme: theme
                    });
                });
            }
        };
        WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var defaultProps = this.constructor.defaultProps;
            this.setState(function(oldState) {
                var theme = $8c881513edf36cac$var$determineTheme(nextProps, oldState.theme, defaultProps);
                return {
                    theme: theme
                };
            });
        };
        WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.unsubscribeId !== -1) this.context[$8c881513edf36cac$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
        };
        WithTheme.prototype.render = function render() {
            var props = $8c881513edf36cac$var$_extends({
                theme: this.state.theme
            }, this.props);
            if (!shouldSetInnerRef) {
                props.ref = props.innerRef;
                delete props.innerRef;
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).createElement(Component$$1, props);
        };
        return WithTheme;
    }((0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).Component);
    WithTheme.contextTypes = $8c881513edf36cac$var$contextShape;
    WithTheme.displayName = 'WithTheme(' + $8c881513edf36cac$var$getComponentName(Component$$1) + ')';
    WithTheme.styledComponentId = 'withTheme';
    return (0, (/*@__PURE__*/$parcel$interopDefault($c7Q22)))(WithTheme, Component$$1);
};
// 
/* eslint-disable */ var $8c881513edf36cac$export$84079c323bb0915e = {
    StyleSheet: $8c881513edf36cac$var$StyleSheet
};
/* Instantiate singletons */ var $8c881513edf36cac$var$ComponentStyle = $8c881513edf36cac$var$_ComponentStyle($8c881513edf36cac$var$generateAlphabeticName, $8c881513edf36cac$var$flatten, $8c881513edf36cac$var$stringifyRules);
var $8c881513edf36cac$var$constructWithOptions = $8c881513edf36cac$var$_constructWithOptions($8c881513edf36cac$export$dbf350e5966cf602);
var $8c881513edf36cac$var$StyledComponent = $8c881513edf36cac$var$_StyledComponent($8c881513edf36cac$var$ComponentStyle, $8c881513edf36cac$var$constructWithOptions);
/* Instantiate exported singletons */ var $8c881513edf36cac$export$d25ddfdf17c3ad3e = $8c881513edf36cac$var$_keyframes($8c881513edf36cac$var$generateAlphabeticName, $8c881513edf36cac$var$stringifyRules, $8c881513edf36cac$export$dbf350e5966cf602);
var $8c881513edf36cac$export$efb9f5caaa2ca0c7 = $8c881513edf36cac$var$_injectGlobal($8c881513edf36cac$var$stringifyRules, $8c881513edf36cac$export$dbf350e5966cf602);
var $8c881513edf36cac$var$styled = $8c881513edf36cac$var$_styled($8c881513edf36cac$var$StyledComponent, $8c881513edf36cac$var$constructWithOptions);
var $8c881513edf36cac$export$2e2bcd8739ae039 = $8c881513edf36cac$var$styled;
 //# sourceMappingURL=styled-components.browser.esm.js.map

});
parcelRegister("eGX1d", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ 'use strict';

var $2zcwO = parcelRequire("2zcwO");
var $ab22c4ce4aae7d44$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $ab22c4ce4aae7d44$var$hyphenateStyleName(string) {
    return $2zcwO(string).replace($ab22c4ce4aae7d44$var$msPattern, '-ms-');
}
module.exports = $ab22c4ce4aae7d44$var$hyphenateStyleName;

});
parcelRegister("2zcwO", function(module, exports) {
'use strict';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $1de891825118c725$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $1de891825118c725$var$hyphenate(string) {
    return string.replace($1de891825118c725$var$_uppercasePattern, '-$1').toLowerCase();
}
module.exports = $1de891825118c725$var$hyphenate;

});


parcelRegister("6tEFg", function(module, exports) {
/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */ (function(factory) {
    module.exports = factory(null);
})(/** @param {*=} options */ function factory(options) {
    'use strict';
    /**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */ var nullptn = /^\0+/g /* matches leading null characters */ ;
    var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */ ;
    var colonptn = /: */g /* splits animation rules */ ;
    var cursorptn = /zoo|gra/ /* assert cursor varient */ ;
    var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */ ;
    var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */ ;
    var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */ ;
    var elementptn = / *[\0] */g /* selector elements */ ;
    var selectorptn = /,\r+?/g /* splits selectors */ ;
    var andptn = /([\t\r\n ])*\f?&/g /* match & */ ;
    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */ ;
    var invalidptn = /\W+/g /* removes invalid characters from keyframes */ ;
    var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */ ;
    var plcholdrptn = /::(place)/g /* match ::placeholder varient */ ;
    var readonlyptn = /:(read-only)/g /* match :read-only varient */ ;
    var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */ ;
    var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */ ;
    var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */ ;
    var whiteptn = /\s{2,}/g /* matches repeating whitespace */ ;
    var pseudoptn = /([^\(])(:+) */g /* pseudo element */ ;
    var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */ ;
    var gradientptn = /([\w-]+t\()/g /* match *gradient property */ ;
    var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */ ;
    var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */ ;
    var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */ ;
    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */ ;
    var trimptn = /[ \t]+$/ /* match tail whitspace */ ;
    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */ ;
    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */ var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */ var SEMICOLON = 59 /* ; */ ;
    var CLOSEBRACES = 125 /* } */ ;
    var OPENBRACES = 123 /* { */ ;
    var OPENPARENTHESES = 40 /* ( */ ;
    var CLOSEPARENTHESES = 41 /* ) */ ;
    var OPENBRACKET = 91 /* [ */ ;
    var CLOSEBRACKET = 93 /* ] */ ;
    var NEWLINE = 10 /* \n */ ;
    var CARRIAGE = 13 /* \r */ ;
    var TAB = 9 /* \t */ ;
    var AT = 64 /* @ */ ;
    var SPACE = 32 /*   */ ;
    var AND = 38 /* & */ ;
    var DASH = 45 /* - */ ;
    var UNDERSCORE = 95 /* _ */ ;
    var STAR = 42 /* * */ ;
    var COMMA = 44 /* , */ ;
    var COLON = 58 /* : */ ;
    var SINGLEQUOTE = 39 /* ' */ ;
    var DOUBLEQUOTE = 34 /* " */ ;
    var FOWARDSLASH = 47 /* / */ ;
    var GREATERTHAN = 62 /* > */ ;
    var PLUS = 43 /* + */ ;
    var TILDE = 126 /* ~ */ ;
    var NULL = 0 /* \0 */ ;
    var FORMFEED = 12 /* \f */ ;
    var VERTICALTAB = 11 /* \v */ ;
    /* special identifiers */ var KEYFRAME = 107 /* k */ ;
    var MEDIA = 109 /* m */ ;
    var SUPPORTS = 115 /* s */ ;
    var PLACEHOLDER = 112 /* p */ ;
    var READONLY = 111 /* o */ ;
    var IMPORT = 105 /* <at>i */ ;
    var CHARSET = 99 /* <at>c */ ;
    var DOCUMENT = 100 /* <at>d */ ;
    var PAGE = 112 /* <at>p */ ;
    var column = 1 /* current column */ ;
    var line = 1 /* current line numebr */ ;
    var pattern = 0 /* :pattern */ ;
    var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */ ;
    var prefix = 1 /* vendor prefix */ ;
    var escape = 1 /* escape :global() pattern */ ;
    var compress = 0 /* compress output */ ;
    var semicolon = 0 /* no/semicolon option */ ;
    var preserve = 0 /* preserve empty selectors */ ;
    /* empty reference */ var array = [];
    /* plugins */ var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */ var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */ var unkwn = 0;
    /* keyframe animation */ var keyed = 1;
    var key = '';
    /* selector namespace */ var nscopealt = '';
    var nscope = '';
    /**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */ function compile(parent, current, body, id, depth) {
        var bracket = 0 /* brackets [] */ ;
        var comment = 0 /* comments /* // or /* */ ;
        var parentheses = 0 /* functions () */ ;
        var quote = 0 /* quotes '', "" */ ;
        var first = 0 /* first character code */ ;
        var second = 0 /* second character code */ ;
        var code = 0 /* current character code */ ;
        var tail = 0 /* previous character code */ ;
        var trail = 0 /* character before previous code */ ;
        var peak = 0 /* previous non-whitespace code */ ;
        var counter = 0 /* count sequence termination */ ;
        var context = 0 /* track current context */ ;
        var atrule = 0 /* track @at-rule context */ ;
        var pseudo = 0 /* track pseudo token index */ ;
        var caret = 0 /* current character index */ ;
        var format = 0 /* control character formating context */ ;
        var insert = 0 /* auto semicolon insertion */ ;
        var invert = 0 /* inverted selector pattern */ ;
        var length = 0 /* generic length address */ ;
        var eof = body.length /* end of file(length) */ ;
        var eol = eof - 1 /* end of file(characters) */ ;
        var char = '' /* current character */ ;
        var chars = '' /* current buffer of characters */ ;
        var child = '' /* next buffer of characters */ ;
        var out = '' /* compiled body */ ;
        var children = '' /* compiled children */ ;
        var flat = '' /* compiled leafs */ ;
        var selector /* generic selector address */ ;
        var result /* generic address */ ;
        // ...build body
        while(caret < eof){
            code = body.charCodeAt(caret);
            // eof varient
            if (caret === eol) // last character + noop context, add synthetic padding for noop context to terminate
            {
                if (comment + quote + parentheses + bracket !== 0) {
                    if (comment !== 0) code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
                    quote = parentheses = bracket = 0;
                    eof++;
                    eol++;
                }
            }
            if (comment + quote + parentheses + bracket === 0) {
                // eof varient
                if (caret === eol) {
                    if (format > 0) chars = chars.replace(formatptn, '');
                    if (chars.trim().length > 0) {
                        switch(code){
                            case SPACE:
                            case TAB:
                            case SEMICOLON:
                            case CARRIAGE:
                            case NEWLINE:
                                break;
                            default:
                                chars += body.charAt(caret);
                        }
                        code = SEMICOLON;
                    }
                }
                // auto semicolon insertion
                if (insert === 1) switch(code){
                    // false flags
                    case OPENBRACES:
                    case CLOSEBRACES:
                    case SEMICOLON:
                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                    case OPENPARENTHESES:
                    case CLOSEPARENTHESES:
                    case COMMA:
                        insert = 0;
                    // ignore
                    case TAB:
                    case CARRIAGE:
                    case NEWLINE:
                    case SPACE:
                        break;
                    // valid
                    default:
                        insert = 0;
                        length = caret;
                        first = code;
                        caret--;
                        code = SEMICOLON;
                        while(length < eof)switch(body.charCodeAt(length++)){
                            case NEWLINE:
                            case CARRIAGE:
                            case SEMICOLON:
                                ++caret;
                                code = first;
                                length = eof;
                                break;
                            case COLON:
                                if (format > 0) {
                                    ++caret;
                                    code = first;
                                }
                            case OPENBRACES:
                                length = eof;
                        }
                }
                // token varient
                switch(code){
                    case OPENBRACES:
                        chars = chars.trim();
                        first = chars.charCodeAt(0);
                        counter = 1;
                        length = ++caret;
                        while(caret < eof){
                            switch(code = body.charCodeAt(caret)){
                                case OPENBRACES:
                                    counter++;
                                    break;
                                case CLOSEBRACES:
                                    counter--;
                                    break;
                                case FOWARDSLASH:
                                    switch(second = body.charCodeAt(caret + 1)){
                                        // /*, //
                                        case STAR:
                                        case FOWARDSLASH:
                                            caret = delimited(second, caret, eol, body);
                                    }
                                    break;
                                // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
                                case OPENBRACKET:
                                    code++;
                                // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
                                case OPENPARENTHESES:
                                    code++;
                                // quote tail delimiter is identical to the head delimiter hence noop,
                                // fallthrough clauses have been shifted to the correct tail delimiter
                                case DOUBLEQUOTE:
                                case SINGLEQUOTE:
                                    while(caret++ < eol){
                                        if (body.charCodeAt(caret) === code) break;
                                    }
                            }
                            if (counter === 0) break;
                            caret++;
                        }
                        child = body.substring(length, caret);
                        if (first === NULL) first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                        switch(first){
                            // @at-rule
                            case AT:
                                if (format > 0) chars = chars.replace(formatptn, '');
                                second = chars.charCodeAt(1);
                                switch(second){
                                    case DOCUMENT:
                                    case MEDIA:
                                    case SUPPORTS:
                                    case DASH:
                                        selector = current;
                                        break;
                                    default:
                                        selector = array;
                                }
                                child = compile(current, selector, child, second, depth + 1);
                                length = child.length;
                                // preserve empty @at-rule
                                if (preserve > 0 && length === 0) length = chars.length;
                                // execute plugins, @at-rule context
                                if (plugged > 0) {
                                    selector = select(array, chars, invert);
                                    result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                                    chars = selector.join('');
                                    if (result !== void 0) {
                                        if ((length = (child = result.trim()).length) === 0) {
                                            second = 0;
                                            child = '';
                                        }
                                    }
                                }
                                if (length > 0) switch(second){
                                    case SUPPORTS:
                                        chars = chars.replace(supportsptn, supports);
                                    case DOCUMENT:
                                    case MEDIA:
                                    case DASH:
                                        child = chars + '{' + child + '}';
                                        break;
                                    case KEYFRAME:
                                        chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                                        child = chars + '{' + child + '}';
                                        if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) child = '@' + webkit + child + '@' + child;
                                        else child = '@' + child;
                                        break;
                                    default:
                                        child = chars + child;
                                        if (id === PAGE) child = (out += child, '');
                                }
                                else child = '';
                                break;
                            // selector
                            default:
                                child = compile(current, select(current, chars, invert), child, id, depth + 1);
                        }
                        children += child;
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        atrule = 0;
                        chars = '';
                        child = '';
                        code = body.charCodeAt(++caret);
                        break;
                    case CLOSEBRACES:
                    case SEMICOLON:
                        chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();
                        if ((length = chars.length) > 1) {
                            // monkey-patch missing colon
                            if (pseudo === 0) {
                                first = chars.charCodeAt(0);
                                // first character is a letter or dash, buffer has a space character
                                if (first === DASH || first > 96 && first < 123) length = (chars = chars.replace(' ', ':')).length;
                            }
                            // execute plugins, property context
                            if (plugged > 0) {
                                if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                                    if ((length = (chars = result.trim()).length) === 0) chars = '\0\0';
                                }
                            }
                            first = chars.charCodeAt(0);
                            second = chars.charCodeAt(1);
                            switch(first){
                                case NULL:
                                    break;
                                case AT:
                                    if (second === IMPORT || second === CHARSET) {
                                        flat += chars + body.charAt(caret);
                                        break;
                                    }
                                default:
                                    if (chars.charCodeAt(length - 1) === COLON) break;
                                    out += property(chars, first, second, chars.charCodeAt(2));
                            }
                        }
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        chars = '';
                        code = body.charCodeAt(++caret);
                        break;
                }
            }
            // parse characters
            switch(code){
                case CARRIAGE:
                case NEWLINE:
                    // auto insert semicolon
                    if (comment + quote + parentheses + bracket + semicolon === 0) // valid non-whitespace characters that
                    // may precede a newline
                    switch(peak){
                        case CLOSEPARENTHESES:
                        case SINGLEQUOTE:
                        case DOUBLEQUOTE:
                        case AT:
                        case TILDE:
                        case GREATERTHAN:
                        case STAR:
                        case PLUS:
                        case FOWARDSLASH:
                        case DASH:
                        case COLON:
                        case COMMA:
                        case SEMICOLON:
                        case OPENBRACES:
                        case CLOSEBRACES:
                            break;
                        default:
                            // current buffer has a colon
                            if (pseudo > 0) insert = 1;
                    }
                    // terminate line comment
                    if (comment === FOWARDSLASH) comment = 0;
                    else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                        format = 1;
                        chars += '\0';
                    }
                    // execute plugins, newline context
                    if (plugged * unkwn > 0) proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
                    // next line, reset column position
                    column = 1;
                    line++;
                    break;
                case SEMICOLON:
                case CLOSEBRACES:
                    if (comment + quote + parentheses + bracket === 0) {
                        column++;
                        break;
                    }
                default:
                    // increment column position
                    column++;
                    // current character
                    char = body.charAt(caret);
                    // remove comments, escape functions, strings, attributes and prepare selectors
                    switch(code){
                        case TAB:
                        case SPACE:
                            if (quote + bracket + comment === 0) switch(tail){
                                case COMMA:
                                case COLON:
                                case TAB:
                                case SPACE:
                                    char = '';
                                    break;
                                default:
                                    if (code !== SPACE) char = ' ';
                            }
                            break;
                        // escape breaking control characters
                        case NULL:
                            char = '\\0';
                            break;
                        case FORMFEED:
                            char = '\\f';
                            break;
                        case VERTICALTAB:
                            char = '\\v';
                            break;
                        // &
                        case AND:
                            // inverted selector pattern i.e html &
                            if (quote + comment + bracket === 0 && cascade > 0) {
                                invert = 1;
                                format = 1;
                                char = '\f' + char;
                            }
                            break;
                        // ::p<l>aceholder, l
                        // :read-on<l>y, l
                        case 108:
                            if (quote + comment + bracket + pattern === 0 && pseudo > 0) switch(caret - pseudo){
                                // ::placeholder
                                case 2:
                                    if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) pattern = tail;
                                // :read-only
                                case 8:
                                    if (trail === READONLY) pattern = trail;
                            }
                            break;
                        // :<pattern>
                        case COLON:
                            if (quote + comment + bracket === 0) pseudo = caret;
                            break;
                        // selectors
                        case COMMA:
                            if (comment + parentheses + quote + bracket === 0) {
                                format = 1;
                                char += '\r';
                            }
                            break;
                        // quotes
                        case DOUBLEQUOTE:
                        case SINGLEQUOTE:
                            if (comment === 0) quote = quote === code ? 0 : quote === 0 ? code : quote;
                            break;
                        // attributes
                        case OPENBRACKET:
                            if (quote + comment + parentheses === 0) bracket++;
                            break;
                        case CLOSEBRACKET:
                            if (quote + comment + parentheses === 0) bracket--;
                            break;
                        // functions
                        case CLOSEPARENTHESES:
                            if (quote + comment + bracket === 0) parentheses--;
                            break;
                        case OPENPARENTHESES:
                            if (quote + comment + bracket === 0) {
                                if (context === 0) switch(tail * 2 + trail * 3){
                                    // :matches
                                    case 533:
                                        break;
                                    // :global, :not, :nth-child etc...
                                    default:
                                        counter = 0;
                                        context = 1;
                                }
                                parentheses++;
                            }
                            break;
                        case AT:
                            if (comment + parentheses + quote + bracket + pseudo + atrule === 0) atrule = 1;
                            break;
                        // block/line comments
                        case STAR:
                        case FOWARDSLASH:
                            if (quote + bracket + parentheses > 0) break;
                            switch(comment){
                                // initialize line/block comment context
                                case 0:
                                    switch(code * 2 + body.charCodeAt(caret + 1) * 3){
                                        // //
                                        case 235:
                                            comment = FOWARDSLASH;
                                            break;
                                        // /*
                                        case 220:
                                            length = caret;
                                            comment = STAR;
                                            break;
                                    }
                                    break;
                                // end block comment context
                                case STAR:
                                    if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                                        // /*<!> ... */, !
                                        if (body.charCodeAt(length + 2) === 33) out += body.substring(length, caret + 1);
                                        char = '';
                                        comment = 0;
                                    }
                            }
                    }
                    // ignore comment blocks
                    if (comment === 0) {
                        // aggressive isolation mode, divide each individual selector
                        // including selectors in :not function but excluding selectors in :global function
                        if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) switch(code){
                            case COMMA:
                            case TILDE:
                            case GREATERTHAN:
                            case PLUS:
                            case CLOSEPARENTHESES:
                            case OPENPARENTHESES:
                                if (context === 0) {
                                    // outside of an isolated context i.e nth-child(<...>)
                                    switch(tail){
                                        case TAB:
                                        case SPACE:
                                        case NEWLINE:
                                        case CARRIAGE:
                                            char = char + '\0';
                                            break;
                                        default:
                                            char = '\0' + char + (code === COMMA ? '' : '\0');
                                    }
                                    format = 1;
                                } else // within an isolated context, sleep untill it's terminated
                                switch(code){
                                    case OPENPARENTHESES:
                                        // :globa<l>(
                                        if (pseudo + 7 === caret && tail === 108) pseudo = 0;
                                        context = ++counter;
                                        break;
                                    case CLOSEPARENTHESES:
                                        if ((context = --counter) === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                        break;
                                }
                                break;
                            case TAB:
                            case SPACE:
                                switch(tail){
                                    case NULL:
                                    case OPENBRACES:
                                    case CLOSEBRACES:
                                    case SEMICOLON:
                                    case COMMA:
                                    case FORMFEED:
                                    case TAB:
                                    case SPACE:
                                    case NEWLINE:
                                    case CARRIAGE:
                                        break;
                                    default:
                                        // ignore in isolated contexts
                                        if (context === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                }
                        }
                        // concat buffer of characters
                        chars += char;
                        // previous non-whitespace character code
                        if (code !== SPACE && code !== TAB) peak = code;
                    }
            }
            // tail character codes
            trail = tail;
            tail = code;
            // visit every character
            caret++;
        }
        length = out.length;
        // preserve empty selector
        if (preserve > 0) {
            if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
                if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) length = current.join(',').length + 2;
            }
        }
        if (length > 0) {
            // cascade isolation mode?
            selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
            // execute plugins, block context
            if (plugged > 0) {
                result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
                if (result !== void 0 && (out = result).length === 0) return flat + out + children;
            }
            out = selector.join(',') + '{' + out + '}';
            if (prefix * pattern !== 0) {
                if (prefix === 2 && !vendor(out, 2)) pattern = 0;
                switch(pattern){
                    // ::read-only
                    case READONLY:
                        out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                        break;
                    // ::placeholder
                    case PLACEHOLDER:
                        out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                        break;
                }
                pattern = 0;
            }
        }
        return flat + out + children;
    }
    /**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */ function select(parent, current, invert) {
        var selectors = current.trim().split(selectorptn);
        var out = selectors;
        var length = selectors.length;
        var l = parent.length;
        switch(l){
            // 0-1 parent selectors
            case 0:
            case 1:
                for(var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i)out[i] = scope(selector, out[i], invert, l).trim();
                break;
            // >2 parent selectors, nested
            default:
                for(var i = 0, j = 0, out = []; i < length; ++i)for(var k = 0; k < l; ++k)out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
        }
        return out;
    }
    /**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */ function scope(parent, current, invert, level) {
        var selector = current;
        var code = selector.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (selector = selector.trim()).charCodeAt(0);
        switch(code){
            // &
            case AND:
                switch(cascade + level){
                    case 0:
                    case 1:
                        if (parent.trim().length === 0) break;
                    default:
                        return selector.replace(andptn, '$1' + parent.trim());
                }
                break;
            // :
            case COLON:
                switch(selector.charCodeAt(1)){
                    // g in :global
                    case 103:
                        if (escape > 0 && cascade > 0) return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                        break;
                    default:
                        // :hover
                        return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            default:
                // html &
                if (invert * cascade > 0 && selector.indexOf('\f') > 0) return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
        }
        return parent + selector;
    }
    /**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */ function property(input, first, second, third) {
        var index = 0;
        var out = input + ';';
        var hash = first * 2 + second * 3 + third * 4;
        var cache;
        // animation: a, n, i characters
        if (hash === 944) return animation(out);
        else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) return out;
        // vendor prefix
        switch(hash){
            // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
            case 1015:
                // text-shadow/text-align/text-transform, a
                return out.charCodeAt(10) === 97 ? webkit + out + out : out;
            // filter/fill f, i, l
            case 951:
                // filter, t
                return out.charCodeAt(3) === 116 ? webkit + out + out : out;
            // color/column, c, o, l
            case 963:
                // column, n
                return out.charCodeAt(5) === 110 ? webkit + out + out : out;
            // box-decoration-break, b, o, x
            case 1009:
                if (out.charCodeAt(4) !== 100) break;
            // mask, m, a, s
            // clip-path, c, l, i
            case 969:
            case 942:
                return webkit + out + out;
            // appearance: a, p, p
            case 978:
                return webkit + out + moz + out + out;
            // hyphens: h, y, p
            // user-select: u, s, e
            case 1019:
            case 983:
                return webkit + out + moz + out + ms + out + out;
            // background/backface-visibility, b, a, c
            case 883:
                // backface-visibility, -
                if (out.charCodeAt(8) === DASH) return webkit + out + out;
                // image-set(...)
                if (out.indexOf('image-set(', 11) > 0) return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
                return out;
            // flex: f, l, e
            case 932:
                if (out.charCodeAt(4) === DASH) switch(out.charCodeAt(5)){
                    // flex-grow, g
                    case 103:
                        return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                    // flex-shrink, s
                    case 115:
                        return webkit + out + ms + out.replace('shrink', 'negative') + out;
                    // flex-basis, b
                    case 98:
                        return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                }
                return webkit + out + ms + out + out;
            // order: o, r, d
            case 964:
                return webkit + out + ms + 'flex' + '-' + out + out;
            // justify-items/justify-content, j, u, s
            case 1023:
                // justify-content, c
                if (out.charCodeAt(8) !== 99) break;
                cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
            // cursor, c, u, r
            case 1005:
                return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
            // writing-mode, w, r, i
            case 1000:
                cache = out.substring(13).trim();
                index = cache.indexOf('-') + 1;
                switch(cache.charCodeAt(0) + cache.charCodeAt(index)){
                    // vertical-lr
                    case 226:
                        cache = out.replace(writingptn, 'tb');
                        break;
                    // vertical-rl
                    case 232:
                        cache = out.replace(writingptn, 'tb-rl');
                        break;
                    // horizontal-tb
                    case 220:
                        cache = out.replace(writingptn, 'lr');
                        break;
                    default:
                        return out;
                }
                return webkit + out + ms + cache + out;
            // position: sticky
            case 1017:
                if (out.indexOf('sticky', 9) === -1) return out;
            // display(flex/inline-flex/inline-box): d, i, s
            case 975:
                index = (out = input).length - 10;
                cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();
                switch(hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)){
                    // inline-
                    case 203:
                        // inline-box
                        if (cache.charCodeAt(8) < 111) break;
                    // inline-box/sticky
                    case 115:
                        out = out.replace(cache, webkit + cache) + ';' + out;
                        break;
                    // inline-flex
                    // flex
                    case 207:
                    case 102:
                        out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
                return out + ';';
            // align-items, align-center, align-self: a, l, i, -
            case 938:
                if (out.charCodeAt(5) === DASH) switch(out.charCodeAt(6)){
                    // align-items, i
                    case 105:
                        cache = out.replace('-items', '');
                        return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                    // align-self, s
                    case 115:
                        return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                    // align-content
                    default:
                        return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                }
                break;
            // min/max
            case 973:
            case 989:
                // min-/max- height/width/block-size/inline-size
                if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) break;
            // height/width: min-content / width: max-content
            case 931:
            case 953:
                if (dimensionptn.test(input) === true) {
                    // stretch
                    if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');
                    else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
                }
                break;
            // transform, transition: t, r, a
            case 962:
                out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;
                // transitions
                if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
                break;
        }
        return out;
    }
    /**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */ function vendor(content, context) {
        var index = content.indexOf(context === 1 ? ':' : '{');
        var key = content.substring(0, context !== 3 ? index : 10);
        var value = content.substring(index + 1, content.length - 1);
        return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */ function supports(match, group) {
        var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
        return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */ function animation(input) {
        var length = input.length;
        var index = input.indexOf(':', 9) + 1;
        var declare = input.substring(0, index).trim();
        var out = input.substring(index, length - 1).trim();
        switch(input.charCodeAt(9) * keyed){
            case 0:
                break;
            // animation-*, -
            case DASH:
                // animation-name, n
                if (input.charCodeAt(10) !== 110) break;
            // animation/animation-name
            default:
                // split in case of multiple animations
                var list = out.split((out = '', animationptn));
                for(var i = 0, index = 0, length = list.length; i < length; index = 0, ++i){
                    var value = list[i];
                    var items = value.split(propertiesptn);
                    while(value = items[index]){
                        var peak = value.charCodeAt(0);
                        if (keyed === 1 && (// letters
                        peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                        peak === DASH && value.charCodeAt(1) !== DASH)) // not a number/function
                        switch(isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)){
                            case 1:
                                switch(value){
                                    // not a valid reserved keyword
                                    case 'infinite':
                                    case 'alternate':
                                    case 'backwards':
                                    case 'running':
                                    case 'normal':
                                    case 'forwards':
                                    case 'both':
                                    case 'none':
                                    case 'linear':
                                    case 'ease':
                                    case 'ease-in':
                                    case 'ease-out':
                                    case 'ease-in-out':
                                    case 'paused':
                                    case 'reverse':
                                    case 'alternate-reverse':
                                    case 'inherit':
                                    case 'initial':
                                    case 'unset':
                                    case 'step-start':
                                    case 'step-end':
                                        break;
                                    default:
                                        value += key;
                                }
                        }
                        items[index++] = value;
                    }
                    out += (i === 0 ? '' : ',') + items.join(' ');
                }
        }
        out = declare + out + ';';
        if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
        return out;
    }
    /**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */ function isolate(current) {
        for(var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i){
            // split individual elements in a selector i.e h1 h2 === [h1, h2]
            var elements = current[i].split(elementptn);
            var out = '';
            for(var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j){
                // empty element
                if ((size = (element = elements[j]).length) === 0 && l > 1) continue;
                tail = out.charCodeAt(out.length - 1);
                code = element.charCodeAt(0);
                padding = '';
                if (j !== 0) // determine if we need padding
                switch(tail){
                    case STAR:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case OPENPARENTHESES:
                        break;
                    default:
                        padding = ' ';
                }
                switch(code){
                    case AND:
                        element = padding + nscopealt;
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                        break;
                    case OPENBRACKET:
                        element = padding + element + nscopealt;
                        break;
                    case COLON:
                        switch(element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3){
                            // :global
                            case 530:
                                if (escape > 0) {
                                    element = padding + element.substring(8, size - 1);
                                    break;
                                }
                            // :hover, :nth-child(), ...
                            default:
                                if (j < 1 || elements[j - 1].length < 1) element = padding + nscopealt + element;
                        }
                        break;
                    case COMMA:
                        padding = '';
                    default:
                        if (size > 1 && element.indexOf(':') > 0) element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                        else element = padding + element + nscopealt;
                }
                out += element;
            }
            selector[i] = out.replace(formatptn, '').trim();
        }
        return selector;
    }
    /**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */ function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
        for(var i = 0, out = content, next; i < plugged; ++i)switch(next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                out = next;
        }
        if (out !== content) return out;
    }
    /**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */ function delimited(code, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            // /*
            case FOWARDSLASH:
                if (code === STAR) {
                    if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) return i + 1;
                }
                break;
            // //
            case NEWLINE:
                if (code === FOWARDSLASH) return i + 1;
        }
        return i;
    }
    /**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */ function match(type, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            case type:
                return i;
        }
        return i;
    }
    /**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */ function minify(output) {
        return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */ function use(plugin) {
        switch(plugin){
            case void 0:
            case null:
                plugged = plugins.length = 0;
                break;
            default:
                if (typeof plugin === 'function') plugins[plugged++] = plugin;
                else if (typeof plugin === 'object') for(var i = 0, length = plugin.length; i < length; ++i)use(plugin[i]);
                else unkwn = !!plugin | 0;
        }
        return use;
    }
    /**
	 * Set
	 *
	 * @param {*} options
	 */ function set(options) {
        for(var name in options){
            var value = options[name];
            switch(name){
                case 'keyframe':
                    keyed = value | 0;
                    break;
                case 'global':
                    escape = value | 0;
                    break;
                case 'cascade':
                    cascade = value | 0;
                    break;
                case 'compress':
                    compress = value | 0;
                    break;
                case 'semicolon':
                    semicolon = value | 0;
                    break;
                case 'preserve':
                    preserve = value | 0;
                    break;
                case 'prefix':
                    should = null;
                    if (!value) prefix = 0;
                    else if (typeof value !== 'function') prefix = 1;
                    else {
                        prefix = 2;
                        should = value;
                    }
            }
        }
        return set;
    }
    /**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */ function stylis(selector, input) {
        if (this !== void 0 && this.constructor === stylis) return factory(selector);
        // setup
        var ns = selector;
        var code = ns.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (ns = ns.trim()).charCodeAt(0);
        // keyframe/animation namespace
        if (keyed > 0) key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
        // reset, used to assert if a plugin is moneky-patching the return value
        code = 1;
        // cascade/isolate
        if (cascade === 1) nscope = ns;
        else nscopealt = ns;
        var selectors = [
            nscope
        ];
        var result;
        // execute plugins, pre-process context
        if (plugged > 0) {
            result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
            if (result !== void 0 && typeof result === 'string') input = result;
        }
        // build
        var output = compile(array, selectors, input, 0, 0);
        // execute plugins, post-process context
        if (plugged > 0) {
            result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
            // bypass minification
            if (result !== void 0 && typeof (output = result) !== 'string') code = 0;
        }
        // reset
        key = '';
        nscope = '';
        nscopealt = '';
        pattern = 0;
        line = 1;
        column = 1;
        return compress * code === 0 ? output : minify(output);
    }
    stylis['use'] = use;
    stylis['set'] = set;
    if (options !== void 0) set(options);
    return stylis;
});

});

parcelRegister("kuGtH", function(module, exports) {
(function(factory) {
    module.exports = factory();
})(function() {
    'use strict';
    return function(insertRule) {
        var delimiter = '/*|*/';
        var needle = delimiter + '}';
        function toSheet(block) {
            if (block) try {
                insertRule(block + '}');
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), '';
                        default:
                            return content + (at === 0 ? delimiter : '');
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

});

parcelRegister("c7Q22", function(module, exports) {
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $8d3e7fef4893b251$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $8d3e7fef4893b251$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $8d3e7fef4893b251$var$defineProperty = Object.defineProperty;
var $8d3e7fef4893b251$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $8d3e7fef4893b251$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $8d3e7fef4893b251$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $8d3e7fef4893b251$var$getPrototypeOf = Object.getPrototypeOf;
var $8d3e7fef4893b251$var$objectPrototype = $8d3e7fef4893b251$var$getPrototypeOf && $8d3e7fef4893b251$var$getPrototypeOf(Object);
function $8d3e7fef4893b251$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($8d3e7fef4893b251$var$objectPrototype) {
            var inheritedComponent = $8d3e7fef4893b251$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $8d3e7fef4893b251$var$objectPrototype) $8d3e7fef4893b251$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $8d3e7fef4893b251$var$getOwnPropertyNames(sourceComponent);
        if ($8d3e7fef4893b251$var$getOwnPropertySymbols) keys = keys.concat($8d3e7fef4893b251$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$8d3e7fef4893b251$var$REACT_STATICS[key] && !$8d3e7fef4893b251$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $8d3e7fef4893b251$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $8d3e7fef4893b251$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $8d3e7fef4893b251$var$hoistNonReactStatics;

});

parcelRegister("9A6O3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("deibr"));

});
parcelRegister("deibr", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $9a1ab006663062e7$export$2b8d127b894957b9, (v) => $9a1ab006663062e7$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9a1ab006663062e7$export$cea3a54a6425200c, (v) => $9a1ab006663062e7$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9a1ab006663062e7$export$a7c73072b1a182ae, (v) => $9a1ab006663062e7$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9a1ab006663062e7$export$9f27bc3417b4524d, (v) => $9a1ab006663062e7$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9a1ab006663062e7$export$db77ccec0bb4ccac, (v) => $9a1ab006663062e7$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9a1ab006663062e7$export$8392c0c9d3dcbd35, (v) => $9a1ab006663062e7$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9a1ab006663062e7$export$ffb0004e005737fa, (v) => $9a1ab006663062e7$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9a1ab006663062e7$export$b624eff549462981, (v) => $9a1ab006663062e7$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9a1ab006663062e7$export$7897aa7841a5380c, (v) => $9a1ab006663062e7$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9a1ab006663062e7$export$602eac185826482c, (v) => $9a1ab006663062e7$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9a1ab006663062e7$export$e2c29f18771995cb, (v) => $9a1ab006663062e7$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9a1ab006663062e7$export$5f8d39834fd61797, (v) => $9a1ab006663062e7$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9a1ab006663062e7$export$74bf444e3cd11ea5, (v) => $9a1ab006663062e7$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9a1ab006663062e7$export$92387174baf9b227, (v) => $9a1ab006663062e7$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9a1ab006663062e7$export$ec112efeb987d9c6, (v) => $9a1ab006663062e7$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9a1ab006663062e7$export$b706b080d889d2c9, (v) => $9a1ab006663062e7$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9a1ab006663062e7$export$5be5a87408f70ddc, (v) => $9a1ab006663062e7$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9a1ab006663062e7$export$45a5e7f76e0caa8d, (v) => $9a1ab006663062e7$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9a1ab006663062e7$export$455c2e768291efa6, (v) => $9a1ab006663062e7$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9a1ab006663062e7$export$9522e17588c12572, (v) => $9a1ab006663062e7$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9a1ab006663062e7$export$2110ac352bb060b9, (v) => $9a1ab006663062e7$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9a1ab006663062e7$export$56885ab8b9c456ab, (v) => $9a1ab006663062e7$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9a1ab006663062e7$export$d927fcb6adf8f9de, (v) => $9a1ab006663062e7$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9a1ab006663062e7$export$b82d16f27459e05a, (v) => $9a1ab006663062e7$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9a1ab006663062e7$export$522c17b4f5e123e8, (v) => $9a1ab006663062e7$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9a1ab006663062e7$export$1aabd8a0274ecfd6, (v) => $9a1ab006663062e7$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9a1ab006663062e7$export$9b621391a187a31a, (v) => $9a1ab006663062e7$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9a1ab006663062e7$export$f5bbd400c2f4426f, (v) => $9a1ab006663062e7$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9a1ab006663062e7$export$2b8d127b894957b9;
var $9a1ab006663062e7$export$cea3a54a6425200c;
var $9a1ab006663062e7$export$a7c73072b1a182ae;
var $9a1ab006663062e7$export$9f27bc3417b4524d;
var $9a1ab006663062e7$export$db77ccec0bb4ccac;
var $9a1ab006663062e7$export$8392c0c9d3dcbd35;
var $9a1ab006663062e7$export$ffb0004e005737fa;
var $9a1ab006663062e7$export$b624eff549462981;
var $9a1ab006663062e7$export$7897aa7841a5380c;
var $9a1ab006663062e7$export$602eac185826482c;
var $9a1ab006663062e7$export$e2c29f18771995cb;
var $9a1ab006663062e7$export$5f8d39834fd61797;
var $9a1ab006663062e7$export$74bf444e3cd11ea5;
var $9a1ab006663062e7$export$92387174baf9b227;
var $9a1ab006663062e7$export$ec112efeb987d9c6;
var $9a1ab006663062e7$export$b706b080d889d2c9;
var $9a1ab006663062e7$export$5be5a87408f70ddc;
var $9a1ab006663062e7$export$45a5e7f76e0caa8d;
var $9a1ab006663062e7$export$455c2e768291efa6;
var $9a1ab006663062e7$export$9522e17588c12572;
var $9a1ab006663062e7$export$2110ac352bb060b9;
var $9a1ab006663062e7$export$56885ab8b9c456ab;
var $9a1ab006663062e7$export$d927fcb6adf8f9de;
var $9a1ab006663062e7$export$b82d16f27459e05a;
var $9a1ab006663062e7$export$522c17b4f5e123e8;
var $9a1ab006663062e7$export$1aabd8a0274ecfd6;
var $9a1ab006663062e7$export$9b621391a187a31a;
var $9a1ab006663062e7$export$f5bbd400c2f4426f;
'use strict';
var $9a1ab006663062e7$var$b = "function" === typeof Symbol && Symbol.for, $9a1ab006663062e7$var$c = $9a1ab006663062e7$var$b ? Symbol.for("react.element") : 60103, $9a1ab006663062e7$var$d = $9a1ab006663062e7$var$b ? Symbol.for("react.portal") : 60106, $9a1ab006663062e7$var$e = $9a1ab006663062e7$var$b ? Symbol.for("react.fragment") : 60107, $9a1ab006663062e7$var$f = $9a1ab006663062e7$var$b ? Symbol.for("react.strict_mode") : 60108, $9a1ab006663062e7$var$g = $9a1ab006663062e7$var$b ? Symbol.for("react.profiler") : 60114, $9a1ab006663062e7$var$h = $9a1ab006663062e7$var$b ? Symbol.for("react.provider") : 60109, $9a1ab006663062e7$var$k = $9a1ab006663062e7$var$b ? Symbol.for("react.context") : 60110, $9a1ab006663062e7$var$l = $9a1ab006663062e7$var$b ? Symbol.for("react.async_mode") : 60111, $9a1ab006663062e7$var$m = $9a1ab006663062e7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9a1ab006663062e7$var$n = $9a1ab006663062e7$var$b ? Symbol.for("react.forward_ref") : 60112, $9a1ab006663062e7$var$p = $9a1ab006663062e7$var$b ? Symbol.for("react.suspense") : 60113, $9a1ab006663062e7$var$q = $9a1ab006663062e7$var$b ? Symbol.for("react.suspense_list") : 60120, $9a1ab006663062e7$var$r = $9a1ab006663062e7$var$b ? Symbol.for("react.memo") : 60115, $9a1ab006663062e7$var$t = $9a1ab006663062e7$var$b ? Symbol.for("react.lazy") : 60116, $9a1ab006663062e7$var$v = $9a1ab006663062e7$var$b ? Symbol.for("react.block") : 60121, $9a1ab006663062e7$var$w = $9a1ab006663062e7$var$b ? Symbol.for("react.fundamental") : 60117, $9a1ab006663062e7$var$x = $9a1ab006663062e7$var$b ? Symbol.for("react.responder") : 60118, $9a1ab006663062e7$var$y = $9a1ab006663062e7$var$b ? Symbol.for("react.scope") : 60119;
function $9a1ab006663062e7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9a1ab006663062e7$var$c:
                switch(a = a.type, a){
                    case $9a1ab006663062e7$var$l:
                    case $9a1ab006663062e7$var$m:
                    case $9a1ab006663062e7$var$e:
                    case $9a1ab006663062e7$var$g:
                    case $9a1ab006663062e7$var$f:
                    case $9a1ab006663062e7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9a1ab006663062e7$var$k:
                            case $9a1ab006663062e7$var$n:
                            case $9a1ab006663062e7$var$t:
                            case $9a1ab006663062e7$var$r:
                            case $9a1ab006663062e7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9a1ab006663062e7$var$d:
                return u;
        }
    }
}
function $9a1ab006663062e7$var$A(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$m;
}
$9a1ab006663062e7$export$2b8d127b894957b9 = $9a1ab006663062e7$var$l;
$9a1ab006663062e7$export$cea3a54a6425200c = $9a1ab006663062e7$var$m;
$9a1ab006663062e7$export$a7c73072b1a182ae = $9a1ab006663062e7$var$k;
$9a1ab006663062e7$export$9f27bc3417b4524d = $9a1ab006663062e7$var$h;
$9a1ab006663062e7$export$db77ccec0bb4ccac = $9a1ab006663062e7$var$c;
$9a1ab006663062e7$export$8392c0c9d3dcbd35 = $9a1ab006663062e7$var$n;
$9a1ab006663062e7$export$ffb0004e005737fa = $9a1ab006663062e7$var$e;
$9a1ab006663062e7$export$b624eff549462981 = $9a1ab006663062e7$var$t;
$9a1ab006663062e7$export$7897aa7841a5380c = $9a1ab006663062e7$var$r;
$9a1ab006663062e7$export$602eac185826482c = $9a1ab006663062e7$var$d;
$9a1ab006663062e7$export$e2c29f18771995cb = $9a1ab006663062e7$var$g;
$9a1ab006663062e7$export$5f8d39834fd61797 = $9a1ab006663062e7$var$f;
$9a1ab006663062e7$export$74bf444e3cd11ea5 = $9a1ab006663062e7$var$p;
$9a1ab006663062e7$export$92387174baf9b227 = function(a) {
    return $9a1ab006663062e7$var$A(a) || $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$l;
};
$9a1ab006663062e7$export$ec112efeb987d9c6 = $9a1ab006663062e7$var$A;
$9a1ab006663062e7$export$b706b080d889d2c9 = function(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$k;
};
$9a1ab006663062e7$export$5be5a87408f70ddc = function(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$h;
};
$9a1ab006663062e7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9a1ab006663062e7$var$c;
};
$9a1ab006663062e7$export$455c2e768291efa6 = function(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$n;
};
$9a1ab006663062e7$export$9522e17588c12572 = function(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$e;
};
$9a1ab006663062e7$export$2110ac352bb060b9 = function(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$t;
};
$9a1ab006663062e7$export$56885ab8b9c456ab = function(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$r;
};
$9a1ab006663062e7$export$d927fcb6adf8f9de = function(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$d;
};
$9a1ab006663062e7$export$b82d16f27459e05a = function(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$g;
};
$9a1ab006663062e7$export$522c17b4f5e123e8 = function(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$f;
};
$9a1ab006663062e7$export$1aabd8a0274ecfd6 = function(a) {
    return $9a1ab006663062e7$var$z(a) === $9a1ab006663062e7$var$p;
};
$9a1ab006663062e7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9a1ab006663062e7$var$e || a === $9a1ab006663062e7$var$m || a === $9a1ab006663062e7$var$g || a === $9a1ab006663062e7$var$f || a === $9a1ab006663062e7$var$p || a === $9a1ab006663062e7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9a1ab006663062e7$var$t || a.$$typeof === $9a1ab006663062e7$var$r || a.$$typeof === $9a1ab006663062e7$var$h || a.$$typeof === $9a1ab006663062e7$var$k || a.$$typeof === $9a1ab006663062e7$var$n || a.$$typeof === $9a1ab006663062e7$var$w || a.$$typeof === $9a1ab006663062e7$var$x || a.$$typeof === $9a1ab006663062e7$var$y || a.$$typeof === $9a1ab006663062e7$var$v);
};
$9a1ab006663062e7$export$f5bbd400c2f4426f = $9a1ab006663062e7$var$z;

});



parcelRegister("8kgy5", function(module, exports) {
$parcel$export(module.exports, "MainLayout", () => $526183fa46fe2041$export$93af822566053b3e);
/* main-layout.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");

var $lE8gv = parcelRequire("lE8gv");

var $i2p82 = parcelRequire("i2p82");

var $b450B = parcelRequire("b450B");

var $b1WJB = parcelRequire("b1WJB");

var $c42RO = parcelRequire("c42RO");

var $cSa27 = parcelRequire("cSa27");

var $9apEo = parcelRequire("9apEo");

var $fOrHi = parcelRequire("fOrHi");

var $ctuWl = parcelRequire("ctuWl");

var $eD8vk = parcelRequire("eD8vk");

var $cn6Gr = parcelRequire("cn6Gr");

var $gw1Pn = parcelRequire("gw1Pn");

var $25Roh = parcelRequire("25Roh");
var $2AuFz = parcelRequire("2AuFz");

var $lIph6 = parcelRequire("lIph6");

var $ezpqI = parcelRequire("ezpqI");

var $45DKq = parcelRequire("45DKq");

var $6Teat = parcelRequire("6Teat");

var $hRlf9 = parcelRequire("hRlf9");

var $kF8th = parcelRequire("kF8th");
const $526183fa46fe2041$var$styles = {
    isDisabledColor: "_syaz1gmx"
};
const $526183fa46fe2041$var$Subtitle = (0, $c42RO.default).span`
	font-style: italic;
	font-size: ${"var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	${({ isDisabled: isDisabled })=>isDisabled ? (0, $c42RO.css)`
					color: ${"var(--ds-text-disabled, #080F214A)"};
				` : ''};
`;
const $526183fa46fe2041$var$PageBannerWrapper = (0, $c42RO.default).div`
	margin-top: ${"var(--ds-space-100, 8px)"};
	margin-bottom: ${"var(--ds-space-negative-050, -4px)"};
`;
const $526183fa46fe2041$var$Main = (0, $c42RO.default).div`
	padding-bottom: ${"var(--ds-space-400, 32px)"};
	padding-left: ${"var(--ds-space-300, 24px)"};
	padding-right: ${"var(--ds-space-300, 24px)"};
	contain: ${({ preventContentOverflow: preventContentOverflow })=>preventContentOverflow ? 'paint' : 'unset'};
`;
const $526183fa46fe2041$var$Icon = (0, $c42RO.default).div`
	line-height: 1;
	margin-right: ${"var(--ds-space-100, 8px)"};
	${({ isDisabled: isDisabled })=>isDisabled ? (0, $c42RO.css)`
					filter: grayscale(100%);
				` : ''};
`;
const $526183fa46fe2041$var$Description = (0, $c42RO.default).div`
	max-width: 900px;
	margin-top: ${"var(--ds-space-negative-100, -8px)"};
`;
const $526183fa46fe2041$var$Avatar = (0, $c42RO.default).div`
	padding-right: ${"var(--ds-space-150, 12px)"};
	float: left;
	${({ isDisabled: isDisabled })=>isDisabled ? (0, $c42RO.css)`
					filter: grayscale(100%);
				` : ''} & > div {
		display: initial !important;
	}
`;
const $526183fa46fe2041$var$Children = ({ children: children, xcss: xcss })=>{
    const defaultChildrenXcss = (0, $eD8vk.xcss)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        marginTop: 'space.300'
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $ctuWl.Box), {
        xcss: [
            defaultChildrenXcss,
            xcss
        ],
        children: children
    });
};
const $526183fa46fe2041$var$AssessmentsLayoutWrapper = (0, $c42RO.default).div`
	height: ${({ heightCss: heightCss })=>heightCss};
	overflow: auto;
`;
const $526183fa46fe2041$var$CustomLayoutHeightWrapper = ({ heightCss: heightCss, children: children })=>{
    if (!heightCss) return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kOwiQ.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($526183fa46fe2041$var$AssessmentsLayoutWrapper, {
        heightCss: heightCss,
        children: children
    });
};
const $526183fa46fe2041$export$f8ab3a63fb5743ec = ({ orgNameForSite: orgNameForSite, title: title, isDisabled: isDisabled = false, subtitle: subtitle, action: action, description: description, children: children, side: side, breadcrumbs: breadcrumbs, pageParent: pageParent, pageBanner: pageBanner, isAutoGridSize: isAutoGridSize, isFullWidth: isFullWidth, inlineEdit: inlineEdit, gridLayout: gridLayout, pageRef: pageRef, testId: testId = 'main-layout', childrenContainerStyle: childrenContainerStyle, preventContentOverflow: preventContentOverflow = false, rightSidebar: rightSidebar, avatarIconUrl: avatarIconUrl, icon: icon, showTitleOnPage: showTitleOnPage = true, excludeTableFullWidth: excludeTableFullWidth = false, mainContentHeightCss: mainContentHeightCss, disableTitleStyles: disableTitleStyles = false, contentAboveDescription: contentAboveDescription, errorFallback: errorFallback, errorCallback: errorCallback })=>{
    const { hideSidebar: hideSidebar } = (0, $ezpqI.useMainLayoutRightSidebar)();
    $lE8gv.useEffect(()=>()=>{
            hideSidebar();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const asidePortalEl = document.getElementById('aside-portal');
    const determineChildGridSize = ()=>{
        if (side || !isFullWidth) return 8;
        return 12;
    };
    const renderIcon = ()=>{
        if (avatarIconUrl) return /*#__PURE__*/ (0, $kOwiQ.jsx)($526183fa46fe2041$var$Avatar, {
            isDisabled: isDisabled || false,
            "data-testid": "avatar-image",
            children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $cSa27.default), {
                src: avatarIconUrl,
                size: "large"
            })
        });
        if (icon) return /*#__PURE__*/ (0, $kOwiQ.jsx)($526183fa46fe2041$var$Icon, {
            isDisabled: isDisabled || false,
            children: icon
        });
        return undefined;
    };
    const onInlineEditConfirm = (value)=>{
        inlineEdit?.onConfirm(value);
    };
    // Extracts a string from a React node if it's a string
    const extractStringFromElement = (element)=>{
        if (typeof element === 'string') return element;
        return '';
    };
    // Extracts strings from an array of React nodes and concatenates them
    const extractStringFromArrayOfElements = (element)=>{
        if (Array.isArray(element)) return element.map(extractStringFromElementRecursively).filter((message)=>message).join(' ');
        return '';
    };
    // Extracts a string from the props of a React element
    const extractStringFromElementProps = (props)=>{
        if (props.isCustomTitle) return props.name || props.productName || props.displayName || '';
        // When a container element (e.g. Stack) wraps multiple children, props.children
        // is an array. extractStringFromElementRecursively only handles single elements,
        // so delegate to extractStringFromArrayOfElements for arrays.
        if (Array.isArray(props.children)) return extractStringFromArrayOfElements(props.children);
        return extractStringFromElementRecursively(props.children);
    };
    // Recursively extracts a string from a React node
    const extractStringFromElementRecursively = (element)=>{
        // Return plain-string children as-is so a title wrapped in an element — e.g.
        // <Flex>{'My title'}<Tag/></Flex> — isn't dropped (A11Y-39308 / WCAG 2.4.2).
        if (typeof element === 'string') return element;
        if (/*#__PURE__*/ $lE8gv.isValidElement(element)) {
            const props = element.props;
            if ((typeof element.type === 'function' || typeof element.type === 'object') && 'displayName' in element.type && (element.type.displayName === 'FormattedMessage' || element.type.displayName === 'MemoizedFormattedMessage')) return props.defaultMessage || '';
            return extractStringFromElementProps(props);
        }
        return '';
    };
    // Main function to extract a title string from a React node
    const extractTitleString = (element)=>{
        if (!element) return '';
        return extractStringFromElement(element) || extractStringFromArrayOfElements(element) || extractStringFromElementRecursively(element);
    };
    const extractedTitle = extractTitleString(title);
    const extractedParentTitle = extractTitleString(pageParent);
    const siteName = (0, $2AuFz.useSiteName)();
    const orgName = (0, $25Roh.useOrgName)() || orgNameForSite;
    const adminTag = /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $b1WJB.default), {
        ...(0, $6Teat.adminMessage)
    });
    const admin = adminTag?.props?.defaultMessage && `${adminTag?.props?.defaultMessage}`;
    const docTitle = ()=>(0, $45DKq.formatDocumentTitle)(extractedTitle, extractedParentTitle, siteName, orgName, admin);
    // Updating the page title to be more specific depending on the path of the page.
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $cn6Gr.ErrorBoundary), {
        fallback: errorFallback,
        onError: errorCallback,
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
            children: /*#__PURE__*/ (0, $kOwiQ.jsx)($526183fa46fe2041$var$CustomLayoutHeightWrapper, {
                heightCss: mainContentHeightCss,
                children: /*#__PURE__*/ (0, $kOwiQ.jsxs)($526183fa46fe2041$var$Main, {
                    innerRef: pageRef,
                    "data-testid": testId,
                    preventContentOverflow: preventContentOverflow,
                    children: [
                        /*#__PURE__*/ (0, $kOwiQ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i2p82))), {
                            title: docTitle(),
                            "data-testid": "document-title"
                        }),
                        /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $9apEo.default), {
                            spacing: !excludeTableFullWidth ? 'cosy' : 'comfortable',
                            layout: !excludeTableFullWidth ? 'fluid' : gridLayout,
                            children: [
                                !side && !isFullWidth && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $fOrHi.default), {
                                    medium: 2
                                }),
                                pageBanner && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $fOrHi.default), {
                                    medium: 12,
                                    children: /*#__PURE__*/ (0, $kOwiQ.jsx)($526183fa46fe2041$var$PageBannerWrapper, {
                                        "data-testid": "pageBanner",
                                        children: pageBanner
                                    })
                                }),
                                /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $fOrHi.default), {
                                    medium: isAutoGridSize ? undefined : determineChildGridSize(),
                                    children: [
                                        /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $gw1Pn.PageHeader), {
                                            bottomBar: subtitle && /*#__PURE__*/ (0, $kOwiQ.jsx)($526183fa46fe2041$var$Subtitle, {
                                                isDisabled: isDisabled,
                                                children: subtitle
                                            }),
                                            actions: action,
                                            breadcrumbs: breadcrumbs,
                                            disableTitleStyles: !!inlineEdit || disableTitleStyles,
                                            children: /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lIph6.Centered), {
                                                axis: "vertical",
                                                children: [
                                                    renderIcon(),
                                                    showTitleOnPage && title && !inlineEdit && /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
                                                        className: (0, $l2NkF.default)([
                                                            isDisabled && $526183fa46fe2041$var$styles.isDisabledColor
                                                        ]),
                                                        children: title
                                                    }),
                                                    inlineEdit && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kF8th.InlineEditTitle), {
                                                        defaultValue: inlineEdit.defaultValue,
                                                        errorMessage: inlineEdit.errorMessage,
                                                        onConfirm: onInlineEditConfirm,
                                                        as: inlineEdit.as
                                                    })
                                                ]
                                            })
                                        }),
                                        contentAboveDescription || null,
                                        description && /*#__PURE__*/ (0, $kOwiQ.jsx)($526183fa46fe2041$var$Description, {
                                            children: description
                                        }),
                                        children && /*#__PURE__*/ (0, $kOwiQ.jsx)($526183fa46fe2041$var$Children, {
                                            xcss: childrenContainerStyle,
                                            children: children
                                        }),
                                        rightSidebar && asidePortalEl && /*#__PURE__*/ (0, $b450B.createPortal)(rightSidebar, asidePortalEl)
                                    ]
                                }),
                                side && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $fOrHi.default), {
                                    medium: 4,
                                    children: /*#__PURE__*/ (0, $kOwiQ.jsx)($526183fa46fe2041$var$Children, {
                                        children: side
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
const $526183fa46fe2041$export$93af822566053b3e = (0, $hRlf9.addCollapsedNavProp)(/*#__PURE__*/ $lE8gv.forwardRef((props, ref)=>/*#__PURE__*/ (0, $kOwiQ.jsx)($526183fa46fe2041$export$f8ab3a63fb5743ec, {
        pageRef: ref,
        ...props
    })));
$526183fa46fe2041$export$93af822566053b3e.displayName = 'MainLayout';

});
parcelRegister("i2p82", function(module, exports) {
'use strict';

var $lE8gv = parcelRequire("lE8gv");

var $dzGx9 = parcelRequire("dzGx9");

var $1Ooep = parcelRequire("1Ooep");
function $d21be7e8d73275fa$var$reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) return innermostProps.title;
}
function $d21be7e8d73275fa$var$handleStateChangeOnClient(title) {
    var nextTitle = title || '';
    if (nextTitle !== document.title) document.title = nextTitle;
}
function $d21be7e8d73275fa$var$DocumentTitle() {}
$d21be7e8d73275fa$var$DocumentTitle.prototype = Object.create($lE8gv.Component.prototype);
$d21be7e8d73275fa$var$DocumentTitle.displayName = 'DocumentTitle';
$d21be7e8d73275fa$var$DocumentTitle.propTypes = {
    title: $dzGx9.string.isRequired
};
$d21be7e8d73275fa$var$DocumentTitle.prototype.render = function() {
    if (this.props.children) return $lE8gv.Children.only(this.props.children);
    else return null;
};
module.exports = $1Ooep($d21be7e8d73275fa$var$reducePropsToState, $d21be7e8d73275fa$var$handleStateChangeOnClient)($d21be7e8d73275fa$var$DocumentTitle);

});
parcelRegister("1Ooep", function(module, exports) {
'use strict';
function $151d41cf6e6095db$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $lE8gv = parcelRequire("lE8gv");
var $151d41cf6e6095db$var$React__default = $151d41cf6e6095db$var$_interopDefault($lE8gv);

var $151d41cf6e6095db$var$shallowEqual = $151d41cf6e6095db$var$_interopDefault((parcelRequire("fqOKa")));
function $151d41cf6e6095db$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $151d41cf6e6095db$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $151d41cf6e6095db$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $151d41cf6e6095db$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $151d41cf6e6095db$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$151d41cf6e6095db$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $151d41cf6e6095db$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($lE8gv.Component);
        $151d41cf6e6095db$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $151d41cf6e6095db$var$_defineProperty(SideEffect, "canUseDOM", $151d41cf6e6095db$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $151d41cf6e6095db$var$withSideEffect;

});
parcelRegister("fqOKa", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});



parcelRegister("b450B", function(module, exports) {
'use strict';
function $0214315b1eae9e96$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0214315b1eae9e96$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$0214315b1eae9e96$var$checkDCE();

module.exports = (parcelRequire("1ZONQ"));

});
parcelRegister("1ZONQ", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1742e55f55c10e98$export$ae55be85d98224ed, (v) => $1742e55f55c10e98$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $1742e55f55c10e98$export$d39a5bbd09211389, (v) => $1742e55f55c10e98$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $1742e55f55c10e98$export$882461b6382ed46c, (v) => $1742e55f55c10e98$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $1742e55f55c10e98$export$466bfc07425424d5, (v) => $1742e55f55c10e98$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $1742e55f55c10e98$export$cd75ccfd720a3cd4, (v) => $1742e55f55c10e98$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $1742e55f55c10e98$export$fa8d919ba61d84db, (v) => $1742e55f55c10e98$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $1742e55f55c10e98$export$757ceba2d55c277e, (v) => $1742e55f55c10e98$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $1742e55f55c10e98$export$b3890eb0ae9dca99, (v) => $1742e55f55c10e98$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $1742e55f55c10e98$export$502457920280e6be, (v) => $1742e55f55c10e98$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $1742e55f55c10e98$export$c78a37762a8d58e1, (v) => $1742e55f55c10e98$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $1742e55f55c10e98$export$dc54d992c10e8a18, (v) => $1742e55f55c10e98$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $1742e55f55c10e98$export$83d89fbfd8236492, (v) => $1742e55f55c10e98$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1742e55f55c10e98$export$ae55be85d98224ed;
var $1742e55f55c10e98$export$d39a5bbd09211389;
var $1742e55f55c10e98$export$882461b6382ed46c;
var $1742e55f55c10e98$export$466bfc07425424d5;
var $1742e55f55c10e98$export$cd75ccfd720a3cd4;
var $1742e55f55c10e98$export$fa8d919ba61d84db;
var $1742e55f55c10e98$export$757ceba2d55c277e;
var $1742e55f55c10e98$export$b3890eb0ae9dca99;
var $1742e55f55c10e98$export$502457920280e6be;
var $1742e55f55c10e98$export$c78a37762a8d58e1;
var $1742e55f55c10e98$export$dc54d992c10e8a18;
var $1742e55f55c10e98$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $lE8gv = parcelRequire("lE8gv");

var $gEGs3 = parcelRequire("gEGs3");
function $1742e55f55c10e98$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1742e55f55c10e98$var$da = new Set, $1742e55f55c10e98$var$ea = {};
function $1742e55f55c10e98$var$fa(a, b) {
    $1742e55f55c10e98$var$ha(a, b);
    $1742e55f55c10e98$var$ha(a + "Capture", b);
}
function $1742e55f55c10e98$var$ha(a, b) {
    $1742e55f55c10e98$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$1742e55f55c10e98$var$da.add(b[a]);
}
var $1742e55f55c10e98$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $1742e55f55c10e98$var$ja = Object.prototype.hasOwnProperty, $1742e55f55c10e98$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $1742e55f55c10e98$var$la = {}, $1742e55f55c10e98$var$ma = {};
function $1742e55f55c10e98$var$na(a) {
    if ($1742e55f55c10e98$var$ja.call($1742e55f55c10e98$var$ma, a)) return !0;
    if ($1742e55f55c10e98$var$ja.call($1742e55f55c10e98$var$la, a)) return !1;
    if ($1742e55f55c10e98$var$ka.test(a)) return $1742e55f55c10e98$var$ma[a] = !0;
    $1742e55f55c10e98$var$la[a] = !0;
    return !1;
}
function $1742e55f55c10e98$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $1742e55f55c10e98$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $1742e55f55c10e98$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $1742e55f55c10e98$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $1742e55f55c10e98$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $1742e55f55c10e98$var$t[a] = new $1742e55f55c10e98$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $1742e55f55c10e98$var$t[b] = new $1742e55f55c10e98$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $1742e55f55c10e98$var$t[a] = new $1742e55f55c10e98$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $1742e55f55c10e98$var$t[a] = new $1742e55f55c10e98$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $1742e55f55c10e98$var$t[a] = new $1742e55f55c10e98$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $1742e55f55c10e98$var$t[a] = new $1742e55f55c10e98$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $1742e55f55c10e98$var$t[a] = new $1742e55f55c10e98$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $1742e55f55c10e98$var$t[a] = new $1742e55f55c10e98$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $1742e55f55c10e98$var$t[a] = new $1742e55f55c10e98$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $1742e55f55c10e98$var$ra = /[\-:]([a-z])/g;
function $1742e55f55c10e98$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($1742e55f55c10e98$var$ra, $1742e55f55c10e98$var$ta);
    $1742e55f55c10e98$var$t[b] = new $1742e55f55c10e98$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($1742e55f55c10e98$var$ra, $1742e55f55c10e98$var$ta);
    $1742e55f55c10e98$var$t[b] = new $1742e55f55c10e98$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($1742e55f55c10e98$var$ra, $1742e55f55c10e98$var$ta);
    $1742e55f55c10e98$var$t[b] = new $1742e55f55c10e98$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $1742e55f55c10e98$var$t[a] = new $1742e55f55c10e98$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$1742e55f55c10e98$var$t.xlinkHref = new $1742e55f55c10e98$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $1742e55f55c10e98$var$t[a] = new $1742e55f55c10e98$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $1742e55f55c10e98$var$ua(a, b, c, d) {
    var e = $1742e55f55c10e98$var$t.hasOwnProperty(b) ? $1742e55f55c10e98$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $1742e55f55c10e98$var$pa(b, c, e, d) && (c = null), d || null === e ? $1742e55f55c10e98$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $1742e55f55c10e98$var$va = $lE8gv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $1742e55f55c10e98$var$wa = Symbol.for("react.element"), $1742e55f55c10e98$var$xa = Symbol.for("react.portal"), $1742e55f55c10e98$var$ya = Symbol.for("react.fragment"), $1742e55f55c10e98$var$za = Symbol.for("react.strict_mode"), $1742e55f55c10e98$var$Aa = Symbol.for("react.profiler"), $1742e55f55c10e98$var$Ba = Symbol.for("react.provider"), $1742e55f55c10e98$var$Ca = Symbol.for("react.context"), $1742e55f55c10e98$var$Da = Symbol.for("react.forward_ref"), $1742e55f55c10e98$var$Ea = Symbol.for("react.suspense"), $1742e55f55c10e98$var$Fa = Symbol.for("react.suspense_list"), $1742e55f55c10e98$var$Ga = Symbol.for("react.memo"), $1742e55f55c10e98$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $1742e55f55c10e98$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $1742e55f55c10e98$var$Ja = Symbol.iterator;
function $1742e55f55c10e98$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1742e55f55c10e98$var$Ja && a[$1742e55f55c10e98$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1742e55f55c10e98$var$u = Object.assign, $1742e55f55c10e98$var$La;
function $1742e55f55c10e98$var$Ma(a) {
    if (void 0 === $1742e55f55c10e98$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $1742e55f55c10e98$var$La = b && b[1] || "";
    }
    return "\n" + $1742e55f55c10e98$var$La + a;
}
var $1742e55f55c10e98$var$Na = !1;
function $1742e55f55c10e98$var$Oa(a, b) {
    if (!a || $1742e55f55c10e98$var$Na) return "";
    $1742e55f55c10e98$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $1742e55f55c10e98$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $1742e55f55c10e98$var$Ma(a) : "";
}
function $1742e55f55c10e98$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $1742e55f55c10e98$var$Ma(a.type);
        case 16:
            return $1742e55f55c10e98$var$Ma("Lazy");
        case 13:
            return $1742e55f55c10e98$var$Ma("Suspense");
        case 19:
            return $1742e55f55c10e98$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $1742e55f55c10e98$var$Oa(a.type, !1), a;
        case 11:
            return a = $1742e55f55c10e98$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $1742e55f55c10e98$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $1742e55f55c10e98$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $1742e55f55c10e98$var$ya:
            return "Fragment";
        case $1742e55f55c10e98$var$xa:
            return "Portal";
        case $1742e55f55c10e98$var$Aa:
            return "Profiler";
        case $1742e55f55c10e98$var$za:
            return "StrictMode";
        case $1742e55f55c10e98$var$Ea:
            return "Suspense";
        case $1742e55f55c10e98$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $1742e55f55c10e98$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $1742e55f55c10e98$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $1742e55f55c10e98$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $1742e55f55c10e98$var$Ga:
            return b = a.displayName || null, null !== b ? b : $1742e55f55c10e98$var$Qa(a.type) || "Memo";
        case $1742e55f55c10e98$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $1742e55f55c10e98$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $1742e55f55c10e98$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $1742e55f55c10e98$var$Qa(b);
        case 8:
            return b === $1742e55f55c10e98$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $1742e55f55c10e98$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $1742e55f55c10e98$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $1742e55f55c10e98$var$Ua(a) {
    var b = $1742e55f55c10e98$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $1742e55f55c10e98$var$Va(a) {
    a._valueTracker || (a._valueTracker = $1742e55f55c10e98$var$Ua(a));
}
function $1742e55f55c10e98$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $1742e55f55c10e98$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $1742e55f55c10e98$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $1742e55f55c10e98$var$Ya(a, b) {
    var c = b.checked;
    return $1742e55f55c10e98$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $1742e55f55c10e98$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $1742e55f55c10e98$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $1742e55f55c10e98$var$$a(a, b) {
    b = b.checked;
    null != b && $1742e55f55c10e98$var$ua(a, "checked", b, !1);
}
function $1742e55f55c10e98$var$ab(a, b) {
    $1742e55f55c10e98$var$$a(a, b);
    var c = $1742e55f55c10e98$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $1742e55f55c10e98$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $1742e55f55c10e98$var$bb(a, b.type, $1742e55f55c10e98$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $1742e55f55c10e98$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $1742e55f55c10e98$var$bb(a, b, c) {
    if ("number" !== b || $1742e55f55c10e98$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $1742e55f55c10e98$var$db = Array.isArray;
function $1742e55f55c10e98$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $1742e55f55c10e98$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $1742e55f55c10e98$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($1742e55f55c10e98$var$p(91));
    return $1742e55f55c10e98$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $1742e55f55c10e98$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($1742e55f55c10e98$var$p(92));
            if ($1742e55f55c10e98$var$db(c)) {
                if (1 < c.length) throw Error($1742e55f55c10e98$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $1742e55f55c10e98$var$Sa(c)
    };
}
function $1742e55f55c10e98$var$hb(a, b) {
    var c = $1742e55f55c10e98$var$Sa(b.value), d = $1742e55f55c10e98$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $1742e55f55c10e98$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $1742e55f55c10e98$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $1742e55f55c10e98$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $1742e55f55c10e98$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $1742e55f55c10e98$var$mb, $1742e55f55c10e98$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $1742e55f55c10e98$var$mb = $1742e55f55c10e98$var$mb || document.createElement("div");
        $1742e55f55c10e98$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $1742e55f55c10e98$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $1742e55f55c10e98$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $1742e55f55c10e98$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $1742e55f55c10e98$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($1742e55f55c10e98$var$pb).forEach(function(a) {
    $1742e55f55c10e98$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $1742e55f55c10e98$var$pb[b] = $1742e55f55c10e98$var$pb[a];
    });
});
function $1742e55f55c10e98$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $1742e55f55c10e98$var$pb.hasOwnProperty(a) && $1742e55f55c10e98$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $1742e55f55c10e98$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $1742e55f55c10e98$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $1742e55f55c10e98$var$tb = $1742e55f55c10e98$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $1742e55f55c10e98$var$ub(a, b) {
    if (b) {
        if ($1742e55f55c10e98$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($1742e55f55c10e98$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($1742e55f55c10e98$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($1742e55f55c10e98$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($1742e55f55c10e98$var$p(62));
    }
}
function $1742e55f55c10e98$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $1742e55f55c10e98$var$wb = null;
function $1742e55f55c10e98$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $1742e55f55c10e98$var$yb = null, $1742e55f55c10e98$var$zb = null, $1742e55f55c10e98$var$Ab = null;
function $1742e55f55c10e98$var$Bb(a) {
    if (a = $1742e55f55c10e98$var$Cb(a)) {
        if ("function" !== typeof $1742e55f55c10e98$var$yb) throw Error($1742e55f55c10e98$var$p(280));
        var b = a.stateNode;
        b && (b = $1742e55f55c10e98$var$Db(b), $1742e55f55c10e98$var$yb(a.stateNode, a.type, b));
    }
}
function $1742e55f55c10e98$var$Eb(a) {
    $1742e55f55c10e98$var$zb ? $1742e55f55c10e98$var$Ab ? $1742e55f55c10e98$var$Ab.push(a) : $1742e55f55c10e98$var$Ab = [
        a
    ] : $1742e55f55c10e98$var$zb = a;
}
function $1742e55f55c10e98$var$Fb() {
    if ($1742e55f55c10e98$var$zb) {
        var a = $1742e55f55c10e98$var$zb, b = $1742e55f55c10e98$var$Ab;
        $1742e55f55c10e98$var$Ab = $1742e55f55c10e98$var$zb = null;
        $1742e55f55c10e98$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$1742e55f55c10e98$var$Bb(b[a]);
    }
}
function $1742e55f55c10e98$var$Gb(a, b) {
    return a(b);
}
function $1742e55f55c10e98$var$Hb() {}
var $1742e55f55c10e98$var$Ib = !1;
function $1742e55f55c10e98$var$Jb(a, b, c) {
    if ($1742e55f55c10e98$var$Ib) return a(b, c);
    $1742e55f55c10e98$var$Ib = !0;
    try {
        return $1742e55f55c10e98$var$Gb(a, b, c);
    } finally{
        if ($1742e55f55c10e98$var$Ib = !1, null !== $1742e55f55c10e98$var$zb || null !== $1742e55f55c10e98$var$Ab) $1742e55f55c10e98$var$Hb(), $1742e55f55c10e98$var$Fb();
    }
}
function $1742e55f55c10e98$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $1742e55f55c10e98$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($1742e55f55c10e98$var$p(231, b, typeof c));
    return c;
}
var $1742e55f55c10e98$var$Lb = !1;
if ($1742e55f55c10e98$var$ia) try {
    var $1742e55f55c10e98$var$Mb = {};
    Object.defineProperty($1742e55f55c10e98$var$Mb, "passive", {
        get: function() {
            $1742e55f55c10e98$var$Lb = !0;
        }
    });
    window.addEventListener("test", $1742e55f55c10e98$var$Mb, $1742e55f55c10e98$var$Mb);
    window.removeEventListener("test", $1742e55f55c10e98$var$Mb, $1742e55f55c10e98$var$Mb);
} catch (a) {
    $1742e55f55c10e98$var$Lb = !1;
}
function $1742e55f55c10e98$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $1742e55f55c10e98$var$Ob = !1, $1742e55f55c10e98$var$Pb = null, $1742e55f55c10e98$var$Qb = !1, $1742e55f55c10e98$var$Rb = null, $1742e55f55c10e98$var$Sb = {
    onError: function(a) {
        $1742e55f55c10e98$var$Ob = !0;
        $1742e55f55c10e98$var$Pb = a;
    }
};
function $1742e55f55c10e98$var$Tb(a, b, c, d, e, f, g, h, k) {
    $1742e55f55c10e98$var$Ob = !1;
    $1742e55f55c10e98$var$Pb = null;
    $1742e55f55c10e98$var$Nb.apply($1742e55f55c10e98$var$Sb, arguments);
}
function $1742e55f55c10e98$var$Ub(a, b, c, d, e, f, g, h, k) {
    $1742e55f55c10e98$var$Tb.apply(this, arguments);
    if ($1742e55f55c10e98$var$Ob) {
        if ($1742e55f55c10e98$var$Ob) {
            var l = $1742e55f55c10e98$var$Pb;
            $1742e55f55c10e98$var$Ob = !1;
            $1742e55f55c10e98$var$Pb = null;
        } else throw Error($1742e55f55c10e98$var$p(198));
        $1742e55f55c10e98$var$Qb || ($1742e55f55c10e98$var$Qb = !0, $1742e55f55c10e98$var$Rb = l);
    }
}
function $1742e55f55c10e98$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $1742e55f55c10e98$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $1742e55f55c10e98$var$Xb(a) {
    if ($1742e55f55c10e98$var$Vb(a) !== a) throw Error($1742e55f55c10e98$var$p(188));
}
function $1742e55f55c10e98$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $1742e55f55c10e98$var$Vb(a);
        if (null === b) throw Error($1742e55f55c10e98$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $1742e55f55c10e98$var$Xb(e), a;
                if (f === d) return $1742e55f55c10e98$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($1742e55f55c10e98$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($1742e55f55c10e98$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($1742e55f55c10e98$var$p(190));
    }
    if (3 !== c.tag) throw Error($1742e55f55c10e98$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $1742e55f55c10e98$var$Zb(a) {
    a = $1742e55f55c10e98$var$Yb(a);
    return null !== a ? $1742e55f55c10e98$var$$b(a) : null;
}
function $1742e55f55c10e98$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $1742e55f55c10e98$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $1742e55f55c10e98$var$ac = $gEGs3.unstable_scheduleCallback, $1742e55f55c10e98$var$bc = $gEGs3.unstable_cancelCallback, $1742e55f55c10e98$var$cc = $gEGs3.unstable_shouldYield, $1742e55f55c10e98$var$dc = $gEGs3.unstable_requestPaint, $1742e55f55c10e98$var$A = $gEGs3.unstable_now, $1742e55f55c10e98$var$ec = $gEGs3.unstable_getCurrentPriorityLevel, $1742e55f55c10e98$var$fc = $gEGs3.unstable_ImmediatePriority, $1742e55f55c10e98$var$gc = $gEGs3.unstable_UserBlockingPriority, $1742e55f55c10e98$var$hc = $gEGs3.unstable_NormalPriority, $1742e55f55c10e98$var$ic = $gEGs3.unstable_LowPriority, $1742e55f55c10e98$var$jc = $gEGs3.unstable_IdlePriority, $1742e55f55c10e98$var$kc = null, $1742e55f55c10e98$var$lc = null, $1742e55f55c10e98$var$B = null, $1742e55f55c10e98$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $1742e55f55c10e98$var$nc(a, b) {
    if ($1742e55f55c10e98$var$lc && "function" === typeof $1742e55f55c10e98$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $1742e55f55c10e98$var$fc;
                break;
            case 4:
                d = $1742e55f55c10e98$var$gc;
                break;
            case 16:
                d = $1742e55f55c10e98$var$hc;
                break;
            case 536870912:
                d = $1742e55f55c10e98$var$jc;
                break;
            default:
                d = $1742e55f55c10e98$var$hc;
        }
        $1742e55f55c10e98$var$lc.onCommitFiberRoot($1742e55f55c10e98$var$kc, a, d, c);
    } catch (e) {}
}
function $1742e55f55c10e98$var$oc(a) {
    $1742e55f55c10e98$var$B = a;
}
function $1742e55f55c10e98$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $1742e55f55c10e98$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $1742e55f55c10e98$var$rc() {
    null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markCommitStopped && $1742e55f55c10e98$var$B.markCommitStopped();
}
function $1742e55f55c10e98$var$sc(a) {
    null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentRenderStarted && $1742e55f55c10e98$var$B.markComponentRenderStarted(a);
}
function $1742e55f55c10e98$var$tc() {
    null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentRenderStopped && $1742e55f55c10e98$var$B.markComponentRenderStopped();
}
function $1742e55f55c10e98$var$uc(a) {
    null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentLayoutEffectUnmountStarted && $1742e55f55c10e98$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $1742e55f55c10e98$var$vc() {
    null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentLayoutEffectUnmountStopped && $1742e55f55c10e98$var$B.markComponentLayoutEffectUnmountStopped();
}
function $1742e55f55c10e98$var$wc(a) {
    null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markRenderStarted && $1742e55f55c10e98$var$B.markRenderStarted(a);
}
function $1742e55f55c10e98$var$xc() {
    null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markRenderStopped && $1742e55f55c10e98$var$B.markRenderStopped();
}
function $1742e55f55c10e98$var$yc(a, b) {
    null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markStateUpdateScheduled && $1742e55f55c10e98$var$B.markStateUpdateScheduled(a, b);
}
var $1742e55f55c10e98$var$Ac = Math.clz32 ? Math.clz32 : $1742e55f55c10e98$var$zc, $1742e55f55c10e98$var$Bc = Math.log, $1742e55f55c10e98$var$Cc = Math.LN2;
function $1742e55f55c10e98$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($1742e55f55c10e98$var$Bc(a) / $1742e55f55c10e98$var$Cc | 0) | 0;
}
function $1742e55f55c10e98$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $1742e55f55c10e98$var$Dc = 64, $1742e55f55c10e98$var$Ec = 4194304;
function $1742e55f55c10e98$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $1742e55f55c10e98$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $1742e55f55c10e98$var$Fc(h) : (f &= g, 0 !== f && (d = $1742e55f55c10e98$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $1742e55f55c10e98$var$Fc(g) : 0 !== f && (d = $1742e55f55c10e98$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $1742e55f55c10e98$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $1742e55f55c10e98$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $1742e55f55c10e98$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $1742e55f55c10e98$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $1742e55f55c10e98$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $1742e55f55c10e98$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $1742e55f55c10e98$var$Kc() {
    var a = $1742e55f55c10e98$var$Dc;
    $1742e55f55c10e98$var$Dc <<= 1;
    0 === ($1742e55f55c10e98$var$Dc & 4194240) && ($1742e55f55c10e98$var$Dc = 64);
    return a;
}
function $1742e55f55c10e98$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $1742e55f55c10e98$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $1742e55f55c10e98$var$Ac(b);
    a[b] = c;
}
function $1742e55f55c10e98$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $1742e55f55c10e98$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $1742e55f55c10e98$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $1742e55f55c10e98$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $1742e55f55c10e98$var$Pc(a, b, c) {
    if ($1742e55f55c10e98$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $1742e55f55c10e98$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $1742e55f55c10e98$var$Qc(a, b) {
    if ($1742e55f55c10e98$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $1742e55f55c10e98$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $1742e55f55c10e98$var$E = 0;
function $1742e55f55c10e98$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $1742e55f55c10e98$var$Sc, $1742e55f55c10e98$var$Tc, $1742e55f55c10e98$var$Uc, $1742e55f55c10e98$var$Vc, $1742e55f55c10e98$var$Wc, $1742e55f55c10e98$var$Xc = !1, $1742e55f55c10e98$var$Yc = [], $1742e55f55c10e98$var$Zc = null, $1742e55f55c10e98$var$$c = null, $1742e55f55c10e98$var$ad = null, $1742e55f55c10e98$var$bd = new Map, $1742e55f55c10e98$var$cd = new Map, $1742e55f55c10e98$var$dd = [], $1742e55f55c10e98$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $1742e55f55c10e98$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $1742e55f55c10e98$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $1742e55f55c10e98$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $1742e55f55c10e98$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $1742e55f55c10e98$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $1742e55f55c10e98$var$cd.delete(b.pointerId);
    }
}
function $1742e55f55c10e98$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $1742e55f55c10e98$var$Cb(b), null !== b && $1742e55f55c10e98$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $1742e55f55c10e98$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $1742e55f55c10e98$var$Zc = $1742e55f55c10e98$var$gd($1742e55f55c10e98$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $1742e55f55c10e98$var$$c = $1742e55f55c10e98$var$gd($1742e55f55c10e98$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $1742e55f55c10e98$var$ad = $1742e55f55c10e98$var$gd($1742e55f55c10e98$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $1742e55f55c10e98$var$bd.set(f, $1742e55f55c10e98$var$gd($1742e55f55c10e98$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $1742e55f55c10e98$var$cd.set(f, $1742e55f55c10e98$var$gd($1742e55f55c10e98$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $1742e55f55c10e98$var$id(a) {
    var b = $1742e55f55c10e98$var$jd(a.target);
    if (null !== b) {
        var c = $1742e55f55c10e98$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $1742e55f55c10e98$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $1742e55f55c10e98$var$Wc(a.priority, function() {
                        $1742e55f55c10e98$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $1742e55f55c10e98$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $1742e55f55c10e98$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $1742e55f55c10e98$var$wb = d;
            c.target.dispatchEvent(d);
            $1742e55f55c10e98$var$wb = null;
        } else return b = $1742e55f55c10e98$var$Cb(c), null !== b && $1742e55f55c10e98$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $1742e55f55c10e98$var$md(a, b, c) {
    $1742e55f55c10e98$var$kd(a) && c.delete(b);
}
function $1742e55f55c10e98$var$nd() {
    $1742e55f55c10e98$var$Xc = !1;
    null !== $1742e55f55c10e98$var$Zc && $1742e55f55c10e98$var$kd($1742e55f55c10e98$var$Zc) && ($1742e55f55c10e98$var$Zc = null);
    null !== $1742e55f55c10e98$var$$c && $1742e55f55c10e98$var$kd($1742e55f55c10e98$var$$c) && ($1742e55f55c10e98$var$$c = null);
    null !== $1742e55f55c10e98$var$ad && $1742e55f55c10e98$var$kd($1742e55f55c10e98$var$ad) && ($1742e55f55c10e98$var$ad = null);
    $1742e55f55c10e98$var$bd.forEach($1742e55f55c10e98$var$md);
    $1742e55f55c10e98$var$cd.forEach($1742e55f55c10e98$var$md);
}
function $1742e55f55c10e98$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $1742e55f55c10e98$var$Xc || ($1742e55f55c10e98$var$Xc = !0, $gEGs3.unstable_scheduleCallback($gEGs3.unstable_NormalPriority, $1742e55f55c10e98$var$nd)));
}
function $1742e55f55c10e98$var$pd(a) {
    function b(b) {
        return $1742e55f55c10e98$var$od(b, a);
    }
    if (0 < $1742e55f55c10e98$var$Yc.length) {
        $1742e55f55c10e98$var$od($1742e55f55c10e98$var$Yc[0], a);
        for(var c = 1; c < $1742e55f55c10e98$var$Yc.length; c++){
            var d = $1742e55f55c10e98$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $1742e55f55c10e98$var$Zc && $1742e55f55c10e98$var$od($1742e55f55c10e98$var$Zc, a);
    null !== $1742e55f55c10e98$var$$c && $1742e55f55c10e98$var$od($1742e55f55c10e98$var$$c, a);
    null !== $1742e55f55c10e98$var$ad && $1742e55f55c10e98$var$od($1742e55f55c10e98$var$ad, a);
    $1742e55f55c10e98$var$bd.forEach(b);
    $1742e55f55c10e98$var$cd.forEach(b);
    for(c = 0; c < $1742e55f55c10e98$var$dd.length; c++)d = $1742e55f55c10e98$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $1742e55f55c10e98$var$dd.length && (c = $1742e55f55c10e98$var$dd[0], null === c.blockedOn);)$1742e55f55c10e98$var$id(c), null === c.blockedOn && $1742e55f55c10e98$var$dd.shift();
}
var $1742e55f55c10e98$var$qd = $1742e55f55c10e98$var$va.ReactCurrentBatchConfig, $1742e55f55c10e98$var$rd = !0;
function $1742e55f55c10e98$var$sd(a, b, c, d) {
    var e = $1742e55f55c10e98$var$E, f = $1742e55f55c10e98$var$qd.transition;
    $1742e55f55c10e98$var$qd.transition = null;
    try {
        $1742e55f55c10e98$var$E = 1, $1742e55f55c10e98$var$td(a, b, c, d);
    } finally{
        $1742e55f55c10e98$var$E = e, $1742e55f55c10e98$var$qd.transition = f;
    }
}
function $1742e55f55c10e98$var$ud(a, b, c, d) {
    var e = $1742e55f55c10e98$var$E, f = $1742e55f55c10e98$var$qd.transition;
    $1742e55f55c10e98$var$qd.transition = null;
    try {
        $1742e55f55c10e98$var$E = 4, $1742e55f55c10e98$var$td(a, b, c, d);
    } finally{
        $1742e55f55c10e98$var$E = e, $1742e55f55c10e98$var$qd.transition = f;
    }
}
function $1742e55f55c10e98$var$td(a, b, c, d) {
    if ($1742e55f55c10e98$var$rd) {
        var e = $1742e55f55c10e98$var$ld(a, b, c, d);
        if (null === e) $1742e55f55c10e98$var$vd(a, b, d, $1742e55f55c10e98$var$wd, c), $1742e55f55c10e98$var$fd(a, d);
        else if ($1742e55f55c10e98$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($1742e55f55c10e98$var$fd(a, d), b & 4 && -1 < $1742e55f55c10e98$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $1742e55f55c10e98$var$Cb(e);
                null !== f && $1742e55f55c10e98$var$Sc(f);
                f = $1742e55f55c10e98$var$ld(a, b, c, d);
                null === f && $1742e55f55c10e98$var$vd(a, b, d, $1742e55f55c10e98$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $1742e55f55c10e98$var$vd(a, b, d, null, c);
    }
}
var $1742e55f55c10e98$var$wd = null;
function $1742e55f55c10e98$var$ld(a, b, c, d) {
    $1742e55f55c10e98$var$wd = null;
    a = $1742e55f55c10e98$var$xb(d);
    a = $1742e55f55c10e98$var$jd(a);
    if (null !== a) {
        if (b = $1742e55f55c10e98$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $1742e55f55c10e98$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $1742e55f55c10e98$var$wd = a;
    return null;
}
function $1742e55f55c10e98$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($1742e55f55c10e98$var$ec()){
                case $1742e55f55c10e98$var$fc:
                    return 1;
                case $1742e55f55c10e98$var$gc:
                    return 4;
                case $1742e55f55c10e98$var$hc:
                case $1742e55f55c10e98$var$ic:
                    return 16;
                case $1742e55f55c10e98$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $1742e55f55c10e98$var$yd = null, $1742e55f55c10e98$var$zd = null, $1742e55f55c10e98$var$Ad = null;
function $1742e55f55c10e98$var$Bd() {
    if ($1742e55f55c10e98$var$Ad) return $1742e55f55c10e98$var$Ad;
    var a, b = $1742e55f55c10e98$var$zd, c = b.length, d, e = "value" in $1742e55f55c10e98$var$yd ? $1742e55f55c10e98$var$yd.value : $1742e55f55c10e98$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $1742e55f55c10e98$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $1742e55f55c10e98$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $1742e55f55c10e98$var$Dd() {
    return !0;
}
function $1742e55f55c10e98$var$Ed() {
    return !1;
}
function $1742e55f55c10e98$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $1742e55f55c10e98$var$Dd : $1742e55f55c10e98$var$Ed;
        this.isPropagationStopped = $1742e55f55c10e98$var$Ed;
        return this;
    }
    $1742e55f55c10e98$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $1742e55f55c10e98$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $1742e55f55c10e98$var$Dd);
        },
        persist: function() {},
        isPersistent: $1742e55f55c10e98$var$Dd
    });
    return b;
}
var $1742e55f55c10e98$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $1742e55f55c10e98$var$Hd = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$Gd), $1742e55f55c10e98$var$Id = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Gd, {
    view: 0,
    detail: 0
}), $1742e55f55c10e98$var$Jd = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$Id), $1742e55f55c10e98$var$Kd, $1742e55f55c10e98$var$Ld, $1742e55f55c10e98$var$Md, $1742e55f55c10e98$var$Od = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $1742e55f55c10e98$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $1742e55f55c10e98$var$Md && ($1742e55f55c10e98$var$Md && "mousemove" === a.type ? ($1742e55f55c10e98$var$Kd = a.screenX - $1742e55f55c10e98$var$Md.screenX, $1742e55f55c10e98$var$Ld = a.screenY - $1742e55f55c10e98$var$Md.screenY) : $1742e55f55c10e98$var$Ld = $1742e55f55c10e98$var$Kd = 0, $1742e55f55c10e98$var$Md = a);
        return $1742e55f55c10e98$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $1742e55f55c10e98$var$Ld;
    }
}), $1742e55f55c10e98$var$Pd = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$Od), $1742e55f55c10e98$var$Qd = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Od, {
    dataTransfer: 0
}), $1742e55f55c10e98$var$Rd = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$Qd), $1742e55f55c10e98$var$Sd = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Id, {
    relatedTarget: 0
}), $1742e55f55c10e98$var$Td = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$Sd), $1742e55f55c10e98$var$Ud = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $1742e55f55c10e98$var$Vd = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$Ud), $1742e55f55c10e98$var$Wd = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $1742e55f55c10e98$var$Xd = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$Wd), $1742e55f55c10e98$var$Yd = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Gd, {
    data: 0
}), $1742e55f55c10e98$var$Zd = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$Yd), $1742e55f55c10e98$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $1742e55f55c10e98$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $1742e55f55c10e98$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $1742e55f55c10e98$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $1742e55f55c10e98$var$be[a]) ? !!b[a] : !1;
}
function $1742e55f55c10e98$var$Nd() {
    return $1742e55f55c10e98$var$ce;
}
var $1742e55f55c10e98$var$de = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $1742e55f55c10e98$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $1742e55f55c10e98$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $1742e55f55c10e98$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $1742e55f55c10e98$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $1742e55f55c10e98$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $1742e55f55c10e98$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $1742e55f55c10e98$var$ee = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$de), $1742e55f55c10e98$var$fe = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $1742e55f55c10e98$var$ge = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$fe), $1742e55f55c10e98$var$he = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $1742e55f55c10e98$var$Nd
}), $1742e55f55c10e98$var$ie = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$he), $1742e55f55c10e98$var$je = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $1742e55f55c10e98$var$ke = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$je), $1742e55f55c10e98$var$le = $1742e55f55c10e98$var$u({}, $1742e55f55c10e98$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $1742e55f55c10e98$var$me = $1742e55f55c10e98$var$Fd($1742e55f55c10e98$var$le), $1742e55f55c10e98$var$ne = [
    9,
    13,
    27,
    32
], $1742e55f55c10e98$var$oe = $1742e55f55c10e98$var$ia && "CompositionEvent" in window, $1742e55f55c10e98$var$pe = null;
$1742e55f55c10e98$var$ia && "documentMode" in document && ($1742e55f55c10e98$var$pe = document.documentMode);
var $1742e55f55c10e98$var$qe = $1742e55f55c10e98$var$ia && "TextEvent" in window && !$1742e55f55c10e98$var$pe, $1742e55f55c10e98$var$re = $1742e55f55c10e98$var$ia && (!$1742e55f55c10e98$var$oe || $1742e55f55c10e98$var$pe && 8 < $1742e55f55c10e98$var$pe && 11 >= $1742e55f55c10e98$var$pe), $1742e55f55c10e98$var$se = String.fromCharCode(32), $1742e55f55c10e98$var$te = !1;
function $1742e55f55c10e98$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $1742e55f55c10e98$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $1742e55f55c10e98$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $1742e55f55c10e98$var$we = !1;
function $1742e55f55c10e98$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $1742e55f55c10e98$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $1742e55f55c10e98$var$te = !0;
            return $1742e55f55c10e98$var$se;
        case "textInput":
            return a = b.data, a === $1742e55f55c10e98$var$se && $1742e55f55c10e98$var$te ? null : a;
        default:
            return null;
    }
}
function $1742e55f55c10e98$var$ye(a, b) {
    if ($1742e55f55c10e98$var$we) return "compositionend" === a || !$1742e55f55c10e98$var$oe && $1742e55f55c10e98$var$ue(a, b) ? (a = $1742e55f55c10e98$var$Bd(), $1742e55f55c10e98$var$Ad = $1742e55f55c10e98$var$zd = $1742e55f55c10e98$var$yd = null, $1742e55f55c10e98$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $1742e55f55c10e98$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $1742e55f55c10e98$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $1742e55f55c10e98$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$1742e55f55c10e98$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $1742e55f55c10e98$var$Be(a, b, c, d) {
    $1742e55f55c10e98$var$Eb(d);
    b = $1742e55f55c10e98$var$Ce(b, "onChange");
    0 < b.length && (c = new $1742e55f55c10e98$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $1742e55f55c10e98$var$De = null, $1742e55f55c10e98$var$Ee = null;
function $1742e55f55c10e98$var$Fe(a) {
    $1742e55f55c10e98$var$Ge(a, 0);
}
function $1742e55f55c10e98$var$He(a) {
    var b = $1742e55f55c10e98$var$Ie(a);
    if ($1742e55f55c10e98$var$Wa(b)) return a;
}
function $1742e55f55c10e98$var$Je(a, b) {
    if ("change" === a) return b;
}
var $1742e55f55c10e98$var$Ke = !1;
if ($1742e55f55c10e98$var$ia) {
    var $1742e55f55c10e98$var$Le;
    if ($1742e55f55c10e98$var$ia) {
        var $1742e55f55c10e98$var$Me = "oninput" in document;
        if (!$1742e55f55c10e98$var$Me) {
            var $1742e55f55c10e98$var$Ne = document.createElement("div");
            $1742e55f55c10e98$var$Ne.setAttribute("oninput", "return;");
            $1742e55f55c10e98$var$Me = "function" === typeof $1742e55f55c10e98$var$Ne.oninput;
        }
        $1742e55f55c10e98$var$Le = $1742e55f55c10e98$var$Me;
    } else $1742e55f55c10e98$var$Le = !1;
    $1742e55f55c10e98$var$Ke = $1742e55f55c10e98$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $1742e55f55c10e98$var$Oe() {
    $1742e55f55c10e98$var$De && ($1742e55f55c10e98$var$De.detachEvent("onpropertychange", $1742e55f55c10e98$var$Pe), $1742e55f55c10e98$var$Ee = $1742e55f55c10e98$var$De = null);
}
function $1742e55f55c10e98$var$Pe(a) {
    if ("value" === a.propertyName && $1742e55f55c10e98$var$He($1742e55f55c10e98$var$Ee)) {
        var b = [];
        $1742e55f55c10e98$var$Be(b, $1742e55f55c10e98$var$Ee, a, $1742e55f55c10e98$var$xb(a));
        $1742e55f55c10e98$var$Jb($1742e55f55c10e98$var$Fe, b);
    }
}
function $1742e55f55c10e98$var$Qe(a, b, c) {
    "focusin" === a ? ($1742e55f55c10e98$var$Oe(), $1742e55f55c10e98$var$De = b, $1742e55f55c10e98$var$Ee = c, $1742e55f55c10e98$var$De.attachEvent("onpropertychange", $1742e55f55c10e98$var$Pe)) : "focusout" === a && $1742e55f55c10e98$var$Oe();
}
function $1742e55f55c10e98$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $1742e55f55c10e98$var$He($1742e55f55c10e98$var$Ee);
}
function $1742e55f55c10e98$var$Se(a, b) {
    if ("click" === a) return $1742e55f55c10e98$var$He(b);
}
function $1742e55f55c10e98$var$Te(a, b) {
    if ("input" === a || "change" === a) return $1742e55f55c10e98$var$He(b);
}
function $1742e55f55c10e98$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $1742e55f55c10e98$var$Ve = "function" === typeof Object.is ? Object.is : $1742e55f55c10e98$var$Ue;
function $1742e55f55c10e98$var$We(a, b) {
    if ($1742e55f55c10e98$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$1742e55f55c10e98$var$ja.call(b, e) || !$1742e55f55c10e98$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $1742e55f55c10e98$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $1742e55f55c10e98$var$Ye(a, b) {
    var c = $1742e55f55c10e98$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $1742e55f55c10e98$var$Xe(c);
    }
}
function $1742e55f55c10e98$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $1742e55f55c10e98$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $1742e55f55c10e98$var$$e() {
    for(var a = window, b = $1742e55f55c10e98$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $1742e55f55c10e98$var$Xa(a.document);
    }
    return b;
}
function $1742e55f55c10e98$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $1742e55f55c10e98$var$bf(a) {
    var b = $1742e55f55c10e98$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $1742e55f55c10e98$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $1742e55f55c10e98$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $1742e55f55c10e98$var$Ye(c, f);
                var g = $1742e55f55c10e98$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $1742e55f55c10e98$var$cf = $1742e55f55c10e98$var$ia && "documentMode" in document && 11 >= document.documentMode, $1742e55f55c10e98$var$df = null, $1742e55f55c10e98$var$ef = null, $1742e55f55c10e98$var$ff = null, $1742e55f55c10e98$var$gf = !1;
function $1742e55f55c10e98$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $1742e55f55c10e98$var$gf || null == $1742e55f55c10e98$var$df || $1742e55f55c10e98$var$df !== $1742e55f55c10e98$var$Xa(d) || (d = $1742e55f55c10e98$var$df, "selectionStart" in d && $1742e55f55c10e98$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $1742e55f55c10e98$var$ff && $1742e55f55c10e98$var$We($1742e55f55c10e98$var$ff, d) || ($1742e55f55c10e98$var$ff = d, d = $1742e55f55c10e98$var$Ce($1742e55f55c10e98$var$ef, "onSelect"), 0 < d.length && (b = new $1742e55f55c10e98$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $1742e55f55c10e98$var$df)));
}
function $1742e55f55c10e98$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $1742e55f55c10e98$var$kf = {
    animationend: $1742e55f55c10e98$var$jf("Animation", "AnimationEnd"),
    animationiteration: $1742e55f55c10e98$var$jf("Animation", "AnimationIteration"),
    animationstart: $1742e55f55c10e98$var$jf("Animation", "AnimationStart"),
    transitionend: $1742e55f55c10e98$var$jf("Transition", "TransitionEnd")
}, $1742e55f55c10e98$var$lf = {}, $1742e55f55c10e98$var$mf = {};
$1742e55f55c10e98$var$ia && ($1742e55f55c10e98$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $1742e55f55c10e98$var$kf.animationend.animation, delete $1742e55f55c10e98$var$kf.animationiteration.animation, delete $1742e55f55c10e98$var$kf.animationstart.animation), "TransitionEvent" in window || delete $1742e55f55c10e98$var$kf.transitionend.transition);
function $1742e55f55c10e98$var$nf(a) {
    if ($1742e55f55c10e98$var$lf[a]) return $1742e55f55c10e98$var$lf[a];
    if (!$1742e55f55c10e98$var$kf[a]) return a;
    var b = $1742e55f55c10e98$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $1742e55f55c10e98$var$mf) return $1742e55f55c10e98$var$lf[a] = b[c];
    return a;
}
var $1742e55f55c10e98$var$of = $1742e55f55c10e98$var$nf("animationend"), $1742e55f55c10e98$var$pf = $1742e55f55c10e98$var$nf("animationiteration"), $1742e55f55c10e98$var$qf = $1742e55f55c10e98$var$nf("animationstart"), $1742e55f55c10e98$var$rf = $1742e55f55c10e98$var$nf("transitionend"), $1742e55f55c10e98$var$sf = new Map, $1742e55f55c10e98$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $1742e55f55c10e98$var$uf(a, b) {
    $1742e55f55c10e98$var$sf.set(a, b);
    $1742e55f55c10e98$var$fa(b, [
        a
    ]);
}
for(var $1742e55f55c10e98$var$vf = 0; $1742e55f55c10e98$var$vf < $1742e55f55c10e98$var$tf.length; $1742e55f55c10e98$var$vf++){
    var $1742e55f55c10e98$var$wf = $1742e55f55c10e98$var$tf[$1742e55f55c10e98$var$vf], $1742e55f55c10e98$var$xf = $1742e55f55c10e98$var$wf.toLowerCase(), $1742e55f55c10e98$var$yf = $1742e55f55c10e98$var$wf[0].toUpperCase() + $1742e55f55c10e98$var$wf.slice(1);
    $1742e55f55c10e98$var$uf($1742e55f55c10e98$var$xf, "on" + $1742e55f55c10e98$var$yf);
}
$1742e55f55c10e98$var$uf($1742e55f55c10e98$var$of, "onAnimationEnd");
$1742e55f55c10e98$var$uf($1742e55f55c10e98$var$pf, "onAnimationIteration");
$1742e55f55c10e98$var$uf($1742e55f55c10e98$var$qf, "onAnimationStart");
$1742e55f55c10e98$var$uf("dblclick", "onDoubleClick");
$1742e55f55c10e98$var$uf("focusin", "onFocus");
$1742e55f55c10e98$var$uf("focusout", "onBlur");
$1742e55f55c10e98$var$uf($1742e55f55c10e98$var$rf, "onTransitionEnd");
$1742e55f55c10e98$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$1742e55f55c10e98$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$1742e55f55c10e98$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$1742e55f55c10e98$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$1742e55f55c10e98$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$1742e55f55c10e98$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$1742e55f55c10e98$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$1742e55f55c10e98$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$1742e55f55c10e98$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$1742e55f55c10e98$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $1742e55f55c10e98$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $1742e55f55c10e98$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($1742e55f55c10e98$var$zf));
function $1742e55f55c10e98$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $1742e55f55c10e98$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $1742e55f55c10e98$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $1742e55f55c10e98$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $1742e55f55c10e98$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($1742e55f55c10e98$var$Qb) throw a = $1742e55f55c10e98$var$Rb, $1742e55f55c10e98$var$Qb = !1, $1742e55f55c10e98$var$Rb = null, a;
}
function $1742e55f55c10e98$var$F(a, b) {
    var c = b[$1742e55f55c10e98$var$Cf];
    void 0 === c && (c = b[$1742e55f55c10e98$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($1742e55f55c10e98$var$Df(b, a, 2, !1), c.add(d));
}
function $1742e55f55c10e98$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $1742e55f55c10e98$var$Df(c, a, d, b);
}
var $1742e55f55c10e98$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $1742e55f55c10e98$var$Gf(a) {
    if (!a[$1742e55f55c10e98$var$Ff]) {
        a[$1742e55f55c10e98$var$Ff] = !0;
        $1742e55f55c10e98$var$da.forEach(function(b) {
            "selectionchange" !== b && ($1742e55f55c10e98$var$Af.has(b) || $1742e55f55c10e98$var$Ef(b, !1, a), $1742e55f55c10e98$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$1742e55f55c10e98$var$Ff] || (b[$1742e55f55c10e98$var$Ff] = !0, $1742e55f55c10e98$var$Ef("selectionchange", !1, b));
    }
}
function $1742e55f55c10e98$var$Df(a, b, c, d) {
    switch($1742e55f55c10e98$var$xd(b)){
        case 1:
            var e = $1742e55f55c10e98$var$sd;
            break;
        case 4:
            e = $1742e55f55c10e98$var$ud;
            break;
        default:
            e = $1742e55f55c10e98$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$1742e55f55c10e98$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $1742e55f55c10e98$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $1742e55f55c10e98$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $1742e55f55c10e98$var$Jb(function() {
        var d = f, e = $1742e55f55c10e98$var$xb(c), g = [];
        a: {
            var h = $1742e55f55c10e98$var$sf.get(a);
            if (void 0 !== h) {
                var k = $1742e55f55c10e98$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $1742e55f55c10e98$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $1742e55f55c10e98$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $1742e55f55c10e98$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $1742e55f55c10e98$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $1742e55f55c10e98$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $1742e55f55c10e98$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $1742e55f55c10e98$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $1742e55f55c10e98$var$ie;
                        break;
                    case $1742e55f55c10e98$var$of:
                    case $1742e55f55c10e98$var$pf:
                    case $1742e55f55c10e98$var$qf:
                        k = $1742e55f55c10e98$var$Vd;
                        break;
                    case $1742e55f55c10e98$var$rf:
                        k = $1742e55f55c10e98$var$ke;
                        break;
                    case "scroll":
                        k = $1742e55f55c10e98$var$Jd;
                        break;
                    case "wheel":
                        k = $1742e55f55c10e98$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $1742e55f55c10e98$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $1742e55f55c10e98$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $1742e55f55c10e98$var$Kb(y, x), null != D && w.push($1742e55f55c10e98$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $1742e55f55c10e98$var$wb && (m = c.relatedTarget || c.fromElement) && ($1742e55f55c10e98$var$jd(m) || m[$1742e55f55c10e98$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $1742e55f55c10e98$var$jd(m) : null, null !== m && (C = $1742e55f55c10e98$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $1742e55f55c10e98$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $1742e55f55c10e98$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $1742e55f55c10e98$var$Ie(k);
                        v = null == m ? h : $1742e55f55c10e98$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $1742e55f55c10e98$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $1742e55f55c10e98$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $1742e55f55c10e98$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $1742e55f55c10e98$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $1742e55f55c10e98$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $1742e55f55c10e98$var$Jf(w);
                                x = $1742e55f55c10e98$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $1742e55f55c10e98$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $1742e55f55c10e98$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $1742e55f55c10e98$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $1742e55f55c10e98$var$Je;
                else if ($1742e55f55c10e98$var$Ae(h)) {
                    if ($1742e55f55c10e98$var$Ke) ca = $1742e55f55c10e98$var$Te;
                    else {
                        ca = $1742e55f55c10e98$var$Re;
                        var R = $1742e55f55c10e98$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $1742e55f55c10e98$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $1742e55f55c10e98$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $1742e55f55c10e98$var$bb(h, "number", h.value);
            }
            R = d ? $1742e55f55c10e98$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($1742e55f55c10e98$var$Ae(R) || "true" === R.contentEditable) $1742e55f55c10e98$var$df = R, $1742e55f55c10e98$var$ef = d, $1742e55f55c10e98$var$ff = null;
                    break;
                case "focusout":
                    $1742e55f55c10e98$var$ff = $1742e55f55c10e98$var$ef = $1742e55f55c10e98$var$df = null;
                    break;
                case "mousedown":
                    $1742e55f55c10e98$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $1742e55f55c10e98$var$gf = !1;
                    $1742e55f55c10e98$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($1742e55f55c10e98$var$cf) break;
                case "keydown":
                case "keyup":
                    $1742e55f55c10e98$var$hf(g, c, e);
            }
            var sa;
            if ($1742e55f55c10e98$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $1742e55f55c10e98$var$we ? $1742e55f55c10e98$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($1742e55f55c10e98$var$re && "ko" !== c.locale && ($1742e55f55c10e98$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $1742e55f55c10e98$var$we && (sa = $1742e55f55c10e98$var$Bd()) : ($1742e55f55c10e98$var$yd = e, $1742e55f55c10e98$var$zd = "value" in $1742e55f55c10e98$var$yd ? $1742e55f55c10e98$var$yd.value : $1742e55f55c10e98$var$yd.textContent, $1742e55f55c10e98$var$we = !0)), R = $1742e55f55c10e98$var$Ce(d, V), 0 < R.length && (V = new $1742e55f55c10e98$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $1742e55f55c10e98$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $1742e55f55c10e98$var$qe ? $1742e55f55c10e98$var$xe(a, c) : $1742e55f55c10e98$var$ye(a, c)) d = $1742e55f55c10e98$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $1742e55f55c10e98$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $1742e55f55c10e98$var$Ge(g, b);
    });
}
function $1742e55f55c10e98$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $1742e55f55c10e98$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $1742e55f55c10e98$var$Kb(a, c), null != f && d.unshift($1742e55f55c10e98$var$Hf(a, f, e)), f = $1742e55f55c10e98$var$Kb(a, b), null != f && d.push($1742e55f55c10e98$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $1742e55f55c10e98$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $1742e55f55c10e98$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $1742e55f55c10e98$var$Kb(c, f), null != k && g.unshift($1742e55f55c10e98$var$Hf(c, k, h))) : e || (k = $1742e55f55c10e98$var$Kb(c, f), null != k && g.push($1742e55f55c10e98$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $1742e55f55c10e98$var$Lf = /\r\n?/g, $1742e55f55c10e98$var$Mf = /\u0000|\uFFFD/g;
function $1742e55f55c10e98$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($1742e55f55c10e98$var$Lf, "\n").replace($1742e55f55c10e98$var$Mf, "");
}
function $1742e55f55c10e98$var$Of(a, b, c) {
    b = $1742e55f55c10e98$var$Nf(b);
    if ($1742e55f55c10e98$var$Nf(a) !== b && c) throw Error($1742e55f55c10e98$var$p(425));
}
function $1742e55f55c10e98$var$Pf() {}
var $1742e55f55c10e98$var$Qf = null, $1742e55f55c10e98$var$Rf = null;
function $1742e55f55c10e98$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $1742e55f55c10e98$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $1742e55f55c10e98$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $1742e55f55c10e98$var$Vf = "function" === typeof Promise ? Promise : void 0, $1742e55f55c10e98$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $1742e55f55c10e98$var$Vf ? function(a) {
    return $1742e55f55c10e98$var$Vf.resolve(null).then(a).catch($1742e55f55c10e98$var$Wf);
} : $1742e55f55c10e98$var$Tf;
function $1742e55f55c10e98$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $1742e55f55c10e98$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $1742e55f55c10e98$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $1742e55f55c10e98$var$pd(b);
}
function $1742e55f55c10e98$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $1742e55f55c10e98$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $1742e55f55c10e98$var$ag = Math.random().toString(36).slice(2), $1742e55f55c10e98$var$bg = "__reactFiber$" + $1742e55f55c10e98$var$ag, $1742e55f55c10e98$var$cg = "__reactProps$" + $1742e55f55c10e98$var$ag, $1742e55f55c10e98$var$If = "__reactContainer$" + $1742e55f55c10e98$var$ag, $1742e55f55c10e98$var$Cf = "__reactEvents$" + $1742e55f55c10e98$var$ag, $1742e55f55c10e98$var$dg = "__reactListeners$" + $1742e55f55c10e98$var$ag, $1742e55f55c10e98$var$eg = "__reactHandles$" + $1742e55f55c10e98$var$ag;
function $1742e55f55c10e98$var$jd(a) {
    var b = a[$1742e55f55c10e98$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$1742e55f55c10e98$var$If] || c[$1742e55f55c10e98$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $1742e55f55c10e98$var$$f(a); null !== a;){
                if (c = a[$1742e55f55c10e98$var$bg]) return c;
                a = $1742e55f55c10e98$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $1742e55f55c10e98$var$Cb(a) {
    a = a[$1742e55f55c10e98$var$bg] || a[$1742e55f55c10e98$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $1742e55f55c10e98$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($1742e55f55c10e98$var$p(33));
}
function $1742e55f55c10e98$var$Db(a) {
    return a[$1742e55f55c10e98$var$cg] || null;
}
var $1742e55f55c10e98$var$fg = [], $1742e55f55c10e98$var$gg = -1;
function $1742e55f55c10e98$var$hg(a) {
    return {
        current: a
    };
}
function $1742e55f55c10e98$var$G(a) {
    0 > $1742e55f55c10e98$var$gg || (a.current = $1742e55f55c10e98$var$fg[$1742e55f55c10e98$var$gg], $1742e55f55c10e98$var$fg[$1742e55f55c10e98$var$gg] = null, $1742e55f55c10e98$var$gg--);
}
function $1742e55f55c10e98$var$H(a, b) {
    $1742e55f55c10e98$var$gg++;
    $1742e55f55c10e98$var$fg[$1742e55f55c10e98$var$gg] = a.current;
    a.current = b;
}
var $1742e55f55c10e98$var$ig = {}, $1742e55f55c10e98$var$I = $1742e55f55c10e98$var$hg($1742e55f55c10e98$var$ig), $1742e55f55c10e98$var$jg = $1742e55f55c10e98$var$hg(!1), $1742e55f55c10e98$var$kg = $1742e55f55c10e98$var$ig;
function $1742e55f55c10e98$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $1742e55f55c10e98$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $1742e55f55c10e98$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $1742e55f55c10e98$var$ng() {
    $1742e55f55c10e98$var$G($1742e55f55c10e98$var$jg);
    $1742e55f55c10e98$var$G($1742e55f55c10e98$var$I);
}
function $1742e55f55c10e98$var$og(a, b, c) {
    if ($1742e55f55c10e98$var$I.current !== $1742e55f55c10e98$var$ig) throw Error($1742e55f55c10e98$var$p(168));
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$I, b);
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$jg, c);
}
function $1742e55f55c10e98$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($1742e55f55c10e98$var$p(108, $1742e55f55c10e98$var$Ra(a) || "Unknown", e));
    return $1742e55f55c10e98$var$u({}, c, d);
}
function $1742e55f55c10e98$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $1742e55f55c10e98$var$ig;
    $1742e55f55c10e98$var$kg = $1742e55f55c10e98$var$I.current;
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$I, a);
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$jg, $1742e55f55c10e98$var$jg.current);
    return !0;
}
function $1742e55f55c10e98$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($1742e55f55c10e98$var$p(169));
    c ? (a = $1742e55f55c10e98$var$pg(a, b, $1742e55f55c10e98$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $1742e55f55c10e98$var$G($1742e55f55c10e98$var$jg), $1742e55f55c10e98$var$G($1742e55f55c10e98$var$I), $1742e55f55c10e98$var$H($1742e55f55c10e98$var$I, a)) : $1742e55f55c10e98$var$G($1742e55f55c10e98$var$jg);
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$jg, c);
}
var $1742e55f55c10e98$var$sg = null, $1742e55f55c10e98$var$tg = !1, $1742e55f55c10e98$var$ug = !1;
function $1742e55f55c10e98$var$vg(a) {
    null === $1742e55f55c10e98$var$sg ? $1742e55f55c10e98$var$sg = [
        a
    ] : $1742e55f55c10e98$var$sg.push(a);
}
function $1742e55f55c10e98$var$wg(a) {
    $1742e55f55c10e98$var$tg = !0;
    $1742e55f55c10e98$var$vg(a);
}
function $1742e55f55c10e98$var$xg() {
    if (!$1742e55f55c10e98$var$ug && null !== $1742e55f55c10e98$var$sg) {
        $1742e55f55c10e98$var$ug = !0;
        var a = 0, b = $1742e55f55c10e98$var$E;
        try {
            var c = $1742e55f55c10e98$var$sg;
            for($1742e55f55c10e98$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $1742e55f55c10e98$var$sg = null;
            $1742e55f55c10e98$var$tg = !1;
        } catch (e) {
            throw null !== $1742e55f55c10e98$var$sg && ($1742e55f55c10e98$var$sg = $1742e55f55c10e98$var$sg.slice(a + 1)), $1742e55f55c10e98$var$ac($1742e55f55c10e98$var$fc, $1742e55f55c10e98$var$xg), e;
        } finally{
            $1742e55f55c10e98$var$E = b, $1742e55f55c10e98$var$ug = !1;
        }
    }
    return null;
}
var $1742e55f55c10e98$var$yg = [], $1742e55f55c10e98$var$zg = 0, $1742e55f55c10e98$var$Ag = null, $1742e55f55c10e98$var$Bg = 0, $1742e55f55c10e98$var$Cg = [], $1742e55f55c10e98$var$Dg = 0, $1742e55f55c10e98$var$Eg = null, $1742e55f55c10e98$var$Fg = 1, $1742e55f55c10e98$var$Gg = "";
function $1742e55f55c10e98$var$Hg(a, b) {
    $1742e55f55c10e98$var$yg[$1742e55f55c10e98$var$zg++] = $1742e55f55c10e98$var$Bg;
    $1742e55f55c10e98$var$yg[$1742e55f55c10e98$var$zg++] = $1742e55f55c10e98$var$Ag;
    $1742e55f55c10e98$var$Ag = a;
    $1742e55f55c10e98$var$Bg = b;
}
function $1742e55f55c10e98$var$Ig(a, b, c) {
    $1742e55f55c10e98$var$Cg[$1742e55f55c10e98$var$Dg++] = $1742e55f55c10e98$var$Fg;
    $1742e55f55c10e98$var$Cg[$1742e55f55c10e98$var$Dg++] = $1742e55f55c10e98$var$Gg;
    $1742e55f55c10e98$var$Cg[$1742e55f55c10e98$var$Dg++] = $1742e55f55c10e98$var$Eg;
    $1742e55f55c10e98$var$Eg = a;
    var d = $1742e55f55c10e98$var$Fg;
    a = $1742e55f55c10e98$var$Gg;
    var e = 32 - $1742e55f55c10e98$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $1742e55f55c10e98$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $1742e55f55c10e98$var$Fg = 1 << 32 - $1742e55f55c10e98$var$Ac(b) + e | c << e | d;
        $1742e55f55c10e98$var$Gg = f + a;
    } else $1742e55f55c10e98$var$Fg = 1 << f | c << e | d, $1742e55f55c10e98$var$Gg = a;
}
function $1742e55f55c10e98$var$Jg(a) {
    null !== a.return && ($1742e55f55c10e98$var$Hg(a, 1), $1742e55f55c10e98$var$Ig(a, 1, 0));
}
function $1742e55f55c10e98$var$Kg(a) {
    for(; a === $1742e55f55c10e98$var$Ag;)$1742e55f55c10e98$var$Ag = $1742e55f55c10e98$var$yg[--$1742e55f55c10e98$var$zg], $1742e55f55c10e98$var$yg[$1742e55f55c10e98$var$zg] = null, $1742e55f55c10e98$var$Bg = $1742e55f55c10e98$var$yg[--$1742e55f55c10e98$var$zg], $1742e55f55c10e98$var$yg[$1742e55f55c10e98$var$zg] = null;
    for(; a === $1742e55f55c10e98$var$Eg;)$1742e55f55c10e98$var$Eg = $1742e55f55c10e98$var$Cg[--$1742e55f55c10e98$var$Dg], $1742e55f55c10e98$var$Cg[$1742e55f55c10e98$var$Dg] = null, $1742e55f55c10e98$var$Gg = $1742e55f55c10e98$var$Cg[--$1742e55f55c10e98$var$Dg], $1742e55f55c10e98$var$Cg[$1742e55f55c10e98$var$Dg] = null, $1742e55f55c10e98$var$Fg = $1742e55f55c10e98$var$Cg[--$1742e55f55c10e98$var$Dg], $1742e55f55c10e98$var$Cg[$1742e55f55c10e98$var$Dg] = null;
}
var $1742e55f55c10e98$var$Lg = null, $1742e55f55c10e98$var$Mg = null, $1742e55f55c10e98$var$J = !1, $1742e55f55c10e98$var$Ng = null;
function $1742e55f55c10e98$var$Og(a, b) {
    var c = $1742e55f55c10e98$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $1742e55f55c10e98$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $1742e55f55c10e98$var$Lg = a, $1742e55f55c10e98$var$Mg = $1742e55f55c10e98$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $1742e55f55c10e98$var$Lg = a, $1742e55f55c10e98$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $1742e55f55c10e98$var$Eg ? {
                id: $1742e55f55c10e98$var$Fg,
                overflow: $1742e55f55c10e98$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $1742e55f55c10e98$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $1742e55f55c10e98$var$Lg = a, $1742e55f55c10e98$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $1742e55f55c10e98$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $1742e55f55c10e98$var$Sg(a) {
    if ($1742e55f55c10e98$var$J) {
        var b = $1742e55f55c10e98$var$Mg;
        if (b) {
            var c = b;
            if (!$1742e55f55c10e98$var$Qg(a, b)) {
                if ($1742e55f55c10e98$var$Rg(a)) throw Error($1742e55f55c10e98$var$p(418));
                b = $1742e55f55c10e98$var$Zf(c.nextSibling);
                var d = $1742e55f55c10e98$var$Lg;
                b && $1742e55f55c10e98$var$Qg(a, b) ? $1742e55f55c10e98$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $1742e55f55c10e98$var$J = !1, $1742e55f55c10e98$var$Lg = a);
            }
        } else {
            if ($1742e55f55c10e98$var$Rg(a)) throw Error($1742e55f55c10e98$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $1742e55f55c10e98$var$J = !1;
            $1742e55f55c10e98$var$Lg = a;
        }
    }
}
function $1742e55f55c10e98$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $1742e55f55c10e98$var$Lg = a;
}
function $1742e55f55c10e98$var$Ug(a) {
    if (a !== $1742e55f55c10e98$var$Lg) return !1;
    if (!$1742e55f55c10e98$var$J) return $1742e55f55c10e98$var$Tg(a), $1742e55f55c10e98$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$1742e55f55c10e98$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $1742e55f55c10e98$var$Mg)) {
        if ($1742e55f55c10e98$var$Rg(a)) throw $1742e55f55c10e98$var$Vg(), Error($1742e55f55c10e98$var$p(418));
        for(; b;)$1742e55f55c10e98$var$Og(a, b), b = $1742e55f55c10e98$var$Zf(b.nextSibling);
    }
    $1742e55f55c10e98$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($1742e55f55c10e98$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $1742e55f55c10e98$var$Mg = $1742e55f55c10e98$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $1742e55f55c10e98$var$Mg = null;
        }
    } else $1742e55f55c10e98$var$Mg = $1742e55f55c10e98$var$Lg ? $1742e55f55c10e98$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $1742e55f55c10e98$var$Vg() {
    for(var a = $1742e55f55c10e98$var$Mg; a;)a = $1742e55f55c10e98$var$Zf(a.nextSibling);
}
function $1742e55f55c10e98$var$Wg() {
    $1742e55f55c10e98$var$Mg = $1742e55f55c10e98$var$Lg = null;
    $1742e55f55c10e98$var$J = !1;
}
function $1742e55f55c10e98$var$Xg(a) {
    null === $1742e55f55c10e98$var$Ng ? $1742e55f55c10e98$var$Ng = [
        a
    ] : $1742e55f55c10e98$var$Ng.push(a);
}
var $1742e55f55c10e98$var$Yg = $1742e55f55c10e98$var$va.ReactCurrentBatchConfig;
function $1742e55f55c10e98$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($1742e55f55c10e98$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($1742e55f55c10e98$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($1742e55f55c10e98$var$p(284));
        if (!c._owner) throw Error($1742e55f55c10e98$var$p(290, a));
    }
    return a;
}
function $1742e55f55c10e98$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($1742e55f55c10e98$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $1742e55f55c10e98$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $1742e55f55c10e98$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $1742e55f55c10e98$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $1742e55f55c10e98$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $1742e55f55c10e98$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $1742e55f55c10e98$var$Ha && $1742e55f55c10e98$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $1742e55f55c10e98$var$Zg(a, b, c), d.return = a, d;
        d = $1742e55f55c10e98$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $1742e55f55c10e98$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $1742e55f55c10e98$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $1742e55f55c10e98$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $1742e55f55c10e98$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $1742e55f55c10e98$var$wa:
                    return c = $1742e55f55c10e98$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $1742e55f55c10e98$var$Zg(a, null, b), c.return = a, c;
                case $1742e55f55c10e98$var$xa:
                    return b = $1742e55f55c10e98$var$fh(b, a.mode, c), b.return = a, b;
                case $1742e55f55c10e98$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($1742e55f55c10e98$var$db(b) || $1742e55f55c10e98$var$Ka(b)) return b = $1742e55f55c10e98$var$gh(b, a.mode, c, null), b.return = a, b;
            $1742e55f55c10e98$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $1742e55f55c10e98$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $1742e55f55c10e98$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $1742e55f55c10e98$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($1742e55f55c10e98$var$db(c) || $1742e55f55c10e98$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $1742e55f55c10e98$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $1742e55f55c10e98$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $1742e55f55c10e98$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $1742e55f55c10e98$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($1742e55f55c10e98$var$db(d) || $1742e55f55c10e98$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $1742e55f55c10e98$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $1742e55f55c10e98$var$J && $1742e55f55c10e98$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $1742e55f55c10e98$var$J && $1742e55f55c10e98$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $1742e55f55c10e98$var$J && $1742e55f55c10e98$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $1742e55f55c10e98$var$Ka(h);
        if ("function" !== typeof l) throw Error($1742e55f55c10e98$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($1742e55f55c10e98$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $1742e55f55c10e98$var$J && $1742e55f55c10e98$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $1742e55f55c10e98$var$J && $1742e55f55c10e98$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $1742e55f55c10e98$var$J && $1742e55f55c10e98$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $1742e55f55c10e98$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $1742e55f55c10e98$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $1742e55f55c10e98$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $1742e55f55c10e98$var$Ha && $1742e55f55c10e98$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $1742e55f55c10e98$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $1742e55f55c10e98$var$ya ? (d = $1742e55f55c10e98$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $1742e55f55c10e98$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $1742e55f55c10e98$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $1742e55f55c10e98$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $1742e55f55c10e98$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $1742e55f55c10e98$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($1742e55f55c10e98$var$db(f)) return m(a, d, f, h);
            if ($1742e55f55c10e98$var$Ka(f)) return w(a, d, f, h);
            $1742e55f55c10e98$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $1742e55f55c10e98$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $1742e55f55c10e98$var$hh = $1742e55f55c10e98$var$bh(!0), $1742e55f55c10e98$var$ih = $1742e55f55c10e98$var$bh(!1), $1742e55f55c10e98$var$jh = $1742e55f55c10e98$var$hg(null), $1742e55f55c10e98$var$kh = null, $1742e55f55c10e98$var$lh = null, $1742e55f55c10e98$var$mh = null;
function $1742e55f55c10e98$var$nh() {
    $1742e55f55c10e98$var$mh = $1742e55f55c10e98$var$lh = $1742e55f55c10e98$var$kh = null;
}
function $1742e55f55c10e98$var$oh(a) {
    var b = $1742e55f55c10e98$var$jh.current;
    $1742e55f55c10e98$var$G($1742e55f55c10e98$var$jh);
    a._currentValue = b;
}
function $1742e55f55c10e98$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $1742e55f55c10e98$var$qh(a, b) {
    $1742e55f55c10e98$var$kh = a;
    $1742e55f55c10e98$var$mh = $1742e55f55c10e98$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($1742e55f55c10e98$var$rh = !0), a.firstContext = null);
}
function $1742e55f55c10e98$var$sh(a) {
    var b = a._currentValue;
    if ($1742e55f55c10e98$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $1742e55f55c10e98$var$lh) {
            if (null === $1742e55f55c10e98$var$kh) throw Error($1742e55f55c10e98$var$p(308));
            $1742e55f55c10e98$var$lh = a;
            $1742e55f55c10e98$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $1742e55f55c10e98$var$lh = $1742e55f55c10e98$var$lh.next = a;
    }
    return b;
}
var $1742e55f55c10e98$var$th = null;
function $1742e55f55c10e98$var$uh(a) {
    null === $1742e55f55c10e98$var$th ? $1742e55f55c10e98$var$th = [
        a
    ] : $1742e55f55c10e98$var$th.push(a);
}
function $1742e55f55c10e98$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $1742e55f55c10e98$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $1742e55f55c10e98$var$wh(a, d);
}
function $1742e55f55c10e98$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $1742e55f55c10e98$var$xh = !1;
function $1742e55f55c10e98$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $1742e55f55c10e98$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $1742e55f55c10e98$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $1742e55f55c10e98$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($1742e55f55c10e98$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $1742e55f55c10e98$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $1742e55f55c10e98$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $1742e55f55c10e98$var$wh(a, c);
}
function $1742e55f55c10e98$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $1742e55f55c10e98$var$Oc(a, c);
    }
}
function $1742e55f55c10e98$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $1742e55f55c10e98$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $1742e55f55c10e98$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $1742e55f55c10e98$var$u({}, q, r);
                            break a;
                        case 2:
                            $1742e55f55c10e98$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $1742e55f55c10e98$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $1742e55f55c10e98$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($1742e55f55c10e98$var$p(191, e));
            e.call(d);
        }
    }
}
var $1742e55f55c10e98$var$Hh = {}, $1742e55f55c10e98$var$Ih = $1742e55f55c10e98$var$hg($1742e55f55c10e98$var$Hh), $1742e55f55c10e98$var$Jh = $1742e55f55c10e98$var$hg($1742e55f55c10e98$var$Hh), $1742e55f55c10e98$var$Kh = $1742e55f55c10e98$var$hg($1742e55f55c10e98$var$Hh);
function $1742e55f55c10e98$var$Lh(a) {
    if (a === $1742e55f55c10e98$var$Hh) throw Error($1742e55f55c10e98$var$p(174));
    return a;
}
function $1742e55f55c10e98$var$Mh(a, b) {
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$Kh, b);
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$Jh, a);
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$Ih, $1742e55f55c10e98$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $1742e55f55c10e98$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $1742e55f55c10e98$var$kb(b, a);
    }
    $1742e55f55c10e98$var$G($1742e55f55c10e98$var$Ih);
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$Ih, b);
}
function $1742e55f55c10e98$var$Nh() {
    $1742e55f55c10e98$var$G($1742e55f55c10e98$var$Ih);
    $1742e55f55c10e98$var$G($1742e55f55c10e98$var$Jh);
    $1742e55f55c10e98$var$G($1742e55f55c10e98$var$Kh);
}
function $1742e55f55c10e98$var$Oh(a) {
    $1742e55f55c10e98$var$Lh($1742e55f55c10e98$var$Kh.current);
    var b = $1742e55f55c10e98$var$Lh($1742e55f55c10e98$var$Ih.current);
    var c = $1742e55f55c10e98$var$kb(b, a.type);
    b !== c && ($1742e55f55c10e98$var$H($1742e55f55c10e98$var$Jh, a), $1742e55f55c10e98$var$H($1742e55f55c10e98$var$Ih, c));
}
function $1742e55f55c10e98$var$Ph(a) {
    $1742e55f55c10e98$var$Jh.current === a && ($1742e55f55c10e98$var$G($1742e55f55c10e98$var$Ih), $1742e55f55c10e98$var$G($1742e55f55c10e98$var$Jh));
}
var $1742e55f55c10e98$var$L = $1742e55f55c10e98$var$hg(0);
function $1742e55f55c10e98$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $1742e55f55c10e98$var$Rh = [];
function $1742e55f55c10e98$var$Sh() {
    for(var a = 0; a < $1742e55f55c10e98$var$Rh.length; a++)$1742e55f55c10e98$var$Rh[a]._workInProgressVersionPrimary = null;
    $1742e55f55c10e98$var$Rh.length = 0;
}
var $1742e55f55c10e98$var$Th = $1742e55f55c10e98$var$va.ReactCurrentDispatcher, $1742e55f55c10e98$var$Uh = $1742e55f55c10e98$var$va.ReactCurrentBatchConfig, $1742e55f55c10e98$var$Vh = 0, $1742e55f55c10e98$var$M = null, $1742e55f55c10e98$var$N = null, $1742e55f55c10e98$var$O = null, $1742e55f55c10e98$var$Wh = !1, $1742e55f55c10e98$var$Xh = !1, $1742e55f55c10e98$var$Yh = 0, $1742e55f55c10e98$var$Zh = 0;
function $1742e55f55c10e98$var$P() {
    throw Error($1742e55f55c10e98$var$p(321));
}
function $1742e55f55c10e98$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$1742e55f55c10e98$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $1742e55f55c10e98$var$ai(a, b, c, d, e, f) {
    $1742e55f55c10e98$var$Vh = f;
    $1742e55f55c10e98$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $1742e55f55c10e98$var$Th.current = null === a || null === a.memoizedState ? $1742e55f55c10e98$var$bi : $1742e55f55c10e98$var$ci;
    a = c(d, e);
    if ($1742e55f55c10e98$var$Xh) {
        f = 0;
        do {
            $1742e55f55c10e98$var$Xh = !1;
            $1742e55f55c10e98$var$Yh = 0;
            if (25 <= f) throw Error($1742e55f55c10e98$var$p(301));
            f += 1;
            $1742e55f55c10e98$var$O = $1742e55f55c10e98$var$N = null;
            b.updateQueue = null;
            $1742e55f55c10e98$var$Th.current = $1742e55f55c10e98$var$di;
            a = c(d, e);
        }while ($1742e55f55c10e98$var$Xh);
    }
    $1742e55f55c10e98$var$Th.current = $1742e55f55c10e98$var$ei;
    b = null !== $1742e55f55c10e98$var$N && null !== $1742e55f55c10e98$var$N.next;
    $1742e55f55c10e98$var$Vh = 0;
    $1742e55f55c10e98$var$O = $1742e55f55c10e98$var$N = $1742e55f55c10e98$var$M = null;
    $1742e55f55c10e98$var$Wh = !1;
    if (b) throw Error($1742e55f55c10e98$var$p(300));
    return a;
}
function $1742e55f55c10e98$var$fi() {
    var a = 0 !== $1742e55f55c10e98$var$Yh;
    $1742e55f55c10e98$var$Yh = 0;
    return a;
}
function $1742e55f55c10e98$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $1742e55f55c10e98$var$O ? $1742e55f55c10e98$var$M.memoizedState = $1742e55f55c10e98$var$O = a : $1742e55f55c10e98$var$O = $1742e55f55c10e98$var$O.next = a;
    return $1742e55f55c10e98$var$O;
}
function $1742e55f55c10e98$var$hi() {
    if (null === $1742e55f55c10e98$var$N) {
        var a = $1742e55f55c10e98$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $1742e55f55c10e98$var$N.next;
    var b = null === $1742e55f55c10e98$var$O ? $1742e55f55c10e98$var$M.memoizedState : $1742e55f55c10e98$var$O.next;
    if (null !== b) $1742e55f55c10e98$var$O = b, $1742e55f55c10e98$var$N = a;
    else {
        if (null === a) throw Error($1742e55f55c10e98$var$p(310));
        $1742e55f55c10e98$var$N = a;
        a = {
            memoizedState: $1742e55f55c10e98$var$N.memoizedState,
            baseState: $1742e55f55c10e98$var$N.baseState,
            baseQueue: $1742e55f55c10e98$var$N.baseQueue,
            queue: $1742e55f55c10e98$var$N.queue,
            next: null
        };
        null === $1742e55f55c10e98$var$O ? $1742e55f55c10e98$var$M.memoizedState = $1742e55f55c10e98$var$O = a : $1742e55f55c10e98$var$O = $1742e55f55c10e98$var$O.next = a;
    }
    return $1742e55f55c10e98$var$O;
}
function $1742e55f55c10e98$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $1742e55f55c10e98$var$ji(a) {
    var b = $1742e55f55c10e98$var$hi(), c = b.queue;
    if (null === c) throw Error($1742e55f55c10e98$var$p(311));
    c.lastRenderedReducer = a;
    var d = $1742e55f55c10e98$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($1742e55f55c10e98$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $1742e55f55c10e98$var$M.lanes |= n;
                $1742e55f55c10e98$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $1742e55f55c10e98$var$Ve(d, b.memoizedState) || ($1742e55f55c10e98$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $1742e55f55c10e98$var$M.lanes |= f, $1742e55f55c10e98$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $1742e55f55c10e98$var$ki(a) {
    var b = $1742e55f55c10e98$var$hi(), c = b.queue;
    if (null === c) throw Error($1742e55f55c10e98$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $1742e55f55c10e98$var$Ve(f, b.memoizedState) || ($1742e55f55c10e98$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $1742e55f55c10e98$var$li() {}
function $1742e55f55c10e98$var$mi(a, b) {
    var c = $1742e55f55c10e98$var$M, d = $1742e55f55c10e98$var$hi(), e = b(), f = !$1742e55f55c10e98$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $1742e55f55c10e98$var$rh = !0);
    d = d.queue;
    $1742e55f55c10e98$var$ni($1742e55f55c10e98$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $1742e55f55c10e98$var$O && $1742e55f55c10e98$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $1742e55f55c10e98$var$pi(9, $1742e55f55c10e98$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $1742e55f55c10e98$var$Q) throw Error($1742e55f55c10e98$var$p(349));
        0 !== ($1742e55f55c10e98$var$Vh & 30) || $1742e55f55c10e98$var$ri(c, b, e);
    }
    return e;
}
function $1742e55f55c10e98$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $1742e55f55c10e98$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $1742e55f55c10e98$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $1742e55f55c10e98$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $1742e55f55c10e98$var$si(b) && $1742e55f55c10e98$var$ti(a);
}
function $1742e55f55c10e98$var$oi(a, b, c) {
    return c(function() {
        $1742e55f55c10e98$var$si(b) && $1742e55f55c10e98$var$ti(a);
    });
}
function $1742e55f55c10e98$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$1742e55f55c10e98$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $1742e55f55c10e98$var$ti(a) {
    var b = $1742e55f55c10e98$var$wh(a, 1);
    null !== b && $1742e55f55c10e98$var$ui(b, a, 1, -1);
}
function $1742e55f55c10e98$var$vi(a) {
    var b = $1742e55f55c10e98$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $1742e55f55c10e98$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $1742e55f55c10e98$var$wi.bind(null, $1742e55f55c10e98$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $1742e55f55c10e98$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $1742e55f55c10e98$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $1742e55f55c10e98$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $1742e55f55c10e98$var$xi() {
    return $1742e55f55c10e98$var$hi().memoizedState;
}
function $1742e55f55c10e98$var$Ai(a, b, c, d) {
    var e = $1742e55f55c10e98$var$gi();
    $1742e55f55c10e98$var$M.flags |= a;
    e.memoizedState = $1742e55f55c10e98$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $1742e55f55c10e98$var$Bi(a, b, c, d) {
    var e = $1742e55f55c10e98$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $1742e55f55c10e98$var$N) {
        var g = $1742e55f55c10e98$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $1742e55f55c10e98$var$$h(d, g.deps)) {
            e.memoizedState = $1742e55f55c10e98$var$pi(b, c, f, d);
            return;
        }
    }
    $1742e55f55c10e98$var$M.flags |= a;
    e.memoizedState = $1742e55f55c10e98$var$pi(1 | b, c, f, d);
}
function $1742e55f55c10e98$var$Ci(a, b) {
    return $1742e55f55c10e98$var$Ai(8390656, 8, a, b);
}
function $1742e55f55c10e98$var$ni(a, b) {
    return $1742e55f55c10e98$var$Bi(2048, 8, a, b);
}
function $1742e55f55c10e98$var$Di(a, b) {
    return $1742e55f55c10e98$var$Bi(4, 2, a, b);
}
function $1742e55f55c10e98$var$Ei(a, b) {
    return $1742e55f55c10e98$var$Bi(4, 4, a, b);
}
function $1742e55f55c10e98$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $1742e55f55c10e98$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $1742e55f55c10e98$var$Bi(4, 4, $1742e55f55c10e98$var$Fi.bind(null, b, a), c);
}
function $1742e55f55c10e98$var$Hi() {}
function $1742e55f55c10e98$var$Ii(a, b) {
    var c = $1742e55f55c10e98$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $1742e55f55c10e98$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $1742e55f55c10e98$var$Ji(a, b) {
    var c = $1742e55f55c10e98$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $1742e55f55c10e98$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $1742e55f55c10e98$var$Ki(a, b, c) {
    if (0 === ($1742e55f55c10e98$var$Vh & 21)) return a.baseState && (a.baseState = !1, $1742e55f55c10e98$var$rh = !0), a.memoizedState = c;
    $1742e55f55c10e98$var$Ve(c, b) || (c = $1742e55f55c10e98$var$Kc(), $1742e55f55c10e98$var$M.lanes |= c, $1742e55f55c10e98$var$Fh |= c, a.baseState = !0);
    return b;
}
function $1742e55f55c10e98$var$Li(a, b) {
    var c = $1742e55f55c10e98$var$E;
    $1742e55f55c10e98$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $1742e55f55c10e98$var$Uh.transition;
    $1742e55f55c10e98$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $1742e55f55c10e98$var$E = c, $1742e55f55c10e98$var$Uh.transition = d;
    }
}
function $1742e55f55c10e98$var$Mi() {
    return $1742e55f55c10e98$var$hi().memoizedState;
}
function $1742e55f55c10e98$var$Ni(a, b, c) {
    var d = $1742e55f55c10e98$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($1742e55f55c10e98$var$Pi(a)) $1742e55f55c10e98$var$Qi(b, c);
    else if (c = $1742e55f55c10e98$var$vh(a, b, c, d), null !== c) {
        var e = $1742e55f55c10e98$var$Ri();
        $1742e55f55c10e98$var$ui(c, a, d, e);
        $1742e55f55c10e98$var$Si(c, b, d);
    }
    $1742e55f55c10e98$var$yc(a, d);
}
function $1742e55f55c10e98$var$wi(a, b, c) {
    var d = $1742e55f55c10e98$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($1742e55f55c10e98$var$Pi(a)) $1742e55f55c10e98$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($1742e55f55c10e98$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $1742e55f55c10e98$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $1742e55f55c10e98$var$vh(a, b, e, d);
        null !== c && (e = $1742e55f55c10e98$var$Ri(), $1742e55f55c10e98$var$ui(c, a, d, e), $1742e55f55c10e98$var$Si(c, b, d));
    }
    $1742e55f55c10e98$var$yc(a, d);
}
function $1742e55f55c10e98$var$Pi(a) {
    var b = a.alternate;
    return a === $1742e55f55c10e98$var$M || null !== b && b === $1742e55f55c10e98$var$M;
}
function $1742e55f55c10e98$var$Qi(a, b) {
    $1742e55f55c10e98$var$Xh = $1742e55f55c10e98$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $1742e55f55c10e98$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $1742e55f55c10e98$var$Oc(a, c);
    }
}
var $1742e55f55c10e98$var$ei = {
    readContext: $1742e55f55c10e98$var$sh,
    useCallback: $1742e55f55c10e98$var$P,
    useContext: $1742e55f55c10e98$var$P,
    useEffect: $1742e55f55c10e98$var$P,
    useImperativeHandle: $1742e55f55c10e98$var$P,
    useInsertionEffect: $1742e55f55c10e98$var$P,
    useLayoutEffect: $1742e55f55c10e98$var$P,
    useMemo: $1742e55f55c10e98$var$P,
    useReducer: $1742e55f55c10e98$var$P,
    useRef: $1742e55f55c10e98$var$P,
    useState: $1742e55f55c10e98$var$P,
    useDebugValue: $1742e55f55c10e98$var$P,
    useDeferredValue: $1742e55f55c10e98$var$P,
    useTransition: $1742e55f55c10e98$var$P,
    useMutableSource: $1742e55f55c10e98$var$P,
    useSyncExternalStore: $1742e55f55c10e98$var$P,
    useId: $1742e55f55c10e98$var$P,
    unstable_isNewReconciler: !1
}, $1742e55f55c10e98$var$bi = {
    readContext: $1742e55f55c10e98$var$sh,
    useCallback: function(a, b) {
        $1742e55f55c10e98$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $1742e55f55c10e98$var$sh,
    useEffect: $1742e55f55c10e98$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $1742e55f55c10e98$var$Ai(4194308, 4, $1742e55f55c10e98$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $1742e55f55c10e98$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $1742e55f55c10e98$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $1742e55f55c10e98$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $1742e55f55c10e98$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $1742e55f55c10e98$var$Ni.bind(null, $1742e55f55c10e98$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $1742e55f55c10e98$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $1742e55f55c10e98$var$vi,
    useDebugValue: $1742e55f55c10e98$var$Hi,
    useDeferredValue: function(a) {
        return $1742e55f55c10e98$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $1742e55f55c10e98$var$vi(!1), b = a[0];
        a = $1742e55f55c10e98$var$Li.bind(null, a[1]);
        $1742e55f55c10e98$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $1742e55f55c10e98$var$M, e = $1742e55f55c10e98$var$gi();
        if ($1742e55f55c10e98$var$J) {
            if (void 0 === c) throw Error($1742e55f55c10e98$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $1742e55f55c10e98$var$Q) throw Error($1742e55f55c10e98$var$p(349));
            0 !== ($1742e55f55c10e98$var$Vh & 30) || $1742e55f55c10e98$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $1742e55f55c10e98$var$Ci($1742e55f55c10e98$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $1742e55f55c10e98$var$pi(9, $1742e55f55c10e98$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $1742e55f55c10e98$var$gi(), b = $1742e55f55c10e98$var$Q.identifierPrefix;
        if ($1742e55f55c10e98$var$J) {
            var c = $1742e55f55c10e98$var$Gg;
            var d = $1742e55f55c10e98$var$Fg;
            c = (d & ~(1 << 32 - $1742e55f55c10e98$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $1742e55f55c10e98$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $1742e55f55c10e98$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $1742e55f55c10e98$var$ci = {
    readContext: $1742e55f55c10e98$var$sh,
    useCallback: $1742e55f55c10e98$var$Ii,
    useContext: $1742e55f55c10e98$var$sh,
    useEffect: $1742e55f55c10e98$var$ni,
    useImperativeHandle: $1742e55f55c10e98$var$Gi,
    useInsertionEffect: $1742e55f55c10e98$var$Di,
    useLayoutEffect: $1742e55f55c10e98$var$Ei,
    useMemo: $1742e55f55c10e98$var$Ji,
    useReducer: $1742e55f55c10e98$var$ji,
    useRef: $1742e55f55c10e98$var$xi,
    useState: function() {
        return $1742e55f55c10e98$var$ji($1742e55f55c10e98$var$ii);
    },
    useDebugValue: $1742e55f55c10e98$var$Hi,
    useDeferredValue: function(a) {
        var b = $1742e55f55c10e98$var$hi();
        return $1742e55f55c10e98$var$Ki(b, $1742e55f55c10e98$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $1742e55f55c10e98$var$ji($1742e55f55c10e98$var$ii)[0], b = $1742e55f55c10e98$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $1742e55f55c10e98$var$li,
    useSyncExternalStore: $1742e55f55c10e98$var$mi,
    useId: $1742e55f55c10e98$var$Mi,
    unstable_isNewReconciler: !1
}, $1742e55f55c10e98$var$di = {
    readContext: $1742e55f55c10e98$var$sh,
    useCallback: $1742e55f55c10e98$var$Ii,
    useContext: $1742e55f55c10e98$var$sh,
    useEffect: $1742e55f55c10e98$var$ni,
    useImperativeHandle: $1742e55f55c10e98$var$Gi,
    useInsertionEffect: $1742e55f55c10e98$var$Di,
    useLayoutEffect: $1742e55f55c10e98$var$Ei,
    useMemo: $1742e55f55c10e98$var$Ji,
    useReducer: $1742e55f55c10e98$var$ki,
    useRef: $1742e55f55c10e98$var$xi,
    useState: function() {
        return $1742e55f55c10e98$var$ki($1742e55f55c10e98$var$ii);
    },
    useDebugValue: $1742e55f55c10e98$var$Hi,
    useDeferredValue: function(a) {
        var b = $1742e55f55c10e98$var$hi();
        return null === $1742e55f55c10e98$var$N ? b.memoizedState = a : $1742e55f55c10e98$var$Ki(b, $1742e55f55c10e98$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $1742e55f55c10e98$var$ki($1742e55f55c10e98$var$ii)[0], b = $1742e55f55c10e98$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $1742e55f55c10e98$var$li,
    useSyncExternalStore: $1742e55f55c10e98$var$mi,
    useId: $1742e55f55c10e98$var$Mi,
    unstable_isNewReconciler: !1
}, $1742e55f55c10e98$var$Ti = $gEGs3.unstable_now, $1742e55f55c10e98$var$Ui = 0, $1742e55f55c10e98$var$Vi = -1, $1742e55f55c10e98$var$Wi = -1, $1742e55f55c10e98$var$Xi = -1, $1742e55f55c10e98$var$Yi = !1, $1742e55f55c10e98$var$Zi = !1;
function $1742e55f55c10e98$var$$i(a, b) {
    if (0 <= $1742e55f55c10e98$var$Wi) {
        var c = $1742e55f55c10e98$var$Ti() - $1742e55f55c10e98$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $1742e55f55c10e98$var$Wi = -1;
    }
}
function $1742e55f55c10e98$var$aj(a) {
    if (0 <= $1742e55f55c10e98$var$Vi) {
        var b = $1742e55f55c10e98$var$Ti() - $1742e55f55c10e98$var$Vi;
        $1742e55f55c10e98$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $1742e55f55c10e98$var$bj(a) {
    if (0 <= $1742e55f55c10e98$var$Xi) {
        var b = $1742e55f55c10e98$var$Ti() - $1742e55f55c10e98$var$Xi;
        $1742e55f55c10e98$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $1742e55f55c10e98$var$cj() {
    $1742e55f55c10e98$var$Vi = $1742e55f55c10e98$var$Ti();
}
function $1742e55f55c10e98$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $1742e55f55c10e98$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $1742e55f55c10e98$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $1742e55f55c10e98$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $1742e55f55c10e98$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $1742e55f55c10e98$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $1742e55f55c10e98$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $1742e55f55c10e98$var$Ri(), e = $1742e55f55c10e98$var$Oi(a), f = $1742e55f55c10e98$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $1742e55f55c10e98$var$Bh(a, f, e);
        null !== b && ($1742e55f55c10e98$var$ui(b, a, e, d), $1742e55f55c10e98$var$Ch(b, a, e));
        $1742e55f55c10e98$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $1742e55f55c10e98$var$Ri(), e = $1742e55f55c10e98$var$Oi(a), f = $1742e55f55c10e98$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $1742e55f55c10e98$var$Bh(a, f, e);
        null !== b && ($1742e55f55c10e98$var$ui(b, a, e, d), $1742e55f55c10e98$var$Ch(b, a, e));
        $1742e55f55c10e98$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $1742e55f55c10e98$var$Ri(), d = $1742e55f55c10e98$var$Oi(a), e = $1742e55f55c10e98$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $1742e55f55c10e98$var$Bh(a, e, d);
        null !== b && ($1742e55f55c10e98$var$ui(b, a, d, c), $1742e55f55c10e98$var$Ch(b, a, d));
        null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markForceUpdateScheduled && $1742e55f55c10e98$var$B.markForceUpdateScheduled(a, d);
    }
};
function $1742e55f55c10e98$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$1742e55f55c10e98$var$We(c, d) || !$1742e55f55c10e98$var$We(e, f) : !0;
}
function $1742e55f55c10e98$var$ij(a, b, c) {
    var d = !1, e = $1742e55f55c10e98$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $1742e55f55c10e98$var$sh(f) : (e = $1742e55f55c10e98$var$mg(b) ? $1742e55f55c10e98$var$kg : $1742e55f55c10e98$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $1742e55f55c10e98$var$lg(a, e) : $1742e55f55c10e98$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $1742e55f55c10e98$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $1742e55f55c10e98$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $1742e55f55c10e98$var$gj.enqueueReplaceState(b, b.state, null);
}
function $1742e55f55c10e98$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $1742e55f55c10e98$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $1742e55f55c10e98$var$sh(f) : (f = $1742e55f55c10e98$var$mg(b) ? $1742e55f55c10e98$var$kg : $1742e55f55c10e98$var$I.current, e.context = $1742e55f55c10e98$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($1742e55f55c10e98$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $1742e55f55c10e98$var$gj.enqueueReplaceState(e, e.state, null), $1742e55f55c10e98$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $1742e55f55c10e98$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $1742e55f55c10e98$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $1742e55f55c10e98$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $1742e55f55c10e98$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $1742e55f55c10e98$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $1742e55f55c10e98$var$pj(a, b, c) {
    c = $1742e55f55c10e98$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $1742e55f55c10e98$var$qj || ($1742e55f55c10e98$var$qj = !0, $1742e55f55c10e98$var$rj = d);
        $1742e55f55c10e98$var$nj(a, b);
    };
    return c;
}
function $1742e55f55c10e98$var$sj(a, b, c) {
    c = $1742e55f55c10e98$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $1742e55f55c10e98$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $1742e55f55c10e98$var$nj(a, b);
        "function" !== typeof d && (null === $1742e55f55c10e98$var$tj ? $1742e55f55c10e98$var$tj = new Set([
            this
        ]) : $1742e55f55c10e98$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $1742e55f55c10e98$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $1742e55f55c10e98$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $1742e55f55c10e98$var$vj.bind(null, a, b, c), $1742e55f55c10e98$var$mc && $1742e55f55c10e98$var$wj(a, c), b.then(d, d));
}
function $1742e55f55c10e98$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $1742e55f55c10e98$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $1742e55f55c10e98$var$Ah(-1, 1), b.tag = 2, $1742e55f55c10e98$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $1742e55f55c10e98$var$zj = $1742e55f55c10e98$var$va.ReactCurrentOwner, $1742e55f55c10e98$var$rh = !1;
function $1742e55f55c10e98$var$Aj(a, b, c, d) {
    b.child = null === a ? $1742e55f55c10e98$var$ih(b, null, c, d) : $1742e55f55c10e98$var$hh(b, a.child, c, d);
}
function $1742e55f55c10e98$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $1742e55f55c10e98$var$qh(b, e);
    $1742e55f55c10e98$var$sc(b);
    d = $1742e55f55c10e98$var$ai(a, b, c, d, f, e);
    c = $1742e55f55c10e98$var$fi();
    $1742e55f55c10e98$var$tc();
    if (null !== a && !$1742e55f55c10e98$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $1742e55f55c10e98$var$Cj(a, b, e);
    $1742e55f55c10e98$var$J && c && $1742e55f55c10e98$var$Jg(b);
    b.flags |= 1;
    $1742e55f55c10e98$var$Aj(a, b, d, e);
    return b.child;
}
function $1742e55f55c10e98$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$1742e55f55c10e98$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $1742e55f55c10e98$var$Fj(a, b, f, d, e);
        a = $1742e55f55c10e98$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $1742e55f55c10e98$var$We;
        if (c(g, d) && a.ref === b.ref) return $1742e55f55c10e98$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $1742e55f55c10e98$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $1742e55f55c10e98$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($1742e55f55c10e98$var$We(f, d) && a.ref === b.ref) {
            if ($1742e55f55c10e98$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($1742e55f55c10e98$var$rh = !0);
            else return b.lanes = a.lanes, $1742e55f55c10e98$var$Cj(a, b, e);
        }
    }
    return $1742e55f55c10e98$var$Gj(a, b, c, d, e);
}
function $1742e55f55c10e98$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $1742e55f55c10e98$var$H($1742e55f55c10e98$var$Ij, $1742e55f55c10e98$var$Jj), $1742e55f55c10e98$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $1742e55f55c10e98$var$H($1742e55f55c10e98$var$Ij, $1742e55f55c10e98$var$Jj), $1742e55f55c10e98$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $1742e55f55c10e98$var$H($1742e55f55c10e98$var$Ij, $1742e55f55c10e98$var$Jj);
            $1742e55f55c10e98$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $1742e55f55c10e98$var$H($1742e55f55c10e98$var$Ij, $1742e55f55c10e98$var$Jj), $1742e55f55c10e98$var$Jj |= d;
    $1742e55f55c10e98$var$Aj(a, b, e, c);
    return b.child;
}
function $1742e55f55c10e98$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $1742e55f55c10e98$var$Gj(a, b, c, d, e) {
    var f = $1742e55f55c10e98$var$mg(c) ? $1742e55f55c10e98$var$kg : $1742e55f55c10e98$var$I.current;
    f = $1742e55f55c10e98$var$lg(b, f);
    $1742e55f55c10e98$var$qh(b, e);
    $1742e55f55c10e98$var$sc(b);
    c = $1742e55f55c10e98$var$ai(a, b, c, d, f, e);
    d = $1742e55f55c10e98$var$fi();
    $1742e55f55c10e98$var$tc();
    if (null !== a && !$1742e55f55c10e98$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $1742e55f55c10e98$var$Cj(a, b, e);
    $1742e55f55c10e98$var$J && d && $1742e55f55c10e98$var$Jg(b);
    b.flags |= 1;
    $1742e55f55c10e98$var$Aj(a, b, c, e);
    return b.child;
}
function $1742e55f55c10e98$var$Lj(a, b, c, d, e) {
    if ($1742e55f55c10e98$var$mg(c)) {
        var f = !0;
        $1742e55f55c10e98$var$qg(b);
    } else f = !1;
    $1742e55f55c10e98$var$qh(b, e);
    if (null === b.stateNode) $1742e55f55c10e98$var$Mj(a, b), $1742e55f55c10e98$var$ij(b, c, d), $1742e55f55c10e98$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $1742e55f55c10e98$var$sh(l) : (l = $1742e55f55c10e98$var$mg(c) ? $1742e55f55c10e98$var$kg : $1742e55f55c10e98$var$I.current, l = $1742e55f55c10e98$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $1742e55f55c10e98$var$jj(b, g, d, l);
        $1742e55f55c10e98$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $1742e55f55c10e98$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $1742e55f55c10e98$var$jg.current || $1742e55f55c10e98$var$xh ? ("function" === typeof n && ($1742e55f55c10e98$var$fj(b, c, n, d), k = b.memoizedState), (h = $1742e55f55c10e98$var$xh || $1742e55f55c10e98$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $1742e55f55c10e98$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $1742e55f55c10e98$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $1742e55f55c10e98$var$sh(k) : (k = $1742e55f55c10e98$var$mg(c) ? $1742e55f55c10e98$var$kg : $1742e55f55c10e98$var$I.current, k = $1742e55f55c10e98$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $1742e55f55c10e98$var$jj(b, g, d, k);
        $1742e55f55c10e98$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $1742e55f55c10e98$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $1742e55f55c10e98$var$jg.current || $1742e55f55c10e98$var$xh ? ("function" === typeof z && ($1742e55f55c10e98$var$fj(b, c, z, d), m = b.memoizedState), (l = $1742e55f55c10e98$var$xh || $1742e55f55c10e98$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $1742e55f55c10e98$var$Nj(a, b, c, d, f, e);
}
function $1742e55f55c10e98$var$Nj(a, b, c, d, e, f) {
    $1742e55f55c10e98$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $1742e55f55c10e98$var$rg(b, c, !1), $1742e55f55c10e98$var$Cj(a, b, f);
    d = b.stateNode;
    $1742e55f55c10e98$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $1742e55f55c10e98$var$Wi = -1;
    } else $1742e55f55c10e98$var$sc(b), h = d.render(), $1742e55f55c10e98$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $1742e55f55c10e98$var$hh(b, a.child, null, f), b.child = $1742e55f55c10e98$var$hh(b, null, g, f)) : $1742e55f55c10e98$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $1742e55f55c10e98$var$rg(b, c, !0);
    return b.child;
}
function $1742e55f55c10e98$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $1742e55f55c10e98$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $1742e55f55c10e98$var$og(a, b.context, !1);
    $1742e55f55c10e98$var$Mh(a, b.containerInfo);
}
function $1742e55f55c10e98$var$Rj(a, b, c, d, e) {
    $1742e55f55c10e98$var$Wg();
    $1742e55f55c10e98$var$Xg(e);
    b.flags |= 256;
    $1742e55f55c10e98$var$Aj(a, b, c, d);
    return b.child;
}
var $1742e55f55c10e98$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $1742e55f55c10e98$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $1742e55f55c10e98$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $1742e55f55c10e98$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$L, e & 1);
    if (null === a) {
        $1742e55f55c10e98$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $1742e55f55c10e98$var$Vj(g, d, 0, null), a = $1742e55f55c10e98$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $1742e55f55c10e98$var$Tj(c), b.memoizedState = $1742e55f55c10e98$var$Sj, a) : $1742e55f55c10e98$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $1742e55f55c10e98$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $1742e55f55c10e98$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $1742e55f55c10e98$var$ch(h, f) : (f = $1742e55f55c10e98$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $1742e55f55c10e98$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $1742e55f55c10e98$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $1742e55f55c10e98$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $1742e55f55c10e98$var$Wj(a, b) {
    b = $1742e55f55c10e98$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $1742e55f55c10e98$var$Yj(a, b, c, d) {
    null !== d && $1742e55f55c10e98$var$Xg(d);
    $1742e55f55c10e98$var$hh(b, a.child, null, c);
    a = $1742e55f55c10e98$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $1742e55f55c10e98$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $1742e55f55c10e98$var$mj(Error($1742e55f55c10e98$var$p(422))), $1742e55f55c10e98$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $1742e55f55c10e98$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $1742e55f55c10e98$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $1742e55f55c10e98$var$hh(b, a.child, null, g);
        b.child.memoizedState = $1742e55f55c10e98$var$Tj(g);
        b.memoizedState = $1742e55f55c10e98$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $1742e55f55c10e98$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($1742e55f55c10e98$var$p(419));
        d = $1742e55f55c10e98$var$mj(f, d, void 0);
        return $1742e55f55c10e98$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($1742e55f55c10e98$var$rh || h) {
        d = $1742e55f55c10e98$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $1742e55f55c10e98$var$wh(a, e), $1742e55f55c10e98$var$ui(d, a, e, -1));
        }
        $1742e55f55c10e98$var$Zj();
        d = $1742e55f55c10e98$var$mj(Error($1742e55f55c10e98$var$p(421)));
        return $1742e55f55c10e98$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $1742e55f55c10e98$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $1742e55f55c10e98$var$Mg = $1742e55f55c10e98$var$Zf(e.nextSibling);
    $1742e55f55c10e98$var$Lg = b;
    $1742e55f55c10e98$var$J = !0;
    $1742e55f55c10e98$var$Ng = null;
    null !== a && ($1742e55f55c10e98$var$Cg[$1742e55f55c10e98$var$Dg++] = $1742e55f55c10e98$var$Fg, $1742e55f55c10e98$var$Cg[$1742e55f55c10e98$var$Dg++] = $1742e55f55c10e98$var$Gg, $1742e55f55c10e98$var$Cg[$1742e55f55c10e98$var$Dg++] = $1742e55f55c10e98$var$Eg, $1742e55f55c10e98$var$Fg = a.id, $1742e55f55c10e98$var$Gg = a.overflow, $1742e55f55c10e98$var$Eg = b);
    b = $1742e55f55c10e98$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $1742e55f55c10e98$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $1742e55f55c10e98$var$ph(a.return, b, c);
}
function $1742e55f55c10e98$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $1742e55f55c10e98$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $1742e55f55c10e98$var$Aj(a, b, d.children, c);
    d = $1742e55f55c10e98$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $1742e55f55c10e98$var$bk(a, c, b);
            else if (19 === a.tag) $1742e55f55c10e98$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $1742e55f55c10e98$var$H($1742e55f55c10e98$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $1742e55f55c10e98$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $1742e55f55c10e98$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $1742e55f55c10e98$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $1742e55f55c10e98$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $1742e55f55c10e98$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $1742e55f55c10e98$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $1742e55f55c10e98$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $1742e55f55c10e98$var$Wi = -1;
    $1742e55f55c10e98$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($1742e55f55c10e98$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $1742e55f55c10e98$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $1742e55f55c10e98$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $1742e55f55c10e98$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $1742e55f55c10e98$var$Oj(b);
            $1742e55f55c10e98$var$Wg();
            break;
        case 5:
            $1742e55f55c10e98$var$Oh(b);
            break;
        case 1:
            $1742e55f55c10e98$var$mg(b.type) && $1742e55f55c10e98$var$qg(b);
            break;
        case 4:
            $1742e55f55c10e98$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $1742e55f55c10e98$var$H($1742e55f55c10e98$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $1742e55f55c10e98$var$H($1742e55f55c10e98$var$L, $1742e55f55c10e98$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $1742e55f55c10e98$var$Uj(a, b, c);
                $1742e55f55c10e98$var$H($1742e55f55c10e98$var$L, $1742e55f55c10e98$var$L.current & 1);
                a = $1742e55f55c10e98$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $1742e55f55c10e98$var$H($1742e55f55c10e98$var$L, $1742e55f55c10e98$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $1742e55f55c10e98$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $1742e55f55c10e98$var$H($1742e55f55c10e98$var$L, $1742e55f55c10e98$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $1742e55f55c10e98$var$Hj(a, b, c);
    }
    return $1742e55f55c10e98$var$Cj(a, b, c);
}
var $1742e55f55c10e98$var$fk, $1742e55f55c10e98$var$gk, $1742e55f55c10e98$var$hk, $1742e55f55c10e98$var$ik;
$1742e55f55c10e98$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$1742e55f55c10e98$var$gk = function() {};
$1742e55f55c10e98$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $1742e55f55c10e98$var$Lh($1742e55f55c10e98$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $1742e55f55c10e98$var$Ya(a, e);
                d = $1742e55f55c10e98$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $1742e55f55c10e98$var$u({}, e, {
                    value: void 0
                });
                d = $1742e55f55c10e98$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $1742e55f55c10e98$var$fb(a, e);
                d = $1742e55f55c10e98$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $1742e55f55c10e98$var$Pf);
        }
        $1742e55f55c10e98$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($1742e55f55c10e98$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($1742e55f55c10e98$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $1742e55f55c10e98$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$1742e55f55c10e98$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $1742e55f55c10e98$var$jk(a, b) {
    if (!$1742e55f55c10e98$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $1742e55f55c10e98$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $1742e55f55c10e98$var$kk(a, b, c) {
    var d = b.pendingProps;
    $1742e55f55c10e98$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $1742e55f55c10e98$var$S(b), null;
        case 1:
            return $1742e55f55c10e98$var$mg(b.type) && $1742e55f55c10e98$var$ng(), $1742e55f55c10e98$var$S(b), null;
        case 3:
            d = b.stateNode;
            $1742e55f55c10e98$var$Nh();
            $1742e55f55c10e98$var$G($1742e55f55c10e98$var$jg);
            $1742e55f55c10e98$var$G($1742e55f55c10e98$var$I);
            $1742e55f55c10e98$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $1742e55f55c10e98$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $1742e55f55c10e98$var$Ng && ($1742e55f55c10e98$var$lk($1742e55f55c10e98$var$Ng), $1742e55f55c10e98$var$Ng = null));
            $1742e55f55c10e98$var$gk(a, b);
            $1742e55f55c10e98$var$S(b);
            return null;
        case 5:
            $1742e55f55c10e98$var$Ph(b);
            var e = $1742e55f55c10e98$var$Lh($1742e55f55c10e98$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $1742e55f55c10e98$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($1742e55f55c10e98$var$p(166));
                    $1742e55f55c10e98$var$S(b);
                    return null;
                }
                a = $1742e55f55c10e98$var$Lh($1742e55f55c10e98$var$Ih.current);
                if ($1742e55f55c10e98$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$1742e55f55c10e98$var$bg] = b;
                    d[$1742e55f55c10e98$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $1742e55f55c10e98$var$F("cancel", d);
                            $1742e55f55c10e98$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $1742e55f55c10e98$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $1742e55f55c10e98$var$zf.length; e++)$1742e55f55c10e98$var$F($1742e55f55c10e98$var$zf[e], d);
                            break;
                        case "source":
                            $1742e55f55c10e98$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $1742e55f55c10e98$var$F("error", d);
                            $1742e55f55c10e98$var$F("load", d);
                            break;
                        case "details":
                            $1742e55f55c10e98$var$F("toggle", d);
                            break;
                        case "input":
                            $1742e55f55c10e98$var$Za(d, c);
                            $1742e55f55c10e98$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $1742e55f55c10e98$var$F("invalid", d);
                            break;
                        case "textarea":
                            $1742e55f55c10e98$var$gb(d, c), $1742e55f55c10e98$var$F("invalid", d);
                    }
                    $1742e55f55c10e98$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $1742e55f55c10e98$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $1742e55f55c10e98$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $1742e55f55c10e98$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $1742e55f55c10e98$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $1742e55f55c10e98$var$Va(d);
                            $1742e55f55c10e98$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $1742e55f55c10e98$var$Va(d);
                            $1742e55f55c10e98$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $1742e55f55c10e98$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $1742e55f55c10e98$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$1742e55f55c10e98$var$bg] = b;
                    a[$1742e55f55c10e98$var$cg] = d;
                    $1742e55f55c10e98$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $1742e55f55c10e98$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $1742e55f55c10e98$var$F("cancel", a);
                                $1742e55f55c10e98$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $1742e55f55c10e98$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $1742e55f55c10e98$var$zf.length; e++)$1742e55f55c10e98$var$F($1742e55f55c10e98$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $1742e55f55c10e98$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $1742e55f55c10e98$var$F("error", a);
                                $1742e55f55c10e98$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $1742e55f55c10e98$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $1742e55f55c10e98$var$Za(a, d);
                                e = $1742e55f55c10e98$var$Ya(a, d);
                                $1742e55f55c10e98$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $1742e55f55c10e98$var$u({}, d, {
                                    value: void 0
                                });
                                $1742e55f55c10e98$var$F("invalid", a);
                                break;
                            case "textarea":
                                $1742e55f55c10e98$var$gb(a, d);
                                e = $1742e55f55c10e98$var$fb(a, d);
                                $1742e55f55c10e98$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $1742e55f55c10e98$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $1742e55f55c10e98$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $1742e55f55c10e98$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $1742e55f55c10e98$var$ob(a, k) : "number" === typeof k && $1742e55f55c10e98$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($1742e55f55c10e98$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $1742e55f55c10e98$var$F("scroll", a) : null != k && $1742e55f55c10e98$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $1742e55f55c10e98$var$Va(a);
                                $1742e55f55c10e98$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $1742e55f55c10e98$var$Va(a);
                                $1742e55f55c10e98$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $1742e55f55c10e98$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $1742e55f55c10e98$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $1742e55f55c10e98$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $1742e55f55c10e98$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $1742e55f55c10e98$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $1742e55f55c10e98$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($1742e55f55c10e98$var$p(166));
                a = $1742e55f55c10e98$var$Lh($1742e55f55c10e98$var$Kh.current);
                $1742e55f55c10e98$var$Lh($1742e55f55c10e98$var$Ih.current);
                if ($1742e55f55c10e98$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$1742e55f55c10e98$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $1742e55f55c10e98$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $1742e55f55c10e98$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $1742e55f55c10e98$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$1742e55f55c10e98$var$bg] = b, b.stateNode = d;
            }
            $1742e55f55c10e98$var$S(b);
            return null;
        case 13:
            $1742e55f55c10e98$var$G($1742e55f55c10e98$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($1742e55f55c10e98$var$J && null !== $1742e55f55c10e98$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $1742e55f55c10e98$var$Vg(), $1742e55f55c10e98$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $1742e55f55c10e98$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($1742e55f55c10e98$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($1742e55f55c10e98$var$p(317));
                        f[$1742e55f55c10e98$var$bg] = b;
                        $1742e55f55c10e98$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $1742e55f55c10e98$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $1742e55f55c10e98$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $1742e55f55c10e98$var$Ng && ($1742e55f55c10e98$var$lk($1742e55f55c10e98$var$Ng), $1742e55f55c10e98$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $1742e55f55c10e98$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($1742e55f55c10e98$var$L.current & 1) ? 0 === $1742e55f55c10e98$var$T && ($1742e55f55c10e98$var$T = 3) : $1742e55f55c10e98$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $1742e55f55c10e98$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $1742e55f55c10e98$var$Nh(), $1742e55f55c10e98$var$gk(a, b), null === a && $1742e55f55c10e98$var$Gf(b.stateNode.containerInfo), $1742e55f55c10e98$var$S(b), null;
        case 10:
            return $1742e55f55c10e98$var$oh(b.type._context), $1742e55f55c10e98$var$S(b), null;
        case 17:
            return $1742e55f55c10e98$var$mg(b.type) && $1742e55f55c10e98$var$ng(), $1742e55f55c10e98$var$S(b), null;
        case 19:
            $1742e55f55c10e98$var$G($1742e55f55c10e98$var$L);
            f = b.memoizedState;
            if (null === f) return $1742e55f55c10e98$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $1742e55f55c10e98$var$jk(f, !1);
                else {
                    if (0 !== $1742e55f55c10e98$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $1742e55f55c10e98$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $1742e55f55c10e98$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $1742e55f55c10e98$var$H($1742e55f55c10e98$var$L, $1742e55f55c10e98$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $1742e55f55c10e98$var$A() > $1742e55f55c10e98$var$mk && (b.flags |= 128, d = !0, $1742e55f55c10e98$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $1742e55f55c10e98$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $1742e55f55c10e98$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$1742e55f55c10e98$var$J) return $1742e55f55c10e98$var$S(b), null;
                    } else 2 * $1742e55f55c10e98$var$A() - f.renderingStartTime > $1742e55f55c10e98$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $1742e55f55c10e98$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $1742e55f55c10e98$var$A(), b.sibling = null, a = $1742e55f55c10e98$var$L.current, $1742e55f55c10e98$var$H($1742e55f55c10e98$var$L, d ? a & 1 | 2 : a & 1), b;
            $1742e55f55c10e98$var$S(b);
            return null;
        case 22:
        case 23:
            return $1742e55f55c10e98$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($1742e55f55c10e98$var$Jj & 1073741824) && ($1742e55f55c10e98$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $1742e55f55c10e98$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($1742e55f55c10e98$var$p(156, b.tag));
}
function $1742e55f55c10e98$var$ok(a, b) {
    $1742e55f55c10e98$var$Kg(b);
    switch(b.tag){
        case 1:
            return $1742e55f55c10e98$var$mg(b.type) && $1742e55f55c10e98$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $1742e55f55c10e98$var$dj(b), b) : null;
        case 3:
            return $1742e55f55c10e98$var$Nh(), $1742e55f55c10e98$var$G($1742e55f55c10e98$var$jg), $1742e55f55c10e98$var$G($1742e55f55c10e98$var$I), $1742e55f55c10e98$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $1742e55f55c10e98$var$Ph(b), null;
        case 13:
            $1742e55f55c10e98$var$G($1742e55f55c10e98$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($1742e55f55c10e98$var$p(340));
                $1742e55f55c10e98$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $1742e55f55c10e98$var$dj(b), b) : null;
        case 19:
            return $1742e55f55c10e98$var$G($1742e55f55c10e98$var$L), null;
        case 4:
            return $1742e55f55c10e98$var$Nh(), null;
        case 10:
            return $1742e55f55c10e98$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $1742e55f55c10e98$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $1742e55f55c10e98$var$pk = !1, $1742e55f55c10e98$var$qk = !1, $1742e55f55c10e98$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $1742e55f55c10e98$var$U = null, $1742e55f55c10e98$var$sk = null, $1742e55f55c10e98$var$tk = null;
function $1742e55f55c10e98$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $1742e55f55c10e98$var$cj(), b.componentWillUnmount();
    } finally{
        $1742e55f55c10e98$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $1742e55f55c10e98$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $1742e55f55c10e98$var$cj(), c(null);
            } finally{
                $1742e55f55c10e98$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $1742e55f55c10e98$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $1742e55f55c10e98$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $1742e55f55c10e98$var$W(a, b, d);
    }
}
var $1742e55f55c10e98$var$xk = !1;
function $1742e55f55c10e98$var$yk(a, b) {
    $1742e55f55c10e98$var$Qf = $1742e55f55c10e98$var$rd;
    a = $1742e55f55c10e98$var$$e();
    if ($1742e55f55c10e98$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $1742e55f55c10e98$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $1742e55f55c10e98$var$rd = !1;
    for($1742e55f55c10e98$var$U = b; null !== $1742e55f55c10e98$var$U;)if (b = $1742e55f55c10e98$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $1742e55f55c10e98$var$U = a;
    else for(; null !== $1742e55f55c10e98$var$U;){
        b = $1742e55f55c10e98$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $1742e55f55c10e98$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($1742e55f55c10e98$var$p(163));
            }
        } catch (D) {
            $1742e55f55c10e98$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $1742e55f55c10e98$var$U = a;
            break;
        }
        $1742e55f55c10e98$var$U = b.return;
    }
    m = $1742e55f55c10e98$var$xk;
    $1742e55f55c10e98$var$xk = !1;
    return m;
}
function $1742e55f55c10e98$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentPassiveEffectUnmountStarted && $1742e55f55c10e98$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $1742e55f55c10e98$var$uc(b), $1742e55f55c10e98$var$wk(b, c, f), 0 !== (a & 8) ? null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentPassiveEffectUnmountStopped && $1742e55f55c10e98$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $1742e55f55c10e98$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $1742e55f55c10e98$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentPassiveEffectMountStarted && $1742e55f55c10e98$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentLayoutEffectMountStarted && $1742e55f55c10e98$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentPassiveEffectMountStopped && $1742e55f55c10e98$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentLayoutEffectMountStopped && $1742e55f55c10e98$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $1742e55f55c10e98$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $1742e55f55c10e98$var$cj(), b(c);
            } finally{
                $1742e55f55c10e98$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $1742e55f55c10e98$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $1742e55f55c10e98$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$1742e55f55c10e98$var$bg], delete b[$1742e55f55c10e98$var$cg], delete b[$1742e55f55c10e98$var$Cf], delete b[$1742e55f55c10e98$var$dg], delete b[$1742e55f55c10e98$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $1742e55f55c10e98$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $1742e55f55c10e98$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $1742e55f55c10e98$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $1742e55f55c10e98$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $1742e55f55c10e98$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($1742e55f55c10e98$var$Fk(a, b, c), a = a.sibling; null !== a;)$1742e55f55c10e98$var$Fk(a, b, c), a = a.sibling;
}
function $1742e55f55c10e98$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($1742e55f55c10e98$var$Gk(a, b, c), a = a.sibling; null !== a;)$1742e55f55c10e98$var$Gk(a, b, c), a = a.sibling;
}
var $1742e55f55c10e98$var$X = null, $1742e55f55c10e98$var$Hk = !1;
function $1742e55f55c10e98$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$1742e55f55c10e98$var$Jk(a, b, c), c = c.sibling;
}
function $1742e55f55c10e98$var$Jk(a, b, c) {
    if ($1742e55f55c10e98$var$lc && "function" === typeof $1742e55f55c10e98$var$lc.onCommitFiberUnmount) try {
        $1742e55f55c10e98$var$lc.onCommitFiberUnmount($1742e55f55c10e98$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $1742e55f55c10e98$var$qk || $1742e55f55c10e98$var$vk(c, b);
        case 6:
            var d = $1742e55f55c10e98$var$X, e = $1742e55f55c10e98$var$Hk;
            $1742e55f55c10e98$var$X = null;
            $1742e55f55c10e98$var$Ik(a, b, c);
            $1742e55f55c10e98$var$X = d;
            $1742e55f55c10e98$var$Hk = e;
            null !== $1742e55f55c10e98$var$X && ($1742e55f55c10e98$var$Hk ? (a = $1742e55f55c10e98$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $1742e55f55c10e98$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $1742e55f55c10e98$var$X && ($1742e55f55c10e98$var$Hk ? (a = $1742e55f55c10e98$var$X, c = c.stateNode, 8 === a.nodeType ? $1742e55f55c10e98$var$Yf(a.parentNode, c) : 1 === a.nodeType && $1742e55f55c10e98$var$Yf(a, c), $1742e55f55c10e98$var$pd(a)) : $1742e55f55c10e98$var$Yf($1742e55f55c10e98$var$X, c.stateNode));
            break;
        case 4:
            d = $1742e55f55c10e98$var$X;
            e = $1742e55f55c10e98$var$Hk;
            $1742e55f55c10e98$var$X = c.stateNode.containerInfo;
            $1742e55f55c10e98$var$Hk = !0;
            $1742e55f55c10e98$var$Ik(a, b, c);
            $1742e55f55c10e98$var$X = d;
            $1742e55f55c10e98$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$1742e55f55c10e98$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $1742e55f55c10e98$var$wk(c, b, g) : 0 !== (f & 4) && ($1742e55f55c10e98$var$uc(c), c.mode & 2 ? ($1742e55f55c10e98$var$cj(), $1742e55f55c10e98$var$wk(c, b, g), $1742e55f55c10e98$var$aj(c)) : $1742e55f55c10e98$var$wk(c, b, g), $1742e55f55c10e98$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $1742e55f55c10e98$var$Ik(a, b, c);
            break;
        case 1:
            if (!$1742e55f55c10e98$var$qk && ($1742e55f55c10e98$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $1742e55f55c10e98$var$uk(c, d);
            } catch (h) {
                $1742e55f55c10e98$var$W(c, b, h);
            }
            $1742e55f55c10e98$var$Ik(a, b, c);
            break;
        case 21:
            $1742e55f55c10e98$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($1742e55f55c10e98$var$qk = (d = $1742e55f55c10e98$var$qk) || null !== c.memoizedState, $1742e55f55c10e98$var$Ik(a, b, c), $1742e55f55c10e98$var$qk = d) : $1742e55f55c10e98$var$Ik(a, b, c);
            break;
        default:
            $1742e55f55c10e98$var$Ik(a, b, c);
    }
}
function $1742e55f55c10e98$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $1742e55f55c10e98$var$rk);
        b.forEach(function(b) {
            var d = $1742e55f55c10e98$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($1742e55f55c10e98$var$mc) {
                    if (null !== $1742e55f55c10e98$var$sk && null !== $1742e55f55c10e98$var$tk) $1742e55f55c10e98$var$wj($1742e55f55c10e98$var$tk, $1742e55f55c10e98$var$sk);
                    else throw Error($1742e55f55c10e98$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $1742e55f55c10e98$var$Mk(a, b, c) {
    $1742e55f55c10e98$var$sk = c;
    $1742e55f55c10e98$var$tk = a;
    $1742e55f55c10e98$var$Nk(b, a);
    $1742e55f55c10e98$var$tk = $1742e55f55c10e98$var$sk = null;
}
function $1742e55f55c10e98$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $1742e55f55c10e98$var$X = h.stateNode;
                        $1742e55f55c10e98$var$Hk = !1;
                        break a;
                    case 3:
                        $1742e55f55c10e98$var$X = h.stateNode.containerInfo;
                        $1742e55f55c10e98$var$Hk = !0;
                        break a;
                    case 4:
                        $1742e55f55c10e98$var$X = h.stateNode.containerInfo;
                        $1742e55f55c10e98$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $1742e55f55c10e98$var$X) throw Error($1742e55f55c10e98$var$p(160));
            $1742e55f55c10e98$var$Jk(f, g, e);
            $1742e55f55c10e98$var$X = null;
            $1742e55f55c10e98$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $1742e55f55c10e98$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$1742e55f55c10e98$var$Nk(b, a), b = b.sibling;
}
function $1742e55f55c10e98$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $1742e55f55c10e98$var$Ok(b, a);
            $1742e55f55c10e98$var$Pk(a);
            if (d & 4) {
                try {
                    $1742e55f55c10e98$var$zk(3, a, a.return), $1742e55f55c10e98$var$Ak(3, a);
                } catch (m) {
                    $1742e55f55c10e98$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $1742e55f55c10e98$var$cj(), $1742e55f55c10e98$var$zk(5, a, a.return);
                    } catch (m) {
                        $1742e55f55c10e98$var$W(a, a.return, m);
                    }
                    $1742e55f55c10e98$var$aj(a);
                } else try {
                    $1742e55f55c10e98$var$zk(5, a, a.return);
                } catch (m) {
                    $1742e55f55c10e98$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $1742e55f55c10e98$var$Ok(b, a);
            $1742e55f55c10e98$var$Pk(a);
            d & 512 && null !== c && $1742e55f55c10e98$var$vk(c, c.return);
            break;
        case 5:
            $1742e55f55c10e98$var$Ok(b, a);
            $1742e55f55c10e98$var$Pk(a);
            d & 512 && null !== c && $1742e55f55c10e98$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $1742e55f55c10e98$var$ob(e, "");
                } catch (m) {
                    $1742e55f55c10e98$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $1742e55f55c10e98$var$$a(e, f);
                    $1742e55f55c10e98$var$vb(h, g);
                    var l = $1742e55f55c10e98$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $1742e55f55c10e98$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $1742e55f55c10e98$var$nb(e, q) : "children" === n ? $1742e55f55c10e98$var$ob(e, q) : $1742e55f55c10e98$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $1742e55f55c10e98$var$ab(e, f);
                            break;
                        case "textarea":
                            $1742e55f55c10e98$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $1742e55f55c10e98$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $1742e55f55c10e98$var$eb(e, !!f.multiple, f.defaultValue, !0) : $1742e55f55c10e98$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$1742e55f55c10e98$var$cg] = f;
                } catch (m) {
                    $1742e55f55c10e98$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $1742e55f55c10e98$var$Ok(b, a);
            $1742e55f55c10e98$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($1742e55f55c10e98$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $1742e55f55c10e98$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $1742e55f55c10e98$var$Ok(b, a);
            $1742e55f55c10e98$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $1742e55f55c10e98$var$pd(b.containerInfo);
            } catch (m) {
                $1742e55f55c10e98$var$W(a, a.return, m);
            }
            break;
        case 4:
            $1742e55f55c10e98$var$Ok(b, a);
            $1742e55f55c10e98$var$Pk(a);
            break;
        case 13:
            $1742e55f55c10e98$var$Ok(b, a);
            $1742e55f55c10e98$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($1742e55f55c10e98$var$Qk = $1742e55f55c10e98$var$A()));
            d & 4 && $1742e55f55c10e98$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($1742e55f55c10e98$var$qk = (l = $1742e55f55c10e98$var$qk) || n, $1742e55f55c10e98$var$Ok(b, a), $1742e55f55c10e98$var$qk = l) : $1742e55f55c10e98$var$Ok(b, a);
            $1742e55f55c10e98$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($1742e55f55c10e98$var$U = a, n = a.child; null !== n;){
                    for(q = $1742e55f55c10e98$var$U = n; null !== $1742e55f55c10e98$var$U;){
                        r = $1742e55f55c10e98$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $1742e55f55c10e98$var$cj(), $1742e55f55c10e98$var$zk(4, r, r.return);
                                } finally{
                                    $1742e55f55c10e98$var$aj(r);
                                }
                                else $1742e55f55c10e98$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $1742e55f55c10e98$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $1742e55f55c10e98$var$uk(c, d);
                                    } catch (m) {
                                        $1742e55f55c10e98$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $1742e55f55c10e98$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $1742e55f55c10e98$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $1742e55f55c10e98$var$U = z) : $1742e55f55c10e98$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $1742e55f55c10e98$var$rb("display", g));
                            } catch (m) {
                                $1742e55f55c10e98$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $1742e55f55c10e98$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $1742e55f55c10e98$var$Ok(b, a);
            $1742e55f55c10e98$var$Pk(a);
            d & 4 && $1742e55f55c10e98$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $1742e55f55c10e98$var$Ok(b, a), $1742e55f55c10e98$var$Pk(a);
    }
}
function $1742e55f55c10e98$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($1742e55f55c10e98$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($1742e55f55c10e98$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($1742e55f55c10e98$var$ob(e, ""), d.flags &= -33);
                    var f = $1742e55f55c10e98$var$Ek(a);
                    $1742e55f55c10e98$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $1742e55f55c10e98$var$Ek(a);
                    $1742e55f55c10e98$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($1742e55f55c10e98$var$p(161));
            }
        } catch (k) {
            $1742e55f55c10e98$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $1742e55f55c10e98$var$Sk(a, b, c) {
    $1742e55f55c10e98$var$sk = c;
    $1742e55f55c10e98$var$tk = b;
    $1742e55f55c10e98$var$U = a;
    $1742e55f55c10e98$var$Tk(a, b, c);
    $1742e55f55c10e98$var$tk = $1742e55f55c10e98$var$sk = null;
}
function $1742e55f55c10e98$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $1742e55f55c10e98$var$U;){
        var e = $1742e55f55c10e98$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $1742e55f55c10e98$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $1742e55f55c10e98$var$qk;
                h = $1742e55f55c10e98$var$pk;
                var l = $1742e55f55c10e98$var$qk;
                $1742e55f55c10e98$var$pk = g;
                if (($1742e55f55c10e98$var$qk = k) && !l) for($1742e55f55c10e98$var$U = e; null !== $1742e55f55c10e98$var$U;)g = $1742e55f55c10e98$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $1742e55f55c10e98$var$Uk(e) : null !== k ? (k.return = g, $1742e55f55c10e98$var$U = k) : $1742e55f55c10e98$var$Uk(e);
                for(; null !== f;)$1742e55f55c10e98$var$U = f, $1742e55f55c10e98$var$Tk(f, b, c), f = f.sibling;
                $1742e55f55c10e98$var$U = e;
                $1742e55f55c10e98$var$pk = h;
                $1742e55f55c10e98$var$qk = l;
            }
            $1742e55f55c10e98$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $1742e55f55c10e98$var$U = f) : $1742e55f55c10e98$var$Vk(a, b, c);
    }
}
function $1742e55f55c10e98$var$Vk(a) {
    for(; null !== $1742e55f55c10e98$var$U;){
        var b = $1742e55f55c10e98$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$1742e55f55c10e98$var$qk) {
                            if (b.mode & 2) try {
                                $1742e55f55c10e98$var$cj(), $1742e55f55c10e98$var$Ak(5, b);
                            } finally{
                                $1742e55f55c10e98$var$aj(b);
                            }
                            else $1742e55f55c10e98$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$1742e55f55c10e98$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $1742e55f55c10e98$var$cj(), d.componentDidMount();
                                } finally{
                                    $1742e55f55c10e98$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $1742e55f55c10e98$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $1742e55f55c10e98$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $1742e55f55c10e98$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $1742e55f55c10e98$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $1742e55f55c10e98$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $1742e55f55c10e98$var$Ui;
                        c = null === c ? "mount" : "update";
                        $1742e55f55c10e98$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $1742e55f55c10e98$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $1742e55f55c10e98$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($1742e55f55c10e98$var$p(163));
                }
                $1742e55f55c10e98$var$qk || b.flags & 512 && $1742e55f55c10e98$var$Bk(b);
            } catch (v) {
                $1742e55f55c10e98$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $1742e55f55c10e98$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $1742e55f55c10e98$var$U = k;
            break;
        }
        $1742e55f55c10e98$var$U = b.return;
    }
}
function $1742e55f55c10e98$var$Rk(a) {
    for(; null !== $1742e55f55c10e98$var$U;){
        var b = $1742e55f55c10e98$var$U;
        if (b === a) {
            $1742e55f55c10e98$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $1742e55f55c10e98$var$U = c;
            break;
        }
        $1742e55f55c10e98$var$U = b.return;
    }
}
function $1742e55f55c10e98$var$Uk(a) {
    for(; null !== $1742e55f55c10e98$var$U;){
        var b = $1742e55f55c10e98$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $1742e55f55c10e98$var$cj();
                        var c = b.return;
                        try {
                            $1742e55f55c10e98$var$Ak(4, b);
                        } catch (l) {
                            $1742e55f55c10e98$var$W(b, c, l);
                        }
                    } finally{
                        $1742e55f55c10e98$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $1742e55f55c10e98$var$Ak(4, b);
                        } catch (l) {
                            $1742e55f55c10e98$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $1742e55f55c10e98$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $1742e55f55c10e98$var$Bk(b);
                    } catch (l) {
                        $1742e55f55c10e98$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $1742e55f55c10e98$var$Bk(b);
                    } catch (l) {
                        $1742e55f55c10e98$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $1742e55f55c10e98$var$W(b, b.return, l);
        }
        if (b === a) {
            $1742e55f55c10e98$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $1742e55f55c10e98$var$U = k;
            break;
        }
        $1742e55f55c10e98$var$U = b.return;
    }
}
var $1742e55f55c10e98$var$Xk = Math.ceil, $1742e55f55c10e98$var$Yk = $1742e55f55c10e98$var$va.ReactCurrentDispatcher, $1742e55f55c10e98$var$Zk = $1742e55f55c10e98$var$va.ReactCurrentOwner, $1742e55f55c10e98$var$$k = $1742e55f55c10e98$var$va.ReactCurrentBatchConfig, $1742e55f55c10e98$var$K = 0, $1742e55f55c10e98$var$Q = null, $1742e55f55c10e98$var$Y = null, $1742e55f55c10e98$var$Z = 0, $1742e55f55c10e98$var$Jj = 0, $1742e55f55c10e98$var$Ij = $1742e55f55c10e98$var$hg(0), $1742e55f55c10e98$var$T = 0, $1742e55f55c10e98$var$al = null, $1742e55f55c10e98$var$Fh = 0, $1742e55f55c10e98$var$bl = 0, $1742e55f55c10e98$var$cl = 0, $1742e55f55c10e98$var$dl = null, $1742e55f55c10e98$var$el = null, $1742e55f55c10e98$var$Qk = 0, $1742e55f55c10e98$var$mk = Infinity, $1742e55f55c10e98$var$fl = null, $1742e55f55c10e98$var$qj = !1, $1742e55f55c10e98$var$rj = null, $1742e55f55c10e98$var$tj = null, $1742e55f55c10e98$var$gl = !1, $1742e55f55c10e98$var$hl = null, $1742e55f55c10e98$var$il = 0, $1742e55f55c10e98$var$jl = [], $1742e55f55c10e98$var$kl = 0, $1742e55f55c10e98$var$ll = null, $1742e55f55c10e98$var$ml = -1, $1742e55f55c10e98$var$nl = 0;
function $1742e55f55c10e98$var$Ri() {
    return 0 !== ($1742e55f55c10e98$var$K & 6) ? $1742e55f55c10e98$var$A() : -1 !== $1742e55f55c10e98$var$ml ? $1742e55f55c10e98$var$ml : $1742e55f55c10e98$var$ml = $1742e55f55c10e98$var$A();
}
function $1742e55f55c10e98$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($1742e55f55c10e98$var$K & 2) && 0 !== $1742e55f55c10e98$var$Z) return $1742e55f55c10e98$var$Z & -$1742e55f55c10e98$var$Z;
    if (null !== $1742e55f55c10e98$var$Yg.transition) return 0 === $1742e55f55c10e98$var$nl && ($1742e55f55c10e98$var$nl = $1742e55f55c10e98$var$Kc()), $1742e55f55c10e98$var$nl;
    a = $1742e55f55c10e98$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $1742e55f55c10e98$var$xd(a.type);
    return a;
}
function $1742e55f55c10e98$var$ui(a, b, c, d) {
    if (50 < $1742e55f55c10e98$var$kl) throw $1742e55f55c10e98$var$kl = 0, $1742e55f55c10e98$var$ll = null, Error($1742e55f55c10e98$var$p(185));
    $1742e55f55c10e98$var$Mc(a, c, d);
    if (0 === ($1742e55f55c10e98$var$K & 2) || a !== $1742e55f55c10e98$var$Q) $1742e55f55c10e98$var$mc && $1742e55f55c10e98$var$Pc(a, b, c), a === $1742e55f55c10e98$var$Q && (0 === ($1742e55f55c10e98$var$K & 2) && ($1742e55f55c10e98$var$bl |= c), 4 === $1742e55f55c10e98$var$T && $1742e55f55c10e98$var$ol(a, $1742e55f55c10e98$var$Z)), $1742e55f55c10e98$var$pl(a, d), 1 === c && 0 === $1742e55f55c10e98$var$K && 0 === (b.mode & 1) && ($1742e55f55c10e98$var$mk = $1742e55f55c10e98$var$A() + 500, $1742e55f55c10e98$var$tg && $1742e55f55c10e98$var$xg());
}
function $1742e55f55c10e98$var$pl(a, b) {
    var c = a.callbackNode;
    $1742e55f55c10e98$var$Ic(a, b);
    var d = $1742e55f55c10e98$var$Gc(a, a === $1742e55f55c10e98$var$Q ? $1742e55f55c10e98$var$Z : 0);
    if (0 === d) null !== c && $1742e55f55c10e98$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $1742e55f55c10e98$var$bc(c);
        if (1 === b) 0 === a.tag ? $1742e55f55c10e98$var$wg($1742e55f55c10e98$var$ql.bind(null, a)) : $1742e55f55c10e98$var$vg($1742e55f55c10e98$var$ql.bind(null, a)), $1742e55f55c10e98$var$Xf(function() {
            0 === ($1742e55f55c10e98$var$K & 6) && $1742e55f55c10e98$var$xg();
        }), c = null;
        else {
            switch($1742e55f55c10e98$var$Rc(d)){
                case 1:
                    c = $1742e55f55c10e98$var$fc;
                    break;
                case 4:
                    c = $1742e55f55c10e98$var$gc;
                    break;
                case 16:
                    c = $1742e55f55c10e98$var$hc;
                    break;
                case 536870912:
                    c = $1742e55f55c10e98$var$jc;
                    break;
                default:
                    c = $1742e55f55c10e98$var$hc;
            }
            c = $1742e55f55c10e98$var$rl(c, $1742e55f55c10e98$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $1742e55f55c10e98$var$sl(a, b) {
    $1742e55f55c10e98$var$Zi = $1742e55f55c10e98$var$Yi = !1;
    $1742e55f55c10e98$var$ml = -1;
    $1742e55f55c10e98$var$nl = 0;
    if (0 !== ($1742e55f55c10e98$var$K & 6)) throw Error($1742e55f55c10e98$var$p(327));
    var c = a.callbackNode;
    if ($1742e55f55c10e98$var$tl() && a.callbackNode !== c) return null;
    var d = $1742e55f55c10e98$var$Gc(a, a === $1742e55f55c10e98$var$Q ? $1742e55f55c10e98$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $1742e55f55c10e98$var$ul(a, d);
    else {
        b = d;
        var e = $1742e55f55c10e98$var$K;
        $1742e55f55c10e98$var$K |= 2;
        var f = $1742e55f55c10e98$var$vl();
        if ($1742e55f55c10e98$var$Q !== a || $1742e55f55c10e98$var$Z !== b) {
            if ($1742e55f55c10e98$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($1742e55f55c10e98$var$wj(a, $1742e55f55c10e98$var$Z), g.clear());
                $1742e55f55c10e98$var$Qc(a, b);
            }
            $1742e55f55c10e98$var$fl = null;
            $1742e55f55c10e98$var$mk = $1742e55f55c10e98$var$A() + 500;
            $1742e55f55c10e98$var$wl(a, b);
        }
        $1742e55f55c10e98$var$wc(b);
        for(;;)try {
            $1742e55f55c10e98$var$xl();
            break;
        } catch (h) {
            $1742e55f55c10e98$var$yl(a, h);
        }
        $1742e55f55c10e98$var$nh();
        $1742e55f55c10e98$var$Yk.current = f;
        $1742e55f55c10e98$var$K = e;
        null !== $1742e55f55c10e98$var$Y ? (null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markRenderYielded && $1742e55f55c10e98$var$B.markRenderYielded(), b = 0) : ($1742e55f55c10e98$var$xc(), $1742e55f55c10e98$var$Q = null, $1742e55f55c10e98$var$Z = 0, b = $1742e55f55c10e98$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $1742e55f55c10e98$var$Jc(a), 0 !== e && (d = e, b = $1742e55f55c10e98$var$zl(a, e)));
        if (1 === b) throw c = $1742e55f55c10e98$var$al, $1742e55f55c10e98$var$wl(a, 0), $1742e55f55c10e98$var$ol(a, d), $1742e55f55c10e98$var$pl(a, $1742e55f55c10e98$var$A()), c;
        if (6 === b) $1742e55f55c10e98$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$1742e55f55c10e98$var$Al(e) && (b = $1742e55f55c10e98$var$ul(a, d), 2 === b && (f = $1742e55f55c10e98$var$Jc(a), 0 !== f && (d = f, b = $1742e55f55c10e98$var$zl(a, f))), 1 === b)) throw c = $1742e55f55c10e98$var$al, $1742e55f55c10e98$var$wl(a, 0), $1742e55f55c10e98$var$ol(a, d), $1742e55f55c10e98$var$pl(a, $1742e55f55c10e98$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($1742e55f55c10e98$var$p(345));
                case 2:
                    $1742e55f55c10e98$var$Cl(a, $1742e55f55c10e98$var$el, $1742e55f55c10e98$var$fl);
                    break;
                case 3:
                    $1742e55f55c10e98$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $1742e55f55c10e98$var$Qk + 500 - $1742e55f55c10e98$var$A(), 10 < b)) {
                        if (0 !== $1742e55f55c10e98$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $1742e55f55c10e98$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $1742e55f55c10e98$var$Tf($1742e55f55c10e98$var$Cl.bind(null, a, $1742e55f55c10e98$var$el, $1742e55f55c10e98$var$fl), b);
                        break;
                    }
                    $1742e55f55c10e98$var$Cl(a, $1742e55f55c10e98$var$el, $1742e55f55c10e98$var$fl);
                    break;
                case 4:
                    $1742e55f55c10e98$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $1742e55f55c10e98$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $1742e55f55c10e98$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $1742e55f55c10e98$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $1742e55f55c10e98$var$Tf($1742e55f55c10e98$var$Cl.bind(null, a, $1742e55f55c10e98$var$el, $1742e55f55c10e98$var$fl), d);
                        break;
                    }
                    $1742e55f55c10e98$var$Cl(a, $1742e55f55c10e98$var$el, $1742e55f55c10e98$var$fl);
                    break;
                case 5:
                    $1742e55f55c10e98$var$Cl(a, $1742e55f55c10e98$var$el, $1742e55f55c10e98$var$fl);
                    break;
                default:
                    throw Error($1742e55f55c10e98$var$p(329));
            }
        }
    }
    $1742e55f55c10e98$var$pl(a, $1742e55f55c10e98$var$A());
    return a.callbackNode === c ? $1742e55f55c10e98$var$sl.bind(null, a) : null;
}
function $1742e55f55c10e98$var$zl(a, b) {
    var c = $1742e55f55c10e98$var$dl;
    a.current.memoizedState.isDehydrated && ($1742e55f55c10e98$var$wl(a, b).flags |= 256);
    a = $1742e55f55c10e98$var$ul(a, b);
    2 !== a && (b = $1742e55f55c10e98$var$el, $1742e55f55c10e98$var$el = c, null !== b && $1742e55f55c10e98$var$lk(b));
    return a;
}
function $1742e55f55c10e98$var$lk(a) {
    null === $1742e55f55c10e98$var$el ? $1742e55f55c10e98$var$el = a : $1742e55f55c10e98$var$el.push.apply($1742e55f55c10e98$var$el, a);
}
function $1742e55f55c10e98$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$1742e55f55c10e98$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $1742e55f55c10e98$var$ol(a, b) {
    b &= ~$1742e55f55c10e98$var$cl;
    b &= ~$1742e55f55c10e98$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $1742e55f55c10e98$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $1742e55f55c10e98$var$ql(a) {
    $1742e55f55c10e98$var$Yi = $1742e55f55c10e98$var$Zi;
    $1742e55f55c10e98$var$Zi = !1;
    if (0 !== ($1742e55f55c10e98$var$K & 6)) throw Error($1742e55f55c10e98$var$p(327));
    $1742e55f55c10e98$var$tl();
    var b = $1742e55f55c10e98$var$Gc(a, 0);
    if (0 === (b & 1)) return $1742e55f55c10e98$var$pl(a, $1742e55f55c10e98$var$A()), null;
    var c = $1742e55f55c10e98$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $1742e55f55c10e98$var$Jc(a);
        0 !== d && (b = d, c = $1742e55f55c10e98$var$zl(a, d));
    }
    if (1 === c) throw c = $1742e55f55c10e98$var$al, $1742e55f55c10e98$var$wl(a, 0), $1742e55f55c10e98$var$ol(a, b), $1742e55f55c10e98$var$pl(a, $1742e55f55c10e98$var$A()), c;
    if (6 === c) throw Error($1742e55f55c10e98$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $1742e55f55c10e98$var$Cl(a, $1742e55f55c10e98$var$el, $1742e55f55c10e98$var$fl);
    $1742e55f55c10e98$var$pl(a, $1742e55f55c10e98$var$A());
    return null;
}
function $1742e55f55c10e98$var$Dl(a, b) {
    var c = $1742e55f55c10e98$var$K;
    $1742e55f55c10e98$var$K |= 1;
    try {
        return a(b);
    } finally{
        $1742e55f55c10e98$var$K = c, 0 === $1742e55f55c10e98$var$K && ($1742e55f55c10e98$var$mk = $1742e55f55c10e98$var$A() + 500, $1742e55f55c10e98$var$tg && $1742e55f55c10e98$var$xg());
    }
}
function $1742e55f55c10e98$var$El(a) {
    null !== $1742e55f55c10e98$var$hl && 0 === $1742e55f55c10e98$var$hl.tag && 0 === ($1742e55f55c10e98$var$K & 6) && $1742e55f55c10e98$var$tl();
    var b = $1742e55f55c10e98$var$K;
    $1742e55f55c10e98$var$K |= 1;
    var c = $1742e55f55c10e98$var$$k.transition, d = $1742e55f55c10e98$var$E;
    try {
        if ($1742e55f55c10e98$var$$k.transition = null, $1742e55f55c10e98$var$E = 1, a) return a();
    } finally{
        $1742e55f55c10e98$var$E = d, $1742e55f55c10e98$var$$k.transition = c, $1742e55f55c10e98$var$K = b, 0 === ($1742e55f55c10e98$var$K & 6) && $1742e55f55c10e98$var$xg();
    }
}
function $1742e55f55c10e98$var$nk() {
    $1742e55f55c10e98$var$Jj = $1742e55f55c10e98$var$Ij.current;
    $1742e55f55c10e98$var$G($1742e55f55c10e98$var$Ij);
}
function $1742e55f55c10e98$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $1742e55f55c10e98$var$Uf(c));
    if (null !== $1742e55f55c10e98$var$Y) for(c = $1742e55f55c10e98$var$Y.return; null !== c;){
        var d = c;
        $1742e55f55c10e98$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $1742e55f55c10e98$var$ng();
                break;
            case 3:
                $1742e55f55c10e98$var$Nh();
                $1742e55f55c10e98$var$G($1742e55f55c10e98$var$jg);
                $1742e55f55c10e98$var$G($1742e55f55c10e98$var$I);
                $1742e55f55c10e98$var$Sh();
                break;
            case 5:
                $1742e55f55c10e98$var$Ph(d);
                break;
            case 4:
                $1742e55f55c10e98$var$Nh();
                break;
            case 13:
                $1742e55f55c10e98$var$G($1742e55f55c10e98$var$L);
                break;
            case 19:
                $1742e55f55c10e98$var$G($1742e55f55c10e98$var$L);
                break;
            case 10:
                $1742e55f55c10e98$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $1742e55f55c10e98$var$nk();
        }
        c = c.return;
    }
    $1742e55f55c10e98$var$Q = a;
    $1742e55f55c10e98$var$Y = a = $1742e55f55c10e98$var$ch(a.current, null);
    $1742e55f55c10e98$var$Z = $1742e55f55c10e98$var$Jj = b;
    $1742e55f55c10e98$var$T = 0;
    $1742e55f55c10e98$var$al = null;
    $1742e55f55c10e98$var$cl = $1742e55f55c10e98$var$bl = $1742e55f55c10e98$var$Fh = 0;
    $1742e55f55c10e98$var$el = $1742e55f55c10e98$var$dl = null;
    if (null !== $1742e55f55c10e98$var$th) {
        for(b = 0; b < $1742e55f55c10e98$var$th.length; b++)if (c = $1742e55f55c10e98$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $1742e55f55c10e98$var$th = null;
    }
    return a;
}
function $1742e55f55c10e98$var$yl(a, b) {
    do {
        var c = $1742e55f55c10e98$var$Y;
        try {
            $1742e55f55c10e98$var$nh();
            $1742e55f55c10e98$var$Th.current = $1742e55f55c10e98$var$ei;
            if ($1742e55f55c10e98$var$Wh) {
                for(var d = $1742e55f55c10e98$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $1742e55f55c10e98$var$Wh = !1;
            }
            $1742e55f55c10e98$var$Vh = 0;
            $1742e55f55c10e98$var$O = $1742e55f55c10e98$var$N = $1742e55f55c10e98$var$M = null;
            $1742e55f55c10e98$var$Xh = !1;
            $1742e55f55c10e98$var$Yh = 0;
            $1742e55f55c10e98$var$Zk.current = null;
            if (null === c || null === c.return) {
                $1742e55f55c10e98$var$T = 1;
                $1742e55f55c10e98$var$al = b;
                $1742e55f55c10e98$var$Y = null;
                break;
            }
            c.mode & 2 && $1742e55f55c10e98$var$$i(c, !0);
            $1742e55f55c10e98$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentSuspended && $1742e55f55c10e98$var$B.markComponentSuspended(c, f, $1742e55f55c10e98$var$Z);
            } else null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markComponentErrored && $1742e55f55c10e98$var$B.markComponentErrored(c, b, $1742e55f55c10e98$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $1742e55f55c10e98$var$Z;
                k.flags |= 32768;
                $1742e55f55c10e98$var$mc && $1742e55f55c10e98$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $1742e55f55c10e98$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $1742e55f55c10e98$var$yj(z, h, k, g, b);
                        z.mode & 1 && $1742e55f55c10e98$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $1742e55f55c10e98$var$uj(g, l, b);
                            $1742e55f55c10e98$var$Zj();
                            break a;
                        }
                        f = Error($1742e55f55c10e98$var$p(426));
                    }
                } else if ($1742e55f55c10e98$var$J && k.mode & 1) {
                    var C = $1742e55f55c10e98$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $1742e55f55c10e98$var$yj(C, h, k, g, b);
                        $1742e55f55c10e98$var$Xg($1742e55f55c10e98$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $1742e55f55c10e98$var$lj(f, k);
                4 !== $1742e55f55c10e98$var$T && ($1742e55f55c10e98$var$T = 2);
                null === $1742e55f55c10e98$var$dl ? $1742e55f55c10e98$var$dl = [
                    g
                ] : $1742e55f55c10e98$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $1742e55f55c10e98$var$pj(g, f, b);
                            $1742e55f55c10e98$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $1742e55f55c10e98$var$tj || !$1742e55f55c10e98$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $1742e55f55c10e98$var$sj(g, k, b);
                                $1742e55f55c10e98$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $1742e55f55c10e98$var$Fl(c);
        } catch (ca) {
            b = ca;
            $1742e55f55c10e98$var$Y === c && null !== c && ($1742e55f55c10e98$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $1742e55f55c10e98$var$vl() {
    var a = $1742e55f55c10e98$var$Yk.current;
    $1742e55f55c10e98$var$Yk.current = $1742e55f55c10e98$var$ei;
    return null === a ? $1742e55f55c10e98$var$ei : a;
}
function $1742e55f55c10e98$var$Zj() {
    if (0 === $1742e55f55c10e98$var$T || 3 === $1742e55f55c10e98$var$T || 2 === $1742e55f55c10e98$var$T) $1742e55f55c10e98$var$T = 4;
    null === $1742e55f55c10e98$var$Q || 0 === ($1742e55f55c10e98$var$Fh & 268435455) && 0 === ($1742e55f55c10e98$var$bl & 268435455) || $1742e55f55c10e98$var$ol($1742e55f55c10e98$var$Q, $1742e55f55c10e98$var$Z);
}
function $1742e55f55c10e98$var$ul(a, b) {
    var c = $1742e55f55c10e98$var$K;
    $1742e55f55c10e98$var$K |= 2;
    var d = $1742e55f55c10e98$var$vl();
    if ($1742e55f55c10e98$var$Q !== a || $1742e55f55c10e98$var$Z !== b) {
        if ($1742e55f55c10e98$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($1742e55f55c10e98$var$wj(a, $1742e55f55c10e98$var$Z), e.clear());
            $1742e55f55c10e98$var$Qc(a, b);
        }
        $1742e55f55c10e98$var$fl = null;
        $1742e55f55c10e98$var$wl(a, b);
    }
    $1742e55f55c10e98$var$wc(b);
    for(;;)try {
        $1742e55f55c10e98$var$Gl();
        break;
    } catch (f) {
        $1742e55f55c10e98$var$yl(a, f);
    }
    $1742e55f55c10e98$var$nh();
    $1742e55f55c10e98$var$K = c;
    $1742e55f55c10e98$var$Yk.current = d;
    if (null !== $1742e55f55c10e98$var$Y) throw Error($1742e55f55c10e98$var$p(261));
    $1742e55f55c10e98$var$xc();
    $1742e55f55c10e98$var$Q = null;
    $1742e55f55c10e98$var$Z = 0;
    return $1742e55f55c10e98$var$T;
}
function $1742e55f55c10e98$var$Gl() {
    for(; null !== $1742e55f55c10e98$var$Y;)$1742e55f55c10e98$var$Hl($1742e55f55c10e98$var$Y);
}
function $1742e55f55c10e98$var$xl() {
    for(; null !== $1742e55f55c10e98$var$Y && !$1742e55f55c10e98$var$cc();)$1742e55f55c10e98$var$Hl($1742e55f55c10e98$var$Y);
}
function $1742e55f55c10e98$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($1742e55f55c10e98$var$Wi = $1742e55f55c10e98$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $1742e55f55c10e98$var$Ti()), b = $1742e55f55c10e98$var$Il(b, a, $1742e55f55c10e98$var$Jj), $1742e55f55c10e98$var$$i(a, !0)) : b = $1742e55f55c10e98$var$Il(b, a, $1742e55f55c10e98$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $1742e55f55c10e98$var$Fl(a) : $1742e55f55c10e98$var$Y = b;
    $1742e55f55c10e98$var$Zk.current = null;
}
function $1742e55f55c10e98$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $1742e55f55c10e98$var$kk(c, b, $1742e55f55c10e98$var$Jj);
            else {
                var d = b;
                $1742e55f55c10e98$var$Wi = $1742e55f55c10e98$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $1742e55f55c10e98$var$Ti());
                c = $1742e55f55c10e98$var$kk(c, b, $1742e55f55c10e98$var$Jj);
                $1742e55f55c10e98$var$$i(b, !1);
            }
            if (null !== c) {
                $1742e55f55c10e98$var$Y = c;
                return;
            }
        } else {
            c = $1742e55f55c10e98$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $1742e55f55c10e98$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $1742e55f55c10e98$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $1742e55f55c10e98$var$T = 6;
                $1742e55f55c10e98$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $1742e55f55c10e98$var$Y = b;
            return;
        }
        $1742e55f55c10e98$var$Y = b = a;
    }while (null !== b);
    0 === $1742e55f55c10e98$var$T && ($1742e55f55c10e98$var$T = 5);
}
function $1742e55f55c10e98$var$Cl(a, b, c) {
    var d = $1742e55f55c10e98$var$E, e = $1742e55f55c10e98$var$$k.transition;
    try {
        $1742e55f55c10e98$var$$k.transition = null, $1742e55f55c10e98$var$E = 1, $1742e55f55c10e98$var$Jl(a, b, c, d);
    } finally{
        $1742e55f55c10e98$var$$k.transition = e, $1742e55f55c10e98$var$E = d;
    }
    return null;
}
function $1742e55f55c10e98$var$Jl(a, b, c, d) {
    do $1742e55f55c10e98$var$tl();
    while (null !== $1742e55f55c10e98$var$hl);
    if (0 !== ($1742e55f55c10e98$var$K & 6)) throw Error($1742e55f55c10e98$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markCommitStarted && $1742e55f55c10e98$var$B.markCommitStarted(e);
    if (null === c) return $1742e55f55c10e98$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($1742e55f55c10e98$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $1742e55f55c10e98$var$Nc(a, f);
    a === $1742e55f55c10e98$var$Q && ($1742e55f55c10e98$var$Y = $1742e55f55c10e98$var$Q = null, $1742e55f55c10e98$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $1742e55f55c10e98$var$gl || ($1742e55f55c10e98$var$gl = !0, $1742e55f55c10e98$var$rl($1742e55f55c10e98$var$hc, function() {
        $1742e55f55c10e98$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $1742e55f55c10e98$var$$k.transition;
        $1742e55f55c10e98$var$$k.transition = null;
        var g = $1742e55f55c10e98$var$E;
        $1742e55f55c10e98$var$E = 1;
        var h = $1742e55f55c10e98$var$K;
        $1742e55f55c10e98$var$K |= 4;
        $1742e55f55c10e98$var$Zk.current = null;
        $1742e55f55c10e98$var$yk(a, c);
        $1742e55f55c10e98$var$Ui = $1742e55f55c10e98$var$Ti();
        $1742e55f55c10e98$var$Mk(a, c, e);
        $1742e55f55c10e98$var$bf($1742e55f55c10e98$var$Rf);
        $1742e55f55c10e98$var$rd = !!$1742e55f55c10e98$var$Qf;
        $1742e55f55c10e98$var$Rf = $1742e55f55c10e98$var$Qf = null;
        a.current = c;
        null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markLayoutEffectsStarted && $1742e55f55c10e98$var$B.markLayoutEffectsStarted(e);
        $1742e55f55c10e98$var$Sk(c, a, e);
        null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markLayoutEffectsStopped && $1742e55f55c10e98$var$B.markLayoutEffectsStopped();
        $1742e55f55c10e98$var$dc();
        $1742e55f55c10e98$var$K = h;
        $1742e55f55c10e98$var$E = g;
        $1742e55f55c10e98$var$$k.transition = f;
    } else a.current = c, $1742e55f55c10e98$var$Ui = $1742e55f55c10e98$var$Ti();
    $1742e55f55c10e98$var$gl && ($1742e55f55c10e98$var$gl = !1, $1742e55f55c10e98$var$hl = a, $1742e55f55c10e98$var$il = e);
    f = a.pendingLanes;
    0 === f && ($1742e55f55c10e98$var$tj = null);
    $1742e55f55c10e98$var$nc(c.stateNode, d);
    $1742e55f55c10e98$var$mc && a.memoizedUpdaters.clear();
    $1742e55f55c10e98$var$pl(a, $1742e55f55c10e98$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($1742e55f55c10e98$var$qj) throw $1742e55f55c10e98$var$qj = !1, a = $1742e55f55c10e98$var$rj, $1742e55f55c10e98$var$rj = null, a;
    0 !== ($1742e55f55c10e98$var$il & 1) && 0 !== a.tag && $1742e55f55c10e98$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($1742e55f55c10e98$var$Zi = !0, a === $1742e55f55c10e98$var$ll ? $1742e55f55c10e98$var$kl++ : ($1742e55f55c10e98$var$kl = 0, $1742e55f55c10e98$var$ll = a)) : $1742e55f55c10e98$var$kl = 0;
    $1742e55f55c10e98$var$xg();
    $1742e55f55c10e98$var$rc();
    return null;
}
function $1742e55f55c10e98$var$tl() {
    if (null !== $1742e55f55c10e98$var$hl) {
        var a = $1742e55f55c10e98$var$Rc($1742e55f55c10e98$var$il), b = $1742e55f55c10e98$var$$k.transition, c = $1742e55f55c10e98$var$E;
        try {
            $1742e55f55c10e98$var$$k.transition = null;
            $1742e55f55c10e98$var$E = 16 > a ? 16 : a;
            if (null === $1742e55f55c10e98$var$hl) var d = !1;
            else {
                a = $1742e55f55c10e98$var$hl;
                var e = $1742e55f55c10e98$var$il;
                $1742e55f55c10e98$var$hl = null;
                $1742e55f55c10e98$var$il = 0;
                if (0 !== ($1742e55f55c10e98$var$K & 6)) throw Error($1742e55f55c10e98$var$p(331));
                null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markPassiveEffectsStarted && $1742e55f55c10e98$var$B.markPassiveEffectsStarted(e);
                e = $1742e55f55c10e98$var$K;
                $1742e55f55c10e98$var$K |= 4;
                for($1742e55f55c10e98$var$U = a.current; null !== $1742e55f55c10e98$var$U;){
                    var f = $1742e55f55c10e98$var$U, g = f.child;
                    if (0 !== ($1742e55f55c10e98$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($1742e55f55c10e98$var$U = l; null !== $1742e55f55c10e98$var$U;){
                                    var n = $1742e55f55c10e98$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($1742e55f55c10e98$var$Xi = $1742e55f55c10e98$var$Ti(), $1742e55f55c10e98$var$zk(8, q, f), $1742e55f55c10e98$var$bj(q)) : $1742e55f55c10e98$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $1742e55f55c10e98$var$U = r;
                                    else for(; null !== $1742e55f55c10e98$var$U;){
                                        n = $1742e55f55c10e98$var$U;
                                        var z = n.sibling, m = n.return;
                                        $1742e55f55c10e98$var$Ck(n);
                                        if (n === l) {
                                            $1742e55f55c10e98$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $1742e55f55c10e98$var$U = z;
                                            break;
                                        }
                                        $1742e55f55c10e98$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $1742e55f55c10e98$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $1742e55f55c10e98$var$U = g;
                    else b: for(; null !== $1742e55f55c10e98$var$U;){
                        f = $1742e55f55c10e98$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($1742e55f55c10e98$var$Xi = $1742e55f55c10e98$var$Ti(), $1742e55f55c10e98$var$zk(9, k, k.return), $1742e55f55c10e98$var$bj(k)) : $1742e55f55c10e98$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $1742e55f55c10e98$var$U = y;
                            break b;
                        }
                        $1742e55f55c10e98$var$U = f.return;
                    }
                }
                var v = a.current;
                for($1742e55f55c10e98$var$U = v; null !== $1742e55f55c10e98$var$U;){
                    g = $1742e55f55c10e98$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $1742e55f55c10e98$var$U = D;
                    else b: for(g = v; null !== $1742e55f55c10e98$var$U;){
                        h = $1742e55f55c10e98$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $1742e55f55c10e98$var$Xi = $1742e55f55c10e98$var$Ti();
                                        try {
                                            $1742e55f55c10e98$var$Ak(9, l);
                                        } finally{
                                            $1742e55f55c10e98$var$bj(l);
                                        }
                                    } else $1742e55f55c10e98$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $1742e55f55c10e98$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $1742e55f55c10e98$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $1742e55f55c10e98$var$U = ca;
                            break b;
                        }
                        $1742e55f55c10e98$var$U = h.return;
                    }
                }
                v = $1742e55f55c10e98$var$jl;
                $1742e55f55c10e98$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $1742e55f55c10e98$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $1742e55f55c10e98$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markPassiveEffectsStopped && $1742e55f55c10e98$var$B.markPassiveEffectsStopped();
                $1742e55f55c10e98$var$K = e;
                $1742e55f55c10e98$var$xg();
                if ($1742e55f55c10e98$var$lc && "function" === typeof $1742e55f55c10e98$var$lc.onPostCommitFiberRoot) try {
                    $1742e55f55c10e98$var$lc.onPostCommitFiberRoot($1742e55f55c10e98$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $1742e55f55c10e98$var$E = c, $1742e55f55c10e98$var$$k.transition = b;
        }
    }
    return !1;
}
function $1742e55f55c10e98$var$Wk(a) {
    $1742e55f55c10e98$var$jl.push(a);
    $1742e55f55c10e98$var$gl || ($1742e55f55c10e98$var$gl = !0, $1742e55f55c10e98$var$rl($1742e55f55c10e98$var$hc, function() {
        $1742e55f55c10e98$var$tl();
        return null;
    }));
}
function $1742e55f55c10e98$var$Kl(a, b, c) {
    b = $1742e55f55c10e98$var$lj(c, b);
    b = $1742e55f55c10e98$var$pj(a, b, 1);
    a = $1742e55f55c10e98$var$Bh(a, b, 1);
    b = $1742e55f55c10e98$var$Ri();
    null !== a && ($1742e55f55c10e98$var$Mc(a, 1, b), $1742e55f55c10e98$var$pl(a, b));
}
function $1742e55f55c10e98$var$W(a, b, c) {
    if (3 === a.tag) $1742e55f55c10e98$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $1742e55f55c10e98$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $1742e55f55c10e98$var$tj || !$1742e55f55c10e98$var$tj.has(d))) {
                a = $1742e55f55c10e98$var$lj(c, a);
                a = $1742e55f55c10e98$var$sj(b, a, 1);
                b = $1742e55f55c10e98$var$Bh(b, a, 1);
                a = $1742e55f55c10e98$var$Ri();
                null !== b && ($1742e55f55c10e98$var$Mc(b, 1, a), $1742e55f55c10e98$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $1742e55f55c10e98$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $1742e55f55c10e98$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $1742e55f55c10e98$var$Q === a && ($1742e55f55c10e98$var$Z & c) === c && (4 === $1742e55f55c10e98$var$T || 3 === $1742e55f55c10e98$var$T && ($1742e55f55c10e98$var$Z & 130023424) === $1742e55f55c10e98$var$Z && 500 > $1742e55f55c10e98$var$A() - $1742e55f55c10e98$var$Qk ? $1742e55f55c10e98$var$wl(a, 0) : $1742e55f55c10e98$var$cl |= c);
    $1742e55f55c10e98$var$pl(a, b);
}
function $1742e55f55c10e98$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $1742e55f55c10e98$var$Ec, $1742e55f55c10e98$var$Ec <<= 1, 0 === ($1742e55f55c10e98$var$Ec & 130023424) && ($1742e55f55c10e98$var$Ec = 4194304)));
    var c = $1742e55f55c10e98$var$Ri();
    a = $1742e55f55c10e98$var$wh(a, b);
    null !== a && ($1742e55f55c10e98$var$Mc(a, b, c), $1742e55f55c10e98$var$pl(a, c));
}
function $1742e55f55c10e98$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $1742e55f55c10e98$var$Ll(a, c);
}
function $1742e55f55c10e98$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($1742e55f55c10e98$var$p(314));
    }
    null !== d && d.delete(b);
    $1742e55f55c10e98$var$Ll(a, c);
}
var $1742e55f55c10e98$var$Il;
$1742e55f55c10e98$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $1742e55f55c10e98$var$jg.current) $1742e55f55c10e98$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $1742e55f55c10e98$var$rh = !1, $1742e55f55c10e98$var$ek(a, b, c);
            $1742e55f55c10e98$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $1742e55f55c10e98$var$rh = !1, $1742e55f55c10e98$var$J && 0 !== (b.flags & 1048576) && $1742e55f55c10e98$var$Ig(b, $1742e55f55c10e98$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $1742e55f55c10e98$var$Mj(a, b);
            a = b.pendingProps;
            var e = $1742e55f55c10e98$var$lg(b, $1742e55f55c10e98$var$I.current);
            $1742e55f55c10e98$var$qh(b, c);
            $1742e55f55c10e98$var$sc(b);
            e = $1742e55f55c10e98$var$ai(null, b, d, a, e, c);
            var f = $1742e55f55c10e98$var$fi();
            $1742e55f55c10e98$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $1742e55f55c10e98$var$mg(d) ? (f = !0, $1742e55f55c10e98$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $1742e55f55c10e98$var$yh(b), e.updater = $1742e55f55c10e98$var$gj, b.stateNode = e, e._reactInternals = b, $1742e55f55c10e98$var$kj(b, d, a, c), b = $1742e55f55c10e98$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $1742e55f55c10e98$var$J && f && $1742e55f55c10e98$var$Jg(b), $1742e55f55c10e98$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $1742e55f55c10e98$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $1742e55f55c10e98$var$Ml(d);
                a = $1742e55f55c10e98$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $1742e55f55c10e98$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $1742e55f55c10e98$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $1742e55f55c10e98$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $1742e55f55c10e98$var$Dj(null, b, d, $1742e55f55c10e98$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($1742e55f55c10e98$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1742e55f55c10e98$var$ej(d, e), $1742e55f55c10e98$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1742e55f55c10e98$var$ej(d, e), $1742e55f55c10e98$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $1742e55f55c10e98$var$Oj(b);
                if (null === a) throw Error($1742e55f55c10e98$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $1742e55f55c10e98$var$zh(a, b);
                $1742e55f55c10e98$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $1742e55f55c10e98$var$lj(Error($1742e55f55c10e98$var$p(423)), b);
                        b = $1742e55f55c10e98$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $1742e55f55c10e98$var$lj(Error($1742e55f55c10e98$var$p(424)), b);
                        b = $1742e55f55c10e98$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($1742e55f55c10e98$var$Mg = $1742e55f55c10e98$var$Zf(b.stateNode.containerInfo.firstChild), $1742e55f55c10e98$var$Lg = b, $1742e55f55c10e98$var$J = !0, $1742e55f55c10e98$var$Ng = null, c = $1742e55f55c10e98$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $1742e55f55c10e98$var$Wg();
                    if (d === e) {
                        b = $1742e55f55c10e98$var$Cj(a, b, c);
                        break a;
                    }
                    $1742e55f55c10e98$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $1742e55f55c10e98$var$Oh(b), null === a && $1742e55f55c10e98$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $1742e55f55c10e98$var$Sf(d, e) ? g = null : null !== f && $1742e55f55c10e98$var$Sf(d, f) && (b.flags |= 32), $1742e55f55c10e98$var$Kj(a, b), $1742e55f55c10e98$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $1742e55f55c10e98$var$Sg(b), null;
        case 13:
            return $1742e55f55c10e98$var$Uj(a, b, c);
        case 4:
            return $1742e55f55c10e98$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $1742e55f55c10e98$var$hh(b, null, d, c) : $1742e55f55c10e98$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1742e55f55c10e98$var$ej(d, e), $1742e55f55c10e98$var$Bj(a, b, d, e, c);
        case 7:
            return $1742e55f55c10e98$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $1742e55f55c10e98$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $1742e55f55c10e98$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $1742e55f55c10e98$var$H($1742e55f55c10e98$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($1742e55f55c10e98$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$1742e55f55c10e98$var$jg.current) {
                            b = $1742e55f55c10e98$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $1742e55f55c10e98$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $1742e55f55c10e98$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($1742e55f55c10e98$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $1742e55f55c10e98$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $1742e55f55c10e98$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $1742e55f55c10e98$var$qh(b, c), e = $1742e55f55c10e98$var$sh(e), $1742e55f55c10e98$var$sc(b), d = d(e), $1742e55f55c10e98$var$tc(), b.flags |= 1, $1742e55f55c10e98$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $1742e55f55c10e98$var$ej(d, b.pendingProps), e = $1742e55f55c10e98$var$ej(d.type, e), $1742e55f55c10e98$var$Dj(a, b, d, e, c);
        case 15:
            return $1742e55f55c10e98$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1742e55f55c10e98$var$ej(d, e), $1742e55f55c10e98$var$Mj(a, b), b.tag = 1, $1742e55f55c10e98$var$mg(d) ? (a = !0, $1742e55f55c10e98$var$qg(b)) : a = !1, $1742e55f55c10e98$var$qh(b, c), $1742e55f55c10e98$var$ij(b, d, e), $1742e55f55c10e98$var$kj(b, d, e, c), $1742e55f55c10e98$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $1742e55f55c10e98$var$dk(a, b, c);
        case 22:
            return $1742e55f55c10e98$var$Hj(a, b, c);
    }
    throw Error($1742e55f55c10e98$var$p(156, b.tag));
};
function $1742e55f55c10e98$var$wj(a, b) {
    $1742e55f55c10e98$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $1742e55f55c10e98$var$Pc(a, c, b);
    });
}
function $1742e55f55c10e98$var$rl(a, b) {
    return $1742e55f55c10e98$var$ac(a, b);
}
function $1742e55f55c10e98$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $1742e55f55c10e98$var$Pg(a, b, c, d) {
    return new $1742e55f55c10e98$var$Nl(a, b, c, d);
}
function $1742e55f55c10e98$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $1742e55f55c10e98$var$Ml(a) {
    if ("function" === typeof a) return $1742e55f55c10e98$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $1742e55f55c10e98$var$Da) return 11;
        if (a === $1742e55f55c10e98$var$Ga) return 14;
    }
    return 2;
}
function $1742e55f55c10e98$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $1742e55f55c10e98$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $1742e55f55c10e98$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $1742e55f55c10e98$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $1742e55f55c10e98$var$ya:
            return $1742e55f55c10e98$var$gh(c.children, e, f, b);
        case $1742e55f55c10e98$var$za:
            g = 8;
            e |= 8;
            break;
        case $1742e55f55c10e98$var$Aa:
            return a = $1742e55f55c10e98$var$Pg(12, c, b, e | 2), a.elementType = $1742e55f55c10e98$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $1742e55f55c10e98$var$Ea:
            return a = $1742e55f55c10e98$var$Pg(13, c, b, e), a.elementType = $1742e55f55c10e98$var$Ea, a.lanes = f, a;
        case $1742e55f55c10e98$var$Fa:
            return a = $1742e55f55c10e98$var$Pg(19, c, b, e), a.elementType = $1742e55f55c10e98$var$Fa, a.lanes = f, a;
        case $1742e55f55c10e98$var$Ia:
            return $1742e55f55c10e98$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $1742e55f55c10e98$var$Ba:
                    g = 10;
                    break a;
                case $1742e55f55c10e98$var$Ca:
                    g = 9;
                    break a;
                case $1742e55f55c10e98$var$Da:
                    g = 11;
                    break a;
                case $1742e55f55c10e98$var$Ga:
                    g = 14;
                    break a;
                case $1742e55f55c10e98$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($1742e55f55c10e98$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $1742e55f55c10e98$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $1742e55f55c10e98$var$gh(a, b, c, d) {
    a = $1742e55f55c10e98$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $1742e55f55c10e98$var$Vj(a, b, c, d) {
    a = $1742e55f55c10e98$var$Pg(22, a, d, b);
    a.elementType = $1742e55f55c10e98$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $1742e55f55c10e98$var$dh(a, b, c) {
    a = $1742e55f55c10e98$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $1742e55f55c10e98$var$fh(a, b, c) {
    b = $1742e55f55c10e98$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $1742e55f55c10e98$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $1742e55f55c10e98$var$Lc(0);
    this.expirationTimes = $1742e55f55c10e98$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $1742e55f55c10e98$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $1742e55f55c10e98$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $1742e55f55c10e98$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $1742e55f55c10e98$var$mc && (b |= 2);
    f = $1742e55f55c10e98$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $1742e55f55c10e98$var$yh(f);
    return a;
}
function $1742e55f55c10e98$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $1742e55f55c10e98$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $1742e55f55c10e98$var$Rl(a) {
    if (!a) return $1742e55f55c10e98$var$ig;
    a = a._reactInternals;
    a: {
        if ($1742e55f55c10e98$var$Vb(a) !== a || 1 !== a.tag) throw Error($1742e55f55c10e98$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($1742e55f55c10e98$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($1742e55f55c10e98$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($1742e55f55c10e98$var$mg(c)) return $1742e55f55c10e98$var$pg(a, c, b);
    }
    return b;
}
function $1742e55f55c10e98$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $1742e55f55c10e98$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $1742e55f55c10e98$var$Rl(null);
    c = a.current;
    d = $1742e55f55c10e98$var$Ri();
    e = $1742e55f55c10e98$var$Oi(c);
    f = $1742e55f55c10e98$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $1742e55f55c10e98$var$Bh(c, f, e);
    a.current.lanes = e;
    $1742e55f55c10e98$var$Mc(a, e, d);
    $1742e55f55c10e98$var$pl(a, d);
    return a;
}
function $1742e55f55c10e98$var$Tl(a, b, c, d) {
    var e = b.current, f = $1742e55f55c10e98$var$Ri(), g = $1742e55f55c10e98$var$Oi(e);
    null !== $1742e55f55c10e98$var$B && "function" === typeof $1742e55f55c10e98$var$B.markRenderScheduled && $1742e55f55c10e98$var$B.markRenderScheduled(g);
    c = $1742e55f55c10e98$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $1742e55f55c10e98$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $1742e55f55c10e98$var$Bh(e, b, g);
    null !== a && ($1742e55f55c10e98$var$ui(a, e, g, f), $1742e55f55c10e98$var$Ch(a, e, g));
    return g;
}
function $1742e55f55c10e98$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $1742e55f55c10e98$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $1742e55f55c10e98$var$Wl(a, b) {
    $1742e55f55c10e98$var$Vl(a, b);
    (a = a.alternate) && $1742e55f55c10e98$var$Vl(a, b);
}
function $1742e55f55c10e98$var$Xl() {
    return null;
}
var $1742e55f55c10e98$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $1742e55f55c10e98$var$Zl(a) {
    this._internalRoot = a;
}
$1742e55f55c10e98$var$$l.prototype.render = $1742e55f55c10e98$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($1742e55f55c10e98$var$p(409));
    $1742e55f55c10e98$var$Tl(a, b, null, null);
};
$1742e55f55c10e98$var$$l.prototype.unmount = $1742e55f55c10e98$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $1742e55f55c10e98$var$El(function() {
            $1742e55f55c10e98$var$Tl(null, a, null, null);
        });
        b[$1742e55f55c10e98$var$If] = null;
    }
};
function $1742e55f55c10e98$var$$l(a) {
    this._internalRoot = a;
}
$1742e55f55c10e98$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $1742e55f55c10e98$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $1742e55f55c10e98$var$dd.length && 0 !== b && b < $1742e55f55c10e98$var$dd[c].priority; c++);
        $1742e55f55c10e98$var$dd.splice(c, 0, a);
        0 === c && $1742e55f55c10e98$var$id(a);
    }
};
function $1742e55f55c10e98$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $1742e55f55c10e98$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $1742e55f55c10e98$var$cm() {}
function $1742e55f55c10e98$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $1742e55f55c10e98$var$Ul(g);
                f.call(a);
            };
        }
        var g = $1742e55f55c10e98$var$Sl(b, d, a, 0, null, !1, !1, "", $1742e55f55c10e98$var$cm);
        a._reactRootContainer = g;
        a[$1742e55f55c10e98$var$If] = g.current;
        $1742e55f55c10e98$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $1742e55f55c10e98$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $1742e55f55c10e98$var$Ul(k);
            h.call(a);
        };
    }
    var k = $1742e55f55c10e98$var$Pl(a, 0, !1, null, null, !1, !1, "", $1742e55f55c10e98$var$cm);
    a._reactRootContainer = k;
    a[$1742e55f55c10e98$var$If] = k.current;
    $1742e55f55c10e98$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $1742e55f55c10e98$var$El(function() {
        $1742e55f55c10e98$var$Tl(b, k, c, d);
    });
    return k;
}
function $1742e55f55c10e98$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $1742e55f55c10e98$var$Ul(g);
                h.call(a);
            };
        }
        $1742e55f55c10e98$var$Tl(b, g, a, e);
    } else g = $1742e55f55c10e98$var$dm(c, b, a, e, d);
    return $1742e55f55c10e98$var$Ul(g);
}
$1742e55f55c10e98$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $1742e55f55c10e98$var$Fc(b.pendingLanes);
                0 !== c && ($1742e55f55c10e98$var$Oc(b, c | 1), $1742e55f55c10e98$var$pl(b, $1742e55f55c10e98$var$A()), 0 === ($1742e55f55c10e98$var$K & 6) && ($1742e55f55c10e98$var$mk = $1742e55f55c10e98$var$A() + 500, $1742e55f55c10e98$var$xg()));
            }
            break;
        case 13:
            $1742e55f55c10e98$var$El(function() {
                var b = $1742e55f55c10e98$var$wh(a, 1);
                if (null !== b) {
                    var c = $1742e55f55c10e98$var$Ri();
                    $1742e55f55c10e98$var$ui(b, a, 1, c);
                }
            }), $1742e55f55c10e98$var$Wl(a, 1);
    }
};
$1742e55f55c10e98$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $1742e55f55c10e98$var$wh(a, 134217728);
        if (null !== b) {
            var c = $1742e55f55c10e98$var$Ri();
            $1742e55f55c10e98$var$ui(b, a, 134217728, c);
        }
        $1742e55f55c10e98$var$Wl(a, 134217728);
    }
};
$1742e55f55c10e98$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $1742e55f55c10e98$var$Oi(a), c = $1742e55f55c10e98$var$wh(a, b);
        if (null !== c) {
            var d = $1742e55f55c10e98$var$Ri();
            $1742e55f55c10e98$var$ui(c, a, b, d);
        }
        $1742e55f55c10e98$var$Wl(a, b);
    }
};
$1742e55f55c10e98$var$Vc = function() {
    return $1742e55f55c10e98$var$E;
};
$1742e55f55c10e98$var$Wc = function(a, b) {
    var c = $1742e55f55c10e98$var$E;
    try {
        return $1742e55f55c10e98$var$E = a, b();
    } finally{
        $1742e55f55c10e98$var$E = c;
    }
};
$1742e55f55c10e98$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $1742e55f55c10e98$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $1742e55f55c10e98$var$Db(d);
                        if (!e) throw Error($1742e55f55c10e98$var$p(90));
                        $1742e55f55c10e98$var$Wa(d);
                        $1742e55f55c10e98$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $1742e55f55c10e98$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $1742e55f55c10e98$var$eb(a, !!c.multiple, b, !1);
    }
};
$1742e55f55c10e98$var$Gb = $1742e55f55c10e98$var$Dl;
$1742e55f55c10e98$var$Hb = $1742e55f55c10e98$var$El;
var $1742e55f55c10e98$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $1742e55f55c10e98$var$Cb,
        $1742e55f55c10e98$var$Ie,
        $1742e55f55c10e98$var$Db,
        $1742e55f55c10e98$var$Eb,
        $1742e55f55c10e98$var$Fb,
        $1742e55f55c10e98$var$Dl
    ]
}, $1742e55f55c10e98$var$gm = {
    findFiberByHostInstance: $1742e55f55c10e98$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $1742e55f55c10e98$var$u({}, a, {
            getLaneLabelMap: $1742e55f55c10e98$var$pc,
            injectProfilingHooks: $1742e55f55c10e98$var$oc
        }), $1742e55f55c10e98$var$kc = b.inject(a), $1742e55f55c10e98$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $1742e55f55c10e98$var$gm.bundleType,
    version: $1742e55f55c10e98$var$gm.version,
    rendererPackageName: $1742e55f55c10e98$var$gm.rendererPackageName,
    rendererConfig: $1742e55f55c10e98$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $1742e55f55c10e98$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $1742e55f55c10e98$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $1742e55f55c10e98$var$gm.findFiberByHostInstance || $1742e55f55c10e98$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$1742e55f55c10e98$export$ae55be85d98224ed = $1742e55f55c10e98$var$fm;
$1742e55f55c10e98$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$1742e55f55c10e98$var$am(b)) throw Error($1742e55f55c10e98$var$p(200));
    return $1742e55f55c10e98$var$Ql(a, b, null, c);
};
$1742e55f55c10e98$export$882461b6382ed46c = function(a, b) {
    if (!$1742e55f55c10e98$var$am(a)) throw Error($1742e55f55c10e98$var$p(299));
    var c = !1, d = "", e = $1742e55f55c10e98$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $1742e55f55c10e98$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$1742e55f55c10e98$var$If] = b.current;
    $1742e55f55c10e98$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $1742e55f55c10e98$var$Zl(b);
};
$1742e55f55c10e98$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($1742e55f55c10e98$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($1742e55f55c10e98$var$p(268, a));
    }
    a = $1742e55f55c10e98$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$1742e55f55c10e98$export$cd75ccfd720a3cd4 = function(a) {
    return $1742e55f55c10e98$var$El(a);
};
$1742e55f55c10e98$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$1742e55f55c10e98$var$bm(b)) throw Error($1742e55f55c10e98$var$p(200));
    return $1742e55f55c10e98$var$em(null, a, b, !0, c);
};
$1742e55f55c10e98$export$757ceba2d55c277e = function(a, b, c) {
    if (!$1742e55f55c10e98$var$am(a)) throw Error($1742e55f55c10e98$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $1742e55f55c10e98$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $1742e55f55c10e98$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$1742e55f55c10e98$var$If] = b.current;
    $1742e55f55c10e98$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $1742e55f55c10e98$var$$l(b);
};
$1742e55f55c10e98$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$1742e55f55c10e98$var$bm(b)) throw Error($1742e55f55c10e98$var$p(200));
    return $1742e55f55c10e98$var$em(null, a, b, !1, c);
};
$1742e55f55c10e98$export$502457920280e6be = function(a) {
    if (!$1742e55f55c10e98$var$bm(a)) throw Error($1742e55f55c10e98$var$p(40));
    return a._reactRootContainer ? ($1742e55f55c10e98$var$El(function() {
        $1742e55f55c10e98$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$1742e55f55c10e98$var$If] = null;
        });
    }), !0) : !1;
};
$1742e55f55c10e98$export$c78a37762a8d58e1 = $1742e55f55c10e98$var$Dl;
$1742e55f55c10e98$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$1742e55f55c10e98$var$bm(c)) throw Error($1742e55f55c10e98$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($1742e55f55c10e98$var$p(38));
    return $1742e55f55c10e98$var$em(a, b, c, !1, d);
};
$1742e55f55c10e98$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("gEGs3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eAQwt"));

});
parcelRegister("eAQwt", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $a9fd2b6b8ac8070c$export$c4744153514ff05d, (v) => $a9fd2b6b8ac8070c$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a9fd2b6b8ac8070c$export$3e506c1ccc9cc1a7, (v) => $a9fd2b6b8ac8070c$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a9fd2b6b8ac8070c$export$e26fe2ed2fa76875, (v) => $a9fd2b6b8ac8070c$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a9fd2b6b8ac8070c$export$502329bbf4b505b1, (v) => $a9fd2b6b8ac8070c$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a9fd2b6b8ac8070c$export$6e3807111c4874c4, (v) => $a9fd2b6b8ac8070c$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a9fd2b6b8ac8070c$export$c27134553091fb3a, (v) => $a9fd2b6b8ac8070c$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a9fd2b6b8ac8070c$export$33ee1acdc04fd2a2, (v) => $a9fd2b6b8ac8070c$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a9fd2b6b8ac8070c$export$b00a404bbd5edef2, (v) => $a9fd2b6b8ac8070c$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $a9fd2b6b8ac8070c$export$8352ce38b91d0c62, (v) => $a9fd2b6b8ac8070c$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a9fd2b6b8ac8070c$export$d66a1c1c77bd778b, (v) => $a9fd2b6b8ac8070c$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a9fd2b6b8ac8070c$export$d3dfb8e4810cb555, (v) => $a9fd2b6b8ac8070c$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $a9fd2b6b8ac8070c$export$839f9183b0465a69, (v) => $a9fd2b6b8ac8070c$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $a9fd2b6b8ac8070c$export$72fdf0e06517287b, (v) => $a9fd2b6b8ac8070c$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $a9fd2b6b8ac8070c$export$4b844e58a3e414b4, (v) => $a9fd2b6b8ac8070c$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a9fd2b6b8ac8070c$export$816d2913ae6b83b1, (v) => $a9fd2b6b8ac8070c$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a9fd2b6b8ac8070c$export$61bcfe829111a1d0, (v) => $a9fd2b6b8ac8070c$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a9fd2b6b8ac8070c$export$7ee8c9beb337bc3f, (v) => $a9fd2b6b8ac8070c$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a9fd2b6b8ac8070c$export$b5836b71941fa3ed, (v) => $a9fd2b6b8ac8070c$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a9fd2b6b8ac8070c$export$cf845f2c119da08a, (v) => $a9fd2b6b8ac8070c$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a9fd2b6b8ac8070c$export$c4744153514ff05d;
var $a9fd2b6b8ac8070c$export$3e506c1ccc9cc1a7;
var $a9fd2b6b8ac8070c$export$e26fe2ed2fa76875;
var $a9fd2b6b8ac8070c$export$502329bbf4b505b1;
var $a9fd2b6b8ac8070c$export$6e3807111c4874c4;
var $a9fd2b6b8ac8070c$export$c27134553091fb3a;
var $a9fd2b6b8ac8070c$export$33ee1acdc04fd2a2;
var $a9fd2b6b8ac8070c$export$b00a404bbd5edef2;
var $a9fd2b6b8ac8070c$export$8352ce38b91d0c62;
var $a9fd2b6b8ac8070c$export$d66a1c1c77bd778b;
var $a9fd2b6b8ac8070c$export$d3dfb8e4810cb555;
var $a9fd2b6b8ac8070c$export$839f9183b0465a69;
var $a9fd2b6b8ac8070c$export$72fdf0e06517287b;
var $a9fd2b6b8ac8070c$export$4b844e58a3e414b4;
var $a9fd2b6b8ac8070c$export$816d2913ae6b83b1;
var $a9fd2b6b8ac8070c$export$61bcfe829111a1d0;
var $a9fd2b6b8ac8070c$export$7ee8c9beb337bc3f;
var $a9fd2b6b8ac8070c$export$b5836b71941fa3ed;
var $a9fd2b6b8ac8070c$export$cf845f2c119da08a;
'use strict';
function $a9fd2b6b8ac8070c$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a9fd2b6b8ac8070c$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a9fd2b6b8ac8070c$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a9fd2b6b8ac8070c$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a9fd2b6b8ac8070c$var$g(C, c)) n < e && 0 > $a9fd2b6b8ac8070c$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a9fd2b6b8ac8070c$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a9fd2b6b8ac8070c$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a9fd2b6b8ac8070c$var$l = performance;
    $a9fd2b6b8ac8070c$export$c4744153514ff05d = function() {
        return $a9fd2b6b8ac8070c$var$l.now();
    };
} else {
    var $a9fd2b6b8ac8070c$var$p = Date, $a9fd2b6b8ac8070c$var$q = $a9fd2b6b8ac8070c$var$p.now();
    $a9fd2b6b8ac8070c$export$c4744153514ff05d = function() {
        return $a9fd2b6b8ac8070c$var$p.now() - $a9fd2b6b8ac8070c$var$q;
    };
}
var $a9fd2b6b8ac8070c$var$r = [], $a9fd2b6b8ac8070c$var$t = [], $a9fd2b6b8ac8070c$var$u = 1, $a9fd2b6b8ac8070c$var$v = null, $a9fd2b6b8ac8070c$var$y = 3, $a9fd2b6b8ac8070c$var$z = !1, $a9fd2b6b8ac8070c$var$A = !1, $a9fd2b6b8ac8070c$var$B = !1, $a9fd2b6b8ac8070c$var$D = "function" === typeof setTimeout ? setTimeout : null, $a9fd2b6b8ac8070c$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a9fd2b6b8ac8070c$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a9fd2b6b8ac8070c$var$G(a) {
    for(var b = $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$t); null !== b;){
        if (null === b.callback) $a9fd2b6b8ac8070c$var$k($a9fd2b6b8ac8070c$var$t);
        else if (b.startTime <= a) $a9fd2b6b8ac8070c$var$k($a9fd2b6b8ac8070c$var$t), b.sortIndex = b.expirationTime, $a9fd2b6b8ac8070c$var$f($a9fd2b6b8ac8070c$var$r, b);
        else break;
        b = $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$t);
    }
}
function $a9fd2b6b8ac8070c$var$H(a) {
    $a9fd2b6b8ac8070c$var$B = !1;
    $a9fd2b6b8ac8070c$var$G(a);
    if (!$a9fd2b6b8ac8070c$var$A) {
        if (null !== $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$r)) $a9fd2b6b8ac8070c$var$A = !0, $a9fd2b6b8ac8070c$var$I($a9fd2b6b8ac8070c$var$J);
        else {
            var b = $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$t);
            null !== b && $a9fd2b6b8ac8070c$var$K($a9fd2b6b8ac8070c$var$H, b.startTime - a);
        }
    }
}
function $a9fd2b6b8ac8070c$var$J(a, b) {
    $a9fd2b6b8ac8070c$var$A = !1;
    $a9fd2b6b8ac8070c$var$B && ($a9fd2b6b8ac8070c$var$B = !1, $a9fd2b6b8ac8070c$var$E($a9fd2b6b8ac8070c$var$L), $a9fd2b6b8ac8070c$var$L = -1);
    $a9fd2b6b8ac8070c$var$z = !0;
    var c = $a9fd2b6b8ac8070c$var$y;
    try {
        $a9fd2b6b8ac8070c$var$G(b);
        for($a9fd2b6b8ac8070c$var$v = $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$r); null !== $a9fd2b6b8ac8070c$var$v && (!($a9fd2b6b8ac8070c$var$v.expirationTime > b) || a && !$a9fd2b6b8ac8070c$var$M());){
            var d = $a9fd2b6b8ac8070c$var$v.callback;
            if ("function" === typeof d) {
                $a9fd2b6b8ac8070c$var$v.callback = null;
                $a9fd2b6b8ac8070c$var$y = $a9fd2b6b8ac8070c$var$v.priorityLevel;
                var e = d($a9fd2b6b8ac8070c$var$v.expirationTime <= b);
                b = $a9fd2b6b8ac8070c$export$c4744153514ff05d();
                "function" === typeof e ? $a9fd2b6b8ac8070c$var$v.callback = e : $a9fd2b6b8ac8070c$var$v === $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$r) && $a9fd2b6b8ac8070c$var$k($a9fd2b6b8ac8070c$var$r);
                $a9fd2b6b8ac8070c$var$G(b);
            } else $a9fd2b6b8ac8070c$var$k($a9fd2b6b8ac8070c$var$r);
            $a9fd2b6b8ac8070c$var$v = $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$r);
        }
        if (null !== $a9fd2b6b8ac8070c$var$v) var w = !0;
        else {
            var m = $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$t);
            null !== m && $a9fd2b6b8ac8070c$var$K($a9fd2b6b8ac8070c$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a9fd2b6b8ac8070c$var$v = null, $a9fd2b6b8ac8070c$var$y = c, $a9fd2b6b8ac8070c$var$z = !1;
    }
}
var $a9fd2b6b8ac8070c$var$N = !1, $a9fd2b6b8ac8070c$var$O = null, $a9fd2b6b8ac8070c$var$L = -1, $a9fd2b6b8ac8070c$var$P = 5, $a9fd2b6b8ac8070c$var$Q = -1;
function $a9fd2b6b8ac8070c$var$M() {
    return $a9fd2b6b8ac8070c$export$c4744153514ff05d() - $a9fd2b6b8ac8070c$var$Q < $a9fd2b6b8ac8070c$var$P ? !1 : !0;
}
function $a9fd2b6b8ac8070c$var$R() {
    if (null !== $a9fd2b6b8ac8070c$var$O) {
        var a = $a9fd2b6b8ac8070c$export$c4744153514ff05d();
        $a9fd2b6b8ac8070c$var$Q = a;
        var b = !0;
        try {
            b = $a9fd2b6b8ac8070c$var$O(!0, a);
        } finally{
            b ? $a9fd2b6b8ac8070c$var$S() : ($a9fd2b6b8ac8070c$var$N = !1, $a9fd2b6b8ac8070c$var$O = null);
        }
    } else $a9fd2b6b8ac8070c$var$N = !1;
}
var $a9fd2b6b8ac8070c$var$S;
if ("function" === typeof $a9fd2b6b8ac8070c$var$F) $a9fd2b6b8ac8070c$var$S = function() {
    $a9fd2b6b8ac8070c$var$F($a9fd2b6b8ac8070c$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a9fd2b6b8ac8070c$var$T = new MessageChannel, $a9fd2b6b8ac8070c$var$U = $a9fd2b6b8ac8070c$var$T.port2;
    $a9fd2b6b8ac8070c$var$T.port1.onmessage = $a9fd2b6b8ac8070c$var$R;
    $a9fd2b6b8ac8070c$var$S = function() {
        $a9fd2b6b8ac8070c$var$U.postMessage(null);
    };
} else $a9fd2b6b8ac8070c$var$S = function() {
    $a9fd2b6b8ac8070c$var$D($a9fd2b6b8ac8070c$var$R, 0);
};
function $a9fd2b6b8ac8070c$var$I(a) {
    $a9fd2b6b8ac8070c$var$O = a;
    $a9fd2b6b8ac8070c$var$N || ($a9fd2b6b8ac8070c$var$N = !0, $a9fd2b6b8ac8070c$var$S());
}
function $a9fd2b6b8ac8070c$var$K(a, b) {
    $a9fd2b6b8ac8070c$var$L = $a9fd2b6b8ac8070c$var$D(function() {
        a($a9fd2b6b8ac8070c$export$c4744153514ff05d());
    }, b);
}
$a9fd2b6b8ac8070c$export$3e506c1ccc9cc1a7 = 5;
$a9fd2b6b8ac8070c$export$e26fe2ed2fa76875 = 1;
$a9fd2b6b8ac8070c$export$502329bbf4b505b1 = 4;
$a9fd2b6b8ac8070c$export$6e3807111c4874c4 = 3;
$a9fd2b6b8ac8070c$export$c27134553091fb3a = null;
$a9fd2b6b8ac8070c$export$33ee1acdc04fd2a2 = 2;
$a9fd2b6b8ac8070c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a9fd2b6b8ac8070c$export$8352ce38b91d0c62 = function() {
    $a9fd2b6b8ac8070c$var$A || $a9fd2b6b8ac8070c$var$z || ($a9fd2b6b8ac8070c$var$A = !0, $a9fd2b6b8ac8070c$var$I($a9fd2b6b8ac8070c$var$J));
};
$a9fd2b6b8ac8070c$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a9fd2b6b8ac8070c$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a9fd2b6b8ac8070c$export$d3dfb8e4810cb555 = function() {
    return $a9fd2b6b8ac8070c$var$y;
};
$a9fd2b6b8ac8070c$export$839f9183b0465a69 = function() {
    return $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$r);
};
$a9fd2b6b8ac8070c$export$72fdf0e06517287b = function(a) {
    switch($a9fd2b6b8ac8070c$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a9fd2b6b8ac8070c$var$y;
    }
    var c = $a9fd2b6b8ac8070c$var$y;
    $a9fd2b6b8ac8070c$var$y = b;
    try {
        return a();
    } finally{
        $a9fd2b6b8ac8070c$var$y = c;
    }
};
$a9fd2b6b8ac8070c$export$4b844e58a3e414b4 = function() {};
$a9fd2b6b8ac8070c$export$816d2913ae6b83b1 = function() {};
$a9fd2b6b8ac8070c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a9fd2b6b8ac8070c$var$y;
    $a9fd2b6b8ac8070c$var$y = a;
    try {
        return b();
    } finally{
        $a9fd2b6b8ac8070c$var$y = c;
    }
};
$a9fd2b6b8ac8070c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a9fd2b6b8ac8070c$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a9fd2b6b8ac8070c$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a9fd2b6b8ac8070c$var$f($a9fd2b6b8ac8070c$var$t, a), null === $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$r) && a === $a9fd2b6b8ac8070c$var$h($a9fd2b6b8ac8070c$var$t) && ($a9fd2b6b8ac8070c$var$B ? ($a9fd2b6b8ac8070c$var$E($a9fd2b6b8ac8070c$var$L), $a9fd2b6b8ac8070c$var$L = -1) : $a9fd2b6b8ac8070c$var$B = !0, $a9fd2b6b8ac8070c$var$K($a9fd2b6b8ac8070c$var$H, c - d))) : (a.sortIndex = e, $a9fd2b6b8ac8070c$var$f($a9fd2b6b8ac8070c$var$r, a), $a9fd2b6b8ac8070c$var$A || $a9fd2b6b8ac8070c$var$z || ($a9fd2b6b8ac8070c$var$A = !0, $a9fd2b6b8ac8070c$var$I($a9fd2b6b8ac8070c$var$J)));
    return a;
};
$a9fd2b6b8ac8070c$export$b5836b71941fa3ed = $a9fd2b6b8ac8070c$var$M;
$a9fd2b6b8ac8070c$export$cf845f2c119da08a = function(a) {
    var b = $a9fd2b6b8ac8070c$var$y;
    return function() {
        var c = $a9fd2b6b8ac8070c$var$y;
        $a9fd2b6b8ac8070c$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a9fd2b6b8ac8070c$var$y = c;
        }
    };
};

});




parcelRegister("cSa27", function(module, exports) {
$parcel$export(module.exports, "default", () => $57d8f33ed5ff08c2$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $3p8Bc = parcelRequire("3p8Bc");

var $GqzVB = parcelRequire("GqzVB");

var $fBWTV = parcelRequire("fBWTV");

var $8lGYd = parcelRequire("8lGYd");

var $1O6oo = parcelRequire("1O6oo");

var $dnigo = parcelRequire("dnigo");

var $3Dje8 = parcelRequire("3Dje8");

var $hPcNy = parcelRequire("hPcNy");

var $bNAzG = parcelRequire("bNAzG");

var $5ksDi = parcelRequire("5ksDi");

var $a0IXt = parcelRequire("a0IXt");
const $57d8f33ed5ff08c2$var$packageName = undefined;
const $57d8f33ed5ff08c2$var$packageVersion = undefined;
const $57d8f33ed5ff08c2$var$containerStyles = null;
const $57d8f33ed5ff08c2$var$updatedHexagonNegativeMarginMap = {
    xxsmall: "_6rth1b3j _1pfh1b3j",
    small: "_6rth1tv6 _1pfh1tv6",
    medium: "_6rth1lmm _1pfh1lmm",
    large: "_6rth1wmd _1pfh1wmd",
    xlarge: "_6rth130q _1pfh130q",
    xxlarge: "_6rthyzhl _1pfhyzhl"
};
const $57d8f33ed5ff08c2$var$normalizeAvatarSize = (size)=>size === 'xsmall' && !(0, $fBWTV.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size;
const $57d8f33ed5ff08c2$var$Avatar = /*#__PURE__*/ (0, $lE8gv.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $3p8Bc.useAnalyticsEvents)();
    const context = (0, $a0IXt.useAvatarContext)();
    const size = $57d8f33ed5ff08c2$var$normalizeAvatarSize(sizeProp || context?.size || 'medium');
    const isUpdatedHexagonGeometry = appearance === 'hexagon' && Boolean(UNSAFE_isUpdatedGeometry) && size !== 'UNSAFE_xsmall';
    const customPresenceNode = /*#__PURE__*/ (0, $lE8gv.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $lE8gv.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall';
    // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    const indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    const lastAnalytics = (0, $lE8gv.useRef)(analyticsContext);
    const labelId = (0, $GqzVB.useId)();
    (0, $lE8gv.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $lE8gv.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $57d8f33ed5ff08c2$var$packageName,
                packageVersion: $57d8f33ed5ff08c2$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ const context = {
            componentName: 'avatar',
            packageName: $57d8f33ed5ff08c2$var$packageName,
            packageVersion: $57d8f33ed5ff08c2$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $3Dje8.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $kOwiQ.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $l2NkF.default)([
                "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm",
                isUpdatedHexagonGeometry && $57d8f33ed5ff08c2$var$updatedHexagonNegativeMarginMap[size]
            ]),
            children: [
                /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $dnigo.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $hPcNy.default)(isDisabled, href, onClick, ariaHasPopup),
                        appearance: appearance,
                        UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        'aria-controls': ariaControls,
                        'aria-expanded': ariaExpanded,
                        'aria-haspopup': ariaHasPopup,
                        avatarImage: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $1O6oo.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                            size: size,
                            testId: testId,
                            imgLoading: imgLoading
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $8lGYd.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $bNAzG.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $5ksDi.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$57d8f33ed5ff08c2$var$Avatar.displayName = 'Avatar';
var $57d8f33ed5ff08c2$export$2e2bcd8739ae039 = $57d8f33ed5ff08c2$var$Avatar;

});
parcelRegister("GqzVB", function(module, exports) {
$parcel$export(module.exports, "useId", () => $7f71a7d8b35402ee$export$f680877a34711e37);

var $lE8gv = parcelRequire("lE8gv");
function $7f71a7d8b35402ee$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).useId().replace(/[:«»]/g, '_');
}

});

parcelRegister("8lGYd", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", () => $ee4214277d9bb425$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $fBWTV = parcelRequire("fBWTV");

var $dnigo = parcelRequire("dnigo");

var $iksqa = parcelRequire("iksqa");
const $ee4214277d9bb425$var$boxShadowCssVar = '--avatar-box-shadow';
const $ee4214277d9bb425$var$bgColorCssVar = '--avatar-bg-color';
const $ee4214277d9bb425$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $ee4214277d9bb425$var$unboundStyles = {
    root: "_11q7cxp3 _vchh1ntv _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _195g1ksc _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    updatedHexagonClipPath: "_mkrz1ezo",
    hexagonBorderContainer: "_11q7cxp3 _1rjcf6hp _18zruxly _1mou18m8 _195gzwb8 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v5641krm _m6k41e03 _1llweo6y"
};
const $ee4214277d9bb425$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_85i5pe44 _1q51pe44 _y4tipe44 _bozgpe44 _6rthn6b1 _1pfhn6b1 _12l2n6b1 _ahbqn6b1",
    hexagonFocusContainer: "_85i5i44o _1q51i44o _y4tii44o _bozgi44o _6rthnlpx _1pfhnlpx _12l2nlpx _ahbqnlpx"
};
// See https://hello.atlassian.net/wiki/spaces/DST/pages/7432283012
const $ee4214277d9bb425$var$updatedHexagonBorderFixStyles = {
    hexagonBorderContainer: "_85i5di1a _1q51di1a _y4tiidpf _bozgidpf _6rthwit5 _1pfhwit5 _12l2idpf _ahbqidpf",
    hexagonFocusContainer: "_85i51hhc _1q511hhc _y4ti1dm9 _bozg1dm9 _6rthypyw _1pfhypyw _12l21ksc _ahbq1ksc"
};
const $ee4214277d9bb425$var$widthHeightMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
// The sole source of truth for the updated hexagon width/height geometry (per size).
const $ee4214277d9bb425$var$updatedHexagonDimensionMap = {
    xxsmall: "_1bsbgaek _4t3ikzaa",
    small: "_1bsb1ftb _4t3i1pm0",
    medium: "_1bsb1cun _4t3i3vj5",
    large: "_1bsbctg4 _4t3i15zd",
    xlarge: "_1bsbovoe _4t3i1sfy",
    xxlarge: "_1bsbhec5 _4t3i1ejz"
};
const $ee4214277d9bb425$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $lE8gv.forwardRef)(({ children: children }, ref)=>{
    (0, $iksqa.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, $lE8gv.useContext)((0, $dnigo.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ (0, $kOwiQ.jsx)(Container, {
        style: {
            [$ee4214277d9bb425$var$bgColorCssVar]: borderColor,
            [$ee4214277d9bb425$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $l2NkF.default)([
            $ee4214277d9bb425$var$unboundStyles.root,
            $ee4214277d9bb425$var$styles.root,
            appearance === 'square' && $ee4214277d9bb425$var$styles.square,
            appearance === 'circle' && $ee4214277d9bb425$var$styles.circle,
            appearance === 'hexagon' && $ee4214277d9bb425$var$unboundStyles.hexagon,
            $ee4214277d9bb425$var$widthHeightMap[size],
            UNSAFE_isUpdatedGeometry && $ee4214277d9bb425$var$updatedHexagonDimensionMap[size],
            stackIndex !== undefined && $ee4214277d9bb425$var$styles.positionRelative,
            isInteractive && !isDisabled && $ee4214277d9bb425$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $fBWTV.fg)('platform-dst-motion-uplift') && $ee4214277d9bb425$var$unboundStyles.interactiveMotion,
            isDisabled && $ee4214277d9bb425$var$styles.disabled
        ]),
        children: children || avatarImage
    });
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        style: {
            [$ee4214277d9bb425$var$bgColorCssVar]: borderColor,
            [$ee4214277d9bb425$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $l2NkF.default)([
            $ee4214277d9bb425$var$unboundStyles.hexagonFocusContainer,
            UNSAFE_isUpdatedGeometry && $ee4214277d9bb425$var$unboundStyles.updatedHexagonClipPath,
            isInteractive && !isDisabled && (0, $fBWTV.fg)('platform-dst-motion-uplift') && $ee4214277d9bb425$var$unboundStyles.interactiveMotion,
            UNSAFE_isUpdatedGeometry && $ee4214277d9bb425$var$updatedHexagonBorderFixStyles.hexagonFocusContainer,
            (0, $fBWTV.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $ee4214277d9bb425$var$hexagonBorderFixStyles.hexagonFocusContainer
        ]),
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
            "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
            className: (0, $l2NkF.default)([
                $ee4214277d9bb425$var$unboundStyles.hexagonBorderContainer,
                UNSAFE_isUpdatedGeometry && $ee4214277d9bb425$var$updatedHexagonBorderFixStyles.hexagonBorderContainer,
                (0, $fBWTV.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $ee4214277d9bb425$var$hexagonBorderFixStyles.hexagonBorderContainer
            ]),
            children: renderedContent
        })
    });
});

});
parcelRegister("dnigo", function(module, exports) {
$parcel$export(module.exports, "AvatarContentContext", () => $28955675cf84c2d9$export$b983474ddd0b6d28);

var $lE8gv = parcelRequire("lE8gv");
const $28955675cf84c2d9$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $28955675cf84c2d9$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $lE8gv.createContext)($28955675cf84c2d9$var$defaultAvatarContentProps);

});

parcelRegister("iksqa", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $a037ea876dda543e$export$7db5c57474082dd9);

var $lE8gv = parcelRequire("lE8gv");

var $3Dje8 = parcelRequire("3Dje8");
const $a037ea876dda543e$export$7db5c57474082dd9 = ()=>{
    const context = (0, $lE8gv.useContext)((0, $3Dje8.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});
parcelRegister("3Dje8", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $2623f43b80cff333$export$6b4cbd90d24955ad);

var $lE8gv = parcelRequire("lE8gv");
const $2623f43b80cff333$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $lE8gv.createContext)(false);

});



parcelRegister("1O6oo", function(module, exports) {
$parcel$export(module.exports, "default", () => $41ed39d6061cc04f$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $bXh4g = parcelRequire("bXh4g");

var $cL9AM = parcelRequire("cL9AM");

var $9qy42 = parcelRequire("9qy42");
const $41ed39d6061cc04f$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g",
    updatedHexagonIcon: "_4cvr1h6o _1bah1h6o",
    updatedHexagonImage: "_mkrz1kw7 _5ral1dfr _1kem1wug"
};
const $41ed39d6061cc04f$var$borderRadiusMap = {
    xxsmall: "_2rkolb4i",
    xsmall: "_2rkolb4i",
    UNSAFE_xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
const $41ed39d6061cc04f$var$nestedSvgStylesMap = {
    xxsmall: "_w8l57vkz _17527vkz",
    xsmall: "_w8l57vkz _17527vkz",
    UNSAFE_xsmall: "_w8l5gktf _1752gktf",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
// NOTE: Must mirror `updatedHexagonDimensionMap` in `../avatar-content.tsx`.
const $41ed39d6061cc04f$var$updatedHexagonNestedSvgStylesMap = {
    xxsmall: "_w8l5gaek _1752kzaa",
    small: "_w8l51ftb _17521pm0",
    medium: "_w8l51cun _17523vj5",
    large: "_w8l5ctg4 _175215zd",
    xlarge: "_w8l5ovoe _17521sfy",
    xxlarge: "_w8l5hec5 _17521ejz"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $41ed39d6061cc04f$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $lE8gv.useState)(false);
    // If src changes, reset state
    (0, $lE8gv.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ (0, $kOwiQ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cL9AM))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ (0, $kOwiQ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bXh4g))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ (0, $kOwiQ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9qy42))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
            className: (0, $l2NkF.default)([
                $41ed39d6061cc04f$var$styles.icon,
                UNSAFE_isUpdatedGeometry ? $41ed39d6061cc04f$var$updatedHexagonNestedSvgStylesMap[size] : $41ed39d6061cc04f$var$nestedSvgStylesMap[size],
                UNSAFE_isUpdatedGeometry && $41ed39d6061cc04f$var$styles.updatedHexagonIcon
            ]),
            children: renderedIcon
        });
    }
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $l2NkF.default)([
            $41ed39d6061cc04f$var$styles.image,
            $41ed39d6061cc04f$var$borderRadiusMap[size],
            appearance === 'circle' && $41ed39d6061cc04f$var$styles.circle,
            appearance === 'hexagon' && $41ed39d6061cc04f$var$styles.hexagon,
            UNSAFE_isUpdatedGeometry && $41ed39d6061cc04f$var$styles.updatedHexagonImage
        ])
    });
};
var $41ed39d6061cc04f$export$2e2bcd8739ae039 = $41ed39d6061cc04f$var$AvatarImage;

});
parcelRegister("bXh4g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1078ad25bb88c0aacc625e83cbe31eaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b4271b56ebd1df0$var$_react = $8b4271b56ebd1df0$var$_interopRequireDefault((parcelRequire("lE8gv")));

var $8b4271b56ebd1df0$var$_iconNew = $8b4271b56ebd1df0$var$_interopRequireDefault((parcelRequire("1jPqJ")));
function $8b4271b56ebd1df0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-agent
 * Usage guidance:
 * Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b4271b56ebd1df0$var$AiAgentIcon = (props)=>/*#__PURE__*/ $8b4271b56ebd1df0$var$_react.default.createElement($8b4271b56ebd1df0$var$_iconNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$8b4271b56ebd1df0$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $8b4271b56ebd1df0$var$_default = module.exports.default = $8b4271b56ebd1df0$var$AiAgentIcon;

});

parcelRegister("cL9AM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44bfe3fda6843e57916c639848bc7fcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94a150a84276c474$var$_react = $94a150a84276c474$var$_interopRequireDefault((parcelRequire("lE8gv")));

var $94a150a84276c474$var$_iconNew = $94a150a84276c474$var$_interopRequireDefault((parcelRequire("1jPqJ")));
function $94a150a84276c474$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94a150a84276c474$var$PersonIcon = (props)=>/*#__PURE__*/ $94a150a84276c474$var$_react.default.createElement($94a150a84276c474$var$_iconNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$94a150a84276c474$var$PersonIcon.displayName = 'PersonIcon';
var $94a150a84276c474$var$_default = module.exports.default = $94a150a84276c474$var$PersonIcon;

});

parcelRegister("9qy42", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a375ef61b97315ae7ff25123b3ed791c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6dd0f737921899f6$var$_react = $6dd0f737921899f6$var$_interopRequireDefault((parcelRequire("lE8gv")));

var $6dd0f737921899f6$var$_iconNew = $6dd0f737921899f6$var$_interopRequireDefault((parcelRequire("1jPqJ")));
function $6dd0f737921899f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/release
 * Usage guidance:
 * Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6dd0f737921899f6$var$ReleaseIcon = (props)=>/*#__PURE__*/ $6dd0f737921899f6$var$_react.default.createElement($6dd0f737921899f6$var$_iconNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$6dd0f737921899f6$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $6dd0f737921899f6$var$_default = module.exports.default = $6dd0f737921899f6$var$ReleaseIcon;

});


parcelRegister("hPcNy", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a33afc2824807ed$export$2e2bcd8739ae039);
const $6a33afc2824807ed$var$getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $6a33afc2824807ed$export$2e2bcd8739ae039 = $6a33afc2824807ed$var$getCustomElement;

});

parcelRegister("bNAzG", function(module, exports) {
$parcel$export(module.exports, "default", () => $20cda6a1cf8caa0d$export$2e2bcd8739ae039);
/* presence-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $eZaUQ = parcelRequire("eZaUQ");
const $20cda6a1cf8caa0d$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $20cda6a1cf8caa0d$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $20cda6a1cf8caa0d$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $20cda6a1cf8caa0d$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
const $20cda6a1cf8caa0d$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ const $20cda6a1cf8caa0d$var$PresenceWrapper = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $l2NkF.default)([
            $20cda6a1cf8caa0d$var$styles.root,
            $20cda6a1cf8caa0d$var$iconSizeMap[size],
            $20cda6a1cf8caa0d$var$circleIconOffsetMap[size],
            appearance === 'square' && $20cda6a1cf8caa0d$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $20cda6a1cf8caa0d$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $eZaUQ.default), {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};
var $20cda6a1cf8caa0d$export$2e2bcd8739ae039 = $20cda6a1cf8caa0d$var$PresenceWrapper;

});
parcelRegister("eZaUQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f34582a952d6840$export$2e2bcd8739ae039);
/* presence.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $aT1Gx = parcelRequire("aT1Gx");
const $1f34582a952d6840$var$BusyIndicator = /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lE8gv.Fragment), {
    children: [
        /*#__PURE__*/ (0, $kOwiQ.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $kOwiQ.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $1f34582a952d6840$var$FocusIndicator = /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $lE8gv.Fragment), {
    children: /*#__PURE__*/ (0, $kOwiQ.jsx)("path", {
        fill: "var(--ds-icon-discovery, #AF59E1)",
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $1f34582a952d6840$var$OfflineIndicator = /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lE8gv.Fragment), {
    children: [
        /*#__PURE__*/ (0, $kOwiQ.jsx)("path", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $kOwiQ.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $1f34582a952d6840$var$OnlineIndicator = /*#__PURE__*/ (0, $kOwiQ.jsx)("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $1f34582a952d6840$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $1f34582a952d6840$var$BusyIndicator;
        case 'focus':
            return $1f34582a952d6840$var$FocusIndicator;
        case 'offline':
            return $1f34582a952d6840$var$OfflineIndicator;
        case 'online':
            return $1f34582a952d6840$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $1f34582a952d6840$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $aT1Gx.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $kOwiQ.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $1f34582a952d6840$var$getPresence(presence)
        }) : children
    });
var $1f34582a952d6840$export$2e2bcd8739ae039 = $1f34582a952d6840$var$AvatarPresence;

});
parcelRegister("aT1Gx", function(module, exports) {
$parcel$export(module.exports, "default", () => $43f59a4553cf4a14$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $43f59a4553cf4a14$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $43f59a4553cf4a14$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $43f59a4553cf4a14$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $l2NkF.default)([
            $43f59a4553cf4a14$var$styles.root,
            $43f59a4553cf4a14$var$unboundStyles.root
        ]),
        children: children
    });
var $43f59a4553cf4a14$export$2e2bcd8739ae039 = $43f59a4553cf4a14$var$IconWrapper;

});



parcelRegister("5ksDi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9ed179786c05e8a$export$2e2bcd8739ae039);
/* status-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $gyW2D = parcelRequire("gyW2D");
const $b9ed179786c05e8a$var$styles = {
    root: "_kqswstnw"
};
const $b9ed179786c05e8a$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $b9ed179786c05e8a$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
const $b9ed179786c05e8a$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
const $b9ed179786c05e8a$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ const $b9ed179786c05e8a$var$StatusWrapper = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $l2NkF.default)([
            $b9ed179786c05e8a$var$styles.root,
            $b9ed179786c05e8a$var$iconSizeMap[size],
            $b9ed179786c05e8a$var$circleIconOffsetMap[size],
            appearance === 'square' && $b9ed179786c05e8a$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $b9ed179786c05e8a$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $gyW2D.default), {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};
var $b9ed179786c05e8a$export$2e2bcd8739ae039 = $b9ed179786c05e8a$var$StatusWrapper;

});
parcelRegister("gyW2D", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5b30dab2b46cdb4$export$2e2bcd8739ae039);
/* status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $aT1Gx = parcelRequire("aT1Gx");
const $f5b30dab2b46cdb4$var$ApprovedIndicator = /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lE8gv.Fragment), {
    children: [
        /*#__PURE__*/ (0, $kOwiQ.jsx)("circle", {
            fill: "var(--ds-icon-success, #6A9A23)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $kOwiQ.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $f5b30dab2b46cdb4$var$DeclinedIndicator = /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lE8gv.Fragment), {
    children: [
        /*#__PURE__*/ (0, $kOwiQ.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $kOwiQ.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $f5b30dab2b46cdb4$var$LockedIndicator = /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lE8gv.Fragment), {
    children: [
        /*#__PURE__*/ (0, $kOwiQ.jsx)("circle", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $kOwiQ.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
const $f5b30dab2b46cdb4$var$WarningIndicator = /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lE8gv.Fragment), {
    children: [
        /*#__PURE__*/ (0, $kOwiQ.jsx)("circle", {
            fill: "var(--ds-icon-warning, #E06C00)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $kOwiQ.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
        })
    ]
});
function $f5b30dab2b46cdb4$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $f5b30dab2b46cdb4$var$ApprovedIndicator;
        case 'declined':
            return $f5b30dab2b46cdb4$var$DeclinedIndicator;
        case 'locked':
            return $f5b30dab2b46cdb4$var$LockedIndicator;
        case 'warning':
            return $f5b30dab2b46cdb4$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $f5b30dab2b46cdb4$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $aT1Gx.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $kOwiQ.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $f5b30dab2b46cdb4$var$getStatus(status)
        }) : children
    });
var $f5b30dab2b46cdb4$export$2e2bcd8739ae039 = $f5b30dab2b46cdb4$var$AvatarStatus;

});


parcelRegister("a0IXt", function(module, exports) {
$parcel$export(module.exports, "useAvatarContext", () => $6150c688f1c14cad$export$b50b87a1c4086b23);

var $lE8gv = parcelRequire("lE8gv");

var $172gB = parcelRequire("172gB");
const $6150c688f1c14cad$export$b50b87a1c4086b23 = ()=>(0, $lE8gv.useContext)((0, $172gB.AvatarContext));

});
parcelRegister("172gB", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", () => $48e3174f4b9afcea$export$a20dad690e1279e2);

var $lE8gv = parcelRequire("lE8gv");
const $48e3174f4b9afcea$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $lE8gv.createContext)(undefined);

});



parcelRegister("9apEo", function(module, exports) {
$parcel$export(module.exports, "default", () => $68f9c8d5f532b12c$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $b0Dmz = parcelRequire("b0Dmz");

var $82alT = parcelRequire("82alT");

var $r5Nkr = parcelRequire("r5Nkr");

var $iRQBr = parcelRequire("iRQBr");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $68f9c8d5f532b12c$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $lE8gv.useContext)((0, $iRQBr.GridContext));
    const { medium: medium } = (0, $lE8gv.useContext)((0, $r5Nkr.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $b0Dmz.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $b0Dmz.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $lE8gv.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $iRQBr.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $82alT.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $68f9c8d5f532b12c$export$2e2bcd8739ae039 = $68f9c8d5f532b12c$var$GridWrapper;

});
parcelRegister("b0Dmz", function(module, exports) {
$parcel$export(module.exports, "defaultGridColumns", () => $7a93cc78db5c60f1$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultSpacing", () => $7a93cc78db5c60f1$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $7a93cc78db5c60f1$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $7a93cc78db5c60f1$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $7a93cc78db5c60f1$export$2303d2bd9eeff99a);
const $7a93cc78db5c60f1$var$defaultGridSize = 8;
const $7a93cc78db5c60f1$export$74797698e12f8baa = 12;
const $7a93cc78db5c60f1$export$b8241a1616ab1b96 = $7a93cc78db5c60f1$var$defaultGridSize * 10;
const $7a93cc78db5c60f1$export$8ec7372efd74b753 = 'cosy';
const $7a93cc78db5c60f1$export$d77f83c3d17a7b8a = 52;
const $7a93cc78db5c60f1$export$f8725d21f81f3e01 = 0;
const $7a93cc78db5c60f1$export$2303d2bd9eeff99a = 'fixed';
const $7a93cc78db5c60f1$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $7a93cc78db5c60f1$export$8b7e31f391e6e681 = '--ds-column-span';
const $7a93cc78db5c60f1$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("82alT", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $795dd9726d45e9f4$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $b0Dmz = parcelRequire("b0Dmz");

var $iRQBr = parcelRequire("iRQBr");

var $fyVOq = parcelRequire("fyVOq");
const $795dd9726d45e9f4$var$defaultGridColumnWidth = 80;
/**
 * The number of available columns in each row.
 */ const $795dd9726d45e9f4$var$varColumnsNum = '--ds-columns-num';
/**
 * The spacing (in `px`) between each column.
 */ const $795dd9726d45e9f4$var$varGridSpacing = '--ds-grid-spacing';
const $795dd9726d45e9f4$var$styles = {
    grid: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3wx3y _n3tdidpf _19bvwx3y _1e0c1txw _kqswh2mm _4cvr1y6m _1n261g80",
    nestedGrid: "_19pkidpf _2hwx1un2 _otyridpf _18u01un2"
};
const $795dd9726d45e9f4$var$gridLayoutMapStyles = {
    fixed: "_p12fgkkb",
    fluid: "_p12f1osq"
};
const $795dd9726d45e9f4$export$ef2184bd89960b14 = ({ layout: layout = (0, $b0Dmz.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $lE8gv.useContext)((0, $iRQBr.GridContext));
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        style: {
            [$795dd9726d45e9f4$var$varColumnsNum]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$795dd9726d45e9f4$var$varGridSpacing]: `${(0, $fyVOq.spacingMapping)[spacing]}px`
        },
        "data-testid": testId,
        className: (0, $l2NkF.default)([
            $795dd9726d45e9f4$var$styles.grid,
            $795dd9726d45e9f4$var$gridLayoutMapStyles[layout],
            isNested && $795dd9726d45e9f4$var$styles.nestedGrid
        ]),
        children: children
    });
};

});
parcelRegister("iRQBr", function(module, exports) {
$parcel$export(module.exports, "GridContext", () => $20f9cd7260860cbc$export$11cae3e04ab99fae);

var $lE8gv = parcelRequire("lE8gv");

var $b0Dmz = parcelRequire("b0Dmz");
const $20f9cd7260860cbc$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $lE8gv.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $b0Dmz.defaultSpacing),
    columns: (0, $b0Dmz.defaultGridColumns)
});

});

parcelRegister("fyVOq", function(module, exports) {
$parcel$export(module.exports, "spacingMapping", () => $397378232c1c2bce$export$2a89a65a43bab52d);
const $397378232c1c2bce$var$defaultGridSize = 8;
const $397378232c1c2bce$export$2a89a65a43bab52d = {
    comfortable: $397378232c1c2bce$var$defaultGridSize * 5,
    cosy: $397378232c1c2bce$var$defaultGridSize * 2,
    compact: $397378232c1c2bce$var$defaultGridSize * 0.5
};

});


parcelRegister("r5Nkr", function(module, exports) {
$parcel$export(module.exports, "GridColumnContext", () => $9f49adcf43b31ee3$export$1229ad7112b989f5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lE8gv = parcelRequire("lE8gv");

var $b0Dmz = parcelRequire("b0Dmz");
const $9f49adcf43b31ee3$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $lE8gv.createContext)({
    medium: (0, $b0Dmz.defaultMedium)
});

});


parcelRegister("fOrHi", function(module, exports) {
$parcel$export(module.exports, "default", () => $52ba468146479b0d$export$2e2bcd8739ae039);
/* grid-column.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $b0Dmz = parcelRequire("b0Dmz");

var $r5Nkr = parcelRequire("r5Nkr");

var $iRQBr = parcelRequire("iRQBr");
/**
 * Determines the method by which column width is calculated.
 */ var $52ba468146479b0d$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($52ba468146479b0d$var$ColumnVariant || {});
/**
 * The spacing (in `px`) between each column.
 */ const $52ba468146479b0d$var$varGridSpacing = '--ds-grid-spacing';
/**
 * The number of columns that a `GridColumn` covers.
 */ const $52ba468146479b0d$var$varColumnSpan = '--ds-column-span';
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $52ba468146479b0d$var$singleColumnWidth = `(99.9999% / var(--ds-columns-num))`;
const $52ba468146479b0d$var$styles = {
    gridColumn: "_19pkidpf _2hwxwx3y _otyridpf _18u0wx3y _1ul9hrtj _16jlkb7n _1o9zidpf _slp31hna"
};
const $52ba468146479b0d$var$gridColumnWidthMapStyles = {
    auto: "_p12f1ho1 _i0dl1wug",
    bounded: "_p12fpg3g _i0dl1osq",
    fullWidth: "_p12f1ho1 _i0dl1osq"
};
const $52ba468146479b0d$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $b0Dmz.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $52ba468146479b0d$var$GridColumn = ({ medium: medium = (0, $b0Dmz.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $lE8gv.useContext)((0, $iRQBr.GridContext));
    const contextValue = (0, $lE8gv.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $52ba468146479b0d$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $r5Nkr.GridColumnContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
            style: {
                /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ [$52ba468146479b0d$var$varColumnSpan]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId,
            className: (0, $l2NkF.default)([
                $52ba468146479b0d$var$styles.gridColumn,
                $52ba468146479b0d$var$gridColumnWidthMapStyles[variant]
            ]),
            children: children
        })
    });
};
var $52ba468146479b0d$export$2e2bcd8739ae039 = $52ba468146479b0d$var$GridColumn;

});

parcelRegister("cn6Gr", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $21835fead7c08ba6$export$e926676385687eaf);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $K23ud = parcelRequire("K23ud");

var $6ivEq = parcelRequire("6ivEq");
class $21835fead7c08ba6$export$e926676385687eaf extends $lE8gv.Component {
    componentDidCatch(error) {
        this.setState({
            hasError: true,
            error: error
        });
        (0, $6ivEq.monitoringClient).onError(error);
        this.props.onError?.({
            error: error
        });
    }
    render() {
        if (this.state.hasError) // TODO: Decide on how to surface errors.
        return /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $kOwiQ.Fragment), {
            children: [
                /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $K23ud.ExperienceFailure), {
                    error: this.state.error || new Error('Unknown error')
                }),
                this.props.fallback
            ]
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}

});
parcelRegister("K23ud", function(module, exports) {
$parcel$export(module.exports, "ExperienceFailure", () => $645554eb5b97951a$export$eed1d73ebdd8c7ab);

var $lE8gv = parcelRequire("lE8gv");

var $cLp76 = parcelRequire("cLp76");

var $bCH43 = parcelRequire("bCH43");
function $645554eb5b97951a$export$eed1d73ebdd8c7ab({ name: name, error: error, attributes: attributes }) {
    const derivedName = (0, $lE8gv.useContext)((0, $cLp76.ExperienceContext));
    const experienceTracker = (0, $lE8gv.useContext)((0, $bCH43.ExperienceTrackerContext));
    const nameOfFailedExperience = name || derivedName;
    (0, $lE8gv.useEffect)(()=>experienceTracker.fail({
            name: nameOfFailedExperience,
            error: error,
            attributes: attributes
        }), [
        nameOfFailedExperience,
        error,
        experienceTracker,
        attributes
    ]);
    return null;
}

});
parcelRegister("cLp76", function(module, exports) {
$parcel$export(module.exports, "ExperienceContext", () => $347dff0b79237cb2$export$fb99266658f5da06);

var $lE8gv = parcelRequire("lE8gv");
const $347dff0b79237cb2$var$defaultExperienceContextValue = undefined;
const $347dff0b79237cb2$export$fb99266658f5da06 = (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).createContext($347dff0b79237cb2$var$defaultExperienceContextValue);

});

parcelRegister("bCH43", function(module, exports) {
$parcel$export(module.exports, "ExperienceTrackerContext", () => $cf271b1eaa507216$export$a7b0697657ed8bd0);

var $lE8gv = parcelRequire("lE8gv");
const $cf271b1eaa507216$export$a7b0697657ed8bd0 = (0, $lE8gv.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    updateAttributes () {}
});

});


parcelRegister("6ivEq", function(module, exports) {
$parcel$export(module.exports, "monitoringClient", () => $a94e44a4b5469298$export$4ae4681adb143a8a);


var $cgAnc = parcelRequire("cgAnc");

const $a94e44a4b5469298$var$getMonitoringClient = ()=>{
    return new (0, $cgAnc.ProductionMonitoringClient)();
};
const $a94e44a4b5469298$export$4ae4681adb143a8a = $a94e44a4b5469298$var$getMonitoringClient();

});
parcelRegister("cgAnc", function(module, exports) {
$parcel$export(module.exports, "ProductionMonitoringClient", () => $b5cfb46965a742e3$export$e9f07f4c768cb2e5);

var $bhEJd = parcelRequire("bhEJd");
var $x2nP6 = parcelRequire("x2nP6");

var $ikNsz = parcelRequire("ikNsz");
class $b5cfb46965a742e3$export$e9f07f4c768cb2e5 {
    onError(error, options) {
        if ((0, $ikNsz.hasGraphQlProperties)(error)) {
            $x2nP6.withScope((scope)=>{
                scope.setTag('isGraphQLError', true);
                scope.setTag('graphQLErrorOperation', error?.operation);
                scope.setTag('graphqlErrorPath', error?.path?.join(','));
                scope.setFingerprint(options?.fingerprint ?? [
                    error?.operation
                ]);
                const newMessage = `GraphQL Error - operation:${error?.operation} - message:${error?.message}`;
                const newError = new Error(newMessage);
                $bhEJd.captureException(newError);
            });
            return;
        }
        $x2nP6.withScope((scope)=>{
            if (options?.fingerprint) scope.setFingerprint(options.fingerprint);
            if (!(error instanceof Error)) {
                let nonErrorWrapper;
                try {
                    nonErrorWrapper = new Error(`Non-Error rejection: ${JSON.stringify(error)}`);
                } catch  {
                    // rare case of Big Int or Circular object
                    nonErrorWrapper = new Error(`Non-Error rejection: ${error}. Unserializable object.`);
                }
                $bhEJd.captureException(nonErrorWrapper);
                return;
            }
            $bhEJd.captureException(error);
        });
    }
    onMessage(message, options) {
        $x2nP6.withScope((scope)=>{
            if (options?.level) scope.setLevel(options.level);
            if (options?.tags) scope.setTags(options.tags);
            if (options?.contexts) Object.entries(options.contexts).forEach(([name, context])=>{
                scope.setContext(name, context);
            });
            $bhEJd.captureMessage(message);
        });
    }
    onUIError(error) {
        if ((0, $ikNsz.isApolloError)(error)) return;
        this.onError(error);
    }
    onExperienceFailure(event) {
        return $bhEJd.captureException(event.error, {
            tags: {
                experience: event.name
            },
            contexts: {
                experience: {
                    id: event.id,
                    ...(0, $ikNsz.getCustomAttributes)(event, [
                        'compoundTaskId'
                    ])
                }
            }
        });
    }
}

});
parcelRegister("bhEJd", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $8370e006cef4b518$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $8370e006cef4b518$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $8370e006cef4b518$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "setUser", () => $8370e006cef4b518$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "lastEventId", () => $8370e006cef4b518$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "startSession", () => $8370e006cef4b518$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $8370e006cef4b518$export$667e7b4d445d566b);

var $1PHIV = parcelRequire("1PHIV");

var $x2nP6 = parcelRequire("x2nP6");

var $aVHpP = parcelRequire("aVHpP");

var $bkjjy = parcelRequire("bkjjy");

var $fpqOZ = parcelRequire("fpqOZ");

var $gb5jY = parcelRequire("gb5jY");

var $1Mikf = parcelRequire("1Mikf");

var $fPxtX = parcelRequire("fPxtX");

var $6BcBO = parcelRequire("6BcBO");

var $48BE1 = parcelRequire("48BE1");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $8370e006cef4b518$export$f5282963edea4a68(exception, hint) {
    return (0, $x2nP6.getCurrentScope)().captureException(exception, (0, $48BE1.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $8370e006cef4b518$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $x2nP6.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $8370e006cef4b518$export$1462b974fdcf6ba2(event, hint) {
    return (0, $x2nP6.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $8370e006cef4b518$export$2f04de43fe27971a(name, context) {
    (0, $x2nP6.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $8370e006cef4b518$export$bb4922da0dd51b92(extras) {
    (0, $x2nP6.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $8370e006cef4b518$export$8e8e7789d42ed61d(key, extra) {
    (0, $x2nP6.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $8370e006cef4b518$export$74a8fb34822092e6(tags) {
    (0, $x2nP6.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $8370e006cef4b518$export$a37d07ee78eb4569(key, value) {
    (0, $x2nP6.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $8370e006cef4b518$export$8b6bb3dd62a01be2(user) {
    (0, $x2nP6.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $8370e006cef4b518$export$5d4e9fd7fac8e617() {
    return (0, $x2nP6.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $8370e006cef4b518$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $x2nP6.getCurrentScope)();
    const client = (0, $x2nP6.getClient)();
    if (!client) (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $1Mikf.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $8370e006cef4b518$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $8370e006cef4b518$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $fPxtX.timestampInSeconds)();
    function finishCheckIn(status) {
        $8370e006cef4b518$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $fPxtX.timestampInSeconds)() - now
        });
    }
    return (0, $x2nP6.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $fpqOZ.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $8370e006cef4b518$export$4909b86c8034bf73(timeout) {
    const client = (0, $x2nP6.getClient)();
    if (client) return client.flush(timeout);
    (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $8370e006cef4b518$export$8360e631d277ea4d(timeout) {
    const client = (0, $x2nP6.getClient)();
    if (client) return client.close(timeout);
    (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $8370e006cef4b518$export$3f95c6f800b78024() {
    return !!(0, $x2nP6.getClient)();
}
/** If the SDK is initialized & enabled. */ function $8370e006cef4b518$export$3b029eb57ac4d562() {
    const client = (0, $x2nP6.getClient)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $8370e006cef4b518$export$9aac0b9f77928fbf(callback) {
    (0, $x2nP6.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $8370e006cef4b518$export$c0d84948cecf78d8(context) {
    const client = (0, $x2nP6.getClient)();
    const isolationScope = (0, $x2nP6.getIsolationScope)();
    const currentScope = (0, $x2nP6.getCurrentScope)();
    const { release: release, environment: environment = (0, $1PHIV.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $6BcBO.GLOBAL_OBJ).navigator || {};
    const session = (0, $bkjjy.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $bkjjy.updateSession)(currentSession, {
        status: 'exited'
    });
    $8370e006cef4b518$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $8370e006cef4b518$export$17a5be43989a0bc1() {
    const isolationScope = (0, $x2nP6.getIsolationScope)();
    const currentScope = (0, $x2nP6.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $bkjjy.closeSession)(session);
    $8370e006cef4b518$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $8370e006cef4b518$var$_sendSessionUpdate() {
    const isolationScope = (0, $x2nP6.getIsolationScope)();
    const currentScope = (0, $x2nP6.getCurrentScope)();
    const client = (0, $x2nP6.getClient)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $8370e006cef4b518$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $8370e006cef4b518$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $8370e006cef4b518$var$_sendSessionUpdate();
}
 //# sourceMappingURL=exports.js.map

});
parcelRegister("1PHIV", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $155c787092810162$export$849dbeeeda01ae98);
const $155c787092810162$export$849dbeeeda01ae98 = 'production';
 //# sourceMappingURL=constants.js.map

});

parcelRegister("x2nP6", function(module, exports) {
$parcel$export(module.exports, "getCurrentScope", () => $0634ee71f38d661d$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getIsolationScope", () => $0634ee71f38d661d$export$68f3af03034c9e90);
$parcel$export(module.exports, "getGlobalScope", () => $0634ee71f38d661d$export$aa55d5ab8e05984f);
$parcel$export(module.exports, "withScope", () => $0634ee71f38d661d$export$ec58d9285c204497);
$parcel$export(module.exports, "withIsolationScope", () => $0634ee71f38d661d$export$9a4fed82c350c2bd);
$parcel$export(module.exports, "getClient", () => $0634ee71f38d661d$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getTraceContextFromScope", () => $0634ee71f38d661d$export$1e83db7ee4876dc4);

var $6O4vj = parcelRequire("6O4vj");

var $f9r1w = parcelRequire("f9r1w");

var $49QZo = parcelRequire("49QZo");

var $9v9Yl = parcelRequire("9v9Yl");

var $6BcBO = parcelRequire("6BcBO");
/**
 * Get the currently active scope.
 */ function $0634ee71f38d661d$export$c7be4b0125a10cba() {
    const carrier = (0, $f9r1w.getMainCarrier)();
    const acs = (0, $6O4vj.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $0634ee71f38d661d$export$68f3af03034c9e90() {
    const carrier = (0, $f9r1w.getMainCarrier)();
    const acs = (0, $6O4vj.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $0634ee71f38d661d$export$aa55d5ab8e05984f() {
    return (0, $6BcBO.getGlobalSingleton)('globalScope', ()=>new (0, $49QZo.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $0634ee71f38d661d$export$ec58d9285c204497(...rest) {
    const carrier = (0, $f9r1w.getMainCarrier)();
    const acs = (0, $6O4vj.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $0634ee71f38d661d$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $f9r1w.getMainCarrier)();
    const acs = (0, $6O4vj.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $0634ee71f38d661d$export$6bb76d6eba7e258c() {
    return $0634ee71f38d661d$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $0634ee71f38d661d$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, spanId: spanId, parentSpanId: parentSpanId } = propagationContext;
    const traceContext = (0, $9v9Yl.dropUndefinedKeys)({
        trace_id: traceId,
        span_id: spanId,
        parent_span_id: parentSpanId
    });
    return traceContext;
}
 //# sourceMappingURL=currentScopes.js.map

});
parcelRegister("6O4vj", function(module, exports) {
$parcel$export(module.exports, "getAsyncContextStrategy", () => $4f4ae7fb89c891e3$export$f639b0c2752203be);

var $f9r1w = parcelRequire("f9r1w");

var $1Go1V = parcelRequire("1Go1V");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $4f4ae7fb89c891e3$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $f9r1w.getMainCarrier)();
    const sentry = (0, $f9r1w.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $4f4ae7fb89c891e3$export$f639b0c2752203be(carrier) {
    const sentry = (0, $f9r1w.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $1Go1V.getStackAsyncContextStrategy)();
}
 //# sourceMappingURL=index.js.map

});
parcelRegister("f9r1w", function(module, exports) {
$parcel$export(module.exports, "getMainCarrier", () => $b07ca8994c016bc9$export$19eade501500c6c1);
$parcel$export(module.exports, "getSentryCarrier", () => $b07ca8994c016bc9$export$c8bfa33e4e8ae492);

var $hWV3f = parcelRequire("hWV3f");

var $6BcBO = parcelRequire("6BcBO");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $b07ca8994c016bc9$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $b07ca8994c016bc9$export$c8bfa33e4e8ae492((0, $6BcBO.GLOBAL_OBJ));
    return 0, $6BcBO.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $b07ca8994c016bc9$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $hWV3f.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $hWV3f.SDK_VERSION] = __SENTRY__[0, $hWV3f.SDK_VERSION] || {};
}
 //# sourceMappingURL=carrier.js.map

});
parcelRegister("hWV3f", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $d1141ba8d1ecbb85$export$31499a9cd224b78c);
// This is a magic string replaced by rollup
const $d1141ba8d1ecbb85$export$31499a9cd224b78c = "8.48.0";
 //# sourceMappingURL=version.js.map

});

parcelRegister("6BcBO", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", () => $4cdffaa7341acead$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalSingleton", () => $4cdffaa7341acead$export$7e223ec222791509);

var $hWV3f = parcelRequire("hWV3f");
/** Get's the global object for the current JavaScript runtime */ const $4cdffaa7341acead$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $4cdffaa7341acead$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $4cdffaa7341acead$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $hWV3f.SDK_VERSION] = __SENTRY__[0, $hWV3f.SDK_VERSION] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}
 //# sourceMappingURL=worldwide.js.map

});


parcelRegister("1Go1V", function(module, exports) {
$parcel$export(module.exports, "getStackAsyncContextStrategy", () => $139c5a9296d0e69e$export$329d4d4d54e42710);

var $4Wch8 = parcelRequire("4Wch8");

var $49QZo = parcelRequire("49QZo");

var $fpqOZ = parcelRequire("fpqOZ");

var $f9r1w = parcelRequire("f9r1w");
/**
 * This is an object that holds a stack of scopes.
 */ class $139c5a9296d0e69e$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $49QZo.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $49QZo.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $fpqOZ.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $139c5a9296d0e69e$var$getAsyncContextStack() {
    const registry = (0, $f9r1w.getMainCarrier)();
    const sentry = (0, $f9r1w.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $139c5a9296d0e69e$export$d36ec451f120cfba((0, $4Wch8.getDefaultCurrentScope)(), (0, $4Wch8.getDefaultIsolationScope)());
}
function $139c5a9296d0e69e$var$withScope(callback) {
    return $139c5a9296d0e69e$var$getAsyncContextStack().withScope(callback);
}
function $139c5a9296d0e69e$var$withSetScope(scope, callback) {
    const stack = $139c5a9296d0e69e$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $139c5a9296d0e69e$var$withIsolationScope(callback) {
    return $139c5a9296d0e69e$var$getAsyncContextStack().withScope(()=>{
        return callback($139c5a9296d0e69e$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $139c5a9296d0e69e$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $139c5a9296d0e69e$var$withIsolationScope,
        withScope: $139c5a9296d0e69e$var$withScope,
        withSetScope: $139c5a9296d0e69e$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $139c5a9296d0e69e$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$139c5a9296d0e69e$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$139c5a9296d0e69e$var$getAsyncContextStack().getIsolationScope()
    };
}
 //# sourceMappingURL=stackStrategy.js.map

});
parcelRegister("4Wch8", function(module, exports) {
$parcel$export(module.exports, "getDefaultCurrentScope", () => $398619db254a74e8$export$6f1b9191db9c4d5);
$parcel$export(module.exports, "getDefaultIsolationScope", () => $398619db254a74e8$export$de9862929b76bf57);

var $49QZo = parcelRequire("49QZo");

var $6BcBO = parcelRequire("6BcBO");
/** Get the default current scope. */ function $398619db254a74e8$export$6f1b9191db9c4d5() {
    return (0, $6BcBO.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $49QZo.Scope)());
}
/** Get the default isolation scope. */ function $398619db254a74e8$export$de9862929b76bf57() {
    return (0, $6BcBO.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $49QZo.Scope)());
}
 //# sourceMappingURL=defaultScopes.js.map

});
parcelRegister("49QZo", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $30711b40763594ce$export$775b6bb06e53a214);

var $bkjjy = parcelRequire("bkjjy");

var $fpqOZ = parcelRequire("fpqOZ");

var $gb5jY = parcelRequire("gb5jY");

var $1Mikf = parcelRequire("1Mikf");

var $6qqWc = parcelRequire("6qqWc");

var $fPxtX = parcelRequire("fPxtX");

var $1ulsa = parcelRequire("1ulsa");

var $awmk8 = parcelRequire("awmk8");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $30711b40763594ce$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $30711b40763594ce$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ // eslint-disable-next-line deprecation/deprecation
    /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $6qqWc.generateTraceId)(),
            spanId: (0, $6qqWc.generateSpanId)()
        };
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $30711b40763594ce$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $awmk8._setSpanForScope)(newScope, (0, $awmk8._getSpanForScope)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $bkjjy.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $30711b40763594ce$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $fpqOZ.isPlainObject)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $awmk8._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $6qqWc.generateTraceId)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $30711b40763594ce$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $fPxtX.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $awmk8._getSpanForScope)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $1ulsa.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = {
            // eslint-disable-next-line deprecation/deprecation
            spanId: (0, $6qqWc.generateSpanId)(),
            ...context
        };
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1Mikf.uuid4)();
        if (!this._client) {
            (0, $gb5jY.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1Mikf.uuid4)();
        if (!this._client) {
            (0, $gb5jY.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1Mikf.uuid4)();
        if (!this._client) {
            (0, $gb5jY.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Holds additional event information.
 */ const $30711b40763594ce$export$775b6bb06e53a214 = $30711b40763594ce$var$ScopeClass;
 //# sourceMappingURL=scope.js.map

});
parcelRegister("bkjjy", function(module, exports) {
$parcel$export(module.exports, "makeSession", () => $83f08b675fa3bcb7$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $83f08b675fa3bcb7$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $83f08b675fa3bcb7$export$56521d9ba90f62ee);




var $9v9Yl = parcelRequire("9v9Yl");

var $fPxtX = parcelRequire("fPxtX");

var $1Mikf = parcelRequire("1Mikf");

/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $83f08b675fa3bcb7$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $fPxtX.timestampInSeconds)();
    const session = {
        sid: (0, $1Mikf.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$83f08b675fa3bcb7$var$sessionToJSON(session)
    };
    if (context) $83f08b675fa3bcb7$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $83f08b675fa3bcb7$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $fPxtX.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $1Mikf.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $83f08b675fa3bcb7$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $83f08b675fa3bcb7$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $83f08b675fa3bcb7$var$sessionToJSON(session) {
    return (0, $9v9Yl.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}
 //# sourceMappingURL=session.js.map

});
parcelRegister("9v9Yl", function(module, exports) {
$parcel$export(module.exports, "fill", () => $6eaebe982fe9d3e5$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $6eaebe982fe9d3e5$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $6eaebe982fe9d3e5$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $6eaebe982fe9d3e5$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "convertToPlainObject", () => $6eaebe982fe9d3e5$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $6eaebe982fe9d3e5$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $6eaebe982fe9d3e5$export$d25f2688db1bb433);

var $fCOkM = parcelRequire("fCOkM");

var $jhPin = parcelRequire("jhPin");

var $fpqOZ = parcelRequire("fpqOZ");

var $gb5jY = parcelRequire("gb5jY");

var $3fQHs = parcelRequire("3fQHs");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $6eaebe982fe9d3e5$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $6eaebe982fe9d3e5$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $jhPin.DEBUG_BUILD) && (0, $gb5jY.logger).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $6eaebe982fe9d3e5$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $jhPin.DEBUG_BUILD) && (0, $gb5jY.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $6eaebe982fe9d3e5$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $6eaebe982fe9d3e5$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $6eaebe982fe9d3e5$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 *
 * @deprecated This function is deprecated and will be removed in the next major version of the SDK.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6eaebe982fe9d3e5$export$9ef804feabbcbaf1(object) {
    return Object.entries(object).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $6eaebe982fe9d3e5$export$62ff257738bf57f5(value) {
    if ((0, $fpqOZ.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$6eaebe982fe9d3e5$var$getOwnProperties(value)
    };
    else if ((0, $fpqOZ.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $6eaebe982fe9d3e5$var$serializeEventTarget(value.target),
            currentTarget: $6eaebe982fe9d3e5$var$serializeEventTarget(value.currentTarget),
            ...$6eaebe982fe9d3e5$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $fpqOZ.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $6eaebe982fe9d3e5$var$serializeEventTarget(target) {
    try {
        return (0, $fpqOZ.isElement)(target) ? (0, $fCOkM.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $6eaebe982fe9d3e5$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $6eaebe982fe9d3e5$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($6eaebe982fe9d3e5$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $3fQHs.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $3fQHs.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $6eaebe982fe9d3e5$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $6eaebe982fe9d3e5$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $6eaebe982fe9d3e5$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($6eaebe982fe9d3e5$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $6eaebe982fe9d3e5$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($6eaebe982fe9d3e5$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $6eaebe982fe9d3e5$var$isPojo(input) {
    if (!(0, $fpqOZ.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e2) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $6eaebe982fe9d3e5$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $fpqOZ.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
 //# sourceMappingURL=object.js.map

});
parcelRegister("fCOkM", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $b60172ea5d87c0fa$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $b60172ea5d87c0fa$export$1cfafeee2987818b);
$parcel$export(module.exports, "getComponentName", () => $b60172ea5d87c0fa$export$26727cfcc4d7e0fc);

var $fpqOZ = parcelRequire("fpqOZ");

var $6BcBO = parcelRequire("6BcBO");
const $b60172ea5d87c0fa$var$WINDOW = (0, $6BcBO.GLOBAL_OBJ);
const $b60172ea5d87c0fa$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b60172ea5d87c0fa$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $b60172ea5d87c0fa$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b60172ea5d87c0fa$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b60172ea5d87c0fa$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($b60172ea5d87c0fa$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $fpqOZ.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $b60172ea5d87c0fa$export$1cfafeee2987818b() {
    try {
        return $b60172ea5d87c0fa$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 *
 * @deprecated This method is deprecated and will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b60172ea5d87c0fa$export$c660c1f3ab49225c(selector) {
    if ($b60172ea5d87c0fa$var$WINDOW.document && $b60172ea5d87c0fa$var$WINDOW.document.querySelector) return $b60172ea5d87c0fa$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $b60172ea5d87c0fa$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$b60172ea5d87c0fa$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
 //# sourceMappingURL=browser.js.map

});
parcelRegister("fpqOZ", function(module, exports) {
$parcel$export(module.exports, "isError", () => $b37dfef77c21285a$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $b37dfef77c21285a$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $b37dfef77c21285a$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $b37dfef77c21285a$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $b37dfef77c21285a$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $b37dfef77c21285a$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $b37dfef77c21285a$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $b37dfef77c21285a$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $b37dfef77c21285a$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $b37dfef77c21285a$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $b37dfef77c21285a$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $b37dfef77c21285a$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $b37dfef77c21285a$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $b37dfef77c21285a$export$bc2894c7158efbac);
$parcel$export(module.exports, "isVueViewModel", () => $b37dfef77c21285a$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $b37dfef77c21285a$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$e6127cc7fe7395c3(wat) {
    switch($b37dfef77c21285a$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $b37dfef77c21285a$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$var$isBuiltin(wat, className) {
    return $b37dfef77c21285a$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$9f9636d330b71954(wat) {
    return $b37dfef77c21285a$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$ef9e2056653f0c8e(wat) {
    return $b37dfef77c21285a$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$12e869b2a583f783(wat) {
    return $b37dfef77c21285a$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$844ec244b1367d54(wat) {
    return $b37dfef77c21285a$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$c3825b437cbdea5c(wat) {
    return wat === null || $b37dfef77c21285a$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$53b83ca8eaab0383(wat) {
    return $b37dfef77c21285a$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $b37dfef77c21285a$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $b37dfef77c21285a$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$49841c62b9eff15(wat) {
    return $b37dfef77c21285a$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $b37dfef77c21285a$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$bc2894c7158efbac(wat) {
    return $b37dfef77c21285a$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b37dfef77c21285a$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
 //# sourceMappingURL=is.js.map

});


parcelRegister("jhPin", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $e0a765132b9df535$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0a765132b9df535$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map

});

parcelRegister("gb5jY", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $bc71cd16ebe66d8e$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $bc71cd16ebe66d8e$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $bc71cd16ebe66d8e$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $bc71cd16ebe66d8e$export$af88d00dbe7f521);

var $jhPin = parcelRequire("jhPin");

var $6BcBO = parcelRequire("6BcBO");
/** Prefix for logging strings */ const $bc71cd16ebe66d8e$var$PREFIX = 'Sentry Logger ';
const $bc71cd16ebe66d8e$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $bc71cd16ebe66d8e$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $bc71cd16ebe66d8e$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $6BcBO.GLOBAL_OBJ))) return callback();
    const console = (0, $6BcBO.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($bc71cd16ebe66d8e$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $bc71cd16ebe66d8e$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $bc71cd16ebe66d8e$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $jhPin.DEBUG_BUILD) $bc71cd16ebe66d8e$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $bc71cd16ebe66d8e$export$cda52e2a8927a2ca(()=>{
                (0, $6BcBO.GLOBAL_OBJ).console[name](`${$bc71cd16ebe66d8e$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $bc71cd16ebe66d8e$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $bc71cd16ebe66d8e$export$af88d00dbe7f521 = (0, $6BcBO.getGlobalSingleton)('logger', $bc71cd16ebe66d8e$var$makeLogger);
 //# sourceMappingURL=logger.js.map

});

parcelRegister("3fQHs", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $25eba6e86797466d$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $25eba6e86797466d$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $25eba6e86797466d$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $25eba6e86797466d$export$a7a5ec66062ea5d);

var $fpqOZ = parcelRequire("fpqOZ");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $25eba6e86797466d$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $25eba6e86797466d$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $25eba6e86797466d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $fpqOZ.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $25eba6e86797466d$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $fpqOZ.isString)(value)) return false;
    if ((0, $fpqOZ.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $fpqOZ.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $25eba6e86797466d$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$25eba6e86797466d$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}
 //# sourceMappingURL=string.js.map

});


parcelRegister("fPxtX", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => $b865975304d95a93$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $b865975304d95a93$export$ee52dced521e3e18);

var $6BcBO = parcelRequire("6BcBO");
const $b865975304d95a93$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $b865975304d95a93$export$7740643b9eeaf0c4() {
    return Date.now() / $b865975304d95a93$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $b865975304d95a93$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $6BcBO.GLOBAL_OBJ);
    if (!performance || !performance.now) return $b865975304d95a93$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $b865975304d95a93$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $b865975304d95a93$export$ee52dced521e3e18 = $b865975304d95a93$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 *
 * @deprecated This variable will be removed in the next major version.
 */ let $b865975304d95a93$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $b865975304d95a93$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $6BcBO.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        // eslint-disable-next-line deprecation/deprecation
        $b865975304d95a93$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            // eslint-disable-next-line deprecation/deprecation
            $b865975304d95a93$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            // eslint-disable-next-line deprecation/deprecation
            $b865975304d95a93$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    // eslint-disable-next-line deprecation/deprecation
    $b865975304d95a93$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();
 //# sourceMappingURL=time.js.map

});

parcelRegister("1Mikf", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $14b87d347c753790$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $14b87d347c753790$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $14b87d347c753790$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $14b87d347c753790$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $14b87d347c753790$export$6de4ffac6a2f1098);

var $9v9Yl = parcelRequire("9v9Yl");

var $3fQHs = parcelRequire("3fQHs");

var $6BcBO = parcelRequire("6BcBO");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $14b87d347c753790$export$19f53698e68b2496() {
    const gbl = (0, $6BcBO.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $14b87d347c753790$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $14b87d347c753790$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $14b87d347c753790$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $14b87d347c753790$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $14b87d347c753790$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $14b87d347c753790$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $14b87d347c753790$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $14b87d347c753790$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $14b87d347c753790$export$d364f2020ab30578(input) {
    const match = input.match($14b87d347c753790$var$SEMVER_REGEXP) || [];
    const major = $14b87d347c753790$var$_parseInt(match[1]);
    const minor = $14b87d347c753790$var$_parseInt(match[2]);
    const patch = $14b87d347c753790$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $14b87d347c753790$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $3fQHs.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $3fQHs.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $3fQHs.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $14b87d347c753790$export$6de4ffac6a2f1098(exception) {
    if ($14b87d347c753790$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $9v9Yl.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $14b87d347c753790$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 *
 * @deprecated This function has been deprecated and will not be replaced.
 */ function $14b87d347c753790$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}
 //# sourceMappingURL=misc.js.map

});


parcelRegister("6qqWc", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", () => $4ada110850232609$export$dc6d7ea554bcce10);
$parcel$export(module.exports, "generateSpanId", () => $4ada110850232609$export$295213bc4d0c54ad);

var $1Mikf = parcelRequire("1Mikf");
/**
 * Returns a new minimal propagation context.
 *
 * @deprecated Use `generateTraceId` and `generateSpanId` instead.
 */ function $4ada110850232609$export$37f0f2f9cf343e5e() {
    return {
        traceId: $4ada110850232609$export$dc6d7ea554bcce10(),
        spanId: $4ada110850232609$export$295213bc4d0c54ad()
    };
}
/**
 * Generate a random, valid trace ID.
 */ function $4ada110850232609$export$dc6d7ea554bcce10() {
    return (0, $1Mikf.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $4ada110850232609$export$295213bc4d0c54ad() {
    return (0, $1Mikf.uuid4)().substring(16);
}
 //# sourceMappingURL=propagationContext.js.map

});

parcelRegister("1ulsa", function(module, exports) {
$parcel$export(module.exports, "merge", () => $11593bfb304768e8$export$4950aa0f605343fb);
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $11593bfb304768e8$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && mergeObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $11593bfb304768e8$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}
 //# sourceMappingURL=merge.js.map

});

parcelRegister("awmk8", function(module, exports) {
$parcel$export(module.exports, "_setSpanForScope", () => $7a8e35947cb019ff$export$3f25fa50c18e20ca);
$parcel$export(module.exports, "_getSpanForScope", () => $7a8e35947cb019ff$export$91f063ebb8eff307);

var $9v9Yl = parcelRequire("9v9Yl");
const $7a8e35947cb019ff$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $7a8e35947cb019ff$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $9v9Yl.addNonEnumerableProperty)(scope, $7a8e35947cb019ff$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$7a8e35947cb019ff$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $7a8e35947cb019ff$export$91f063ebb8eff307(scope) {
    return scope[$7a8e35947cb019ff$var$SCOPE_SPAN_FIELD];
}
 //# sourceMappingURL=spanOnScope.js.map

});






parcelRegister("aVHpP", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $020db128042cae8a$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $020db128042cae8a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map

});

parcelRegister("48BE1", function(module, exports) {
$parcel$export(module.exports, "prepareEvent", () => $30351c3544bc25b9$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $30351c3544bc25b9$export$76b5f966996d1653);

var $1PHIV = parcelRequire("1PHIV");

var $x2nP6 = parcelRequire("x2nP6");

var $7v52z = parcelRequire("7v52z");

var $49QZo = parcelRequire("49QZo");

var $8FvAr = parcelRequire("8FvAr");

var $1Mikf = parcelRequire("1Mikf");

var $hFBOQ = parcelRequire("hFBOQ");

var $3fQHs = parcelRequire("3fQHs");

var $fPxtX = parcelRequire("fPxtX");

var $6MMzE = parcelRequire("6MMzE");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $30351c3544bc25b9$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $1Mikf.uuid4)(),
        timestamp: event.timestamp || (0, $fPxtX.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $30351c3544bc25b9$export$d7e04067a6fbc882(prepared, options);
    $30351c3544bc25b9$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $30351c3544bc25b9$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $30351c3544bc25b9$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $1Mikf.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $x2nP6.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $6MMzE.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $6MMzE.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $6MMzE.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $7v52z.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $30351c3544bc25b9$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $30351c3544bc25b9$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $30351c3544bc25b9$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $1PHIV.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    if (event.message) event.message = (0, $3fQHs.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $3fQHs.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $3fQHs.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $30351c3544bc25b9$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $8FvAr.getFilenameToDebugIdMap)(stackParser);
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (filenameDebugIdMap && frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $30351c3544bc25b9$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $30351c3544bc25b9$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $30351c3544bc25b9$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $hFBOQ.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $hFBOQ.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $hFBOQ.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $hFBOQ.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $hFBOQ.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $hFBOQ.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts && event.contexts.flags && normalized.contexts) normalized.contexts.flags = (0, $hFBOQ.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $30351c3544bc25b9$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $49QZo.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $30351c3544bc25b9$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($30351c3544bc25b9$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($30351c3544bc25b9$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $30351c3544bc25b9$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $49QZo.Scope) || typeof hint === 'function';
}
const $30351c3544bc25b9$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $30351c3544bc25b9$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$30351c3544bc25b9$var$captureContextKeys.includes(key));
}
 //# sourceMappingURL=prepareEvent.js.map

});
parcelRegister("7v52z", function(module, exports) {
$parcel$export(module.exports, "notifyEventProcessors", () => $575f56996106a848$export$bf2a096c3e883e79);

var $aVHpP = parcelRequire("aVHpP");

var $fpqOZ = parcelRequire("fpqOZ");

var $gb5jY = parcelRequire("gb5jY");

var $dGw9M = parcelRequire("dGw9M");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $575f56996106a848$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $dGw9M.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $aVHpP.DEBUG_BUILD) && processor.id && result === null && (0, $gb5jY.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $fpqOZ.isThenable)(result)) result.then((final)=>$575f56996106a848$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $575f56996106a848$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}
 //# sourceMappingURL=eventProcessors.js.map

});
parcelRegister("dGw9M", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $9f682445353b683e$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $9f682445353b683e$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $9f682445353b683e$export$78e43115b553f358);

var $fpqOZ = parcelRequire("fpqOZ");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9f682445353b683e$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9f682445353b683e$var$States || ($9f682445353b683e$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9f682445353b683e$export$1fda8aa4d135f8aa(value) {
    return new $9f682445353b683e$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9f682445353b683e$export$78e43115b553f358(reason) {
    return new $9f682445353b683e$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9f682445353b683e$export$6f292d4960313241 {
    constructor(executor){
        $9f682445353b683e$export$6f292d4960313241.prototype.__init.call(this);
        $9f682445353b683e$export$6f292d4960313241.prototype.__init2.call(this);
        $9f682445353b683e$export$6f292d4960313241.prototype.__init3.call(this);
        $9f682445353b683e$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $9f682445353b683e$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $9f682445353b683e$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $9f682445353b683e$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($9f682445353b683e$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($9f682445353b683e$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $9f682445353b683e$var$States.PENDING) return;
            if ((0, $fpqOZ.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $9f682445353b683e$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $9f682445353b683e$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $9f682445353b683e$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}
 //# sourceMappingURL=syncpromise.js.map

});


parcelRegister("8FvAr", function(module, exports) {
$parcel$export(module.exports, "getFilenameToDebugIdMap", () => $64faa78ebd80c8fb$export$e069fee9c632ed00);

var $6BcBO = parcelRequire("6BcBO");
let $64faa78ebd80c8fb$var$parsedStackResults;
let $64faa78ebd80c8fb$var$lastKeysCount;
let $64faa78ebd80c8fb$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $64faa78ebd80c8fb$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $6BcBO.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($64faa78ebd80c8fb$var$cachedFilenameDebugIds && debugIdKeys.length === $64faa78ebd80c8fb$var$lastKeysCount) return $64faa78ebd80c8fb$var$cachedFilenameDebugIds;
    $64faa78ebd80c8fb$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $64faa78ebd80c8fb$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$64faa78ebd80c8fb$var$parsedStackResults) $64faa78ebd80c8fb$var$parsedStackResults = {};
        const result = $64faa78ebd80c8fb$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame && stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $64faa78ebd80c8fb$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $64faa78ebd80c8fb$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $64faa78ebd80c8fb$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $64faa78ebd80c8fb$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}
 //# sourceMappingURL=debug-ids.js.map

});

parcelRegister("hFBOQ", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $cdd39a10cf7e94a3$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $cdd39a10cf7e94a3$export$23fbbb20bed71033);

var $fpqOZ = parcelRequire("fpqOZ");

var $a6qp5 = parcelRequire("a6qp5");

var $9v9Yl = parcelRequire("9v9Yl");

var $fmUGy = parcelRequire("fmUGy");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cdd39a10cf7e94a3$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $cdd39a10cf7e94a3$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $cdd39a10cf7e94a3$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $cdd39a10cf7e94a3$export$a3295358bff77e(object, depth);
    if ($cdd39a10cf7e94a3$var$jsonSize(normalized) > maxSize) return $cdd39a10cf7e94a3$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $cdd39a10cf7e94a3$var$visit(key, value, depth = Infinity, maxProperties = Infinity, // eslint-disable-next-line deprecation/deprecation
memo = (0, $a6qp5.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $cdd39a10cf7e94a3$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $cdd39a10cf7e94a3$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $9v9Yl.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $cdd39a10cf7e94a3$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $cdd39a10cf7e94a3$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $fpqOZ.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $fpqOZ.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $fmUGy.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $cdd39a10cf7e94a3$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $cdd39a10cf7e94a3$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $cdd39a10cf7e94a3$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cdd39a10cf7e94a3$var$jsonSize(value) {
    return $cdd39a10cf7e94a3$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $cdd39a10cf7e94a3$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
 //# sourceMappingURL=normalize.js.map

});
parcelRegister("a6qp5", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $75aef220649062a9$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 *
 * @deprecated This function is deprecated and will be removed in the next major version.
 */ // TODO(v9): Move this function into normalize() directly
function $75aef220649062a9$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}
 //# sourceMappingURL=memo.js.map

});

parcelRegister("fmUGy", function(module, exports) {
$parcel$export(module.exports, "UNKNOWN_FUNCTION", () => $02e32ceddbcb275f$export$27c7e15d453fc0ac);
$parcel$export(module.exports, "createStackParser", () => $02e32ceddbcb275f$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $02e32ceddbcb275f$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $02e32ceddbcb275f$export$aad197c7121a6651);
$parcel$export(module.exports, "getFramesFromEvent", () => $02e32ceddbcb275f$export$91d8ca51bd9f6a47);
const $02e32ceddbcb275f$var$STACKTRACE_FRAME_LIMIT = 50;
const $02e32ceddbcb275f$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $02e32ceddbcb275f$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $02e32ceddbcb275f$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $02e32ceddbcb275f$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $02e32ceddbcb275f$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($02e32ceddbcb275f$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $02e32ceddbcb275f$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $02e32ceddbcb275f$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $02e32ceddbcb275f$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $02e32ceddbcb275f$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $02e32ceddbcb275f$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($02e32ceddbcb275f$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($02e32ceddbcb275f$var$STRIP_FRAME_REGEXP.test($02e32ceddbcb275f$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($02e32ceddbcb275f$var$STRIP_FRAME_REGEXP.test($02e32ceddbcb275f$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $02e32ceddbcb275f$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $02e32ceddbcb275f$var$getLastStackFrame(localStack).filename,
            function: frame.function || $02e32ceddbcb275f$export$27c7e15d453fc0ac
        }));
}
function $02e32ceddbcb275f$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $02e32ceddbcb275f$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $02e32ceddbcb275f$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $02e32ceddbcb275f$var$defaultFunctionName;
        return fn.name || $02e32ceddbcb275f$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $02e32ceddbcb275f$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $02e32ceddbcb275f$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}
 //# sourceMappingURL=stacktrace.js.map

});


parcelRegister("6MMzE", function(module, exports) {
$parcel$export(module.exports, "applyScopeDataToEvent", () => $4f0ce7923045c0e5$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $4f0ce7923045c0e5$export$25ac7e259a513db4);

var $ftKkF = parcelRequire("ftKkF");

var $9v9Yl = parcelRequire("9v9Yl");

var $1ulsa = parcelRequire("1ulsa");

var $hYVtp = parcelRequire("hYVtp");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $4f0ce7923045c0e5$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $4f0ce7923045c0e5$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $4f0ce7923045c0e5$var$applySpanToEvent(event, span);
    $4f0ce7923045c0e5$var$applyFingerprintToEvent(event, fingerprint);
    $4f0ce7923045c0e5$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $4f0ce7923045c0e5$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $4f0ce7923045c0e5$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $4f0ce7923045c0e5$export$b1a120a2871faa46(data, 'extra', extra);
    $4f0ce7923045c0e5$export$b1a120a2871faa46(data, 'tags', tags);
    $4f0ce7923045c0e5$export$b1a120a2871faa46(data, 'user', user);
    $4f0ce7923045c0e5$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $1ulsa.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $4f0ce7923045c0e5$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $1ulsa.merge)(data[prop], mergeVal, 1);
}
function $4f0ce7923045c0e5$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $9v9Yl.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $9v9Yl.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $9v9Yl.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $9v9Yl.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $4f0ce7923045c0e5$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $4f0ce7923045c0e5$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $4f0ce7923045c0e5$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $hYVtp.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $ftKkF.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $hYVtp.getRootSpan)(span);
    const transactionName = (0, $hYVtp.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $4f0ce7923045c0e5$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}
 //# sourceMappingURL=applyScopeDataToEvent.js.map

});
parcelRegister("ftKkF", function(module, exports) {
$parcel$export(module.exports, "getDynamicSamplingContextFromScope", () => $b44d8111286fbc46$export$89ef1736f08c6b2b);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $b44d8111286fbc46$export$a117f995597e25df);

var $1PHIV = parcelRequire("1PHIV");

var $x2nP6 = parcelRequire("x2nP6");

var $er6NG = parcelRequire("er6NG");

var $VxrSw = parcelRequire("VxrSw");

var $9v9Yl = parcelRequire("9v9Yl");

var $E9m4X = parcelRequire("E9m4X");

var $hYVtp = parcelRequire("hYVtp");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $b44d8111286fbc46$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $b44d8111286fbc46$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $9v9Yl.addNonEnumerableProperty)(spanWithMaybeDsc, $b44d8111286fbc46$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $b44d8111286fbc46$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $9v9Yl.dropUndefinedKeys)({
        environment: options.environment || (0, $1PHIV.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $b44d8111286fbc46$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $b44d8111286fbc46$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $b44d8111286fbc46$export$a117f995597e25df(span) {
    const client = (0, $x2nP6.getClient)();
    if (!client) return {};
    const rootSpan = (0, $hYVtp.getRootSpan)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$b44d8111286fbc46$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $VxrSw.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const dsc = $b44d8111286fbc46$export$366bad00d6815eed(span.spanContext().traceId, client);
    const jsonSpan = (0, $hYVtp.spanToJSON)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $er6NG.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $er6NG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasTracingEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $E9m4X.hasTracingEnabled)()) dsc.sampled = String((0, $hYVtp.spanIsSampled)(rootSpan));
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $b44d8111286fbc46$export$95cf936fdacaff7b(span) {
    const dsc = $b44d8111286fbc46$export$a117f995597e25df(span);
    return (0, $VxrSw.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}
 //# sourceMappingURL=dynamicSamplingContext.js.map

});
parcelRegister("er6NG", function(module, exports) {
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $a828dcb994e8ffdf$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $a828dcb994e8ffdf$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $a828dcb994e8ffdf$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $a828dcb994e8ffdf$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", () => $a828dcb994e8ffdf$export$165ce9a229f6f050);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $a828dcb994e8ffdf$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $a828dcb994e8ffdf$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $a828dcb994e8ffdf$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $a828dcb994e8ffdf$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $a828dcb994e8ffdf$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $a828dcb994e8ffdf$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $a828dcb994e8ffdf$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $a828dcb994e8ffdf$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $a828dcb994e8ffdf$export$1efec95406bbe327 = 'sentry.profile_id';
const $a828dcb994e8ffdf$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $a828dcb994e8ffdf$export$b016f89ac1066ec = 'cache.hit';
const $a828dcb994e8ffdf$export$3110e4c3f4386399 = 'cache.key';
const $a828dcb994e8ffdf$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $a828dcb994e8ffdf$export$be7a251980e7e946 = 'http.request.method';
const $a828dcb994e8ffdf$export$25dfd73e0e32c6e1 = 'url.full';
 //# sourceMappingURL=semanticAttributes.js.map

});

parcelRegister("VxrSw", function(module, exports) {
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $0acf4530e131f105$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $0acf4530e131f105$export$56766feef403f365);

var $jhPin = parcelRequire("jhPin");

var $fpqOZ = parcelRequire("fpqOZ");

var $gb5jY = parcelRequire("gb5jY");
/**
 * @deprecated Use a `"baggage"` string directly
 */ const $0acf4530e131f105$export$9ca9946bd449ac06 = 'baggage';
const $0acf4530e131f105$export$6e69537d67fa20f = 'sentry-';
const $0acf4530e131f105$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $0acf4530e131f105$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $0acf4530e131f105$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $0acf4530e131f105$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($0acf4530e131f105$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($0acf4530e131f105$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $0acf4530e131f105$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$0acf4530e131f105$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $0acf4530e131f105$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $0acf4530e131f105$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $fpqOZ.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $0acf4530e131f105$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $0acf4530e131f105$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $0acf4530e131f105$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $0acf4530e131f105$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $0acf4530e131f105$export$bdd844ddb2def819) {
            (0, $jhPin.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}
 //# sourceMappingURL=baggage.js.map

});

parcelRegister("E9m4X", function(module, exports) {
$parcel$export(module.exports, "hasTracingEnabled", () => $078afe4591939d95$export$5008da00b1b6dee6);

var $x2nP6 = parcelRequire("x2nP6");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $078afe4591939d95$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $x2nP6.getClient)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}
 //# sourceMappingURL=hasTracingEnabled.js.map

});

parcelRegister("hYVtp", function(module, exports) {
$parcel$export(module.exports, "spanToJSON", () => $d1749f4b838fc980$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceContext", () => $d1749f4b838fc980$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanIsSampled", () => $d1749f4b838fc980$export$5caecac1caaf3a71);
$parcel$export(module.exports, "getRootSpan", () => $d1749f4b838fc980$export$c4c6a79b1260ca1b);
$parcel$export(module.exports, "showSpanDropWarning", () => $d1749f4b838fc980$export$d11691ff45a3e535);

var $6O4vj = parcelRequire("6O4vj");

var $f9r1w = parcelRequire("f9r1w");

var $x2nP6 = parcelRequire("x2nP6");

var $cOvx8 = parcelRequire("cOvx8");

var $er6NG = parcelRequire("er6NG");

var $bCC5S = parcelRequire("bCC5S");

var $gb5jY = parcelRequire("gb5jY");

var $9v9Yl = parcelRequire("9v9Yl");

var $6qqWc = parcelRequire("6qqWc");

var $fPxtX = parcelRequire("fPxtX");

var $cBNQ2 = parcelRequire("cBNQ2");

var $awmk8 = parcelRequire("awmk8");
// These are aligned with OpenTelemetry trace flags
const $d1749f4b838fc980$export$208d5b368507fb8b = 0x0;
const $d1749f4b838fc980$export$eb571cd9b5d98de8 = 0x1;
// todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`
let $d1749f4b838fc980$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $d1749f4b838fc980$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $d1749f4b838fc980$export$92d8c23565496537(span);
    return (0, $9v9Yl.dropUndefinedKeys)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $d1749f4b838fc980$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $d1749f4b838fc980$export$92d8c23565496537(span).parent_span_id;
    const span_id = isRemote ? (0, $6qqWc.generateSpanId)() : spanId;
    return (0, $9v9Yl.dropUndefinedKeys)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $d1749f4b838fc980$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $d1749f4b838fc980$export$5caecac1caaf3a71(span);
    return (0, $cBNQ2.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $d1749f4b838fc980$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $d1749f4b838fc980$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $d1749f4b838fc980$var$ensureTimestampInSeconds(input.getTime());
    return (0, $fPxtX.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $d1749f4b838fc980$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $d1749f4b838fc980$export$92d8c23565496537(span) {
    if ($d1749f4b838fc980$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($d1749f4b838fc980$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $9v9Yl.dropUndefinedKeys)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $d1749f4b838fc980$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $d1749f4b838fc980$export$3f7581298f56c6d7(endTime) || undefined,
                status: $d1749f4b838fc980$export$e238a77ea3a8cd66(status),
                op: attributes[0, $er6NG.SEMANTIC_ATTRIBUTE_SENTRY_OP],
                origin: attributes[0, $er6NG.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
                _metrics_summary: (0, $cOvx8.getMetricSummaryJsonForSpan)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $d1749f4b838fc980$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $d1749f4b838fc980$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $d1749f4b838fc980$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $d1749f4b838fc980$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $d1749f4b838fc980$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $bCC5S.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $bCC5S.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'unknown_error';
}
const $d1749f4b838fc980$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $d1749f4b838fc980$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $d1749f4b838fc980$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$d1749f4b838fc980$var$ROOT_SPAN_FIELD] || span;
    (0, $9v9Yl.addNonEnumerableProperty)(childSpan, $d1749f4b838fc980$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$d1749f4b838fc980$var$CHILD_SPANS_FIELD]) span[$d1749f4b838fc980$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $9v9Yl.addNonEnumerableProperty)(span, $d1749f4b838fc980$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $d1749f4b838fc980$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$d1749f4b838fc980$var$CHILD_SPANS_FIELD]) span[$d1749f4b838fc980$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $d1749f4b838fc980$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($d1749f4b838fc980$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$d1749f4b838fc980$var$CHILD_SPANS_FIELD] ? Array.from(span[$d1749f4b838fc980$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $d1749f4b838fc980$export$c4c6a79b1260ca1b(span) {
    return span[$d1749f4b838fc980$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $d1749f4b838fc980$export$1be426a8e585c83e() {
    const carrier = (0, $f9r1w.getMainCarrier)();
    const acs = (0, $6O4vj.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $awmk8._getSpanForScope)((0, $x2nP6.getCurrentScope)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $d1749f4b838fc980$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $d1749f4b838fc980$export$1be426a8e585c83e();
    if (span) (0, $cOvx8.updateMetricSummaryOnSpan)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 *
 * todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`.
 */ function $d1749f4b838fc980$export$d11691ff45a3e535() {
    if (!$d1749f4b838fc980$var$hasShownSpanDropWarning) {
        (0, $gb5jY.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly.');
        });
        $d1749f4b838fc980$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $d1749f4b838fc980$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $er6NG.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $er6NG.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}
 //# sourceMappingURL=spanUtils.js.map

});
parcelRegister("cOvx8", function(module, exports) {
$parcel$export(module.exports, "getMetricSummaryJsonForSpan", () => $95429d6b6655eb0d$export$2e7205e45c58797d);
$parcel$export(module.exports, "updateMetricSummaryOnSpan", () => $95429d6b6655eb0d$export$102c7b059b14a4a);

var $9v9Yl = parcelRequire("9v9Yl");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $95429d6b6655eb0d$var$METRICS_SPAN_FIELD = '_sentryMetrics';
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $95429d6b6655eb0d$export$2e7205e45c58797d(span) {
    const storage = span[$95429d6b6655eb0d$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $9v9Yl.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $95429d6b6655eb0d$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$95429d6b6655eb0d$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$95429d6b6655eb0d$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}
 //# sourceMappingURL=metric-summary.js.map

});

parcelRegister("bCC5S", function(module, exports) {
$parcel$export(module.exports, "SPAN_STATUS_UNSET", () => $8760caf74c819751$export$136e25984ba4a383);
$parcel$export(module.exports, "SPAN_STATUS_OK", () => $8760caf74c819751$export$58f7963109c806fc);
const $8760caf74c819751$export$136e25984ba4a383 = 0;
const $8760caf74c819751$export$58f7963109c806fc = 1;
const $8760caf74c819751$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $8760caf74c819751$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $8760caf74c819751$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $8760caf74c819751$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $8760caf74c819751$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $8760caf74c819751$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $8760caf74c819751$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}
 //# sourceMappingURL=spanstatus.js.map

});

parcelRegister("cBNQ2", function(module, exports) {
$parcel$export(module.exports, "generateSentryTraceHeader", () => $92df9991bd6f2b4e$export$f35d907436da45cf);

var $VxrSw = parcelRequire("VxrSw");

var $6qqWc = parcelRequire("6qqWc");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $92df9991bd6f2b4e$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $92df9991bd6f2b4e$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($92df9991bd6f2b4e$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $92df9991bd6f2b4e$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $92df9991bd6f2b4e$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $VxrSw.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData || !traceparentData.traceId) return {
        traceId: (0, $6qqWc.generateTraceId)(),
        spanId: (0, $6qqWc.generateSpanId)()
    };
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    const virtualSpanId = (0, $6qqWc.generateSpanId)();
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        spanId: virtualSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $92df9991bd6f2b4e$export$f35d907436da45cf(traceId = (0, $6qqWc.generateTraceId)(), spanId = (0, $6qqWc.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
 //# sourceMappingURL=tracing.js.map

});






parcelRegister("ikNsz", function(module, exports) {
$parcel$export(module.exports, "isApolloError", () => $32e1fdbf2da75fd0$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "hasGraphQlProperties", () => $32e1fdbf2da75fd0$export$dde1f544c19b5495);
$parcel$export(module.exports, "getCustomAttributes", () => $32e1fdbf2da75fd0$export$1ef2b1f78c9e40d9);

var $lUWyH = parcelRequire("lUWyH");
const $32e1fdbf2da75fd0$export$17f5e6bd290bb15d = (error)=>error instanceof (0, $lUWyH.ApolloError);
const $32e1fdbf2da75fd0$export$dde1f544c19b5495 = (error)=>{
    if (typeof error !== 'object' || error === undefined || error === null) return false;
    const graphQlErrorKeys = [
        'operation',
        'message',
        'path',
        'locations',
        'extensions'
    ];
    return graphQlErrorKeys.every((key)=>key in error);
};
const $32e1fdbf2da75fd0$export$1ef2b1f78c9e40d9 = (event, keys)=>keys.reduce((acc, key)=>{
        if (!event.attributes || !('custom' in event.attributes) || typeof event.attributes.custom !== 'object') return acc;
        const value = event.attributes.custom?.[key];
        if (value === undefined) return acc;
        return {
            ...acc,
            [key]: value
        };
    }, {});

});




parcelRegister("gw1Pn", function(module, exports) {
$parcel$export(module.exports, "PageHeader", () => $46bb6bcd960fa2ed$export$53f1cd6809577fc5);
/* page-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");
parcelRequire("lE8gv");

var $ioH72 = parcelRequire("ioH72");
const $46bb6bcd960fa2ed$var$ACTIONS_STYLE_HOOK = 'data-page-header-actions';
// Allows actions to wrap below title at narrow widths
const $46bb6bcd960fa2ed$var$wrappingTitleRowStyles = null;
// Allows multiple actions to wrap over multiple rows at narrow widths
const $46bb6bcd960fa2ed$var$actionsStyles = null;
const $46bb6bcd960fa2ed$export$53f1cd6809577fc5 = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        className: (0, $l2NkF.default)([
            "_96wexy5q _1q531g80 _pxqvidpf"
        ]),
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $ioH72.default), {
            ...props,
            actions: actions && /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
                [$46bb6bcd960fa2ed$var$ACTIONS_STYLE_HOOK]: '',
                className: (0, $l2NkF.default)([
                    "_1e0c1txw _1n261g80 _1p57u2gc _o5724jg8 _6ufw1g80 _1cplidpf"
                ]),
                children: actions
            })
        })
    });

});
parcelRegister("ioH72", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d7c6893539505ee$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $cZ2aX = parcelRequire("cZ2aX");

var $cdnu5 = parcelRequire("cdnu5");

var $8dUA0 = parcelRequire("8dUA0");

var $kYFh3 = parcelRequire("kYFh3");

var $35067 = parcelRequire("35067");

var $38jSh = parcelRequire("38jSh");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $7d7c6893539505ee$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $8dUA0.default), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $38jSh.default), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $35067.default), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kYFh3.default), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $cZ2aX.default), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $cdnu5.default), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $7d7c6893539505ee$export$2e2bcd8739ae039 = $7d7c6893539505ee$var$PageHeader;

});
parcelRegister("cZ2aX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9325eb0d4a6aa760$export$2e2bcd8739ae039);
/* actions-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $9325eb0d4a6aa760$var$actionStyles = null;
/**
 * __Actions wrapper__.
 *
 * An actions wrapper is a wrapper for the actions, which appear on the top right of the PageHeader component.
 *
 */ const $9325eb0d4a6aa760$var$ActionsWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        className: (0, $l2NkF.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
var $9325eb0d4a6aa760$export$2e2bcd8739ae039 = $9325eb0d4a6aa760$var$ActionsWrapper;

});

parcelRegister("cdnu5", function(module, exports) {
$parcel$export(module.exports, "default", () => $f586bcf2609dd441$export$2e2bcd8739ae039);
/* bottom-bar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $7Ql7y = parcelRequire("7Ql7y");
const $f586bcf2609dd441$var$styles = {
    bottomBar: "_1pfhpxbi"
};
/**
 * __Bottom bar__.
 *
 * A bottom bar is a wrapper for the bottom bar, which appears at the bottom of the PageHeader component.
 *
 */ const $f586bcf2609dd441$var$BottomBar = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $7Ql7y.Box), {
        xcss: $f586bcf2609dd441$var$styles.bottomBar,
        children: children
    });
};
var $f586bcf2609dd441$export$2e2bcd8739ae039 = $f586bcf2609dd441$var$BottomBar;

});

parcelRegister("8dUA0", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2d8c8ae4a88ca86$export$2e2bcd8739ae039);
/* outer-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $d2d8c8ae4a88ca86$var$outerStyles = null;
/**
 * __Outer wrapper__.
 *
 * An outer wrapper that is the outermost component of the PageHeader component. It wraps around the PageHeader, its Actions,
 * the BottomBar and its Breadcrumbs.
 *
 */ const $d2d8c8ae4a88ca86$var$OuterWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        className: (0, $l2NkF.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
var $d2d8c8ae4a88ca86$export$2e2bcd8739ae039 = $d2d8c8ae4a88ca86$var$OuterWrapper;

});

parcelRegister("kYFh3", function(module, exports) {
$parcel$export(module.exports, "default", () => $78cee8cd0b68e9d3$export$2e2bcd8739ae039);
/* title.tsx generated by @compiled/babel-plugin v3.0.2 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");

var $lE8gv = parcelRequire("lE8gv");
const $78cee8cd0b68e9d3$var$truncateStyles = null;
const $78cee8cd0b68e9d3$var$titleStyles = null;
/**
 * __Styled title wrapper__.
 *
 * A styled title wrapper is a wrapper around the title that controls its the styles exclusively.
 *
 */ const $78cee8cd0b68e9d3$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $l2NkF.default)([
            "_11c810sd _12ji1r31 _1qu2glyw _12y31o36 _syazi7uo _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
var $78cee8cd0b68e9d3$export$2e2bcd8739ae039 = $78cee8cd0b68e9d3$var$Title;

});

parcelRegister("35067", function(module, exports) {
$parcel$export(module.exports, "default", () => $fed2afd07f124fa1$export$2e2bcd8739ae039);
/* title-container.tsx generated by @compiled/babel-plugin v3.0.2 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $fed2afd07f124fa1$var$titleContainerStyles = null;
const $fed2afd07f124fa1$var$titleContainerTruncateStyles = null;
/**
 * Title container.
 *
 * A title container is a container that wraps around the title and its styles (if applied).
 *
 */ const $fed2afd07f124fa1$var$TitleContainer = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        className: (0, $l2NkF.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc _1i4q1hna",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
var $fed2afd07f124fa1$export$2e2bcd8739ae039 = $fed2afd07f124fa1$var$TitleContainer;

});

parcelRegister("38jSh", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b064a6a27756b7e$export$2e2bcd8739ae039);
/* title-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $5b064a6a27756b7e$var$titleWrapperStyles = null;
const $5b064a6a27756b7e$var$titleWrapperTruncateStyles = null;
/**
 * __Title wrapper__.
 *
 * A title wrapper is a wrapper around the title and the actions.
 *
 */ const $5b064a6a27756b7e$var$TitleWrapper = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        className: (0, $l2NkF.default)([
            "_1e0c1txw _4cvr1y6m _1n261q9c",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
var $5b064a6a27756b7e$export$2e2bcd8739ae039 = $5b064a6a27756b7e$var$TitleWrapper;

});



parcelRegister("25Roh", function(module, exports) {
$parcel$export(module.exports, "useOrgName", () => $28eda8cc67c6fb4f$export$740fa80a533435ab);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $15rQV = parcelRequire("15rQV");
function $28eda8cc67c6fb4f$export$71691c04d9ba4824(Component) {
    return class extends $lE8gv.Component {
        render() {
            return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $15rQV.RouteIdContext).Consumer, {
                children: (value)=>/*#__PURE__*/ (0, $kOwiQ.jsx)(Component, {
                        ...this.props,
                        orgName: value.orgName
                    })
            });
        }
    };
}
const $28eda8cc67c6fb4f$export$740fa80a533435ab = ()=>{
    const routeInfo = $lE8gv.useContext((0, $15rQV.RouteIdContext));
    return routeInfo.orgName;
};

});
parcelRegister("15rQV", function(module, exports) {
$parcel$export(module.exports, "RouteIdContext", () => $d93738d2fb7d188a$export$92d0be8f6ef5c7bf);

var $lE8gv = parcelRequire("lE8gv");
const $d93738d2fb7d188a$var$defaultRouteId = {
    orgId: undefined,
    siteId: undefined,
    isLoading: false,
    orgName: undefined,
    siteName: undefined,
    tenantId: undefined
};
const $d93738d2fb7d188a$export$92d0be8f6ef5c7bf = /*#__PURE__*/ $lE8gv.createContext($d93738d2fb7d188a$var$defaultRouteId);

});


parcelRegister("2AuFz", function(module, exports) {
$parcel$export(module.exports, "useSiteName", () => $6e1bc3cab80800dd$export$47e202e52a137ceb);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $15rQV = parcelRequire("15rQV");
function $6e1bc3cab80800dd$export$f3a441bc514b813e(Component) {
    return class extends $lE8gv.Component {
        render() {
            return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $15rQV.RouteIdContext).Consumer, {
                children: (value)=>/*#__PURE__*/ (0, $kOwiQ.jsx)(Component, {
                        ...this.props,
                        siteName: value.siteName
                    })
            });
        }
    };
}
const $6e1bc3cab80800dd$export$47e202e52a137ceb = ()=>{
    const routeInfo = $lE8gv.useContext((0, $15rQV.RouteIdContext));
    return routeInfo.siteName;
};

});

parcelRegister("lIph6", function(module, exports) {
$parcel$export(module.exports, "Centered", () => $76c5c2d54c7006d5$export$844f199b4427ce36);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $c42RO = parcelRequire("c42RO");
function $76c5c2d54c7006d5$var$horizontal(axis) {
    return axis !== 'vertical';
}
function $76c5c2d54c7006d5$var$vertical(axis) {
    return axis !== 'horizontal';
}
const $76c5c2d54c7006d5$var$CenteredStyle = (0, $c42RO.default).div`
	display: flex;
	${({ axis: axis = 'both' })=>$76c5c2d54c7006d5$var$horizontal(axis) ? (0, $c42RO.css)`
					justify-content: center;
				` : ''}
	${({ axis: axis = 'both' })=>$76c5c2d54c7006d5$var$vertical(axis) ? (0, $c42RO.css)`
					align-items: center;
				` : ''};
`;
const $76c5c2d54c7006d5$export$844f199b4427ce36 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $kOwiQ.jsx)($76c5c2d54c7006d5$var$CenteredStyle, {
        ...props,
        children: children
    });

});

parcelRegister("ezpqI", function(module, exports) {
$parcel$export(module.exports, "useMainLayoutRightSidebar", () => $988a8dd5658a63d8$export$95141422a93f9689);

var $2tHmK = parcelRequire("2tHmK");
const $988a8dd5658a63d8$export$95141422a93f9689 = ()=>({
        showSidebar () {
            (0, $2tHmK.Navigation).reactiveVariables.showRightSidebarContainer(true);
        },
        hideSidebar () {
            (0, $2tHmK.Navigation).reactiveVariables.showRightSidebarContainer(false);
        },
        setExpanded (expanded) {
            (0, $2tHmK.Navigation).reactiveVariables.isRightSidebarExpanded(expanded);
        }
    });

});
parcelRegister("2tHmK", function(module, exports) {
$parcel$export(module.exports, "Navigation", () => $81f3f4dea9d568ae$export$b8a61e5c71402559);
/* eslint-disable @typescript-eslint/no-namespace */ 
var $lUWyH = parcelRequire("lUWyH");
(function(Navigation) {
    (function(DrawerType) {
        DrawerType["NONE"] = "NONE";
        DrawerType["IDM"] = "IDM";
        DrawerType["IDM_NO_REDIRECT"] = "IDM_NO_REDIRECT";
        DrawerType["SAML"] = "SAML";
        DrawerType["USER_PROVISIONING_CREATE_DIRECTORY"] = "USER_PROVISIONING_CREATE_DIRECTORY";
        DrawerType["USER_PROVISIONING_REGEN_API_KEY"] = "USER_PROVISIONING_REGEN_API_KEY";
        DrawerType["CREATE_ADMIN_API_KEY_DRAWER"] = "CREATE_ADMIN_API_KEY_DRAWER";
        DrawerType["CREATE_ADMIN_API_KEY_DRAWER_NEW"] = "CREATE_ADMIN_API_KEY_DRAWER_NEW";
        DrawerType["CREATE_SERVICE_ACCOUNT_DRAWER"] = "CREATE_SERVICE_ACCOUNT_DRAWER";
        DrawerType["CREATE_OAUTH_CREDENTIALS_DRAWER"] = "CREATE_OAUTH_CREDENTIALS_DRAWER";
        DrawerType["API_TOKENS_CONVERSION_DRAWER"] = "API_TOKENS_CONVERSION_DRAWER";
        DrawerType["ADD_APPS_TO_SERVICE_ACCOUNT_DRAWER"] = "ADD_APPS_TO_SERVICE_ACCOUNT_DRAWER";
        DrawerType["ADD_PRODUCT_DRAWER"] = "ADD_PRODUCT_DRAWER";
        DrawerType["SETUP_PRODUCT_DRAWER"] = "SETUP_PRODUCT_DRAWER";
        DrawerType["SELECTIVE_DOMAIN_CLAIM_DRAWER"] = "SELECTIVE_DOMAIN_CLAIM_DRAWER";
        DrawerType["ADD_DOMAIN_DRAWER"] = "ADD_DOMAIN_DRAWER";
        DrawerType["SITE_CREATE"] = "SITE_CREATE";
        DrawerType["INVITE_USER"] = "INVITE_USER";
        DrawerType["INVITE_EXCO_USER"] = "INVITE_EXCO_USER";
        DrawerType["EXPORT_USERS"] = "EXPORT_USERS";
        DrawerType["G_SUITE_WIZARD"] = "G_SUITE_WIZARD";
        DrawerType["ORG_G_SUITE_IN_ACCESS_WIZARD"] = "ORG_G_SUITE_IN_ACCESS_WIZARD";
        DrawerType["ORG_INVITE_USER"] = "ORG_INVITE_USER";
        DrawerType["ORG_SITE_IMPORT"] = "ORG_SITE_IMPORT";
        DrawerType["UNIFIED_SITE_IMPORT"] = "UNIFIED_SITE_IMPORT";
        DrawerType["PRODUCTS_TRANSFER"] = "PRODUCTS_TRANSFER";
        DrawerType["OKTA_CLOUD_CONNECT"] = "OKTA_CLOUD_CONNECT";
        DrawerType["IDP_ADD_SAML"] = "IDP_ADD_SAML";
        DrawerType["IDP_ADD_SCIM"] = "IDP_ADD_SCIM";
        DrawerType["IDP_ADD_SLO"] = "IDP_ADD_SLO";
        DrawerType["JSM_IDP_ADD_SAML"] = "JSM_IDP_ADD_SAML";
        DrawerType["JSM_IDP_ADD_SCIM"] = "JSM_IDP_ADD_SCIM";
        DrawerType["ORG_O_SYNC_DRAWER"] = "ORG_O_SYNC_DRAWER";
        DrawerType["LINK_PRODUCTS_DRAWER"] = "LINK_PRODUCTS_DRAWER";
        DrawerType["ADD_STANDALONE_APP_DRAWER"] = "ADD_STANDALONE_APP_DRAWER";
        DrawerType["ADD_APP_DRAWER"] = "ADD_APP_DRAWER";
        DrawerType["ADD_ATLASSIAN_INTELLIGENCE"] = "ADD_ATLASSIAN_INTELLIGENCE";
        DrawerType["ADD_TOWNSQUARE"] = "ADD_TOWNSQUARE";
        DrawerType["EXTERNAL_USER_SECURITY_ADD_TEST_USERS"] = "EXTERNAL_USER_SECURITY_ADD_TEST_USERS";
        DrawerType["DATA_CLASSIFICATION_EDIT_DRAWER"] = "DATA_CLASSIFICATION_EDIT_DRAWER";
        DrawerType["DATA_CLASSIFICATION_DRAWER"] = "DATA_CLASSIFICATION_DRAWER";
        DrawerType["ADD_SINGLE_PRODUCT_DRAWER"] = "ADD_SINGLE_PRODUCT_DRAWER";
        DrawerType["AGP_ONBOARDING_SITE_SELECTION"] = "AGP_ONBOARDING_SITE_SELECTION";
        DrawerType["LINK_ON_PREM_PRODUCTS_CLOUD_PRODUCT_CONNECTION_DRAWER"] = "LINK_ON_PREM_PRODUCTS_CLOUD_PRODUCT_CONNECTION_DRAWER";
    })(Navigation.DrawerType || (Navigation.DrawerType = {}));
    (function(ModalType) {
        ModalType["NONE"] = "NONE";
        ModalType["AGP_ONBOARDING_PREMIUM_EDITIONS"] = "AGP_ONBOARDING_PREMIUM_EDITIONS";
        ModalType["AGP_ONBOARDING_PREMIUM_TRIAL"] = "AGP_ONBOARDING_PREMIUM_TRIAL";
        ModalType["AGP_ONBOARDING_CONTACT_REP"] = "AGP_ONBOARDING_CONTACT_REP";
        ModalType["AGP_ONBOARDING_NO_TRIAL"] = "AGP_ONBOARDING_NO_TRIAL";
    })(Navigation.ModalType || (Navigation.ModalType = {}));
    Navigation.reactiveVariables = {
        activeDrawer: (0, $lUWyH.makeVar)("NONE"),
        activeModal: (0, $lUWyH.makeVar)("NONE"),
        selectedOrgId: (0, $lUWyH.makeVar)(undefined),
        selectedUserId: (0, $lUWyH.makeVar)(''),
        selectedUserDisplayName: (0, $lUWyH.makeVar)(''),
        redirectOrgRoute: (0, $lUWyH.makeVar)(null),
        selectedDirectoryId: (0, $lUWyH.makeVar)(''),
        selectedClassificationLevelId: (0, $lUWyH.makeVar)(undefined),
        isDataClassificationOnboarding: (0, $lUWyH.makeVar)(false),
        showLeftSidebarContainer: (0, $lUWyH.makeVar)(false),
        showRightSidebarContainer: (0, $lUWyH.makeVar)(false),
        isRightSidebarExpanded: (0, $lUWyH.makeVar)(false),
        activeLeftSidebarView: (0, $lUWyH.makeVar)(null),
        addProductFromTask: (0, $lUWyH.makeVar)(undefined),
        userRequestsAccessRequestsSidebar: (0, $lUWyH.makeVar)(null),
        userRequestsInterestSidebar: (0, $lUWyH.makeVar)(null),
        atlassianIntelligenceContext: (0, $lUWyH.makeVar)(null),
        linkOnPremProductsCloudProductConnectionDrawArgs: (0, $lUWyH.makeVar)(undefined),
        userAccessSettingsUserInvitationsSidebar: (0, $lUWyH.makeVar)(null),
        source: (0, $lUWyH.makeVar)(undefined),
        unitIdFromRoute: (0, $lUWyH.makeVar)(undefined),
        preselectedAppName: (0, $lUWyH.makeVar)(undefined),
        rovoChatAdminEnabled: (0, $lUWyH.makeVar)(false),
        inviteDirectoryId: (0, $lUWyH.makeVar)(undefined)
    };
    Navigation.closeTrialAccessDrawer = ()=>{
        Navigation.reactiveVariables.activeDrawer("NONE");
        Navigation.reactiveVariables.selectedOrgId(undefined);
        Navigation.reactiveVariables.redirectOrgRoute(null);
    };
    Navigation.showTrialAccessDrawer = ({ orgId: orgId, redirectOrgRoute: redirectOrgRoute })=>{
        Navigation.reactiveVariables.activeDrawer("IDM");
        Navigation.reactiveVariables.selectedOrgId(orgId);
        Navigation.reactiveVariables.redirectOrgRoute(redirectOrgRoute);
    };
    Navigation.showResetApiTokenDrawer = ({ externalDirectoryId: externalDirectoryId })=>{
        Navigation.reactiveVariables.activeDrawer("USER_PROVISIONING_REGEN_API_KEY");
        Navigation.reactiveVariables.selectedDirectoryId(externalDirectoryId);
    };
    Navigation.showEditClassificationDrawer = ({ orgId: orgId, levelId: levelId })=>{
        Navigation.reactiveVariables.activeDrawer("DATA_CLASSIFICATION_EDIT_DRAWER");
        Navigation.reactiveVariables.selectedOrgId(orgId);
        Navigation.reactiveVariables.selectedClassificationLevelId(levelId);
    };
    Navigation.showDataClassificationDrawer = ({ showOnboarding: showOnboarding })=>{
        Navigation.reactiveVariables.isDataClassificationOnboarding(showOnboarding);
        Navigation.reactiveVariables.activeDrawer("DATA_CLASSIFICATION_DRAWER");
    };
    Navigation.showAddSingleProductDrawer = (addProductFromTask)=>{
        Navigation.reactiveVariables.activeDrawer("ADD_SINGLE_PRODUCT_DRAWER");
        Navigation.reactiveVariables.addProductFromTask(addProductFromTask);
    };
    Navigation.showUserRequestsInterestSidebar = (interestData)=>{
        Navigation.reactiveVariables.showRightSidebarContainer(true);
        Navigation.reactiveVariables.userRequestsInterestSidebar(interestData);
    };
    Navigation.showUserRequestsAccessRequestsSidebar = (accessRequestData, paginationAttributes, isFromDeeplink = false)=>{
        Navigation.reactiveVariables.showRightSidebarContainer(true);
        Navigation.reactiveVariables.userRequestsAccessRequestsSidebar({
            ...accessRequestData,
            ...paginationAttributes !== undefined && {
                paginationAttributes: paginationAttributes
            },
            isFromDeeplink: isFromDeeplink
        });
    };
    Navigation.clearUserRequestsSidebars = ()=>{
        Navigation.reactiveVariables.userRequestsAccessRequestsSidebar(null);
        Navigation.reactiveVariables.userRequestsInterestSidebar(null);
    };
    Navigation.showLinkOnPremProductsCloudProductConnectionDrawer = (args)=>{
        Navigation.reactiveVariables.activeDrawer("LINK_ON_PREM_PRODUCTS_CLOUD_PRODUCT_CONNECTION_DRAWER");
        Navigation.reactiveVariables.linkOnPremProductsCloudProductConnectionDrawArgs(args);
    };
    Navigation.showUserAccessSettingsUserInvitationsSidebar = (userInvitationsData)=>{
        Navigation.reactiveVariables.showRightSidebarContainer(true);
        Navigation.reactiveVariables.userAccessSettingsUserInvitationsSidebar(userInvitationsData);
    };
    Navigation.showAddAppDrawer = (unitId, preselectedAppName)=>{
        Navigation.reactiveVariables.unitIdFromRoute(unitId);
        Navigation.reactiveVariables.preselectedAppName(preselectedAppName);
        Navigation.reactiveVariables.activeDrawer("ADD_APP_DRAWER");
    };
    Navigation.clearUnitIdFromRoute = ()=>{
        Navigation.reactiveVariables.unitIdFromRoute(undefined);
    };
    Navigation.clearPreselectedAppName = ()=>{
        Navigation.reactiveVariables.preselectedAppName(undefined);
    };
})($81f3f4dea9d568ae$export$b8a61e5c71402559 || ($81f3f4dea9d568ae$export$b8a61e5c71402559 = {}));
var $81f3f4dea9d568ae$export$b8a61e5c71402559;

});


parcelRegister("45DKq", function(module, exports) {
$parcel$export(module.exports, "formatDocumentTitle", () => $a22d49e548b146b0$export$3e5cac8fcc3f469b);
/**
 * Constructs a formatted document title string by joining the provided components with ' - '.
 *
 * This is the same logic used by MainLayout to construct document.title.
 * It is extracted here so that it can be reused by the useDocumentTitle hook
 * for pages that don't use MainLayout (e.g. FocusedTask pages, error pages).
 *
 * @param title - The page-specific title (e.g. "Create migration plan")
 * @param pageParentTitle - The parent page title (e.g. "Cloud migrations")
 * @param siteName - The site name from RouteIdContext (may be undefined)
 * @param orgName - The org name from RouteIdContext (may be undefined)
 * @param admin - The admin suffix (typically "Atlassian Administration")
 * @returns The formatted document title string
 */ const $a22d49e548b146b0$export$3e5cac8fcc3f469b = (title, pageParentTitle, siteName, orgName, admin)=>{
    // Initializing doc title to construct
    const toReturnDocTitle = [];
    // Adding provided components to doc title
    if (title) toReturnDocTitle.push(title);
    if (pageParentTitle) toReturnDocTitle.push(pageParentTitle);
    if (siteName) toReturnDocTitle.push(siteName);
    if (orgName && orgName !== title) toReturnDocTitle.push(orgName);
    toReturnDocTitle.push(admin);
    // Join all components together with a hyphen
    return toReturnDocTitle.join(' - ');
};

});

parcelRegister("6Teat", function(module, exports) {
$parcel$export(module.exports, "adminMessage", () => $f47ff891d77ccfea$export$1a0d6f0bfc13a3e0);

var $4Qx8e = parcelRequire("4Qx8e");
/**
 * The admin suffix message used in document titles.
 */ const $f47ff891d77ccfea$var$messages = (0, $4Qx8e.defineMessages)({
    admin: {
        id: 'main-layout.admin-nonfinal',
        description: 'General label for page titles.',
        defaultMessage: 'Atlassian Administration'
    }
});
const $f47ff891d77ccfea$export$1a0d6f0bfc13a3e0 = $f47ff891d77ccfea$var$messages.admin;

});

parcelRegister("hRlf9", function(module, exports) {
$parcel$export(module.exports, "addCollapsedNavProp", () => $e1957382d7d354b8$export$49076285d1ac3dd1);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $2tHmK = parcelRequire("2tHmK");
function $e1957382d7d354b8$export$49076285d1ac3dd1(Component) {
    const isVisible = (props)=>{
        const { collapsedNav: collapsedNav } = props;
        return !collapsedNav;
    };
    class NavVisibilityControllerImpl extends $lE8gv.Component {
        static getDerivedStateFromProps(nextProps, prevState) {
            const newShouldShow = isVisible(nextProps);
            if (prevState.shouldShowNav === newShouldShow) return null;
            return {
                shouldShowNav: newShouldShow
            };
        }
        componentDidMount() {
            const { shouldShowNav: shouldShowNav } = this.state;
            if (typeof shouldShowNav !== 'undefined') (0, $2tHmK.Navigation).reactiveVariables.showLeftSidebarContainer(shouldShowNav);
        }
        componentDidUpdate(_, nextState) {
            if (this.state.shouldShowNav === nextState.shouldShowNav || typeof nextState.shouldShowNav === 'undefined') return;
            (0, $2tHmK.Navigation).reactiveVariables.showLeftSidebarContainer(nextState.shouldShowNav);
        }
        render() {
            const { collapsedNav: // we are stripping this one to not provide it to the `Component />`
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            collapsedNav, toggleNavigation: // we are stripping this one to not provide it to the `Component />`
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            toggleNavigation, ...rest } = this.props; // we put `any` here to avoid TS error about destructuring a generic type
            return /*#__PURE__*/ (0, $kOwiQ.jsx)(Component, {
                ...rest
            });
        }
        constructor(...args){
            super(...args), this.state = {};
        }
    }
    return NavVisibilityControllerImpl;
}

});

parcelRegister("kF8th", function(module, exports) {
$parcel$export(module.exports, "InlineEditTitle", () => $9d0c52d61e53b8f8$export$30c7300f5fdd9da6);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $c42RO = parcelRequire("c42RO");

var $2kLYy = parcelRequire("2kLYy");

var $afn8r = parcelRequire("afn8r");

var $cFQqg = parcelRequire("cFQqg");

var $b4g8Q = parcelRequire("b4g8Q");

var $3vZdv = parcelRequire("3vZdv");

var $ctuWl = parcelRequire("ctuWl");

var $cstvi = parcelRequire("cstvi");
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $9d0c52d61e53b8f8$var$Title = (0, $c42RO.default).span`
	font-size: ${"var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	font-weight: ${"var(--ds-font-weight-semibold, 600)"};
	padding-top: ${'3'}px;
	margin-top: 0;
	${({ isDisabled: isDisabled })=>isDisabled ? (0, $c42RO.css)`
					color: ${"var(--ds-text-disabled, #080F214A)"};
				` : ''};
`;
const $9d0c52d61e53b8f8$var$compactInputStyles = (0, $c42RO.css)`
	/* Give the compact edit field room to grow so the title isn't clipped
	   mid-word while editing (the read view is content-sized in the toolbar,
	   which would otherwise leave the input very narrow). */
	min-width: 320px;

	input {
		font-size: ${16 / 14}em;
		line-height: ${1.25};
		font-weight: ${"var(--ds-font-weight-semibold, 600)"};
	}
`;
const $9d0c52d61e53b8f8$var$defaultInputStyles = (0, $c42RO.css)`
	input {
		font-size: ${24 / 14}em;
		line-height: ${28 / 24};
		font-weight: ${"var(--ds-font-weight-medium, 500)"};
	}
`;
const $9d0c52d61e53b8f8$var$TextfieldWrapper = (0, $c42RO.default).div`
	input {
		color: ${"var(--ds-text, #292A2E)"};
		letter-spacing: -0.01em;
		margin: 0;
	}
	${(props)=>props.isCompact ? $9d0c52d61e53b8f8$var$compactInputStyles : $9d0c52d61e53b8f8$var$defaultInputStyles};
`;
const $9d0c52d61e53b8f8$var$ErrorWrapper = (0, $c42RO.default).div`
	margin: 0;
	font-size: initial;
`;
const $9d0c52d61e53b8f8$var$WarningIconWrapper = (0, $c42RO.default).div`
	padding-right: ${"var(--ds-space-100, 8px)"};
	line-height: 100%;
`;
const $9d0c52d61e53b8f8$var$InlineEditWrapper = (0, $c42RO.default).div`
	margin-top: ${"var(--ds-space-negative-100, -8px)"};
	width: 100%;

	#error-message {
		font-size: ${"var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
`;
const $9d0c52d61e53b8f8$var$ReadViewWrapper = (0, $c42RO.default).div`
	margin: 0 0 0 ${"var(--ds-space-negative-025, -2px)"};
`;
const $9d0c52d61e53b8f8$export$30c7300f5fdd9da6 = ({ defaultValue: defaultValue, errorMessage: errorMessage, onConfirm: onConfirm, size: size = 'large', as: as })=>{
    const [inlineTitleTextValue, setInlineTitleTextValue] = $lE8gv.useState(defaultValue);
    $lE8gv.useEffect(()=>{
        setInlineTitleTextValue(defaultValue);
    }, [
        defaultValue
    ]);
    const handleConfirm = (value)=>{
        const trimmed = value.trim();
        if (!trimmed) return;
        setInlineTitleTextValue(trimmed);
        if (onConfirm) onConfirm(trimmed);
    };
    const validate = (value)=>{
        if (errorMessage && value === inlineTitleTextValue) return errorMessage;
        return undefined;
    };
    const renderInlineEditView = ({ errorMessage: _errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $b4g8Q.default), {
            isOpen: fieldProps.isInvalid,
            content: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $ctuWl.Box), {
                id: "error-message",
                children: errorMessage
            }),
            placement: "right",
            children: /*#__PURE__*/ (0, $kOwiQ.jsx)($9d0c52d61e53b8f8$var$TextfieldWrapper, {
                isCompact: size !== 'large',
                children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $cstvi.default), {
                    ...fieldProps,
                    autoFocus: true,
                    testId: "inline-edit-edit-view",
                    elemAfterInput: errorMessage && fieldProps.value === inlineTitleTextValue && /*#__PURE__*/ (0, $kOwiQ.jsx)($9d0c52d61e53b8f8$var$WarningIconWrapper, {
                        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cFQqg))), {
                            label: "information",
                            color: "var(--ds-icon-warning, #E06C00)",
                            spacing: "none"
                        })
                    })
                })
            })
        });
    const renderInlineEditReadView = ()=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $afn8r.default), {
            size: size,
            as: as,
            children: /*#__PURE__*/ (0, $kOwiQ.jsxs)($9d0c52d61e53b8f8$var$ReadViewWrapper, {
                "data-testid": "inline-edit-title-view",
                children: [
                    /*#__PURE__*/ (0, $kOwiQ.jsx)($9d0c52d61e53b8f8$var$Title, {
                        isDisabled: false,
                        children: inlineTitleTextValue
                    }),
                    errorMessage && /*#__PURE__*/ (0, $kOwiQ.jsx)($9d0c52d61e53b8f8$var$ErrorWrapper, {
                        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $2kLYy.ErrorMessage), {
                            children: errorMessage
                        })
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($9d0c52d61e53b8f8$var$InlineEditWrapper, {
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $3vZdv.default), {
            defaultValue: inlineTitleTextValue,
            editView: renderInlineEditView,
            readView: renderInlineEditReadView,
            onConfirm: handleConfirm,
            validate: validate,
            isRequired: true
        })
    });
};

});
parcelRegister("2kLYy", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $55cd24972921f695$export$915e9e7bd4f0f96d);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $lI6cI = parcelRequire("lI6cI");

var $gUqVu = parcelRequire("gUqVu");

var $kA3Og = parcelRequire("kA3Og");
const $55cd24972921f695$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $lI6cI.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $gUqVu.default), {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
(0, $kA3Og.default).mark($55cd24972921f695$export$915e9e7bd4f0f96d);

});
parcelRegister("lI6cI", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $11c08b4aeb49ab9c$export$3c4232819458a302);

var $lE8gv = parcelRequire("lE8gv");
const $11c08b4aeb49ab9c$export$3c4232819458a302 = /*#__PURE__*/ (0, $lE8gv.createContext)(undefined);

});

parcelRegister("gUqVu", function(module, exports) {
$parcel$export(module.exports, "default", () => $67d826e80acbe02c$export$2e2bcd8739ae039);
/* message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $lwdf7 = parcelRequire("lwdf7");

var $1hMfY = parcelRequire("1hMfY");

var $haIGR = parcelRequire("haIGR");

var $fBWTV = parcelRequire("fBWTV");

var $SUDaS = parcelRequire("SUDaS");

var $iJdwg = parcelRequire("iJdwg");
const $67d826e80acbe02c$var$messageStyles = null;
const $67d826e80acbe02c$var$messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const $67d826e80acbe02c$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $67d826e80acbe02c$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        className: (0, $l2NkF.default)([
            $67d826e80acbe02c$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $67d826e80acbe02c$var$messageIcons = {
    error: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lwdf7))), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hMfY))), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
};
const $67d826e80acbe02c$var$MessageRow = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, isExiting: isExiting = false, testId: testId })=>{
    const icon = $67d826e80acbe02c$var$messageIcons[appearance];
    const { isWrapper: isWrapper } = (0, $lE8gv.useContext)((0, $SUDaS.MessageWrapperContext));
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsxs)("div", {
        "data-testid": testId,
        id: isExiting ? undefined : fieldId,
        // Let the wrapper own announcements from the first render when present.
        "aria-live": isWrapper ? undefined : 'polite',
        "aria-hidden": isExiting ? true : undefined,
        className: (0, $l2NkF.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            $67d826e80acbe02c$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $kOwiQ.jsx)($67d826e80acbe02c$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $67d826e80acbe02c$var$MotionMessage = (props)=>{
    const isErrorMessage = props.appearance === 'error';
    const { hasMotionBoundary: hasMotionBoundary, transition: transition } = (0, $lE8gv.useContext)((0, $SUDaS.MessageWrapperContext));
    const shouldAnimate = isErrorMessage || hasMotionBoundary;
    const { ref: ref, state: state } = (0, $haIGR.useMotion)({
        initialState: shouldAnimate && transition !== 'instant' ? undefined : 'visible'
    });
    const row = /*#__PURE__*/ (0, $kOwiQ.jsx)($67d826e80acbe02c$var$MessageRow, {
        appearance: props.appearance,
        fieldId: props.fieldId,
        isExiting: state === 'exiting',
        testId: props.testId,
        children: props.children
    });
    if (!shouldAnimate) return row;
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $iJdwg.default), {
        state: state,
        transition: transition,
        motionRef: ref,
        testId: props.testId && `${props.testId}-motion`,
        children: row
    });
};
/**
 * __Message__
 *
 * A message component for displaying messages in a form.
 */ const $67d826e80acbe02c$var$Message = (props)=>{
    if (!(0, $fBWTV.fg)('platform-dst-motion-uplift-input')) return /*#__PURE__*/ (0, $kOwiQ.jsx)($67d826e80acbe02c$var$MessageRow, {
        appearance: props.appearance,
        fieldId: props.fieldId,
        testId: props.testId,
        children: props.children
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($67d826e80acbe02c$var$MotionMessage, {
        appearance: props.appearance,
        fieldId: props.fieldId,
        testId: props.testId,
        children: props.children
    });
};
var $67d826e80acbe02c$export$2e2bcd8739ae039 = $67d826e80acbe02c$var$Message;

});
parcelRegister("haIGR", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $5bc42faf5169a33c$export$2a51cfe9390d36ef);
/* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Exposes start and finish callbacks while useMotion coordinates the animation lifecycle.

var $lE8gv = parcelRequire("lE8gv");

var $3ipAE = parcelRequire("3ipAE");

var $ltdOs = parcelRequire("ltdOs");

var $40b6i = parcelRequire("40b6i");

var $1Jmmk = parcelRequire("1Jmmk");

var $e0fjj = parcelRequire("e0fjj");

var $1n7QE = parcelRequire("1n7QE");

var $lnnSq = parcelRequire("lnnSq");

var $9qQWw = parcelRequire("9qQWw");

var $7EYFw = parcelRequire("7EYFw");
function $5bc42faf5169a33c$export$2a51cfe9390d36ef({ onFinish: onFinishMotion, onStart: onStartMotion, initialState: initialState } = {}) {
    const reducedMotion = (0, $1Jmmk.isReducedMotion)();
    const staggered = (0, $7EYFw.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $9qQWw.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggeredIsReady = staggered.isReady;
    const [state, setState] = (0, $lE8gv.useState)(initialState ?? (appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'));
    // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    const motionState = isExiting ? 'exiting' : state;
    const elementRef = (0, $lE8gv.useRef)(null);
    const onFinishMotionRef = (0, $lE8gv.useRef)(onFinishMotion);
    onFinishMotionRef.current = onFinishMotion;
    const onStartMotionRef = (0, $lE8gv.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    const onExitFinishedRef = (0, $lE8gv.useRef)(onExitFinished);
    onExitFinishedRef.current = onExitFinished;
    const reanimateRef = (0, $lE8gv.useRef)();
    const animationRef = (0, $lE8gv.useRef)();
    const staggeredEntryRef = (0, $lE8gv.useRef)();
    (0, $1n7QE.useLayoutEffect)(()=>{
        if (motionState === 'exiting') onStartMotionRef.current?.('exiting');
        if (motionState === 'entering') onStartMotionRef.current?.('entering');
    }, [
        motionState
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, $lE8gv.useCallback)((currentState, cancelled)=>{
        // We are done animating, so we set the state to visible
        let newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinishedRef.current?.();
            onFinishMotionRef.current?.('exiting');
        }
        if (currentState === 'entering') onFinishMotionRef.current?.('entering');
        if (reanimateRef.current === (0, $lnnSq.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $lnnSq.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $lnnSq.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $lnnSq.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Handles staggered entry
    (0, $lE8gv.useEffect)(()=>{
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $lE8gv.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $40b6i.getDurationMs)((0, $e0fjj.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $ltdOs.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    const reanimate = (0, $lE8gv.useCallback)((value)=>{
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $lnnSq.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $lnnSq.Reanimate).enter) setState('entering');
        else if (value === (0, $lnnSq.Reanimate).exit) setState('exiting');
    }, []);
    const ref = (0, $lE8gv.useMemo)(()=>(0, $3ipAE.default)([
            staggered.ref,
            elementRef
        ]), [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});
parcelRegister("3ipAE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a315edc2cb93c4c$export$2e2bcd8739ae039);
function $2a315edc2cb93c4c$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("ltdOs", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", () => $7e7a151865e562f7$export$dd9b73a7482d05b6);

var $836yG = parcelRequire("836yG");
const $7e7a151865e562f7$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
const $7e7a151865e562f7$var$toCssList = (value)=>value.split(',').map((item)=>item.trim()).filter(Boolean);
const $7e7a151865e562f7$var$toTimeList = (value)=>$7e7a151865e562f7$var$toCssList(value).filter((time)=>$7e7a151865e562f7$var$cssTimePattern.test(time)).map((0, $836yG.convertToMs));
const $7e7a151865e562f7$export$dd9b73a7482d05b6 = (animationName, animationDuration, animationDelay)=>{
    const names = $7e7a151865e562f7$var$toCssList(animationName);
    const durations = $7e7a151865e562f7$var$toTimeList(animationDuration);
    const delays = $7e7a151865e562f7$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    let longestDuration = 0;
    for(let index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        const duration = durations[index % durations.length];
        const delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("836yG", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $8dcc798d27fc4611$export$75eee42ff540d8ae);
const $8dcc798d27fc4611$export$75eee42ff540d8ae = (duration)=>{
    // Use regex to separate the number and the unit
    const matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    const value = parseFloat(matches[1]);
    const unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("40b6i", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $c4af5a9788ec498a$export$d0038b6e47881463);
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ const $c4af5a9788ec498a$export$d0038b6e47881463 = (animation)=>{
    const animations = animation.split(/,(?![^()]*\))/).map((value)=>[
            ...value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g)
        ]).filter((matches)=>matches.length > 0);
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce((longest, matches)=>{
        const toMilliseconds = (match)=>{
            const value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        const timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("1Jmmk", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $30c63238907d0acb$export$b7baf7667a68d87c);

var $lAAAx = parcelRequire("lAAAx");
const $30c63238907d0acb$export$b7baf7667a68d87c = ()=>{
    if (!(0, $lAAAx.isMatchMediaAvailable)()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};

});
parcelRegister("lAAAx", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $98aed12ce1df7b5b$export$c5406bd59b374abd);
const $98aed12ce1df7b5b$export$c5406bd59b374abd = ()=>typeof window !== 'undefined' && 'matchMedia' in window;

});


parcelRegister("e0fjj", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $ee52158b4de31c18$export$82b92541889a035d);

var $5oRUl = parcelRequire("5oRUl");
const $ee52158b4de31c18$export$82b92541889a035d = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        const documentElement = (0, $5oRUl.getDocument)()?.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});
parcelRegister("5oRUl", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $25a3ab5e415d33e2$export$f65ca476c09acec0);
const $25a3ab5e415d33e2$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("1n7QE", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $1257d0301564b64f$export$e5c5a5f917a5871c);

var $lE8gv = parcelRequire("lE8gv");
const $1257d0301564b64f$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $lE8gv.useEffect) : (0, $lE8gv.useLayoutEffect);

});

parcelRegister("lnnSq", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $7b1a5c4b3031fed7$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $7b1a5c4b3031fed7$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("9qQWw", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $d2c6ca3e80a36be9$export$3b6f38abbdcbd000);

var $lE8gv = parcelRequire("lE8gv");

var $jZj0v = parcelRequire("jZj0v");
const $d2c6ca3e80a36be9$export$3b6f38abbdcbd000 = ()=>{
    return (0, $lE8gv.useContext)((0, $jZj0v.ExitingContext));
};

});
parcelRegister("jZj0v", function(module, exports) {
$parcel$export(module.exports, "defaultExitingContext", () => $15a1c44133577d9a$export$52502485782d6180);
$parcel$export(module.exports, "ExitingContext", () => $15a1c44133577d9a$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $15a1c44133577d9a$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $fBWTV = parcelRequire("fBWTV");
const $15a1c44133577d9a$export$52502485782d6180 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
const $15a1c44133577d9a$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $lE8gv.createContext)($15a1c44133577d9a$export$52502485782d6180);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $15a1c44133577d9a$var$wrapChildWithContextProvider = (child, value = $15a1c44133577d9a$export$52502485782d6180)=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($15a1c44133577d9a$export$b9c4904d7a6929e6.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $15a1c44133577d9a$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $lE8gv.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $15a1c44133577d9a$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $15a1c44133577d9a$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $15a1c44133577d9a$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $15a1c44133577d9a$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $15a1c44133577d9a$var$ExitingPersistence = /*#__PURE__*/ (0, $lE8gv.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $lE8gv.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $lE8gv.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $lE8gv.useState)(()=>({
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        }));
    (0, $lE8gv.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
	 * useState is mocked to return a boolean value.
	 */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $15a1c44133577d9a$var$childrenToArray(previousChildren);
    const current = $15a1c44133577d9a$var$childrenToArray(currentChildren);
    if (currentChildren !== children) {
        // Parent updates can rerender this boundary before its children finish exiting. Keep
        // the previous children until their onFinish callbacks release them.
        const hasPendingExit = ((0, $fBWTV.fg)('platform-dst-motion-uplift-labels') || (0, $fBWTV.fg)('platform-dst-motion-uplift-input')) && $15a1c44133577d9a$var$getMissingKeys(current, previous).size > 0;
        setChildren([
            hasPendingExit ? previousChildren : currentChildren,
            children
        ]);
    }
    const nextChildren = currentChildren !== children ? $15a1c44133577d9a$var$childrenToArray(children) : current;
    const missingKeys = $15a1c44133577d9a$var$getMissingKeys(nextChildren, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $15a1c44133577d9a$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $fBWTV.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        // Retained exits can span several parent renders. Unchanged siblings should
        // keep their context identity instead of receiving redundant updates.
        if (((0, $fBWTV.fg)('platform-dst-motion-uplift-labels') || (0, $fBWTV.fg)('platform-dst-motion-uplift-input')) && !isExiting) return $15a1c44133577d9a$var$wrapChildWithContextProvider(child, defaultContext);
        return $15a1c44133577d9a$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$15a1c44133577d9a$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$15a1c44133577d9a$export$2e2bcd8739ae039 = $15a1c44133577d9a$var$ExitingPersistence;
$15a1c44133577d9a$var$ExitingPersistence.displayName = 'ExitingPersistence';

});


parcelRegister("7EYFw", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $a0e584db6e9a8728$export$25c7213fc07ec080);

var $lE8gv = parcelRequire("lE8gv");

var $2jCCg = parcelRequire("2jCCg");

var $1WnSV = parcelRequire("1WnSV");
const $a0e584db6e9a8728$export$25c7213fc07ec080 = ()=>{
    const identifier = (0, $2jCCg.useUniqueId)();
    const context = (0, $lE8gv.useContext)((0, $1WnSV.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("2jCCg", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $1ca8fbbe7d50f0ad$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $lE8gv = parcelRequire("lE8gv");
function $1ca8fbbe7d50f0ad$export$c485849f2e393253() {
    const identifier = (0, $lE8gv.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("1WnSV", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $abb35fd2b489b281$export$5e65d7d58ae96ad8);
$parcel$export(module.exports, "default", () => $abb35fd2b489b281$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $6esjp = parcelRequire("6esjp");

var $1n7QE = parcelRequire("1n7QE");
const $abb35fd2b489b281$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $lE8gv.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $6esjp.default)
    }));
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $abb35fd2b489b281$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $lE8gv.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $lE8gv.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $1n7QE.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($abb35fd2b489b281$export$5e65d7d58ae96ad8.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$abb35fd2b489b281$export$2e2bcd8739ae039 = $abb35fd2b489b281$var$StaggeredEntrance;

});



parcelRegister("SUDaS", function(module, exports) {
$parcel$export(module.exports, "MessageWrapperContext", () => $485def93ba73f9e9$export$579aef2c392a54d4);

var $lE8gv = parcelRequire("lE8gv");
const $485def93ba73f9e9$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $lE8gv.createContext)({
    isWrapper: false,
    hasMotionBoundary: false,
    transition: 'row'
});

});

parcelRegister("iJdwg", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba1151306844389b$export$2e2bcd8739ae039);
/* message-track.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $ba1151306844389b$var$expandRow = null;
const $ba1151306844389b$var$collapseRow = null;
const $ba1151306844389b$var$messageTrackStyles = {
    root: "_1e0c11p5 _2z05hkll",
    row: "_1tkeidpf",
    hidden: "_2z0563bf _3um015vq",
    invisible: "_3um015vq",
    enteringExpand: "_y44vum57 _1bumglyw",
    exitingCollapse: "_y44vhopr _1bumglyw",
    entering: "_y44v17p6 _1bumglyw",
    exiting: "_y44vst8y _1bumglyw",
    exitingInstant: "_1e0cglyw"
};
const $ba1151306844389b$var$MessageTrack = ({ children: children, transition: transition, motionRef: motionRef, state: state, testId: testId })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        ref: motionRef,
        "aria-hidden": state === 'exiting' ? true : undefined,
        "data-testid": testId,
        className: (0, $l2NkF.default)([
            $ba1151306844389b$var$messageTrackStyles.root,
            transition === 'row' && (state === 'init' || state === 'hidden') && $ba1151306844389b$var$messageTrackStyles.hidden,
            transition === 'groupEnter' && (state === 'init' || state === 'hidden') && $ba1151306844389b$var$messageTrackStyles.invisible,
            transition === 'row' && state === 'entering' && $ba1151306844389b$var$messageTrackStyles.enteringExpand,
            transition === 'row' && state === 'exiting' && $ba1151306844389b$var$messageTrackStyles.exitingCollapse,
            transition === 'groupEnter' && state === 'entering' && $ba1151306844389b$var$messageTrackStyles.entering,
            transition === 'groupExit' && state === 'exiting' && $ba1151306844389b$var$messageTrackStyles.exiting,
            transition === 'instant' && state === 'exiting' && $ba1151306844389b$var$messageTrackStyles.exitingInstant
        ]),
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
            className: (0, $l2NkF.default)([
                $ba1151306844389b$var$messageTrackStyles.row
            ]),
            children: children
        })
    });
var $ba1151306844389b$export$2e2bcd8739ae039 = $ba1151306844389b$var$MessageTrack;

});


parcelRegister("kA3Og", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffe0be9ffa0ced3e$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");
const $ffe0be9ffa0ced3e$var$messageMotionCapability = Symbol.for('@atlaskit/form/message-motion-capable');
const $ffe0be9ffa0ced3e$var$messageMotion = {
    mark (component) {
        Object.defineProperty(component, $ffe0be9ffa0ced3e$var$messageMotionCapability, {
            value: true
        });
    },
    isCapable (child) {
        if (!/*#__PURE__*/ (0, $lE8gv.isValidElement)(child)) return false;
        const childType = child.type;
        return (typeof childType === 'function' || typeof childType === 'object' && childType !== null) && Reflect.get(childType, $ffe0be9ffa0ced3e$var$messageMotionCapability) === true;
    }
};
var $ffe0be9ffa0ced3e$export$2e2bcd8739ae039 = $ffe0be9ffa0ced3e$var$messageMotion;

});


parcelRegister("b4g8Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $5dcf55eed1579925$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $5Ifxs = parcelRequire("5Ifxs");

var $lC4HT = parcelRequire("lC4HT");

var $6esjp = parcelRequire("6esjp");

var $gvny8 = parcelRequire("gvny8");

var $hAJGY = parcelRequire("hAJGY");

var $jZ3f4 = parcelRequire("jZ3f4");

var $fBWTV = parcelRequire("fBWTV");

var $amLEq = parcelRequire("amLEq");

var $d0Uue = parcelRequire("d0Uue");

var $96Stf = parcelRequire("96Stf");

var $d0sYo = parcelRequire("d0sYo");

var $cOP98 = parcelRequire("cOP98");
const $5dcf55eed1579925$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $5dcf55eed1579925$var$checkIsChildOfPortal(node.parentElement);
};
// Close manager for layering
const $5dcf55eed1579925$var$CloseManager = ({ handleEscapeClose: handleEscapeClose, handleClick: handleClick })=>{
    (0, $hAJGY.useCloseOnEscapePress)({
        onClose: handleEscapeClose
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $jZ3f4.useLayering)();
    (0, $lE8gv.useEffect)(()=>{
        return (0, $5Ifxs.bind)(window, {
            type: 'click',
            listener: (e)=>{
                if (isLayerDisabled()) return;
                handleClick(e);
            },
            options: {
                capture: true
            }
        });
    }, [
        handleClick,
        isLayerDisabled
    ]);
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {});
};
const $5dcf55eed1579925$var$InlineDialog = /*#__PURE__*/ (0, $lE8gv.memo)(function InlineDialog(props) {
    if ((0, $fBWTV.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $cOP98.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($5dcf55eed1579925$var$InlineDialogLegacy, {
        ...props
    });
});
function $5dcf55eed1579925$var$InlineDialogLegacy({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $6esjp.default), onContentClick: onContentClick = (0, $6esjp.default), onContentFocus: onContentFocus = (0, $6esjp.default), onClose: providedOnClose = (0, $6esjp.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children, fallbackPlacements: fallbackPlacements }) {
    const containerRef = (0, $lE8gv.useRef)(null);
    const triggerRef = (0, $lE8gv.useRef)(null);
    const onClose = (0, $lC4HT.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: undefined,
        packageVersion: undefined
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $lE8gv.useRef)(onClose);
    (0, $lE8gv.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $lE8gv.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isOpen) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($5dcf55eed1579925$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isOpen
    ]);
    const handleClick = (0, $lE8gv.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        if (containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        containerRef,
        triggerRef
    ]);
    /**
	 * Auto-flip is enabled by default in `@atlaskit/popper` and
	 * the `InlineDialog` API does not allow disabling it.
	 *
	 * We only need to override it if there are `fallbackPlacements` specified.
	 */ const modifiers = (0, $lE8gv.useMemo)(()=>fallbackPlacements ? [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ] : [], [
        fallbackPlacements
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $amLEq.Popper), {
        placement: placement,
        strategy: strategy,
        modifiers: modifiers,
        children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $d0sYo.Container), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                style: style,
                testId: testId,
                children: typeof content === 'function' ? content() : content
            })
    }) : null;
    return /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $d0Uue.Manager), {
        children: [
            /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $96Stf.Reference), {
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
                        ref: (node)=>{
                            // Resolve to the first element child of the div in `children`
                            const firstElementChild = node?.firstElementChild || null;
                            triggerRef.current = firstElementChild;
                            if (typeof ref === 'function') ref(firstElementChild);
                            else ref.current = firstElementChild;
                        },
                        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).Fragment, {
                            children: children
                        })
                    })
            }),
            isOpen ? /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $gvny8.Layering), {
                isDisabled: false,
                children: [
                    popper,
                    /*#__PURE__*/ (0, $kOwiQ.jsx)($5dcf55eed1579925$var$CloseManager, {
                        handleEscapeClose: handleCloseRequest,
                        handleClick: handleClick
                    })
                ]
            }) : popper
        ]
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5dcf55eed1579925$export$2e2bcd8739ae039 = $5dcf55eed1579925$var$InlineDialog;

});
parcelRegister("5Ifxs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $hE4Hi = parcelRequire("hE4Hi");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $hE4Hi.bind;
    }
});

var $wZM3k = parcelRequire("wZM3k");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $wZM3k.bindAll;
    }
});

});
parcelRegister("hE4Hi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $cd89d0e2557b6cdd$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $cd89d0e2557b6cdd$var$bind;

});

parcelRegister("wZM3k", function(module, exports) {
"use strict";
var $0632e84fd26b41c6$var$__assign = module.exports && module.exports.__assign || function() {
    $0632e84fd26b41c6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0632e84fd26b41c6$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $hE4Hi = parcelRequire("hE4Hi");
function $0632e84fd26b41c6$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $0632e84fd26b41c6$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $0632e84fd26b41c6$var$__assign($0632e84fd26b41c6$var$__assign({}, original), {
        options: $0632e84fd26b41c6$var$__assign($0632e84fd26b41c6$var$__assign({}, $0632e84fd26b41c6$var$toOptions(sharedOptions)), $0632e84fd26b41c6$var$toOptions(original.options))
    });
    return binding;
}
function $0632e84fd26b41c6$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $0632e84fd26b41c6$var$getBinding(original, sharedOptions);
        return (0, $hE4Hi.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $0632e84fd26b41c6$var$bindAll;

});


parcelRegister("gvny8", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $2f435394e0d2e1ee$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $6GKQE = parcelRequire("6GKQE");

var $4Qib8 = parcelRequire("4Qib8");

var $50CH5 = parcelRequire("50CH5");

var $2ztwy = parcelRequire("2ztwy");
const $2f435394e0d2e1ee$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $lE8gv.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode?.addChild(levelNodeSafe);
        return ()=>{
            parentNode?.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $4Qib8.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $50CH5.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
const $2f435394e0d2e1ee$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $lE8gv.useContext)((0, $4Qib8.LevelContext));
    const parentNode = (0, $lE8gv.useContext)((0, $50CH5.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $lE8gv.useRef)(new (0, $6GKQE.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kOwiQ.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $kOwiQ.jsx)($2f435394e0d2e1ee$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $2ztwy.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};

});
parcelRegister("6GKQE", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $be4ce251359c07b9$export$da4f61fd78d35243);
class $be4ce251359c07b9$export$da4f61fd78d35243 {
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}

});

parcelRegister("4Qib8", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $44a0d44f8a069977$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $lE8gv = parcelRequire("lE8gv");
const $44a0d44f8a069977$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $lE8gv.createContext)(0);

});

parcelRegister("50CH5", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $0acc07e0892e3e08$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $lE8gv = parcelRequire("lE8gv");
const $0acc07e0892e3e08$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $lE8gv.createContext)({
    current: null
});

});

parcelRegister("2ztwy", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $004f4c6cf4c8ae25$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $lE8gv = parcelRequire("lE8gv");
const $004f4c6cf4c8ae25$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $lE8gv.createContext)({
    current: null
});

});


parcelRegister("hAJGY", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $56b13bfe8623c7f3$export$4a4bf067ea9e7886);

var $lE8gv = parcelRequire("lE8gv");

var $5Ifxs = parcelRequire("5Ifxs");

var $jZ3f4 = parcelRequire("jZ3f4");
const $56b13bfe8623c7f3$var$ESCAPE = 'Escape';
function $56b13bfe8623c7f3$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled, isEnabled: isEnabled = true }) {
    const escapePressed = (0, $lE8gv.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = (0, $jZ3f4.useLayering)({
        isEnabled: isEnabled
    });
    const onKeyDown = (0, $lE8gv.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $56b13bfe8623c7f3$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $lE8gv.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $lE8gv.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $5Ifxs.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        isEnabled,
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("jZ3f4", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $145610af26616be4$export$c8b4d54e03dee6ed);

var $lE8gv = parcelRequire("lE8gv");

var $4Qib8 = parcelRequire("4Qib8");

var $50CH5 = parcelRequire("50CH5");

var $2ztwy = parcelRequire("2ztwy");
function $145610af26616be4$export$c8b4d54e03dee6ed({ isEnabled: isEnabled = true } = {}) {
    const levelFromContext = (0, $lE8gv.useContext)((0, $4Qib8.LevelContext));
    const currentLevel = isEnabled ? levelFromContext : 0;
    const layerNode = (0, $lE8gv.useContext)((0, $50CH5.LevelNodeContext));
    const rootNode = (0, $lE8gv.useContext)((0, $2ztwy.RootNodeContext));
    const isLayerDisabled = (0, $lE8gv.useCallback)(()=>{
        if (!isEnabled) return false;
        // This is an impossible case, added for type safety
        if (!layerNode?.current || !rootNode?.current) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        isEnabled,
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $lE8gv.useCallback)(()=>{
        if (!isEnabled) return null;
        return rootNode?.current ? rootNode.current.getHeight() : null;
    }, [
        isEnabled,
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});


parcelRegister("amLEq", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $b7e695e4cb135686$export$badac9ada3a0bdf9);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $2rJtU = parcelRequire("2rJtU");

var $fBWTV = parcelRequire("fBWTV");

var $1SubA = parcelRequire("1SubA");

var $hTIUJ = parcelRequire("hTIUJ");

const $b7e695e4cb135686$var$viewportPadding = 5;
const $b7e695e4cb135686$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $b7e695e4cb135686$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $b7e695e4cb135686$var$defaultChildrenFn() {
    return null;
}
const $b7e695e4cb135686$var$defaultOffset = [
    0,
    8
];
function $b7e695e4cb135686$export$badac9ada3a0bdf9({ children: children, offset: offset, placement: placement, referenceElement: referenceElement, modifiers: modifiers, strategy: strategy, shouldFitViewport: shouldFitViewport }) {
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $fBWTV.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $hTIUJ.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($b7e695e4cb135686$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $b7e695e4cb135686$var$LegacyPopper({ children: children = $b7e695e4cb135686$var$defaultChildrenFn, offset: offset = $b7e695e4cb135686$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $lE8gv.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $b7e695e4cb135686$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $1SubA.getMaxSizeModifiers)({
            viewportPadding: $b7e695e4cb135686$var$viewportPadding
        }) : [];
        return [
            ...$b7e695e4cb135686$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $lE8gv.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $2rJtU.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("2rJtU", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $1c81620c73446dff$export$badac9ada3a0bdf9);

var $lE8gv = parcelRequire("lE8gv");

var $iUr3Z = parcelRequire("iUr3Z");

var $hofj5 = parcelRequire("hofj5");

var $al9Lh = parcelRequire("al9Lh");
var $1c81620c73446dff$var$NOOP = function NOOP() {
    return void 0;
};
var $1c81620c73446dff$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $1c81620c73446dff$var$EMPTY_MODIFIERS = [];
function $1c81620c73446dff$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $1c81620c73446dff$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $lE8gv.useContext((0, $iUr3Z.ManagerReferenceNodeContext));
    var _React$useState = $lE8gv.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $lE8gv.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $lE8gv.useEffect(function() {
        (0, $hofj5.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $lE8gv.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $al9Lh.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $lE8gv.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $1c81620c73446dff$var$NOOP,
            update: update || $1c81620c73446dff$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $hofj5.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("iUr3Z", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $dc4273271ab0466a$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $dc4273271ab0466a$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $dc4273271ab0466a$export$d0d38e7dec7a1a61);

var $lE8gv = parcelRequire("lE8gv");
var $dc4273271ab0466a$export$3dbd3405086fec7b = $lE8gv.createContext();
var $dc4273271ab0466a$export$cbabb21c2529b130 = $lE8gv.createContext();
function $dc4273271ab0466a$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $lE8gv.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $lE8gv.useRef(false);
    $lE8gv.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $lE8gv.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $lE8gv.createElement($dc4273271ab0466a$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $lE8gv.createElement($dc4273271ab0466a$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("hofj5", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $ca908d311c331b1a$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $ca908d311c331b1a$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $ca908d311c331b1a$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $ca908d311c331b1a$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $ca908d311c331b1a$export$700979bc83e7db82);

var $lE8gv = parcelRequire("lE8gv");
var $ca908d311c331b1a$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $ca908d311c331b1a$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $ca908d311c331b1a$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $ca908d311c331b1a$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $ca908d311c331b1a$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $ca908d311c331b1a$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $lE8gv.useLayoutEffect : $lE8gv.useEffect;

});

parcelRegister("al9Lh", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $78736ffacd697a47$export$f4d5bf230a36dd6e);

var $lE8gv = parcelRequire("lE8gv");

var $b450B = parcelRequire("b450B");

var $hnYnF = parcelRequire("hnYnF");

var $glWoR = parcelRequire("glWoR");

var $hofj5 = parcelRequire("hofj5");
var $78736ffacd697a47$var$EMPTY_MODIFIERS = [];
var $78736ffacd697a47$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $lE8gv.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $78736ffacd697a47$var$EMPTY_MODIFIERS
    };
    var _React$useState = $lE8gv.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $lE8gv.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $b450B.flushSync(function() {
                    setState({
                        styles: (0, $hofj5.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $hofj5.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $lE8gv.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($glWoR)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $lE8gv.useRef();
    (0, $hofj5.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $hofj5.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $hnYnF.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("hnYnF", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $ca836bff0ceac793$export$8f7491d57c8f97a9);

var $9yzFP = parcelRequire("9yzFP");

var $10qfj = parcelRequire("10qfj");

var $e44HK = parcelRequire("e44HK");

var $8MF7o = parcelRequire("8MF7o");

var $b3ruI = parcelRequire("b3ruI");

var $bpIHh = parcelRequire("bpIHh");

var $iZO9z = parcelRequire("iZO9z");

var $3HxTq = parcelRequire("3HxTq");

var $jYFiS = parcelRequire("jYFiS");

var $kdhdO = parcelRequire("kdhdO");


var $ca836bff0ceac793$export$d34966752335dd47 = [
    (0, $10qfj.default),
    (0, $e44HK.default),
    (0, $8MF7o.default),
    (0, $b3ruI.default),
    (0, $bpIHh.default),
    (0, $iZO9z.default),
    (0, $3HxTq.default),
    (0, $jYFiS.default),
    (0, $kdhdO.default)
];
var $ca836bff0ceac793$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $9yzFP.popperGenerator)({
    defaultModifiers: $ca836bff0ceac793$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("9yzFP", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $6f52f614824b50f0$export$ed5e13716264f202);

var $bjjb7 = parcelRequire("bjjb7");

var $1AIhw = parcelRequire("1AIhw");

var $jQQNx = parcelRequire("jQQNx");

var $Np85X = parcelRequire("Np85X");

var $8Bl4s = parcelRequire("8Bl4s");

var $4Mmgf = parcelRequire("4Mmgf");

var $1rggl = parcelRequire("1rggl");


var $idCAj = parcelRequire("idCAj");
var $6f52f614824b50f0$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $6f52f614824b50f0$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $6f52f614824b50f0$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $6f52f614824b50f0$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $6f52f614824b50f0$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $idCAj.isElement)(reference) ? (0, $jQQNx.default)(reference) : reference.contextElement ? (0, $jQQNx.default)(reference.contextElement) : [],
                    popper: (0, $jQQNx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $8Bl4s.default)((0, $1rggl.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$6f52f614824b50f0$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bjjb7.default)(reference, (0, $Np85X.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $1AIhw.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4Mmgf.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$6f52f614824b50f0$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $6f52f614824b50f0$export$8f7491d57c8f97a9 = /*#__PURE__*/ $6f52f614824b50f0$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("bjjb7", function(module, exports) {
$parcel$export(module.exports, "default", () => $83c05878decb7af3$export$2e2bcd8739ae039);

var $8rh79 = parcelRequire("8rh79");

var $ftpcA = parcelRequire("ftpcA");

var $5mD3D = parcelRequire("5mD3D");

var $idCAj = parcelRequire("idCAj");

var $hTkTh = parcelRequire("hTkTh");

var $fECmK = parcelRequire("fECmK");

var $cPOkM = parcelRequire("cPOkM");

var $bJIYU = parcelRequire("bJIYU");
function $83c05878decb7af3$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $bJIYU.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $bJIYU.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $83c05878decb7af3$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $idCAj.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $idCAj.isHTMLElement)(offsetParent) && $83c05878decb7af3$var$isElementScaled(offsetParent);
    var documentElement = (0, $fECmK.default)(offsetParent);
    var rect = (0, $8rh79.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $5mD3D.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $cPOkM.default)(documentElement)) scroll = (0, $ftpcA.default)(offsetParent);
        if ((0, $idCAj.isHTMLElement)(offsetParent)) {
            offsets = (0, $8rh79.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $hTkTh.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("8rh79", function(module, exports) {
$parcel$export(module.exports, "default", () => $624e1ee81fc4b69b$export$2e2bcd8739ae039);

var $idCAj = parcelRequire("idCAj");

var $bJIYU = parcelRequire("bJIYU");

var $7lam2 = parcelRequire("7lam2");

var $bX0d4 = parcelRequire("bX0d4");
function $624e1ee81fc4b69b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $idCAj.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $bJIYU.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $bJIYU.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $idCAj.isElement)(element) ? (0, $7lam2.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bX0d4.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("idCAj", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $d4375f0157bf3416$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $d4375f0157bf3416$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $d4375f0157bf3416$export$af51f0f06c0f328a);

var $7lam2 = parcelRequire("7lam2");
function $d4375f0157bf3416$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $7lam2.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d4375f0157bf3416$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $7lam2.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d4375f0157bf3416$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $7lam2.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("7lam2", function(module, exports) {
$parcel$export(module.exports, "default", () => $558286c10b3e0a62$export$2e2bcd8739ae039);
function $558286c10b3e0a62$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("bJIYU", function(module, exports) {
$parcel$export(module.exports, "max", () => $88b6ca0cf542df2f$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $88b6ca0cf542df2f$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $88b6ca0cf542df2f$export$2077e0241d6afd3c);
var $88b6ca0cf542df2f$export$8960430cfd85939f = Math.max;
var $88b6ca0cf542df2f$export$96ec731ed4dcb222 = Math.min;
var $88b6ca0cf542df2f$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("bX0d4", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b355e096db5ec6e$export$2e2bcd8739ae039);

var $2TizI = parcelRequire("2TizI");
function $8b355e096db5ec6e$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $2TizI.default)());
}

});
parcelRegister("2TizI", function(module, exports) {
$parcel$export(module.exports, "default", () => $21af2076e421cd7c$export$2e2bcd8739ae039);
function $21af2076e421cd7c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("ftpcA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b43d1d07dd4e21d2$export$2e2bcd8739ae039);

var $cJ4aX = parcelRequire("cJ4aX");

var $7lam2 = parcelRequire("7lam2");

var $idCAj = parcelRequire("idCAj");

var $dkflC = parcelRequire("dkflC");
function $b43d1d07dd4e21d2$export$2e2bcd8739ae039(node) {
    if (node === (0, $7lam2.default)(node) || !(0, $idCAj.isHTMLElement)(node)) return (0, $cJ4aX.default)(node);
    else return (0, $dkflC.default)(node);
}

});
parcelRegister("cJ4aX", function(module, exports) {
$parcel$export(module.exports, "default", () => $943ced389b5c36a7$export$2e2bcd8739ae039);

var $7lam2 = parcelRequire("7lam2");
function $943ced389b5c36a7$export$2e2bcd8739ae039(node) {
    var win = (0, $7lam2.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("dkflC", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b390c5b43aaf0b8$export$2e2bcd8739ae039);
function $9b390c5b43aaf0b8$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("5mD3D", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e7d4dd4dc902f36$export$2e2bcd8739ae039);
function $3e7d4dd4dc902f36$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("hTkTh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d067c7278f064519$export$2e2bcd8739ae039);

var $8rh79 = parcelRequire("8rh79");

var $fECmK = parcelRequire("fECmK");

var $cJ4aX = parcelRequire("cJ4aX");
function $d067c7278f064519$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $8rh79.default)((0, $fECmK.default)(element)).left + (0, $cJ4aX.default)(element).scrollLeft;
}

});
parcelRegister("fECmK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6585a18e72f8942$export$2e2bcd8739ae039);

var $idCAj = parcelRequire("idCAj");
function $b6585a18e72f8942$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $idCAj.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("cPOkM", function(module, exports) {
$parcel$export(module.exports, "default", () => $95814ac177871ff6$export$2e2bcd8739ae039);

var $cJX6r = parcelRequire("cJX6r");
function $95814ac177871ff6$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cJX6r.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("cJX6r", function(module, exports) {
$parcel$export(module.exports, "default", () => $946788a0f4cb5b21$export$2e2bcd8739ae039);

var $7lam2 = parcelRequire("7lam2");
function $946788a0f4cb5b21$export$2e2bcd8739ae039(element) {
    return (0, $7lam2.default)(element).getComputedStyle(element);
}

});



parcelRegister("1AIhw", function(module, exports) {
$parcel$export(module.exports, "default", () => $128b80a39e30dddc$export$2e2bcd8739ae039);

var $8rh79 = parcelRequire("8rh79");
function $128b80a39e30dddc$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $8rh79.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("jQQNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $e73bd43d63fc0476$export$2e2bcd8739ae039);

var $9UXQr = parcelRequire("9UXQr");

var $bwhG0 = parcelRequire("bwhG0");

var $7lam2 = parcelRequire("7lam2");

var $cPOkM = parcelRequire("cPOkM");
function $e73bd43d63fc0476$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $9UXQr.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $7lam2.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $cPOkM.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($e73bd43d63fc0476$export$2e2bcd8739ae039((0, $bwhG0.default)(target)));
}

});
parcelRegister("9UXQr", function(module, exports) {
$parcel$export(module.exports, "default", () => $7387c3f0ee75f57e$export$2e2bcd8739ae039);

var $bwhG0 = parcelRequire("bwhG0");

var $cPOkM = parcelRequire("cPOkM");

var $5mD3D = parcelRequire("5mD3D");

var $idCAj = parcelRequire("idCAj");
function $7387c3f0ee75f57e$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $5mD3D.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $idCAj.isHTMLElement)(node) && (0, $cPOkM.default)(node)) return node;
    return $7387c3f0ee75f57e$export$2e2bcd8739ae039((0, $bwhG0.default)(node));
}

});
parcelRegister("bwhG0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8630650c8c83364c$export$2e2bcd8739ae039);

var $5mD3D = parcelRequire("5mD3D");

var $fECmK = parcelRequire("fECmK");

var $idCAj = parcelRequire("idCAj");
function $8630650c8c83364c$export$2e2bcd8739ae039(element) {
    if ((0, $5mD3D.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $idCAj.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $fECmK.default)(element) // fallback
    );
}

});



parcelRegister("Np85X", function(module, exports) {
$parcel$export(module.exports, "default", () => $094811ed1a686541$export$2e2bcd8739ae039);

var $7lam2 = parcelRequire("7lam2");

var $5mD3D = parcelRequire("5mD3D");

var $cJX6r = parcelRequire("cJX6r");

var $idCAj = parcelRequire("idCAj");

var $jIYwx = parcelRequire("jIYwx");

var $bwhG0 = parcelRequire("bwhG0");

var $2TizI = parcelRequire("2TizI");
function $094811ed1a686541$var$getTrueOffsetParent(element) {
    if (!(0, $idCAj.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cJX6r.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $094811ed1a686541$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $2TizI.default)());
    var isIE = /Trident/i.test((0, $2TizI.default)());
    if (isIE && (0, $idCAj.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cJX6r.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $bwhG0.default)(element);
    if ((0, $idCAj.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $idCAj.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $5mD3D.default)(currentNode)) < 0){
        var css = (0, $cJX6r.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $094811ed1a686541$export$2e2bcd8739ae039(element) {
    var window = (0, $7lam2.default)(element);
    var offsetParent = $094811ed1a686541$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $jIYwx.default)(offsetParent) && (0, $cJX6r.default)(offsetParent).position === 'static')offsetParent = $094811ed1a686541$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $5mD3D.default)(offsetParent) === 'html' || (0, $5mD3D.default)(offsetParent) === 'body' && (0, $cJX6r.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $094811ed1a686541$var$getContainingBlock(element) || window;
}

});
parcelRegister("jIYwx", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5c11326c7c7fe46$export$2e2bcd8739ae039);

var $5mD3D = parcelRequire("5mD3D");
function $e5c11326c7c7fe46$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $5mD3D.default)(element)) >= 0;
}

});


parcelRegister("8Bl4s", function(module, exports) {
$parcel$export(module.exports, "default", () => $64321fa72cfd7cb3$export$2e2bcd8739ae039);

var $hqIIS = parcelRequire("hqIIS");
function $64321fa72cfd7cb3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $64321fa72cfd7cb3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $64321fa72cfd7cb3$var$order(modifiers); // order based on phase
    return (0, $hqIIS.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("hqIIS", function(module, exports) {
$parcel$export(module.exports, "top", () => $cb078e631b7f146e$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $cb078e631b7f146e$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $cb078e631b7f146e$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $cb078e631b7f146e$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $cb078e631b7f146e$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $cb078e631b7f146e$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $cb078e631b7f146e$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $cb078e631b7f146e$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $cb078e631b7f146e$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $cb078e631b7f146e$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $cb078e631b7f146e$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $cb078e631b7f146e$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $cb078e631b7f146e$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $cb078e631b7f146e$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $cb078e631b7f146e$export$d087d3878fdf71d5);
var $cb078e631b7f146e$export$1e95b668f3b82d = 'top';
var $cb078e631b7f146e$export$40e543e69a8b3fbb = 'bottom';
var $cb078e631b7f146e$export$79ffe56a765070d2 = 'right';
var $cb078e631b7f146e$export$eabcd2c8791e7bf4 = 'left';
var $cb078e631b7f146e$export$dfb5619354ba860 = 'auto';
var $cb078e631b7f146e$export$aec2ce47c367b8c3 = [
    $cb078e631b7f146e$export$1e95b668f3b82d,
    $cb078e631b7f146e$export$40e543e69a8b3fbb,
    $cb078e631b7f146e$export$79ffe56a765070d2,
    $cb078e631b7f146e$export$eabcd2c8791e7bf4
];
var $cb078e631b7f146e$export$b3571188c770cc5a = 'start';
var $cb078e631b7f146e$export$bd5df0f255a350f8 = 'end';
var $cb078e631b7f146e$export$390fd549c5303b4d = 'clippingParents';
var $cb078e631b7f146e$export$d7b7311ec04a3e8f = 'viewport';
var $cb078e631b7f146e$export$ae5ab1c730825774 = 'popper';
var $cb078e631b7f146e$export$ca50aac9f3ba507f = 'reference';
var $cb078e631b7f146e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $cb078e631b7f146e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $cb078e631b7f146e$export$b3571188c770cc5a,
        placement + "-" + $cb078e631b7f146e$export$bd5df0f255a350f8
    ]);
}, []);
var $cb078e631b7f146e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($cb078e631b7f146e$export$aec2ce47c367b8c3, [
    $cb078e631b7f146e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $cb078e631b7f146e$export$b3571188c770cc5a,
        placement + "-" + $cb078e631b7f146e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $cb078e631b7f146e$export$421679a7c3d56e = 'beforeRead';
var $cb078e631b7f146e$export$aafa59e2e03f2942 = 'read';
var $cb078e631b7f146e$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $cb078e631b7f146e$export$c65e99957a05207c = 'beforeMain';
var $cb078e631b7f146e$export$f22da7240b7add18 = 'main';
var $cb078e631b7f146e$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $cb078e631b7f146e$export$8d4d2d70e7d46032 = 'beforeWrite';
var $cb078e631b7f146e$export$68d8715fc104d294 = 'write';
var $cb078e631b7f146e$export$70a6e5159acce2e6 = 'afterWrite';
var $cb078e631b7f146e$export$d087d3878fdf71d5 = [
    $cb078e631b7f146e$export$421679a7c3d56e,
    $cb078e631b7f146e$export$aafa59e2e03f2942,
    $cb078e631b7f146e$export$6964f6c886723980,
    $cb078e631b7f146e$export$c65e99957a05207c,
    $cb078e631b7f146e$export$f22da7240b7add18,
    $cb078e631b7f146e$export$bab79516f2d662fe,
    $cb078e631b7f146e$export$8d4d2d70e7d46032,
    $cb078e631b7f146e$export$68d8715fc104d294,
    $cb078e631b7f146e$export$70a6e5159acce2e6
];

});


parcelRegister("4Mmgf", function(module, exports) {
$parcel$export(module.exports, "default", () => $37ace9b0f98f69f8$export$2e2bcd8739ae039);
function $37ace9b0f98f69f8$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("1rggl", function(module, exports) {
$parcel$export(module.exports, "default", () => $10c4ed77ef29089f$export$2e2bcd8739ae039);
function $10c4ed77ef29089f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("10qfj", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bba266b727c0df0$export$2e2bcd8739ae039);

var $7lam2 = parcelRequire("7lam2");
var $0bba266b727c0df0$var$passive = {
    passive: true
};
function $0bba266b727c0df0$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $7lam2.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $0bba266b727c0df0$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $0bba266b727c0df0$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $0bba266b727c0df0$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $0bba266b727c0df0$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $0bba266b727c0df0$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $0bba266b727c0df0$var$effect,
    data: {}
};

});

parcelRegister("e44HK", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3d516a081fcaada$export$2e2bcd8739ae039);

var $iVu6U = parcelRequire("iVu6U");
function $a3d516a081fcaada$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $iVu6U.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a3d516a081fcaada$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $a3d516a081fcaada$var$popperOffsets,
    data: {}
};

});
parcelRegister("iVu6U", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc74e82911d20f47$export$2e2bcd8739ae039);

var $siyi0 = parcelRequire("siyi0");

var $zcKuU = parcelRequire("zcKuU");

var $lBxGR = parcelRequire("lBxGR");

var $hqIIS = parcelRequire("hqIIS");
function $dc74e82911d20f47$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $siyi0.default)(placement) : null;
    var variation = placement ? (0, $zcKuU.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $hqIIS.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $hqIIS.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $hqIIS.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $hqIIS.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lBxGR.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $hqIIS.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $hqIIS.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("siyi0", function(module, exports) {
$parcel$export(module.exports, "default", () => $055101b0e984bc16$export$2e2bcd8739ae039);

function $055101b0e984bc16$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("zcKuU", function(module, exports) {
$parcel$export(module.exports, "default", () => $069d28ad4300bf61$export$2e2bcd8739ae039);
function $069d28ad4300bf61$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lBxGR", function(module, exports) {
$parcel$export(module.exports, "default", () => $fba72fe0398d5a37$export$2e2bcd8739ae039);
function $fba72fe0398d5a37$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("8MF7o", function(module, exports) {
$parcel$export(module.exports, "default", () => $6652b3a13e891e71$export$2e2bcd8739ae039);

var $hqIIS = parcelRequire("hqIIS");

var $Np85X = parcelRequire("Np85X");

var $7lam2 = parcelRequire("7lam2");

var $fECmK = parcelRequire("fECmK");

var $cJX6r = parcelRequire("cJX6r");

var $siyi0 = parcelRequire("siyi0");

var $zcKuU = parcelRequire("zcKuU");

var $bJIYU = parcelRequire("bJIYU");
var $6652b3a13e891e71$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6652b3a13e891e71$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $bJIYU.round)(x * dpr) / dpr || 0,
        y: (0, $bJIYU.round)(y * dpr) / dpr || 0
    };
}
function $6652b3a13e891e71$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $hqIIS.left);
    var sideY = (0, $hqIIS.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $Np85X.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $7lam2.default)(popper)) {
            offsetParent = (0, $fECmK.default)(popper);
            if ((0, $cJX6r.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $hqIIS.top) || (placement === (0, $hqIIS.left) || placement === (0, $hqIIS.right)) && variation === (0, $hqIIS.end)) {
            sideY = (0, $hqIIS.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $hqIIS.left) || (placement === (0, $hqIIS.top) || placement === (0, $hqIIS.bottom)) && variation === (0, $hqIIS.end)) {
            sideX = (0, $hqIIS.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6652b3a13e891e71$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6652b3a13e891e71$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $7lam2.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6652b3a13e891e71$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $siyi0.default)(state.placement),
        variation: (0, $zcKuU.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6652b3a13e891e71$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6652b3a13e891e71$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6652b3a13e891e71$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6652b3a13e891e71$var$computeStyles,
    data: {}
};

});

parcelRegister("b3ruI", function(module, exports) {
$parcel$export(module.exports, "default", () => $80c54d5613234534$export$2e2bcd8739ae039);

var $5mD3D = parcelRequire("5mD3D");

var $idCAj = parcelRequire("idCAj");
// and applies them to the HTMLElements such as popper and arrow
function $80c54d5613234534$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $idCAj.isHTMLElement)(element) || !(0, $5mD3D.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $80c54d5613234534$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $idCAj.isHTMLElement)(element) || !(0, $5mD3D.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $80c54d5613234534$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $80c54d5613234534$var$applyStyles,
    effect: $80c54d5613234534$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("bpIHh", function(module, exports) {
$parcel$export(module.exports, "default", () => $84f4b36a2d2554a4$export$2e2bcd8739ae039);

var $siyi0 = parcelRequire("siyi0");

var $hqIIS = parcelRequire("hqIIS");
function $84f4b36a2d2554a4$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $siyi0.default)(placement);
    var invertDistance = [
        (0, $hqIIS.left),
        (0, $hqIIS.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $hqIIS.left),
        (0, $hqIIS.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $84f4b36a2d2554a4$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $hqIIS.placements).reduce(function(acc, placement) {
        acc[placement] = $84f4b36a2d2554a4$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $84f4b36a2d2554a4$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $84f4b36a2d2554a4$var$offset
};

});

parcelRegister("iZO9z", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd44d3ed3325fe7b$export$2e2bcd8739ae039);

var $iQLiU = parcelRequire("iQLiU");

var $siyi0 = parcelRequire("siyi0");

var $bxO3b = parcelRequire("bxO3b");

var $cQuWI = parcelRequire("cQuWI");

var $2FFSU = parcelRequire("2FFSU");

var $hqIIS = parcelRequire("hqIIS");

var $zcKuU = parcelRequire("zcKuU");
function $dd44d3ed3325fe7b$var$getExpandedFallbackPlacements(placement) {
    if ((0, $siyi0.default)(placement) === (0, $hqIIS.auto)) return [];
    var oppositePlacement = (0, $iQLiU.default)(placement);
    return [
        (0, $bxO3b.default)(placement),
        oppositePlacement,
        (0, $bxO3b.default)(oppositePlacement)
    ];
}
function $dd44d3ed3325fe7b$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $siyi0.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $iQLiU.default)(preferredPlacement)
    ] : $dd44d3ed3325fe7b$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $siyi0.default)(placement) === (0, $hqIIS.auto) ? (0, $2FFSU.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $siyi0.default)(placement);
        var isStartVariation = (0, $zcKuU.default)(placement) === (0, $hqIIS.start);
        var isVertical = [
            (0, $hqIIS.top),
            (0, $hqIIS.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $cQuWI.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $hqIIS.right) : (0, $hqIIS.left) : isStartVariation ? (0, $hqIIS.bottom) : (0, $hqIIS.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $iQLiU.default)(mainVariationSide);
        var altVariationSide = (0, $iQLiU.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dd44d3ed3325fe7b$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dd44d3ed3325fe7b$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("iQLiU", function(module, exports) {
$parcel$export(module.exports, "default", () => $db91c6eb1f3b50ab$export$2e2bcd8739ae039);
var $db91c6eb1f3b50ab$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $db91c6eb1f3b50ab$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $db91c6eb1f3b50ab$var$hash[matched];
    });
}

});

parcelRegister("bxO3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $867999b91abbcc07$export$2e2bcd8739ae039);
var $867999b91abbcc07$var$hash = {
    start: 'end',
    end: 'start'
};
function $867999b91abbcc07$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $867999b91abbcc07$var$hash[matched];
    });
}

});

parcelRegister("cQuWI", function(module, exports) {
$parcel$export(module.exports, "default", () => $95a258962a280c18$export$2e2bcd8739ae039);

var $1ah4h = parcelRequire("1ah4h");

var $fECmK = parcelRequire("fECmK");

var $8rh79 = parcelRequire("8rh79");

var $iVu6U = parcelRequire("iVu6U");

var $fXwpp = parcelRequire("fXwpp");

var $hqIIS = parcelRequire("hqIIS");

var $idCAj = parcelRequire("idCAj");

var $b0u56 = parcelRequire("b0u56");

var $hJMUM = parcelRequire("hJMUM");
function $95a258962a280c18$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $hqIIS.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $hqIIS.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $hqIIS.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $b0u56.default)(typeof padding !== 'number' ? padding : (0, $hJMUM.default)(padding, (0, $hqIIS.basePlacements)));
    var altContext = elementContext === (0, $hqIIS.popper) ? (0, $hqIIS.reference) : (0, $hqIIS.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $1ah4h.default)((0, $idCAj.isElement)(element) ? element : element.contextElement || (0, $fECmK.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $8rh79.default)(state.elements.reference);
    var popperOffsets = (0, $iVu6U.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $fXwpp.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $hqIIS.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $hqIIS.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $hqIIS.right),
                (0, $hqIIS.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $hqIIS.top),
                (0, $hqIIS.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("1ah4h", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d93f6fb0b18d077$export$2e2bcd8739ae039);

var $hqIIS = parcelRequire("hqIIS");

var $8yvBM = parcelRequire("8yvBM");

var $7755d = parcelRequire("7755d");

var $jQQNx = parcelRequire("jQQNx");

var $Np85X = parcelRequire("Np85X");

var $fECmK = parcelRequire("fECmK");

var $cJX6r = parcelRequire("cJX6r");

var $idCAj = parcelRequire("idCAj");

var $8rh79 = parcelRequire("8rh79");

var $bwhG0 = parcelRequire("bwhG0");

var $iFfDd = parcelRequire("iFfDd");

var $5mD3D = parcelRequire("5mD3D");

var $fXwpp = parcelRequire("fXwpp");

var $bJIYU = parcelRequire("bJIYU");
function $0d93f6fb0b18d077$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $8rh79.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $0d93f6fb0b18d077$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $hqIIS.viewport) ? (0, $fXwpp.default)((0, $8yvBM.default)(element, strategy)) : (0, $idCAj.isElement)(clippingParent) ? $0d93f6fb0b18d077$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $fXwpp.default)((0, $7755d.default)((0, $fECmK.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $0d93f6fb0b18d077$var$getClippingParents(element) {
    var clippingParents = (0, $jQQNx.default)((0, $bwhG0.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cJX6r.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $idCAj.isHTMLElement)(element) ? (0, $Np85X.default)(element) : element;
    if (!(0, $idCAj.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $idCAj.isElement)(clippingParent) && (0, $iFfDd.default)(clippingParent, clipperElement) && (0, $5mD3D.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $0d93f6fb0b18d077$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $0d93f6fb0b18d077$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $0d93f6fb0b18d077$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $bJIYU.max)(rect.top, accRect.top);
        accRect.right = (0, $bJIYU.min)(rect.right, accRect.right);
        accRect.bottom = (0, $bJIYU.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $bJIYU.max)(rect.left, accRect.left);
        return accRect;
    }, $0d93f6fb0b18d077$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("8yvBM", function(module, exports) {
$parcel$export(module.exports, "default", () => $63aa047b51ee97b2$export$2e2bcd8739ae039);

var $7lam2 = parcelRequire("7lam2");

var $fECmK = parcelRequire("fECmK");

var $hTkTh = parcelRequire("hTkTh");

var $bX0d4 = parcelRequire("bX0d4");
function $63aa047b51ee97b2$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $7lam2.default)(element);
    var html = (0, $fECmK.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bX0d4.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $hTkTh.default)(element),
        y: y
    };
}

});

parcelRegister("7755d", function(module, exports) {
$parcel$export(module.exports, "default", () => $52dd213d70c283a0$export$2e2bcd8739ae039);

var $fECmK = parcelRequire("fECmK");

var $cJX6r = parcelRequire("cJX6r");

var $hTkTh = parcelRequire("hTkTh");

var $cJ4aX = parcelRequire("cJ4aX");

var $bJIYU = parcelRequire("bJIYU");
function $52dd213d70c283a0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $fECmK.default)(element);
    var winScroll = (0, $cJ4aX.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $bJIYU.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $bJIYU.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $hTkTh.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cJX6r.default)(body || html).direction === 'rtl') x += (0, $bJIYU.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("iFfDd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9682e709b357c14$export$2e2bcd8739ae039);

var $idCAj = parcelRequire("idCAj");
function $d9682e709b357c14$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $idCAj.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("fXwpp", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9e58168f0e942e0$export$2e2bcd8739ae039);
function $b9e58168f0e942e0$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("b0u56", function(module, exports) {
$parcel$export(module.exports, "default", () => $803707563f9a2bc5$export$2e2bcd8739ae039);

var $fkxUI = parcelRequire("fkxUI");
function $803707563f9a2bc5$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $fkxUI.default)(), paddingObject);
}

});
parcelRegister("fkxUI", function(module, exports) {
$parcel$export(module.exports, "default", () => $b29307d6e06bd52e$export$2e2bcd8739ae039);
function $b29307d6e06bd52e$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hJMUM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce9c9513f22e0e6d$export$2e2bcd8739ae039);
function $ce9c9513f22e0e6d$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("2FFSU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f1fe68822e70707$export$2e2bcd8739ae039);

var $zcKuU = parcelRequire("zcKuU");

var $hqIIS = parcelRequire("hqIIS");

var $cQuWI = parcelRequire("cQuWI");

var $siyi0 = parcelRequire("siyi0");
function $1f1fe68822e70707$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $hqIIS.placements) : _options$allowedAutoP;
    var variation = (0, $zcKuU.default)(placement);
    var placements = variation ? flipVariations ? (0, $hqIIS.variationPlacements) : (0, $hqIIS.variationPlacements).filter(function(placement) {
        return (0, $zcKuU.default)(placement) === variation;
    }) : (0, $hqIIS.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $cQuWI.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $siyi0.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("3HxTq", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b1fadb5a71dca55$export$2e2bcd8739ae039);

var $hqIIS = parcelRequire("hqIIS");

var $siyi0 = parcelRequire("siyi0");

var $lBxGR = parcelRequire("lBxGR");

var $dV1Jx = parcelRequire("dV1Jx");

var $jEol8 = parcelRequire("jEol8");

var $1AIhw = parcelRequire("1AIhw");

var $Np85X = parcelRequire("Np85X");

var $cQuWI = parcelRequire("cQuWI");

var $zcKuU = parcelRequire("zcKuU");

var $fkxUI = parcelRequire("fkxUI");

var $bJIYU = parcelRequire("bJIYU");
function $2b1fadb5a71dca55$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $cQuWI.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $siyi0.default)(state.placement);
    var variation = (0, $zcKuU.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lBxGR.default)(basePlacement);
    var altAxis = (0, $dV1Jx.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $hqIIS.top) : (0, $hqIIS.left);
        var altSide = mainAxis === 'y' ? (0, $hqIIS.bottom) : (0, $hqIIS.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $hqIIS.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $hqIIS.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $1AIhw.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $fkxUI.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $jEol8.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $Np85X.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $jEol8.within)(tether ? (0, $bJIYU.min)(min, tetherMin) : min, offset, tether ? (0, $bJIYU.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $hqIIS.top) : (0, $hqIIS.left);
        var _altSide = mainAxis === 'x' ? (0, $hqIIS.bottom) : (0, $hqIIS.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $hqIIS.top),
            (0, $hqIIS.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $jEol8.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $jEol8.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $2b1fadb5a71dca55$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $2b1fadb5a71dca55$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("dV1Jx", function(module, exports) {
$parcel$export(module.exports, "default", () => $a221f1768810b794$export$2e2bcd8739ae039);
function $a221f1768810b794$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("jEol8", function(module, exports) {
$parcel$export(module.exports, "within", () => $e4e4a21f6b745f5d$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $e4e4a21f6b745f5d$export$86c8af6d3ef0b4a);

var $bJIYU = parcelRequire("bJIYU");
function $e4e4a21f6b745f5d$export$f28d906d67a997f3(min, value, max) {
    return (0, $bJIYU.max)(min, (0, $bJIYU.min)(value, max));
}
function $e4e4a21f6b745f5d$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $e4e4a21f6b745f5d$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("jYFiS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8b3a8f2724cef6f$export$2e2bcd8739ae039);

var $siyi0 = parcelRequire("siyi0");

var $1AIhw = parcelRequire("1AIhw");

var $iFfDd = parcelRequire("iFfDd");

var $Np85X = parcelRequire("Np85X");

var $lBxGR = parcelRequire("lBxGR");

var $jEol8 = parcelRequire("jEol8");

var $b0u56 = parcelRequire("b0u56");

var $hJMUM = parcelRequire("hJMUM");

var $hqIIS = parcelRequire("hqIIS");
var $e8b3a8f2724cef6f$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $b0u56.default)(typeof padding !== 'number' ? padding : (0, $hJMUM.default)(padding, (0, $hqIIS.basePlacements)));
};
function $e8b3a8f2724cef6f$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $siyi0.default)(state.placement);
    var axis = (0, $lBxGR.default)(basePlacement);
    var isVertical = [
        (0, $hqIIS.left),
        (0, $hqIIS.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e8b3a8f2724cef6f$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $1AIhw.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $hqIIS.top) : (0, $hqIIS.left);
    var maxProp = axis === 'y' ? (0, $hqIIS.bottom) : (0, $hqIIS.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $Np85X.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $jEol8.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e8b3a8f2724cef6f$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $iFfDd.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e8b3a8f2724cef6f$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $e8b3a8f2724cef6f$var$arrow,
    effect: $e8b3a8f2724cef6f$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("kdhdO", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb726173cdc3dead$export$2e2bcd8739ae039);

var $hqIIS = parcelRequire("hqIIS");

var $cQuWI = parcelRequire("cQuWI");
function $eb726173cdc3dead$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $eb726173cdc3dead$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $hqIIS.top),
        (0, $hqIIS.right),
        (0, $hqIIS.bottom),
        (0, $hqIIS.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $eb726173cdc3dead$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $cQuWI.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $cQuWI.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $eb726173cdc3dead$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $eb726173cdc3dead$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $eb726173cdc3dead$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $eb726173cdc3dead$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $eb726173cdc3dead$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $eb726173cdc3dead$var$hide
};

});


parcelRegister("glWoR", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $be7be88bda9cba38$var$hasElementType = typeof Element !== 'undefined';
var $be7be88bda9cba38$var$hasMap = typeof Map === 'function';
var $be7be88bda9cba38$var$hasSet = typeof Set === 'function';
var $be7be88bda9cba38$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $be7be88bda9cba38$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$be7be88bda9cba38$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($be7be88bda9cba38$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$be7be88bda9cba38$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($be7be88bda9cba38$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($be7be88bda9cba38$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($be7be88bda9cba38$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$be7be88bda9cba38$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $be7be88bda9cba38$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("1SubA", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $fd7996a15d5b5d5d$export$6d8c2b45c99d6e3f);
function $fd7996a15d5b5d5d$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});

parcelRegister("hTIUJ", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", () => $c1bb08278b79ac78$export$9802f50720ab826e);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $6esjp = parcelRequire("6esjp");

var $3xsJK = parcelRequire("3xsJK");

var $h1jDZ = parcelRequire("h1jDZ");

var $9AktP = parcelRequire("9AktP");

var $5oW0N = parcelRequire("5oW0N");

var $hS8z7 = parcelRequire("hS8z7");

var $lI0ME = parcelRequire("lI0ME");

var $bFK5x = parcelRequire("bFK5x");

var $8bZOf = parcelRequire("8bZOf");

var $fHuXz = parcelRequire("fHuXz");

var $1pden = parcelRequire("1pden");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ const $c1bb08278b79ac78$var$noopStyle = {};
const $c1bb08278b79ac78$var$noopSetRef = (0, $6esjp.default);
const $c1bb08278b79ac78$var$noopUpdate = ()=>Promise.resolve(null);
const $c1bb08278b79ac78$var$noopForceUpdate = ()=>({});
const $c1bb08278b79ac78$var$noopArrowProps = {
    ref: $c1bb08278b79ac78$var$noopSetRef,
    style: $c1bb08278b79ac78$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $c1bb08278b79ac78$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    const [along, away] = offset;
    if (along == null && away == null) return undefined;
    return [
        along ?? 0,
        away ?? 0
    ];
}
/**
 * SSR-safe `instanceof HTMLElement`. This runs during render, and the server
 * has no `HTMLElement` global. No hydration mismatch: refs are unset on the
 * server and on the first client render, so both sides get the same result.
 */ function $c1bb08278b79ac78$var$isHTMLElement(value) {
    return typeof HTMLElement !== 'undefined' && value instanceof HTMLElement;
}
function $c1bb08278b79ac78$export$9802f50720ab826e({ children: children, offset: offset, placement: placement = 'bottom-start', referenceElement: referenceElement, shouldFitViewport: shouldFitViewport = false }) {
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    const managerAnchor = (0, $fHuXz.useManagerAnchor)();
    const effectiveReference = referenceElement ?? managerAnchor ?? undefined;
    // Real DOM nodes are anchored by `useAnchoredPopover`; popper
    // `VirtualElement`s go to `useAnchoredPopoverAtPoint`, which owns a synthetic
    // anchor element in `document.body`.
    const htmlAnchor = $c1bb08278b79ac78$var$isHTMLElement(effectiveReference) ? effectiveReference : null;
    const virtualReference = effectiveReference != null && !$c1bb08278b79ac78$var$isHTMLElement(effectiveReference) ? effectiveReference : null;
    const htmlAnchorRef = (0, $lE8gv.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    const popoverRef = (0, $lE8gv.useRef)(null);
    const popoverId = (0, $hS8z7.usePopoverId)();
    // Track the resolved DOM anchor in state so the visibility hook re-runs when
    // its identity changes. Virtual anchors do not feed that hook, because their
    // probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    const [resolvedAnchor, setResolvedAnchor] = (0, $lE8gv.useState)(htmlAnchor);
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    const topLayerPlacement = (0, $lE8gv.useMemo)(()=>{
        return (0, $3xsJK.fromLegacyPlacement)({
            legacy: (0, $8bZOf.toLegacyPlacement)(placement),
            offset: $c1bb08278b79ac78$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    const isOpen = effectiveReference != null;
    // Refs, because `getPoint` is LATCHED: called once per activation, so a
    // closed-over value would go stale if either prop changed while it stayed open.
    const virtualReferenceRef = (0, $lE8gv.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    const topLayerPlacementRef = (0, $lE8gv.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    // Two positioning hooks, at most one enabled: `htmlAnchor` and
    // `virtualReference` both derive from `effectiveReference`, so they are never
    // both set, and when neither is the popover is closed.
    const isElementAnchored = htmlAnchor !== null;
    const isPointAnchored = virtualReference !== null;
    // Passed as one object so the element and point calls cannot drift.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        inlineSize: shouldFitViewport ? 'max-available' : 'content',
        blockSize: shouldFitViewport ? 'max-available' : 'content'
    };
    (0, $9AktP.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: htmlAnchorRef,
        isEnabled: isElementAnchored
    });
    (0, $5oW0N.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isPointAnchored,
        getPoint: ()=>{
            const current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $bFK5x.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $lI0ME.isPageRtl)()
            });
        }
    });
    const { isReferenceHidden: isReferenceHidden, hasPopperEscaped: hasPopperEscaped } = (0, $1pden.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    });
    const renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    const renderPropArg = {
        ref: $c1bb08278b79ac78$var$noopSetRef,
        style: $c1bb08278b79ac78$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $c1bb08278b79ac78$var$noopUpdate,
        forceUpdate: $c1bb08278b79ac78$var$noopForceUpdate,
        arrowProps: $c1bb08278b79ac78$var$noopArrowProps
    };
    const content = renderChildren(renderPropArg);
    // Rendered directly into the `<Popover>` host, which supplies the flex
    // formatting context the size caps need — so the render prop must return ONE
    // element. See `children` in `@atlaskit/top-layer`'s `popover/types.tsx`.
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $h1jDZ.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false,
        children: content
    });
}

});
parcelRegister("3xsJK", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $ca194a2d2e0e4393$export$69e99ed50b2534c9);

var $8VMjr = parcelRequire("8VMjr");
function $ca194a2d2e0e4393$export$69e99ed50b2534c9({ legacy: legacy, offset: offset }) {
    const basePlacement = (0, $8VMjr.placementMapping)[legacy];
    if (!offset) return basePlacement;
    const [along, away] = offset;
    return {
        ...basePlacement,
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    };
}

});
parcelRegister("8VMjr", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $6fcb75cfacd6e6f4$export$27df359c528b7120);
const $6fcb75cfacd6e6f4$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("h1jDZ", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $b9401eab31324a17$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ /* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");

var $lE8gv = parcelRequire("lE8gv");

var $adpJV = parcelRequire("adpJV");

var $5Ifxs = parcelRequire("5Ifxs");

var $3ipAE = parcelRequire("3ipAE");

var $fx8aD = parcelRequire("fx8aD");

var $l0Txf = parcelRequire("l0Txf");

var $bEF5j = parcelRequire("bEF5j");

var $9NqPa = parcelRequire("9NqPa");

var $f95e7 = parcelRequire("f95e7");

var $eZdFC = parcelRequire("eZdFC");

var $6wcCx = parcelRequire("6wcCx");

var $82rCk = parcelRequire("82rCk");
/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */ function $b9401eab31324a17$var$restoreFocus({ popover: popover, focusRestorationTarget: focusRestorationTarget }) {
    if (!focusRestorationTarget) return;
    const { ownerDocument: ownerDocument } = popover;
    // Native restoration has finished. Preserve focus moved outside the popover.
    const activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ const $b9401eab31324a17$var$supportsPopoverHint = (0, $fx8aD.default)(()=>{
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    const element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
/**
 * **Surface reset**
 *
 * The host is still a DOM child of its trigger for inheritance, so it inherits
 * values like `pointer-events: none` or `white-space: nowrap`. Resets them to
 * what `<body>` gave the portal path. `font` and direction still inherit.
 * Not `all: initial`: that would also override the UA `[popover]` rules.
 *
 * `color` is a reset too: the UA `[popover]` rule sets `color: CanvasText`, so
 * the host never inherits a colour. `color.text` is what `<body>` gave the portal
 * path. Not `inherit`, which would take the trigger's colour (for example a link).
 * See `notes/decisions/surface-reset-color.md`.
 *
 * KEEP IN SYNC with `dialog/dialog-content.tsx` (ADS forbids shared styles).
 * The `satisfies` check below catches drift.
 */ const $b9401eab31324a17$var$surfaceResetStyles = {
    root: "_goh41wug _ux9u4jg8 _19w84jg8 _1f6b4jg8 _tcxkv2br _m466idpf _1b80glyw _9kefi7uo"
};
const $b9401eab31324a17$var$styles = {
    root: "_lzhqglyw _az2pidpf _13shidpf _1mjeidpf _byz4idpf _b2a9idpf _z3e7idpf _1aqridpf _1ap0idpf _1vdi1wug _wmifewfl _1blzewfl _1rec1j28 _kqwmvrvc _1maw1q9c _17ke4jg8 _1ogd4jg8 _1dqv1n9t _qctn1ns9 _1rmr1wug _1yd01wug _li0iglyw _1gd81wug _ao8dglyw _1ljj4jg8 _jg1o4jg8 _1f2zglyw _x2wjglyw _tdqwglyw _1s8uglyw _1715kb7n _1p7w1txw _51hckb7n _1yp3idpf _f5r5idpf",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
const $b9401eab31324a17$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
const $b9401eab31324a17$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $lE8gv.forwardRef)(function Popover({ children: children, mode: modeProp = 'auto', onClose: onClose, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, placement: placement, testId: testId, isOpen: isOpen, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, initialFocusRef: initialFocusRef, role: // ARIA
role, label: label, labelledBy: labelledBy, id: idProp }, ref) {
    const autoId = (0, $lE8gv.useId)();
    const ownRef = (0, $lE8gv.useRef)(null);
    const combinedRef = (0, $3ipAE.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    const popoverId = idProp ?? `popover-${autoId.replace(/:/g, '')}`;
    // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    const onCloseRef = (0, $lE8gv.useRef)(onClose);
    (0, $l0Txf.useLayoutEffect)(()=>{
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    // A popover with `onClose` is closable (see `closable-popover-contract`).
    // `requestClosePopovers()` asks it to close; the consumer decides.
    const isClosable = Boolean(onClose);
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    const mode = modeProp === 'hint' && !$b9401eab31324a17$var$supportsPopoverHint() ? 'auto' : modeProp;
    const popupMotionStyle = (0, $lE8gv.useMemo)(()=>{
        if (!placement || !shouldAnimate) return undefined;
        const { axis: axis, edge: edge } = (0, $f95e7.resolvePlacement)({
            placement: placement
        });
        return $b9401eab31324a17$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Tracks the close reason, including our own hidePopover() calls.
    const closeReasonRef = (0, $lE8gv.useRef)('light-dismiss');
    // Pre-open focus target, cleared before close when restoration is not eligible.
    const focusRestorationTargetRef = (0, $lE8gv.useRef)(null);
    const handleBeforeToggle = (0, $lE8gv.useCallback)((event)=>{
        const popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        const { ownerDocument: ownerDocument } = popover;
        const { activeElement: activeElement } = ownerDocument;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        }
        /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */ if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    const handleToggleClosed = (0, $lE8gv.useCallback)((event)=>{
        const popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        const focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        const reason = closeReasonRef.current;
        // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss';
        // Run after native restoration, before notifying the consumer, which may move focus itself.
        $b9401eab31324a17$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        });
        // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') onCloseRef.current?.({
            reason: reason
        });
    }, []);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $eZdFC.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // Focus management: Tab cycling for dialog roles. Initial focus is below
    // the show/hide layout effect. Restoration is native for outermost
    // popovers; nested popovers are handled above via the `beforetoggle`
    // snapshot. Passing `phase` keeps `useFocusWrap` attached through the
    // animated-exit window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $6wcCx.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $l0Txf.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        const unbindEscape = (0, $5Ifxs.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $9NqPa.isNativeElementOpen)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        const unbindToggle = (0, $5Ifxs.bind)(element, {
            type: 'toggle',
            listener: (event)=>{
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        });
        // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        const unbindBeforeToggle = (0, $5Ifxs.bind)(element, {
            type: 'beforetoggle',
            listener: (event)=>{
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        });
        // `requestClosePopovers()` asks the consumer to close. Nothing is
        // hidden here, so a consumer that keeps `isOpen` stays in sync.
        const unbindRequestClose = (0, $5Ifxs.bind)(element, {
            type: (0, $bEF5j.requestCloseEventName),
            listener: ()=>{
                onCloseRef.current?.({
                    reason: 'programmatic'
                });
            }
        });
        return ()=>{
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
            unbindRequestClose();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $l0Txf.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch  {}
            return ()=>{
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch  {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch  {}
    }, [
        isOpen
    ]);
    // Initial focus (role-dependent) is a layout effect, so it must come AFTER
    // the show/hide layout effect above: React runs layout effects in source
    // order, and focus only works once `showPopover()` has run. Focus then
    // lands in the same task as the open, before the browser paints.
    (0, $82rCk.useInitialFocus)({
        elementRef: ownRef,
        initialFocusRef: initialFocusRef,
        phase: phase,
        role: role
    });
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        ref: combinedRef,
        id: popoverId,
        // @ts-expect-error -- popover attribute not yet in React types
        // eslint-disable-next-line react/no-unknown-property -- popover attribute not yet in React types
        popover: mode,
        role: role,
        // Keep in sync with `closablePopoverAttribute` (internal/closable-popover-contract).
        "data-top-layer-closable": isClosable ? '' : undefined,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Motion styles are selected at runtime from the placement.
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $l2NkF.default)([
            $b9401eab31324a17$var$styles.root,
            $b9401eab31324a17$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $b9401eab31324a17$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $b9401eab31324a17$var$styles.exit,
            shouldAnimate && $b9401eab31324a17$var$styles.motion,
            (0, $adpJV.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("adpJV", function(module, exports) {
$parcel$export(module.exports, "cx", () => $76ff15a333f40722$export$a274e22fb40f762e);

var $l2NkF = parcelRequire("l2NkF");
const $76ff15a333f40722$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $l2NkF.default)(actualStyles);
}; //# sourceMappingURL=index.js.map

});

parcelRegister("fx8aD", function(module, exports) {
$parcel$export(module.exports, "default", () => $c15cceab85b2c8ef$export$2e2bcd8739ae039);
function $c15cceab85b2c8ef$export$2e2bcd8739ae039(fn) {
    let cache = null;
    return function result(...args) {
        if (!cache) cache = {
            value: fn.call(this, ...args)
        };
        /**
		 * Intentionally not adding `.clear()` function property
		 *
		 * - We currently have no need for it
		 * - We don't want to add a `.clear()` to functions that should never be called twice,
		 *   for example: `cleanup` functions.
		 * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
		 *   need arises 🧘
		 */ return cache.value;
    };
}

});

parcelRegister("l0Txf", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $55b112db8f42041f$export$e5c5a5f917a5871c);

var $lE8gv = parcelRequire("lE8gv");
const $55b112db8f42041f$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $lE8gv.useEffect) : (0, $lE8gv.useLayoutEffect);

});

parcelRegister("bEF5j", function(module, exports) {
$parcel$export(module.exports, "closablePopoverAttribute", () => $d67b9b4f47d73712$export$c6890d80f1a52941);
$parcel$export(module.exports, "requestCloseEventName", () => $d67b9b4f47d73712$export$17ed9502ee8e92da);
/**
 * Set by `Popover` on its host element when it has an `onClose`. Only those
 * popovers can be asked to close, so only those are counted by
 * `hasOpenDialogOrPopover` and asked to close by `requestClosePopovers`.
 * Popovers without `onClose` (for example the flag group or a spotlight) are
 * not dismissible by outside code and are skipped.
 */ const $d67b9b4f47d73712$export$c6890d80f1a52941 = 'data-top-layer-closable';
const $d67b9b4f47d73712$export$17ed9502ee8e92da = 'top-layer-request-close';

});

parcelRegister("9NqPa", function(module, exports) {
$parcel$export(module.exports, "isNativeElementOpen", () => $5d58d49c1784e151$export$89b923e18c14644d);
function $5d58d49c1784e151$export$89b923e18c14644d({ element: element }) {
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw for unsupported pseudo-classes.
    try {
        return element.matches(':popover-open');
    } catch  {
        return false;
    }
}

});

parcelRegister("f95e7", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $dbf9077e7e9ccefc$export$63044d21bc3d3fa2);

var $5Cipp = parcelRequire("5Cipp");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ const $dbf9077e7e9ccefc$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $dbf9077e7e9ccefc$export$63044d21bc3d3fa2({ placement: placement }) {
    return {
        axis: placement.axis ?? 'block',
        edge: placement.edge ?? 'end',
        align: placement.align ?? 'center',
        // Not `??`: `undefined` must survive, so "not specified" stays
        // distinguishable from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $5Cipp.toCssLengthString)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $5Cipp.toCssLengthString)({
                value: placement.offset?.gap ?? $dbf9077e7e9ccefc$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $5Cipp.toCssLengthString)({
                    value: placement.offset?.crossAxisShift?.value ?? 0
                }),
                direction: placement.offset?.crossAxisShift?.direction ?? 'forwards'
            }
        }
    };
}

});
parcelRegister("5Cipp", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $93d8efb49c125bc8$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $93d8efb49c125bc8$export$63b6b0ff65d84d47({ value: value }) {
    if (typeof value === 'number') return `${value}px`;
    return value;
}

});


parcelRegister("eZdFC", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $b368d209f1d4028b$export$1bccb45daf07907f);

var $lE8gv = parcelRequire("lE8gv");

var $l0Txf = parcelRequire("l0Txf");

var $9NqPa = parcelRequire("9NqPa");

var $6lq2D = parcelRequire("6lq2D");
function $b368d209f1d4028b$var$runCancellableSettlement({ schedule: schedule, onSettled: onSettled }) {
    let isCancelled = false;
    schedule(()=>{
        if (isCancelled) return;
        onSettled();
    });
    return ()=>{
        // Prevent an interrupted or unmounted lifecycle from firing a stale callback.
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $b368d209f1d4028b$var$runOnAnimationsSettled({ element: element, onSettled: onSettled }) {
    return $b368d209f1d4028b$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: (settle)=>{
            const animations = element.getAnimations?.() ?? [];
            Promise.allSettled(animations.map((animation)=>animation.finished)).then(settle);
        }
    });
}
function $b368d209f1d4028b$var$getInitialVisibilityState({ isOpen: isOpen, willAnimate: willAnimate }) {
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility phase.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $b368d209f1d4028b$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        const shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return {
            ...state,
            controlledIntent: 'open'
        };
    }
    if (action.type === 'close-requested') return {
        ...state,
        controlledIntent: 'closed'
    };
    if (action.type === 'exit-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return {
            ...state,
            phase: 'exiting'
        };
    }
    // A browser dismiss started the exit, and something showed the element
    // again before the exit settled, while controlled intent stayed open. For
    // example, `@atlaskit/tooltip` re-shows after a light dismiss in the same
    // task. The element never painted closed, so go back to `open`.
    if (action.type === 'native-open-started') {
        if (state.phase !== 'exiting' || state.controlledIntent !== 'open') return state;
        return {
            ...state,
            phase: 'open'
        };
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return {
            ...state,
            phase: 'open'
        };
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return {
            ...state,
            phase: 'closed'
        };
    }
    return state;
}
function $b368d209f1d4028b$export$1bccb45daf07907f({ isOpen: isOpen, shouldAnimate: shouldAnimate, elementRef: elementRef, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish }) {
    const willAnimate = shouldAnimate && !(0, $6lq2D.prefersReducedMotion)();
    const [visibilityState, dispatch] = (0, $lE8gv.useReducer)($b368d209f1d4028b$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $b368d209f1d4028b$var$getInitialVisibilityState);
    const { phase: phase, controlledIntent: controlledIntent } = visibilityState;
    // Keep stable refs to the latest callbacks so effects and animation settlement closures
    // always call the current callback without needing them in dependency arrays.
    const onEnterFinishRef = (0, $lE8gv.useRef)(onEnterFinish);
    const onExitFinishRef = (0, $lE8gv.useRef)(onExitFinish);
    const willAnimateRef = (0, $lE8gv.useRef)(willAnimate);
    (0, $l0Txf.useLayoutEffect)(()=>{
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Entry can commit `open` before its callback because the host stays mounted.
    // This ensures consumers observe the settled DOM rather than entering styles.
    // Treat the phase before the initial commit as closed so an initially open host
    // notifies consumers.
    const prevPhaseRef = (0, $lE8gv.useRef)('closed');
    (0, $lE8gv.useEffect)(()=>{
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (prevPhase === phase) return;
        if (phase === 'open') onEnterFinishRef.current?.();
    }, [
        phase
    ]);
    const isMounted = phase !== 'closed';
    const cancelExitSettlementRef = (0, $lE8gv.useRef)(()=>{});
    // Exit must notify consumers before `closed` unmounts the host.
    const settleExit = (0, $lE8gv.useCallback)(()=>{
        onExitFinishRef.current?.();
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    // Primitives bind these stable callbacks to their native lifecycle events.
    // This keeps event ownership at the primitive while the hook owns state transitions.
    const onBeforeToggle = (0, $lE8gv.useCallback)((event)=>{
        // Any native transition supersedes a previous exit snapshot. This prevents
        // a stale settlement from closing a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot currentTarget because the DOM clears it after event dispatch.
        const element = event.currentTarget;
        if (event.newState === 'open') {
            if (element instanceof HTMLElement) {
                element.removeAttribute('inert');
                element.removeAttribute('aria-hidden');
            }
            // Dispatched on every native open. The reducer only acts when a browser
            // dismiss left the host `exiting` while `isOpen` stayed `true`.
            dispatch({
                type: 'native-open-started'
            });
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // We use a microtask to let native focus restoration happen before making the element inert.
            // The browser restores focus after beforetoggle returns, during its close steps.
            queueMicrotask(()=>{
                // A controlled close can be interrupted by isOpen changing back to true,
                // which reopens the element before this microtask runs.
                if ((0, $9NqPa.isNativeElementOpen)({
                    element: element
                })) return;
                // Exit animations keep closed content rendered, so make it non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'exit-started'
            });
        }
    }, []);
    const onToggle = (0, $lE8gv.useCallback)((event)=>{
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $b368d209f1d4028b$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        const element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after synchronous `beforetoggle`.
        // Snapshot here so the exiting phase styles have committed and the list
        // represents the animations that actually govern exit settlement.
        cancelExitSettlementRef.current = $b368d209f1d4028b$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $l0Txf.useLayoutEffect)(()=>()=>{
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        }, []);
    // Entry settlement only removes entering styles. Its callback runs after the
    // resulting `open` commit in the effect above.
    (0, $lE8gv.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        const element = elementRef.current;
        if (!element) return;
        return $b368d209f1d4028b$var$runOnAnimationsSettled({
            element: element,
            onSettled () {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}

});
parcelRegister("6lq2D", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $d4b127668b86691e$export$ff7706047246b98b);

var $fx8aD = parcelRequire("fx8aD");
const $d4b127668b86691e$export$ff7706047246b98b = (0, $fx8aD.default)(()=>{
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("6wcCx", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $b1cd8d3461d75d2d$export$4f6462e86a70abe5);

var $lE8gv = parcelRequire("lE8gv");

var $5Ifxs = parcelRequire("5Ifxs");

var $lE1mX = parcelRequire("lE1mX");

var $jy45l = parcelRequire("jy45l");

var $jme2w = parcelRequire("jme2w");

var $2u12y = parcelRequire("2u12y");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/decisions/menu-keyboard.md
 */ function $b1cd8d3461d75d2d$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $b1cd8d3461d75d2d$export$4f6462e86a70abe5({ elementRef: elementRef, role: role, phase: phase }) {
    const isVisible = phase !== 'closed';
    (0, $lE8gv.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !$b1cd8d3461d75d2d$var$roleRequiresFocusWrap(role) || !isVisible) return;
        const unbind = (0, $5Ifxs.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $2u12y.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                const direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                const next = (0, $jme2w.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                const fallback = direction === 'forwards' ? (0, $lE1mX.getFirstFocusable)({
                    container: element
                }) : (0, $jy45l.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("lE1mX", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $f9f624edd04024c1$export$748138f04a69bf21);

var $fL9DY = parcelRequire("fL9DY");
function $f9f624edd04024c1$export$748138f04a69bf21({ container: container, filter: filter }) {
    const items = (0, $fL9DY.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("fL9DY", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $5cc4ba6eda7f7b2b$export$f6768025e418420e);

var $gtfUI = parcelRequire("gtfUI");
const $5cc4ba6eda7f7b2b$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
const $5cc4ba6eda7f7b2b$var$exclusionSelector = $5cc4ba6eda7f7b2b$var$focusableExclusions.map((selector)=>`:not(${selector})`).join('');
const $5cc4ba6eda7f7b2b$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map((selector)=>`${selector}${$5cc4ba6eda7f7b2b$var$exclusionSelector}`).join(',');
function $5cc4ba6eda7f7b2b$var$isVisible(element) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch  {
        return true;
    }
}
function $5cc4ba6eda7f7b2b$export$f6768025e418420e({ container: container, filter: filter }) {
    const containerLayer = (0, $gtfUI.getClosestLayer)({
        element: container
    });
    return Array.from(container.querySelectorAll($5cc4ba6eda7f7b2b$var$focusableSelector)).filter((element)=>{
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $gtfUI.getClosestLayer)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$5cc4ba6eda7f7b2b$var$isVisible(element)) return false;
        return !filter || filter(element, container);
    });
}

});
parcelRegister("gtfUI", function(module, exports) {
$parcel$export(module.exports, "getClosestLayer", () => $670812335545e1b5$export$3c9385904be131db);
function $670812335545e1b5$export$3c9385904be131db({ element: element }) {
    return element.closest('[popover], dialog');
}

});



parcelRegister("jy45l", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $b721d9f1c80061f6$export$73e81fa65335a75b);

var $fL9DY = parcelRequire("fL9DY");
function $b721d9f1c80061f6$export$73e81fa65335a75b({ container: container, filter: filter }) {
    const items = (0, $fL9DY.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("jme2w", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $fb8c3626173ff585$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * The currently focused element does not need to be tabbable. This prevents
 * navigation from getting stuck on an element that was programmatically or
 * pointer focused with `tabindex="-1"`. Negative-tab-index elements remain
 * excluded as destinations.
 *
 * Returns `null` if there is no focused element within the container.
 */ 
var $fL9DY = parcelRequire("fL9DY");
function $fb8c3626173ff585$export$a7db88e6d491b450({ container: container, direction: direction, filter: filter }) {
    const all = (0, $fL9DY.getFocusables)({
        container: container,
        filter: filter
    });
    const first = all[0];
    const last = all[all.length - 1];
    // Checking the elements directly narrows types from `HTMLElement | undefined`.
    if (!first || !last) return null;
    const current = container.ownerDocument.activeElement;
    if (!(current instanceof HTMLElement) || !container.contains(current)) return null;
    const index = all.indexOf(current);
    // The focused element can be absent from `all` when it is non-tabbable or
    // excluded by the filter. Find the first focusable element that follows it in
    // the DOM, which identifies the nearest focusable destination in either direction.
    if (index === -1) {
        const followingIndex = all.findIndex((element)=>Boolean(current.compareDocumentPosition(element) & current.DOCUMENT_POSITION_FOLLOWING));
        if (direction === 'forwards') // If nothing follows the current element, then wrap to the start.
        return all[followingIndex] ?? first;
        // The closest preceding element is immediately before the first following one.
        // A missing adjacent entry means the backward sequence wraps to the end.
        return all[followingIndex - 1] ?? last;
    }
    // The current element is tabbable, so use its adjacent list entry and wrap
    // when it is already at the boundary.
    if (direction === 'forwards') return all[index + 1] ?? first;
    return all[index - 1] ?? last;
}

});

parcelRegister("2u12y", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $c9e495d82ff6ffed$export$b9590fdfeb5f722f);

var $gtfUI = parcelRequire("gtfUI");
function $c9e495d82ff6ffed$export$b9590fdfeb5f722f({ container: container }) {
    const focused = container.ownerDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $gtfUI.getClosestLayer)({
        element: focused
    }) !== (0, $gtfUI.getClosestLayer)({
        element: container
    });
}

});


parcelRegister("82rCk", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $deb81d2009ddfcb0$export$e992c40175757a22);

var $lE8gv = parcelRequire("lE8gv");

var $l0Txf = parcelRequire("l0Txf");

var $lE1mX = parcelRequire("lE1mX");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox. This applies to `menu`, `listbox`, and to
 * `dialog` / `alertdialog` when the combobox is outside the dialog. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, menu, or dialog), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
const $deb81d2009ddfcb0$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $deb81d2009ddfcb0$var$isTextboxLikeElement(element) {
    const role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    const tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        const type = (element.getAttribute('type') ?? 'text').toLowerCase();
        return $deb81d2009ddfcb0$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $deb81d2009ddfcb0$var$isComboboxControllingPopup({ container: container }) {
    const ownerDocument = container.ownerDocument;
    const active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$deb81d2009ddfcb0$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    const idRefs = active.getAttribute('aria-controls') ?? active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    const referencedIds = idRefs.split(/\s+/).filter((id)=>id !== '');
    return referencedIds.some((id)=>{
        const referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
/**
 * The `initialFocusRef` override target, when it is inside the popover. A
 * target outside the popover (or not in the DOM) is ignored, so the role
 * default applies.
 */ function $deb81d2009ddfcb0$var$getOverrideTarget({ container: container, initialFocusRef: initialFocusRef }) {
    const target = initialFocusRef?.current;
    if (target && container.contains(target)) return target;
    return null;
}
function $deb81d2009ddfcb0$var$getInitialFocusTarget({ container: container, initialFocusRef: initialFocusRef, role: role }) {
    // In each role branch, the combobox carve-out decides whether focus moves.
    // The override target, then the role default, decides where.
    if (role === 'dialog' || role === 'alertdialog') {
        // APG allows a combobox to control a dialog popup. Focus stays on the
        // combobox only when it is OUTSIDE the dialog. A dialog that contains
        // its own combobox still takes focus (see the comment below on why the
        // carve-out is per-role).
        if (!container.contains(container.ownerDocument.activeElement) && $deb81d2009ddfcb0$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $deb81d2009ddfcb0$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Prefer element with the native HTML autofocus attribute.
        const autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $lE1mX.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific rather than hoisted.
    // Hoisting it over-matched on dialog popups that contain a nested
    // combobox (e.g. datetime-picker's dialog hosts a react-select), where
    // the active combobox's `aria-controls` falsely matched the container
    // and suppressed the dialog's own focus contract. The dialog branch
    // above therefore skips only for a combobox outside the dialog.
    if (role === 'menu') {
        if ($deb81d2009ddfcb0$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $deb81d2009ddfcb0$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/decisions/menu-keyboard.md
        return (0, $lE1mX.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($deb81d2009ddfcb0$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $deb81d2009ddfcb0$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        const selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        const firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $lE1mX.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $deb81d2009ddfcb0$export$e992c40175757a22({ elementRef: elementRef, initialFocusRef: initialFocusRef, phase: phase, role: role }) {
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    const prevPhaseRef = (0, $lE8gv.useRef)('closed');
    (0, $l0Txf.useLayoutEffect)(()=>{
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        const element = elementRef.current;
        if (!element) return;
        $deb81d2009ddfcb0$var$getInitialFocusTarget({
            container: element,
            initialFocusRef: initialFocusRef,
            role: role
        })?.focus();
    }, [
        elementRef,
        initialFocusRef,
        phase,
        role
    ]);
}

});


parcelRegister("9AktP", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopover", () => $369cdf682b495fd8$export$147d8888d96bf7a3);
/**
 * Positioning AND anchor-relative sizing for top-layer popovers. Anchors an
 * ELEMENT; to anchor a viewport coordinate use `useAnchoredPopoverAtPoint`.
 *
 * Two runtime paths, each a function that applies its styles and returns the
 * cleanup: CSS Anchor Positioning in `./anchor-positioning`, and the JavaScript
 * fallback in `./javascript-fallback`. The path is resolved ONCE, at the top of
 * the hook, and threaded through positioning, sizing and margins.
 *
 * See `notes/architecture/positioning.md` and
 * `notes/decisions/fit-available-space.md`.
 */ 
var $lE8gv = parcelRequire("lE8gv");

var $GqzVB = parcelRequire("GqzVB");

var $l0Txf = parcelRequire("l0Txf");

var $dzHHB = parcelRequire("dzHHB");

var $h36n9 = parcelRequire("h36n9");

var $imKFq = parcelRequire("imKFq");

var $f95e7 = parcelRequire("f95e7");

var $2BTm8 = parcelRequire("2BTm8");

var $ldiUE = parcelRequire("ldiUE");
/**
 * Which way the popover's inline axis runs. Maps every physical measurement below
 * onto a logical axis: the viewport unit of each cap and the anchor's measured
 * size. A style read, not a layout read, so it is cheap enough to take for every
 * popover.
 */ function $369cdf682b495fd8$var$getPopoverWritingMode({ popover: popover }) {
    // `String()` because not every test environment implements `writing-mode`.
    const writingMode = String(getComputedStyle(popover).writingMode);
    const isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? 'vertical' : 'horizontal';
}
/**
 * Measured stand-in for `anchor-size(self-*)`, used wherever `anchor-size()` is
 * not: the JavaScript fallback, and browsers with anchor positioning but no
 * `anchor-size()`.
 *
 * `offsetWidth` / `offsetHeight` are physical, so the axis is picked from the
 * POPOVER's `writing-mode`. Deliberately not memoized: a cached anchor size is a
 * stale one. Runs once per effect, not per frame.
 */ function $369cdf682b495fd8$var$measureAnchorSize({ anchor: anchor, writingMode: writingMode }) {
    if (writingMode === 'vertical') return {
        inline: `${anchor.offsetHeight}px`,
        block: `${anchor.offsetWidth}px`
    };
    return {
        inline: `${anchor.offsetWidth}px`,
        block: `${anchor.offsetHeight}px`
    };
}
const $369cdf682b495fd8$var$NO_ANCHOR_SIZE = {
    inline: null,
    block: null
};
const $369cdf682b495fd8$var$CSS_ANCHOR_SIZE = {
    inline: 'anchor-size(self-inline)',
    block: 'anchor-size(self-block)'
};
function $369cdf682b495fd8$var$isAnchorRelative(size) {
    return size === 'match-anchor' || size === 'min-anchor';
}
/**
 * The `anchor-name` written to an anchor that does not already carry one, as a CSS
 * `<dashed-ident>`. `useId()` is the same source as every other id in the design
 * system, including the popover's own `id` that `aria-controls` and `popovertarget`
 * point at, so it is unique exactly where those are and collides exactly where
 * they do. See `useAnchoredPopover` for the one case that needs the host's help.
 *
 * `@atlaskit/ds-lib`'s `useId` already swaps React's `:` and `«»` for `_`. The
 * replace covers a host `identifierPrefix`, which may carry characters a
 * `<dashed-ident>` cannot.
 */ function $369cdf682b495fd8$var$useNewAnchorName() {
    const id = (0, $GqzVB.useId)();
    return (0, $lE8gv.useMemo)(()=>`--anchor-${id.replace(/[^A-Za-z0-9_-]/g, '_')}`, [
        id
    ]);
}
/**
 * A referentially-stable, fully-resolved `TPlacement`, so a fresh inline
 * `placement` object does not re-run the effect.
 */ function $369cdf682b495fd8$var$useStablePlacement(placement) {
    const resolved = (0, $f95e7.resolvePlacement)({
        placement: placement
    });
    const axis = resolved.axis;
    const edge = resolved.edge;
    const align = resolved.align;
    const minSize = resolved.minSize;
    const gap = resolved.offset.gap;
    const shiftValue = resolved.offset.crossAxisShift.value;
    const shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuilt from primitive deps, so the factory does not close over `resolved`
    // and exhaustive-deps can verify it.
    return (0, $lE8gv.useMemo)(()=>({
            axis: axis,
            edge: edge,
            align: align,
            minSize: minSize,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        }), [
        axis,
        edge,
        align,
        minSize,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $369cdf682b495fd8$export$147d8888d96bf7a3({ anchorRef: anchorRef, popoverRef: popoverRef, placement: placement, isOpen: isOpen, isEnabled: isEnabled = true, inlineSize: inlineSize = 'content', blockSize: blockSize = 'content', shouldPreserveInlineSize: shouldPreserveInlineSize = false, forceFallbackPositioning: forceFallbackPositioning = false }) {
    // Stable for the life of the hook instance, so it follows a replacement anchor
    // element (the point hook remounts its `<div>`).
    const fallbackAnchorName = $369cdf682b495fd8$var$useNewAnchorName();
    const stablePlacement = $369cdf682b495fd8$var$useStablePlacement(placement);
    (0, $l0Txf.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        // Resolved once, so positioning, sizing and margins cannot disagree about it.
        const isUsingCssAnchorPositioning = (0, $2BTm8.supportsAnchorPositioning)() && !forceFallbackPositioning;
        // BOTH probes: a browser can have positioning without sizing, and
        // `anchor-size()` needs the `position-anchor` only the CSS path writes.
        const canUseAnchorSize = isUsingCssAnchorPositioning && (0, $ldiUE.supportsAnchorSize)();
        const trigger = anchorRef.current;
        const popover = popoverRef.current;
        if (!trigger || !popover) return;
        // Fitting also reserves padding from the viewport edge as a margin.
        const isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
        // Always read: the viewport caps are always written, and their unit follows
        // the popover's writing mode.
        const writingMode = $369cdf682b495fd8$var$getPopoverWritingMode({
            popover: popover
        });
        // Skipped where possible, so a position-only consumer pays no layout read.
        // Fitting on the CSS path needs it to clamp the default flip floor; see
        // `getDefaultPlacementAxisFloor`.
        const needsAnchorSize = $369cdf682b495fd8$var$isAnchorRelative(inlineSize) || $369cdf682b495fd8$var$isAnchorRelative(blockSize) || isFitting && isUsingCssAnchorPositioning;
        const anchorSize = needsAnchorSize ? canUseAnchorSize ? $369cdf682b495fd8$var$CSS_ANCHOR_SIZE : $369cdf682b495fd8$var$measureAnchorSize({
            anchor: trigger,
            writingMode: writingMode
        }) : $369cdf682b495fd8$var$NO_ANCHOR_SIZE;
        const sizeStyles = (0, $h36n9.getAnchoredPopoverSizeDeclarations)({
            placement: stablePlacement,
            inlineSize: inlineSize,
            blockSize: blockSize,
            isUsingCssAnchorPositioning: isUsingCssAnchorPositioning,
            anchorSize: anchorSize,
            writingMode: writingMode,
            shouldPreserveInlineSize: shouldPreserveInlineSize
        });
        if (isUsingCssAnchorPositioning) return (0, $dzHHB.applyAnchorPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles,
            isFitting: isFitting,
            fallbackAnchorName: fallbackAnchorName
        });
        return (0, $imKFq.applyJavaScriptFallbackPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles
        });
    }, [
        isEnabled,
        anchorRef,
        popoverRef,
        stablePlacement,
        inlineSize,
        blockSize,
        shouldPreserveInlineSize,
        fallbackAnchorName,
        forceFallbackPositioning,
        isOpen
    ]);
}

});
parcelRegister("dzHHB", function(module, exports) {
$parcel$export(module.exports, "applyAnchorPositioning", () => $70b0f3836354cc9d$export$50da8074e1408934);
/**
 * The CSS Anchor Positioning path: `position-anchor`, `position-area`,
 * `position-try-fallbacks` and the gap / shift margins, all declared on the
 * popover so the browser owns placement and flipping. The twin of
 * `../javascript-fallback/apply-javascript-fallback-positioning`.
 */ 
var $a9koZ = parcelRequire("a9koZ");

var $cJvU1 = parcelRequire("cJvU1");

var $h18DU = parcelRequire("h18DU");

var $erAOW = parcelRequire("erAOW");

var $i3Cro = parcelRequire("i3Cro");

var $a6CMT = parcelRequire("a6CMT");

var $hWJsq = parcelRequire("hWJsq");
function $70b0f3836354cc9d$export$50da8074e1408934({ anchor: anchor, popover: popover, placement: placement, sizeStyles: sizeStyles, isFitting: isFitting, fallbackAnchorName: fallbackAnchorName }) {
    // Reuse rather than mint: another popover may already be anchored to it, or a
    // CONSUMER may have set it on their own element, as `post-office` does.
    const existingAnchorName = (0, $i3Cro.getExistingAnchorName)(anchor);
    const anchorName = existingAnchorName ?? fallbackAnchorName;
    const gap = (0, $h18DU.edgeMargin)({
        placement: placement,
        offset: placement.offset.gap
    });
    const crossAxisShift = (0, $cJvU1.crossAxisShiftMargins)({
        placement: placement,
        crossAxisShiftCssValue: placement.offset.crossAxisShift.value,
        direction: placement.offset.crossAxisShift.direction
    });
    const popoverStyles = [
        {
            property: 'position-anchor',
            value: anchorName
        },
        {
            property: 'position-area',
            value: (0, $a6CMT.placementToPositionArea)({
                placement: placement
            })
        },
        {
            property: 'position-try-fallbacks',
            value: (0, $hWJsq.placementToTryFallbacks)({
                placement: placement
            })
        },
        /**
		 * **`position-visibility: always`**
		 *
		 * `position-visibility` is used to control the visibility of an anchored
		 * popover based on the visibility of the element being anchored to (the target).
		 *
		 * Default `position-visibility` value: `anchors-visible` → hide the anchored
		 * popover when the target is fully clipped by an ancestor (eg a scroll container)
		 * or is `visibility:hidden`.
		 * Sadly this "automatic hiding" does not actually "close" the popover,
		 * so things like `:popover-open` are still active, even though the popover
		 * is no longer painted and no longer receives pointer input. Chrome keeps it
		 * focusable and in the accessibility tree, so keyboard and screen reader users
		 * can still land inside a surface that is not painted.
		 * Per-engine behaviour: `notes/decisions/position-visibility-always.md`.
		 *
		 * Generally we have not run into issues with the default (`anchors-visible`)
		 *
		 * Exceptions:
		 *  - Target is intentionally not visible (eg `position:absolute` moving it outside of
		 *    its parent's "clipped boundary", or a `visibility:hidden` trigger)
		 *  - A trigger is scrolled out of its scroll container while the popover is open.
		 *
		 * We are switching from `anchors-visible` → `always` _for now_ to force no
		 * automatic hiding of the popover. There seems to be no compelling reason to use
		 * the default value. If one arises in the future, we could look towards making
		 *  this behaviour configurable.
		 */ {
            property: 'position-visibility',
            value: 'always'
        },
        // Reset browser default popover positioning that conflicts
        // with anchor positioning (UA: `inset: 0; margin: auto;`)
        {
            property: 'margin',
            value: '0'
        },
        {
            property: 'inset',
            value: 'auto'
        },
        gap,
        // When fitting, the shift margins come back COMPOSED with the reserved
        // viewport padding, rather than being written twice.
        ...isFitting ? (0, $erAOW.getFitMarginDeclarations)({
            placement: placement,
            crossAxisShiftMargins: crossAxisShift
        }) : crossAxisShift,
        ...sizeStyles
    ];
    // Anchor names are never cleaned up: multiple popovers can share an anchor,
    // and even with reference counting an async React update could remove the name
    // while something else still uses it. See
    // `notes/decisions/anchor-name-lifetime.md`. Only written when minted: a name
    // from a stylesheet may be a list, which an inline copy of its first entry
    // would collapse.
    if (existingAnchorName === null) anchor.style.setProperty('anchor-name', anchorName);
    return (0, $a9koZ.setStyle)({
        element: popover,
        styles: popoverStyles
    });
}

});
parcelRegister("a9koZ", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $ba9cfeaf7661cd08$export$37a5fde709c1db82);
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ function $ba9cfeaf7661cd08$export$37a5fde709c1db82({ element: element, styles: styles }) {
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    const priorValues = styles.map(({ property: property })=>({
            property: property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property: property, value: value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property: property, value: value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});

parcelRegister("cJvU1", function(module, exports) {
$parcel$export(module.exports, "crossAxisShiftMargins", () => $63c9438967f54586$export$f7505ccec0897ae3);
function $63c9438967f54586$export$f7505ccec0897ae3({ placement: placement, crossAxisShiftCssValue: crossAxisShiftCssValue, direction: direction }) {
    const crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // `calc()` rather than JavaScript math, so opaque values such as design tokens
    // negate correctly.
    const negated = `calc(-1 * ${crossAxisShiftCssValue})`;
    const isForwards = direction === 'forwards';
    return [
        {
            property: `margin-${crossAxis}-start`,
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: `margin-${crossAxis}-end`,
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}

});

parcelRegister("h18DU", function(module, exports) {
$parcel$export(module.exports, "edgeMargin", () => $f499e254f282aa9d$export$b94d052c6b40496);
function $f499e254f282aa9d$export$b94d052c6b40496({ placement: placement, offset: offset }) {
    const { axis: axis, edge: edge } = placement;
    // The side FACING the anchor is always opposite the placement edge.
    const anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: `margin-${axis}-${anchorFacingEdge}`,
        value: offset
    };
}

});

parcelRegister("erAOW", function(module, exports) {
$parcel$export(module.exports, "getFitMarginDeclarations", () => $752dcdb949ad1b2f$export$a7ffde4a856e8d8e);

var $h36n9 = parcelRequire("h36n9");
/**
 * The cross-axis sides that face the viewport rather than the anchor, and so take
 * the reserved padding.
 *
 * A `span-*` cell aligns the popover's MARGIN box to the anchor's edge, so padding
 * on the anchor-facing side does not reserve space at the viewport: it insets the
 * border box from the edge the consumer asked it to line up with. A centred
 * popover has no anchor-facing side, and padding both keeps the shift pair
 * antisymmetric so `anchor-center` still centres.
 *
 * Known cost: the slide fallbacks do not swap the inline margins the way
 * `flip-inline` does, so a slid popover keeps its padding on the anchor side (or,
 * re-centred, sits 2.5px off centre). Alignment in the requested position wins.
 */ function $752dcdb949ad1b2f$var$viewportFacingCrossAxisSides({ align: align }) {
    if (align === 'center') return [
        'start',
        'end'
    ];
    // `align: 'start'` sits on the anchor's start edge and expands toward end.
    return [
        align === 'start' ? 'end' : 'start'
    ];
}
function $752dcdb949ad1b2f$export$a7ffde4a856e8d8e({ placement: placement, crossAxisShiftMargins: crossAxisShiftMargins }) {
    const crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    const paddedProperties = new Set($752dcdb949ad1b2f$var$viewportFacingCrossAxisSides({
        align: placement.align
    }).map((side)=>`margin-${crossAxis}-${side}`));
    return [
        {
            property: `margin-${placement.axis}-${placement.edge}`,
            value: (0, $h36n9.VIEWPORT_PADDING)
        },
        ...crossAxisShiftMargins.map(({ property: property, value: value })=>paddedProperties.has(property) ? {
                property: property,
                value: `calc(${value} + ${0, $h36n9.VIEWPORT_PADDING})`
            } : {
                property: property,
                value: value
            })
    ];
}

});
parcelRegister("h36n9", function(module, exports) {
$parcel$export(module.exports, "VIEWPORT_PADDING", () => $ada224cb1c403d3f$export$9f2fdbacbc62226e);
$parcel$export(module.exports, "getAnchoredPopoverSizeDeclarations", () => $ada224cb1c403d3f$export$860b30329fa0b990);
const $ada224cb1c403d3f$export$9f2fdbacbc62226e = '5px';
const $ada224cb1c403d3f$export$32ab78b2bb853a01 = '150px';
/**
 * The dynamic viewport unit for one of the popover's axes. Not `dvi` / `dvb`:
 * css-values-4 defines those against the ROOT element's writing mode, while the
 * `max-{axis}-size` they are written to follows the popover's, so a popover in a
 * `vertical-rl` subtree of a horizontal document would be capped by the wrong
 * dimension.
 */ function $ada224cb1c403d3f$var$viewportUnit({ axis: axis, writingMode: writingMode }) {
    const isHorizontalAxis = axis === 'inline' === (writingMode === 'horizontal');
    return isHorizontalAxis ? 'dvw' : 'dvh';
}
function $ada224cb1c403d3f$var$getCrossAxis(axis) {
    return axis === 'block' ? 'inline' : 'block';
}
/**
 * The whole viewport, less the reserved padding on both sides. Rule 3's backstop.
 */ function $ada224cb1c403d3f$var$viewportCap({ axis: axis, writingMode: writingMode }) {
    return `calc(100${$ada224cb1c403d3f$var$viewportUnit({
        axis: axis,
        writingMode: writingMode
    })} - 2 * ${$ada224cb1c403d3f$export$9f2fdbacbc62226e})`;
}
/**
 * The position-area cell cap, for the placement axis only. The host carries
 * `position-area`, so per css-anchor-position-1 the cell is its containing block:
 * `100%` is the anchor edge to the viewport edge, and it follows whichever side
 * `position-try-fallbacks` settles on. Percentages do not subtract margins, so
 * the gap is subtracted here.
 *
 * Meaningless on the JavaScript fallback, whose containing block is the viewport,
 * so that path gets `viewportCap` on both axes.
 */ function $ada224cb1c403d3f$var$cellCap({ gap: gap }) {
    return `calc(100% - ${$ada224cb1c403d3f$export$9f2fdbacbc62226e} - ${gap})`;
}
/**
 * The anchor term of the placement-axis floor, and the one place it is capped.
 *
 * `'match-anchor'` earns a floor only where it can flip: a definite size clamps to
 * the cap and shrinks below the anchor instead of flipping.
 *
 * The `canFlip` clamp is deliberate both ways. With no flip in play an unclamped
 * floor beats `max-{axis}-size` (CSS resolves `min` last), making the viewport
 * backstop inert. With a flip in play, clamping would stop the floor exceeding
 * the cell cap, which is what drives the flip.
 */ function $ada224cb1c403d3f$var$getPlacementAxisAnchorFloor({ placementAxis: placementAxis, placementAxisSize: placementAxisSize, anchorValue: anchorValue, canFlip: canFlip, writingMode: writingMode }) {
    const hasAnchorFloor = placementAxisSize === 'min-anchor' || placementAxisSize === 'match-anchor' && canFlip;
    if (!hasAnchorFloor || anchorValue === null) return undefined;
    if (canFlip) return anchorValue;
    return `min(${anchorValue}, ${$ada224cb1c403d3f$var$viewportCap({
        axis: placementAxis,
        writingMode: writingMode
    })})`;
}
/**
 * The default flip floor, clamped so that SOME cell can always hold it.
 *
 * The two cells either side of the anchor add up to the viewport less the anchor,
 * so the roomier one is at least half of that. A floor whose margin box fits
 * inside that half is guaranteed a cell somewhere in the fallback chain.
 * Unclamped, a short viewport with a centred anchor has NO cell that holds
 * 150px: every try-fallback overflows, the browser reverts to the base position,
 * and the floor pushes the popover past the viewport edge.
 *
 * This is NOT the `min(floor, cellCap)` that suppresses flipping: it is relative
 * to the VIEWPORT, so a small base cell still overflows it. `max(0px, …)` states
 * the lower bound for an anchor taller than the viewport.
 */ function $ada224cb1c403d3f$var$getDefaultPlacementAxisFloor({ placementAxis: placementAxis, anchorValue: anchorValue, gap: gap, writingMode: writingMode }) {
    if (anchorValue === null) return $ada224cb1c403d3f$export$32ab78b2bb853a01;
    // The viewport term and the anchor term must measure the SAME axis; see
    // `viewportUnit`.
    const viewport = `100${$ada224cb1c403d3f$var$viewportUnit({
        axis: placementAxis,
        writingMode: writingMode
    })}`;
    const halfOfRemainingViewport = `calc((${viewport} - ${anchorValue}) / 2 - ${gap} - ${$ada224cb1c403d3f$export$9f2fdbacbc62226e})`;
    return `min(${$ada224cb1c403d3f$export$32ab78b2bb853a01}, max(0px, ${halfOfRemainingViewport}))`;
}
/**
 * The placement-axis floor: explicit minimums COMPOSE, the default does not.
 *
 * `placement.minSize` and the anchor term are both explicit requests, so they
 * compose as `max()`. `FALLBACK_MINIMUM_MAIN_AXIS_SIZE` never composes: it only
 * ever won by overriding a size the consumer asked for, and the anchor term drives
 * the flip on its own. Knock-on, intended: `minSize: 0` no longer removes an
 * anchor floor, because `max(0px, anchor)` IS the anchor.
 */ function $ada224cb1c403d3f$var$getPlacementAxisFloor({ minSize: minSize, placementAxis: placementAxis, placementAxisSize: placementAxisSize, anchorValue: anchorValue, gap: gap, canFlip: canFlip, writingMode: writingMode }) {
    const anchorFloor = $ada224cb1c403d3f$var$getPlacementAxisAnchorFloor({
        placementAxis: placementAxis,
        placementAxisSize: placementAxisSize,
        anchorValue: anchorValue,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (minSize !== undefined) return anchorFloor === undefined ? minSize : `max(${minSize}, ${anchorFloor})`;
    if (anchorFloor !== undefined) return anchorFloor;
    if (!canFlip) return undefined;
    return $ada224cb1c403d3f$var$getDefaultPlacementAxisFloor({
        placementAxis: placementAxis,
        anchorValue: anchorValue,
        gap: gap,
        writingMode: writingMode
    });
}
function $ada224cb1c403d3f$export$860b30329fa0b990({ placement: placement, inlineSize: inlineSize, blockSize: blockSize, isUsingCssAnchorPositioning: isUsingCssAnchorPositioning, anchorSize: anchorSize, writingMode: writingMode, shouldPreserveInlineSize: shouldPreserveInlineSize = false }) {
    const placementAxis = placement.axis;
    const crossAxis = $ada224cb1c403d3f$var$getCrossAxis(placementAxis);
    // Rule 1. Feeds the per-axis CAPS only.
    const size = {
        inline: inlineSize === 'content' && blockSize === 'max-available' ? 'max-available' : inlineSize,
        block: blockSize === 'content' && inlineSize === 'max-available' ? 'max-available' : blockSize
    };
    // Rule 2 reads the requested values instead, un-mirrored: flipping is a
    // whole-popover outcome, so a fit request on either axis turns the floor on.
    const isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
    // ...but only where the floor is what causes the flip. On the JavaScript
    // fallback a floor only inflates the measured size the side is picked from, so
    // it would flip a popover that fits.
    const canFlip = isFitting && isUsingCssAnchorPositioning;
    const declarations = [
        // Rule 3: both caps are always written. Only the placement axis can take the
        // cell cap.
        {
            property: `max-${placementAxis}-size`,
            value: size[placementAxis] === 'max-available' && isUsingCssAnchorPositioning ? $ada224cb1c403d3f$var$cellCap({
                gap: placement.offset.gap
            }) : $ada224cb1c403d3f$var$viewportCap({
                axis: placementAxis,
                writingMode: writingMode
            })
        },
        {
            property: `max-${crossAxis}-size`,
            value: $ada224cb1c403d3f$var$viewportCap({
                axis: crossAxis,
                writingMode: writingMode
            })
        }
    ];
    // Rule 4. Only for a non-anchor-relative inline axis, so `'match-anchor'` below
    // stays the one writer of `inline-size` when it applies. CSS path only: the
    // fallback's containing block is the viewport, where shrink-to-fit already IS
    // the natural width for anything that fits on screen.
    if (isUsingCssAnchorPositioning && !shouldPreserveInlineSize && (size.inline === 'content' || size.inline === 'max-available')) declarations.push({
        property: 'inline-size',
        value: 'max-content'
    });
    // A max beats a definite size, so the caps above still win over this.
    for (const axis of [
        placementAxis,
        crossAxis
    ]){
        const anchorValue = anchorSize[axis];
        if (size[axis] === 'match-anchor' && anchorValue !== null) declarations.push({
            property: `${axis}-size`,
            value: anchorValue
        });
    }
    const placementAxisFloor = $ada224cb1c403d3f$var$getPlacementAxisFloor({
        minSize: placement.minSize,
        placementAxis: placementAxis,
        placementAxisSize: size[placementAxis],
        anchorValue: anchorSize[placementAxis],
        gap: placement.offset.gap,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (placementAxisFloor !== undefined) declarations.push({
        property: `min-${placementAxis}-size`,
        value: placementAxisFloor
    });
    // A size contract, not a flip driver, so it is clamped to the cap.
    const crossAxisAnchorValue = anchorSize[crossAxis];
    if (size[crossAxis] === 'min-anchor' && crossAxisAnchorValue !== null) declarations.push({
        property: `min-${crossAxis}-size`,
        value: `min(${crossAxisAnchorValue}, ${$ada224cb1c403d3f$var$viewportCap({
            axis: crossAxis,
            writingMode: writingMode
        })})`
    });
    return declarations;
}

});


parcelRegister("i3Cro", function(module, exports) {
$parcel$export(module.exports, "getExistingAnchorName", () => $36cde61bd51f315e$export$948d15b01d509455);
/**
 * The `anchor-name` an element already carries, or `null`. Computed as well as
 * inline, so a name set from a STYLESHEET is found: a minted inline name would
 * otherwise override it for every other rule anchored to that element.
 * `anchor-name` is a list and `position-anchor` takes one ident, so the first
 * name is the one to anchor to.
 */ function $36cde61bd51f315e$export$948d15b01d509455(element) {
    const declared = element.style.getPropertyValue('anchor-name') || getComputedStyle(element).getPropertyValue('anchor-name');
    const first = declared.split(',')[0].trim();
    return first !== '' && first !== 'none' ? first : null;
}

});

parcelRegister("a6CMT", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $bd96e346c74afdc8$export$de49b61f233ddeb9);
function $bd96e346c74afdc8$export$de49b61f233ddeb9({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = placement;
    const edgeValue = `${axis}-${edge}`;
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    const spanDir = align === 'start' ? 'end' : 'start';
    return `${edgeValue} span-${crossAxis}-${spanDir}`;
}

});

parcelRegister("hWJsq", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $f61b4d75e95c6e4d$export$c4e16947a95d61f1);
/**
 * The cells to slide to along one edge, on the cross axis.
 *
 * A try option is only worth listing if its margin box can fit where an earlier
 * one did not, and two options over the SAME cell have the same margin box and
 * the same fit result. That rules out three cells for an aligned placement: the
 * near span on the requested edge IS the base position-area, and on the opposite
 * edge the near and far spans are where `flip-{A}` and the diagonal flip land.
 *
 * A centred placement has no near or far, so it slides to both spans on both
 * edges.
 */ function $f61b4d75e95c6e4d$var$slideOnEdge({ align: align, edgeKey: edgeKey, crossAxis: crossAxis, isOppositeEdge: isOppositeEdge }) {
    if (align === 'center') return [
        `${edgeKey} span-${crossAxis}-end`,
        `${edgeKey} span-${crossAxis}-start`
    ];
    if (isOppositeEdge) return [
        edgeKey
    ];
    // For `align: 'start'` the popover expands toward `end`, so the far span is
    // `start`; `align: 'end'` mirrors this.
    const far = align === 'start' ? 'start' : 'end';
    return [
        edgeKey,
        `${edgeKey} span-${crossAxis}-${far}`
    ];
}
function $f61b4d75e95c6e4d$var$flipDiagonally({ axis: axis }) {
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    const flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return `${flipOnMainAxis} ${flipToCrossAxis}`;
}
function $f61b4d75e95c6e4d$export$c4e16947a95d61f1({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = placement;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const flippedEdge = edge === 'start' ? 'end' : 'start';
    const sameEdgeArea = `${axis}-${edge}`;
    const oppositeEdgeArea = `${axis}-${flippedEdge}`;
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    return [
        $f61b4d75e95c6e4d$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: false
        }),
        flipOnMainAxis,
        align !== 'center' ? $f61b4d75e95c6e4d$var$flipDiagonally({
            axis: axis
        }) : null,
        $f61b4d75e95c6e4d$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: true
        })
    ].filter(Boolean).flat().join(', ');
}

});


parcelRegister("imKFq", function(module, exports) {
$parcel$export(module.exports, "applyJavaScriptFallbackPositioning", () => $8fc5be3d3d06a2f9$export$89babc4c2047d2ba);
/**
 * The JavaScript positioning fallback: measured `position: fixed` coordinates for
 * browsers without CSS Anchor Positioning.
 *
 * Best effort, degrading in that order: measured anchored position, then anchored
 * with unresolvable offsets treated as `0`, then centred in the viewport, and
 * always visible. The two hazards differ in kind: `new ResizeObserver` runs
 * synchronously in the layout effect, where a throw unmounts the React tree,
 * while `update` runs asynchronously, where the danger is an uncleared
 * `opacity: 0`.
 */ 
var $5Ifxs = parcelRequire("5Ifxs");

var $hNPke = parcelRequire("hNPke");

var $c1u8L = parcelRequire("c1u8L");

var $a9koZ = parcelRequire("a9koZ");

var $kmo4F = parcelRequire("kmo4F");

var $9FRHY = parcelRequire("9FRHY");

var $cgaAt = parcelRequire("cgaAt");
/**
 * Wrapped because jsdom throws on the unknown `:popover-open` selector.
 */ function $8fc5be3d3d06a2f9$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch  {
        return false;
    }
}
/**
 * Observes the popover until its first non-zero layout, then self-disconnects;
 * ongoing movement is handled by the scroll and resize listeners. The popover is
 * `display: none` until `showPopover()`, and some browsers fire `toggle` before
 * layout, so RAF-after-toggle is unreliable.
 *
 * `null` where `ResizeObserver` is missing (non-DOM jest environments). There is
 * then no measurement to wait for, so the caller positions immediately and must
 * not hide the popover, because no reveal would follow.
 */ function $8fc5be3d3d06a2f9$var$createFirstLayoutObserver({ popover: popover, onFirstLayout: onFirstLayout }) {
    if (typeof ResizeObserver === 'undefined') return null;
    try {
        const observer = new ResizeObserver(()=>{
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                onFirstLayout();
                observer.disconnect();
            }
        });
        return observer;
    } catch (error) {
        (0, $cgaAt.warnFallbackFailure)({
            error: error
        });
        return null;
    }
}
function $8fc5be3d3d06a2f9$export$89babc4c2047d2ba({ anchor: anchor, popover: popover, placement: placement, sizeStyles: sizeStyles }) {
    // Already in the top layer via the `popover` attribute, so this only resets the
    // UA defaults and writes measured `top` / `left`.
    const cleanupBaseStyles = (0, $a9koZ.setStyle)({
        element: popover,
        styles: [
            {
                property: 'margin',
                value: '0'
            },
            {
                property: 'inset',
                value: 'auto'
            },
            ...sizeStyles
        ]
    });
    // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
    // so restore prior inline values rather than removing ours.
    let undoPosition;
    let undoHide;
    // Resolved once per open and per resize, reused across scrolls: resolving is a
    // full style and layout flush, and a scroll cannot change what a CSS length
    // resolves to. A resize can (viewport units), and so can a re-open (a token
    // retargeted while closed).
    let resolvedOffsets = null;
    function invalidateResolvedOffsets() {
        resolvedOffsets = null;
    }
    function getResolvedOffsets() {
        if (resolvedOffsets) return resolvedOffsets;
        // Probed INSIDE the popover: it is in the top layer, not the anchor's DOM
        // tree, so anywhere else resolves a token against a different scope.
        resolvedOffsets = {
            gap: (0, $9FRHY.resolveCssLengthToPixels)({
                value: placement.offset.gap,
                container: popover
            }),
            crossAxisShift: (0, $9FRHY.resolveCssLengthToPixels)({
                value: placement.offset.crossAxisShift.value,
                container: popover
            })
        };
        return resolvedOffsets;
    }
    function reveal() {
        undoHide?.();
        undoHide = undefined;
    }
    function restorePosition() {
        undoPosition?.();
        undoPosition = undefined;
    }
    // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
    // elements during `<dialog>` initial-focus traversal.
    function hideUntilPositioned() {
        // Keep the first snapshot, else we capture our own `opacity: 0`.
        if (undoHide) return;
        undoHide = (0, $a9koZ.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'opacity',
                    value: '0'
                }
            ]
        });
    }
    /**
	 * Last resort. The base styles above reset the UA
	 * `[popover] { inset: 0; margin: auto }`, so a popover with no `top` / `left`
	 * sits in the viewport corner rather than centred.
	 */ function centerInViewport() {
        restorePosition();
        undoPosition = (0, $a9koZ.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'inset',
                    value: '0'
                },
                {
                    property: 'margin',
                    value: 'auto'
                }
            ]
        });
    }
    function update() {
        try {
            const triggerRect = anchor.getBoundingClientRect();
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            const { gap: gap, crossAxisShift: crossAxisShift } = getResolvedOffsets();
            const { top: top, left: left } = (0, $kmo4F.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: placement,
                viewport: viewport,
                gap: gap,
                crossAxisShift: {
                    value: crossAxisShift,
                    direction: placement.offset.crossAxisShift.direction
                }
            });
            // A non-finite coordinate serialises to a declaration the browser drops,
            // landing the popover in the corner just as silently as a throw would.
            if (!Number.isFinite(top) || !Number.isFinite(left)) {
                centerInViewport();
                return;
            }
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $a9koZ.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: `${top}px`
                    },
                    {
                        property: 'left',
                        value: `${left}px`
                    }
                ]
            });
        } catch (error) {
            (0, $cgaAt.warnFallbackFailure)({
                error: error
            });
            // Anchoring needs the trigger geometry we just failed to get, so the
            // centred position is the only one left to degrade to.
            try {
                centerInViewport();
            } catch  {}
        } finally{
            // Unconditional. A popover in the wrong place is recoverable on the
            // next scroll or resize; one left at `opacity: 0` is invisible forever.
            reveal();
        }
    }
    function invalidateAndUpdate() {
        invalidateResolvedOffsets();
        update();
    }
    // One update per animation frame. Scroll reuses the resolved offsets; resize
    // re-resolves them.
    const scheduledScrollUpdate = (0, $hNPke.default)(update);
    const scheduledResizeUpdate = (0, $hNPke.default)(invalidateAndUpdate);
    const firstLayoutObserver = $8fc5be3d3d06a2f9$var$createFirstLayoutObserver({
        popover: popover,
        onFirstLayout: update
    });
    function positionOnNextLayout() {
        // A token can have been retargeted while the popover was closed, so each
        // open re-resolves the offsets.
        invalidateResolvedOffsets();
        // No observer means no measurement is coming: position now, and do not
        // hide, because the reveal would never arrive.
        if (!firstLayoutObserver) {
            update();
            return;
        }
        hideUntilPositioned();
        firstLayoutObserver.observe(popover);
    }
    // The popover can already be open when this runs, in which case the initial
    // `toggle` has fired and the listener below would miss it.
    if ($8fc5be3d3d06a2f9$var$isPopoverOpen(popover)) positionOnNextLayout();
    return (0, $c1u8L.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
    (0, $5Ifxs.bind)(popover, {
        type: 'toggle',
        listener: (event)=>{
            const toggleEvent = event;
            if (toggleEvent.newState === 'open') positionOnNextLayout();
        }
    }), ()=>firstLayoutObserver?.disconnect(), (0, $5Ifxs.bind)(window, {
        type: 'scroll',
        listener: scheduledScrollUpdate,
        options: {
            capture: true,
            passive: true
        }
    }), (0, $5Ifxs.bind)(window, {
        type: 'resize',
        listener: scheduledResizeUpdate,
        options: {
            passive: true
        }
    }), ()=>{
        scheduledScrollUpdate.cancel();
        scheduledResizeUpdate.cancel();
        restorePosition();
        reveal();
    });
}

});
parcelRegister("hNPke", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf5ed364cce98654$export$2e2bcd8739ae039);
var $cf5ed364cce98654$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $cf5ed364cce98654$export$2e2bcd8739ae039 = $cf5ed364cce98654$var$rafSchd;

});

parcelRegister("c1u8L", function(module, exports) {
$parcel$export(module.exports, "combine", () => $0c9abe020ce25692$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $0c9abe020ce25692$export$1be1fc439b849fdf(...cleanupFns) {
    return function cleanup() {
        cleanupFns.forEach((callback)=>callback?.());
    };
}

});

parcelRegister("kmo4F", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $c917f051d60a0592$export$d5ef1dac02135664);
/**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $c917f051d60a0592$var$computeEdgePosition({ axis: axis, edge: edge, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight, viewport: viewport, gap: gap }) {
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        const spaceBelow = viewport.height - triggerRect.bottom;
        const spaceAbove = triggerRect.top;
        const fitsBelow = spaceBelow >= popoverHeight + gap;
        const useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        const spaceAbove = triggerRect.top;
        const spaceBelow = viewport.height - triggerRect.bottom;
        const fitsAbove = spaceAbove >= popoverHeight + gap;
        const useAbove = fitsAbove || spaceAbove >= spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        const spaceRight = viewport.width - triggerRect.right;
        const spaceLeft = triggerRect.left;
        const fitsRight = spaceRight >= popoverWidth + gap;
        const useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        const spaceLeft = triggerRect.left;
        const spaceRight = viewport.width - triggerRect.right;
        const fitsLeft = spaceLeft >= popoverWidth + gap;
        const useLeft = fitsLeft || spaceLeft >= spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $c917f051d60a0592$var$applyAlignment({ position: position, axis: axis, align: align, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight }) {
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return {
            ...position,
            left: triggerRect.left
        };
        // align === 'end'
        return {
            ...position,
            left: triggerRect.right - popoverWidth
        };
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return {
        ...position,
        top: triggerRect.top
    };
    // align === 'end'
    return {
        ...position,
        top: triggerRect.bottom - popoverHeight
    };
}
/**
 * Applies the cross-axis shift offset. `forwards` always moves the popover
 * toward the cross-axis END, for every `align` value.
 *
 * Do not add a per-`align` sign inversion here. This is a coordinate, so the
 * direction is the sign and nothing else. The CSS path inverts only because an
 * END-side margin pushes a box the opposite way to a START-side one, which is a
 * property of margins.
 */ function $c917f051d60a0592$var$applyCrossAxisShift({ position: position, axis: axis, crossAxisShift: crossAxisShift }) {
    if (crossAxisShift.value === 0) return position;
    const directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    const delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return {
        ...position,
        left: position.left + delta
    };
    return {
        ...position,
        top: position.top + delta
    };
}
function $c917f051d60a0592$export$d5ef1dac02135664({ triggerRect: triggerRect, popoverEl: popoverEl, placement: placement, viewport: viewport, gap: gap, crossAxisShift: crossAxisShift }) {
    const { axis: axis, edge: edge, align: align } = placement;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    const popoverWidth = popoverEl.offsetWidth;
    const popoverHeight = popoverEl.offsetHeight;
    const basePosition = $c917f051d60a0592$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    const alignedPosition = $c917f051d60a0592$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    const shiftedPosition = $c917f051d60a0592$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("9FRHY", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $4f9a49687ff70d1c$export$98721546d2816d9e);

var $cgaAt = parcelRequire("cgaAt");
/**
 * `null` when the environment cannot measure at all.
 */ function $4f9a49687ff70d1c$var$measureWithProbe({ value: value, container: container }) {
    // Reached through the container rather than the global, so a popover in
    // another document still measures and one with no view degrades gracefully.
    const view = container.ownerDocument.defaultView;
    if (!view) return null;
    const probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hidden from assistive tech and event targeting; defensive against
    // `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    try {
        container.appendChild(probe);
        const resolved = parseFloat(view.getComputedStyle(probe).marginLeft);
        return Number.isFinite(resolved) ? resolved : 0;
    } catch (error) {
        (0, $cgaAt.warnFallbackFailure)({
            error: error
        });
        return null;
    } finally{
        // `remove()` rather than `removeChild()`: consumer code may already have
        // detached the probe, which must not throw out of a layout effect.
        probe.remove();
    }
}
function $4f9a49687ff70d1c$export$98721546d2816d9e({ value: value, container: container }) {
    if (typeof value === 'number') return value;
    // Fast path: consumers occasionally pass `'0'` instead of the number `0`.
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from `resolvePlacement`, so this avoids
    // a reflow for the common case.
    const pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    return $4f9a49687ff70d1c$var$measureWithProbe({
        value: value,
        container: container
    }) ?? 0;
}

});
parcelRegister("cgaAt", function(module, exports) {
$parcel$export(module.exports, "warnFallbackFailure", () => $39ad6a3b9dac1199$export$e142245b95267f17);

function $39ad6a3b9dac1199$export$e142245b95267f17({ error: error }) {
    return;
}

});



parcelRegister("2BTm8", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorPositioning", () => $a223dd9b0e0118e4$export$7192e63dfa9e8124);

var $ipcAu = parcelRequire("ipcAu");
const $a223dd9b0e0118e4$export$7192e63dfa9e8124 = (0, $ipcAu.createCssDeclarationProbe)({
    property: 'anchor-name',
    value: '--a'
});

});
parcelRegister("ipcAu", function(module, exports) {
$parcel$export(module.exports, "createCssDeclarationProbe", () => $750220dffc39f4cc$export$69de71b4b7c76bad);

var $fx8aD = parcelRequire("fx8aD");
function $750220dffc39f4cc$export$69de71b4b7c76bad({ property: property, value: value }) {
    return (0, $fx8aD.default)(function supportsCssDeclaration() {
        if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
        return CSS.supports(property, value);
    });
}

});


parcelRegister("ldiUE", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorSize", () => $a9293547219a2b88$export$1c8dd0d1c9df9c6e);

var $ipcAu = parcelRequire("ipcAu");
const $a9293547219a2b88$export$1c8dd0d1c9df9c6e = (0, $ipcAu.createCssDeclarationProbe)({
    property: 'min-inline-size',
    value: 'anchor-size(self-inline)'
});

});


parcelRegister("5oW0N", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopoverAtPoint", () => $3775672cab2e6a73$export$3c5c8baff3ccd957);
/**
 * Positioning and sizing for a popover anchored to a viewport COORDINATE. No
 * positioning logic here: CSS Anchor Positioning needs a real element to carry
 * `anchor-name`, so this hook creates a hidden, zero-size one at the requested
 * point and delegates everything else to `useAnchoredPopover`.
 *
 * See `notes/decisions/anchored-popover-at-point.md` for why this is a sibling
 * hook instead of an anchor union inside `useAnchoredPopover`.
 */ 
var $lE8gv = parcelRequire("lE8gv");

var $l0Txf = parcelRequire("l0Txf");

var $9AktP = parcelRequire("9AktP");
/**
 * Appended to `document.body` to escape any transformed ancestor, which would
 * break viewport-relative resolution of `position: fixed`. `Object.assign`
 * rather than `setStyle`: we own the element, so there is nothing to restore.
 */ function $3775672cab2e6a73$var$mountAnchorElementAtPoint({ point: point }) {
    const element = document.createElement('div');
    element.setAttribute('aria-hidden', 'true');
    Object.assign(element.style, {
        position: 'fixed',
        // Physical insets: `inset-inline-start` would need `viewportWidth - point.x`
        // in RTL.
        top: `${point.y}px`,
        left: `${point.x}px`,
        // Zero size, so placement alone decides which side the popover sits on.
        width: '0',
        height: '0',
        pointerEvents: 'none'
    });
    document.body.appendChild(element);
    return {
        element: element,
        cleanup: function cleanup() {
            element.remove();
        }
    };
}
function $3775672cab2e6a73$export$3c5c8baff3ccd957({ getPoint: getPoint, isEnabled: isEnabled = true, ...rest }) {
    const anchorRef = (0, $lE8gv.useRef)(null);
    // Latched, keyed on `isEnabled`: consumers read mutable refs inside `getPoint`,
    // so re-reading it would move an already-open popover, and keying on
    // `getPoint`'s identity would re-latch on every parent render.
    const getPointRef = (0, $lE8gv.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Declared BEFORE `useAnchoredPopover` below, so the element exists when that
    // hook's effect reads the ref (React runs layout effects in source order). This
    // effect must not depend on anything the delegated effect does not: a dependency
    // here alone re-creates the element without that hook writing an `anchor-name`
    // onto it, and positioning silently dies.
    (0, $l0Txf.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const point = getPointRef.current();
        if (!point) return;
        const { element: element, cleanup: unmountAnchorElement } = $3775672cab2e6a73$var$mountAnchorElementAtPoint({
            point: point
        });
        anchorRef.current = element;
        return function cleanup() {
            unmountAnchorElement();
            anchorRef.current = null;
        };
    // The latch. See `getPointRef` above: `getPoint` is deliberately absent.
    }, [
        isEnabled
    ]);
    (0, $9AktP.useAnchoredPopover)({
        ...rest,
        anchorRef: anchorRef,
        isEnabled: isEnabled
    });
}

});

parcelRegister("hS8z7", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $c50ee3f71569142b$export$9198c6c168be2eeb);

var $GqzVB = parcelRequire("GqzVB");
function $c50ee3f71569142b$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id`, not React's `useId`: React's output contains
    // `:`, `«` and `»`, which are invalid in an HTML id token.
    return `popover-${(0, $GqzVB.useId)()}`;
}

});

parcelRegister("lI0ME", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", () => $4905c012ab94fa7a$export$175375e9a2b5515d);

var $5oRUl = parcelRequire("5oRUl");
function $4905c012ab94fa7a$export$175375e9a2b5515d() {
    const document = (0, $5oRUl.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});

parcelRegister("bFK5x", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", () => $54e71378a3e17475$export$b065aeb850c3e87f);
function $54e71378a3e17475$export$b065aeb850c3e87f({ rect: rect, placement: placement, isRtl: isRtl }) {
    const axis = placement.axis ?? 'block';
    const edge = placement.edge ?? 'end';
    const align = placement.align ?? 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        const y = edge === 'start' ? rect.top : rect.bottom;
        const x = $54e71378a3e17475$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: x,
            y: y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    const x = $54e71378a3e17475$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    const y = $54e71378a3e17475$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $54e71378a3e17475$var$horizontalForAlign({ rect: rect, align: align, isRtl: isRtl }) {
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    const isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $54e71378a3e17475$var$verticalForAlign({ rect: rect, align: align }) {
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $54e71378a3e17475$var$inlineEdgeX({ rect: rect, edge: edge, isRtl: isRtl }) {
    const isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("8bZOf", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", () => $ee203b8716d432c3$export$e9a6fdb80170ffd);
function $ee203b8716d432c3$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("fHuXz", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", () => $4405e89fb6c81a1d$export$941a7e8bf0b9eafd);

var $lE8gv = parcelRequire("lE8gv");

var $kdSi3 = parcelRequire("kdSi3");
function $4405e89fb6c81a1d$export$941a7e8bf0b9eafd() {
    return (0, $lE8gv.useContext)((0, $kdSi3.AnchorContext));
}

});
parcelRegister("kdSi3", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", () => $a644d7673a880e3b$export$8f73317645bb7b8e);

var $lE8gv = parcelRequire("lE8gv");
const $a644d7673a880e3b$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $lE8gv.createContext)(null);

});


parcelRegister("1pden", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", () => $e87bf340a146c357$export$61d36e2b682e92f7);

var $lE8gv = parcelRequire("lE8gv");

var $5Ifxs = parcelRequire("5Ifxs");

var $l0Txf = parcelRequire("l0Txf");

var $gJSKv = parcelRequire("gJSKv");
const $e87bf340a146c357$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $e87bf340a146c357$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $e87bf340a146c357$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $e87bf340a146c357$var$isClippedByAncestors(element) {
    const rect = element.getBoundingClientRect();
    let parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        const style = window.getComputedStyle(parent);
        const clipsHorizontally = $e87bf340a146c357$var$isClippingOverflow(style.overflowX);
        const clipsVertically = $e87bf340a146c357$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            const parentRect = parent.getBoundingClientRect();
            const horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            const verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $e87bf340a146c357$export$61d36e2b682e92f7({ anchor: anchor, popoverRef: popoverRef }) {
    const [visibility, setVisibility] = (0, $lE8gv.useState)($e87bf340a146c357$var$INITIAL);
    const measure = (0, $lE8gv.useCallback)(()=>{
        if (!anchor) {
            setVisibility((previous)=>previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $e87bf340a146c357$var$INITIAL);
            return;
        }
        const viewport = (0, $gJSKv.readViewport)();
        const anchorRect = anchor.getBoundingClientRect();
        const isReferenceHidden = $e87bf340a146c357$var$isFullyOutsideViewport(anchorRect, viewport) || $e87bf340a146c357$var$isClippedByAncestors(anchor);
        const popoverElement = popoverRef.current;
        const hasPopperEscaped = popoverElement ? $e87bf340a146c357$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility((previous)=>{
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $l0Txf.useLayoutEffect)(()=>{
        measure();
        if (typeof window === 'undefined') return undefined;
        const cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(()=>measure());
            observer.observe(anchor);
            cleanups.push(()=>observer.disconnect());
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $5Ifxs.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        const visual = window.visualViewport;
        if (visual) cleanups.push((0, $5Ifxs.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return ()=>{
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("gJSKv", function(module, exports) {
$parcel$export(module.exports, "readViewport", () => $15dd260123bbf7ae$export$64beed533e21f72d);
function $15dd260123bbf7ae$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    const visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("d0Uue", function(module, exports) {
$parcel$export(module.exports, "Manager", () => $0ac5034f183d916d$export$d0d38e7dec7a1a61);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $iUr3Z = parcelRequire("iUr3Z");

var $kdSi3 = parcelRequire("kdSi3");

var $de1TG = parcelRequire("de1TG");

var $kydDT = parcelRequire("kydDT");
function $0ac5034f183d916d$export$d0d38e7dec7a1a61({ children: children }) {
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    const { anchor: anchor, setAnchor: setAnchor } = (0, $kydDT.useAnchorState)();
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $iUr3Z.Manager), {
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $de1TG.AnchorSetterContext).Provider, {
            value: setAnchor,
            children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kdSi3.AnchorContext).Provider, {
                value: anchor,
                children: children
            })
        })
    });
}

});
parcelRegister("de1TG", function(module, exports) {
$parcel$export(module.exports, "AnchorSetterContext", () => $ffa47ce43221a657$export$804169e6eecdff16);

var $lE8gv = parcelRequire("lE8gv");
const $ffa47ce43221a657$export$804169e6eecdff16 = /*#__PURE__*/ (0, $lE8gv.createContext)(()=>undefined);

});

parcelRegister("kydDT", function(module, exports) {
$parcel$export(module.exports, "useAnchorState", () => $f38308beafddc785$export$1b1b50fdcd7ac375);

var $lE8gv = parcelRequire("lE8gv");
function $f38308beafddc785$export$1b1b50fdcd7ac375() {
    const [anchor, setAnchor] = (0, $lE8gv.useState)(null);
    return {
        anchor: anchor,
        setAnchor: setAnchor
    };
}

});


parcelRegister("96Stf", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $6cdce4e3d74790ca$export$e0be378c32fb70a7);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $e0RzB = parcelRequire("e0RzB");

var $3ipAE = parcelRequire("3ipAE");

var $hr0WH = parcelRequire("hr0WH");
function $6cdce4e3d74790ca$export$e0be378c32fb70a7({ children: children, innerRef: innerRef }) {
    const publishAnchor = (0, $hr0WH.useManagerAnchorSetter)();
    const composedRef = (0, $lE8gv.useMemo)(()=>(0, $3ipAE.default)([
            publishAnchor,
            innerRef
        ]), [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $e0RzB.Reference), {
        innerRef: composedRef,
        children: children
    });
}

});
parcelRegister("e0RzB", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $a33a9f49e3c2824f$export$e0be378c32fb70a7);

var $lE8gv = parcelRequire("lE8gv");

var $f6U20 = parcelRequire("f6U20");

var $iUr3Z = parcelRequire("iUr3Z");

var $hofj5 = parcelRequire("hofj5");
function $a33a9f49e3c2824f$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $lE8gv.useContext((0, $iUr3Z.ManagerReferenceNodeSetterContext));
    var refHandler = $lE8gv.useCallback(function(node) {
        (0, $hofj5.setRef)(innerRef, node);
        (0, $hofj5.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $lE8gv.useEffect(function() {
        return function() {
            return (0, $hofj5.setRef)(innerRef, null);
        };
    }, []);
    $lE8gv.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($f6U20)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $hofj5.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("f6U20", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $b002e1380083278a$var$__DEV__ = false;
var $b002e1380083278a$var$warning = function() {};
if ($b002e1380083278a$var$__DEV__) {
    var $b002e1380083278a$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $b002e1380083278a$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $b002e1380083278a$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $b002e1380083278a$var$warning;

});


parcelRegister("hr0WH", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchorSetter", () => $1017825970f4772b$export$fcdda419d7091b3);

var $lE8gv = parcelRequire("lE8gv");

var $de1TG = parcelRequire("de1TG");
function $1017825970f4772b$export$fcdda419d7091b3() {
    return (0, $lE8gv.useContext)((0, $de1TG.AnchorSetterContext));
}

});


parcelRegister("d0sYo", function(module, exports) {
$parcel$export(module.exports, "Container", () => $414724cf9dd0bf22$export$42a852a2b6b56249);
/* inline-dialog-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $414724cf9dd0bf22$var$containerStyles = null;
const $414724cf9dd0bf22$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $lE8gv.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        className: (0, $l2NkF.default)([
            "_2rkofajl _vchh1ntv _p12flti4 _c71llti4 _1pbyowjs _bfhk1bhr _16qs130s _syazi7uo _85i5pxbi _1q51pxbi _y4ti1ejb _bozg1ejb _nt751r31 _49pcglyw _1hvw1o36"
        ]),
        children: typeof children === 'function' ? children() : children
    });
});

});

parcelRegister("cOP98", function(module, exports) {
$parcel$export(module.exports, "default", () => $6501538091fe7d90$export$2e2bcd8739ae039);
/* inline-dialog-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $lC4HT = parcelRequire("lC4HT");

var $6esjp = parcelRequire("6esjp");

var $1J3Yq = parcelRequire("1J3Yq");

var $3xsJK = parcelRequire("3xsJK");

var $LhXOl = parcelRequire("LhXOl");

var $h1jDZ = parcelRequire("h1jDZ");

var $9AktP = parcelRequire("9AktP");

var $hS8z7 = parcelRequire("hS8z7");
const $6501538091fe7d90$var$displayContentsStyles = {
    root: "_1e0c1bgi"
};
const $6501538091fe7d90$var$styles = {
    container: "_2rkofajl _vchh1ntv _p12flti4 _c71llti4 _bfhk1bhr _16qs130s _85i5pxbi _1q51pxbi _y4ti1ejb _bozg1ejb"
};
/**
 * Returns the trigger button when the element is a button, or its first descendant button.
 * InlineDialog accepts arbitrary child markup, so the first button is used as the pragmatic target
 * when a wrapper contains multiple buttons.
 */ function $6501538091fe7d90$var$getTriggerElement(trigger) {
    if (!trigger) return null;
    if (trigger instanceof HTMLButtonElement) return trigger;
    return trigger.querySelector('button');
}
/**
 * Applies ARIA attributes to the child trigger element via an effect,
 * keeping them in sync with popup state.
 */ function $6501538091fe7d90$var$TriggerWrapper({ children: children, triggerRef: triggerRef, ariaAttributes: ariaAttributes }) {
    (0, $lE8gv.useEffect)(()=>{
        const trigger = $6501538091fe7d90$var$getTriggerElement(triggerRef.current);
        if (!trigger) return;
        // Apply each attribute. When a value is `undefined` (e.g.
        // `aria-controls` while the popover host is not in the DOM),
        // remove the attribute so the trigger does not retain a stale
        // reference from a previous open.
        Object.entries(ariaAttributes).forEach(([key, value])=>{
            if (value === undefined) {
                trigger.removeAttribute(key);
                return;
            }
            trigger.setAttribute(key, String(value));
        });
    }, [
        ariaAttributes,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        ref: (node)=>{
            if (!node) {
                triggerRef.current = null;
                return;
            }
            // CSS-in-JS may inject <style> elements into this wrapper; they are not trigger elements.
            const triggerElement = Array.from(node.children).find((child)=>child instanceof HTMLElement && !(child instanceof HTMLStyleElement));
            triggerRef.current = triggerElement ?? null;
        },
        className: (0, $l2NkF.default)([
            $6501538091fe7d90$var$displayContentsStyles.root
        ]),
        children: children
    });
}
/**
 * Top-layer implementation of InlineDialog.
 *
 * Replaces the legacy rendering pipeline (Popper.js + Portal + @atlaskit/layering)
 * with the native Popover API + CSS Anchor Positioning via @atlaskit/top-layer.
 *
 * Gated behind the `platform-dst-top-layer` feature flag.
 */ const $6501538091fe7d90$var$InlineDialogTopLayer = /*#__PURE__*/ (0, $lE8gv.memo)(function InlineDialogTopLayer({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $6esjp.default), onContentClick: onContentClick = (0, $6esjp.default), onContentFocus: onContentFocus = (0, $6esjp.default), onClose: providedOnClose = (0, $6esjp.default), placement: placement = 'bottom-start', testId: testId, content: content, children: children, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js fallbackPlacements not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
fallbackPlacements: _fallbackPlacements }) {
    const triggerRef = (0, $lE8gv.useRef)(null);
    const popoverRef = (0, $lE8gv.useRef)(null);
    const popoverId = (0, $hS8z7.usePopoverId)();
    const onClose = (0, $lC4HT.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: undefined,
        packageVersion: undefined
    });
    // Placement conversion.
    const topLayerPlacement = (0, $lE8gv.useMemo)(()=>(0, $3xsJK.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]);
    // `isOpen` is included so the anchor positioning effect re-runs when
    // the Popover host element is unmounted/remounted across open cycles.
    (0, $9AktP.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    });
    // onClose bridge.
    // Translates top-layer's { reason } into the legacy onClose({ isOpen, event }) shape.
    // Focus restoration is handled automatically by the Popover based on the content role
    // (role="dialog" -> auto-restore).
    const handleOnClose = (0, $lE8gv.useCallback)(({ reason: reason })=>{
        const syntheticEvent = (0, $LhXOl.createPopoverCloseEvent)({
            reason: reason
        });
        onClose({
            isOpen: false,
            event: syntheticEvent
        });
    }, [
        onClose
    ]);
    const ariaAttributes = (0, $1J3Yq.getAriaForTrigger)({
        role: 'dialog',
        isOpen: isOpen,
        popoverId: popoverId
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lE8gv.Fragment), {
        children: [
            /*#__PURE__*/ (0, $kOwiQ.jsx)($6501538091fe7d90$var$TriggerWrapper, {
                triggerRef: triggerRef,
                ariaAttributes: ariaAttributes,
                children: children
            }),
            /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $h1jDZ.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "dialog",
                // TODO: i18n. Hardcoded label is not translatable.
                // Acceptable given this component is intent-to-deprecate.
                label: "Inline dialog",
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId,
                children: /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
                    role: "presentation",
                    onBlur: onContentBlur,
                    onClick: onContentClick,
                    onFocus: onContentFocus,
                    className: (0, $l2NkF.default)([
                        $6501538091fe7d90$var$styles.container
                    ]),
                    children: typeof content === 'function' ? content() : content
                })
            })
        ]
    });
});
var $6501538091fe7d90$export$2e2bcd8739ae039 = $6501538091fe7d90$var$InlineDialogTopLayer;

});
parcelRegister("1J3Yq", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", () => $6477f785cccdfcab$export$9dd1d61dd4d4755);
/**
 * Maps each supported popover role to its `aria-haspopup` value.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. Roles that do not produce a popup use `undefined` instead (for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading), so they are intentionally excluded
 * from this mapping and from `getAriaForTrigger`.
 *
 * `true` is intentionally not a value in this mapping. The runtime only ever
 * produces the explicit string forms, so allowing it would invite consumers
 * to pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ const $6477f785cccdfcab$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $6477f785cccdfcab$export$9dd1d61dd4d4755({ role: role, isOpen: isOpen, popoverId: popoverId }) {
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': role ? $6477f785cccdfcab$var$roleToAriaHasPopup[role] : undefined,
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("LhXOl", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", () => $9989c79e056aef7f$export$27b4de066896ac63);
function $9989c79e056aef7f$export$27b4de066896ac63({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});



parcelRegister("3vZdv", function(module, exports) {
$parcel$export(module.exports, "default", () => $622f7702bfbc7a6f$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");

var $lE8gv = parcelRequire("lE8gv");

var $lC4HT = parcelRequire("lC4HT");

var $9KCfh = parcelRequire("9KCfh");

var $gsoqF = parcelRequire("gsoqF");

var $fBWTV = parcelRequire("fBWTV");

var $cwRZg = parcelRequire("cwRZg");

var $kagwH = parcelRequire("kagwH");

var $7eBEg = parcelRequire("7eBEg");

var $ipZb0 = parcelRequire("ipZb0");

var $aana3 = parcelRequire("aana3");

var $9Ffg2 = parcelRequire("9Ffg2");
const $622f7702bfbc7a6f$var$fieldStyles = null;
const $622f7702bfbc7a6f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: undefined,
    packageVersion: undefined
};
const $622f7702bfbc7a6f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $lE8gv.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $lE8gv.useState)(startWithEditViewOpen);
    const timerRef = (0, $lE8gv.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $aana3.default)(isEditing, isEditingState);
    const onCancel = (0, $lE8gv.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $lE8gv.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $lC4HT.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$622f7702bfbc7a6f$var$analyticsAttributes
    });
    const onCancelClick = (0, $lE8gv.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $lE8gv.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        // Ignore if the provided ref is a function. This is used to make the
        // typechecking accurate. Inline edit only uses one type of ref, so this
        // will never trigger.
        if (typeof formRef === 'function') return;
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]);
    /**
   * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons.
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
   */ const onEditViewWrapperBlur = (0, $lE8gv.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]);
    /**
   * Gets called when focus is transferred to the editView, or action buttons.
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field.
   */ const onEditViewWrapperFocus = (0, $lE8gv.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) {
            const labelText = typeof label === 'string' ? label : (0, $ipZb0.default)(label);
            return `${editButtonLabel}, ${labelText}, ${editLabel}`;
        }
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $9Ffg2.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $gsoqF.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("form", {
                /**
     * It is not normally acceptable to add key handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * to add support for keyboard functionality instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there is no negative
     * impacts to assistive technologies.
     */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                // Below we have added a class name to the form element to prevent the default focus on the form element
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $fBWTV.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $9KCfh.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $kOwiQ.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $l2NkF.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $7eBEg.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $cwRZg.Pressable), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kagwH.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view") : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $9KCfh.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view")
            })
    });
};
const $622f7702bfbc7a6f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $kOwiQ.jsx)($622f7702bfbc7a6f$var$InnerInlineEdit, {
        ...props
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$622f7702bfbc7a6f$export$2e2bcd8739ae039 = $622f7702bfbc7a6f$var$InlineEdit;

});
parcelRegister("9KCfh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $76c06538d5208875$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");

var $lE8gv = parcelRequire("lE8gv");

var $GqzVB = parcelRequire("GqzVB");

var $2kLYy = parcelRequire("2kLYy");

var $lI6cI = parcelRequire("lI6cI");

var $66g0m = parcelRequire("66g0m");

var $hRwnJ = parcelRequire("hRwnJ");

var $jLdno = parcelRequire("jLdno");

var $bFSXD = parcelRequire("bFSXD");

var $1mTpO = parcelRequire("1mTpO");

var $fd7Nb = parcelRequire("fd7Nb");

var $kGajv = parcelRequire("kGajv");
const $76c06538d5208875$var$fieldWrapperStyles = null;
function $76c06538d5208875$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $76c06538d5208875$var$isFunction(x) {
    return typeof x === 'function';
}
function $76c06538d5208875$var$usePreviousRef(current) {
    const ref = (0, $lE8gv.useRef)(current);
    // will be updated on the next render
    (0, $lE8gv.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $76c06538d5208875$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $76c06538d5208875$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $lE8gv.useContext)((0, $66g0m.FormContext));
    const isDisabled = (0, $lE8gv.useContext)((0, $jLdno.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $76c06538d5208875$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $76c06538d5208875$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$76c06538d5208875$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $lE8gv.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $76c06538d5208875$var$usePreviousRef(state);
    (0, $lE8gv.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $76c06538d5208875$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($76c06538d5208875$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, $GqzVB.useId)();
    const fieldId = (0, $lE8gv.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $kOwiQ.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $l2NkF.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $bFSXD.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $fd7Nb.RequiredAsterisk), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $lI6cI.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $1mTpO.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $hRwnJ.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $2kLYy.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kGajv.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("66g0m", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $a90916584896d74e$export$c24727297075ec6a);

var $lE8gv = parcelRequire("lE8gv");
const $a90916584896d74e$export$c24727297075ec6a = /*#__PURE__*/ (0, $lE8gv.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});

});

parcelRegister("hRwnJ", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $30a4467fc3d9d8b2$export$8fbe3c7d0ed2c683);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $lI6cI = parcelRequire("lI6cI");

var $gUqVu = parcelRequire("gUqVu");

var $kA3Og = parcelRequire("kA3Og");
const $30a4467fc3d9d8b2$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $lI6cI.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $gUqVu.default), {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
(0, $kA3Og.default).mark($30a4467fc3d9d8b2$export$8fbe3c7d0ed2c683);

});

parcelRegister("jLdno", function(module, exports) {
$parcel$export(module.exports, "IsDisabledContext", () => $54cd72fc7e991643$export$c17cf6b332a82dbc);

var $lE8gv = parcelRequire("lE8gv");
const $54cd72fc7e991643$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $lE8gv.createContext)(false);

});

parcelRegister("bFSXD", function(module, exports) {
$parcel$export(module.exports, "Label", () => $5c06028ba03c0bb2$export$b04be29aa201d4f5);
/* label.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $5c06028ba03c0bb2$var$fieldsetLabelStyles = null;
const $5c06028ba03c0bb2$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $l2NkF.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });

});

parcelRegister("1mTpO", function(module, exports) {
$parcel$export(module.exports, "MessageWrapper", () => $7c2e9daad2dd8baf$export$ec445f12f63100a5);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $jZj0v = parcelRequire("jZj0v");

var $fBWTV = parcelRequire("fBWTV");

var $cg514 = parcelRequire("cg514");

var $SUDaS = parcelRequire("SUDaS");

var $h4nVJ = parcelRequire("h4nVJ");

var $kA3Og = parcelRequire("kA3Og");
const $7c2e9daad2dd8baf$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true,
        hasMotionBoundary: false,
        transition: 'row'
    };
    const shouldProvideMotionBoundary = (0, $fBWTV.fg)('platform-dst-motion-uplift-input') && (0, $lE8gv.Children).toArray(children).every((0, $kA3Og.default).isCapable);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $SUDaS.MessageWrapperContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: shouldProvideMotionBoundary ? /*#__PURE__*/ (0, $kOwiQ.jsx)($7c2e9daad2dd8baf$var$MotionMessages, {
                children: children
            }) : children
        })
    });
};
const $7c2e9daad2dd8baf$var$getChildKeys = (children)=>(0, $lE8gv.Children).toArray(children).filter((0, $lE8gv.isValidElement)).map((child)=>child.key).filter((key)=>key !== null);
const $7c2e9daad2dd8baf$var$getTransition = (previousKeys, currentKeys)=>{
    const previous = new Set(previousKeys);
    const current = new Set(currentKeys);
    const removedCount = previousKeys.filter((key)=>!current.has(key)).length;
    const addedCount = currentKeys.filter((key)=>!previous.has(key)).length;
    if (removedCount > 0 && addedCount > 0) return 'instant';
    if (previousKeys.length === 0 && addedCount > 1) return 'groupEnter';
    if (currentKeys.length === 0 && removedCount > 1) return 'groupExit';
    return 'row';
};
const $7c2e9daad2dd8baf$var$MotionMessages = ({ children: children })=>{
    const currentKeys = $7c2e9daad2dd8baf$var$getChildKeys(children);
    const submitCount = (0, $lE8gv.useContext)((0, $cg514.FormSubmitContext));
    const [transition, setTransition] = (0, $lE8gv.useState)(()=>({
            keys: currentKeys,
            mode: 'row',
            submitCount: submitCount
        }));
    const hasKeyChange = currentKeys.length !== transition.keys.length || currentKeys.some((key, index)=>key !== transition.keys[index]);
    const isSubmitUpdate = submitCount !== transition.submitCount;
    if (hasKeyChange || isSubmitUpdate) setTransition({
        keys: currentKeys,
        mode: !hasKeyChange ? transition.mode : isSubmitUpdate ? 'instant' : $7c2e9daad2dd8baf$var$getTransition(transition.keys, currentKeys),
        submitCount: submitCount
    });
    const motionContextValue = (0, $lE8gv.useMemo)(()=>({
            isWrapper: true,
            hasMotionBoundary: true,
            transition: transition.mode
        }), [
        transition.mode
    ]);
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $SUDaS.MessageWrapperContext).Provider, {
        value: motionContextValue,
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $h4nVJ.default), {
            transition: transition.mode,
            children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $jZj0v.default), {
                appear: true,
                children: children
            })
        })
    });
};

});
parcelRegister("cg514", function(module, exports) {
$parcel$export(module.exports, "FormSubmitContext", () => $87ade9421ee7fe2c$export$8f3f615a5fb5d1d6);

var $lE8gv = parcelRequire("lE8gv");
const $87ade9421ee7fe2c$export$8f3f615a5fb5d1d6 = /*#__PURE__*/ (0, $lE8gv.createContext)(0);

});

parcelRegister("h4nVJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7d231e4f5ad518e$export$2e2bcd8739ae039);
/* message-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $c7d231e4f5ad518e$var$expandRow = null;
const $c7d231e4f5ad518e$var$collapseRow = null;
const $c7d231e4f5ad518e$var$messageGroupStyles = {
    root: "_1e0c11p5 _2z05hkll",
    row: "_1tkeidpf",
    expand: "_y44vl7y1 _1bumglyw",
    collapse: "_y44v1avz _1bumglyw"
};
const $c7d231e4f5ad518e$var$MessageGroup = ({ children: children, transition: transition })=>/*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        "data-testid": "message-wrapper-motion",
        className: (0, $l2NkF.default)([
            $c7d231e4f5ad518e$var$messageGroupStyles.root,
            transition === 'groupEnter' && $c7d231e4f5ad518e$var$messageGroupStyles.expand,
            transition === 'groupExit' && $c7d231e4f5ad518e$var$messageGroupStyles.collapse
        ]),
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
            className: (0, $l2NkF.default)([
                $c7d231e4f5ad518e$var$messageGroupStyles.row
            ]),
            children: children
        })
    });
var $c7d231e4f5ad518e$export$2e2bcd8739ae039 = $c7d231e4f5ad518e$var$MessageGroup;

});


parcelRegister("fd7Nb", function(module, exports) {
$parcel$export(module.exports, "RequiredAsterisk", () => $c754977b65ea2406$export$a4bb55a1e3b8a49f);
/* required-asterisk.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $c754977b65ea2406$var$requiredIndicatorStyles = null;
function $c754977b65ea2406$export$a4bb55a1e3b8a49f() {
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $l2NkF.default)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("kGajv", function(module, exports) {
$parcel$export(module.exports, "ValidMessage", () => $3479a2ef17e53172$export$5505afb209a532c8);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $lI6cI = parcelRequire("lI6cI");

var $gUqVu = parcelRequire("gUqVu");

var $kA3Og = parcelRequire("kA3Og");
const $3479a2ef17e53172$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $lI6cI.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $gUqVu.default), {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
(0, $kA3Og.default).mark($3479a2ef17e53172$export$5505afb209a532c8);

});


parcelRegister("gsoqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cd40fd4a022a0e4$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v3.0.2 */ /* form.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $5m9w2 = parcelRequire("5m9w2");

var $gcQod = parcelRequire("gcQod");

var $3YySR = parcelRequire("3YySR");

var $g6DtW = parcelRequire("g6DtW");

var $3ipAE = parcelRequire("3ipAE");

var $fBWTV = parcelRequire("fBWTV");

var $66g0m = parcelRequire("66g0m");

var $cg514 = parcelRequire("cg514");

var $jLdno = parcelRequire("jLdno");

var $gAmJs = parcelRequire("gAmJs");
const $2cd40fd4a022a0e4$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $lE8gv.useRef)(null);
    const onSubmitRef = (0, $lE8gv.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $lE8gv.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $5m9w2.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($3YySR)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($3YySR)))(values, name, value);
                    }
                }
            }
        });
        (0, $gcQod.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $gAmJs.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $lE8gv.useState)({
        dirty: false,
        submitting: false
    });
    const [submitCount, setSubmitCount] = (0, $lE8gv.useState)(0);
    (0, $lE8gv.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $lE8gv.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        if ((0, $fBWTV.fg)('platform-dst-motion-uplift-input')) setSubmitCount((count)=>count + 1);
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, $lE8gv.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $lE8gv.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $3ipAE.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $kOwiQ.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $66g0m.FormContext).Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $cg514.FormSubmitContext).Provider, {
            value: submitCount,
            children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $jLdno.IsDisabledContext).Provider, {
                value: isDisabled,
                children: childrenContent
            })
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $2cd40fd4a022a0e4$var$Form = (0, $g6DtW.default)($2cd40fd4a022a0e4$var$FormBase);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2cd40fd4a022a0e4$export$2e2bcd8739ae039 = $2cd40fd4a022a0e4$var$Form;

});
parcelRegister("5m9w2", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $3e666371aed14456$export$c52e5867d5879e24);
$parcel$export(module.exports, "createForm", () => $3e666371aed14456$export$f681a8129d2e9d28);

var $fisuc = parcelRequire("fisuc");

var $hW6d0 = parcelRequire("hW6d0");
//      
var $3e666371aed14456$var$charCodeOfDot = ".".charCodeAt(0);
var $3e666371aed14456$var$reEscapeChar = /\\(\\)?/g;
var $3e666371aed14456$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $3e666371aed14456$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $3e666371aed14456$var$charCodeOfDot) result.push("");
    string.replace($3e666371aed14456$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($3e666371aed14456$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $3e666371aed14456$var$keysCache = {};
var $3e666371aed14456$var$keysRegex = /[.[\]]+/;
var $3e666371aed14456$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($3e666371aed14456$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $3e666371aed14456$var$keysCache[key] = key.split($3e666371aed14456$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $3e666371aed14456$var$keysCache[key] = $3e666371aed14456$var$stringToPath(key);
    }
    return $3e666371aed14456$var$keysCache[key];
};
//      
var $3e666371aed14456$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $3e666371aed14456$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $3e666371aed14456$var$_toPropertyKey(arg) {
    var key = $3e666371aed14456$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $3e666371aed14456$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3e666371aed14456$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $hW6d0.default)(current, [
                key
            ].map($3e666371aed14456$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $fisuc.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $3e666371aed14456$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $3e666371aed14456$var$setInRecursor(state, 0, $3e666371aed14456$var$toPath(key), value1, destroyArrays);
};
var $3e666371aed14456$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $3e666371aed14456$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $3e666371aed14456$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $3e666371aed14456$export$c52e5867d5879e24(values, name);
    var error = $3e666371aed14456$export$c52e5867d5879e24(errors, name);
    if (error && error[$3e666371aed14456$export$735bebc8ffabf28a]) error = error[$3e666371aed14456$export$735bebc8ffabf28a];
    var submitError = submitErrors && $3e666371aed14456$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $3e666371aed14456$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($3e666371aed14456$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $3e666371aed14456$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $3e666371aed14456$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $3e666371aed14456$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$3e666371aed14456$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $3e666371aed14456$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $3e666371aed14456$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $3e666371aed14456$var$subscriptionFilter(result, state, previousState, subscription, $3e666371aed14456$export$41e855cb628c1b55, $3e666371aed14456$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $3e666371aed14456$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $3e666371aed14456$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $3e666371aed14456$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $3e666371aed14456$var$subscriptionFilter(result, state, previousState, subscription, $3e666371aed14456$export$f1ff97b9d1c7a3c3, $3e666371aed14456$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $3e666371aed14456$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$3e666371aed14456$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $3e666371aed14456$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $3e666371aed14456$export$83d89fbfd8236492 = "4.20.10";
var $3e666371aed14456$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $3e666371aed14456$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $3e666371aed14456$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $3e666371aed14456$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $3e666371aed14456$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $3e666371aed14456$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $3e666371aed14456$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $3e666371aed14456$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($3e666371aed14456$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $3e666371aed14456$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $fisuc.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $fisuc.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $3e666371aed14456$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $3e666371aed14456$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $fisuc.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $fisuc.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $fisuc.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $3e666371aed14456$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $3e666371aed14456$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $3e666371aed14456$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $3e666371aed14456$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $3e666371aed14456$export$e6bdf135a54e021b,
                    shallowEqual: $3e666371aed14456$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $fisuc.default)({}, state.formState.values)); // clone to avoid writing
            if ($3e666371aed14456$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($3e666371aed14456$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $3e666371aed14456$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $3e666371aed14456$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $fisuc.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $fisuc.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $3e666371aed14456$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $3e666371aed14456$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $3e666371aed14456$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$3e666371aed14456$export$735bebc8ffabf28a]) {
                    var existing = $3e666371aed14456$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$3e666371aed14456$export$735bebc8ffabf28a] = error[$3e666371aed14456$export$735bebc8ffabf28a];
                    merged = $3e666371aed14456$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$3e666371aed14456$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$3e666371aed14456$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $fisuc.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $3e666371aed14456$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $3e666371aed14456$var$notify(fieldSubscriber, fieldState, lastFieldState, $3e666371aed14456$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $3e666371aed14456$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $fisuc.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($3e666371aed14456$export$c52e5867d5879e24(formState.values, key), $3e666371aed14456$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($3e666371aed14456$export$c52e5867d5879e24(formState.values, key), $3e666371aed14456$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$3e666371aed14456$var$hasAnyError(formState.errors) && !(formState.submitErrors && $3e666371aed14456$var$hasAnyError(formState.submitErrors));
        var nextFormState = $3e666371aed14456$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $3e666371aed14456$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $3e666371aed14456$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $3e666371aed14456$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $3e666371aed14456$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $3e666371aed14456$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $3e666371aed14456$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $3e666371aed14456$var$notify(state.subscribers, nextFormState, lastFormState, $3e666371aed14456$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $fisuc.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($3e666371aed14456$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $fisuc.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $fisuc.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($3e666371aed14456$export$c52e5867d5879e24(formState.values, key), $3e666371aed14456$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $3e666371aed14456$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $3e666371aed14456$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $3e666371aed14456$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $3e666371aed14456$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $3e666371aed14456$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $3e666371aed14456$export$c52e5867d5879e24(state.formState.values, name) === $3e666371aed14456$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $3e666371aed14456$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $3e666371aed14456$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $3e666371aed14456$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $3e666371aed14456$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $3e666371aed14456$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $3e666371aed14456$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $fisuc.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $fisuc.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $fisuc.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $3e666371aed14456$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$3e666371aed14456$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $fisuc.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $3e666371aed14456$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $3e666371aed14456$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $3e666371aed14456$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $3e666371aed14456$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});
parcelRegister("hW6d0", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0ecab5e8481bc99$export$2e2bcd8739ae039);
function $d0ecab5e8481bc99$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("gcQod", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcc667cc8456dccf$export$2e2bcd8739ae039);

var $5m9w2 = parcelRequire("5m9w2");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $bcc667cc8456dccf$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $bcc667cc8456dccf$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($bcc667cc8456dccf$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $bcc667cc8456dccf$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $5m9w2.getIn)(errors, input.name);
    });
};
//      
var $bcc667cc8456dccf$var$noop = function noop() {};
var $bcc667cc8456dccf$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $bcc667cc8456dccf$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $bcc667cc8456dccf$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $bcc667cc8456dccf$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $bcc667cc8456dccf$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($bcc667cc8456dccf$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$bcc667cc8456dccf$export$2e2bcd8739ae039 = $bcc667cc8456dccf$var$createDecorator;

});

parcelRegister("3YySR", function(module, exports) {

var $7HdJI = parcelRequire("7HdJI");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $2e5208ec662dbcd0$var$set(object, path, value) {
    return object == null ? object : $7HdJI(object, path, value);
}
module.exports = $2e5208ec662dbcd0$var$set;

});
parcelRegister("7HdJI", function(module, exports) {

var $1dvdi = parcelRequire("1dvdi");

var $6ndtv = parcelRequire("6ndtv");

var $3c2Ts = parcelRequire("3c2Ts");

var $jNh0z = parcelRequire("jNh0z");

var $3en4C = parcelRequire("3en4C");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $59a73453276a6da1$var$baseSet(object, path, value, customizer) {
    if (!$jNh0z(object)) return object;
    path = $6ndtv(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $3en4C(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $jNh0z(objValue) ? objValue : $3c2Ts(path[index + 1]) ? [] : {};
        }
        $1dvdi(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $59a73453276a6da1$var$baseSet;

});
parcelRegister("1dvdi", function(module, exports) {

var $4kPgI = parcelRequire("4kPgI");

var $5wTnf = parcelRequire("5wTnf");
/** Used for built-in method references. */ var $0e2f37afc5c4a542$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0e2f37afc5c4a542$var$hasOwnProperty = $0e2f37afc5c4a542$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $0e2f37afc5c4a542$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($0e2f37afc5c4a542$var$hasOwnProperty.call(object, key) && $5wTnf(objValue, value)) || value === undefined && !(key in object)) $4kPgI(object, key, value);
}
module.exports = $0e2f37afc5c4a542$var$assignValue;

});
parcelRegister("4kPgI", function(module, exports) {

var $9bQMf = parcelRequire("9bQMf");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3280cc8cdb1d3de5$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $9bQMf) $9bQMf(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $3280cc8cdb1d3de5$var$baseAssignValue;

});
parcelRegister("9bQMf", function(module, exports) {

var $dEsDD = parcelRequire("dEsDD");
var $6b0e149b7da61e86$var$defineProperty = function() {
    try {
        var func = $dEsDD(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $6b0e149b7da61e86$var$defineProperty;

});
parcelRegister("dEsDD", function(module, exports) {

var $9ZppE = parcelRequire("9ZppE");

var $HUjje = parcelRequire("HUjje");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $9f0539c21f373652$var$getNative(object, key) {
    var value = $HUjje(object, key);
    return $9ZppE(value) ? value : undefined;
}
module.exports = $9f0539c21f373652$var$getNative;

});
parcelRegister("9ZppE", function(module, exports) {

var $jdiP6 = parcelRequire("jdiP6");

var $3WTA9 = parcelRequire("3WTA9");

var $jNh0z = parcelRequire("jNh0z");

var $jgGGQ = parcelRequire("jgGGQ");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $745d85fc03a17953$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $745d85fc03a17953$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $745d85fc03a17953$var$funcProto = Function.prototype, $745d85fc03a17953$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $745d85fc03a17953$var$funcToString = $745d85fc03a17953$var$funcProto.toString;
/** Used to check objects for own properties. */ var $745d85fc03a17953$var$hasOwnProperty = $745d85fc03a17953$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $745d85fc03a17953$var$reIsNative = RegExp('^' + $745d85fc03a17953$var$funcToString.call($745d85fc03a17953$var$hasOwnProperty).replace($745d85fc03a17953$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $745d85fc03a17953$var$baseIsNative(value) {
    if (!$jNh0z(value) || $3WTA9(value)) return false;
    var pattern = $jdiP6(value) ? $745d85fc03a17953$var$reIsNative : $745d85fc03a17953$var$reIsHostCtor;
    return pattern.test($jgGGQ(value));
}
module.exports = $745d85fc03a17953$var$baseIsNative;

});
parcelRegister("jdiP6", function(module, exports) {

var $dbGxT = parcelRequire("dbGxT");

var $jNh0z = parcelRequire("jNh0z");
/** `Object#toString` result references. */ var $dfcdd5218749cffd$var$asyncTag = '[object AsyncFunction]', $dfcdd5218749cffd$var$funcTag = '[object Function]', $dfcdd5218749cffd$var$genTag = '[object GeneratorFunction]', $dfcdd5218749cffd$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $dfcdd5218749cffd$var$isFunction(value) {
    if (!$jNh0z(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $dbGxT(value);
    return tag == $dfcdd5218749cffd$var$funcTag || tag == $dfcdd5218749cffd$var$genTag || tag == $dfcdd5218749cffd$var$asyncTag || tag == $dfcdd5218749cffd$var$proxyTag;
}
module.exports = $dfcdd5218749cffd$var$isFunction;

});
parcelRegister("dbGxT", function(module, exports) {

var $4AytH = parcelRequire("4AytH");

var $2EMkt = parcelRequire("2EMkt");

var $3qDs6 = parcelRequire("3qDs6");
/** `Object#toString` result references. */ var $999d4e1da2e35ad2$var$nullTag = '[object Null]', $999d4e1da2e35ad2$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $999d4e1da2e35ad2$var$symToStringTag = $4AytH ? $4AytH.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $999d4e1da2e35ad2$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $999d4e1da2e35ad2$var$undefinedTag : $999d4e1da2e35ad2$var$nullTag;
    return $999d4e1da2e35ad2$var$symToStringTag && $999d4e1da2e35ad2$var$symToStringTag in Object(value) ? $2EMkt(value) : $3qDs6(value);
}
module.exports = $999d4e1da2e35ad2$var$baseGetTag;

});
parcelRegister("4AytH", function(module, exports) {

var $dw2yO = parcelRequire("dw2yO");
/** Built-in value references. */ var $357544d22b52476c$var$Symbol = $dw2yO.Symbol;
module.exports = $357544d22b52476c$var$Symbol;

});
parcelRegister("dw2yO", function(module, exports) {

var $9vwGG = parcelRequire("9vwGG");
/** Detect free variable `self`. */ var $9d703ff9e22220e3$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9d703ff9e22220e3$var$root = $9vwGG || $9d703ff9e22220e3$var$freeSelf || Function('return this')();
module.exports = $9d703ff9e22220e3$var$root;

});
parcelRegister("9vwGG", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $6ec05d5e3aa6c3f5$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $6ec05d5e3aa6c3f5$var$freeGlobal;

});



parcelRegister("2EMkt", function(module, exports) {

var $4AytH = parcelRequire("4AytH");
/** Used for built-in method references. */ var $1ef4ce647def246b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1ef4ce647def246b$var$hasOwnProperty = $1ef4ce647def246b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1ef4ce647def246b$var$nativeObjectToString = $1ef4ce647def246b$var$objectProto.toString;
/** Built-in value references. */ var $1ef4ce647def246b$var$symToStringTag = $4AytH ? $4AytH.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $1ef4ce647def246b$var$getRawTag(value) {
    var isOwn = $1ef4ce647def246b$var$hasOwnProperty.call(value, $1ef4ce647def246b$var$symToStringTag), tag = value[$1ef4ce647def246b$var$symToStringTag];
    try {
        value[$1ef4ce647def246b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $1ef4ce647def246b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$1ef4ce647def246b$var$symToStringTag] = tag;
        else delete value[$1ef4ce647def246b$var$symToStringTag];
    }
    return result;
}
module.exports = $1ef4ce647def246b$var$getRawTag;

});

parcelRegister("3qDs6", function(module, exports) {
/** Used for built-in method references. */ var $27f26732ca251255$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $27f26732ca251255$var$nativeObjectToString = $27f26732ca251255$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $27f26732ca251255$var$objectToString(value) {
    return $27f26732ca251255$var$nativeObjectToString.call(value);
}
module.exports = $27f26732ca251255$var$objectToString;

});


parcelRegister("jNh0z", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e68fc965ccc7b578$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $e68fc965ccc7b578$var$isObject;

});


parcelRegister("3WTA9", function(module, exports) {

var $hWiNN = parcelRequire("hWiNN");
/** Used to detect methods masquerading as native. */ var $2e01e757f281e15c$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($hWiNN && $hWiNN.keys && $hWiNN.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $2e01e757f281e15c$var$isMasked(func) {
    return !!$2e01e757f281e15c$var$maskSrcKey && $2e01e757f281e15c$var$maskSrcKey in func;
}
module.exports = $2e01e757f281e15c$var$isMasked;

});
parcelRegister("hWiNN", function(module, exports) {

var $dw2yO = parcelRequire("dw2yO");
/** Used to detect overreaching core-js shims. */ var $d0f6702f56ceb632$var$coreJsData = $dw2yO["__core-js_shared__"];
module.exports = $d0f6702f56ceb632$var$coreJsData;

});


parcelRegister("jgGGQ", function(module, exports) {
/** Used for built-in method references. */ var $e070a0460172bbde$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $e070a0460172bbde$var$funcToString = $e070a0460172bbde$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $e070a0460172bbde$var$toSource(func) {
    if (func != null) {
        try {
            return $e070a0460172bbde$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $e070a0460172bbde$var$toSource;

});


parcelRegister("HUjje", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $083fb258d283ccf1$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $083fb258d283ccf1$var$getValue;

});




parcelRegister("5wTnf", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $406ae505c9cbee92$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $406ae505c9cbee92$var$eq;

});


parcelRegister("6ndtv", function(module, exports) {

var $949Z8 = parcelRequire("949Z8");

var $6GRly = parcelRequire("6GRly");

var $jdM04 = parcelRequire("jdM04");

var $1Wt1x = parcelRequire("1Wt1x");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $4a3f57ead3551fa2$var$castPath(value, object) {
    if ($949Z8(value)) return value;
    return $6GRly(value, object) ? [
        value
    ] : $jdM04($1Wt1x(value));
}
module.exports = $4a3f57ead3551fa2$var$castPath;

});
parcelRegister("949Z8", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $699c3b966358fd18$var$isArray = Array.isArray;
module.exports = $699c3b966358fd18$var$isArray;

});

parcelRegister("6GRly", function(module, exports) {

var $949Z8 = parcelRequire("949Z8");

var $cxw9U = parcelRequire("cxw9U");
/** Used to match property names within property paths. */ var $4df00bdb2d366ada$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $4df00bdb2d366ada$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $4df00bdb2d366ada$var$isKey(value, object) {
    if ($949Z8(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $cxw9U(value)) return true;
    return $4df00bdb2d366ada$var$reIsPlainProp.test(value) || !$4df00bdb2d366ada$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $4df00bdb2d366ada$var$isKey;

});
parcelRegister("cxw9U", function(module, exports) {

var $dbGxT = parcelRequire("dbGxT");

var $696Tm = parcelRequire("696Tm");
/** `Object#toString` result references. */ var $9211832efdd61de9$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $9211832efdd61de9$var$isSymbol(value) {
    return typeof value == 'symbol' || $696Tm(value) && $dbGxT(value) == $9211832efdd61de9$var$symbolTag;
}
module.exports = $9211832efdd61de9$var$isSymbol;

});
parcelRegister("696Tm", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4798edf486302ab4$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $4798edf486302ab4$var$isObjectLike;

});



parcelRegister("jdM04", function(module, exports) {

var $cvpos = parcelRequire("cvpos");
/** Used to match property names within property paths. */ var $dfe4771178449e34$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $dfe4771178449e34$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $dfe4771178449e34$var$stringToPath = $cvpos(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($dfe4771178449e34$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($dfe4771178449e34$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $dfe4771178449e34$var$stringToPath;

});
parcelRegister("cvpos", function(module, exports) {

var $frcwe = parcelRequire("frcwe");
/** Used as the maximum memoize cache size. */ var $91ac13e5dadda3b8$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $91ac13e5dadda3b8$var$memoizeCapped(func) {
    var result = $frcwe(func, function(key) {
        if (cache.size === $91ac13e5dadda3b8$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $91ac13e5dadda3b8$var$memoizeCapped;

});
parcelRegister("frcwe", function(module, exports) {

var $jQ70v = parcelRequire("jQ70v");
/** Error message constants. */ var $b3d316a46016bf52$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $b3d316a46016bf52$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($b3d316a46016bf52$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($b3d316a46016bf52$var$memoize.Cache || $jQ70v);
    return memoized;
}
// Expose `MapCache`.
$b3d316a46016bf52$var$memoize.Cache = $jQ70v;
module.exports = $b3d316a46016bf52$var$memoize;

});
parcelRegister("jQ70v", function(module, exports) {

var $aSjjh = parcelRequire("aSjjh");

var $czCdb = parcelRequire("czCdb");

var $iKiDj = parcelRequire("iKiDj");

var $c504N = parcelRequire("c504N");

var $1uFBJ = parcelRequire("1uFBJ");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e7184f1ed209d554$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$e7184f1ed209d554$var$MapCache.prototype.clear = $aSjjh;
$e7184f1ed209d554$var$MapCache.prototype['delete'] = $czCdb;
$e7184f1ed209d554$var$MapCache.prototype.get = $iKiDj;
$e7184f1ed209d554$var$MapCache.prototype.has = $c504N;
$e7184f1ed209d554$var$MapCache.prototype.set = $1uFBJ;
module.exports = $e7184f1ed209d554$var$MapCache;

});
parcelRegister("aSjjh", function(module, exports) {

var $Tc2SG = parcelRequire("Tc2SG");

var $jy1KT = parcelRequire("jy1KT");

var $kwYi9 = parcelRequire("kwYi9");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7eaded17d5ecadc5$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $Tc2SG,
        'map': new ($kwYi9 || $jy1KT),
        'string': new $Tc2SG
    };
}
module.exports = $7eaded17d5ecadc5$var$mapCacheClear;

});
parcelRegister("Tc2SG", function(module, exports) {

var $gdCVi = parcelRequire("gdCVi");

var $g0JOU = parcelRequire("g0JOU");

var $57Xqj = parcelRequire("57Xqj");

var $ivDVM = parcelRequire("ivDVM");

var $jJATC = parcelRequire("jJATC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0a5e7b25d0ff01d1$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$0a5e7b25d0ff01d1$var$Hash.prototype.clear = $gdCVi;
$0a5e7b25d0ff01d1$var$Hash.prototype['delete'] = $g0JOU;
$0a5e7b25d0ff01d1$var$Hash.prototype.get = $57Xqj;
$0a5e7b25d0ff01d1$var$Hash.prototype.has = $ivDVM;
$0a5e7b25d0ff01d1$var$Hash.prototype.set = $jJATC;
module.exports = $0a5e7b25d0ff01d1$var$Hash;

});
parcelRegister("gdCVi", function(module, exports) {

var $abQ5h = parcelRequire("abQ5h");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $bcec0d8c84abb380$var$hashClear() {
    this.__data__ = $abQ5h ? $abQ5h(null) : {};
    this.size = 0;
}
module.exports = $bcec0d8c84abb380$var$hashClear;

});
parcelRegister("abQ5h", function(module, exports) {

var $dEsDD = parcelRequire("dEsDD");
/* Built-in method references that are verified to be native. */ var $76b3554d24f33e79$var$nativeCreate = $dEsDD(Object, 'create');
module.exports = $76b3554d24f33e79$var$nativeCreate;

});


parcelRegister("g0JOU", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ba803054a538df03$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $ba803054a538df03$var$hashDelete;

});

parcelRegister("57Xqj", function(module, exports) {

var $abQ5h = parcelRequire("abQ5h");
/** Used to stand-in for `undefined` hash values. */ var $3bbbb37588ff9d58$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $3bbbb37588ff9d58$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3bbbb37588ff9d58$var$hasOwnProperty = $3bbbb37588ff9d58$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3bbbb37588ff9d58$var$hashGet(key) {
    var data = this.__data__;
    if ($abQ5h) {
        var result = data[key];
        return result === $3bbbb37588ff9d58$var$HASH_UNDEFINED ? undefined : result;
    }
    return $3bbbb37588ff9d58$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $3bbbb37588ff9d58$var$hashGet;

});

parcelRegister("ivDVM", function(module, exports) {

var $abQ5h = parcelRequire("abQ5h");
/** Used for built-in method references. */ var $d79a18ae8229aae7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d79a18ae8229aae7$var$hasOwnProperty = $d79a18ae8229aae7$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d79a18ae8229aae7$var$hashHas(key) {
    var data = this.__data__;
    return $abQ5h ? data[key] !== undefined : $d79a18ae8229aae7$var$hasOwnProperty.call(data, key);
}
module.exports = $d79a18ae8229aae7$var$hashHas;

});

parcelRegister("jJATC", function(module, exports) {

var $abQ5h = parcelRequire("abQ5h");
/** Used to stand-in for `undefined` hash values. */ var $e5ded710cb76d293$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $e5ded710cb76d293$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $abQ5h && value === undefined ? $e5ded710cb76d293$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $e5ded710cb76d293$var$hashSet;

});


parcelRegister("jy1KT", function(module, exports) {

var $13z8E = parcelRequire("13z8E");

var $11yXz = parcelRequire("11yXz");

var $f9eVE = parcelRequire("f9eVE");

var $2MrF7 = parcelRequire("2MrF7");

var $iJBA0 = parcelRequire("iJBA0");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e3b28ddc8ca636b5$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$e3b28ddc8ca636b5$var$ListCache.prototype.clear = $13z8E;
$e3b28ddc8ca636b5$var$ListCache.prototype['delete'] = $11yXz;
$e3b28ddc8ca636b5$var$ListCache.prototype.get = $f9eVE;
$e3b28ddc8ca636b5$var$ListCache.prototype.has = $2MrF7;
$e3b28ddc8ca636b5$var$ListCache.prototype.set = $iJBA0;
module.exports = $e3b28ddc8ca636b5$var$ListCache;

});
parcelRegister("13z8E", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $0c51541035107425$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $0c51541035107425$var$listCacheClear;

});

parcelRegister("11yXz", function(module, exports) {

var $as6eR = parcelRequire("as6eR");
/** Used for built-in method references. */ var $0bf100bb9158911b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $0bf100bb9158911b$var$splice = $0bf100bb9158911b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0bf100bb9158911b$var$listCacheDelete(key) {
    var data = this.__data__, index = $as6eR(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $0bf100bb9158911b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $0bf100bb9158911b$var$listCacheDelete;

});
parcelRegister("as6eR", function(module, exports) {

var $5wTnf = parcelRequire("5wTnf");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $79c15bce47f9c7de$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($5wTnf(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $79c15bce47f9c7de$var$assocIndexOf;

});


parcelRegister("f9eVE", function(module, exports) {

var $as6eR = parcelRequire("as6eR");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b07346dae209a173$var$listCacheGet(key) {
    var data = this.__data__, index = $as6eR(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b07346dae209a173$var$listCacheGet;

});

parcelRegister("2MrF7", function(module, exports) {

var $as6eR = parcelRequire("as6eR");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2065859f8ae86d98$var$listCacheHas(key) {
    return $as6eR(this.__data__, key) > -1;
}
module.exports = $2065859f8ae86d98$var$listCacheHas;

});

parcelRegister("iJBA0", function(module, exports) {

var $as6eR = parcelRequire("as6eR");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $da399480cea12d06$var$listCacheSet(key, value) {
    var data = this.__data__, index = $as6eR(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $da399480cea12d06$var$listCacheSet;

});


parcelRegister("kwYi9", function(module, exports) {

var $dEsDD = parcelRequire("dEsDD");

var $dw2yO = parcelRequire("dw2yO");
/* Built-in method references that are verified to be native. */ var $ef25907c2169f649$var$Map = $dEsDD($dw2yO, 'Map');
module.exports = $ef25907c2169f649$var$Map;

});


parcelRegister("czCdb", function(module, exports) {

var $eN8cO = parcelRequire("eN8cO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $927664ef902afec3$var$mapCacheDelete(key) {
    var result = $eN8cO(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $927664ef902afec3$var$mapCacheDelete;

});
parcelRegister("eN8cO", function(module, exports) {

var $2RniB = parcelRequire("2RniB");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ac4c01c3bd7f4358$var$getMapData(map, key) {
    var data = map.__data__;
    return $2RniB(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $ac4c01c3bd7f4358$var$getMapData;

});
parcelRegister("2RniB", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $21529ab384c5d0d2$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $21529ab384c5d0d2$var$isKeyable;

});



parcelRegister("iKiDj", function(module, exports) {

var $eN8cO = parcelRequire("eN8cO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $da5afa07f3e161b2$var$mapCacheGet(key) {
    return $eN8cO(this, key).get(key);
}
module.exports = $da5afa07f3e161b2$var$mapCacheGet;

});

parcelRegister("c504N", function(module, exports) {

var $eN8cO = parcelRequire("eN8cO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8cb602d63b31cc48$var$mapCacheHas(key) {
    return $eN8cO(this, key).has(key);
}
module.exports = $8cb602d63b31cc48$var$mapCacheHas;

});

parcelRegister("1uFBJ", function(module, exports) {

var $eN8cO = parcelRequire("eN8cO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $1168de33284aebf4$var$mapCacheSet(key, value) {
    var data = $eN8cO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $1168de33284aebf4$var$mapCacheSet;

});





parcelRegister("1Wt1x", function(module, exports) {

var $lYtdw = parcelRequire("lYtdw");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $16a1b8c20232c390$var$toString(value) {
    return value == null ? '' : $lYtdw(value);
}
module.exports = $16a1b8c20232c390$var$toString;

});
parcelRegister("lYtdw", function(module, exports) {

var $4AytH = parcelRequire("4AytH");

var $3vtBO = parcelRequire("3vtBO");

var $949Z8 = parcelRequire("949Z8");

var $cxw9U = parcelRequire("cxw9U");
/** Used as references for various `Number` constants. */ var $fff5dd797dcd7b42$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $fff5dd797dcd7b42$var$symbolProto = $4AytH ? $4AytH.prototype : undefined, $fff5dd797dcd7b42$var$symbolToString = $fff5dd797dcd7b42$var$symbolProto ? $fff5dd797dcd7b42$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $fff5dd797dcd7b42$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($949Z8(value)) // Recursively convert values (susceptible to call stack limits).
    return $3vtBO(value, $fff5dd797dcd7b42$var$baseToString) + '';
    if ($cxw9U(value)) return $fff5dd797dcd7b42$var$symbolToString ? $fff5dd797dcd7b42$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$fff5dd797dcd7b42$var$INFINITY ? '-0' : result;
}
module.exports = $fff5dd797dcd7b42$var$baseToString;

});
parcelRegister("3vtBO", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $28db3c0e1cc2044d$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $28db3c0e1cc2044d$var$arrayMap;

});




parcelRegister("3c2Ts", function(module, exports) {
/** Used as references for various `Number` constants. */ var $2534bcaf758f24ae$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $2534bcaf758f24ae$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $2534bcaf758f24ae$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $2534bcaf758f24ae$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $2534bcaf758f24ae$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $2534bcaf758f24ae$var$isIndex;

});

parcelRegister("3en4C", function(module, exports) {

var $cxw9U = parcelRequire("cxw9U");
/** Used as references for various `Number` constants. */ var $25a493d4a923a661$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $25a493d4a923a661$var$toKey(value) {
    if (typeof value == 'string' || $cxw9U(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$25a493d4a923a661$var$INFINITY ? '-0' : result;
}
module.exports = $25a493d4a923a661$var$toKey;

});



parcelRegister("g6DtW", function(module, exports) {
$parcel$export(module.exports, "default", () => $1463b7b43b25d6f8$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $1463b7b43b25d6f8$export$2e2bcd8739ae039 = (0, $lE8gv.forwardRef);

});

parcelRegister("gAmJs", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $2e0ace6f662c8ea3$export$fc06342dc8588d3b);

var $5m9w2 = parcelRequire("5m9w2");
const $2e0ace6f662c8ea3$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $5m9w2.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $5m9w2.getIn)(errors, input.name);
    });
};

});


parcelRegister("cwRZg", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $713d814a8809a96f$export$27c701ed9e449e99);
/* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ /* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $adpJV = parcelRequire("adpJV");

var $lC4HT = parcelRequire("lC4HT");

var $brALg = parcelRequire("brALg");

var $6esjp = parcelRequire("6esjp");

var $dMSHp = parcelRequire("dMSHp");

var $3MutS = parcelRequire("3MutS");
const $713d814a8809a96f$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
const $713d814a8809a96f$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $lE8gv.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $6esjp.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $lE8gv.useContext)((0, $dMSHp.default));
    const handleClick = (0, $lE8gv.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $lC4HT.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $3MutS.Focusable), {
        // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
        as: "button",
        // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $brALg.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $adpJV.cx)($713d814a8809a96f$var$styles.root, isDisabled && $713d814a8809a96f$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});

});
parcelRegister("brALg", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $3391aed8b1500eee$export$95df08bae54cb4df);
function $3391aed8b1500eee$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("3MutS", function(module, exports) {
$parcel$export(module.exports, "Focusable", () => $c967913dc70ce2d8$export$35a3bebf7ef2d934);
/* focusable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $c967913dc70ce2d8$var$focusRingStyles = null;
const $c967913dc70ce2d8$var$insetFocusRingStyles = null;
const $c967913dc70ce2d8$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $lE8gv.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $kOwiQ.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $l2NkF.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});

});


parcelRegister("7eBEg", function(module, exports) {
$parcel$export(module.exports, "default", () => $a12e5d0bd87a712d$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $ddJ2b = parcelRequire("ddJ2b");

var $knsAY = parcelRequire("knsAY");

var $0QaiM = parcelRequire("0QaiM");
const $a12e5d0bd87a712d$var$buttonsContainerStyles = null;
const $a12e5d0bd87a712d$var$buttonWrapperBaseStyles = null;
const $a12e5d0bd87a712d$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>/*#__PURE__*/ (0, $kOwiQ.jsxs)("div", {
        className: (0, $l2NkF.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
                tabIndex: -1,
                className: (0, $l2NkF.default)([
                    "_2rko1qi0 _11c8fhey _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs130s _1mpy1b66 _1nlx1bhr _l2uv6o2t _7mfvm8nx _szlbi7uo"
                ]),
                children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $ddJ2b.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($knsAY))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
                tabIndex: -1,
                className: (0, $l2NkF.default)([
                    "_2rko1qi0 _11c8fhey _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs130s _1mpy1b66 _1nlx1bhr _l2uv6o2t _7mfvm8nx _szlbi7uo"
                ]),
                children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $ddJ2b.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0QaiM))), {
                            ...iconProps,
                            size: "small"
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a12e5d0bd87a712d$export$2e2bcd8739ae039 = $a12e5d0bd87a712d$var$Buttons;

});
parcelRegister("ddJ2b", function(module, exports) {
$parcel$export(module.exports, "default", () => $04d4123367646736$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $3ipAE = parcelRequire("3ipAE");

var $cwHM5 = parcelRequire("cwHM5");

var $kagwH = parcelRequire("kagwH");

var $bheDP = parcelRequire("bheDP");

var $FibV7 = parcelRequire("FibV7");

var $kQVzY = parcelRequire("kQVzY");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $04d4123367646736$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $bheDP.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $FibV7.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kQVzY.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kagwH.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $cwHM5.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: tooltip?.hasNewContentOnTriggerClick,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        shortcut: tooltip?.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $kOwiQ.jsx)((0, $bheDP.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $3ipAE.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $FibV7.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kQVzY.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kagwH.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$04d4123367646736$var$IconButton.displayName = 'IconButton';
var $04d4123367646736$export$2e2bcd8739ae039 = $04d4123367646736$var$IconButton;

});
parcelRegister("cwHM5", function(module, exports) {
$parcel$export(module.exports, "default", () => $d890f612b6a1619f$export$2e2bcd8739ae039);
/* tooltip.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $5Ifxs = parcelRequire("5Ifxs");

var $8qXPU = parcelRequire("8qXPU");

var $3ipAE = parcelRequire("3ipAE");

var $6esjp = parcelRequire("6esjp");

var $l2iS7 = parcelRequire("l2iS7");

var $72WFF = parcelRequire("72WFF");

var $nV5wS = parcelRequire("nV5wS");

var $jZj0v = parcelRequire("jZj0v");

var $d4GDb = parcelRequire("d4GDb");

var $fBWTV = parcelRequire("fBWTV");

var $amLEq = parcelRequire("amLEq");

var $92sXA = parcelRequire("92sXA");

var $4zhbd = parcelRequire("4zhbd");

var $3xsJK = parcelRequire("3xsJK");

var $h1jDZ = parcelRequire("h1jDZ");

var $9AktP = parcelRequire("9AktP");

var $5oW0N = parcelRequire("5oW0N");

var $gF5jn = parcelRequire("gF5jn");

var $0399H = parcelRequire("0399H");

var $8mTwD = parcelRequire("8mTwD");

var $hwbeJ = parcelRequire("hwbeJ");

var $89KrN = parcelRequire("89KrN");

var $kra7p = parcelRequire("kra7p");

var $iaiIy = parcelRequire("iaiIy");
const $d890f612b6a1619f$var$tooltipZIndex = (0, $4zhbd.layers).tooltip();
const $d890f612b6a1619f$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: undefined,
    packageVersion: undefined
};
// Inverts motion direction
const $d890f612b6a1619f$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $d890f612b6a1619f$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
 * gate is off, so this cannot affect the legacy path even if it gains a caller
 * there.
 *
 * `mouseover` also fires when the pointer crosses boundaries between elements
 * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
 * distinguishes a real re-entry from one of those.
 */ function $d890f612b6a1619f$var$isTopLayerPointerReEntry({ trigger: trigger, relatedTarget: relatedTarget }) {
    if (!(0, $fBWTV.fg)('platform-dst-top-layer-tooltip')) return false;
    // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $d890f612b6a1619f$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, component: Container = (0, $iaiIy.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $6esjp.default), onHide: onHide = (0, $6esjp.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut, shouldAlwaysFadeIn: shouldAlwaysFadeIn = false, shouldRenderToParent: shouldRenderToParent = false }) {
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position;
    // The deprecated hide props win over `hasNewContentOnTriggerClick`, as the prop
    // docs say. Setting both is a mistake, so keep the older behaviour. Read only
    // together with `platform-dst-top-layer-tooltip`; without the gate a press
    // never closes.
    const isStayOpenOnTriggerClick = hasNewContentOnTriggerClick && !hideTooltipOnClick && !hideTooltipOnMouseDown;
    const onShowHandler = (0, $8qXPU.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$d890f612b6a1619f$var$analyticsAttributes
    });
    const onHideHandler = (0, $8qXPU.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$d890f612b6a1619f$var$analyticsAttributes
    });
    const apiRef = (0, $lE8gv.useRef)(null);
    const [state, setState] = (0, $lE8gv.useState)('hide');
    const targetRef = (0, $lE8gv.useRef)(null);
    const containerRef = (0, $lE8gv.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $lE8gv.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $72WFF.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $72WFF.default)(onShowHandler);
    const onHideHandlerStable = (0, $72WFF.default)(onHideHandler);
    const delayStable = (0, $72WFF.default)(delay);
    const canAppearStable = (0, $72WFF.default)(canAppear);
    const hasCalledShowHandler = (0, $lE8gv.useRef)(false);
    const shouldAlwaysFadeInStable = (0, $72WFF.default)(shouldAlwaysFadeIn);
    const start = (0, $lE8gv.useCallback)((api)=>{
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $lE8gv.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $lE8gv.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $lE8gv.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $lE8gv.useRef)(false);
    (0, $lE8gv.useEffect)(()=>{
        return (0, $0399H.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    // Set while a pointer press has dismissed the tooltip. Every read and write is
    // behind `platform-dst-top-layer-tooltip`, where `popover="hint"` owns pointer
    // dismissal, so the legacy path never sees this.
    const isTopLayerPointerDismissedRef = (0, $lE8gv.useRef)(false);
    const tryShowTooltip = (0, $lE8gv.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Stay dismissed until the trigger is re-entered or blurred. Otherwise
     * light dismiss hides on pointerup and the next `mouseover` from a
     * boundary crossing inside the trigger re-shows it. Deliberately after
     * the "already active" branch, so a held press stays visible.
     */ if (isTopLayerPointerDismissedRef.current && (0, $fBWTV.fg)('platform-dst-top-layer-tooltip')) return;
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else if ((0, $fBWTV.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        const api = (0, $89KrN.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, $lE8gv.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="hint" handles Escape natively
    (0, $l2iS7.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $fBWTV.fg)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    const handleExitFinish = (0, $lE8gv.useCallback)(()=>{
        apiRef.current?.finishHideAnimation();
    }, []);
    // Browser dismiss (light dismiss on pointerup, or Escape). Recorded so we stay
    // hidden until the trigger is re-entered. Only wired up on the top-layer path,
    // but gated anyway to keep every use of the ref flag-checked.
    const handlePopoverClose = (0, $lE8gv.useCallback)(()=>{
        if ((0, $fBWTV.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $lE8gv.useEffect)(()=>{
        if (state === 'hide') return 0, $6esjp.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $5Ifxs.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $lE8gv.useCallback)(()=>{
        // `hasNewContentOnTriggerClick`: `TopLayerTooltipPopup` re-shows the popover
        // after the light dismiss, so there is nothing to record, and a pending
        // show goes ahead with the new content, as it does without the gate.
        if (isStayOpenOnTriggerClick && (0, $fBWTV.fg)('platform-dst-top-layer-tooltip')) return;
        // Native light dismiss hides on pointerup, not here. Recorded now so the
        // tooltip stays dismissed afterwards.
        if ((0, $fBWTV.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        const shouldCancelPendingShow = stableState.current === 'hide' && (0, $fBWTV.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        isStayOpenOnTriggerClick,
        stableState
    ]);
    const onClick = (0, $lE8gv.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $lE8gv.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Re-arm on a real re-entry, not on a boundary crossing inside the trigger.
        if ($d890f612b6a1619f$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $fBWTV.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        const source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $lE8gv.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    const onMouseOverTooltip = (0, $lE8gv.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $lE8gv.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch  {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $lE8gv.useCallback)(()=>{
        // Focus leaving ends the dismissal, so focus coming back can show the tooltip.
        if ((0, $fBWTV.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $lE8gv.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    const handleOpenLayerObserverCloseSignal = (0, $lE8gv.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    // Called unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path a tooltip is not a layer (open layer
    // checks skip tooltips), so it does not register with the observer.
    (0, $nV5wS.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        isEnabled: !(0, $fBWTV.fg)('platform-dst-top-layer-tooltip'),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (isMousePosition && apiRef.current?.mousePos && targetRef.current) return (0, $hwbeJ.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $kra7p.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $lE8gv.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    const PopperWrapper = shouldRenderToParent ? (0, $lE8gv.Fragment) : $d890f612b6a1619f$var$TooltipPortal;
    const trigger = typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lE8gv.Fragment), {
        children: [
            children({
                ...tooltipTriggerProps,
                // `testId` propagates to the trigger element so `data-testid` lands in the
                // rendered DOM. Required because `@atlaskit/button/new` (and other Pressable-
                // backed primitives) overwrite `data-testid` from spread; passing a typed
                // `testId` lets their own destructure pick it up directly.
                ...testId ? {
                    testId: `${testId}--container`
                } : {},
                'aria-describedby': tooltipIdForHiddenContent,
                ref: setDirectRef
            }),
            hiddenContent
        ]
    }) : /*#__PURE__*/ (0, $kOwiQ.jsxs)(CastTargetContainer, {
        ...tooltipTriggerProps,
        ...testId ? {
            'data-testid': `${testId}--container`
        } : undefined,
        ref: setImplicitRefFromChildren,
        /**
   * TODO: Why is role="presentation" added?
   * - Is it only to "remove" the `Container` from screen readers?
   * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
   * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
   */ role: "presentation",
        children: [
            children,
            hiddenContent
        ]
    });
    if ((0, $fBWTV.fg)('platform-dst-top-layer-tooltip')) return /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lE8gv.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $kOwiQ.jsx)($d890f612b6a1619f$var$TopLayerTooltipPopup, {
                targetRef: targetRef,
                tooltipPosition: tooltipPosition,
                mousePos: apiRef.current?.mousePos ?? undefined,
                position: position,
                onMouseOut: onMouseOut,
                onMouseOverTooltip: onMouseOverTooltip,
                ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
                truncate: truncate,
                testId: testId,
                shortcut: shortcut,
                content: content,
                Container: Container,
                onClose: handlePopoverClose,
                shouldStayOpenOnTriggerClick: isStayOpenOnTriggerClick,
                onExitFinish: handleExitFinish,
                isOpen: state !== 'hide' && state !== 'top-layer-exit'
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $lE8gv.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $kOwiQ.jsx)(PopperWrapper, {
                children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $amLEq.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        const direction = isMousePosition ? undefined : $d890f612b6a1619f$var$invertedDirection[$d890f612b6a1619f$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $jZj0v.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $d4GDb.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $kOwiQ.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
var $d890f612b6a1619f$export$2e2bcd8739ae039 = $d890f612b6a1619f$var$Tooltip;
const $d890f612b6a1619f$var$TooltipPortal = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $92sXA.default), {
        zIndex: $d890f612b6a1619f$var$tooltipZIndex,
        children: children
    });
};
const $d890f612b6a1619f$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with two positioning
 * hooks, of which EXACTLY ONE is enabled - two writing to the same popover would
 * fight for ownership, so `isEnabled` is derived from one boolean and negated:
 *
 *   - `useAnchoredPopoverAtPoint` for cursor-tracking positions (`mouse`,
 *     `mouse-x`, `mouse-y`) activated by a pointer.
 *   - `useAnchoredPopover` for everything else, including a cursor position
 *     activated via keyboard focus, where there is no cursor to track and
 *     anchoring to the trigger is what keeps the tooltip beside the target.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $d890f612b6a1619f$var$TopLayerTooltipPopup({ targetRef: targetRef, tooltipPosition: tooltipPosition, mousePos: mousePos, position: position, onMouseOut: onMouseOut, onMouseOverTooltip: onMouseOverTooltip, ignoreTooltipPointerEvents: ignoreTooltipPointerEvents, truncate: truncate, testId: testId, shortcut: shortcut, content: content, Container: Container, onClose: onClose, onExitFinish: onExitFinish, isOpen: isOpen, shouldStayOpenOnTriggerClick: shouldStayOpenOnTriggerClick }) {
    const popoverRef = (0, $lE8gv.useRef)(null);
    // Never read. Some custom `component` wrappers render nothing without a ref.
    const containerRef = (0, $lE8gv.useRef)(null);
    // The host unmounts on close and remounts on open, so set `data-placement`
    // whenever a node attaches, as well as when the placement changes.
    const setPopoverNode = (0, $lE8gv.useCallback)((node)=>{
        node?.setAttribute('data-placement', tooltipPosition);
    }, [
        tooltipPosition
    ]);
    const hostRef = (0, $3ipAE.default)([
        popoverRef,
        setPopoverNode
    ]);
    // `shouldStayOpenOnTriggerClick`: a press on the trigger light-dismisses the hint
    // popover, and the browser gives no way to cancel that. The dismiss runs
    // before the `pointerup` is dispatched, so show the popover again from the
    // trigger's `pointerup`. It is the same task, so no closed frame is painted,
    // the entry transition does not restart, and the `toggle` events coalesce
    // to open -> open, so `onClose` is not called. `mouseup` covers
    // environments that dismiss on `mouseup` too, such as the test polyfill.
    // `showPopover()` does nothing when the popover is already open. A layout
    // effect, so the listener is gone in the same commit that closes the
    // popover: a passive cleanup runs later, and a `pointerup` in that gap would
    // re-open a closing tooltip.
    (0, $lE8gv.useLayoutEffect)(()=>{
        const trigger = targetRef.current;
        if (!shouldStayOpenOnTriggerClick || !isOpen || !trigger) return;
        const reshow = ()=>{
            try {
                popoverRef.current?.showPopover();
            } catch  {}
        };
        return (0, $5Ifxs.bindAll)(trigger, [
            {
                type: 'pointerup',
                listener: reshow
            },
            {
                type: 'mouseup',
                listener: reshow
            }
        ]);
    }, [
        shouldStayOpenOnTriggerClick,
        isOpen,
        targetRef
    ]);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to the hook and
    // to `Popover`.
    const placement = (0, $3xsJK.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    const isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    const isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // One object so the two calls cannot drift on `placement` or `isOpen`.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: placement,
        isOpen: isOpen
    };
    (0, $9AktP.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: targetRef,
        isEnabled: !isMouseStrategyActive
    });
    // `getPoint()` is latched once per activation, which is per-show here because
    // `TopLayerTooltipPopup` mounts fresh on every show. `null` before the trigger
    // has mounted applies no positioning at all.
    (0, $5oW0N.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isMouseStrategyActive,
        getPoint: ()=>{
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $8mTwD.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $h1jDZ.Popover), {
        ref: hostRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? `${testId}--popover` : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $d890f612b6a1619f$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $d890f612b6a1619f$var$tooltipMouseAnimationStyles.exit,
        placement: placement,
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $gF5jn.DefaultRoleContext).Provider, {
            value: "presentation",
            children: /*#__PURE__*/ (0, $kOwiQ.jsx)(Container, {
                ref: containerRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- top-layer spike
                className: "Tooltip",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- top-layer spike
                style: ignoreTooltipPointerEvents ? {
                    pointerEvents: 'none'
                } : undefined,
                truncate: truncate,
                placement: tooltipPosition,
                testId: testId,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut,
                children: typeof content === 'function' ? content({
                    update: (0, $6esjp.default)
                }) : content
            })
        })
    });
}

});
parcelRegister("8qXPU", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $ccc35820056eee84$export$1a04351537078b55);

var $lE8gv = parcelRequire("lE8gv");

var $3p8Bc = parcelRequire("3p8Bc");

var $2gQ9a = parcelRequire("2gQ9a");
function $ccc35820056eee84$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $3p8Bc.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $2gQ9a.useTrackedRef)(analyticsData);
    const fnRef = (0, $2gQ9a.useTrackedRef)(fn);
    const handler = (0, $lE8gv.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("l2iS7", function(module, exports) {
$parcel$export(module.exports, "default", () => $61e6a6c71f69659e$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");

var $5Ifxs = parcelRequire("5Ifxs");

var $fgGie = parcelRequire("fgGie");
function $61e6a6c71f69659e$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $lE8gv.useRef)(false);
    const onKeyDown = (0, $lE8gv.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $fgGie.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $lE8gv.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $lE8gv.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $5Ifxs.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("fgGie", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", () => $ffce8470e0eb0b63$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $ffce8470e0eb0b63$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_LEFT", () => $ffce8470e0eb0b63$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $ffce8470e0eb0b63$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_HOME", () => $ffce8470e0eb0b63$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $ffce8470e0eb0b63$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $ffce8470e0eb0b63$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $ffce8470e0eb0b63$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $ffce8470e0eb0b63$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $ffce8470e0eb0b63$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ const $ffce8470e0eb0b63$export$390330c10ff2b9a1 = 'ArrowUp';
const $ffce8470e0eb0b63$export$a80636c6f41931fe = 'ArrowDown';
const $ffce8470e0eb0b63$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $ffce8470e0eb0b63$export$c40f9845adc73fb5 = 'ArrowRight';
const $ffce8470e0eb0b63$export$4af703091671bc = 'Home';
const $ffce8470e0eb0b63$export$e2bc30913faa5db7 = 'End';
const $ffce8470e0eb0b63$export$10f6869ed0a7d75b = 'Tab';
const $ffce8470e0eb0b63$export$8152f929a25a0ff4 = 'Enter';
const $ffce8470e0eb0b63$export$e51a3576c045c8d5 = 'Space';
const $ffce8470e0eb0b63$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("72WFF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cf2c7d9c3d2f70b$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");
function $1cf2c7d9c3d2f70b$export$2e2bcd8739ae039(value) {
    const ref = (0, $lE8gv.useRef)(value);
    (0, $lE8gv.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("nV5wS", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $cf6edf2a1b99085a$export$469bb693f11edc7f);

var $lE8gv = parcelRequire("lE8gv");

var $kTfJ0 = parcelRequire("kTfJ0");

var $5orv7 = parcelRequire("5orv7");
function $cf6edf2a1b99085a$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose, isEnabled: isEnabled = true }) {
    const context = (0, $lE8gv.useContext)((0, $kTfJ0.OpenLayerObserverContext));
    const namespace = (0, $5orv7.useOpenLayerObserverNamespace)();
    (0, $lE8gv.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (context === null || !isEnabled) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isEnabled,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("kTfJ0", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $61e46a2462aa008c$export$5fbf4d7fae6cdc00);

var $lE8gv = parcelRequire("lE8gv");
const $61e46a2462aa008c$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $lE8gv.createContext)(null);

});

parcelRegister("5orv7", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $ef5326f1e4904bc4$export$1d57e79091cc3046);

var $lE8gv = parcelRequire("lE8gv");

var $a2OCI = parcelRequire("a2OCI");
function $ef5326f1e4904bc4$export$1d57e79091cc3046() {
    const namespace = (0, $lE8gv.useContext)((0, $a2OCI.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("a2OCI", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $46d7576a27bdf1fc$export$644a49f3b8c50fcd);

var $lE8gv = parcelRequire("lE8gv");
const $46d7576a27bdf1fc$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $lE8gv.createContext)(null);

});



parcelRegister("d4GDb", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b9298458b66b5ae$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $ddx3E = parcelRequire("ddx3E");
const $8b9298458b66b5ae$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $8b9298458b66b5ae$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $8b9298458b66b5ae$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $ddx3E.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $8b9298458b66b5ae$export$2e2bcd8739ae039 = $8b9298458b66b5ae$var$FadeIn;

});
parcelRegister("ddx3E", function(module, exports) {
$parcel$export(module.exports, "default", () => $9548b6d5522645cf$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $b28gO = parcelRequire("b28gO");

var $1hShM = parcelRequire("1hShM");

var $1Jmmk = parcelRequire("1Jmmk");

var $bpOeK = parcelRequire("bpOeK");

var $9qQWw = parcelRequire("9qQWw");

var $7EYFw = parcelRequire("7EYFw");
const $9548b6d5522645cf$var$zoomIn = null;
const $9548b6d5522645cf$var$zoomOut = null;
const $9548b6d5522645cf$var$fadeIn = null;
const $9548b6d5522645cf$var$fadeOut = null;
const $9548b6d5522645cf$var$fadeInFromTop = null;
const $9548b6d5522645cf$var$fadeOutFromTop = null;
const $9548b6d5522645cf$var$fadeInFromLeft = null;
const $9548b6d5522645cf$var$fadeOutFromLeft = null;
const $9548b6d5522645cf$var$fadeInFromBottom = null;
const $9548b6d5522645cf$var$fadeOutFromBottom = null;
const $9548b6d5522645cf$var$fadeInFromRight = null;
const $9548b6d5522645cf$var$fadeOutFromRight = null;
const $9548b6d5522645cf$var$fadeInFromTopConstant = null;
const $9548b6d5522645cf$var$fadeOutFromTopConstant = null;
const $9548b6d5522645cf$var$fadeInFromLeftConstant = null;
const $9548b6d5522645cf$var$fadeOutFromLeftConstant = null;
const $9548b6d5522645cf$var$fadeInFromBottomConstant = null;
const $9548b6d5522645cf$var$fadeOutFromBottomConstant = null;
const $9548b6d5522645cf$var$fadeInFromRightConstant = null;
const $9548b6d5522645cf$var$fadeOutFromRightConstant = null;
const $9548b6d5522645cf$var$slideInFromTop = null;
const $9548b6d5522645cf$var$slideOutFromTop = null;
const $9548b6d5522645cf$var$slideInFromRight = null;
const $9548b6d5522645cf$var$slideOutFromRight = null;
const $9548b6d5522645cf$var$slideInFromBottom = null;
const $9548b6d5522645cf$var$slideOutFromBottom = null;
const $9548b6d5522645cf$var$slideInFromLeft = null;
const $9548b6d5522645cf$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $9548b6d5522645cf$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $7EYFw.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $9qQWw.useExitingPersistence)();
    const setTimeout = (0, $bpOeK.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $lE8gv.useState)(appear);
    (0, $lE8gv.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $1Jmmk.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $1hShM.exitingDurations)[duration] : (0, $b28gO.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $l2NkF.default)([
            (0, $l2NkF.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $l2NkF.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $l2NkF.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $l2NkF.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $l2NkF.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $l2NkF.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $l2NkF.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $l2NkF.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $l2NkF.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $l2NkF.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $l2NkF.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $l2NkF.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $l2NkF.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $l2NkF.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $l2NkF.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $l2NkF.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $l2NkF.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $l2NkF.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $l2NkF.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $l2NkF.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $l2NkF.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $l2NkF.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $l2NkF.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $l2NkF.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $l2NkF.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $l2NkF.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $l2NkF.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $l2NkF.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $l2NkF.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $l2NkF.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $l2NkF.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $l2NkF.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $l2NkF.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $l2NkF.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $l2NkF.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $l2NkF.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $l2NkF.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $l2NkF.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $l2NkF.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $l2NkF.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $l2NkF.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $l2NkF.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $l2NkF.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $l2NkF.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $l2NkF.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $l2NkF.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $l2NkF.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $l2NkF.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $l2NkF.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $l2NkF.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $l2NkF.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $9548b6d5522645cf$export$2e2bcd8739ae039 = $9548b6d5522645cf$var$EnteringMotion;

});
parcelRegister("b28gO", function(module, exports) {
$parcel$export(module.exports, "durations", () => $523ce5e811ee96e5$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $523ce5e811ee96e5$export$368bacef0dacbe05 = 25;
const $523ce5e811ee96e5$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("1hShM", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $fad91b3cb091a482$export$30fa1a2e62ae150c);

var $b28gO = parcelRequire("b28gO");
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $fad91b3cb091a482$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $fad91b3cb091a482$export$30fa1a2e62ae150c = {
    none: (0, $b28gO.durations).none,
    small: (0, $b28gO.durations).small * $fad91b3cb091a482$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $b28gO.durations).medium * $fad91b3cb091a482$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $b28gO.durations).large * $fad91b3cb091a482$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("bpOeK", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $943f39935d72c902$export$4f34107a2b00f39c);

var $lE8gv = parcelRequire("lE8gv");
const $943f39935d72c902$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $943f39935d72c902$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $lE8gv.useRef)([]);
    (0, $lE8gv.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $943f39935d72c902$var$getHookDeps(opts));
    return (0, $lE8gv.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});



parcelRegister("92sXA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac37c24b89cbf72b$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $fBWTV = parcelRequire("fBWTV");

var $5Co2M = parcelRequire("5Co2M");

var $c8s1I = parcelRequire("c8s1I");

var $1s3HN = parcelRequire("1s3HN");

var $hhi18 = parcelRequire("hhi18");
function $ac37c24b89cbf72b$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $1s3HN.default)(mountStrategy);
    (0, $hhi18.default)(zIndex);
    return !(0, $fBWTV.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $5Co2M.default), {
        zIndex: zIndex,
        children: children
    }) : null : /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $c8s1I.default), {
        zIndex: zIndex,
        children: children
    });
}

});
parcelRegister("5Co2M", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ebc2c36f4b59397$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $b450B = parcelRequire("b450B");

var $e2LvR = parcelRequire("e2LvR");

var $4Rzse = parcelRequire("4Rzse");

var $ktAm3 = parcelRequire("ktAm3");

var $iskAl = parcelRequire("iskAl");

var $7xcMO = parcelRequire("7xcMO");

var $eZXQ3 = parcelRequire("eZXQ3");
function $7ebc2c36f4b59397$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $lE8gv.useMemo)(()=>(0, $7xcMO.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, $4Rzse.useColorMode)();
    const isInsideThemeProvider = (0, $ktAm3.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $iskAl.appendPortalContainerIfNotAppended)(container);
    (0, $lE8gv.useEffect)(()=>{
        return ()=>{
            (0, $eZXQ3.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $b450B.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $e2LvR.ThemeProvider), {
        defaultColorMode: colorMode,
        children: children
    }) : children, container);
}

});
parcelRegister("e2LvR", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $4ea041776b260e78$export$d8964aec282183a3);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");

var $lE8gv = parcelRequire("lE8gv");

var $5Ifxs = parcelRequire("5Ifxs");

var $fBWTV = parcelRequire("fBWTV");

var $cdQaS = parcelRequire("cdQaS");

var $j6ufZ = parcelRequire("j6ufZ");

var $b7I9v = parcelRequire("b7I9v");

var $4pICg = parcelRequire("4pICg");

var $fdxeA = parcelRequire("fdxeA");

var $fkWkL = parcelRequire("fkWkL");

var $eXiuK = parcelRequire("eXiuK");

var $hLuDX = parcelRequire("hLuDX");

var $6Nau7 = parcelRequire("6Nau7");

var $aXWf3 = parcelRequire("aXWf3");

var $ktAm3 = parcelRequire("ktAm3");

var $ToA3E = parcelRequire("ToA3E");

var $3rr4j = parcelRequire("3rr4j");
const $4ea041776b260e78$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography'
};
const $4ea041776b260e78$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $4ea041776b260e78$var$prefersDarkModeMql = $4ea041776b260e78$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $4ea041776b260e78$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $4ea041776b260e78$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $4ea041776b260e78$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $4ea041776b260e78$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode = 'auto', defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $lE8gv.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $lE8gv.useState)($4ea041776b260e78$var$getReconciledColorMode(defaultColorMode));
    const isInsideAppProvider = (0, $fkWkL.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, $fdxeA.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, $ktAm3.useIsInsideThemeProvider)(); /**
                                                             * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
                                                             *
                                                             * This will not use sub-tree theming but instead set the global theme state using the
                                                             * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
                                                             * for compatibility with `@atlaskit/css-reset`.
                                                             *
                                                             * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
                                                             * `html` in order to apply global theme state, which would allow a more consistent approach to
                                                             * theme loading.
                                                             */ 
    const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled; /**
                                                                                                             * Each provider owns its own override stylesheet, so nested providers don't overwrite or remove
                                                                                                             * each other's overrides. `useId` is stable between the server render and hydration.
                                                                                                             *
                                                                                                             * Subtree providers also scope their override selector to their own element. Otherwise every
                                                                                                             * subtree using the same custom theme would match every provider's overrides, and the last
                                                                                                             * stylesheet in the document would win. The root provider targets `html`, which subtrees
                                                                                                             * inherit from.
                                                                                                             */ 
    const customThemeOverridesStyleId = (0, $lE8gv.useId)();
    const { theme: normalizedDefaultTheme, inlineStyles: inlineStyles } = (0, $j6ufZ.getThemeAndOverrides)(defaultTheme, isRootThemeProvider ? undefined : customThemeOverridesStyleId);
    const [theme, setTheme] = (0, $lE8gv.useState)(()=>({
            ...$4ea041776b260e78$var$defaultThemeSettings,
            ...normalizedDefaultTheme
        }));
    const [hasHoistedInlineThemeStyles, setHasHoistedInlineThemeStyles] = (0, $lE8gv.useState)(false);
    const setColorMode = (0, $lE8gv.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($4ea041776b260e78$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $lE8gv.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $lE8gv.useRef)(null); /**
                                                                                                * Custom theme overrides apply regardless of `platform-static-theme-loading`: that gate only
                                                                                                * controls how the theme stylesheets themselves are loaded.
                                                                                                */ 
    const inlineThemeStylesOverrides = inlineStyles;
    (0, $lE8gv.useLayoutEffect)(()=>{
        return ()=>{
            document.head.querySelector(`style[data-theme-overrides="${customThemeOverridesStyleId}"]`)?.remove();
        };
    }, [
        customThemeOverridesStyleId
    ]);
    (0, $lE8gv.useLayoutEffect)(()=>{
        const isStaticThemeLoadingEnabled = (0, $fBWTV.fg)('platform-static-theme-loading');
        if (isStaticThemeLoadingEnabled && !hasHoistedInlineThemeStyles) (0, $ToA3E.getInlineThemeStyles)(theme, chosenColorMode).forEach(({ id: id, css: css })=>{
            if (document.head.querySelector(`style[data-theme="${id}"]`)) return;
            const style = document.createElement('style');
            style.dataset.theme = id;
            style.textContent = css;
            document.head.appendChild(style);
        });
        const existingOverrideStyle = document.head.querySelector(`style[data-theme-overrides="${customThemeOverridesStyleId}"]`);
        if (inlineThemeStylesOverrides) {
            if (existingOverrideStyle) existingOverrideStyle.textContent = inlineThemeStylesOverrides;
            else {
                const style = document.createElement('style');
                style.dataset.themeOverrides = customThemeOverridesStyleId;
                style.textContent = inlineThemeStylesOverrides;
                document.head.appendChild(style);
            }
        } else existingOverrideStyle?.remove();
         // Only re-render to drop the inline styles when there are any to drop.
        if (!hasHoistedInlineThemeStyles && (isStaticThemeLoadingEnabled || inlineThemeStylesOverrides)) setHasHoistedInlineThemeStyles(true);
    }, [
        chosenColorMode,
        customThemeOverridesStyleId,
        hasHoistedInlineThemeStyles,
        inlineThemeStylesOverrides,
        theme
    ]);
    (0, $lE8gv.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, $4pICg.setGlobalTheme)({
                    ...theme,
                    colorMode: reconciledColorMode
                });
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $3rr4j.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $lE8gv.useEffect)(()=>{
        if (!$4ea041776b260e78$var$prefersDarkModeMql) return;
        const unbindListener = (0, $5Ifxs.bind)($4ea041776b260e78$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = {
        ...(0, $b7I9v.getThemeHtmlAttrs)({
            ...theme,
            colorMode: reconciledColorMode
        }),
        [(0, $cdQaS.SUBTREE_THEME_ATTRIBUTE)]: true,
        // Matches this provider's scoped override selector. Only set when there are overrides.
        ...inlineThemeStylesOverrides ? {
            [(0, $j6ufZ.CUSTOM_THEME_SCOPE_ATTRIBUTE)]: customThemeOverridesStyleId
        } : {}
    };
    const inlineThemeStyles = (0, $fBWTV.fg)('platform-static-theme-loading') && !hasHoistedInlineThemeStyles ? (0, $ToA3E.getInlineThemeStyles)(theme, chosenColorMode) : [];
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $hLuDX.InsideThemeProviderContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $eXiuK.ColorModeContext).Provider, {
            value: reconciledColorMode,
            children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $6Nau7.SetColorModeContext).Provider, {
                value: setColorMode,
                children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $aXWf3.ThemeContext).Provider, {
                    value: theme,
                    children: /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $aXWf3.SetThemeContext).Provider, {
                        value: setPartialTheme,
                        children: !isRootThemeProvider ? /*#__PURE__*/ (0, $kOwiQ.jsxs)("div", {
                            ...attrs,
                            className: (0, $l2NkF.default)([
                                $4ea041776b260e78$var$contentStyles.body
                            ]),
                            children: [
                                !hasHoistedInlineThemeStyles && inlineThemeStylesOverrides && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                /*#__PURE__*/ (0, $kOwiQ.jsx)("style", {
                                    "data-theme-overrides": customThemeOverridesStyleId,
                                    children: inlineThemeStylesOverrides
                                }),
                                inlineThemeStyles.map(({ id: id, css: css })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                    /*#__PURE__*/ (0, $kOwiQ.jsx)("style", {
                                        "data-theme": id,
                                        children: css
                                    }, id)),
                                children
                            ]
                        }) : /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $kOwiQ.Fragment), {
                            children: [
                                !hasHoistedInlineThemeStyles && inlineThemeStylesOverrides && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                /*#__PURE__*/ (0, $kOwiQ.jsx)("style", {
                                    "data-theme-overrides": customThemeOverridesStyleId,
                                    children: inlineThemeStylesOverrides
                                }),
                                inlineThemeStyles.map(({ id: id, css: css })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                    /*#__PURE__*/ (0, $kOwiQ.jsx)("style", {
                                        "data-theme": id,
                                        children: css
                                    }, id)),
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("j6ufZ", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_THEME_SCOPE_ATTRIBUTE", () => $0b5657ceec300738$export$e5f6e0f338f81b9a);
$parcel$export(module.exports, "getThemeAndOverrides", () => $0b5657ceec300738$export$12087c26a9b2e83e);
function $0b5657ceec300738$var$isThemeWithOverrides(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'overrides' in value && typeof value.id === 'string' && typeof value.overrides === 'object' && value.overrides !== null;
}
const $0b5657ceec300738$export$e5f6e0f338f81b9a = 'data-theme-overrides-scope';
function $0b5657ceec300738$export$12087c26a9b2e83e(themeWithOverrides, scope) {
    const theme = {};
    const overrides = {};
    for (const [themeKind, value] of Object.entries(themeWithOverrides || {})){
        if ($0b5657ceec300738$var$isThemeWithOverrides(value)) {
            theme[themeKind] = value.id;
            overrides[themeKind] = {
                [value.id]: value.overrides
            };
            continue;
        }
        theme[themeKind] = value;
    }
    return {
        theme: theme,
        inlineStyles: $0b5657ceec300738$var$getCustomThemeOverrideStyles(overrides, scope)
    };
}
/**
 * Escapes a value for use inside a double-quoted CSS attribute selector.
 */ function $0b5657ceec300738$var$escapeAttributeValue(value) {
    return value.replace(/["\\]/g, '\\$&');
}
function $0b5657ceec300738$var$getThemeOverrideSelector(themeKind, themeName, scope) {
    // Colour themes only apply in their own colour mode.
    const colorMode = themeKind === 'light' || themeKind === 'dark' ? `[data-color-mode="${themeKind}"]` : '';
    const theme = `${colorMode}[data-theme~="${themeKind}:${themeName}"]`;
    if (scope) return `[data-subtree-theme][${$0b5657ceec300738$export$e5f6e0f338f81b9a}="${$0b5657ceec300738$var$escapeAttributeValue(scope)}"]${theme}`;
    return `html${theme}, [data-subtree-theme]${theme}`;
}
function $0b5657ceec300738$var$getCssVariableName(propertyName) {
    return `--ds-${propertyName.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
}
/**
 * Generates CSS for custom theme overrides.
 *
 * Override property names are converted from camel case to `--ds-` CSS custom properties.
 */ function $0b5657ceec300738$var$getCustomThemeOverrideStyles(overrides, scope) {
    if (!overrides) return '';
    return Object.entries(overrides).flatMap(([themeKind, themes])=>Object.entries(themes || {}).flatMap(([themeName, values])=>{
            const styles = Object.entries(values || {})// Unset optional inputs are skipped so the theme's `var()` fallback applies. Writing
            // `undefined` would be a valid custom property value that breaks the formula.
            .filter(([, value])=>value !== undefined && value !== null).map(([propertyName, value])=>`${$0b5657ceec300738$var$getCssVariableName(propertyName)}: ${value};`).join('');
            return styles ? `
		${$0b5657ceec300738$var$getThemeOverrideSelector(themeKind, themeName, scope)} {
			${styles}
		}
	` : [];
        })).join('');
}

});

parcelRegister("b7I9v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "getThemeHtmlAttrs", () => $c1f9e183a1d4cef2$export$e1f80cb7a749802f);
$parcel$export(module.exports, "default", () => $c1f9e183a1d4cef2$export$2e2bcd8739ae039);

var $fBWTV = parcelRequire("fBWTV");

var $cdQaS = parcelRequire("cdQaS");

var $14mFB = parcelRequire("14mFB");

var $baS1f = parcelRequire("baS1f");

var $c3oS5 = parcelRequire("c3oS5");

var $c6gxo = parcelRequire("c6gxo");
const $c1f9e183a1d4cef2$var$defaultColorMode = 'light';
const $c1f9e183a1d4cef2$var$defaultContrastMode = 'no-preference';
const $c1f9e183a1d4cef2$export$e1f80cb7a749802f = ({ colorMode: colorMode = (0, $baS1f.themeStateDefaults)['colorMode'], dark: dark = (0, $baS1f.themeStateDefaults)['dark'], light: light = (0, $baS1f.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $baS1f.themeStateDefaults)['contrastMode'], motion: motion = (0, $baS1f.themeStateDefaults)['motion'](), shape: shape = (0, $baS1f.themeStateDefaults)['shape'], spacing: spacing = (0, $baS1f.themeStateDefaults)['spacing'], typography: typography = (0, $baS1f.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $baS1f.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $14mFB.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $cdQaS.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $cdQaS.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $c1f9e183a1d4cef2$var$defaultColorMode : colorMode
    };
    if ((0, $fBWTV.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $cdQaS.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $c1f9e183a1d4cef2$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $c6gxo.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $c3oS5.hash)(optionString);
        result[0, $cdQaS.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $c1f9e183a1d4cef2$export$2e2bcd8739ae039 = $c1f9e183a1d4cef2$export$e1f80cb7a749802f;

});
parcelRegister("14mFB", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", () => $ef613e840caa0480$export$62c37ab81302621a);

var $9y6Bq = parcelRequire("9y6Bq");

var $2hQ83 = parcelRequire("2hQ83");

var $adI2s = parcelRequire("adI2s");
const $ef613e840caa0480$var$customThemeOptions = 'UNSAFE_themeOptions';
const $ef613e840caa0480$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $9y6Bq.isColorMode)(id) || // custom theme state
        kind === $ef613e840caa0480$var$customThemeOptions && typeof id === 'object' || // other theme states
        (0, $adI2s.isThemeKind)(kind) && typeof id === 'string' && (0, $2hQ83.isThemeIds)(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});

parcelRegister("baS1f", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $f361c90bd11e8cb0$export$9aedcfa7336a207);
function $f361c90bd11e8cb0$var$getMotionDefault() {
    return 'motion';
}
const $f361c90bd11e8cb0$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography',
    motion: $f361c90bd11e8cb0$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("c3oS5", function(module, exports) {
$parcel$export(module.exports, "hash", () => $5f09c2d0fd2272ae$export$d6af199866bfb566);
const $5f09c2d0fd2272ae$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("c6gxo", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $f2f1cb486e6d88f6$export$53031ac1ecb71f44);
const $f2f1cb486e6d88f6$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);

});


parcelRegister("4pICg", function(module, exports) {
$parcel$export(module.exports, "setGlobalTheme", () => $8c358e139018e201$export$fd7e0dd2b74807f7);

var $fBWTV = parcelRequire("fBWTV");

var $gDX2W = parcelRequire("gDX2W");

var $baS1f = parcelRequire("baS1f");

var $1UZyi = parcelRequire("1UZyi");

var $1WTLC = parcelRequire("1WTLC");

var $b8EGt = parcelRequire("b8EGt");

var $cb1Bj = parcelRequire("cb1Bj");

var $c6gxo = parcelRequire("c6gxo");

var $h9BLn = parcelRequire("h9BLn");

var $8lS1T = parcelRequire("8lS1T");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $8c358e139018e201$export$fd7e0dd2b74807f7 = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $baS1f.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $baS1f.themeStateDefaults)['contrastMode'], dark: dark = (0, $baS1f.themeStateDefaults)['dark'], light: light = (0, $baS1f.themeStateDefaults)['light'], shape: shape = (0, $baS1f.themeStateDefaults)['shape'], spacing: spacing = (0, $baS1f.themeStateDefaults)['spacing'], typography: typography = (0, $baS1f.themeStateDefaults)['typography'], motion: motion = (0, $baS1f.themeStateDefaults)['motion'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $baS1f.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $baS1f.themeStateDefaults),
        typography: (0, $baS1f.themeStateDefaults)['typography'],
        shape: (0, $baS1f.themeStateDefaults)['shape'],
        motion: (0, $baS1f.themeStateDefaults)['motion'](),
        ...(0, $gDX2W.getGlobalTheme)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $fBWTV.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        motion: motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    const themePreferences = (0, $cb1Bj.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $8lS1T.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    const themeOverridePreferences = (0, $b8EGt.getThemeOverridePreferences)(themeState);
    // Start loading override CSS before the first await. It is appended only after the standard
    // themes have loaded so that the override cascade order remains deterministic.
    const overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map((themeId)=>(0, $h9BLn.loadThemeCss)(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $c6gxo.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $baS1f.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $1WTLC.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("hGebj"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    if (themeLoader) for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    else {
        const overrideThemeCss = await Promise.all(overrideThemeCssLoadingTasks);
        await Promise.all(themeOverridePreferences.map((themeId, index)=>(0, $8lS1T.loadAndAppendThemeCss)(themeId, overrideThemeCss[index])));
    }
    const autoUnbind = (0, $1UZyi.default)(themeState);
    return autoUnbind;
};

});
parcelRegister("1UZyi", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8c62a79caee8670$export$2e2bcd8739ae039);

var $fBWTV = parcelRequire("fBWTV");

var $b7I9v = parcelRequire("b7I9v");

var $d3mhf = parcelRequire("d3mhf");

var $3V8OG = parcelRequire("3V8OG");
function $a8c62a79caee8670$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $d3mhf.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $d3mhf.default).bind();
    } else (0, $d3mhf.default).unbind();
    if ((0, $fBWTV.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $3V8OG.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $3V8OG.default).bind();
        } else (0, $3V8OG.default).unbind();
    }
    const themeAttributes = (0, $b7I9v.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $d3mhf.default).unbind();
        if ((0, $fBWTV.fg)('platform_increased-contrast-themes')) (0, $3V8OG.default).unbind();
    };
}

});
parcelRegister("d3mhf", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a3daabb896bfe7e$export$2e2bcd8739ae039);

var $5Ifxs = parcelRequire("5Ifxs");

var $cdQaS = parcelRequire("cdQaS");

var $8lS1T = parcelRequire("8lS1T");
const $9a3daabb896bfe7e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $9a3daabb896bfe7e$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $cdQaS.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $9a3daabb896bfe7e$var$darkModeMql = $9a3daabb896bfe7e$var$isMatchMediaAvailable && window.matchMedia((0, $8lS1T.darkModeMediaQuery));
class $9a3daabb896bfe7e$var$ColorModeObserver {
    getColorMode() {
        if (!$9a3daabb896bfe7e$var$darkModeMql) return 'light';
        return $9a3daabb896bfe7e$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($9a3daabb896bfe7e$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $5Ifxs.bind)($9a3daabb896bfe7e$var$darkModeMql, {
            type: 'change',
            listener: $9a3daabb896bfe7e$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $9a3daabb896bfe7e$var$SingletonColorModeObserver = new $9a3daabb896bfe7e$var$ColorModeObserver();
var $9a3daabb896bfe7e$export$2e2bcd8739ae039 = $9a3daabb896bfe7e$var$SingletonColorModeObserver;

});
parcelRegister("8lS1T", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $dfb4ff0669563e37$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $dfb4ff0669563e37$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $dfb4ff0669563e37$export$8662df6937d86fcb);

var $cdQaS = parcelRequire("cdQaS");

var $h9BLn = parcelRequire("h9BLn");
const $dfb4ff0669563e37$export$26cd7ae85c7144e5 = async (themeId, preloadedThemeCss)=>{
    if (document.head.querySelector(`style[${(0, $cdQaS.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $cdQaS.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = preloadedThemeCss ?? await (0, $h9BLn.loadThemeCss)(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $dfb4ff0669563e37$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $dfb4ff0669563e37$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("h9BLn", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", () => $550a7b6fd1c9d0dc$export$8a48286ed7df6720);

var $4RAzu = parcelRequire("4RAzu");
const $550a7b6fd1c9d0dc$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $4RAzu.default)[themeId]();
    return themeCss;
};

});
parcelRegister("4RAzu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "themeImportMap", () => $d90486883423d75e$export$3a171c49f8c16356);
$parcel$export(module.exports, "default", () => $d90486883423d75e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::b1d12c60fe57e05a2251249c2cea7224>>
 * @codegenCommand yarn build tokens
 */ 



















const $d90486883423d75e$export$3a171c49f8c16356 = {
    'light': ()=>(parcelRequire("6Krgf")),
    'light-future': ()=>(parcelRequire("2U5Tu")),
    'light-finesse': ()=>(parcelRequire("26HrT")),
    'light-increased-contrast-finesse': ()=>(parcelRequire("lwrQl")),
    'light-increased-contrast': ()=>(parcelRequire("2ytAm")),
    'UNSAFE-dynamic': ()=>(parcelRequire("4v5gO")),
    'UNSAFE-dynamic-dark': ()=>(parcelRequire("kQYhc")),
    'UNSAFE-test-light': ()=>(parcelRequire("keReS")),
    'UNSAFE-test-dark': ()=>(parcelRequire("6P1lr")),
    'dark': ()=>(parcelRequire("lh5iS")),
    'dark-future': ()=>(parcelRequire("77mud")),
    'dark-finesse': ()=>(parcelRequire("kKsFe")),
    'dark-increased-contrast-finesse': ()=>(parcelRequire("gcBvw")),
    'dark-increased-contrast': ()=>(parcelRequire("1KNaV")),
    'spacing': ()=>(parcelRequire("b2iXo")),
    'typography': ()=>(parcelRequire("79JqY")),
    'UNSAFE-typography': ()=>(parcelRequire("1rqdf")),
    'typography-finesse': ()=>(parcelRequire("qNpxZ")),
    'shape': ()=>(parcelRequire("ie7Vz")),
    'motion': ()=>(parcelRequire("cZcvI"))
};
var $d90486883423d75e$export$2e2bcd8739ae039 = $d90486883423d75e$export$3a171c49f8c16356;

});
parcelRegister("6Krgf", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("aeDKW").then(()=>parcelRequire('7YpHT'));

});
parcelRegister("9RrC7", function(module, exports) {
"use strict";

function $72de7bd006ad901d$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("6tnyh")).resolve(id));
}
module.exports = $72de7bd006ad901d$var$load;

});
parcelRegister("6tnyh", function(module, exports) {
$parcel$export(module.exports, "register", () => $4b67b872b2290bfc$export$6503ec6e8aabbaf, (v) => $4b67b872b2290bfc$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $4b67b872b2290bfc$export$f7ad0328861e2f03, (v) => $4b67b872b2290bfc$export$f7ad0328861e2f03 = v);
var $4b67b872b2290bfc$export$6503ec6e8aabbaf;
var $4b67b872b2290bfc$export$f7ad0328861e2f03;
"use strict";
var $4b67b872b2290bfc$var$mapping = new Map();
function $4b67b872b2290bfc$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4b67b872b2290bfc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4b67b872b2290bfc$var$resolve(id) {
    var resolved = $4b67b872b2290bfc$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4b67b872b2290bfc$export$6503ec6e8aabbaf = $4b67b872b2290bfc$var$register;
$4b67b872b2290bfc$export$f7ad0328861e2f03 = $4b67b872b2290bfc$var$resolve;

});



parcelRegister("2U5Tu", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("8BltH").then(()=>parcelRequire('6H9UL'));

});

parcelRegister("26HrT", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("6nVEu").then(()=>parcelRequire('aLg7M'));

});

parcelRegister("lwrQl", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("cL8Q9").then(()=>parcelRequire('112bx'));

});

parcelRegister("2ytAm", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("bIJLC").then(()=>parcelRequire('hQuJH'));

});

parcelRegister("4v5gO", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("aDJDN").then(()=>parcelRequire('q9hVB'));

});

parcelRegister("kQYhc", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("4yKuS").then(()=>parcelRequire('fT8Wl'));

});

parcelRegister("keReS", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("6Rgz4").then(()=>parcelRequire('375C7'));

});

parcelRegister("6P1lr", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("kpfVT").then(()=>parcelRequire('lKRE9'));

});

parcelRegister("lh5iS", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("3GK6r").then(()=>parcelRequire('fZeQy'));

});

parcelRegister("77mud", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("kIkuJ").then(()=>parcelRequire('ah4Ty'));

});

parcelRegister("kKsFe", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("iIeIB").then(()=>parcelRequire('knarw'));

});

parcelRegister("gcBvw", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("icTlA").then(()=>parcelRequire('leG35'));

});

parcelRegister("1KNaV", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("9Lty1").then(()=>parcelRequire('aTexC'));

});

parcelRegister("b2iXo", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("h63Ie").then(()=>parcelRequire('c2fID'));

});

parcelRegister("79JqY", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("7Kpes").then(()=>parcelRequire('1GFHH'));

});

parcelRegister("1rqdf", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("6raGW").then(()=>parcelRequire('1Febm'));

});

parcelRegister("qNpxZ", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("aVM5G").then(()=>parcelRequire('8oUU3'));

});

parcelRegister("ie7Vz", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("jtvTy").then(()=>parcelRequire('j3k5C'));

});

parcelRegister("cZcvI", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("bDNTp").then(()=>parcelRequire('1KJbM'));

});





parcelRegister("3V8OG", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a8f82a817af7f2c$export$2e2bcd8739ae039);

var $5Ifxs = parcelRequire("5Ifxs");

var $cdQaS = parcelRequire("cdQaS");

var $8lS1T = parcelRequire("8lS1T");
const $4a8f82a817af7f2c$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $4a8f82a817af7f2c$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $cdQaS.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $4a8f82a817af7f2c$var$contrastModeMql = $4a8f82a817af7f2c$var$isMatchMediaAvailable && window.matchMedia((0, $8lS1T.moreContrastMediaQuery));
class $4a8f82a817af7f2c$var$ContrastModeObserver {
    getContrastMode() {
        if (!$4a8f82a817af7f2c$var$contrastModeMql) return 'no-preference';
        return $4a8f82a817af7f2c$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($4a8f82a817af7f2c$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $5Ifxs.bind)($4a8f82a817af7f2c$var$contrastModeMql, {
            type: 'change',
            listener: $4a8f82a817af7f2c$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $4a8f82a817af7f2c$var$SingletonContrastModeObserver = new $4a8f82a817af7f2c$var$ContrastModeObserver();
var $4a8f82a817af7f2c$export$2e2bcd8739ae039 = $4a8f82a817af7f2c$var$SingletonContrastModeObserver;

});


parcelRegister("1WTLC", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $5a5ae832058b54d6$export$bd1ac9300b0e885a);

var $cdQaS = parcelRequire("cdQaS");

var $c3oS5 = parcelRequire("c3oS5");
function $5a5ae832058b54d6$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $c3oS5.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $cdQaS.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $cdQaS.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("b8EGt", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", () => $02860a99063d75c5$export$5d76d7014f4a5d08);

var $fBWTV = parcelRequire("fBWTV");

var $jTc12 = parcelRequire("jTc12");
const $02860a99063d75c5$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
const $02860a99063d75c5$export$5d76d7014f4a5d08 = (themeState)=>{
    if (!(0, $fBWTV.fg)('platform-dst-tokens-finesse')) return [];
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, typography: typography } = themeState;
    const selectedThemes = [
        ...colorMode === 'auto' ? [
            light,
            dark
        ] : [
            themeState[colorMode]
        ],
        typography
    ];
    if (contrastMode !== 'no-preference' && (0, $fBWTV.fg)('platform_increased-contrast-themes')) selectedThemes.forEach((themeId)=>{
        const increasedContrastTheme = (0, $jTc12.default)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    const themeOverridePreferences = selectedThemes.map((themeId)=>$02860a99063d75c5$var$finesseOverrides[themeId]).filter((themeId)=>themeId !== undefined);
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("jTc12", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdee8bb374564e35$export$2e2bcd8739ae039);

var $iso59 = parcelRequire("iso59");
function $fdee8bb374564e35$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $iso59.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});
parcelRegister("iso59", function(module, exports) {
$parcel$export(module.exports, "default", () => $6157caf8864eb1f0$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ 
var $hNnJZ = parcelRequire("hNnJZ");


/**
 * Contrast preferences: The system contrast preference
 */ const $6157caf8864eb1f0$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $6157caf8864eb1f0$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
const $6157caf8864eb1f0$export$92ba366331403db2 = [
    ...(0, $hNnJZ.themeIds),
    ...$6157caf8864eb1f0$export$ba8a43b83ecc69f8
];
const $6157caf8864eb1f0$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'UNSAFE-dynamic': {
        id: 'UNSAFE-dynamic',
        displayName: 'UNSAFE Dynamic Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-dynamic-dark': {
        id: 'UNSAFE-dynamic-dark',
        displayName: 'UNSAFE Dynamic Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'UNSAFE-test-light': {
        id: 'UNSAFE-test-light',
        displayName: 'UNSAFE Test Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-test-dark': {
        id: 'UNSAFE-test-dark',
        displayName: 'UNSAFE Test Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'UNSAFE-typography': {
        id: 'UNSAFE-typography',
        displayName: 'UNSAFE Dynamic Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        extends: 'typography'
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$6157caf8864eb1f0$export$2e2bcd8739ae039 = $6157caf8864eb1f0$export$9d64ff89b6869900;

});



parcelRegister("cb1Bj", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $a76a76751d43237a$export$dd6aeb7c823fc03d);

var $fBWTV = parcelRequire("fBWTV");

var $jTc12 = parcelRequire("jTc12");
const $a76a76751d43237a$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography, motion: motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $fBWTV.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $jTc12.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $fBWTV.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $jTc12.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};

});

parcelRegister("hGebj", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("3Z1BP"),
    $9RrC7("caBGH")
]).then(()=>parcelRequire('4PD00'));

});


parcelRegister("fdxeA", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $be9e07f2bf8e919d$export$a782702263f77544);

var $lE8gv = parcelRequire("lE8gv");

var $18hJI = parcelRequire("18hJI");
const $be9e07f2bf8e919d$export$a782702263f77544 = ()=>{
    return (0, $lE8gv.useContext)((0, $18hJI.AppProviderThemingEnabledContext));
};

});
parcelRegister("18hJI", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $852cba3274dfafe8$export$d2def9838ca456c0);

var $lE8gv = parcelRequire("lE8gv");
const $852cba3274dfafe8$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $lE8gv.createContext)(false);

});


parcelRegister("fkWkL", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $8d5f6660b4a3c260$export$26aa23367bfbab0e);

var $lE8gv = parcelRequire("lE8gv");

var $a9lJj = parcelRequire("a9lJj");
const $8d5f6660b4a3c260$export$26aa23367bfbab0e = ()=>{
    return (0, $lE8gv.useContext)((0, $a9lJj.InsideAppProviderContext));
};

});
parcelRegister("a9lJj", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $b00f26d41423797b$export$7981b2444296e410);

var $lE8gv = parcelRequire("lE8gv");
const $b00f26d41423797b$export$7981b2444296e410 = /*#__PURE__*/ (0, $lE8gv.createContext)(false);

});


parcelRegister("hLuDX", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $112d16c8d99c9914$export$332347eeb335453c);

var $lE8gv = parcelRequire("lE8gv");
const $112d16c8d99c9914$export$332347eeb335453c = /*#__PURE__*/ (0, $lE8gv.createContext)(false);

});

parcelRegister("6Nau7", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $5fd128ef2254f6db$export$b06130bad0bbc70f);

var $lE8gv = parcelRequire("lE8gv");
const $5fd128ef2254f6db$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $lE8gv.createContext)(undefined);

});

parcelRegister("aXWf3", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $7e86a4f80c43d3a9$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $7e86a4f80c43d3a9$export$f7a97b47760e2a13);

var $lE8gv = parcelRequire("lE8gv");
const $7e86a4f80c43d3a9$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $lE8gv.createContext)(undefined);
const $7e86a4f80c43d3a9$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $lE8gv.createContext)(undefined);

});

parcelRegister("ktAm3", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $5b806aca9157a3a5$export$7ca11437599d653d);

var $lE8gv = parcelRequire("lE8gv");

var $hLuDX = parcelRequire("hLuDX");
const $5b806aca9157a3a5$export$7ca11437599d653d = ()=>{
    return (0, $lE8gv.useContext)((0, $hLuDX.InsideThemeProviderContext)) ?? false;
};

});

parcelRegister("ToA3E", function(module, exports) {
$parcel$export(module.exports, "getInlineThemeStyles", () => $b52a04581e4bb065$export$ae40e6ba718781b9);

var $lE8gv = parcelRequire("lE8gv");

var $4RAzu = parcelRequire("4RAzu");

var $b8EGt = parcelRequire("b8EGt");

var $cb1Bj = parcelRequire("cb1Bj");
const $b52a04581e4bb065$var$themeCssPromises = new Map();
function $b52a04581e4bb065$var$getThemeCssPromise(themeId) {
    let themeCssPromise = $b52a04581e4bb065$var$themeCssPromises.get(themeId);
    if (!themeCssPromise) {
        themeCssPromise = (0, $4RAzu.themeImportMap)[themeId]().then(({ default: css })=>css);
        $b52a04581e4bb065$var$themeCssPromises.set(themeId, themeCssPromise);
    }
    return themeCssPromise;
}
function $b52a04581e4bb065$var$getInlineThemeCss(themeId) {
    const reactUse = (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).use;
    const isServer = globalThis.__SERVER__ === true || typeof document === 'undefined';
    if (isServer) return reactUse?.($b52a04581e4bb065$var$getThemeCssPromise(themeId));
    return document.body.querySelector(`style[data-theme="${themeId}"]`)?.textContent ?? undefined;
}
function $b52a04581e4bb065$export$ae40e6ba718781b9(theme, colorMode) {
    const themeState = {
        ...theme,
        colorMode: colorMode,
        contrastMode: 'no-preference'
    };
    const themeIds = [
        ...(0, $cb1Bj.getThemePreferences)(themeState),
        ...(0, $b8EGt.getThemeOverridePreferences)(themeState)
    ];
    return [
        ...new Set(themeIds)
    ].map((themeId)=>{
        const css = $b52a04581e4bb065$var$getInlineThemeCss(themeId);
        return css ? {
            id: themeId,
            css: css
        } : undefined;
    }).filter((style)=>style !== undefined);
}

});

parcelRegister("3rr4j", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $f149c34281507fa0$export$7d4a7e812d176b24);

var $5oRUl = parcelRequire("5oRUl");

var $4RAzu = parcelRequire("4RAzu");

var $ewMV1 = parcelRequire("ewMV1");
const $f149c34281507fa0$var$loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, $ewMV1.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, $4RAzu.themeImportMap)[themeId]();
    return themeCss;
};
const $f149c34281507fa0$var$mountThemeCss = async (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, $5oRUl.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, $ewMV1.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const $f149c34281507fa0$var$loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await $f149c34281507fa0$var$loadThemeCss(themeId);
    if (!themeCss) return;
    $f149c34281507fa0$var$mountThemeCss(themeCss, themeId);
};
const $f149c34281507fa0$export$7d4a7e812d176b24 = async (theme)=>{
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach($f149c34281507fa0$var$loadAndMountThemeCss);
};

});
parcelRegister("ewMV1", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $e3cb0f3b4abfb1f1$export$835a0dc855d02822);

var $5oRUl = parcelRequire("5oRUl");

var $cdQaS = parcelRequire("cdQaS");
function $e3cb0f3b4abfb1f1$export$835a0dc855d02822(themeId) {
    const doc = (0, $5oRUl.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, $cdQaS.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

});



parcelRegister("4Rzse", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $58be00cea89c5539$export$20f3076712c8dfa);

var $lE8gv = parcelRequire("lE8gv");

var $gDX2W = parcelRequire("gDX2W");

var $cE35U = parcelRequire("cE35U");

var $eXiuK = parcelRequire("eXiuK");
function $58be00cea89c5539$export$20f3076712c8dfa() {
    const value = (0, $lE8gv.useContext)((0, $eXiuK.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, $gDX2W.getGlobalTheme)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $lE8gv.useState)(theme?.colorMode || 'light');
    (0, $lE8gv.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $cE35U.ThemeMutationObserver)((theme)=>{
            setResolvedColorMode(theme?.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});

parcelRegister("iskAl", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $60754af1c038ca44$export$c582005add11e141);

var $cliWO = parcelRequire("cliWO");

var $2ELY8 = parcelRequire("2ELY8");
const $60754af1c038ca44$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $cliWO.portalParentSelector));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $cliWO.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $2ELY8.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $60754af1c038ca44$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $60754af1c038ca44$var$getPortalParent().appendChild(container);
};

});
parcelRegister("cliWO", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $0f010f8299a45677$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $0f010f8299a45677$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $0f010f8299a45677$export$13f57c02915787b3);
const $0f010f8299a45677$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $0f010f8299a45677$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $0f010f8299a45677$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("2ELY8", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $39eafa0482e342ae$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $39eafa0482e342ae$export$135b49d4bc2964c6 = ()=>{
    return document.body;
};

});


parcelRegister("7xcMO", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $aa169d4c31a1c837$export$26ae5ca175b4ec5a);

var $cliWO = parcelRequire("cliWO");
const $aa169d4c31a1c837$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $cliWO.portalClassName);
    container.style.zIndex = `${zIndex}`;
    return container;
};

});

parcelRegister("eZXQ3", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $41027e213f17b66c$export$da99f98bf3fe55b3);

var $cliWO = parcelRequire("cliWO");

var $2ELY8 = parcelRequire("2ELY8");
const $41027e213f17b66c$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $cliWO.portalParentSelector));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $cliWO.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $2ELY8.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $41027e213f17b66c$export$da99f98bf3fe55b3 = (container)=>{
    const parent = $41027e213f17b66c$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("c8s1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $99a03fd1de3a95b1$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $b450B = parcelRequire("b450B");

var $e2LvR = parcelRequire("e2LvR");

var $4Rzse = parcelRequire("4Rzse");

var $ktAm3 = parcelRequire("ktAm3");

var $4thZU = parcelRequire("4thZU");

var $jddHi = parcelRequire("jddHi");

var $i03aX = parcelRequire("i03aX");
function $99a03fd1de3a95b1$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $lE8gv.useState)(null);
    const colorMode = (0, $4Rzse.useColorMode)();
    const isInsideThemeProvider = (0, $ktAm3.useIsInsideThemeProvider)();
    (0, $4thZU.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $jddHi.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $i03aX.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ const suspendedChildren = /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $lE8gv.Suspense), {
        fallback: null,
        children: isInsideThemeProvider ? /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $e2LvR.ThemeProvider), {
            defaultColorMode: colorMode,
            children: children
        }) : children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $b450B.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("4thZU", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $2034c4b80daf5891$export$700979bc83e7db82);

var $lE8gv = parcelRequire("lE8gv");
const $2034c4b80daf5891$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $lE8gv.useLayoutEffect) : (0, $lE8gv.useEffect);

});

parcelRegister("jddHi", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $26cdb16690f59961$export$fef014d7cef9e543);

var $cliWO = parcelRequire("cliWO");
const $26cdb16690f59961$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $26cdb16690f59961$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($26cdb16690f59961$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $cliWO.portalClassName);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("i03aX", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $665a30503b480939$export$95029ca7aca2989e);

var $cliWO = parcelRequire("cliWO");

var $2ELY8 = parcelRequire("2ELY8");
const $665a30503b480939$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $665a30503b480939$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($665a30503b480939$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $cliWO.portalParentSelector));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $cliWO.portalParentClassName);
            parent.style.display = 'flex';
            (0, $2ELY8.getBody)()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});


parcelRegister("1s3HN", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e7f1a456923fd47$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");

var $4thZU = parcelRequire("4thZU");
const $5e7f1a456923fd47$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $lE8gv.useState)(false);
    const [useMountEffect] = (0, $lE8gv.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $4thZU.useIsomorphicLayoutEffect) : (0, $lE8gv.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $5e7f1a456923fd47$export$2e2bcd8739ae039 = $5e7f1a456923fd47$var$useIsSubsequentRender;

});

parcelRegister("hhi18", function(module, exports) {
$parcel$export(module.exports, "default", () => $05322869395a250b$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");

var $hhT5V = parcelRequire("hhT5V");

var $5wWOQ = parcelRequire("5wWOQ");
const $05322869395a250b$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $lE8gv.useEffect)(()=>{
        (0, $5wWOQ.default)((0, $hhT5V.PORTAL_MOUNT_EVENT), zIndexNumber);
        return ()=>{
            (0, $5wWOQ.default)((0, $hhT5V.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $05322869395a250b$export$2e2bcd8739ae039 = $05322869395a250b$var$useFirePortalEvent;

});
parcelRegister("hhT5V", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $d16fc9fb2e2f40bd$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $d16fc9fb2e2f40bd$export$80816bd900e5bd00);
const $d16fc9fb2e2f40bd$export$ed5835cc67e87f72 = 'akPortalMount';
const $d16fc9fb2e2f40bd$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("5wWOQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $01d95e4a493a7057$export$2e2bcd8739ae039);
const $01d95e4a493a7057$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $01d95e4a493a7057$var$getLayerName = (zIndex)=>{
    return $01d95e4a493a7057$var$zIndexToName.hasOwnProperty(zIndex) ? $01d95e4a493a7057$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $01d95e4a493a7057$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $01d95e4a493a7057$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $01d95e4a493a7057$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $01d95e4a493a7057$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("4zhbd", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $8G3fl = parcelRequire("8G3fl");
module.exports = Object.assign({}, $8G3fl, {
    gridSize: ()=>8,
    borderRadius: ()=>3,
    fontSize: ()=>14,
    fontSizeSmall: ()=>11
});
if ($8G3fl.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});
parcelRegister("8G3fl", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", () => $9354ece0b2140c37$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $9354ece0b2140c37$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $9354ece0b2140c37$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "layers", () => $9354ece0b2140c37$export$7be255094ccdc533);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $9354ece0b2140c37$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $9354ece0b2140c37$export$c93026a968943f95 = 'light';
const $9354ece0b2140c37$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $9354ece0b2140c37$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};

});


parcelRegister("gF5jn", function(module, exports) {
$parcel$export(module.exports, "DefaultRoleContext", () => $df42b5a96a433313$export$acf85578b9060d4d);
$parcel$export(module.exports, "useDefaultRole", () => $df42b5a96a433313$export$940503e6d676c973);

var $lE8gv = parcelRequire("lE8gv");
const $df42b5a96a433313$export$acf85578b9060d4d = /*#__PURE__*/ (0, $lE8gv.createContext)(undefined);
function $df42b5a96a433313$export$940503e6d676c973() {
    return (0, $lE8gv.useContext)($df42b5a96a433313$export$acf85578b9060d4d);
}

});

parcelRegister("0399H", function(module, exports) {
$parcel$export(module.exports, "register", () => $e04d81266e790a49$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $5Ifxs = parcelRequire("5Ifxs");
const $e04d81266e790a49$var$registrations = new Set();
let $e04d81266e790a49$var$cleanupEndEventListeners = null;
function $e04d81266e790a49$var$onDragStart() {
    if ($e04d81266e790a49$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $e04d81266e790a49$var$cleanupEndEventListeners = (0, $5Ifxs.bindAll)(window, [
        {
            type: 'dragend',
            listener: $e04d81266e790a49$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $e04d81266e790a49$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $e04d81266e790a49$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($e04d81266e790a49$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $e04d81266e790a49$var$onDragEnd() {
    $e04d81266e790a49$var$cleanupEndEventListeners?.();
    $e04d81266e790a49$var$cleanupEndEventListeners = null;
    const clone = Array.from($e04d81266e790a49$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $e04d81266e790a49$var$bindStartEvents() {
    return (0, $5Ifxs.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $e04d81266e790a49$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $e04d81266e790a49$var$onDragStart
        }
    ]);
}
let $e04d81266e790a49$var$cleanupStartEventListeners = null;
function $e04d81266e790a49$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$e04d81266e790a49$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $e04d81266e790a49$var$cleanupStartEventListeners = $e04d81266e790a49$var$bindStartEvents();
    $e04d81266e790a49$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $e04d81266e790a49$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $e04d81266e790a49$var$registrations.delete(registration);
        if ($e04d81266e790a49$var$registrations.size === 0) {
            $e04d81266e790a49$var$cleanupStartEventListeners?.();
            $e04d81266e790a49$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("8mTwD", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", () => $9291486a6bc4096b$export$d26fd3d066ede49);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $9291486a6bc4096b$var$getTriggerEdgeX({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $9291486a6bc4096b$var$getTriggerEdgeY({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $9291486a6bc4096b$export$d26fd3d066ede49({ cursor: cursor, triggerRect: triggerRect, tooltipPosition: tooltipPosition, placement: placement }) {
    if (tooltipPosition === 'mouse-y') return {
        x: $9291486a6bc4096b$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $9291486a6bc4096b$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("hwbeJ", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $ae051c9a51303a53$export$2e68479e0a5d8746);
function $ae051c9a51303a53$export$2e68479e0a5d8746(mousePos, { targetElement: targetElement, tooltipPosition: tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

});

parcelRegister("89KrN", function(module, exports) {
$parcel$export(module.exports, "show", () => $c27f6aaa17d3a553$export$57bf213be019eeb0);

var $fBWTV = parcelRequire("fBWTV");
let $c27f6aaa17d3a553$var$delayId = null;
function $c27f6aaa17d3a553$var$clearScheduled() {
    if ($c27f6aaa17d3a553$var$delayId != null) {
        window.clearTimeout($c27f6aaa17d3a553$var$delayId);
        $c27f6aaa17d3a553$var$delayId = null;
    }
}
function $c27f6aaa17d3a553$var$scheduleTimeout(fn, delay) {
    $c27f6aaa17d3a553$var$clearScheduled();
    $c27f6aaa17d3a553$var$delayId = window.setTimeout(()=>{
        $c27f6aaa17d3a553$var$delayId = null;
        fn();
    }, delay);
}
let $c27f6aaa17d3a553$var$active = null;
function $c27f6aaa17d3a553$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($c27f6aaa17d3a553$var$active && $c27f6aaa17d3a553$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $c27f6aaa17d3a553$var$clearScheduled();
            $c27f6aaa17d3a553$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $c27f6aaa17d3a553$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $c27f6aaa17d3a553$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $fBWTV.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $c27f6aaa17d3a553$var$scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        const shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        const showImmediately = Boolean($c27f6aaa17d3a553$var$active && $c27f6aaa17d3a553$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($c27f6aaa17d3a553$var$active) {
            $c27f6aaa17d3a553$var$clearScheduled();
            $c27f6aaa17d3a553$var$active.entry.hide({
                isImmediate: true
            });
            $c27f6aaa17d3a553$var$active.entry.done();
            $c27f6aaa17d3a553$var$active = null;
        }
        // this tooltip is now the active tooltip
        $c27f6aaa17d3a553$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $c27f6aaa17d3a553$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("kra7p", function(module, exports) {
$parcel$export(module.exports, "default", () => $079c4722a4b9a348$export$2e2bcd8739ae039);

var $74Gmc = parcelRequire("74Gmc");
function $079c4722a4b9a348$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $74Gmc.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("74Gmc", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $f4c01b34cd384eba$export$6ee17796e3d70de2);

var $GqzVB = parcelRequire("GqzVB");
function $f4c01b34cd384eba$export$6ee17796e3d70de2() {
    const uid = (0, $GqzVB.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

});


parcelRegister("iaiIy", function(module, exports) {
$parcel$export(module.exports, "default", () => $93a8aacf65cb5586$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $5mzPB = parcelRequire("5mzPB");
const $93a8aacf65cb5586$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $93a8aacf65cb5586$var$TooltipContainer = /*#__PURE__*/ (0, $lE8gv.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $5mzPB.default), {
        ref: ref,
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $l2NkF.default)([
            $93a8aacf65cb5586$var$styles.base,
            truncate && $93a8aacf65cb5586$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role,
        children: children
    });
});
$93a8aacf65cb5586$var$TooltipContainer.displayName = 'TooltipContainer';
var $93a8aacf65cb5586$export$2e2bcd8739ae039 = $93a8aacf65cb5586$var$TooltipContainer;

});
parcelRegister("5mzPB", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dcf9178d312f599$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $lE8gv = parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");

var $gF5jn = parcelRequire("gF5jn");

var $gzLXm = parcelRequire("gzLXm");
const $3dcf9178d312f599$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const $3dcf9178d312f599$var$TooltipPrimitive = /*#__PURE__*/ (0, $lE8gv.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    const defaultRole = (0, $gF5jn.useDefaultRole)();
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $kOwiQ.jsxs)("div", {
            role: role ?? defaultRole ?? 'tooltip',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $l2NkF.default)([
                "_80om73ad",
                className
            ]),
            // Because the tooltip should not be focusable, there is no reason to have key events.
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $gF5jn.DefaultRoleContext).Provider, {
                    value: undefined,
                    children: children
                }),
                shortcut && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $gzLXm.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$3dcf9178d312f599$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $3dcf9178d312f599$export$2e2bcd8739ae039 = $3dcf9178d312f599$var$TooltipPrimitive;

});
parcelRegister("gzLXm", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $05f30e6f04414857$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $l2NkF = parcelRequire("l2NkF");
const $05f30e6f04414857$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $05f30e6f04414857$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
        className: (0, $l2NkF.default)([
            $05f30e6f04414857$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $kOwiQ.jsx)("kbd", {
                className: (0, $l2NkF.default)([
                    $05f30e6f04414857$var$styles.shortcutSegment
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};

});




parcelRegister("bheDP", function(module, exports) {
$parcel$export(module.exports, "default", () => $82a699f87a8dcaa5$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */ /* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");

var $lE8gv = parcelRequire("lE8gv");

var $l9Cfa = parcelRequire("l9Cfa");

var $3ipAE = parcelRequire("3ipAE");

var $9oEM9 = parcelRequire("9oEM9");

var $GqzVB = parcelRequire("GqzVB");

var $fBWTV = parcelRequire("fBWTV");

var $cwRZg = parcelRequire("cwRZg");

var $kagwH = parcelRequire("kagwH");

var $bEOXO = parcelRequire("bEOXO");

var $kjhuW = parcelRequire("kjhuW");

var $9FxRo = parcelRequire("9FxRo");

var $9xkAQ = parcelRequire("9xkAQ");
const $82a699f87a8dcaa5$var$LOADING_LABEL = ', Loading';
const $82a699f87a8dcaa5$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_2rko12b0 _1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
const $82a699f87a8dcaa5$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $82a699f87a8dcaa5$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $82a699f87a8dcaa5$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
const $82a699f87a8dcaa5$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $82a699f87a8dcaa5$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $82a699f87a8dcaa5$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $82a699f87a8dcaa5$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $82a699f87a8dcaa5$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $82a699f87a8dcaa5$var$brandSelectedSplitButtonStyles = {
    root: "_bfhk1gmr _syaz1oa5 _8l3ma755 _aetrb3bt _10531oa5 _f8pj1oa5 _30l31oa5 _9h8h1oa5",
    interactive: "_irr33v15 _30l31oa5 _1di6u02c _9h8h1oa5"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $82a699f87a8dcaa5$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, rootXcss: rootXcss, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const localRef = (0, $lE8gv.useRef)(null);
    const splitButtonContext = (0, $kjhuW.useSplitButtonContext)();
    const loadingLabelId = (0, $GqzVB.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    // The open dropdown is part of a primary action, not a standalone selection.
    const isBrandSelectedSplitButton = isSelected && appearance === 'primary' && splitButtonContext?.appearance === 'primary' && (0, $fBWTV.fg)('platform-dst-tokens-finesse');
    (0, $9oEM9.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $cwRZg.Pressable), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $3ipAE.default)([
            localRef,
            ref
        ]),
        xcss: (0, $l9Cfa.cx)($82a699f87a8dcaa5$var$styles.base, isInteractive && $82a699f87a8dcaa5$var$styles.interactiveMotion, appearance === 'default' && $82a699f87a8dcaa5$var$defaultStyles.root, appearance === 'default' && isInteractive && $82a699f87a8dcaa5$var$defaultStyles.interactive, appearance === 'primary' && $82a699f87a8dcaa5$var$primaryStyles.root, appearance === 'primary' && isInteractive && $82a699f87a8dcaa5$var$primaryStyles.interactive, appearance === 'rovo' && $82a699f87a8dcaa5$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $82a699f87a8dcaa5$var$rovoStyles.interactive, appearance === 'warning' && $82a699f87a8dcaa5$var$warningStyles.root, appearance === 'warning' && isInteractive && $82a699f87a8dcaa5$var$warningStyles.interactive, appearance === 'danger' && $82a699f87a8dcaa5$var$dangerStyles.root, appearance === 'danger' && isInteractive && $82a699f87a8dcaa5$var$dangerStyles.interactive, appearance === 'discovery' && $82a699f87a8dcaa5$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $82a699f87a8dcaa5$var$discoveryStyles.interactive, appearance === 'subtle' && $82a699f87a8dcaa5$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $82a699f87a8dcaa5$var$subtleStyles.interactive, $82a699f87a8dcaa5$var$styles.linkDecorationUnset, isSelected && $82a699f87a8dcaa5$var$selectedStyles.root, isSelected && isSplitButton && $82a699f87a8dcaa5$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $82a699f87a8dcaa5$var$selectedStyles.interactive, isBrandSelectedSplitButton && $82a699f87a8dcaa5$var$brandSelectedSplitButtonStyles.root, isBrandSelectedSplitButton && isInteractive && $82a699f87a8dcaa5$var$brandSelectedSplitButtonStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $82a699f87a8dcaa5$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $82a699f87a8dcaa5$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $82a699f87a8dcaa5$var$selectedStyles.discovery, isDisabled && $82a699f87a8dcaa5$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $82a699f87a8dcaa5$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $82a699f87a8dcaa5$var$defaultStyles.disabled, spacing === 'compact' && $82a699f87a8dcaa5$var$styles.spacingCompact, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $82a699f87a8dcaa5$var$styles.circle, shouldFitContainer && $82a699f87a8dcaa5$var$styles.fullWidth, hasIconBefore && $82a699f87a8dcaa5$var$styles.buttonIconBefore, hasIconAfter && $82a699f87a8dcaa5$var$styles.buttonIconAfter, isIconButton && $82a699f87a8dcaa5$var$styles.iconButton, isIconButton && spacing === 'compact' && $82a699f87a8dcaa5$var$styles.iconButtonCompact, isLoading && $82a699f87a8dcaa5$var$styles.loading, isSplitButton && $82a699f87a8dcaa5$var$styles.splitButton, isNavigationSplitButton && $82a699f87a8dcaa5$var$styles.navigationSplitButton, rootXcss),
        isDisabled: isDisabled,
        "aria-live": "polite",
        ...isLoading && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$82a699f87a8dcaa5$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $9FxRo.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $kOwiQ.jsxs)((0, $bEOXO.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
                    className: (0, $l2NkF.default)([
                        $82a699f87a8dcaa5$var$styles.loadingOverlay
                    ]),
                    children: (0, $9xkAQ.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kagwH.default), {
                    id: loadingLabelId,
                    children: $82a699f87a8dcaa5$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $82a699f87a8dcaa5$export$2e2bcd8739ae039 = $82a699f87a8dcaa5$var$ButtonBase;

});
parcelRegister("l9Cfa", function(module, exports) {
$parcel$export(module.exports, "cx", () => $d0f3be8a2ac71c50$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("lE8gv");

var $9Ferw = parcelRequire("9Ferw");
const $d0f3be8a2ac71c50$var$strictApi = (0, $9Ferw.createStrictAPI)();
const $d0f3be8a2ac71c50$export$dbf350e5966cf602 = $d0f3be8a2ac71c50$var$strictApi.css;
const $d0f3be8a2ac71c50$export$eb1ecd84a24ee424 = $d0f3be8a2ac71c50$var$strictApi.cssMap;
$d0f3be8a2ac71c50$var$strictApi.cssMap;
const $d0f3be8a2ac71c50$export$a274e22fb40f762e = $d0f3be8a2ac71c50$var$strictApi.cx;
const $d0f3be8a2ac71c50$var$XCSSProp = $d0f3be8a2ac71c50$var$strictApi.XCSSProp;

});
parcelRegister("9Ferw", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $7093256e6442dbde$export$39716b4af53f4ad);

var $66Rj0 = parcelRequire("66Rj0");

var $adpJV = parcelRequire("adpJV");
function $7093256e6442dbde$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $66Rj0.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $66Rj0.createStrictSetupError)();
        },
        cx: $adpJV.cx,
        XCSSProp () {
            throw (0, $66Rj0.createStrictSetupError)();
        }
    };
} //# sourceMappingURL=index.js.map

});
parcelRegister("66Rj0", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $472ca6f75af11f93$export$c4df1cb0c2b4d77c);
const $472ca6f75af11f93$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $472ca6f75af11f93$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});



parcelRegister("bEOXO", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $3ecdfb9fb1aa577c$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $lE8gv = parcelRequire("lE8gv");
const $3ecdfb9fb1aa577c$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $lE8gv.createContext)(undefined);

});

parcelRegister("kjhuW", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $7893ee1ba9a4a9f3$export$47e2c6fdb142d947);

var $lE8gv = parcelRequire("lE8gv");

var $bEOXO = parcelRequire("bEOXO");
const $7893ee1ba9a4a9f3$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $lE8gv.useContext)((0, $bEOXO.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("9FxRo", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f6be97d5df917f9$export$2e2bcd8739ae039);
function $9f6be97d5df917f9$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $9f6be97d5df917f9$var$tabKeyCode = 9;
function $9f6be97d5df917f9$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $9f6be97d5df917f9$var$tabKeyCode) return;
    $9f6be97d5df917f9$var$abort(event);
}
function $9f6be97d5df917f9$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $9f6be97d5df917f9$var$abort,
        onMouseUpCapture: $9f6be97d5df917f9$var$abort,
        onKeyDownCapture: $9f6be97d5df917f9$var$onKey,
        onKeyUpCapture: $9f6be97d5df917f9$var$onKey,
        onTouchStartCapture: $9f6be97d5df917f9$var$abort,
        onTouchEndCapture: $9f6be97d5df917f9$var$abort,
        onPointerDownCapture: $9f6be97d5df917f9$var$abort,
        onPointerUpCapture: $9f6be97d5df917f9$var$abort,
        onClickCapture: $9f6be97d5df917f9$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $9f6be97d5df917f9$var$abort
    } : events;
}

});

parcelRegister("9xkAQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8e3795c6f007f17$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $4zqUT = parcelRequire("4zqUT");
function $c8e3795c6f007f17$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $c8e3795c6f007f17$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $c8e3795c6f007f17$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $4zqUT.default), {
        size: $c8e3795c6f007f17$var$getIconSpacing(spacing),
        appearance: $c8e3795c6f007f17$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("FibV7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c73c68baa2ea9f7$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");
parcelRequire("lE8gv");
const $6c73c68baa2ea9f7$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $6c73c68baa2ea9f7$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, $kOwiQ.jsx)("span", {
        className: (0, $l2NkF.default)([
            $6c73c68baa2ea9f7$var$styles.common,
            type === 'text' && $6c73c68baa2ea9f7$var$styles.text,
            type === 'icon' && $6c73c68baa2ea9f7$var$styles.icon,
            isLoading && $6c73c68baa2ea9f7$var$styles.fade
        ]),
        children: children
    });
};
var $6c73c68baa2ea9f7$export$2e2bcd8739ae039 = $6c73c68baa2ea9f7$var$Content;

});

parcelRegister("kQVzY", function(module, exports) {
$parcel$export(module.exports, "default", () => $edafb7e89a5cc28c$export$2e2bcd8739ae039);

var $kOwiQ = parcelRequire("kOwiQ");
parcelRequire("lE8gv");

var $fBWTV = parcelRequire("fBWTV");
function $edafb7e89a5cc28c$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $edafb7e89a5cc28c$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $edafb7e89a5cc28c$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $fBWTV.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $kOwiQ.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $kOwiQ.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $edafb7e89a5cc28c$export$2e2bcd8739ae039 = $edafb7e89a5cc28c$var$IconRenderer;

});


parcelRegister("knsAY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97fadb77040fc214fca377f612fb6ef3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed5c230f898ae40f$var$_react = $ed5c230f898ae40f$var$_interopRequireDefault((parcelRequire("lE8gv")));

var $ed5c230f898ae40f$var$_iconNew = $ed5c230f898ae40f$var$_interopRequireDefault((parcelRequire("1jPqJ")));
function $ed5c230f898ae40f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-mark
 * Usage guidance:
 * Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed5c230f898ae40f$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ed5c230f898ae40f$var$_react.default.createElement($ed5c230f898ae40f$var$_iconNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$ed5c230f898ae40f$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $ed5c230f898ae40f$var$_default = module.exports.default = $ed5c230f898ae40f$var$CheckMarkIcon;

});

parcelRegister("0QaiM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe87206c037b1ad46cb54a88ca95fa3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0028771da18ea6d8$var$_react = $0028771da18ea6d8$var$_interopRequireDefault((parcelRequire("lE8gv")));

var $0028771da18ea6d8$var$_iconNew = $0028771da18ea6d8$var$_interopRequireDefault((parcelRequire("1jPqJ")));
function $0028771da18ea6d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0028771da18ea6d8$var$CrossIcon = (props)=>/*#__PURE__*/ $0028771da18ea6d8$var$_react.default.createElement($0028771da18ea6d8$var$_iconNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$0028771da18ea6d8$var$CrossIcon.displayName = 'CrossIcon';
var $0028771da18ea6d8$var$_default = module.exports.default = $0028771da18ea6d8$var$CrossIcon;

});


parcelRegister("ipZb0", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f7adb0cd6f25eba$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");
/**
 * Recursively extracts plain text content from a ReactNode.
 *
 * This is useful when a ReactNode needs to be represented as a string,
 * e.g. for use in an `aria-label` attribute.
 */ const $3f7adb0cd6f25eba$var$getTextFromReactNode = (node)=>{
    if (node == null || typeof node === 'boolean') return '';
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($3f7adb0cd6f25eba$var$getTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lE8gv))).isValidElement(node)) return $3f7adb0cd6f25eba$var$getTextFromReactNode(node.props.children);
    return '';
};
var $3f7adb0cd6f25eba$export$2e2bcd8739ae039 = $3f7adb0cd6f25eba$var$getTextFromReactNode;

});

parcelRegister("aana3", function(module, exports) {
$parcel$export(module.exports, "default", () => $eeb98861bdfc2f9b$export$2e2bcd8739ae039);

var $lE8gv = parcelRequire("lE8gv");
const $eeb98861bdfc2f9b$var$usePrevious = (value)=>{
    const ref = (0, $lE8gv.useRef)();
    (0, $lE8gv.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $eeb98861bdfc2f9b$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $lE8gv.useRef)(null);
    const editViewRef = (0, $lE8gv.useRef)();
    const preventFocusOnEditButtonRef = (0, $lE8gv.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $eeb98861bdfc2f9b$var$usePrevious(shouldBeEditing);
    (0, $lE8gv.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $lE8gv.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $eeb98861bdfc2f9b$export$2e2bcd8739ae039 = $eeb98861bdfc2f9b$var$useButtonFocusHook;

});

parcelRegister("9Ffg2", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd5b2cbb8abda2b4$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");

var $lE8gv = parcelRequire("lE8gv");

var $cwRZg = parcelRequire("cwRZg");
const $cd5b2cbb8abda2b4$var$readViewContainerStyles = null;
const $cd5b2cbb8abda2b4$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189eidpf _1dqoglyw _1h6d1j28 _1e0c1ule _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _r06hglyw _bfhk1j28 _vwz4kb7n _1xp41v1w _14lydkaa _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $cd5b2cbb8abda2b4$var$readViewWrapperStyles = null;
const $cd5b2cbb8abda2b4$var$readViewFitContainerWidthStyles = null;
const $cd5b2cbb8abda2b4$var$DRAG_THRESHOLD = 5;
const $cd5b2cbb8abda2b4$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $lE8gv.useRef)(0);
    const startY = (0, $lE8gv.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>Math.abs(startX.current - event.clientX) >= $cd5b2cbb8abda2b4$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $cd5b2cbb8abda2b4$var$DRAG_THRESHOLD;
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $kOwiQ.jsxs)("div", {
        className: (0, $l2NkF.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $kOwiQ.jsx)((0, $cwRZg.Pressable), {
                xcss: $cd5b2cbb8abda2b4$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $kOwiQ.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $l2NkF.default)([
                    "_2rko1qi0 _v564k6bl _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr31dpa",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cd5b2cbb8abda2b4$export$2e2bcd8739ae039 = $cd5b2cbb8abda2b4$var$ReadView;

});


parcelRegister("cstvi", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ae54aa3a7e1dea7$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kOwiQ = parcelRequire("kOwiQ");

var $l2NkF = parcelRequire("l2NkF");

var $lE8gv = parcelRequire("lE8gv");

var $lC4HT = parcelRequire("lC4HT");

var $fBWTV = parcelRequire("fBWTV");
const $7ae54aa3a7e1dea7$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $7ae54aa3a7e1dea7$var$inputMediaDisabled = null;
const $7ae54aa3a7e1dea7$var$analyticsParams = {
    componentName: 'textField',
    packageName: undefined,
    packageVersion: undefined
};
const $7ae54aa3a7e1dea7$var$disabledStyle = {
    standard: "_1h6d187o _bfhk187o _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
const $7ae54aa3a7e1dea7$var$invalidStyle = null;
const $7ae54aa3a7e1dea7$var$focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
const $7ae54aa3a7e1dea7$var$hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
const $7ae54aa3a7e1dea7$var$inputMotionStyles = {
    legacy: "_v564r5cv",
    base: "_v56497ke"
};
const $7ae54aa3a7e1dea7$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
const $7ae54aa3a7e1dea7$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $7ae54aa3a7e1dea7$var$getMaxWidth = (width)=>!width ? `100%` : width in $7ae54aa3a7e1dea7$var$widthMap ? `${$7ae54aa3a7e1dea7$var$widthMap[width]}px` : `${+width}px`;
const $7ae54aa3a7e1dea7$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $7ae54aa3a7e1dea7$var$containerStyles = null;
const $7ae54aa3a7e1dea7$var$inputDisabledStyle = null;
const $7ae54aa3a7e1dea7$var$inputCompactStyle = null;
const $7ae54aa3a7e1dea7$var$inputMonospacedStyle = null;
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textfield uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $7ae54aa3a7e1dea7$var$inputStyle = null;
const $7ae54aa3a7e1dea7$var$finessePlaceholderStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $7ae54aa3a7e1dea7$var$Textfield = /*#__PURE__*/ (0, $lE8gv.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const isInputMotionEnabled = (0, $fBWTV.fg)('platform-dst-motion-uplift-input');
    const isInteractive = !isDisabled && !isReadOnly;
    const inputRef = (0, $lE8gv.useRef)(null);
    const handleOnFocus = (0, $lC4HT.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$7ae54aa3a7e1dea7$var$analyticsParams
    });
    const handleOnBlur = (0, $lC4HT.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$7ae54aa3a7e1dea7$var$analyticsParams
    });
    const handleOnMouseDown = (0, $lE8gv.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $lE8gv.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $kOwiQ.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$7ae54aa3a7e1dea7$var$getMaxWidth(width)}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $l2NkF.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1qi0",
            !isInputMotionEnabled && $7ae54aa3a7e1dea7$var$inputMotionStyles.legacy,
            isInputMotionEnabled && isInteractive && $7ae54aa3a7e1dea7$var$inputMotionStyles.base,
            $7ae54aa3a7e1dea7$var$getContainerTextBgAndBorderColor[appearance],
            $7ae54aa3a7e1dea7$var$containerStyleAppearance[appearance],
            !isDisabled && $7ae54aa3a7e1dea7$var$focusWithinStyle[appearance],
            !isDisabled && $7ae54aa3a7e1dea7$var$hoverStyle[appearance],
            isDisabled && $7ae54aa3a7e1dea7$var$containerMedia.disabled,
            isDisabled && $7ae54aa3a7e1dea7$var$disabledStyle[appearance],
            isInvalid && $7ae54aa3a7e1dea7$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $kOwiQ.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                // TODO: When removing legacy theming fix this.
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $l2NkF.default)([
                    "_19itidpf _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _j4tm1d4k _1tmk12x7 _npz312x7 _1j6u12x7 _1ark12x7",
                    (0, $fBWTV.fg)('platform-dst-tokens-finesse') && "_1idrazsu",
                    isMonospaced && "_ect4zzfg _1f2rzzfg",
                    isCompact && "_11zp1b66 _1l021b66 _daj712x7 _141f12x7 _rzs1v77o _141av77o _mwav12x7 _1aex12x7",
                    isDisabled && "_syaz1gmx _1idr1gmx",
                    isDisabled && "_1fnx18qt"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $7ae54aa3a7e1dea7$export$2e2bcd8739ae039 = $7ae54aa3a7e1dea7$var$Textfield;

});






parcelRegister("7sG1y", function(module, exports) {
$parcel$export(module.exports, "RouteNames", () => $6d422fe67bb85917$export$f4bfbadc8ccd5fbc);
var $6d422fe67bb85917$export$f4bfbadc8ccd5fbc = /*#__PURE__*/ function(RouteNames) {
    RouteNames["MARKETPLACE_APP_LIST_PAGE"] = "marketplace-app-list-page";
    RouteNames["MARKETPLACE_APP_DETAILS_PAGE"] = "marketplace-app-details";
    RouteNames["MASTER_ORG_LANDING"] = "master-org-landing-page";
    RouteNames["ORG_DETAILS_PAGE"] = "org-details-page";
    RouteNames["ORG_PROFILE_PAGE"] = "org-profile-page";
    RouteNames["ADMIN_PAGE"] = "admin-page";
    RouteNames["AUTH_POLICY_PAGE"] = "authentication-policies-page";
    RouteNames["API_TOKENS_PAGE"] = "api-tokens-page";
    RouteNames["DOMAIN_CLAIM_DETAILS_PAGE"] = "domain-claim-details-page";
    RouteNames["DOMAIN_CLAIM"] = "domain-claim-page";
    RouteNames["USER_PROVISIONING_VORTEX"] = "user-provisioning-page-vortex";
    RouteNames["CLAIM_PAGE"] = "claim-page";
    RouteNames["MEMBER_PAGE"] = "member-page";
    RouteNames["MEMBER_DETAIL_PAGE"] = "member-detail-page";
    RouteNames["AUDIT_LOG_PAGE"] = "audit-log-page";
    RouteNames["AUDIT_LOG_PAGE_SEARCH"] = "audit-log-page-search";
    RouteNames["AUDIT_LOG_ASYNC_QUERY_RESULTS_PAGE"] = "audit-log-async-query-results-page";
    RouteNames["UNIT_AUDIT_LOG_ASYNC_QUERY_RESULTS_PAGE"] = "unit-audit-log-async-query-results-page";
    RouteNames["AUDIT_LOG_EXPORT_DOWNLOAD"] = "audit-log-export-download-page";
    RouteNames["AUDIT_LOG_ACTIVITIES_PAGE"] = "audit-logs-activity-settings-page";
    RouteNames["SITE_AUDIT_LOG_PAGE"] = "site-audit-log-page";
    RouteNames["SITE_AUDIT_LOG_SEARCH_PAGE"] = "site-audit-log-search-page";
    RouteNames["SITE_AUDIT_LOG_ASYNC_QUERY_RESULTS_PAGE"] = "site-audit-log-async-query-results-page";
    RouteNames["EXPORT_DOWNLOAD"] = "export-download-page";
    RouteNames["SITE_APP_EXPORT_DOWNLOAD"] = "site-app-export-download-page";
    RouteNames["UNIT_ADMIN_EXPORT_DOWNLOAD"] = "unit-admin-export-download-page";
    RouteNames["SERVICE_ACCOUNTS_PAGE"] = "service-accounts-page";
    RouteNames["ACTORS_PAGE"] = "actors-page";
    RouteNames["ACTOR_DETAILS_PAGE"] = "actor-details-page";
    RouteNames["ORG_SITES_PREVIEW_PAGE"] = "org-sites-preview-page";
    RouteNames["SERVICE_ACCOUNT_DETAILS_PAGE"] = "service-account-details-page";
    RouteNames["USERS_PAGE"] = "unified-users-page";
    RouteNames["GROUPS_PAGE"] = "groups-page";
    RouteNames["UNIFIED_USER_PROFILE_PAGE"] = "unified-user-profile-page";
    RouteNames["UNIFIED_GROUPS_PAGE"] = "unified-groups-page";
    RouteNames["UNIFIED_GROUP_DETAILS_PAGE"] = "unified-group-details-page";
    RouteNames["UNIFIED_SITE_GROUPS_PAGE"] = "unified-site-groups-page";
    RouteNames["UNIFIED_SITE_GROUP_DETAILS_PAGE"] = "unified-site-group-details-page";
    RouteNames["UNIFIED_SITE_USERS_PAGE"] = "unified-site-users-page";
    RouteNames["UNIFIED_SITE_USER_PROFILE_PAGE"] = "unified-site-user-profile-page";
    RouteNames["UNIT_LIST_PAGE"] = "unit-list-page";
    RouteNames["UNIT_PROFILE_PAGE"] = "unit-profile-page";
    RouteNames["UNIT_LAUNCH_PAGE"] = "unit-launch-page";
    RouteNames["UNIT_SETTINGS_PAGE"] = "unit-settings-page";
    RouteNames["UNIT_DEBUG_PAGE"] = "unit-debug-page";
    RouteNames["UNIT_PROVISIONING_RULES_PAGE"] = "unit-provisioning-rules-page";
    RouteNames["FOOTPRINT_PAGE"] = "footprint-page";
    RouteNames["USER_EXPORT_DOWNLOAD_PAGE"] = "user-export-download-page";
    RouteNames["DIRECTORY_EXPORT_DOWNLOAD_PAGE"] = "directory-export-download-page";
    RouteNames["COMPLIANCE_PAGE"] = "compliance-page";
    RouteNames["COMPLIANCE_BAA_FEATURE_GATE_PAGE"] = "compliance-baa-feature-gate-page";
    RouteNames["COMPLIANCE_DATA_RETENTION_PAGE"] = "compliance-data-retention-page";
    RouteNames["DATA_RETENTION_PAGE"] = "data-retention-page";
    RouteNames["MANAGED_LABELS_PAGE"] = "managed-labels-page";
    RouteNames["GOVERNANCE_MANAGER_V2_PAGE"] = "governance-manager-v2-page";
    RouteNames["ROVO_PAGE"] = "rovo-page";
    RouteNames["CONNECTOR_DETAIL_PAGE"] = "connector-detail-page";
    RouteNames["MIGRATION_DATA_MANAGEMENT_PAGE"] = "migration-data-management-page";
    RouteNames["SAML_PAGE"] = "saml-page";
    RouteNames["TEAMS_DIRECTORY_PAGE"] = "teams-directory-page";
    RouteNames["TEAMS_PROFILE_PAGE"] = "teams-profile-page";
    RouteNames["DATA_CLASSIFICATION_DETAILS_PAGE"] = "data-classification-details-page";
    RouteNames["DATA_CLASSIFICATION_SETTINGS_PAGE"] = "data-classification-settings-page";
    RouteNames["DATA_CLASSIFICATION_PAGE"] = "data-classification-page";
    RouteNames["DATA_SECURITY_POLICIES_DETAILS"] = "data-security-policies-details-page";
    RouteNames["DATA_SECURITY_POLICIES"] = "data-security-policies-page";
    RouteNames["DATA_SECURITY_POLICY"] = "data-security-policy";
    RouteNames["DETECTION_LIBRARY_PAGE"] = "detection-library-page";
    RouteNames["FINDINGS_PAGE"] = "findings-page";
    RouteNames["VIOLATIONS_LIST_PAGE"] = "violations-list-page";
    RouteNames["VIOLATIONS_DETAILS_PAGE"] = "violations-details-page";
    RouteNames["DATA_LOSS_PREVENTION_APP_ACCESS_CONTROL_PAGE"] = "data-loss-prevention-app-access-control-page";
    RouteNames["DATA_LOSS_PREVENTION_SIMPLE_CONTROL_PAGE"] = "data-loss-prevention-simple-control-page";
    RouteNames["USER_PROVISIONING_PAGE"] = "user-provisioning-page";
    RouteNames["OSYNC_PAGE"] = "osync-page";
    RouteNames["GSUITE_PAGE"] = "g-suite-page";
    RouteNames["PRODUCTS_LIST"] = "products-list-page";
    RouteNames["PRODUCTS_OVERVIEW"] = "products-overview-page";
    RouteNames["USER_REQUESTS_PAGE"] = "user-requests-page";
    RouteNames["LINK_ON_PREM_PRODUCTS_DASHBOARD"] = "link-on-prem-products-dashboard-page";
    RouteNames["DATA_TRANSFER_PAGE"] = "data-transfer-page";
    RouteNames["DATA_EXPORT_PAGE"] = "data-export-page";
    RouteNames["DATA_EXPORT_CREATE_POLICY_PAGE"] = "data-export-create-policy-page";
    RouteNames["DATA_EXPORT_EDIT_POLICY_PAGE"] = "data-export-edit-policy-page";
    RouteNames["DATA_EXPORT_POLICY_DETAILS_PAGE"] = "data-export-policy-details-page";
    RouteNames["REMEDIATIONS_PAGE"] = "remediations-page";
    RouteNames["CONTACTS_PAGE"] = "contacts-page";
    RouteNames["USER_COUNTS_DETAILS"] = "user-counts-details-page";
    RouteNames["USER_COUNTS_LANDING"] = "user-counts-landing-page";
    RouteNames["MOBILE_SECURITY_SETTINGS"] = "mobile-security-settings-page";
    RouteNames["USER_ACCESS_SETTINGS"] = "user-access-settings-page";
    RouteNames["APP_ACCESS_SETTINGS"] = "app-access-settings-page";
    RouteNames["APP_CONTAINER_PAGE"] = "app-container-page";
    RouteNames["DISCOVERED_PRODUCTS"] = "discovered-products-page";
    RouteNames["SHADOW_IT_APPS"] = "shadow-it-apps-page";
    RouteNames["SECURE_TUNNELS_PAGE"] = "secure-tunnels-page";
    RouteNames["EMAILS_PAGE"] = "emails-page";
    RouteNames["EMAIL_CONTENT_PAGE"] = "email-content-page";
    RouteNames["BILLING_PREVIEW_PAGE"] = "billing-preview-page";
    RouteNames["MOBILE_SECURITY_PAGE"] = "mobile-security-page";
    RouteNames["USER_TIER_PAGE"] = "user-tier-page";
    RouteNames["BRIE_DASHBOARD_PAGE"] = "brie-dashboard-page";
    RouteNames["BRIE_POLICY_DETAILS_PAGE"] = "brie-policy-details-page";
    RouteNames["BRIE_CREATE_POLICY_PAGE"] = "brie-create-policy-page";
    RouteNames["BRIE_RESTORE_BACKUP_PAGE"] = "brie-restore-backup-page";
    RouteNames["PRODUCT_REQUESTS_SETTING_PAGE"] = "product-requests-setting-page";
    RouteNames["ATLASSIAN_INTELLIGENCE_PAGE"] = "atlassian-intelligence-page";
    RouteNames["AI_ENABLED_APPS_PAGE"] = "ai-enabled-apps-page";
    RouteNames["ROVO_ACCESS_PAGE"] = "rovo-access-page";
    RouteNames["ROVO_ACCESS_PAGE_ROVO_AND_AI_CHILD"] = "rovo-access-page-rovo-and-ai-child";
    RouteNames["ROVO_OVERVIEW_PAGE"] = "rovo-overview-page";
    RouteNames["ROVO_OVERVIEW_PAGE_ROVO_AND_AI_CHILD"] = "rovo-overview-page-rovo-and-ai-child";
    RouteNames["ROVO_SETTINGS_PAGE"] = "rovo-settings-page";
    RouteNames["ROVO_SETTINGS_PAGE_ROVO_AND_AI_CHILD"] = "rovo-settings-page-rovo-and-ai-child";
    RouteNames["ROVO_MCP_SERVER_PAGE"] = "rovo-mcp-server-page";
    RouteNames["ROVO_MCP_SERVER_PAGE_INTEGRATIONS_CHILD"] = "rovo-mcp-server-page-integrations-child";
    RouteNames["ROVO_A2A_PAGE"] = "rovo-a2a-page";
    RouteNames["ROVO_A2A_PAGE_ROVO_AND_AI_CHILD"] = "rovo-a2a-page-rovo-and-ai-child";
    RouteNames["TWG_CLI_SETTINGS_PAGE"] = "twg-cli-settings-page";
    RouteNames["TWG_CLI_SETTINGS_PAGE_LEGACY"] = "twg-cli-settings-page-legacy";
    RouteNames["TWG_CLI_SETTINGS_PAGE_INTEGRATIONS_CHILD"] = "twg-cli-settings-page-integrations-child";
    RouteNames["CODE_CONTEXT_PAGE"] = "code-context-page";
    RouteNames["CODE_CONTEXT_PAGE_INTEGRATIONS_CHILD"] = "code-context-page-integrations-child";
    RouteNames["TEAMWORK_GRAPH_PAGE"] = "teamwork-graph-page";
    RouteNames["TEAMWORK_GRAPH_PAGE_INTEGRATIONS_CHILD"] = "teamwork-graph-page-integrations-child";
    RouteNames["ROVO_CONNECTORS_PAGE"] = "rovo-connectors-page";
    RouteNames["ROVO_CONNECTORS_PAGE_INTEGRATIONS_CHILD"] = "rovo-connectors-page-integrations-child";
    RouteNames["ROVO_INSIGHTS_NAV_PAGE"] = "rovo-insights-nav-page";
    RouteNames["ROVO_INSIGHTS_NAV_PAGE_ROVO_AND_AI_CHILD"] = "rovo-insights-nav-page-rovo-and-ai-child";
    RouteNames["TOWNSQUARE_PAGE"] = "townsquare-page";
    RouteNames["COMPLIANCE_MANAGE_PRODUCT_PAGE"] = "compliance-manage-product-page";
    RouteNames["PRODUCT_REQUESTS_PAGE"] = "product-requests-page";
    RouteNames["API_KEYS_PAGE"] = "api-keys-page";
    RouteNames["API_KEYS_AND_OAUTH_PAGE"] = "api-keys-and-oauth-page";
    RouteNames["MCP_SETTINGS_PAGE"] = "mcp-settings-page";
    RouteNames["CUSTOM_DOMAINS_DETAILS_PAGE"] = "custom-domains-details-page";
    RouteNames["SECURITY_CHECKLIST_PAGE"] = "security-checklist-page";
    RouteNames["UNIFIED_POLICY_PAGE"] = "unified-policy-page";
    RouteNames["UNIFIED_POLICY_DETAILS_PAGE"] = "unified-policy-details-page";
    RouteNames["UNIFIED_POLICY_DETAILS_VERSION_PAGE"] = "unified-policy-details-version-page";
    RouteNames["CREATE_WITH_ROVO_PREVIEW_PAGE"] = "create-with-rovo-preview-page";
    RouteNames["UGC_LANDING_PAGE_V2"] = "ugc-landing-page-v2";
    RouteNames["RELEASE_TRACKS_PAGE"] = "release-tracks-page";
    RouteNames["EXPERIMENT_CONTROLS_PAGE"] = "experiment-controls-page";
    RouteNames["IDENTITY_PROVIDERS_PAGE"] = "identity-providers-page";
    RouteNames["DATA_RESIDENCY_PAGE"] = "data-residency-page";
    RouteNames["DATA_RESIDENCY_SETTINGS_PAGE"] = "data-residency-settings-page";
    RouteNames["ENCRYPTION_PAGE"] = "encryption-page";
    RouteNames["LINKS_MIGRATION_PAGE"] = "links-migration-page";
    RouteNames["USER_MERGE_HOME_PAGE"] = "user-merge-home-page";
    RouteNames["USER_MERGE_START_PAGE"] = "user-merge-start-page";
    RouteNames["LINKS_MIGRATION_AUDIT_LOG_PAGE"] = "links-migration-audit-log-page";
    RouteNames["C2C_MIGRATION_DASHBOARD_PAGE"] = "cloud-to-cloud-migration-dashboard-page";
    RouteNames["MIGRATION_DASHBOARD_PAGE"] = "migration-dashboard-page";
    RouteNames["MIGRATION_PLAN_SCOPE_DETAILS"] = "migration-plan-scope-details";
    RouteNames["PRODUCT_URLS_PAGE"] = "product-urls-page";
    RouteNames["INSIGHTS_PAGE"] = "insights-page";
    RouteNames["ANALYTICS_PAGE"] = "analytics-page";
    RouteNames["ROVO_INSIGHTS_PAGE"] = "rovo-insights-page";
    RouteNames["ROVO_TRENDS_PAGE"] = "rovo-trends-page";
    RouteNames["ROVO_CHAT_PROTECTION_PAGE"] = "rovo-chat-protection-page";
    RouteNames["ROVO_CHAT_PROTECTION_PAGE_ROVO_AND_AI_CHILD"] = "rovo-chat-protection-page-rovo-and-ai-child";
    RouteNames["CONNECTOR_PROTECTION_PAGE"] = "connector-protection-page";
    RouteNames["CONNECTOR_PROTECTION_PAGE_ROVO_AND_AI_CHILD"] = "connector-protection-page-rovo-and-ai-child";
    RouteNames["USAGE_SETTINGS_PAGE"] = "usage-settings-page";
    RouteNames["PLATFORM_USAGE_LANDING_PAGE"] = "platform-usage-landing-page";
    RouteNames["METERS_PAGE"] = "meters-page";
    RouteNames["PLATFORM_USAGE_DETAILS_PAGE"] = "platform-usage-details-page";
    RouteNames["METERS_DETAILS_PAGE"] = "meters-details-page";
    // TODO: EMER-351: Remove this route when we can deprecate meteringBucketId logic
    RouteNames["PLATFORM_USAGE_DETAILS_LEGACY_PAGE_WITH_METERING_BUCKET_ID"] = "platform-usage-details-legacy-page-with-metering-bucket-id";
    RouteNames["IP_ALLOWLIST_PAGE"] = "ip-allowlist-page";
    RouteNames["IP_ALLOWLIST_POLICY_DETAILS_PAGE"] = "ip-allowlist-policy-details-page";
    RouteNames["TENANT_ACCESS_RESTRICTIONS_PAGE"] = "tenant-access-restrictions-page";
    RouteNames["TENANT_ACCESS_RESTRICTIONS_POLICY_DETAILS_PAGE"] = "tenant-access-restrictions-policy-details-page";
    RouteNames["CONDITIONAL_ACCESS_POLICIES_PAGE"] = "conditional-access-policies-page";
    RouteNames["CONDITIONAL_ACCESS_POLICY_DETAILS_PAGE"] = "conditional-access-policy-details-page";
    RouteNames["IDENTITY_PROVIDERS_DETAILS_PAGE"] = "identity-providers-details-page";
    RouteNames["SANDBOX_PAGE"] = "sandbox-page";
    RouteNames["SANDBOXES_PAGE"] = "sandboxes-page";
    RouteNames["SANDBOX_CREATE_DEPLOYMENT_PAGE"] = "sandbox-create-deployment-page";
    RouteNames["SANDBOXES_CREATE_DEPLOYMENT_PAGE"] = "sandboxes-create-deployment-page";
    RouteNames["SANDBOXES_DEPLOYMENT_PAGE"] = "sandboxes-deployment-page";
    RouteNames["SANDBOX_DEPLOYMENT_PAGE"] = "sandbox-deployment-page";
    RouteNames["SANDBOXES_DEPLOYMENT_REPORT_PAGE"] = "sandboxes-deployment-report-page";
    RouteNames["SANDBOX_DEPLOYMENT_REPORT_PAGE"] = "sandbox-deployment-report-page";
    RouteNames["SANDBOX_DETAILS_PAGE"] = "sandbox-details-page";
    RouteNames["SANDBOXES_DETAILS_PAGE"] = "sandboxes-details-page";
    RouteNames["SANDBOX_UNIT_DETAILS_PAGE"] = "sandbox-unit-details-page";
    RouteNames["AUTH_POLICIES_DETAILS_PAGE"] = "authentication-policies-details-page";
    RouteNames["AUTH_POLICIES_PAGE"] = "auth-policies-page";
    RouteNames["EXTERNAL_USER_SECURITY_PAGE_POLICY"] = "external-user-security-page-policy";
    RouteNames["LOGIN_CUSTOMIZATION_PAGE"] = "login-customisation-page";
    RouteNames["AUTH_POLICIES_AUTOMATION_PAGE"] = "auth-policies-automation-page";
    RouteNames["GLOBAL_AUTOMATION_PAGE"] = "global-automations-page";
    RouteNames["EXTERNAL_USER_SECURITY_PAGE"] = "external-user-security-page";
    RouteNames["PRODUCT_DETAILS_PAGE"] = "product-details-page";
    RouteNames["DATA_RESIDENCY_APP_DETAILS_PAGE"] = "data-residency-app-details-page";
    RouteNames["ENCRYPTION_POLICY_DETAILS"] = "encryption-policy-details-page";
    RouteNames["C2C_MIGRATION_DETAILS_PAGE"] = "cloud-to-cloud-migration-details-page";
    RouteNames["C2C_MIGRATION_CREATE_PAGE"] = "cloud-to-cloud-migration-create-page";
    RouteNames["C2D_MIGRATION_CREATE_PAGE"] = "c2d-migration-create-page";
    RouteNames["MIGRATION_CONTROL_CENTER_PAGE"] = "migration-control-center-page";
    RouteNames["AVIATOR_ROUTER"] = "aviator-router";
    RouteNames["PRODUCT_UPDATES"] = "product-updates-routes";
    RouteNames["ENVIRONMENTS"] = "environments-page";
    RouteNames["ENVIRONMENT_DETAILS_PAGE"] = "environment-details-page";
    RouteNames["PIPELINE_ENVIRONMENT_DETAILS_PAGE"] = "pipeline-environment-details-page";
    RouteNames["PIPELINES"] = "pipelines-page";
    RouteNames["FREEZE_WINDOWS"] = "freeze-windows-page";
    RouteNames["GSUITE_SETTINGS"] = "g-suite-settings";
    RouteNames["GSUITE_SETUP"] = "g-suite-setup";
    RouteNames["EXTERNAL_USERS_POLICY_USERS"] = "external-users-policy-users";
    RouteNames["EXTERNAL_USERS_POLICY_ID"] = "external-users-policy-id";
    RouteNames["EXTERNAL_USER_DEFAULT_POLICY"] = "external-users-default-policy";
    RouteNames["EXTERNAL_USER_POLICY"] = "external-users-policy";
    RouteNames["EXTERNAL_USER_DEFAULT"] = "external-users-default";
    RouteNames["PRODUCT_UPDATES_CHANGELOG_DETAILS_PAGE"] = "product-updates-changelog-details-page";
    RouteNames["PRODUCT_UPDATES_LIST_VIEW_PAGE"] = "product-updates-list-view-page";
    RouteNames["IDENTITY_PROVIDERS_SAML_PAGE"] = "identity-providers-saml-page";
    RouteNames["IDENTITY_PROVIDERS_SCIM_PAGE"] = "identity-providers-scim-page";
    RouteNames["IDENTITY_PROVIDERS_GSUITE_PAGE"] = "identity-providers-g-suite-page";
    RouteNames["IDENTITY_PROVIDERS_OSYNC_PAGE"] = "identity-providers-osync-page";
    RouteNames["IDENTITY_PROVIDERS_GROUPS_PAGE"] = "identity-providers-groups-page";
    RouteNames["IDENTITY_PROVIDERS_DOMAINS_PAGE"] = "identity-providers-linked-domains-page";
    RouteNames["IDENTITY_PROVIDERS_AUTH_DETAILS_PAGE"] = "identity-providers-authentication-policies-details-page";
    RouteNames["IDENTITY_PROVIDERS_AUTH_POLICIES_PAGE"] = "identity-providers-authentication-policies-page";
    RouteNames["IDENTITY_PROVIDERS_AUDIT_LOG_PAGE"] = "identity-providers-audit-log-page";
    RouteNames["JSM_IDENTITY_PROVIDERS_SAML_PAGE"] = "jsm-identity-providers-saml-page";
    RouteNames["JSM_IDENTITY_PROVIDERS_SAML_DETAILS_PAGE"] = "jsm-identity-providers-details-page";
    RouteNames["JSM_SCIM_PAGE"] = "jsm-identity-providers-scim-page";
    RouteNames["JSM_IDP_TROUBLESHOOTING_LOGS"] = "jsm-identity-providers-troubleshooting-logs-page";
    RouteNames["JSM_PAGE"] = "jsm-page";
    RouteNames["ACCESS_REQUESTS"] = "access-requests-page";
    RouteNames["USER_CONNECTED_APPS"] = "user-connected-apps-page";
    RouteNames["USER_CONNECTED_APPS_TAB"] = "user-connected-apps-page-tab";
    RouteNames["USER_CONNECTED_APPS_DETAILS"] = "user-connected-apps-details-page";
    RouteNames["USER_CONNECTED_APPS_STUDIO_APP_REVIEW"] = "user-connected-apps-studio-app-review-page";
    RouteNames["USER_CONNECTED_APPS_PRODUCT_DETAILS"] = "user-connected-apps-product-details";
    RouteNames["USER_CONNECTED_APPS_PRODUCT_DETAILS_TAB"] = "user-connected-apps-product-details-tab";
    RouteNames["USER_CONNECTED_APPS_MCP_SERVER_PAGE"] = "user-connected-apps-mcp-server-page";
    RouteNames["USER_CONNECTED_APPS_OAUTH"] = "user-connected-apps-oauth";
    RouteNames["USER_CONNECTED_OAUTH_TAB"] = "user-connected-apps-oauth-tab";
    RouteNames["SETUP_PAGE"] = "setup-page";
    RouteNames["BILLING_PAGES"] = "billing-pages";
    RouteNames["AGENTS_OVERVIEW_PAGE"] = "agents-overview-page";
    RouteNames["AGENTS_OVERVIEW_NAV_PAGE"] = "agents-overview-nav-page";
    RouteNames["AGENTS_OVERVIEW_NAV_PAGE_ROVO_AND_AI_CHILD"] = "agents-overview-nav-page-rovo-and-ai-child";
    RouteNames["AGENT_DETAILS_PAGE"] = "agent-details-page";
    RouteNames["AGENTS_EXPORT_DOWNLOAD_PAGE"] = "agents-export-download-page";
    RouteNames["DIRECTORY_AGENTS_EXPORT_DOWNLOAD_PAGE"] = "directory-agents-export-download-page";
    // Portfolio Insights Navigation V2 routes
    RouteNames["CLOUD_READINESS_PAGE"] = "cloud-readiness-page";
    RouteNames["CLOUD_READINESS_DETAIL"] = "cloud-readiness-details-page";
    RouteNames["CLOUD_READINESS_DETAIL_OVERVIEW"] = "overview-page";
    RouteNames["CLOUD_READINESS_DETAIL_DATA_SHAPE"] = "data-shape-page";
    RouteNames["CLOUD_READINESS_DETAIL_MARKETPLACE_APPS"] = "marketplace-apps-page";
    RouteNames["CLOUD_READINESS_DETAIL_CUSTOM_APPS"] = "custom-apps-page";
    RouteNames["CLOUD_READINESS_DETAIL_PRE_MIGRATION_CHECKS"] = "pre-migration-checks-page";
    RouteNames["CLOUD_READINESS_DETAIL_DATA_CLEANUP"] = "data-cleanup-page";
    RouteNames["CUSTOMIZATIONS_PAGE"] = "customizations-listing-page";
    RouteNames["CUSTOMIZATIONS_INSTANCE_PAGE"] = "customizations-instance-page";
    RouteNames["CUSTOMIZATION_DETAILS_PAGE"] = "customization-details-page";
    RouteNames["INSTANCE_HEALTH_PAGE"] = "instance-health-page";
    RouteNames["INSTANCE_HEALTH_DETAIL"] = "instance-health-detail-page";
    RouteNames["INSTANCE_HEALTH_DETAIL_OPTIMIZATION"] = "optimization-page";
    RouteNames["INSTANCE_HEALTH_DETAIL_PERFORMANCE"] = "performance-page";
    RouteNames["INSTANCE_HEALTH_DETAIL_SECURITY"] = "security-page";
    RouteNames["WORKFLOW_DISCOVERY_PAGE"] = "workflow-discovery-top-level-page";
    RouteNames["WORKFLOW_DISCOVERY_DETAILS_PAGE"] = "workflow-discovery-details-page";
    RouteNames["DETECTED_INSTANCES_PAGE"] = "detected-instances-page";
    RouteNames["HIDDEN_INSTANCES_PAGE"] = "hidden-instances-page";
    RouteNames["AVIATOR_MARKETPLACE_APPS"] = "aviator-marketplace-apps-page";
    RouteNames["PERFORMANCE_MONITORING_PAGE"] = "performance-monitoring-page";
    RouteNames["PERFORMANCE_BY_USER_DETAILS_PAGE"] = "performance-by-user-details-page";
    RouteNames["PERFORMANCE_MONITORING_CHILD_PAGE"] = "performance-monitoring-child-page";
    RouteNames["USER_SETUP_DETAILS_PAGE"] = "user-setup-details-page";
    RouteNames["AVIATOR_SERVICE_HEALTH_DASHBOARD"] = "aviator-service-health-dashboard";
    RouteNames["AVIATOR_SERVICE_HEALTH_DASHBOARD_CURRENT_STATUS"] = "aviator-service-health-dashboard-current-status";
    RouteNames["AVIATOR_SERVICE_HEALTH_DASHBOARD_INCIDENT_DETAILS"] = "aviator-service-health-dashboard-incident-details";
    RouteNames["AVIATOR_SERVICE_HEALTH_DASHBOARD_INCIDENT_HISTORY"] = "aviator-service-health-dashboard-incident-history";
    RouteNames["AVIATOR_SERVICE_HEALTH_DASHBOARD_APP_DETAILS"] = "aviator-service-health-dashboard-app-details";
    RouteNames["AVIATOR_SERVICE_HEALTH_DASHBOARD_MAINTENANCE_DETAILS"] = "aviator-service-health-dashboard-maintenance-details";
    RouteNames["AVIATOR_SERVICE_HEALTH_DASHBOARD_NOTIFICATION_SETTINGS"] = "aviator-service-health-dashboard-notification-settings";
    RouteNames["STATUS_HUB_PAGE"] = "status-hub-page";
    RouteNames["STATUS_HUB_CHILD_PAGE"] = "status-hub-child-page";
    RouteNames["DISASTER_RECOVERY"] = "disaster-recovery";
    RouteNames["UPDATE_PAYMENT_METHOD"] = "update-payment-method-page";
    RouteNames["ADD_PAYMENT_DETAILS"] = "add-payment-details-page";
    RouteNames["MONTHLY_TO_ANNUAL"] = "monthly-to-annual-page";
    RouteNames["MIGRATION_DATA_SCOPE"] = "migration-data-scope";
    RouteNames["MIGRATION_SXP_CREATE_MIGRATION"] = "migration-sxp-create-migration";
    RouteNames["MIGRATION_DC2C_CONNECT_PAGE"] = "migration-dc2c-connect-page";
    RouteNames["MIGRATION_DC2C_DASHBOARD_PAGE"] = "migration-dc2c-dashboard-page";
    RouteNames["MIGRATION_DC2C_CREATE_MIGRATION"] = "migration-dc2c-create-migration";
    RouteNames["MIGRATION_DC2C_MIGRATION_DETAILS"] = "migration-dc2c-migration-details-page";
    RouteNames["MIGRATION_DC2C_MIGRATION_PREFLIGHTS_PAGE"] = "migration-dc2c-migration-preflights-page";
    RouteNames["MIGRATION_DC2C_DELTA_MIGRATIONS_HOME_PAGE"] = "migration-dc2c-delta-migrations-home-page";
    RouteNames["MIGRATION_DC2C_CONNECT_TO_SOURCE"] = "migration-dc2c-connect-to-source";
    RouteNames["MIGRATION_PERMISSION_PAGE"] = "migration-permission-error-page";
    RouteNames["CHANGE_EDITION_ENTITLEMENT"] = "change-edition-entitlement";
    RouteNames["CHOOSE_ANNUAL_BILLING_CYCLE"] = "choose-annual-billing-cycle";
    RouteNames["TEAM_SITE_ASSIGNMENT_PAGE"] = "team-site-assignment-page";
    // org billing routes
    RouteNames["ORG_BILLING_OVERVIEW_PAGE"] = "org-billing-overview-page";
    RouteNames["ORG_BILLING_PAYMENT_DETAILS_PAGE"] = "org-billing-payment-details-page";
    RouteNames["ORG_BILLING_HISTORY_PAGE"] = "org-billing-history-page";
    RouteNames["ORG_BILLING_ESTIMATE_PAGE"] = "org-billing-estimate-page";
    RouteNames["ORG_BILLING_MANAGE_SUBSCRIPTIONS_PAGE"] = "org-billing-manage-subscriptions-page";
    // site routes
    RouteNames["SITE_USER_EXPORT_DOWNLOAD_PAGE"] = "site-user-export-download-page";
    RouteNames["SITE_AGENTS_EXPORT_DOWNLOAD_PAGE"] = "site-agents-export-download-page";
    RouteNames["SITE_ACCESS_REQUESTS_PAGE"] = "site-access-requests-page";
    RouteNames["SITE_ACCESS_CONFIGURATION_PAGE"] = "access-configuration-page";
    RouteNames["SITE_JSM_PAGE"] = "site-jsm-page";
    RouteNames["SITE_JSM_IDP_PAGE"] = "jsm-idp-page";
    RouteNames["SITE_USER_CONNECTED_APPS_PAGE"] = "site-user-connected-apps-page";
    RouteNames["SITE_USER_CONNECTED_APPS_SUBPAGE"] = "site-user-connected-apps-subpage";
    RouteNames["SITE_USER_CONNECTED_APPS_DETAILS_PAGE"] = "site-user-connected-apps-details-page";
    RouteNames["SITE_ACCESS_PAGE"] = "access-page";
    // billing site routes
    RouteNames["SITE_BILLING_OVERVIEW_PAGE"] = "site-billing-overview-page";
    RouteNames["SITE_BILLING_PAYMENT_DETAILS_PAGE"] = "site-billing-payment-details-page";
    RouteNames["SITE_BILLING_HISTORY_PAGE"] = "site-billing-history-page";
    RouteNames["SITE_BILLING_ESTIMATE_PAGE"] = "site-billing-estimate-page";
    RouteNames["SITE_BILLING_MANAGE_SUBSCRIPTIONS_PAGE"] = "site-billing-manage-subscriptions-page";
    RouteNames["SITE_BILLING_ADD_APPLICATION_PAGE"] = "site-billing-add-application-page";
    // SITE_BILLING_NEW_PRODUCTS_PAGE = 'site-billing-new-products-page',
    // SITE_BILLING_UPFLOW_PAYMENTS_PAGE = 'site-billing-upflow-payments-page',
    // for ufo
    RouteNames["ACCESS_SITE"] = "site-access-page";
    RouteNames["SITE_GSUITE_PAGE"] = "gsuite-page";
    RouteNames["SITE_EMOJI_PAGE"] = "emoji-page";
    RouteNames["SITE_PHONE_NUMBERS_PAGE"] = "phone-numbers-page";
    RouteNames["SITE_PHONE_NUMBERS_TAB_PAGE"] = "phone-numbers-tab-page";
    RouteNames["SITE_STORAGE_PAGE"] = "storage-page";
    RouteNames["SITE_SETUP_PAGE"] = "site-setup-page";
    RouteNames["SITE_BILLING_PAGE"] = "site-billing-pages";
    RouteNames["SITE_BILLING_PREVIEW_PAGE"] = "site-billing-preview-page";
    // top routes
    RouteNames["TOP_ROUTE_DASHBOARD"] = "dashboard";
    RouteNames["TOP_ROUTE_SHADOW_IT_REQUEST_GATE"] = "shadow-it-request-gate";
    RouteNames["TOP_ROUTE_ORG_PICKER"] = "org-picker";
    RouteNames["TOP_ROUTE_ORG_PICKER_ATLASSIAN_ACCESS"] = "org-picker-atlassian-access";
    RouteNames["TOP_ROUTE_ORG_PICKER_ATLASSIAN_GUARD"] = "org-picker-atlassian-guard";
    RouteNames["TOP_ROUTE_ORG_PICKER_ATLASSIAN_GUARD_PREMIUM"] = "org-picker-atlassian-guard-premium";
    RouteNames["TOP_ROUTE_ROVO"] = "rovo";
    return RouteNames;
}({});
var $6d422fe67bb85917$export$45d806189971ee03 = /*#__PURE__*/ function(TagIds) {
    TagIds["SHD_BETA_LOZENGE"] = "shd-beta-lozenge";
    return TagIds;
}({});

});

parcelRegister("7KyMT", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("ghnKe"),
    $9RrC7("bPECp"),
    $9RrC7("3CM5k"),
    $9RrC7("2gvxY"),
    $9RrC7("2Ko6U"),
    $9RrC7("c1qD4"),
    $9RrC7("0tCbH"),
    $9RrC7("cLb1a"),
    $9RrC7("85YFn"),
    $9RrC7("4m6Sg"),
    $9RrC7("88egG"),
    $9RrC7("7IqYH"),
    $9RrC7("diQFn"),
    $9RrC7("lThGo"),
    $9RrC7("kqsRS"),
    $9RrC7("eF4KJ"),
    $9RrC7("gELit"),
    $9RrC7("ZfUwX"),
    $9RrC7("3Xpnn"),
    $9RrC7("8hiQE"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("l6fOw"),
    $9RrC7("1zBeC"),
    $9RrC7("2RT17")
]).then(()=>parcelRequire('9Gxx8'));

});

parcelRegister("lN73Y", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("cUJAl"),
    $9RrC7("2pg3m"),
    $9RrC7("jphmg"),
    $9RrC7("6bavh"),
    $9RrC7("ghnKe"),
    $9RrC7("3CM5k"),
    $9RrC7("2gvxY"),
    $9RrC7("0tCbH"),
    $9RrC7("85YFn"),
    $9RrC7("4m6Sg"),
    $9RrC7("diQFn"),
    $9RrC7("8hiQE"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("l6fOw"),
    $9RrC7("1zBeC"),
    $9RrC7("asxOw")
]).then(()=>parcelRequire('CbMtF'));

});

parcelRegister("inEZM", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("js6Cm"),
    $9RrC7("6bavh"),
    $9RrC7("ghnKe"),
    $9RrC7("3CM5k"),
    $9RrC7("c1qD4"),
    $9RrC7("4m6Sg"),
    $9RrC7("ZfUwX"),
    $9RrC7("8hiQE"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("l6fOw"),
    $9RrC7("1zBeC"),
    $9RrC7("ces2M"),
    $9RrC7("kFXZg")
]).then(()=>parcelRequire('1WZ1H'));

});

parcelRegister("gt8bZ", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = $9RrC7("ces2M").then(()=>parcelRequire('XaUc3'));

});

parcelRegister("8zyfx", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("kHMxr"),
    $9RrC7("5kyE2"),
    $9RrC7("44fje"),
    $9RrC7("2RCHM"),
    $9RrC7("js6Cm"),
    $9RrC7("c1qD4"),
    $9RrC7("ZfUwX"),
    $9RrC7("8hiQE"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("l6fOw"),
    $9RrC7("ces2M"),
    $9RrC7("2G69c")
]).then(()=>parcelRequire('k6Uvp'));

});

parcelRegister("cWV9s", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("grpqW"),
    $9RrC7("2itlB"),
    $9RrC7("hYsq8"),
    $9RrC7("27PFq"),
    $9RrC7("6gLy6"),
    $9RrC7("c2gm1"),
    $9RrC7("kHMxr"),
    $9RrC7("0tCbH"),
    $9RrC7("8hiQE"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("ces2M"),
    $9RrC7("efjTD")
]).then(()=>parcelRequire('6GyPk'));

});

parcelRegister("4I9s9", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("kHMxr"),
    $9RrC7("5kyE2"),
    $9RrC7("2RCHM"),
    $9RrC7("js6Cm"),
    $9RrC7("c1qD4"),
    $9RrC7("ZfUwX"),
    $9RrC7("gnmCu"),
    $9RrC7("l6fOw"),
    $9RrC7("ces2M"),
    $9RrC7("KOaqT")
]).then(()=>parcelRequire('76U6h'));

});

parcelRegister("hZGBl", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("jphmg"),
    $9RrC7("c1qD4"),
    $9RrC7("eF4KJ"),
    $9RrC7("gELit"),
    $9RrC7("ZfUwX"),
    $9RrC7("3Xpnn"),
    $9RrC7("l6fOw"),
    $9RrC7("6o1mL")
]).then(()=>parcelRequire('lwuT6'));

});

parcelRegister("51elL", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("jphmg"),
    $9RrC7("c1qD4"),
    $9RrC7("8hiQE"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("l6fOw"),
    $9RrC7("1zBeC"),
    $9RrC7("cSHtB")
]).then(()=>parcelRequire('7mKEc'));

});

parcelRegister("6xvhN", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("jphmg"),
    $9RrC7("ces2M"),
    $9RrC7("63CmB")
]).then(()=>parcelRequire('efmhU'));

});

parcelRegister("dtdll", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("jphmg"),
    $9RrC7("ces2M"),
    $9RrC7("lwtVY")
]).then(()=>parcelRequire('anOnr'));

});

parcelRegister("1NyM0", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("jphmg"),
    $9RrC7("8hiQE"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("l6fOw"),
    $9RrC7("1zBeC"),
    $9RrC7("ces2M"),
    $9RrC7("iNR1D")
]).then(()=>parcelRequire('cb5Hl'));

});

parcelRegister("4WCnI", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("jphmg"),
    $9RrC7("8hiQE"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("l6fOw"),
    $9RrC7("1zBeC"),
    $9RrC7("ces2M"),
    $9RrC7("dRDdi")
]).then(()=>parcelRequire('b2yya'));

});

parcelRegister("5qkmM", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("jphmg"),
    $9RrC7("8hiQE"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("l6fOw"),
    $9RrC7("1zBeC"),
    $9RrC7("ces2M"),
    $9RrC7("gIOz8")
]).then(()=>parcelRequire('2XdqQ'));

});

parcelRegister("2zbF3", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("jphmg"),
    $9RrC7("8hiQE"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("l6fOw"),
    $9RrC7("1zBeC"),
    $9RrC7("ces2M"),
    $9RrC7("3Q1oM")
]).then(()=>parcelRequire('lNHC2'));

});


parcelRegister("hBZYs", function(module, exports) {
$parcel$export(module.exports, "initSentry", () => $f739be93f55bc700$export$f5ae3c4820871661);
$parcel$export(module.exports, "setSentryUser", () => $f739be93f55bc700$export$5ceec5c8be62fa1b);

var $5aXcQ = parcelRequire("5aXcQ");
var $bhEJd = parcelRequire("bhEJd");

var $7e8C3 = parcelRequire("7e8C3");
const $f739be93f55bc700$export$f5ae3c4820871661 = ()=>$5aXcQ.init((0, $7e8C3.getConfig)().sentryConfig);
const $f739be93f55bc700$export$5ceec5c8be62fa1b = (_user)=>{
    $bhEJd.setUser(null);
};

});
parcelRegister("5aXcQ", function(module, exports) {
$parcel$export(module.exports, "init", () => $3c4bd004e022faf4$export$2cd8252107eb640b);

var $gb5jY = parcelRequire("gb5jY");
var $fb5ty = parcelRequire("fb5ty");
var $dZ6so = parcelRequire("dZ6so");
var $x2nP6 = parcelRequire("x2nP6");
var $kE4qe = parcelRequire("kE4qe");
var $szCCs = parcelRequire("szCCs");
var $5ylgB = parcelRequire("5ylgB");
var $4P7DZ = parcelRequire("4P7DZ");
var $bhEJd = parcelRequire("bhEJd");
var $fmUGy = parcelRequire("fmUGy");
var $jqugQ = parcelRequire("jqugQ");

var $ijndu = parcelRequire("ijndu");

var $bwJrq = parcelRequire("bwJrq");

var $3eIan = parcelRequire("3eIan");

var $VzPt7 = parcelRequire("VzPt7");

var $ejF24 = parcelRequire("ejF24");

var $hdU18 = parcelRequire("hdU18");

var $9Dk4x = parcelRequire("9Dk4x");

var $GFolx = parcelRequire("GFolx");

var $6kme1 = parcelRequire("6kme1");

var $9LQEU = parcelRequire("9LQEU");

var $b6yqE = parcelRequire("b6yqE");
/** Get the default integrations for the browser SDK. */ function $3c4bd004e022faf4$export$5783b2920b1d62b9(options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ const integrations = [
        (0, $5ylgB.inboundFiltersIntegration)(),
        (0, $dZ6so.functionToStringIntegration)(),
        (0, $ejF24.browserApiErrorsIntegration)(),
        (0, $VzPt7.breadcrumbsIntegration)(),
        (0, $9Dk4x.globalHandlersIntegration)(),
        (0, $6kme1.linkedErrorsIntegration)(),
        (0, $fb5ty.dedupeIntegration)(),
        (0, $GFolx.httpContextIntegration)()
    ];
    // eslint-disable-next-line deprecation/deprecation
    if (options.autoSessionTracking !== false) integrations.push((0, $hdU18.browserSessionIntegration)());
    return integrations;
}
function $3c4bd004e022faf4$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $3c4bd004e022faf4$export$5783b2920b1d62b9(optionsArg),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $3eIan.WINDOW).SENTRY_RELEASE && (0, $3eIan.WINDOW).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $3eIan.WINDOW).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $3c4bd004e022faf4$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $3eIan.WINDOW).window !== 'undefined' && (0, $3eIan.WINDOW);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $3eIan.WINDOW).location && (0, $3eIan.WINDOW).location.href || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $3eIan.WINDOW) === (0, $3eIan.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $3c4bd004e022faf4$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $3c4bd004e022faf4$var$applyDefaultOptions(browserOptions);
    if (!options.skipBrowserExtensionCheck && $3c4bd004e022faf4$var$shouldShowBrowserExtensionError()) {
        (0, $gb5jY.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if (0, $bwJrq.DEBUG_BUILD) {
        if (!(0, $jqugQ.supportsFetch)()) (0, $gb5jY.logger).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $fmUGy.stackParserFromStackParserOptions)(options.stackParser || (0, $9LQEU.defaultStackParser)),
        integrations: (0, $kE4qe.getIntegrationsToSetup)(options),
        transport: options.transport || (0, $b6yqE.makeFetchTransport)
    };
    return (0, $4P7DZ.initAndBind)((0, $ijndu.BrowserClient), clientOptions);
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $3c4bd004e022faf4$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $3eIan.WINDOW).document) {
        (0, $bwJrq.DEBUG_BUILD) && (0, $gb5jY.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $x2nP6.getCurrentScope)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $bwJrq.DEBUG_BUILD) && (0, $gb5jY.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $bhEJd.lastEventId)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $3eIan.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $szCCs.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $3eIan.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $3eIan.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $3eIan.WINDOW).document.head || (0, $3eIan.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $bwJrq.DEBUG_BUILD) && (0, $gb5jY.logger).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3c4bd004e022faf4$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3c4bd004e022faf4$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $3c4bd004e022faf4$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $x2nP6.getClient)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}
 //# sourceMappingURL=sdk.js.map

});
parcelRegister("fb5ty", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $b0cc2172c8f5fb04$export$6d39aa44cd0c7567);

var $kE4qe = parcelRequire("kE4qe");

var $aVHpP = parcelRequire("aVHpP");

var $gb5jY = parcelRequire("gb5jY");

var $fmUGy = parcelRequire("fmUGy");
const $b0cc2172c8f5fb04$var$INTEGRATION_NAME = 'Dedupe';
const $b0cc2172c8f5fb04$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b0cc2172c8f5fb04$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b0cc2172c8f5fb04$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b0cc2172c8f5fb04$export$6d39aa44cd0c7567 = (0, $kE4qe.defineIntegration)($b0cc2172c8f5fb04$var$_dedupeIntegration);
/** only exported for tests. */ function $b0cc2172c8f5fb04$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b0cc2172c8f5fb04$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b0cc2172c8f5fb04$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b0cc2172c8f5fb04$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b0cc2172c8f5fb04$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b0cc2172c8f5fb04$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b0cc2172c8f5fb04$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b0cc2172c8f5fb04$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b0cc2172c8f5fb04$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b0cc2172c8f5fb04$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b0cc2172c8f5fb04$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b0cc2172c8f5fb04$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $fmUGy.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $fmUGy.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b0cc2172c8f5fb04$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $b0cc2172c8f5fb04$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
 //# sourceMappingURL=dedupe.js.map

});
parcelRegister("kE4qe", function(module, exports) {
$parcel$export(module.exports, "getIntegrationsToSetup", () => $f07af9348395921d$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $f07af9348395921d$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $f07af9348395921d$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $f07af9348395921d$export$35abcfd71227c6ca);
$parcel$export(module.exports, "defineIntegration", () => $f07af9348395921d$export$2323046b9414659f);

var $x2nP6 = parcelRequire("x2nP6");

var $aVHpP = parcelRequire("aVHpP");

var $gb5jY = parcelRequire("gb5jY");
const $f07af9348395921d$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $f07af9348395921d$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $f07af9348395921d$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    const finalIntegrations = $f07af9348395921d$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === 'Debug');
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $f07af9348395921d$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $f07af9348395921d$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $f07af9348395921d$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $f07af9348395921d$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($f07af9348395921d$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $f07af9348395921d$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $f07af9348395921d$export$2d8f5188773bcddd(integration) {
    const client = (0, $x2nP6.getClient)();
    if (!client) {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $f07af9348395921d$export$2323046b9414659f(fn) {
    return fn;
}
 //# sourceMappingURL=integration.js.map

});


parcelRegister("dZ6so", function(module, exports) {
$parcel$export(module.exports, "functionToStringIntegration", () => $a2e5fb12fbdb582d$export$7918117e9202e4fb);

var $x2nP6 = parcelRequire("x2nP6");

var $kE4qe = parcelRequire("kE4qe");

var $9v9Yl = parcelRequire("9v9Yl");
let $a2e5fb12fbdb582d$var$originalFunctionToString;
const $a2e5fb12fbdb582d$var$INTEGRATION_NAME = 'FunctionToString';
const $a2e5fb12fbdb582d$var$SETUP_CLIENTS = new WeakMap();
const $a2e5fb12fbdb582d$var$_functionToStringIntegration = ()=>{
    return {
        name: $a2e5fb12fbdb582d$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $a2e5fb12fbdb582d$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $9v9Yl.getOriginalFunction)(this);
                    const context = $a2e5fb12fbdb582d$var$SETUP_CLIENTS.has((0, $x2nP6.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $a2e5fb12fbdb582d$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $a2e5fb12fbdb582d$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $a2e5fb12fbdb582d$export$7918117e9202e4fb = (0, $kE4qe.defineIntegration)($a2e5fb12fbdb582d$var$_functionToStringIntegration);
 //# sourceMappingURL=functiontostring.js.map

});

parcelRegister("szCCs", function(module, exports) {
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $055e3f67b737ea56$export$9964600bfe84e6a3);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $055e3f67b737ea56$export$671c7ed8e40a7a57);

var $htKiL = parcelRequire("htKiL");
const $055e3f67b737ea56$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $055e3f67b737ea56$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $055e3f67b737ea56$var$_getIngestEndpoint(dsn) {
    return `${$055e3f67b737ea56$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $055e3f67b737ea56$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $055e3f67b737ea56$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $055e3f67b737ea56$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$055e3f67b737ea56$var$_getIngestEndpoint(dsn)}?${$055e3f67b737ea56$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $055e3f67b737ea56$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $htKiL.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$055e3f67b737ea56$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $htKiL.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
 //# sourceMappingURL=api.js.map

});
parcelRegister("htKiL", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $cb990fa013f681b2$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $cb990fa013f681b2$export$128827c3562ec0cb);

var $jhPin = parcelRequire("jhPin");

var $gb5jY = parcelRequire("gb5jY");
/** Regular expression used to parse a Dsn. */ const $cb990fa013f681b2$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $cb990fa013f681b2$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $cb990fa013f681b2$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $cb990fa013f681b2$export$b892860177f70a30(str) {
    const match = $cb990fa013f681b2$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $gb5jY.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $cb990fa013f681b2$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $cb990fa013f681b2$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $cb990fa013f681b2$var$validateDsn(dsn) {
    if (!(0, $jhPin.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $gb5jY.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $gb5jY.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$cb990fa013f681b2$var$isValidProtocol(protocol)) {
        (0, $gb5jY.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $gb5jY.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $cb990fa013f681b2$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $cb990fa013f681b2$export$b892860177f70a30(from) : $cb990fa013f681b2$var$dsnFromComponents(from);
    if (!components || !$cb990fa013f681b2$var$validateDsn(components)) return undefined;
    return components;
}
 //# sourceMappingURL=dsn.js.map

});


parcelRegister("5ylgB", function(module, exports) {
$parcel$export(module.exports, "inboundFiltersIntegration", () => $40b09fdab6c00d2b$export$cb3c5c2ceb9818ba);

var $aVHpP = parcelRequire("aVHpP");

var $kE4qe = parcelRequire("kE4qe");

var $gb5jY = parcelRequire("gb5jY");

var $1Mikf = parcelRequire("1Mikf");

var $3fQHs = parcelRequire("3fQHs");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $40b09fdab6c00d2b$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/
];
/** Options for the InboundFilters integration */ const $40b09fdab6c00d2b$var$INTEGRATION_NAME = 'InboundFilters';
const $40b09fdab6c00d2b$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $40b09fdab6c00d2b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $40b09fdab6c00d2b$var$_mergeOptions(options, clientOptions);
            return $40b09fdab6c00d2b$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $40b09fdab6c00d2b$export$cb3c5c2ceb9818ba = (0, $kE4qe.defineIntegration)($40b09fdab6c00d2b$var$_inboundFiltersIntegration);
function $40b09fdab6c00d2b$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $40b09fdab6c00d2b$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $40b09fdab6c00d2b$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $40b09fdab6c00d2b$var$_isSentryError(event)) {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $1Mikf.getEventDescription)(event)}`);
        return true;
    }
    if ($40b09fdab6c00d2b$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $1Mikf.getEventDescription)(event)}`);
        return true;
    }
    if ($40b09fdab6c00d2b$var$_isUselessError(event)) {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $1Mikf.getEventDescription)(event)}`);
        return true;
    }
    if ($40b09fdab6c00d2b$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $1Mikf.getEventDescription)(event)}`);
        return true;
    }
    if ($40b09fdab6c00d2b$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $1Mikf.getEventDescription)(event)}.\nUrl: ${$40b09fdab6c00d2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$40b09fdab6c00d2b$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $1Mikf.getEventDescription)(event)}.\nUrl: ${$40b09fdab6c00d2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $40b09fdab6c00d2b$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $40b09fdab6c00d2b$var$_getPossibleEventMessages(event).some((message)=>(0, $3fQHs.stringMatchesSomePattern)(message, ignoreErrors));
}
function $40b09fdab6c00d2b$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $3fQHs.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $40b09fdab6c00d2b$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $40b09fdab6c00d2b$var$_getEventFilterUrl(event);
    return !url ? false : (0, $3fQHs.stringMatchesSomePattern)(url, denyUrls);
}
function $40b09fdab6c00d2b$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $40b09fdab6c00d2b$var$_getEventFilterUrl(event);
    return !url ? true : (0, $3fQHs.stringMatchesSomePattern)(url, allowUrls);
}
function $40b09fdab6c00d2b$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $40b09fdab6c00d2b$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $40b09fdab6c00d2b$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $40b09fdab6c00d2b$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $40b09fdab6c00d2b$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).error(`Cannot extract url for event ${(0, $1Mikf.getEventDescription)(event)}`);
        return null;
    }
}
function $40b09fdab6c00d2b$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}
 //# sourceMappingURL=inboundfilters.js.map

});

parcelRegister("4P7DZ", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $3831dac53cfd34e7$export$5333c3f1c58d9bc1);

var $x2nP6 = parcelRequire("x2nP6");

var $aVHpP = parcelRequire("aVHpP");

var $gb5jY = parcelRequire("gb5jY");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $3831dac53cfd34e7$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $aVHpP.DEBUG_BUILD) (0, $gb5jY.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $gb5jY.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $x2nP6.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $3831dac53cfd34e7$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $3831dac53cfd34e7$export$ecb76f41d43c0e43(client) {
    (0, $x2nP6.getCurrentScope)().setClient(client);
}
 //# sourceMappingURL=sdk.js.map

});

parcelRegister("jqugQ", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $e247ed24e398810b$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "supportsNativeFetch", () => $e247ed24e398810b$export$c82d238e23c40b21);

var $jhPin = parcelRequire("jhPin");

var $gb5jY = parcelRequire("gb5jY");

var $6BcBO = parcelRequire("6BcBO");
const $e247ed24e398810b$var$WINDOW = (0, $6BcBO.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $e247ed24e398810b$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $e247ed24e398810b$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $e247ed24e398810b$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $e247ed24e398810b$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $e247ed24e398810b$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $e247ed24e398810b$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $e247ed24e398810b$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$e247ed24e398810b$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($e247ed24e398810b$export$d5f608b368e73f38($e247ed24e398810b$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $e247ed24e398810b$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $e247ed24e398810b$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $jhPin.DEBUG_BUILD) && (0, $gb5jY.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $e247ed24e398810b$export$531055a6c684a70a() {
    return 'ReportingObserver' in $e247ed24e398810b$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $e247ed24e398810b$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$e247ed24e398810b$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
 //# sourceMappingURL=supports.js.map

});

parcelRegister("ijndu", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $d54c02b11f426c2d$export$1df9218a526d318d);

var $gjgnf = parcelRequire("gjgnf");
var $h2LhK = parcelRequire("h2LhK");
var $80BkC = parcelRequire("80BkC");
var $gb5jY = parcelRequire("gb5jY");

var $bwJrq = parcelRequire("bwJrq");

var $bCht7 = parcelRequire("bCht7");

var $3eIan = parcelRequire("3eIan");

var $6xrJb = parcelRequire("6xrJb");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $d54c02b11f426c2d$export$1df9218a526d318d extends (0, $h2LhK.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $3eIan.WINDOW).SENTRY_SDK_SOURCE || (0, $80BkC.getSDKSource)();
        (0, $gjgnf.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $3eIan.WINDOW).document) (0, $3eIan.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $3eIan.WINDOW).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $bCht7.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $bCht7.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $bwJrq.DEBUG_BUILD) && (0, $gb5jY.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $6xrJb.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
}
 //# sourceMappingURL=client.js.map

});
parcelRegister("gjgnf", function(module, exports) {
$parcel$export(module.exports, "applySdkMetadata", () => $bdfb1f363e29184c$export$b9f95b027256052c);

var $hWV3f = parcelRequire("hWV3f");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $bdfb1f363e29184c$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $hWV3f.SDK_VERSION)
            })),
        version: (0, $hWV3f.SDK_VERSION)
    };
    options._metadata = metadata;
}
 //# sourceMappingURL=sdkMetadata.js.map

});

parcelRegister("h2LhK", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $c6874d6fda192f3b$export$4f22f74eddb7716a);

var $szCCs = parcelRequire("szCCs");

var $x2nP6 = parcelRequire("x2nP6");

var $aVHpP = parcelRequire("aVHpP");

var $iixXb = parcelRequire("iixXb");

var $kE4qe = parcelRequire("kE4qe");

var $bkjjy = parcelRequire("bkjjy");

var $ftKkF = parcelRequire("ftKkF");

var $12qv7 = parcelRequire("12qv7");

var $htKiL = parcelRequire("htKiL");

var $d0PHu = parcelRequire("d0PHu");

var $1yrnO = parcelRequire("1yrnO");

var $fpqOZ = parcelRequire("fpqOZ");

var $gb5jY = parcelRequire("gb5jY");

var $1Mikf = parcelRequire("1Mikf");

var $dGw9M = parcelRequire("dGw9M");

var $2cwLd = parcelRequire("2cwLd");

var $48BE1 = parcelRequire("48BE1");

var $hYVtp = parcelRequire("hYVtp");
const $c6874d6fda192f3b$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $c6874d6fda192f3b$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $htKiL.makeDsn)(options.dsn);
        else (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $szCCs.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // TODO(v9): Remove this deprecation warning
        const tracingOptions = [
            'enableTracing',
            'tracesSampleRate',
            'tracesSampler'
        ];
        const undefinedOption = tracingOptions.find((option)=>option in options && options[option] == undefined);
        if (undefinedOption) (0, $gb5jY.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn(`[Sentry] Deprecation warning: \`${undefinedOption}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`);
        });
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint, scope) {
        const eventId = (0, $1Mikf.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $1Mikf.checkOrSetAlreadyCaught)(exception)) {
            (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).log($c6874d6fda192f3b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $1Mikf.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $fpqOZ.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $fpqOZ.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $1Mikf.uuid4)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $1Mikf.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).log($c6874d6fda192f3b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $bkjjy.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $dGw9M.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $kE4qe.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $kE4qe.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $iixXb.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $d0PHu.addItemToEnvelope)(env, (0, $d0PHu.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $iixXb.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).error('Transport disabled');
        return (0, $dGw9M.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $kE4qe.setupIntegrations)(this, integrations);
        (0, $kE4qe.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $bkjjy.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $dGw9M.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope = (0, $x2nP6.getCurrentScope)(), isolationScope = (0, $x2nP6.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $48BE1.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            evt.contexts = {
                trace: (0, $x2nP6.getTraceContextFromScope)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $ftKkF.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $aVHpP.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $gb5jY.logger).log(sentryError.message);
                else (0, $gb5jY.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $c6874d6fda192f3b$var$isTransactionEvent(event);
        const isError = $c6874d6fda192f3b$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $2cwLd.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $dGw9M.rejectedSyncPromise)(new (0, $1yrnO.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $1yrnO.SentryError)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $c6874d6fda192f3b$var$processBeforeSend(this, options, prepared, hint);
            return $c6874d6fda192f3b$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $1yrnO.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $1yrnO.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $1yrnO.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $12qv7.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $htKiL.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $c6874d6fda192f3b$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $fpqOZ.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $fpqOZ.isPlainObject)(event) && event !== null) throw new (0, $1yrnO.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $1yrnO.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $fpqOZ.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $1yrnO.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $c6874d6fda192f3b$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($c6874d6fda192f3b$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($c6874d6fda192f3b$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else {
                    (0, $hYVtp.showSpanDropWarning)();
                    client.recordDroppedEvent('before_send', 'span');
                }
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $c6874d6fda192f3b$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $c6874d6fda192f3b$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
 //# sourceMappingURL=baseclient.js.map

});
parcelRegister("iixXb", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $d5243ee96f90db00$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $d5243ee96f90db00$export$c31057337a18010f);

var $ftKkF = parcelRequire("ftKkF");

var $htKiL = parcelRequire("htKiL");

var $d0PHu = parcelRequire("d0PHu");




var $hYVtp = parcelRequire("hYVtp");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $d5243ee96f90db00$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $d5243ee96f90db00$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $d0PHu.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $htKiL.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $d0PHu.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $d5243ee96f90db00$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $d0PHu.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $d5243ee96f90db00$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $d0PHu.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $d0PHu.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $d5243ee96f90db00$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $ftKkF.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $htKiL.dsnToString)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = beforeSendSpan((0, $hYVtp.spanToJSON)(span));
        if (!spanJson) (0, $hYVtp.showSpanDropWarning)();
        return spanJson;
    } : (span)=>(0, $hYVtp.spanToJSON)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $d0PHu.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $d0PHu.createEnvelope)(headers, items);
}
 //# sourceMappingURL=envelope.js.map

});
parcelRegister("d0PHu", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $97936119a27aa608$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $97936119a27aa608$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $97936119a27aa608$export$c56c55acf0136fd3);
$parcel$export(module.exports, "serializeEnvelope", () => $97936119a27aa608$export$32f9b428425aac85);
$parcel$export(module.exports, "createSpanEnvelopeItem", () => $97936119a27aa608$export$655cf139bc8b8afd);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $97936119a27aa608$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $97936119a27aa608$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $97936119a27aa608$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $97936119a27aa608$export$92b6093782fe661b);

var $htKiL = parcelRequire("htKiL");

var $hFBOQ = parcelRequire("hFBOQ");

var $9v9Yl = parcelRequire("9v9Yl");

var $6BcBO = parcelRequire("6BcBO");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $97936119a27aa608$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $97936119a27aa608$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $97936119a27aa608$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $97936119a27aa608$export$604a45d95a155e2b(envelope, types) {
    return $97936119a27aa608$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $97936119a27aa608$var$encodeUTF8(input) {
    return (0, $6BcBO.GLOBAL_OBJ).__SENTRY__ && (0, $6BcBO.GLOBAL_OBJ).__SENTRY__.encodePolyfill ? (0, $6BcBO.GLOBAL_OBJ).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $97936119a27aa608$var$decodeUTF8(input) {
    return (0, $6BcBO.GLOBAL_OBJ).__SENTRY__ && (0, $6BcBO.GLOBAL_OBJ).__SENTRY__.decodePolyfill ? (0, $6BcBO.GLOBAL_OBJ).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $97936119a27aa608$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $97936119a27aa608$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $97936119a27aa608$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $hFBOQ.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $97936119a27aa608$var$concatBuffers(parts);
}
function $97936119a27aa608$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $97936119a27aa608$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $97936119a27aa608$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($97936119a27aa608$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $97936119a27aa608$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $97936119a27aa608$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $97936119a27aa608$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $9v9Yl.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $97936119a27aa608$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket',
    raw_security: 'security'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $97936119a27aa608$export$b11169581eeaf237(type) {
    return $97936119a27aa608$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $97936119a27aa608$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $97936119a27aa608$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $htKiL.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $9v9Yl.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}
 //# sourceMappingURL=envelope.js.map

});


parcelRegister("12qv7", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $0c1a88de58c48dbf$export$f3b9ed77c03eeb00);

var $d0PHu = parcelRequire("d0PHu");

var $fPxtX = parcelRequire("fPxtX");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $0c1a88de58c48dbf$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $fPxtX.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $d0PHu.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
 //# sourceMappingURL=clientreport.js.map

});

parcelRegister("1yrnO", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $121e3524bca9d3cd$export$5949942ba2a7c0e2);
/** An error emitted by Sentry SDKs and related utilities. */ class $121e3524bca9d3cd$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}
 //# sourceMappingURL=error.js.map

});

parcelRegister("2cwLd", function(module, exports) {
$parcel$export(module.exports, "parseSampleRate", () => $19a61d57a8f73b24$export$a5bd2d81656d9546);

var $aVHpP = parcelRequire("aVHpP");

var $gb5jY = parcelRequire("gb5jY");
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $19a61d57a8f73b24$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}
 //# sourceMappingURL=parseSampleRate.js.map

});


parcelRegister("80BkC", function(module, exports) {
$parcel$export(module.exports, "getSDKSource", () => $5d4b481523636704$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $5d4b481523636704$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $5d4b481523636704$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}
 //# sourceMappingURL=env.js.map

});

parcelRegister("bwJrq", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $8645ee9004d4cdb2$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $8645ee9004d4cdb2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map

});

parcelRegister("bCht7", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $8750cb3fc74ee2dd$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $8750cb3fc74ee2dd$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $8750cb3fc74ee2dd$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $8750cb3fc74ee2dd$export$5425b53185d13d6c);

var $1Mikf = parcelRequire("1Mikf");
var $9v9Yl = parcelRequire("9v9Yl");
var $x2nP6 = parcelRequire("x2nP6");
var $fpqOZ = parcelRequire("fpqOZ");
var $hFBOQ = parcelRequire("hFBOQ");
var $dGw9M = parcelRequire("dGw9M");
/**
 * This function creates an exception from a JavaScript Error
 */ function $8750cb3fc74ee2dd$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $8750cb3fc74ee2dd$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $8750cb3fc74ee2dd$export$2e9ae379995d99e3(ex),
        value: $8750cb3fc74ee2dd$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $8750cb3fc74ee2dd$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $x2nP6.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $8750cb3fc74ee2dd$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $hFBOQ.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $8750cb3fc74ee2dd$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $fpqOZ.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $8750cb3fc74ee2dd$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $8750cb3fc74ee2dd$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $8750cb3fc74ee2dd$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $8750cb3fc74ee2dd$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $8750cb3fc74ee2dd$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $8750cb3fc74ee2dd$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $8750cb3fc74ee2dd$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $8750cb3fc74ee2dd$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $8750cb3fc74ee2dd$var$getSkipFirstStackStringLines(ex) {
    if (ex && $8750cb3fc74ee2dd$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $8750cb3fc74ee2dd$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $8750cb3fc74ee2dd$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $8750cb3fc74ee2dd$export$2e9ae379995d99e3(ex) {
    const name = ex && ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $8750cb3fc74ee2dd$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $8750cb3fc74ee2dd$export$86005d1b62804363(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    if ($8750cb3fc74ee2dd$var$isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $8750cb3fc74ee2dd$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $8750cb3fc74ee2dd$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $1Mikf.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dGw9M.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $8750cb3fc74ee2dd$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $8750cb3fc74ee2dd$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dGw9M.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $8750cb3fc74ee2dd$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $fpqOZ.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $8750cb3fc74ee2dd$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $fpqOZ.isDOMError)(exception) || (0, $fpqOZ.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $8750cb3fc74ee2dd$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $fpqOZ.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $8750cb3fc74ee2dd$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $1Mikf.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $fpqOZ.isError)(exception)) // we have a real Error object, do nothing
    return $8750cb3fc74ee2dd$var$eventFromError(stackParser, exception);
    if ((0, $fpqOZ.isPlainObject)(exception) || (0, $fpqOZ.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $8750cb3fc74ee2dd$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $1Mikf.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $8750cb3fc74ee2dd$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $1Mikf.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $1Mikf.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $8750cb3fc74ee2dd$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $8750cb3fc74ee2dd$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $1Mikf.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $fpqOZ.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $8750cb3fc74ee2dd$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $9v9Yl.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $fpqOZ.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $fpqOZ.isEvent)(exception)) {
        const className = $8750cb3fc74ee2dd$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $8750cb3fc74ee2dd$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $8750cb3fc74ee2dd$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}
 //# sourceMappingURL=eventbuilder.js.map

});

parcelRegister("3eIan", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $25b4f06651024bbf$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $25b4f06651024bbf$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $25b4f06651024bbf$export$4997ffc0176396a6);

var $1Mikf = parcelRequire("1Mikf");
var $9v9Yl = parcelRequire("9v9Yl");
var $bhEJd = parcelRequire("bhEJd");
var $6BcBO = parcelRequire("6BcBO");
var $x2nP6 = parcelRequire("x2nP6");
const $25b4f06651024bbf$export$56d8a8a25bd48b81 = (0, $6BcBO.GLOBAL_OBJ);
let $25b4f06651024bbf$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $25b4f06651024bbf$export$b79738ab10c590b2() {
    return $25b4f06651024bbf$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $25b4f06651024bbf$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $25b4f06651024bbf$var$ignoreOnError++;
    setTimeout(()=>{
        $25b4f06651024bbf$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $25b4f06651024bbf$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $9v9Yl.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$25b4f06651024bbf$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $25b4f06651024bbf$export$1265a142ff5ba165();
            (0, $x2nP6.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $1Mikf.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $1Mikf.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $bhEJd.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e2) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $9v9Yl.markFunctionWrapped)(sentryWrapped, fn);
    (0, $9v9Yl.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch (e3) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
 //# sourceMappingURL=helpers.js.map

});

parcelRegister("6xrJb", function(module, exports) {
$parcel$export(module.exports, "createUserFeedbackEnvelope", () => $4c2b554c7aa9f03c$export$24a4dfcb686ee5bf);

var $d0PHu = parcelRequire("d0PHu");
var $htKiL = parcelRequire("htKiL");
/**
 * Creates an envelope from a user feedback.
 */ function $4c2b554c7aa9f03c$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $htKiL.dsnToString)(dsn)
        }
    };
    const item = $4c2b554c7aa9f03c$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $d0PHu.createEnvelope)(headers, [
        item
    ]);
}
function $4c2b554c7aa9f03c$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}
 //# sourceMappingURL=userfeedback.js.map

});


parcelRegister("VzPt7", function(module, exports) {
$parcel$export(module.exports, "breadcrumbsIntegration", () => $0ad11de8074991b6$export$c079d904b326663a);

var $a9BnW = parcelRequire("a9BnW");
var $cHb0C = parcelRequire("cHb0C");
var $cgPBw = parcelRequire("cgPBw");

var $jkoPA = parcelRequire("jkoPA");
var $6Fn2e = parcelRequire("6Fn2e");
var $iMnHG = parcelRequire("iMnHG");
var $kE4qe = parcelRequire("kE4qe");
var $3uGpK = parcelRequire("3uGpK");
var $x2nP6 = parcelRequire("x2nP6");
var $fCOkM = parcelRequire("fCOkM");
var $1Mikf = parcelRequire("1Mikf");
var $gb5jY = parcelRequire("gb5jY");
var $hMFeE = parcelRequire("hMFeE");
var $3fQHs = parcelRequire("3fQHs");
var $bpEvF = parcelRequire("bpEvF");

var $bwJrq = parcelRequire("bwJrq");

var $3eIan = parcelRequire("3eIan");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $0ad11de8074991b6$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $0ad11de8074991b6$var$INTEGRATION_NAME = 'Breadcrumbs';
const $0ad11de8074991b6$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $0ad11de8074991b6$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $6Fn2e.addConsoleInstrumentationHandler)($0ad11de8074991b6$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $a9BnW.addClickKeypressInstrumentationHandler)($0ad11de8074991b6$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $cgPBw.addXhrInstrumentationHandler)($0ad11de8074991b6$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $iMnHG.addFetchInstrumentationHandler)($0ad11de8074991b6$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $cHb0C.addHistoryInstrumentationHandler)($0ad11de8074991b6$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $0ad11de8074991b6$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $0ad11de8074991b6$export$c079d904b326663a = (0, $kE4qe.defineIntegration)($0ad11de8074991b6$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $0ad11de8074991b6$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $x2nP6.getClient)() !== client) return;
        (0, $jkoPA.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $1Mikf.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $0ad11de8074991b6$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $x2nP6.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $0ad11de8074991b6$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $bwJrq.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$0ad11de8074991b6$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$0ad11de8074991b6$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $0ad11de8074991b6$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $0ad11de8074991b6$var$_isEvent(event) ? event.target : event;
            target = (0, $fCOkM.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $fCOkM.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $jkoPA.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $0ad11de8074991b6$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $x2nP6.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $bpEvF.severityLevelFromString)(handlerData.level),
            message: (0, $3fQHs.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $3fQHs.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $jkoPA.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $0ad11de8074991b6$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $x2nP6.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $cgPBw.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const level = (0, $3uGpK.getBreadcrumbLogLevelFromHttpStatusCode)(status_code);
        (0, $jkoPA.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http',
            level: level
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $0ad11de8074991b6$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $x2nP6.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $jkoPA.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const level = (0, $3uGpK.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code);
            (0, $jkoPA.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http',
                level: level
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $0ad11de8074991b6$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $x2nP6.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $hMFeE.parseUrl)((0, $3eIan.WINDOW).location.href);
        let parsedFrom = from ? (0, $hMFeE.parseUrl)(from) : undefined;
        const parsedTo = (0, $hMFeE.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $jkoPA.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $0ad11de8074991b6$var$_isEvent(event) {
    return !!event && !!event.target;
}
 //# sourceMappingURL=breadcrumbs.js.map

});
parcelRegister("a9BnW", function(module, exports) {
$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $7647be94cd67ce8a$export$5aeffd3db2cf9df7);

var $6pNMt = parcelRequire("6pNMt");
var $42ZzK = parcelRequire("42ZzK");
var $1jEZO = parcelRequire("1jEZO");

var $azdco = parcelRequire("azdco");
const $7647be94cd67ce8a$var$DEBOUNCE_DURATION = 1000;
let $7647be94cd67ce8a$var$debounceTimerID;
let $7647be94cd67ce8a$var$lastCapturedEventType;
let $7647be94cd67ce8a$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7647be94cd67ce8a$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $6pNMt.addHandler)(type, handler);
    (0, $6pNMt.maybeInstrument)(type, $7647be94cd67ce8a$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $7647be94cd67ce8a$export$3014bbf0af0e1d4a() {
    if (!(0, $azdco.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $6pNMt.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $7647be94cd67ce8a$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $azdco.WINDOW).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $azdco.WINDOW).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $azdco.WINDOW);
        const targetObj = globalObject[target];
        const proto = targetObj && targetObj.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $42ZzK.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $7647be94cd67ce8a$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $42ZzK.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $7647be94cd67ce8a$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $7647be94cd67ce8a$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $7647be94cd67ce8a$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $7647be94cd67ce8a$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $7647be94cd67ce8a$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $7647be94cd67ce8a$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($7647be94cd67ce8a$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $42ZzK.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $42ZzK.addNonEnumerableProperty)(target, '_sentryId', (0, $1jEZO.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$7647be94cd67ce8a$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $7647be94cd67ce8a$var$lastCapturedEventType = event.type;
            $7647be94cd67ce8a$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($7647be94cd67ce8a$var$debounceTimerID);
        $7647be94cd67ce8a$var$debounceTimerID = (0, $azdco.WINDOW).setTimeout(()=>{
            $7647be94cd67ce8a$var$lastCapturedEventTargetId = undefined;
            $7647be94cd67ce8a$var$lastCapturedEventType = undefined;
        }, $7647be94cd67ce8a$var$DEBOUNCE_DURATION);
    };
}
function $7647be94cd67ce8a$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}
 //# sourceMappingURL=dom.js.map

});
parcelRegister("6pNMt", function(module, exports) {
$parcel$export(module.exports, "addHandler", () => $0134936035cf5d13$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $0134936035cf5d13$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $0134936035cf5d13$export$b18c893e424d3127);

var $c0SYH = parcelRequire("c0SYH");

var $9QJSh = parcelRequire("9QJSh");

var $jqGzp = parcelRequire("jqGzp");
// We keep the handlers globally
const $0134936035cf5d13$var$handlers = {};
const $0134936035cf5d13$var$instrumented = {};
/** Add a handler function. */ function $0134936035cf5d13$export$a4e09611e30da72e(type, handler) {
    $0134936035cf5d13$var$handlers[type] = $0134936035cf5d13$var$handlers[type] || [];
    $0134936035cf5d13$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $0134936035cf5d13$export$b17eab759a1cb5fe() {
    Object.keys($0134936035cf5d13$var$handlers).forEach((key)=>{
        $0134936035cf5d13$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $0134936035cf5d13$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$0134936035cf5d13$var$instrumented[type]) {
        $0134936035cf5d13$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $c0SYH.DEBUG_BUILD) && (0, $9QJSh.logger).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $0134936035cf5d13$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $0134936035cf5d13$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $c0SYH.DEBUG_BUILD) && (0, $9QJSh.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $jqGzp.getFunctionName)(handler)}\nError:`, e);
    }
}
 //# sourceMappingURL=handlers.js.map

});
parcelRegister("c0SYH", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $8bf0219e8284378e$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $8bf0219e8284378e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map

});

parcelRegister("9QJSh", function(module, exports) {
$parcel$export(module.exports, "logger", () => $72bc8e201be2e1e1$export$af88d00dbe7f521);

var $c0SYH = parcelRequire("c0SYH");

var $bCKXd = parcelRequire("bCKXd");
/** Prefix for logging strings */ const $72bc8e201be2e1e1$var$PREFIX = 'Sentry Logger ';
const $72bc8e201be2e1e1$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $72bc8e201be2e1e1$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $72bc8e201be2e1e1$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $bCKXd.GLOBAL_OBJ))) return callback();
    const console = (0, $bCKXd.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($72bc8e201be2e1e1$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $72bc8e201be2e1e1$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $72bc8e201be2e1e1$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $c0SYH.DEBUG_BUILD) $72bc8e201be2e1e1$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $72bc8e201be2e1e1$export$cda52e2a8927a2ca(()=>{
                (0, $bCKXd.GLOBAL_OBJ).console[name](`${$72bc8e201be2e1e1$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $72bc8e201be2e1e1$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $72bc8e201be2e1e1$export$af88d00dbe7f521 = (0, $bCKXd.getGlobalSingleton)('logger', $72bc8e201be2e1e1$var$makeLogger);
 //# sourceMappingURL=logger.js.map

});
parcelRegister("bCKXd", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", () => $8767aa702c64c6c1$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalSingleton", () => $8767aa702c64c6c1$export$7e223ec222791509);

var $eScZH = parcelRequire("eScZH");
/** Get's the global object for the current JavaScript runtime */ const $8767aa702c64c6c1$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $8767aa702c64c6c1$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $8767aa702c64c6c1$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $eScZH.SDK_VERSION] = __SENTRY__[0, $eScZH.SDK_VERSION] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}
 //# sourceMappingURL=worldwide.js.map

});
parcelRegister("eScZH", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $ad4030300a7cc88d$export$31499a9cd224b78c);
// This is a magic string replaced by rollup
const $ad4030300a7cc88d$export$31499a9cd224b78c = "8.48.0";
 //# sourceMappingURL=version.js.map

});



parcelRegister("jqGzp", function(module, exports) {
$parcel$export(module.exports, "getFunctionName", () => $e251778e719ed1dc$export$aad197c7121a6651);
const $e251778e719ed1dc$var$STACKTRACE_FRAME_LIMIT = 50;
const $e251778e719ed1dc$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $e251778e719ed1dc$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $e251778e719ed1dc$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $e251778e719ed1dc$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $e251778e719ed1dc$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($e251778e719ed1dc$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $e251778e719ed1dc$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $e251778e719ed1dc$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $e251778e719ed1dc$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $e251778e719ed1dc$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $e251778e719ed1dc$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($e251778e719ed1dc$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($e251778e719ed1dc$var$STRIP_FRAME_REGEXP.test($e251778e719ed1dc$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($e251778e719ed1dc$var$STRIP_FRAME_REGEXP.test($e251778e719ed1dc$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $e251778e719ed1dc$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $e251778e719ed1dc$var$getLastStackFrame(localStack).filename,
            function: frame.function || $e251778e719ed1dc$export$27c7e15d453fc0ac
        }));
}
function $e251778e719ed1dc$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $e251778e719ed1dc$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $e251778e719ed1dc$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $e251778e719ed1dc$var$defaultFunctionName;
        return fn.name || $e251778e719ed1dc$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $e251778e719ed1dc$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $e251778e719ed1dc$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}
 //# sourceMappingURL=stacktrace.js.map

});


parcelRegister("42ZzK", function(module, exports) {
$parcel$export(module.exports, "fill", () => $2f271cf1e1805d72$export$9563e054e6f787fb);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $2f271cf1e1805d72$export$e73679ffaf56810e);

var $kZAgV = parcelRequire("kZAgV");

var $c0SYH = parcelRequire("c0SYH");

var $iSDQx = parcelRequire("iSDQx");

var $9QJSh = parcelRequire("9QJSh");

var $5TVAT = parcelRequire("5TVAT");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $2f271cf1e1805d72$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $2f271cf1e1805d72$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $c0SYH.DEBUG_BUILD) && (0, $9QJSh.logger).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $2f271cf1e1805d72$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $c0SYH.DEBUG_BUILD) && (0, $9QJSh.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $2f271cf1e1805d72$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $2f271cf1e1805d72$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $2f271cf1e1805d72$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 *
 * @deprecated This function is deprecated and will be removed in the next major version of the SDK.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2f271cf1e1805d72$export$9ef804feabbcbaf1(object) {
    return Object.entries(object).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $2f271cf1e1805d72$export$62ff257738bf57f5(value) {
    if ((0, $iSDQx.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$2f271cf1e1805d72$var$getOwnProperties(value)
    };
    else if ((0, $iSDQx.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $2f271cf1e1805d72$var$serializeEventTarget(value.target),
            currentTarget: $2f271cf1e1805d72$var$serializeEventTarget(value.currentTarget),
            ...$2f271cf1e1805d72$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $iSDQx.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $2f271cf1e1805d72$var$serializeEventTarget(target) {
    try {
        return (0, $iSDQx.isElement)(target) ? (0, $kZAgV.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $2f271cf1e1805d72$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $2f271cf1e1805d72$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($2f271cf1e1805d72$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $5TVAT.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $5TVAT.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $2f271cf1e1805d72$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $2f271cf1e1805d72$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $2f271cf1e1805d72$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($2f271cf1e1805d72$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $2f271cf1e1805d72$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($2f271cf1e1805d72$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $2f271cf1e1805d72$var$isPojo(input) {
    if (!(0, $iSDQx.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e2) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $2f271cf1e1805d72$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $iSDQx.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
 //# sourceMappingURL=object.js.map

});
parcelRegister("kZAgV", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $f485a40373c74a6d$export$5647df6b7814ac86);

var $iSDQx = parcelRequire("iSDQx");

var $bCKXd = parcelRequire("bCKXd");
const $f485a40373c74a6d$var$WINDOW = (0, $bCKXd.GLOBAL_OBJ);
const $f485a40373c74a6d$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $f485a40373c74a6d$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $f485a40373c74a6d$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $f485a40373c74a6d$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $f485a40373c74a6d$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($f485a40373c74a6d$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $iSDQx.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $f485a40373c74a6d$export$1cfafeee2987818b() {
    try {
        return $f485a40373c74a6d$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 *
 * @deprecated This method is deprecated and will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f485a40373c74a6d$export$c660c1f3ab49225c(selector) {
    if ($f485a40373c74a6d$var$WINDOW.document && $f485a40373c74a6d$var$WINDOW.document.querySelector) return $f485a40373c74a6d$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $f485a40373c74a6d$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$f485a40373c74a6d$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
 //# sourceMappingURL=browser.js.map

});
parcelRegister("iSDQx", function(module, exports) {
$parcel$export(module.exports, "isError", () => $dbec2dcca4aa8d25$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $dbec2dcca4aa8d25$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $dbec2dcca4aa8d25$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $dbec2dcca4aa8d25$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $dbec2dcca4aa8d25$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $dbec2dcca4aa8d25$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $dbec2dcca4aa8d25$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $dbec2dcca4aa8d25$export$49841c62b9eff15);
$parcel$export(module.exports, "isVueViewModel", () => $dbec2dcca4aa8d25$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $dbec2dcca4aa8d25$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$e6127cc7fe7395c3(wat) {
    switch($dbec2dcca4aa8d25$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $dbec2dcca4aa8d25$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$var$isBuiltin(wat, className) {
    return $dbec2dcca4aa8d25$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$9f9636d330b71954(wat) {
    return $dbec2dcca4aa8d25$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$ef9e2056653f0c8e(wat) {
    return $dbec2dcca4aa8d25$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$12e869b2a583f783(wat) {
    return $dbec2dcca4aa8d25$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$844ec244b1367d54(wat) {
    return $dbec2dcca4aa8d25$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$c3825b437cbdea5c(wat) {
    return wat === null || $dbec2dcca4aa8d25$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$53b83ca8eaab0383(wat) {
    return $dbec2dcca4aa8d25$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $dbec2dcca4aa8d25$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $dbec2dcca4aa8d25$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$49841c62b9eff15(wat) {
    return $dbec2dcca4aa8d25$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $dbec2dcca4aa8d25$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$bc2894c7158efbac(wat) {
    return $dbec2dcca4aa8d25$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $dbec2dcca4aa8d25$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
 //# sourceMappingURL=is.js.map

});


parcelRegister("5TVAT", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $44bec3c5b1bd9617$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $44bec3c5b1bd9617$export$4215662d762d6f9d);

var $iSDQx = parcelRequire("iSDQx");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $44bec3c5b1bd9617$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $44bec3c5b1bd9617$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $44bec3c5b1bd9617$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $iSDQx.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $44bec3c5b1bd9617$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $iSDQx.isString)(value)) return false;
    if ((0, $iSDQx.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $iSDQx.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $44bec3c5b1bd9617$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$44bec3c5b1bd9617$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}
 //# sourceMappingURL=string.js.map

});


parcelRegister("1jEZO", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $0f575dbf06e03baf$export$19f53698e68b2496);

var $42ZzK = parcelRequire("42ZzK");

var $5TVAT = parcelRequire("5TVAT");

var $bCKXd = parcelRequire("bCKXd");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $0f575dbf06e03baf$export$19f53698e68b2496() {
    const gbl = (0, $bCKXd.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $0f575dbf06e03baf$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $0f575dbf06e03baf$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $0f575dbf06e03baf$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $0f575dbf06e03baf$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $0f575dbf06e03baf$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $0f575dbf06e03baf$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $0f575dbf06e03baf$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $0f575dbf06e03baf$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $0f575dbf06e03baf$export$d364f2020ab30578(input) {
    const match = input.match($0f575dbf06e03baf$var$SEMVER_REGEXP) || [];
    const major = $0f575dbf06e03baf$var$_parseInt(match[1]);
    const minor = $0f575dbf06e03baf$var$_parseInt(match[2]);
    const patch = $0f575dbf06e03baf$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $0f575dbf06e03baf$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $5TVAT.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $5TVAT.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $5TVAT.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $0f575dbf06e03baf$export$6de4ffac6a2f1098(exception) {
    if ($0f575dbf06e03baf$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $42ZzK.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $0f575dbf06e03baf$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 *
 * @deprecated This function has been deprecated and will not be replaced.
 */ function $0f575dbf06e03baf$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}
 //# sourceMappingURL=misc.js.map

});

parcelRegister("azdco", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $7b176950a4ce5dff$export$56d8a8a25bd48b81);

var $bCKXd = parcelRequire("bCKXd");
const $7b176950a4ce5dff$export$56d8a8a25bd48b81 = (0, $bCKXd.GLOBAL_OBJ);
 //# sourceMappingURL=types.js.map

});


parcelRegister("cHb0C", function(module, exports) {
$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $93e20a54ca61dfc8$export$3f18c56c58114e75);

var $6pNMt = parcelRequire("6pNMt");
var $42ZzK = parcelRequire("42ZzK");
var $gvKgJ = parcelRequire("gvKgJ");

var $azdco = parcelRequire("azdco");
let $93e20a54ca61dfc8$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $93e20a54ca61dfc8$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $6pNMt.addHandler)(type, handler);
    (0, $6pNMt.maybeInstrument)(type, $93e20a54ca61dfc8$var$instrumentHistory);
}
function $93e20a54ca61dfc8$var$instrumentHistory() {
    if (!(0, $gvKgJ.supportsHistory)()) return;
    const oldOnPopState = (0, $azdco.WINDOW).onpopstate;
    (0, $azdco.WINDOW).onpopstate = function(...args) {
        const to = (0, $azdco.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $93e20a54ca61dfc8$var$lastHref;
        $93e20a54ca61dfc8$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $6pNMt.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $93e20a54ca61dfc8$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $93e20a54ca61dfc8$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $6pNMt.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $42ZzK.fill)((0, $azdco.WINDOW).history, 'pushState', historyReplacementFunction);
    (0, $42ZzK.fill)((0, $azdco.WINDOW).history, 'replaceState', historyReplacementFunction);
}
 //# sourceMappingURL=history.js.map

});
parcelRegister("gvKgJ", function(module, exports) {
$parcel$export(module.exports, "supportsHistory", () => $c0536e9fe0d9893e$export$67fc34576016d6ec);

var $bCKXd = parcelRequire("bCKXd");
// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $c0536e9fe0d9893e$var$WINDOW = (0, $bCKXd.GLOBAL_OBJ);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $c0536e9fe0d9893e$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    // TODO(v9): Remove this custom check, it is pretty old and likely not needed anymore
    const chromeVar = $c0536e9fe0d9893e$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    const hasHistoryApi = 'history' in $c0536e9fe0d9893e$var$WINDOW && !!$c0536e9fe0d9893e$var$WINDOW.history.pushState && !!$c0536e9fe0d9893e$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
 //# sourceMappingURL=supportsHistory.js.map

});


parcelRegister("cgPBw", function(module, exports) {
$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $8eef022d35eead7a$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $8eef022d35eead7a$export$26ace48dd54c9aea);

var $6pNMt = parcelRequire("6pNMt");
var $iSDQx = parcelRequire("iSDQx");
var $a3OQA = parcelRequire("a3OQA");

var $azdco = parcelRequire("azdco");
const $8eef022d35eead7a$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8eef022d35eead7a$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $6pNMt.addHandler)(type, handler);
    (0, $6pNMt.maybeInstrument)(type, $8eef022d35eead7a$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $8eef022d35eead7a$export$c67d533bf77cbf54() {
    if (!(0, $azdco.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $a3OQA.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $iSDQx.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $8eef022d35eead7a$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$8eef022d35eead7a$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$8eef022d35eead7a$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $a3OQA.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $6pNMt.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$8eef022d35eead7a$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $iSDQx.isString)(header) && (0, $iSDQx.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$8eef022d35eead7a$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $a3OQA.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $6pNMt.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $8eef022d35eead7a$var$parseUrl(url) {
    if ((0, $iSDQx.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}
 //# sourceMappingURL=xhr.js.map

});
parcelRegister("a3OQA", function(module, exports) {
$parcel$export(module.exports, "timestampInSeconds", () => $7531a064eb04c44d$export$ee52dced521e3e18);

var $bCKXd = parcelRequire("bCKXd");
const $7531a064eb04c44d$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $7531a064eb04c44d$export$7740643b9eeaf0c4() {
    return Date.now() / $7531a064eb04c44d$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $7531a064eb04c44d$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $bCKXd.GLOBAL_OBJ);
    if (!performance || !performance.now) return $7531a064eb04c44d$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $7531a064eb04c44d$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $7531a064eb04c44d$export$ee52dced521e3e18 = $7531a064eb04c44d$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 *
 * @deprecated This variable will be removed in the next major version.
 */ let $7531a064eb04c44d$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $7531a064eb04c44d$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $bCKXd.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        // eslint-disable-next-line deprecation/deprecation
        $7531a064eb04c44d$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            // eslint-disable-next-line deprecation/deprecation
            $7531a064eb04c44d$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            // eslint-disable-next-line deprecation/deprecation
            $7531a064eb04c44d$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    // eslint-disable-next-line deprecation/deprecation
    $7531a064eb04c44d$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();
 //# sourceMappingURL=time.js.map

});


parcelRegister("jkoPA", function(module, exports) {
$parcel$export(module.exports, "addBreadcrumb", () => $e123257b1ad790c9$export$efda9a273d7a036d);

var $x2nP6 = parcelRequire("x2nP6");

var $gb5jY = parcelRequire("gb5jY");

var $fPxtX = parcelRequire("fPxtX");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $e123257b1ad790c9$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $e123257b1ad790c9$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $x2nP6.getClient)();
    const isolationScope = (0, $x2nP6.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $e123257b1ad790c9$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $fPxtX.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $gb5jY.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
 //# sourceMappingURL=breadcrumbs.js.map

});

parcelRegister("6Fn2e", function(module, exports) {
$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $4da870abb4fe59ed$export$1d6e0d073f9e6723);

var $gb5jY = parcelRequire("gb5jY");

var $9v9Yl = parcelRequire("9v9Yl");

var $6BcBO = parcelRequire("6BcBO");

var $bSkKy = parcelRequire("bSkKy");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4da870abb4fe59ed$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $bSkKy.addHandler)(type, handler);
    (0, $bSkKy.maybeInstrument)(type, $4da870abb4fe59ed$var$instrumentConsole);
}
function $4da870abb4fe59ed$var$instrumentConsole() {
    if (!('console' in (0, $6BcBO.GLOBAL_OBJ))) return;
    (0, $gb5jY.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $6BcBO.GLOBAL_OBJ).console)) return;
        (0, $9v9Yl.fill)((0, $6BcBO.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $gb5jY.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $bSkKy.triggerHandlers)('console', handlerData);
                const log = (0, $gb5jY.originalConsoleMethods)[level];
                log && log.apply((0, $6BcBO.GLOBAL_OBJ).console, args);
            };
        });
    });
}
 //# sourceMappingURL=console.js.map

});
parcelRegister("bSkKy", function(module, exports) {
$parcel$export(module.exports, "addHandler", () => $8a54d55f496832c7$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $8a54d55f496832c7$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $8a54d55f496832c7$export$b18c893e424d3127);

var $jhPin = parcelRequire("jhPin");

var $gb5jY = parcelRequire("gb5jY");

var $fmUGy = parcelRequire("fmUGy");
// We keep the handlers globally
const $8a54d55f496832c7$var$handlers = {};
const $8a54d55f496832c7$var$instrumented = {};
/** Add a handler function. */ function $8a54d55f496832c7$export$a4e09611e30da72e(type, handler) {
    $8a54d55f496832c7$var$handlers[type] = $8a54d55f496832c7$var$handlers[type] || [];
    $8a54d55f496832c7$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $8a54d55f496832c7$export$b17eab759a1cb5fe() {
    Object.keys($8a54d55f496832c7$var$handlers).forEach((key)=>{
        $8a54d55f496832c7$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $8a54d55f496832c7$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$8a54d55f496832c7$var$instrumented[type]) {
        $8a54d55f496832c7$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $jhPin.DEBUG_BUILD) && (0, $gb5jY.logger).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $8a54d55f496832c7$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $8a54d55f496832c7$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $jhPin.DEBUG_BUILD) && (0, $gb5jY.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $fmUGy.getFunctionName)(handler)}\nError:`, e);
    }
}
 //# sourceMappingURL=handlers.js.map

});


parcelRegister("iMnHG", function(module, exports) {
$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $dabf18bd89be4a78$export$f75d3c772c923df0);

var $fpqOZ = parcelRequire("fpqOZ");

var $9v9Yl = parcelRequire("9v9Yl");

var $jqugQ = parcelRequire("jqugQ");

var $fPxtX = parcelRequire("fPxtX");

var $6BcBO = parcelRequire("6BcBO");

var $bSkKy = parcelRequire("bSkKy");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $dabf18bd89be4a78$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $bSkKy.addHandler)(type, handler);
    (0, $bSkKy.maybeInstrument)(type, ()=>$dabf18bd89be4a78$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $dabf18bd89be4a78$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $bSkKy.addHandler)(type, handler);
    (0, $bSkKy.maybeInstrument)(type, ()=>$dabf18bd89be4a78$var$instrumentFetch($dabf18bd89be4a78$var$streamHandler));
}
function $dabf18bd89be4a78$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $jqugQ.supportsNativeFetch)()) return;
    (0, $9v9Yl.fill)((0, $6BcBO.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $dabf18bd89be4a78$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $fPxtX.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $bSkKy.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $6BcBO.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $bSkKy.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $fPxtX.timestampInSeconds)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $bSkKy.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $fPxtX.timestampInSeconds)() * 1000,
                    error: error
                });
                if ((0, $fpqOZ.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $9v9Yl.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $dabf18bd89be4a78$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $dabf18bd89be4a78$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $dabf18bd89be4a78$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $bSkKy.triggerHandlers)('fetch-body-resolved', {
            endTimestamp: (0, $fPxtX.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $dabf18bd89be4a78$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $dabf18bd89be4a78$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($dabf18bd89be4a78$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $dabf18bd89be4a78$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $dabf18bd89be4a78$var$getUrlFromResource(url),
            method: $dabf18bd89be4a78$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $dabf18bd89be4a78$var$getUrlFromResource(arg),
        method: $dabf18bd89be4a78$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
 //# sourceMappingURL=fetch.js.map

});

parcelRegister("3uGpK", function(module, exports) {
$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", () => $28b5130840fdc55f$export$b8cfcc4175694bcc);
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $28b5130840fdc55f$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}
 //# sourceMappingURL=breadcrumb-log-level.js.map

});

parcelRegister("hMFeE", function(module, exports) {
$parcel$export(module.exports, "parseUrl", () => $cf26e7d6810afb28$export$7a5253c0f62e0150);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $cf26e7d6810afb28$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $cf26e7d6810afb28$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 *
 * @deprecated This function will be removed in the next major version.
 */ // TODO(v9): Hoist this function into the places where we use it. (as it stands only react router v6 instrumentation)
function $cf26e7d6810afb28$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $cf26e7d6810afb28$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}
 //# sourceMappingURL=url.js.map

});

parcelRegister("bpEvF", function(module, exports) {
$parcel$export(module.exports, "severityLevelFromString", () => $84f173e7505173af$export$d771ef054122c30a);
/**
 * @deprecated This variable has been deprecated and will be removed in the next major version.
 */ const $84f173e7505173af$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $84f173e7505173af$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}
 //# sourceMappingURL=severity.js.map

});


parcelRegister("ejF24", function(module, exports) {
$parcel$export(module.exports, "browserApiErrorsIntegration", () => $a6c2ab360a0502c6$export$59bfe9f1c76150e);

var $kE4qe = parcelRequire("kE4qe");
var $9v9Yl = parcelRequire("9v9Yl");
var $fmUGy = parcelRequire("fmUGy");

var $3eIan = parcelRequire("3eIan");
const $a6c2ab360a0502c6$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $a6c2ab360a0502c6$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $a6c2ab360a0502c6$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $a6c2ab360a0502c6$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $9v9Yl.fill)((0, $3eIan.WINDOW), 'setTimeout', $a6c2ab360a0502c6$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $9v9Yl.fill)((0, $3eIan.WINDOW), 'setInterval', $a6c2ab360a0502c6$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $9v9Yl.fill)((0, $3eIan.WINDOW), 'requestAnimationFrame', $a6c2ab360a0502c6$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $3eIan.WINDOW)) (0, $9v9Yl.fill)(XMLHttpRequest.prototype, 'send', $a6c2ab360a0502c6$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $a6c2ab360a0502c6$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($a6c2ab360a0502c6$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $a6c2ab360a0502c6$export$59bfe9f1c76150e = (0, $kE4qe.defineIntegration)($a6c2ab360a0502c6$var$_browserApiErrorsIntegration);
function $a6c2ab360a0502c6$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $3eIan.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $fmUGy.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $a6c2ab360a0502c6$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $3eIan.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $fmUGy.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $a6c2ab360a0502c6$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $9v9Yl.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $fmUGy.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $9v9Yl.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $fmUGy.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $3eIan.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $a6c2ab360a0502c6$var$_wrapEventTarget(target) {
    const globalObject = (0, $3eIan.WINDOW);
    const targetObj = globalObject[target];
    const proto = targetObj && targetObj.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $9v9Yl.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($a6c2ab360a0502c6$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $3eIan.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $fmUGy.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (e2) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $3eIan.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $fmUGy.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $9v9Yl.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $a6c2ab360a0502c6$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
 //# sourceMappingURL=browserapierrors.js.map

});

parcelRegister("hdU18", function(module, exports) {
$parcel$export(module.exports, "browserSessionIntegration", () => $c89f1a68f39fe238$export$1baa7880e357371c);

var $cHb0C = parcelRequire("cHb0C");

var $bhEJd = parcelRequire("bhEJd");
var $kE4qe = parcelRequire("kE4qe");
var $gb5jY = parcelRequire("gb5jY");

var $bwJrq = parcelRequire("bwJrq");

var $3eIan = parcelRequire("3eIan");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $c89f1a68f39fe238$export$1baa7880e357371c = (0, $kE4qe.defineIntegration)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $3eIan.WINDOW).document === 'undefined') {
                (0, $bwJrq.DEBUG_BUILD) && (0, $gb5jY.logger).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $bhEJd.startSession)({
                ignoreDuration: true
            });
            (0, $bhEJd.captureSession)();
            // We want to create a session for every navigation as well
            (0, $cHb0C.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $bhEJd.startSession)({
                        ignoreDuration: true
                    });
                    (0, $bhEJd.captureSession)();
                }
            });
        }
    };
});
 //# sourceMappingURL=browsersession.js.map

});

parcelRegister("9Dk4x", function(module, exports) {
$parcel$export(module.exports, "globalHandlersIntegration", () => $7037537db0f514c2$export$66acc70e8cf2b71a);

var $13711 = parcelRequire("13711");
var $93Sh7 = parcelRequire("93Sh7");
var $bhEJd = parcelRequire("bhEJd");
var $kE4qe = parcelRequire("kE4qe");
var $x2nP6 = parcelRequire("x2nP6");
var $fCOkM = parcelRequire("fCOkM");
var $fpqOZ = parcelRequire("fpqOZ");
var $gb5jY = parcelRequire("gb5jY");
var $fmUGy = parcelRequire("fmUGy");

var $bwJrq = parcelRequire("bwJrq");

var $bCht7 = parcelRequire("bCht7");

var $3eIan = parcelRequire("3eIan");
const $7037537db0f514c2$var$INTEGRATION_NAME = 'GlobalHandlers';
const $7037537db0f514c2$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $7037537db0f514c2$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $7037537db0f514c2$var$_installGlobalOnErrorHandler(client);
                $7037537db0f514c2$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $7037537db0f514c2$var$_installGlobalOnUnhandledRejectionHandler(client);
                $7037537db0f514c2$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $7037537db0f514c2$export$66acc70e8cf2b71a = (0, $kE4qe.defineIntegration)($7037537db0f514c2$var$_globalHandlersIntegration);
function $7037537db0f514c2$var$_installGlobalOnErrorHandler(client) {
    (0, $13711.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $7037537db0f514c2$var$getOptions();
        if ((0, $x2nP6.getClient)() !== client || (0, $3eIan.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $7037537db0f514c2$var$_enhanceEventWithInitialFrame((0, $bCht7.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $bhEJd.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $7037537db0f514c2$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $93Sh7.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $7037537db0f514c2$var$getOptions();
        if ((0, $x2nP6.getClient)() !== client || (0, $3eIan.shouldIgnoreOnError)()) return;
        const error = $7037537db0f514c2$var$_getUnhandledRejectionError(e);
        const event = (0, $fpqOZ.isPrimitive)(error) ? $7037537db0f514c2$var$_eventFromRejectionWithPrimitive(error) : (0, $bCht7.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $bhEJd.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $7037537db0f514c2$var$_getUnhandledRejectionError(error) {
    if ((0, $fpqOZ.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $7037537db0f514c2$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $7037537db0f514c2$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $fpqOZ.isString)(url) && url.length > 0 ? url : (0, $fCOkM.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $fmUGy.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $7037537db0f514c2$var$globalHandlerLog(type) {
    (0, $bwJrq.DEBUG_BUILD) && (0, $gb5jY.logger).log(`Global Handler attached: ${type}`);
}
function $7037537db0f514c2$var$getOptions() {
    const client = (0, $x2nP6.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
 //# sourceMappingURL=globalhandlers.js.map

});
parcelRegister("13711", function(module, exports) {
$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $0c3b835fbbbc539b$export$55b5c3ba2194f0c6);

var $6BcBO = parcelRequire("6BcBO");

var $bSkKy = parcelRequire("bSkKy");
let $0c3b835fbbbc539b$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0c3b835fbbbc539b$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $bSkKy.addHandler)(type, handler);
    (0, $bSkKy.maybeInstrument)(type, $0c3b835fbbbc539b$var$instrumentError);
}
function $0c3b835fbbbc539b$var$instrumentError() {
    $0c3b835fbbbc539b$var$_oldOnErrorHandler = (0, $6BcBO.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $6BcBO.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $bSkKy.triggerHandlers)('error', handlerData);
        if ($0c3b835fbbbc539b$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $0c3b835fbbbc539b$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $6BcBO.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}
 //# sourceMappingURL=globalError.js.map

});

parcelRegister("93Sh7", function(module, exports) {
$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $698e7ec24f7aa20d$export$8bf4fc6858821a4e);

var $6BcBO = parcelRequire("6BcBO");

var $bSkKy = parcelRequire("bSkKy");
let $698e7ec24f7aa20d$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $698e7ec24f7aa20d$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $bSkKy.addHandler)(type, handler);
    (0, $bSkKy.maybeInstrument)(type, $698e7ec24f7aa20d$var$instrumentUnhandledRejection);
}
function $698e7ec24f7aa20d$var$instrumentUnhandledRejection() {
    $698e7ec24f7aa20d$var$_oldOnUnhandledRejectionHandler = (0, $6BcBO.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $6BcBO.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $bSkKy.triggerHandlers)('unhandledrejection', handlerData);
        if ($698e7ec24f7aa20d$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $698e7ec24f7aa20d$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $6BcBO.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
 //# sourceMappingURL=globalUnhandledRejection.js.map

});


parcelRegister("GFolx", function(module, exports) {
$parcel$export(module.exports, "httpContextIntegration", () => $080407e28890821f$export$1378794447170364);

var $kE4qe = parcelRequire("kE4qe");

var $3eIan = parcelRequire("3eIan");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $080407e28890821f$export$1378794447170364 = (0, $kE4qe.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $3eIan.WINDOW).navigator && !(0, $3eIan.WINDOW).location && !(0, $3eIan.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $3eIan.WINDOW).location && (0, $3eIan.WINDOW).location.href;
            const { referrer: referrer } = (0, $3eIan.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $3eIan.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});
 //# sourceMappingURL=httpcontext.js.map

});

parcelRegister("6kme1", function(module, exports) {
$parcel$export(module.exports, "linkedErrorsIntegration", () => $49b5d9c7dff3c892$export$ebabb00eb7f3a395);

var $46oRv = parcelRequire("46oRv");
var $kE4qe = parcelRequire("kE4qe");

var $bCht7 = parcelRequire("bCht7");
const $49b5d9c7dff3c892$var$DEFAULT_KEY = 'cause';
const $49b5d9c7dff3c892$var$DEFAULT_LIMIT = 5;
const $49b5d9c7dff3c892$var$INTEGRATION_NAME = 'LinkedErrors';
const $49b5d9c7dff3c892$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $49b5d9c7dff3c892$var$DEFAULT_LIMIT;
    const key = options.key || $49b5d9c7dff3c892$var$DEFAULT_KEY;
    return {
        name: $49b5d9c7dff3c892$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $46oRv.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $bCht7.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $49b5d9c7dff3c892$export$ebabb00eb7f3a395 = (0, $kE4qe.defineIntegration)($49b5d9c7dff3c892$var$_linkedErrorsIntegration);
 //# sourceMappingURL=linkederrors.js.map

});
parcelRegister("46oRv", function(module, exports) {
$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $2fcb0209ba403a91$export$b91c38ed7d8ae9b2);

var $fpqOZ = parcelRequire("fpqOZ");

var $3fQHs = parcelRequire("3fQHs");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $2fcb0209ba403a91$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $fpqOZ.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $2fcb0209ba403a91$var$truncateAggregateExceptions($2fcb0209ba403a91$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $2fcb0209ba403a91$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $fpqOZ.isInstanceOf)(error[key], Error)) {
        $2fcb0209ba403a91$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $2fcb0209ba403a91$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $2fcb0209ba403a91$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $fpqOZ.isInstanceOf)(childError, Error)) {
            $2fcb0209ba403a91$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $2fcb0209ba403a91$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $2fcb0209ba403a91$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $2fcb0209ba403a91$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $2fcb0209ba403a91$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $2fcb0209ba403a91$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $3fQHs.truncate)(exception.value, maxValueLength);
        return exception;
    });
}
 //# sourceMappingURL=aggregate-errors.js.map

});


parcelRegister("9LQEU", function(module, exports) {
$parcel$export(module.exports, "defaultStackParser", () => $71d159cfa31e57f2$export$2b2b997d81bf3907);

var $fmUGy = parcelRequire("fmUGy");
// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $71d159cfa31e57f2$var$OPERA10_PRIORITY = 10;
const $71d159cfa31e57f2$var$OPERA11_PRIORITY = 20;
const $71d159cfa31e57f2$var$CHROME_PRIORITY = 30;
const $71d159cfa31e57f2$var$WINJS_PRIORITY = 40;
const $71d159cfa31e57f2$var$GECKO_PRIORITY = 50;
function $71d159cfa31e57f2$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $fmUGy.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $71d159cfa31e57f2$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $71d159cfa31e57f2$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $71d159cfa31e57f2$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $71d159cfa31e57f2$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $71d159cfa31e57f2$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $71d159cfa31e57f2$var$createFrame(filename, (0, $fmUGy.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $71d159cfa31e57f2$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $71d159cfa31e57f2$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $71d159cfa31e57f2$var$extractSafariExtensionDetails(parts[1] || (0, $fmUGy.UNKNOWN_FUNCTION), parts[2]);
        return $71d159cfa31e57f2$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $71d159cfa31e57f2$export$263a749fff749872 = [
    $71d159cfa31e57f2$var$CHROME_PRIORITY,
    $71d159cfa31e57f2$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $71d159cfa31e57f2$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $71d159cfa31e57f2$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $71d159cfa31e57f2$var$gecko = (line)=>{
    const parts = $71d159cfa31e57f2$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $71d159cfa31e57f2$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $fmUGy.UNKNOWN_FUNCTION);
        [func, filename] = $71d159cfa31e57f2$var$extractSafariExtensionDetails(func, filename);
        return $71d159cfa31e57f2$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $71d159cfa31e57f2$export$cdba47a5dd2804d = [
    $71d159cfa31e57f2$var$GECKO_PRIORITY,
    $71d159cfa31e57f2$var$gecko
];
const $71d159cfa31e57f2$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $71d159cfa31e57f2$var$winjs = (line)=>{
    const parts = $71d159cfa31e57f2$var$winjsRegex.exec(line);
    return parts ? $71d159cfa31e57f2$var$createFrame(parts[2], parts[1] || (0, $fmUGy.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $71d159cfa31e57f2$export$179460296da408e8 = [
    $71d159cfa31e57f2$var$WINJS_PRIORITY,
    $71d159cfa31e57f2$var$winjs
];
const $71d159cfa31e57f2$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $71d159cfa31e57f2$var$opera10 = (line)=>{
    const parts = $71d159cfa31e57f2$var$opera10Regex.exec(line);
    return parts ? $71d159cfa31e57f2$var$createFrame(parts[2], parts[3] || (0, $fmUGy.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $71d159cfa31e57f2$export$f892b52c880ffc7a = [
    $71d159cfa31e57f2$var$OPERA10_PRIORITY,
    $71d159cfa31e57f2$var$opera10
];
const $71d159cfa31e57f2$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $71d159cfa31e57f2$var$opera11 = (line)=>{
    const parts = $71d159cfa31e57f2$var$opera11Regex.exec(line);
    return parts ? $71d159cfa31e57f2$var$createFrame(parts[5], parts[3] || parts[4] || (0, $fmUGy.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $71d159cfa31e57f2$export$af11af13f09fb0dc = [
    $71d159cfa31e57f2$var$OPERA11_PRIORITY,
    $71d159cfa31e57f2$var$opera11
];
const $71d159cfa31e57f2$export$7197c0fe6554c079 = [
    $71d159cfa31e57f2$export$263a749fff749872,
    $71d159cfa31e57f2$export$cdba47a5dd2804d
];
const $71d159cfa31e57f2$export$2b2b997d81bf3907 = (0, $fmUGy.createStackParser)(...$71d159cfa31e57f2$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $71d159cfa31e57f2$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $fmUGy.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};
 //# sourceMappingURL=stack-parsers.js.map

});

parcelRegister("b6yqE", function(module, exports) {
$parcel$export(module.exports, "makeFetchTransport", () => $815af61a584cedec$export$b2311068c46d7cc8);

var $cm1l0 = parcelRequire("cm1l0");

var $7hMXL = parcelRequire("7hMXL");
var $dGw9M = parcelRequire("dGw9M");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $815af61a584cedec$export$b2311068c46d7cc8(options, nativeFetch = (0, $cm1l0.getNativeImplementation)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $cm1l0.clearCachedImplementation)('fetch');
            return (0, $dGw9M.rejectedSyncPromise)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $cm1l0.clearCachedImplementation)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $dGw9M.rejectedSyncPromise)(e);
        }
    }
    return (0, $7hMXL.createTransport)(options, makeRequest);
}
 //# sourceMappingURL=fetch.js.map

});
parcelRegister("cm1l0", function(module, exports) {
$parcel$export(module.exports, "getNativeImplementation", () => $8fe893ca5c83d79b$export$e464f4a514ac28a8);
$parcel$export(module.exports, "clearCachedImplementation", () => $8fe893ca5c83d79b$export$8aa36702e8c8978);

var $k3nAw = parcelRequire("k3nAw");
var $9QJSh = parcelRequire("9QJSh");

var $9OnyR = parcelRequire("9OnyR");

var $azdco = parcelRequire("azdco");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $8fe893ca5c83d79b$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $8fe893ca5c83d79b$export$e464f4a514ac28a8(name) {
    const cached = $8fe893ca5c83d79b$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $azdco.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $k3nAw.isNativeFunction)(impl)) return $8fe893ca5c83d79b$var$cachedImplementations[name] = impl.bind((0, $azdco.WINDOW));
    const document = (0, $azdco.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $9OnyR.DEBUG_BUILD) && (0, $9QJSh.logger).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $8fe893ca5c83d79b$var$cachedImplementations[name] = impl.bind((0, $azdco.WINDOW));
}
/** Clear a cached implementation. */ function $8fe893ca5c83d79b$export$8aa36702e8c8978(name) {
    $8fe893ca5c83d79b$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $8fe893ca5c83d79b$export$e7aa7bc5c1b3cfb3(...rest) {
    return $8fe893ca5c83d79b$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $8fe893ca5c83d79b$export$831dc9f2ab0a617b(...rest) {
    return $8fe893ca5c83d79b$export$e464f4a514ac28a8('setTimeout')(...rest);
}
 //# sourceMappingURL=getNativeImplementation.js.map

});
parcelRegister("k3nAw", function(module, exports) {
$parcel$export(module.exports, "isNativeFunction", () => $e99662915c82e8fd$export$d5f608b368e73f38);

var $c0SYH = parcelRequire("c0SYH");

var $9QJSh = parcelRequire("9QJSh");

var $bCKXd = parcelRequire("bCKXd");
const $e99662915c82e8fd$var$WINDOW = (0, $bCKXd.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $e99662915c82e8fd$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $e99662915c82e8fd$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $e99662915c82e8fd$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $e99662915c82e8fd$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $e99662915c82e8fd$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $e99662915c82e8fd$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $e99662915c82e8fd$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$e99662915c82e8fd$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($e99662915c82e8fd$export$d5f608b368e73f38($e99662915c82e8fd$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $e99662915c82e8fd$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $e99662915c82e8fd$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $c0SYH.DEBUG_BUILD) && (0, $9QJSh.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $e99662915c82e8fd$export$531055a6c684a70a() {
    return 'ReportingObserver' in $e99662915c82e8fd$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $e99662915c82e8fd$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$e99662915c82e8fd$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
 //# sourceMappingURL=supports.js.map

});

parcelRegister("9OnyR", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $724b0f5da8428b64$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $724b0f5da8428b64$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map

});


parcelRegister("7hMXL", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $54e019f328e1b0fa$export$d09f50d9ab7f7b69);

var $aVHpP = parcelRequire("aVHpP");

var $d0PHu = parcelRequire("d0PHu");

var $1yrnO = parcelRequire("1yrnO");

var $gb5jY = parcelRequire("gb5jY");

var $jLsjU = parcelRequire("jLsjU");

var $hLXXi = parcelRequire("hLXXi");

var $dGw9M = parcelRequire("dGw9M");
const $54e019f328e1b0fa$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $54e019f328e1b0fa$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $jLsjU.makePromiseBuffer)(options.bufferSize || $54e019f328e1b0fa$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $d0PHu.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $d0PHu.envelopeItemTypeToDataCategory)(type);
            if ((0, $hLXXi.isRateLimited)(rateLimits, dataCategory)) {
                const event = $54e019f328e1b0fa$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $dGw9M.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $d0PHu.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $d0PHu.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $54e019f328e1b0fa$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $d0PHu.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $d0PHu.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $hLXXi.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $1yrnO.SentryError)) {
                (0, $aVHpP.DEBUG_BUILD) && (0, $gb5jY.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $dGw9M.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $54e019f328e1b0fa$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}
 //# sourceMappingURL=base.js.map

});
parcelRegister("jLsjU", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $e6385fe3ad59a18d$export$85a4f67f852183e6);

var $1yrnO = parcelRequire("1yrnO");

var $dGw9M = parcelRequire("dGw9M");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $e6385fe3ad59a18d$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $dGw9M.rejectedSyncPromise)(new (0, $1yrnO.SentryError)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $dGw9M.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $dGw9M.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}
 //# sourceMappingURL=promisebuffer.js.map

});

parcelRegister("hLXXi", function(module, exports) {
$parcel$export(module.exports, "isRateLimited", () => $cf0555590f8f96d2$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $cf0555590f8f96d2$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $cf0555590f8f96d2$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $cf0555590f8f96d2$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $cf0555590f8f96d2$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $cf0555590f8f96d2$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $cf0555590f8f96d2$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $cf0555590f8f96d2$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $cf0555590f8f96d2$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $cf0555590f8f96d2$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
 //# sourceMappingURL=ratelimit.js.map

});





parcelRegister("7Yxfg", function(module, exports) {

var $9RrC7 = parcelRequire("9RrC7");
module.exports = Promise.all([
    $9RrC7("5AnuA"),
    $9RrC7("4UjLL"),
    $9RrC7("igAKU"),
    $9RrC7("6AsHK"),
    $9RrC7("fV56I"),
    $9RrC7("3uy0h"),
    $9RrC7("jNjsI"),
    $9RrC7("2Yxd4"),
    $9RrC7("k3h6N"),
    $9RrC7("eSsbR"),
    $9RrC7("dmICX"),
    $9RrC7("fQ6XC"),
    $9RrC7("4213d"),
    $9RrC7("1HeUP"),
    $9RrC7("2QpBD"),
    $9RrC7("9qbmy"),
    $9RrC7("5EVg4"),
    $9RrC7("hAXjY"),
    $9RrC7("2pg3m"),
    $9RrC7("3CM5k"),
    $9RrC7("gELit"),
    $9RrC7("ZfUwX"),
    $9RrC7("5Ily4"),
    $9RrC7("gnmCu"),
    $9RrC7("8BH0p")
]).then(()=>parcelRequire('e33R1'));

});

/* eslint-disable import/first */ // Since we have side effects, the order of these imports matter.
// These must come before other imports.
/* eslint-disable import/no-unassigned-import */ 
var $lMF6r = parcelRequire("lMF6r");

var $gpIDL = parcelRequire("gpIDL");

var $iaNM3 = parcelRequire("iaNM3");

var $6Zw1b = parcelRequire("6Zw1b");

var $eMGcJ = parcelRequire("eMGcJ");
const $44d3ba4d9ab03037$var$styleSheet = `
${(0, $iaNM3.default)}
${(0, $lMF6r.default)}
${(0, $6Zw1b.default)}
${(0, $gpIDL.default)}
${(0, $eMGcJ.default)}
`;
var $44d3ba4d9ab03037$export$2e2bcd8739ae039 = $44d3ba4d9ab03037$var$styleSheet;



/* eslint-disable import/no-unassigned-import */ // (we are relying on side-effects here, don't report them as errors)
// IE11
var $472a42319f266a90$exports = {};
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var $j1pco = parcelRequire("j1pco");

$j1pco($j1pco.P, 'Array', {
    fill: (parcelRequire("5HVL6"))
});

(parcelRequire("04hvK"))('fill');



$472a42319f266a90$exports = (parcelRequire("7y4ZL")).Array.fill;


var $dc6e3c47998d299b$exports = {};
'use strict';

var $j1pco = parcelRequire("j1pco");

var $ee74b00110999214$var$$find = (parcelRequire("13ySl"))(5);
var $ee74b00110999214$var$KEY = 'find';
var $ee74b00110999214$var$forced = true;
// Shouldn't skip holes
if ($ee74b00110999214$var$KEY in []) Array(1)[$ee74b00110999214$var$KEY](function() {
    $ee74b00110999214$var$forced = false;
});
$j1pco($j1pco.P + $j1pco.F * $ee74b00110999214$var$forced, 'Array', {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $ee74b00110999214$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("04hvK"))($ee74b00110999214$var$KEY);



$dc6e3c47998d299b$exports = (parcelRequire("7y4ZL")).Array.find;


var $591a9b675713cbca$exports = {};
'use strict';

var $j1pco = parcelRequire("j1pco");

var $516806c0b4877a72$var$$find = (parcelRequire("13ySl"))(6);
var $516806c0b4877a72$var$KEY = 'findIndex';
var $516806c0b4877a72$var$forced = true;
// Shouldn't skip holes
if ($516806c0b4877a72$var$KEY in []) Array(1)[$516806c0b4877a72$var$KEY](function() {
    $516806c0b4877a72$var$forced = false;
});
$j1pco($j1pco.P + $j1pco.F * $516806c0b4877a72$var$forced, 'Array', {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $516806c0b4877a72$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("04hvK"))($516806c0b4877a72$var$KEY);



$591a9b675713cbca$exports = (parcelRequire("7y4ZL")).Array.findIndex;


var $44f06dd27576bba9$exports = {};
'use strict';

var $ce83e34c9c4c7fa1$var$$at = (parcelRequire("hkQtO"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("41dFV"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $ce83e34c9c4c7fa1$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});


'use strict';

var $h2gZM = parcelRequire("h2gZM");

var $j1pco = parcelRequire("j1pco");

var $1Wq2M = parcelRequire("1Wq2M");

var $h5z5G = parcelRequire("h5z5G");

var $1zRzE = parcelRequire("1zRzE");

var $217we = parcelRequire("217we");
var $fd5cf3e4d78df8e1$exports = {};
'use strict';

var $6CKsg = parcelRequire("6CKsg");

var $8ZvAE = parcelRequire("8ZvAE");
$fd5cf3e4d78df8e1$exports = function(object, index, value) {
    if (index in object) $6CKsg.f(object, index, $8ZvAE(0, value));
    else object[index] = value;
};



var $hqd6k = parcelRequire("hqd6k");

$j1pco($j1pco.S + $j1pco.F * !(parcelRequire("8fqBw"))(function(iter) {
    Array.from(iter);
}), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
        var O = $1Wq2M(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = $hqd6k(O);
        var length, result, step, iterator;
        if (mapping) mapfn = $h2gZM(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && $1zRzE(iterFn))) for(iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++)$fd5cf3e4d78df8e1$exports(result, index, mapping ? $h5z5G(iterator, mapfn, [
            step.value,
            index
        ], true) : step.value);
        else {
            length = $217we(O.length);
            for(result = new C(length); length > index; index++)$fd5cf3e4d78df8e1$exports(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
        result.length = index;
        return result;
    }
});



$44f06dd27576bba9$exports = (parcelRequire("7y4ZL")).Array.from;


var $be254891ed5ddf5d$exports = {};
'use strict';

var $j1pco = parcelRequire("j1pco");

var $1e5f54fb1e70d2b6$var$$includes = (parcelRequire("fHwaf"))(true);
$j1pco($j1pco.P, 'Array', {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $1e5f54fb1e70d2b6$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("04hvK"))('includes');



$be254891ed5ddf5d$exports = (parcelRequire("7y4ZL")).Array.includes;


var $6f52627ed6563d6e$exports = {};
'use strict';

var $l6l01 = parcelRequire("l6l01");
var $823d40028f159cc1$var$test = {};

var $jZx91 = parcelRequire("jZx91");
$823d40028f159cc1$var$test[$jZx91('toStringTag')] = 'z';

if ($823d40028f159cc1$var$test + '' != '[object z]') (parcelRequire("if6L8"))(Object.prototype, 'toString', function toString() {
    return '[object ' + $l6l01(this) + ']';
}, true);



var $1fe74760b31bb1bc$exports = {};
'use strict';

var $04hvK = parcelRequire("04hvK");
var $e0053a3e7d1d44e6$exports = {};
$e0053a3e7d1d44e6$exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};



var $8grU2 = parcelRequire("8grU2");

var $3dpeK = parcelRequire("3dpeK");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
$1fe74760b31bb1bc$exports = (parcelRequire("41dFV"))(Array, 'Array', function(iterated, kind) {
    this._t = $3dpeK(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $e0053a3e7d1d44e6$exports(1);
    }
    if (kind == 'keys') return $e0053a3e7d1d44e6$exports(0, index);
    if (kind == 'values') return $e0053a3e7d1d44e6$exports(0, O[index]);
    return $e0053a3e7d1d44e6$exports(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$8grU2.Arguments = $8grU2.Array;
$04hvK('keys');
$04hvK('values');
$04hvK('entries');



var $2mdEd = parcelRequire("2mdEd");

var $if6L8 = parcelRequire("if6L8");

var $iR5RQ = parcelRequire("iR5RQ");

var $vr8t0 = parcelRequire("vr8t0");

var $8grU2 = parcelRequire("8grU2");

var $jZx91 = parcelRequire("jZx91");
var $c5b56dfff014cd49$var$ITERATOR = $jZx91('iterator');
var $c5b56dfff014cd49$var$TO_STRING_TAG = $jZx91('toStringTag');
var $c5b56dfff014cd49$var$ArrayValues = $8grU2.Array;
var $c5b56dfff014cd49$var$DOMIterables = {
    CSSRuleList: true,
    CSSStyleDeclaration: false,
    CSSValueList: false,
    ClientRectList: false,
    DOMRectList: false,
    DOMStringList: false,
    DOMTokenList: true,
    DataTransferItemList: false,
    FileList: false,
    HTMLAllCollection: false,
    HTMLCollection: false,
    HTMLFormElement: false,
    HTMLSelectElement: false,
    MediaList: true,
    MimeTypeArray: false,
    NamedNodeMap: false,
    NodeList: true,
    PaintRequestList: false,
    Plugin: false,
    PluginArray: false,
    SVGLengthList: false,
    SVGNumberList: false,
    SVGPathSegList: false,
    SVGPointList: false,
    SVGStringList: false,
    SVGTransformList: false,
    SourceBufferList: false,
    StyleSheetList: true,
    TextTrackCueList: false,
    TextTrackList: false,
    TouchList: false
};
for(var $c5b56dfff014cd49$var$collections = $2mdEd($c5b56dfff014cd49$var$DOMIterables), $c5b56dfff014cd49$var$i = 0; $c5b56dfff014cd49$var$i < $c5b56dfff014cd49$var$collections.length; $c5b56dfff014cd49$var$i++){
    var $c5b56dfff014cd49$var$NAME = $c5b56dfff014cd49$var$collections[$c5b56dfff014cd49$var$i];
    var $c5b56dfff014cd49$var$explicit = $c5b56dfff014cd49$var$DOMIterables[$c5b56dfff014cd49$var$NAME];
    var $c5b56dfff014cd49$var$Collection = $iR5RQ[$c5b56dfff014cd49$var$NAME];
    var $c5b56dfff014cd49$var$proto = $c5b56dfff014cd49$var$Collection && $c5b56dfff014cd49$var$Collection.prototype;
    var $c5b56dfff014cd49$var$key;
    if ($c5b56dfff014cd49$var$proto) {
        if (!$c5b56dfff014cd49$var$proto[$c5b56dfff014cd49$var$ITERATOR]) $vr8t0($c5b56dfff014cd49$var$proto, $c5b56dfff014cd49$var$ITERATOR, $c5b56dfff014cd49$var$ArrayValues);
        if (!$c5b56dfff014cd49$var$proto[$c5b56dfff014cd49$var$TO_STRING_TAG]) $vr8t0($c5b56dfff014cd49$var$proto, $c5b56dfff014cd49$var$TO_STRING_TAG, $c5b56dfff014cd49$var$NAME);
        $8grU2[$c5b56dfff014cd49$var$NAME] = $c5b56dfff014cd49$var$ArrayValues;
        if ($c5b56dfff014cd49$var$explicit) {
            for($c5b56dfff014cd49$var$key in $1fe74760b31bb1bc$exports)if (!$c5b56dfff014cd49$var$proto[$c5b56dfff014cd49$var$key]) $if6L8($c5b56dfff014cd49$var$proto, $c5b56dfff014cd49$var$key, $1fe74760b31bb1bc$exports[$c5b56dfff014cd49$var$key], true);
        }
    }
}


var $7e10f6530c1df971$exports = {};
'use strict';
var $1fee0e2fe742f0e9$exports = {};
'use strict';

var $6CKsg = parcelRequire("6CKsg");
var $1fee0e2fe742f0e9$require$dP = $6CKsg.f;

var $f48dC = parcelRequire("f48dC");

var $1PH8x = parcelRequire("1PH8x");

var $h2gZM = parcelRequire("h2gZM");

var $9rpke = parcelRequire("9rpke");

var $j61VM = parcelRequire("j61VM");

var $41dFV = parcelRequire("41dFV");

var $788b3cc34a69d93b$exports = {};
'use strict';

var $iR5RQ = parcelRequire("iR5RQ");

var $6CKsg = parcelRequire("6CKsg");

var $leD2I = parcelRequire("leD2I");

var $788b3cc34a69d93b$var$SPECIES = (parcelRequire("jZx91"))('species');
$788b3cc34a69d93b$exports = function(KEY) {
    var C = $iR5RQ[KEY];
    if ($leD2I && C && !C[$788b3cc34a69d93b$var$SPECIES]) $6CKsg.f(C, $788b3cc34a69d93b$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};



var $leD2I = parcelRequire("leD2I");

var $7Z8vr = parcelRequire("7Z8vr");
var $1fee0e2fe742f0e9$require$fastKey = $7Z8vr.fastKey;
var $00f79b6ab8f38a01$exports = {};

var $f87WO = parcelRequire("f87WO");
$00f79b6ab8f38a01$exports = function(it, TYPE) {
    if (!$f87WO(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
};


var $1fee0e2fe742f0e9$var$SIZE = $leD2I ? '_s' : 'size';
var $1fee0e2fe742f0e9$var$getEntry = function(that, key) {
    // fast case
    var index = $1fee0e2fe742f0e9$require$fastKey(key);
    var entry;
    if (index !== 'F') return that._i[index];
    // frozen object case
    for(entry = that._f; entry; entry = entry.n){
        if (entry.k == key) return entry;
    }
};
$1fee0e2fe742f0e9$exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $9rpke(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $f48dC(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[$1fee0e2fe742f0e9$var$SIZE] = 0; // size
            if (iterable != undefined) $j61VM(iterable, IS_MAP, that[ADDER], that);
        });
        $1PH8x(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
                for(var that = $00f79b6ab8f38a01$exports(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n){
                    entry.r = true;
                    if (entry.p) entry.p = entry.p.n = undefined;
                    delete data[entry.i];
                }
                that._f = that._l = undefined;
                that[$1fee0e2fe742f0e9$var$SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            'delete': function(key) {
                var that = $00f79b6ab8f38a01$exports(this, NAME);
                var entry = $1fee0e2fe742f0e9$var$getEntry(that, key);
                if (entry) {
                    var next = entry.n;
                    var prev = entry.p;
                    delete that._i[entry.i];
                    entry.r = true;
                    if (prev) prev.n = next;
                    if (next) next.p = prev;
                    if (that._f == entry) that._f = next;
                    if (that._l == entry) that._l = prev;
                    that[$1fee0e2fe742f0e9$var$SIZE]--;
                }
                return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                $00f79b6ab8f38a01$exports(this, NAME);
                var f = $h2gZM(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                var entry;
                while(entry = entry ? entry.n : this._f){
                    f(entry.v, entry.k, this);
                    // revert to the last existing entry
                    while(entry && entry.r)entry = entry.p;
                }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
                return !!$1fee0e2fe742f0e9$var$getEntry($00f79b6ab8f38a01$exports(this, NAME), key);
            }
        });
        if ($leD2I) $1fee0e2fe742f0e9$require$dP(C.prototype, 'size', {
            get: function() {
                return $00f79b6ab8f38a01$exports(this, NAME)[$1fee0e2fe742f0e9$var$SIZE];
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var entry = $1fee0e2fe742f0e9$var$getEntry(that, key);
        var prev, index;
        // change existing entry
        if (entry) entry.v = value;
        else {
            that._l = entry = {
                i: index = $1fee0e2fe742f0e9$require$fastKey(key, true),
                k: key,
                v: value,
                p: prev = that._l,
                n: undefined,
                r: false // <- removed
            };
            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[$1fee0e2fe742f0e9$var$SIZE]++;
            // add to index
            if (index !== 'F') that._i[index] = entry;
        }
        return that;
    },
    getEntry: $1fee0e2fe742f0e9$var$getEntry,
    setStrong: function(C, NAME, IS_MAP) {
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        $41dFV(C, NAME, function(iterated, kind) {
            this._t = $00f79b6ab8f38a01$exports(iterated, NAME); // target
            this._k = kind; // kind
            this._l = undefined; // previous
        }, function() {
            var that = this;
            var kind = that._k;
            var entry = that._l;
            // revert to the last existing entry
            while(entry && entry.r)entry = entry.p;
            // get next entry
            if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return $e0053a3e7d1d44e6$exports(1);
            }
            // return step by kind
            if (kind == 'keys') return $e0053a3e7d1d44e6$exports(0, entry.k);
            if (kind == 'values') return $e0053a3e7d1d44e6$exports(0, entry.v);
            return $e0053a3e7d1d44e6$exports(0, [
                entry.k,
                entry.v
            ]);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // add [@@species], 23.1.2.2, 23.2.2.2
        $788b3cc34a69d93b$exports(NAME);
    }
};



var $7e10f6530c1df971$var$MAP = 'Map';

// 23.1 Map Objects
$7e10f6530c1df971$exports = (parcelRequire("75rkt"))($7e10f6530c1df971$var$MAP, function(get) {
    return function Map() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key) {
        var entry = $1fee0e2fe742f0e9$exports.getEntry($00f79b6ab8f38a01$exports(this, $7e10f6530c1df971$var$MAP), key);
        return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value) {
        return $1fee0e2fe742f0e9$exports.def($00f79b6ab8f38a01$exports(this, $7e10f6530c1df971$var$MAP), key === 0 ? 0 : key, value);
    }
}, $1fee0e2fe742f0e9$exports, true);


// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $j1pco = parcelRequire("j1pco");

$j1pco($j1pco.P + $j1pco.R, 'Map', {
    toJSON: (parcelRequire("kVqBO"))('Map')
});


// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of

(parcelRequire("bUsrR"))('Map');


// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from

(parcelRequire("c79nm"))('Map');



$6f52627ed6563d6e$exports = (parcelRequire("7y4ZL")).Map;


var $a5099266995a2168$exports = {};
// 19.1.3.1 Object.assign(target, source)

var $j1pco = parcelRequire("j1pco");

$j1pco($j1pco.S + $j1pco.F, 'Object', {
    assign: (parcelRequire("9Uv0U"))
});



$a5099266995a2168$exports = (parcelRequire("7y4ZL")).Object.assign;


var $f32bf1a7423c5296$exports = {};
// https://github.com/tc39/proposal-object-values-entries

var $j1pco = parcelRequire("j1pco");

var $516d8af779df9fe8$var$$entries = (parcelRequire("hm18H"))(true);
$j1pco($j1pco.S, 'Object', {
    entries: function entries(it) {
        return $516d8af779df9fe8$var$$entries(it);
    }
});



$f32bf1a7423c5296$exports = (parcelRequire("7y4ZL")).Object.entries;


var $8b48ef879803717e$exports = {};
// https://github.com/tc39/proposal-object-values-entries

var $j1pco = parcelRequire("j1pco");

var $55684dc3cd4056cf$var$$values = (parcelRequire("hm18H"))(false);
$j1pco($j1pco.S, 'Object', {
    values: function values(it) {
        return $55684dc3cd4056cf$var$$values(it);
    }
});



$8b48ef879803717e$exports = (parcelRequire("7y4ZL")).Object.values;


var $7bb60165b03543c6$exports = {};
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';

var $j1pco = parcelRequire("j1pco");

var $217we = parcelRequire("217we");
var $62c8e7d2151d56a8$exports = {};
// helper for String#{startsWith, endsWith, includes}
var $c9bf3bede6501862$exports = {};
// 7.2.8 IsRegExp(argument)

var $f87WO = parcelRequire("f87WO");

var $3rACp = parcelRequire("3rACp");

var $c9bf3bede6501862$var$MATCH = (parcelRequire("jZx91"))('match');
$c9bf3bede6501862$exports = function(it) {
    var isRegExp;
    return $f87WO(it) && ((isRegExp = it[$c9bf3bede6501862$var$MATCH]) !== undefined ? !!isRegExp : $3rACp(it) == 'RegExp');
};



var $fSXfQ = parcelRequire("fSXfQ");
$62c8e7d2151d56a8$exports = function(that, searchString, NAME) {
    if ($c9bf3bede6501862$exports(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
    return String($fSXfQ(that));
};


var $45b88eccc070a617$var$STARTS_WITH = 'startsWith';
var $45b88eccc070a617$var$$startsWith = ''[$45b88eccc070a617$var$STARTS_WITH];

$j1pco($j1pco.P + $j1pco.F * (parcelRequire("2GCTx"))($45b88eccc070a617$var$STARTS_WITH), 'String', {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $62c8e7d2151d56a8$exports(this, searchString, $45b88eccc070a617$var$STARTS_WITH);
        var index = $217we(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = String(searchString);
        return $45b88eccc070a617$var$$startsWith ? $45b88eccc070a617$var$$startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
    }
});



$7bb60165b03543c6$exports = (parcelRequire("7y4ZL")).String.startsWith;


/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */ (function() {
    'use strict';
    // Exit early if we're not running in a browser.
    if (typeof window !== 'object') return;
    // Exit early if all IntersectionObserver and IntersectionObserverEntry
    // features are natively supported.
    if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
        // Minimal polyfill for Edge 15's lack of `isIntersecting`
        // See: https://github.com/w3c/IntersectionObserver/issues/211
        if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
            get: function() {
                return this.intersectionRatio > 0;
            }
        });
        return;
    }
    /**
 * A local reference to the document.
 */ var document = window.document;
    /**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */ var registry = [];
    /**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */ function IntersectionObserverEntry(entry) {
        this.time = entry.time;
        this.target = entry.target;
        this.rootBounds = entry.rootBounds;
        this.boundingClientRect = entry.boundingClientRect;
        this.intersectionRect = entry.intersectionRect || getEmptyRect();
        this.isIntersecting = !!entry.intersectionRect;
        // Calculates the intersection ratio.
        var targetRect = this.boundingClientRect;
        var targetArea = targetRect.width * targetRect.height;
        var intersectionRect = this.intersectionRect;
        var intersectionArea = intersectionRect.width * intersectionRect.height;
        // Sets intersection ratio.
        if (targetArea) // Round the intersection ratio to avoid floating point math issues:
        // https://github.com/w3c/IntersectionObserver/issues/324
        this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
        else // If area is zero and is intersecting, sets to 1, otherwise to 0
        this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
    /**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */ function IntersectionObserver(callback, opt_options) {
        var options = opt_options || {};
        if (typeof callback != 'function') throw new Error('callback must be a function');
        if (options.root && options.root.nodeType != 1) throw new Error('root must be an Element');
        // Binds and throttles `this._checkForIntersections`.
        this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
        // Private properties.
        this._callback = callback;
        this._observationTargets = [];
        this._queuedEntries = [];
        this._rootMarginValues = this._parseRootMargin(options.rootMargin);
        // Public properties.
        this.thresholds = this._initThresholds(options.threshold);
        this.root = options.root || null;
        this.rootMargin = this._rootMarginValues.map(function(margin) {
            return margin.value + margin.unit;
        }).join(' ');
    }
    /**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */ IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
    /**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */ IntersectionObserver.prototype.POLL_INTERVAL = null;
    /**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */ IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
    /**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */ IntersectionObserver.prototype.observe = function(target) {
        var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
            return item.element == target;
        });
        if (isTargetAlreadyObserved) return;
        if (!(target && target.nodeType == 1)) throw new Error('target must be an Element');
        this._registerInstance();
        this._observationTargets.push({
            element: target,
            entry: null
        });
        this._monitorIntersections();
        this._checkForIntersections();
    };
    /**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */ IntersectionObserver.prototype.unobserve = function(target) {
        this._observationTargets = this._observationTargets.filter(function(item) {
            return item.element != target;
        });
        if (!this._observationTargets.length) {
            this._unmonitorIntersections();
            this._unregisterInstance();
        }
    };
    /**
 * Stops observing all target elements for intersection changes.
 */ IntersectionObserver.prototype.disconnect = function() {
        this._observationTargets = [];
        this._unmonitorIntersections();
        this._unregisterInstance();
    };
    /**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */ IntersectionObserver.prototype.takeRecords = function() {
        var records = this._queuedEntries.slice();
        this._queuedEntries = [];
        return records;
    };
    /**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */ IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
        var threshold = opt_threshold || [
            0
        ];
        if (!Array.isArray(threshold)) threshold = [
            threshold
        ];
        return threshold.sort().filter(function(t, i, a) {
            if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) throw new Error('threshold must be a number between 0 and 1 inclusively');
            return t !== a[i - 1];
        });
    };
    /**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */ IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
        var marginString = opt_rootMargin || '0px';
        var margins = marginString.split(/\s+/).map(function(margin) {
            var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
            if (!parts) throw new Error('rootMargin must be specified in pixels or percent');
            return {
                value: parseFloat(parts[1]),
                unit: parts[2]
            };
        });
        // Handles shorthand.
        margins[1] = margins[1] || margins[0];
        margins[2] = margins[2] || margins[0];
        margins[3] = margins[3] || margins[1];
        return margins;
    };
    /**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */ IntersectionObserver.prototype._monitorIntersections = function() {
        if (!this._monitoringIntersections) {
            this._monitoringIntersections = true;
            // If a poll interval is set, use polling instead of listening to
            // resize and scroll events or DOM mutations.
            if (this.POLL_INTERVAL) this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL);
            else {
                addEvent(window, 'resize', this._checkForIntersections, true);
                addEvent(document, 'scroll', this._checkForIntersections, true);
                if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
                    this._domObserver = new MutationObserver(this._checkForIntersections);
                    this._domObserver.observe(document, {
                        attributes: true,
                        childList: true,
                        characterData: true,
                        subtree: true
                    });
                }
            }
        }
    };
    /**
 * Stops polling for intersection changes.
 * @private
 */ IntersectionObserver.prototype._unmonitorIntersections = function() {
        if (this._monitoringIntersections) {
            this._monitoringIntersections = false;
            clearInterval(this._monitoringInterval);
            this._monitoringInterval = null;
            removeEvent(window, 'resize', this._checkForIntersections, true);
            removeEvent(document, 'scroll', this._checkForIntersections, true);
            if (this._domObserver) {
                this._domObserver.disconnect();
                this._domObserver = null;
            }
        }
    };
    /**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */ IntersectionObserver.prototype._checkForIntersections = function() {
        var rootIsInDom = this._rootIsInDom();
        var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
        this._observationTargets.forEach(function(item) {
            var target = item.element;
            var targetRect = getBoundingClientRect(target);
            var rootContainsTarget = this._rootContainsTarget(target);
            var oldEntry = item.entry;
            var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, rootRect);
            var newEntry = item.entry = new IntersectionObserverEntry({
                time: now(),
                target: target,
                boundingClientRect: targetRect,
                rootBounds: rootRect,
                intersectionRect: intersectionRect
            });
            if (!oldEntry) this._queuedEntries.push(newEntry);
            else if (rootIsInDom && rootContainsTarget) // If the new entry intersection ratio has crossed any of the
            // thresholds, add a new entry.
            {
                if (this._hasCrossedThreshold(oldEntry, newEntry)) this._queuedEntries.push(newEntry);
            } else // If the root is not in the DOM or target is not contained within
            // root but the previous entry for this target had an intersection,
            // add a new record indicating removal.
            if (oldEntry && oldEntry.isIntersecting) this._queuedEntries.push(newEntry);
        }, this);
        if (this._queuedEntries.length) this._callback(this.takeRecords(), this);
    };
    /**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */ IntersectionObserver.prototype._computeTargetAndRootIntersection = function(target, rootRect) {
        // If the element isn't displayed, an intersection can't happen.
        if (window.getComputedStyle(target).display == 'none') return;
        var targetRect = getBoundingClientRect(target);
        var intersectionRect = targetRect;
        var parent = getParentNode(target);
        var atRoot = false;
        while(!atRoot){
            var parentRect = null;
            var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};
            // If the parent isn't displayed, an intersection can't happen.
            if (parentComputedStyle.display == 'none') return;
            if (parent == this.root || parent == document) {
                atRoot = true;
                parentRect = rootRect;
            } else // If the element has a non-visible overflow, and it's not the <body>
            // or <html> element, update the intersection rect.
            // Note: <body> and <html> cannot be clipped to a rect that's not also
            // the document rect, so no need to compute a new intersection.
            if (parent != document.body && parent != document.documentElement && parentComputedStyle.overflow != 'visible') parentRect = getBoundingClientRect(parent);
            // If either of the above conditionals set a new parentRect,
            // calculate new intersection data.
            if (parentRect) {
                intersectionRect = computeRectIntersection(parentRect, intersectionRect);
                if (!intersectionRect) break;
            }
            parent = getParentNode(parent);
        }
        return intersectionRect;
    };
    /**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */ IntersectionObserver.prototype._getRootRect = function() {
        var rootRect;
        if (this.root) rootRect = getBoundingClientRect(this.root);
        else {
            // Use <html>/<body> instead of window since scroll bars affect size.
            var html = document.documentElement;
            var body = document.body;
            rootRect = {
                top: 0,
                left: 0,
                right: html.clientWidth || body.clientWidth,
                width: html.clientWidth || body.clientWidth,
                bottom: html.clientHeight || body.clientHeight,
                height: html.clientHeight || body.clientHeight
            };
        }
        return this._expandRectByRootMargin(rootRect);
    };
    /**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */ IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
        var margins = this._rootMarginValues.map(function(margin, i) {
            return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
        });
        var newRect = {
            top: rect.top - margins[0],
            right: rect.right + margins[1],
            bottom: rect.bottom + margins[2],
            left: rect.left - margins[3]
        };
        newRect.width = newRect.right - newRect.left;
        newRect.height = newRect.bottom - newRect.top;
        return newRect;
    };
    /**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */ IntersectionObserver.prototype._hasCrossedThreshold = function(oldEntry, newEntry) {
        // To make comparing easier, an entry that has a ratio of 0
        // but does not actually intersect is given a value of -1
        var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
        var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;
        // Ignore unchanged ratios
        if (oldRatio === newRatio) return;
        for(var i = 0; i < this.thresholds.length; i++){
            var threshold = this.thresholds[i];
            // Return true if an entry matches a threshold or if the new ratio
            // and the old ratio are on the opposite sides of a threshold.
            if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) return true;
        }
    };
    /**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */ IntersectionObserver.prototype._rootIsInDom = function() {
        return !this.root || containsDeep(document, this.root);
    };
    /**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */ IntersectionObserver.prototype._rootContainsTarget = function(target) {
        return containsDeep(this.root || document, target);
    };
    /**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */ IntersectionObserver.prototype._registerInstance = function() {
        if (registry.indexOf(this) < 0) registry.push(this);
    };
    /**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */ IntersectionObserver.prototype._unregisterInstance = function() {
        var index = registry.indexOf(this);
        if (index != -1) registry.splice(index, 1);
    };
    /**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */ function now() {
        return window.performance && performance.now && performance.now();
    }
    /**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */ function throttle(fn, timeout) {
        var timer = null;
        return function() {
            if (!timer) timer = setTimeout(function() {
                fn();
                timer = null;
            }, timeout);
        };
    }
    /**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */ function addEvent(node, event, fn, opt_useCapture) {
        if (typeof node.addEventListener == 'function') node.addEventListener(event, fn, opt_useCapture || false);
        else if (typeof node.attachEvent == 'function') node.attachEvent('on' + event, fn);
    }
    /**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */ function removeEvent(node, event, fn, opt_useCapture) {
        if (typeof node.removeEventListener == 'function') node.removeEventListener(event, fn, opt_useCapture || false);
        else if (typeof node.detatchEvent == 'function') node.detatchEvent('on' + event, fn);
    }
    /**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */ function computeRectIntersection(rect1, rect2) {
        var top = Math.max(rect1.top, rect2.top);
        var bottom = Math.min(rect1.bottom, rect2.bottom);
        var left = Math.max(rect1.left, rect2.left);
        var right = Math.min(rect1.right, rect2.right);
        var width = right - left;
        var height = bottom - top;
        return width >= 0 && height >= 0 && {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: width,
            height: height
        };
    }
    /**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */ function getBoundingClientRect(el) {
        var rect;
        try {
            rect = el.getBoundingClientRect();
        } catch (err) {
        // Ignore Windows 7 IE11 "Unspecified error"
        // https://github.com/w3c/IntersectionObserver/pull/205
        }
        if (!rect) return getEmptyRect();
        // Older IE
        if (!(rect.width && rect.height)) rect = {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top
        };
        return rect;
    }
    /**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */ function getEmptyRect() {
        return {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 0,
            height: 0
        };
    }
    /**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */ function containsDeep(parent, child) {
        var node = child;
        while(node){
            if (node == parent) return true;
            node = getParentNode(node);
        }
        return false;
    }
    /**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */ function getParentNode(node) {
        var parent = node.parentNode;
        if (parent && parent.nodeType == 11 && parent.host) // If the parent is a shadow root, return the host element.
        return parent.host;
        if (parent && parent.assignedSlot) // If the parent is distributed in a <slot>, return the parent of a slot.
        return parent.assignedSlot.parentNode;
        return parent;
    }
    // Exposes the constructors globally.
    window.IntersectionObserver = IntersectionObserver;
    window.IntersectionObserverEntry = IntersectionObserverEntry;
})();


"use strict";
var $69fac9427df2972b$exports = {};
'use strict';

var $cUEwJ = parcelRequire("cUEwJ");

var $i9PqC = parcelRequire("i9PqC");

var $gvp2l = parcelRequire("gvp2l");

var $7UCsS = parcelRequire("7UCsS");

var $2niSg = parcelRequire("2niSg");

var $7p9t8 = parcelRequire("7p9t8");
var $10ed74afef446048$require$META = $7p9t8.KEY;

var $d6gmi = parcelRequire("d6gmi");

var $7Ebfd = parcelRequire("7Ebfd");

var $5MNda = parcelRequire("5MNda");

var $7bg9a = parcelRequire("7bg9a");

var $5zj8I = parcelRequire("5zj8I");

var $cDLhd = parcelRequire("cDLhd");

var $29gH0 = parcelRequire("29gH0");
var $fb53628521bc4406$exports = {};
// all enumerable object keys, includes symbols

var $abZqb = parcelRequire("abZqb");

var $62w6m = parcelRequire("62w6m");

var $4OvuN = parcelRequire("4OvuN");
$fb53628521bc4406$exports = function(it) {
    var result = $abZqb(it);
    var getSymbols = $62w6m.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $4OvuN.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};



var $8D3Ey = parcelRequire("8D3Ey");

var $9bg2N = parcelRequire("9bg2N");

var $5ehF7 = parcelRequire("5ehF7");

var $87N8x = parcelRequire("87N8x");

var $e6Osc = parcelRequire("e6Osc");

var $hFD9L = parcelRequire("hFD9L");

var $jPGz2 = parcelRequire("jPGz2");

var $9hnGd = parcelRequire("9hnGd");

var $9fHtC = parcelRequire("9fHtC");

var $clqre = parcelRequire("clqre");

var $62w6m = parcelRequire("62w6m");

var $1w421 = parcelRequire("1w421");

var $abZqb = parcelRequire("abZqb");
var $10ed74afef446048$var$gOPD = $clqre.f;
var $10ed74afef446048$var$dP = $1w421.f;
var $10ed74afef446048$var$gOPN = $9fHtC.f;
var $10ed74afef446048$var$$Symbol = $cUEwJ.Symbol;
var $10ed74afef446048$var$$JSON = $cUEwJ.JSON;
var $10ed74afef446048$var$_stringify = $10ed74afef446048$var$$JSON && $10ed74afef446048$var$$JSON.stringify;
var $10ed74afef446048$var$PROTOTYPE = 'prototype';
var $10ed74afef446048$var$HIDDEN = $5zj8I('_hidden');
var $10ed74afef446048$var$TO_PRIMITIVE = $5zj8I('toPrimitive');
var $10ed74afef446048$var$isEnum = {}.propertyIsEnumerable;
var $10ed74afef446048$var$SymbolRegistry = $7Ebfd('symbol-registry');
var $10ed74afef446048$var$AllSymbols = $7Ebfd('symbols');
var $10ed74afef446048$var$OPSymbols = $7Ebfd('op-symbols');
var $10ed74afef446048$var$ObjectProto = Object[$10ed74afef446048$var$PROTOTYPE];
var $10ed74afef446048$var$USE_NATIVE = typeof $10ed74afef446048$var$$Symbol == 'function' && !!$62w6m.f;
var $10ed74afef446048$var$QObject = $cUEwJ.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $10ed74afef446048$var$setter = !$10ed74afef446048$var$QObject || !$10ed74afef446048$var$QObject[$10ed74afef446048$var$PROTOTYPE] || !$10ed74afef446048$var$QObject[$10ed74afef446048$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $10ed74afef446048$var$setSymbolDesc = $gvp2l && $d6gmi(function() {
    return $9hnGd($10ed74afef446048$var$dP({}, 'a', {
        get: function() {
            return $10ed74afef446048$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $10ed74afef446048$var$gOPD($10ed74afef446048$var$ObjectProto, key);
    if (protoDesc) delete $10ed74afef446048$var$ObjectProto[key];
    $10ed74afef446048$var$dP(it, key, D);
    if (protoDesc && it !== $10ed74afef446048$var$ObjectProto) $10ed74afef446048$var$dP($10ed74afef446048$var$ObjectProto, key, protoDesc);
} : $10ed74afef446048$var$dP;
var $10ed74afef446048$var$wrap = function(tag) {
    var sym = $10ed74afef446048$var$AllSymbols[tag] = $9hnGd($10ed74afef446048$var$$Symbol[$10ed74afef446048$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $10ed74afef446048$var$isSymbol = $10ed74afef446048$var$USE_NATIVE && typeof $10ed74afef446048$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $10ed74afef446048$var$$Symbol;
};
var $10ed74afef446048$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $10ed74afef446048$var$ObjectProto) $10ed74afef446048$var$$defineProperty($10ed74afef446048$var$OPSymbols, key, D);
    $9bg2N(it);
    key = $hFD9L(key, true);
    $9bg2N(D);
    if ($i9PqC($10ed74afef446048$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$i9PqC(it, $10ed74afef446048$var$HIDDEN)) $10ed74afef446048$var$dP(it, $10ed74afef446048$var$HIDDEN, $jPGz2(1, {}));
            it[$10ed74afef446048$var$HIDDEN][key] = true;
        } else {
            if ($i9PqC(it, $10ed74afef446048$var$HIDDEN) && it[$10ed74afef446048$var$HIDDEN][key]) it[$10ed74afef446048$var$HIDDEN][key] = false;
            D = $9hnGd(D, {
                enumerable: $jPGz2(0, false)
            });
        }
        return $10ed74afef446048$var$setSymbolDesc(it, key, D);
    }
    return $10ed74afef446048$var$dP(it, key, D);
};
var $10ed74afef446048$var$$defineProperties = function defineProperties(it, P) {
    $9bg2N(it);
    var keys = $fb53628521bc4406$exports(P = $e6Osc(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$10ed74afef446048$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $10ed74afef446048$var$$create = function create(it, P) {
    return P === undefined ? $9hnGd(it) : $10ed74afef446048$var$$defineProperties($9hnGd(it), P);
};
var $10ed74afef446048$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $10ed74afef446048$var$isEnum.call(this, key = $hFD9L(key, true));
    if (this === $10ed74afef446048$var$ObjectProto && $i9PqC($10ed74afef446048$var$AllSymbols, key) && !$i9PqC($10ed74afef446048$var$OPSymbols, key)) return false;
    return E || !$i9PqC(this, key) || !$i9PqC($10ed74afef446048$var$AllSymbols, key) || $i9PqC(this, $10ed74afef446048$var$HIDDEN) && this[$10ed74afef446048$var$HIDDEN][key] ? E : true;
};
var $10ed74afef446048$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $e6Osc(it);
    key = $hFD9L(key, true);
    if (it === $10ed74afef446048$var$ObjectProto && $i9PqC($10ed74afef446048$var$AllSymbols, key) && !$i9PqC($10ed74afef446048$var$OPSymbols, key)) return;
    var D = $10ed74afef446048$var$gOPD(it, key);
    if (D && $i9PqC($10ed74afef446048$var$AllSymbols, key) && !($i9PqC(it, $10ed74afef446048$var$HIDDEN) && it[$10ed74afef446048$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $10ed74afef446048$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $10ed74afef446048$var$gOPN($e6Osc(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$i9PqC($10ed74afef446048$var$AllSymbols, key = names[i++]) && key != $10ed74afef446048$var$HIDDEN && key != $10ed74afef446048$require$META) result.push(key);
    return result;
};
var $10ed74afef446048$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $10ed74afef446048$var$ObjectProto;
    var names = $10ed74afef446048$var$gOPN(IS_OP ? $10ed74afef446048$var$OPSymbols : $e6Osc(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($i9PqC($10ed74afef446048$var$AllSymbols, key = names[i++]) && (IS_OP ? $i9PqC($10ed74afef446048$var$ObjectProto, key) : true)) result.push($10ed74afef446048$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$10ed74afef446048$var$USE_NATIVE) {
    $10ed74afef446048$var$$Symbol = function Symbol() {
        if (this instanceof $10ed74afef446048$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $7bg9a(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $10ed74afef446048$var$ObjectProto) $set.call($10ed74afef446048$var$OPSymbols, value);
            if ($i9PqC(this, $10ed74afef446048$var$HIDDEN) && $i9PqC(this[$10ed74afef446048$var$HIDDEN], tag)) this[$10ed74afef446048$var$HIDDEN][tag] = false;
            $10ed74afef446048$var$setSymbolDesc(this, tag, $jPGz2(1, value));
        };
        if ($gvp2l && $10ed74afef446048$var$setter) $10ed74afef446048$var$setSymbolDesc($10ed74afef446048$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $10ed74afef446048$var$wrap(tag);
    };
    $2niSg($10ed74afef446048$var$$Symbol[$10ed74afef446048$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $clqre.f = $10ed74afef446048$var$$getOwnPropertyDescriptor;
    $1w421.f = $10ed74afef446048$var$$defineProperty;
    (parcelRequire("dQVrJ")).f = $9fHtC.f = $10ed74afef446048$var$$getOwnPropertyNames;
    (parcelRequire("4OvuN")).f = $10ed74afef446048$var$$propertyIsEnumerable;
    $62w6m.f = $10ed74afef446048$var$$getOwnPropertySymbols;
    if ($gvp2l && !(parcelRequire("6VDEP"))) $2niSg($10ed74afef446048$var$ObjectProto, 'propertyIsEnumerable', $10ed74afef446048$var$$propertyIsEnumerable, true);
    $cDLhd.f = function(name) {
        return $10ed74afef446048$var$wrap($5zj8I(name));
    };
}
$7UCsS($7UCsS.G + $7UCsS.W + $7UCsS.F * !$10ed74afef446048$var$USE_NATIVE, {
    Symbol: $10ed74afef446048$var$$Symbol
});
for(var $10ed74afef446048$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $10ed74afef446048$var$j = 0; $10ed74afef446048$var$es6Symbols.length > $10ed74afef446048$var$j;)$5zj8I($10ed74afef446048$var$es6Symbols[$10ed74afef446048$var$j++]);
for(var $10ed74afef446048$var$wellKnownSymbols = $abZqb($5zj8I.store), $10ed74afef446048$var$k = 0; $10ed74afef446048$var$wellKnownSymbols.length > $10ed74afef446048$var$k;)$29gH0($10ed74afef446048$var$wellKnownSymbols[$10ed74afef446048$var$k++]);
$7UCsS($7UCsS.S + $7UCsS.F * !$10ed74afef446048$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $i9PqC($10ed74afef446048$var$SymbolRegistry, key += '') ? $10ed74afef446048$var$SymbolRegistry[key] : $10ed74afef446048$var$SymbolRegistry[key] = $10ed74afef446048$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$10ed74afef446048$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $10ed74afef446048$var$SymbolRegistry)if ($10ed74afef446048$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $10ed74afef446048$var$setter = true;
    },
    useSimple: function() {
        $10ed74afef446048$var$setter = false;
    }
});
$7UCsS($7UCsS.S + $7UCsS.F * !$10ed74afef446048$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $10ed74afef446048$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $10ed74afef446048$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $10ed74afef446048$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $10ed74afef446048$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $10ed74afef446048$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $10ed74afef446048$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $10ed74afef446048$var$FAILS_ON_PRIMITIVES = $d6gmi(function() {
    $62w6m.f(1);
});
$7UCsS($7UCsS.S + $7UCsS.F * $10ed74afef446048$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $62w6m.f($87N8x(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$10ed74afef446048$var$$JSON && $7UCsS($7UCsS.S + $7UCsS.F * (!$10ed74afef446048$var$USE_NATIVE || $d6gmi(function() {
    var S = $10ed74afef446048$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $10ed74afef446048$var$_stringify([
        S
    ]) != '[null]' || $10ed74afef446048$var$_stringify({
        a: S
    }) != '{}' || $10ed74afef446048$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$5ehF7(replacer) && it === undefined || $10ed74afef446048$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$8D3Ey(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$10ed74afef446048$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $10ed74afef446048$var$_stringify.apply($10ed74afef446048$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$10ed74afef446048$var$$Symbol[$10ed74afef446048$var$PROTOTYPE][$10ed74afef446048$var$TO_PRIMITIVE] || (parcelRequire("6G6JS"))($10ed74afef446048$var$$Symbol[$10ed74afef446048$var$PROTOTYPE], $10ed74afef446048$var$TO_PRIMITIVE, $10ed74afef446048$var$$Symbol[$10ed74afef446048$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$5MNda($10ed74afef446048$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$5MNda(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$5MNda($cUEwJ.JSON, 'JSON', true);



var $7UCsS = parcelRequire("7UCsS");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$7UCsS($7UCsS.S, 'Object', {
    create: (parcelRequire("9hnGd"))
});



var $7UCsS = parcelRequire("7UCsS");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$7UCsS($7UCsS.S + $7UCsS.F * !(parcelRequire("gvp2l")), 'Object', {
    defineProperty: (parcelRequire("1w421")).f
});



var $7UCsS = parcelRequire("7UCsS");


// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$7UCsS($7UCsS.S + $7UCsS.F * !(parcelRequire("gvp2l")), 'Object', {
    defineProperties: (parcelRequire("44tfH"))
});


// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $e6Osc = parcelRequire("e6Osc");

var $clqre = parcelRequire("clqre");
var $beda240de7d78552$require$$getOwnPropertyDescriptor = $clqre.f;

(parcelRequire("7Q2IA"))('getOwnPropertyDescriptor', function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $beda240de7d78552$require$$getOwnPropertyDescriptor($e6Osc(it), key);
    };
});


// 19.1.2.9 Object.getPrototypeOf(O)

var $87N8x = parcelRequire("87N8x");

var $hQ3EZ = parcelRequire("hQ3EZ");

(parcelRequire("7Q2IA"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $hQ3EZ($87N8x(it));
    };
});


// 19.1.2.14 Object.keys(O)

var $87N8x = parcelRequire("87N8x");

var $abZqb = parcelRequire("abZqb");

(parcelRequire("7Q2IA"))('keys', function() {
    return function keys(it) {
        return $abZqb($87N8x(it));
    };
});


// 19.1.2.7 Object.getOwnPropertyNames(O)


(parcelRequire("7Q2IA"))('getOwnPropertyNames', function() {
    return (parcelRequire("9fHtC")).f;
});


// 19.1.2.5 Object.freeze(O)

var $5ehF7 = parcelRequire("5ehF7");

var $7p9t8 = parcelRequire("7p9t8");
var $166ffc92d0a37566$require$meta = $7p9t8.onFreeze;

(parcelRequire("7Q2IA"))('freeze', function($freeze) {
    return function freeze(it) {
        return $freeze && $5ehF7(it) ? $freeze($166ffc92d0a37566$require$meta(it)) : it;
    };
});


// 19.1.2.17 Object.seal(O)

var $5ehF7 = parcelRequire("5ehF7");

var $7p9t8 = parcelRequire("7p9t8");
var $e460c54462cb1202$require$meta = $7p9t8.onFreeze;

(parcelRequire("7Q2IA"))('seal', function($seal) {
    return function seal(it) {
        return $seal && $5ehF7(it) ? $seal($e460c54462cb1202$require$meta(it)) : it;
    };
});


// 19.1.2.15 Object.preventExtensions(O)

var $5ehF7 = parcelRequire("5ehF7");

var $7p9t8 = parcelRequire("7p9t8");
var $b3380faf26ad2116$require$meta = $7p9t8.onFreeze;

(parcelRequire("7Q2IA"))('preventExtensions', function($preventExtensions) {
    return function preventExtensions(it) {
        return $preventExtensions && $5ehF7(it) ? $preventExtensions($b3380faf26ad2116$require$meta(it)) : it;
    };
});


// 19.1.2.12 Object.isFrozen(O)

var $5ehF7 = parcelRequire("5ehF7");

(parcelRequire("7Q2IA"))('isFrozen', function($isFrozen) {
    return function isFrozen(it) {
        return $5ehF7(it) ? $isFrozen ? $isFrozen(it) : false : true;
    };
});


// 19.1.2.13 Object.isSealed(O)

var $5ehF7 = parcelRequire("5ehF7");

(parcelRequire("7Q2IA"))('isSealed', function($isSealed) {
    return function isSealed(it) {
        return $5ehF7(it) ? $isSealed ? $isSealed(it) : false : true;
    };
});


// 19.1.2.11 Object.isExtensible(O)

var $5ehF7 = parcelRequire("5ehF7");

(parcelRequire("7Q2IA"))('isExtensible', function($isExtensible) {
    return function isExtensible(it) {
        return $5ehF7(it) ? $isExtensible ? $isExtensible(it) : true : false;
    };
});


// 19.1.3.1 Object.assign(target, source)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S + $7UCsS.F, 'Object', {
    assign: (parcelRequire("kr8PN"))
});


// 19.1.3.10 Object.is(value1, value2)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S, 'Object', {
    is: (parcelRequire("etufX"))
});


// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S, 'Object', {
    setPrototypeOf: (parcelRequire("gALmc")).set
});


'use strict';

var $d4Dmo = parcelRequire("d4Dmo");
var $6ce49b7f5847a088$var$test = {};

var $5zj8I = parcelRequire("5zj8I");
$6ce49b7f5847a088$var$test[$5zj8I('toStringTag')] = 'z';

if ($6ce49b7f5847a088$var$test + '' != '[object z]') (parcelRequire("2niSg"))(Object.prototype, 'toString', function toString() {
    return '[object ' + $d4Dmo(this) + ']';
}, true);


// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.P, 'Function', {
    bind: (parcelRequire("1iNAj"))
});



var $1w421 = parcelRequire("1w421");
var $9db133a90799baa7$require$dP = $1w421.f;
var $9db133a90799baa7$var$FProto = Function.prototype;
var $9db133a90799baa7$var$nameRE = /^\s*function ([^ (]*)/;
var $9db133a90799baa7$var$NAME = 'name';

// 19.2.4.2 name
$9db133a90799baa7$var$NAME in $9db133a90799baa7$var$FProto || (parcelRequire("gvp2l")) && $9db133a90799baa7$require$dP($9db133a90799baa7$var$FProto, $9db133a90799baa7$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return ('' + this).match($9db133a90799baa7$var$nameRE)[1];
        } catch (e) {
            return '';
        }
    }
});


'use strict';

var $5ehF7 = parcelRequire("5ehF7");

var $hQ3EZ = parcelRequire("hQ3EZ");

var $9347a48e5f128851$var$HAS_INSTANCE = (parcelRequire("5zj8I"))('hasInstance');
var $9347a48e5f128851$var$FunctionProto = Function.prototype;

// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!($9347a48e5f128851$var$HAS_INSTANCE in $9347a48e5f128851$var$FunctionProto)) (parcelRequire("1w421")).f($9347a48e5f128851$var$FunctionProto, $9347a48e5f128851$var$HAS_INSTANCE, {
    value: function(O) {
        if (typeof this != 'function' || !$5ehF7(O)) return false;
        if (!$5ehF7(this.prototype)) return O instanceof this;
        // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
        while(O = $hQ3EZ(O))if (this.prototype === O) return true;
        return false;
    }
});



var $7UCsS = parcelRequire("7UCsS");
var $6e56a838ffa16dfc$exports = {};

var $cUEwJ = parcelRequire("cUEwJ");
var $6e56a838ffa16dfc$require$$parseInt = $cUEwJ.parseInt;

var $3JQ2K = parcelRequire("3JQ2K");
var $6e56a838ffa16dfc$require$$trim = $3JQ2K.trim;

var $UqiYA = parcelRequire("UqiYA");
var $6e56a838ffa16dfc$var$hex = /^[-+]?0[xX]/;
$6e56a838ffa16dfc$exports = $6e56a838ffa16dfc$require$$parseInt($UqiYA + '08') !== 8 || $6e56a838ffa16dfc$require$$parseInt($UqiYA + '0x16') !== 22 ? function parseInt(str, radix) {
    var string = $6e56a838ffa16dfc$require$$trim(String(str), 3);
    return $6e56a838ffa16dfc$require$$parseInt(string, radix >>> 0 || ($6e56a838ffa16dfc$var$hex.test(string) ? 16 : 10));
} : $6e56a838ffa16dfc$require$$parseInt;


// 18.2.5 parseInt(string, radix)
$7UCsS($7UCsS.G + $7UCsS.F * (parseInt != $6e56a838ffa16dfc$exports), {
    parseInt: $6e56a838ffa16dfc$exports
});



var $7UCsS = parcelRequire("7UCsS");
var $1202c6eeef8de166$exports = {};

var $cUEwJ = parcelRequire("cUEwJ");
var $1202c6eeef8de166$require$$parseFloat = $cUEwJ.parseFloat;

var $3JQ2K = parcelRequire("3JQ2K");
var $1202c6eeef8de166$require$$trim = $3JQ2K.trim;

$1202c6eeef8de166$exports = 1 / $1202c6eeef8de166$require$$parseFloat((parcelRequire("UqiYA")) + '-0') !== -Infinity ? function parseFloat(str) {
    var string = $1202c6eeef8de166$require$$trim(String(str), 3);
    var result = $1202c6eeef8de166$require$$parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $1202c6eeef8de166$require$$parseFloat;


// 18.2.4 parseFloat(string)
$7UCsS($7UCsS.G + $7UCsS.F * (parseFloat != $1202c6eeef8de166$exports), {
    parseFloat: $1202c6eeef8de166$exports
});


'use strict';

var $cUEwJ = parcelRequire("cUEwJ");

var $i9PqC = parcelRequire("i9PqC");

var $8t6Im = parcelRequire("8t6Im");

var $1EHqA = parcelRequire("1EHqA");

var $hFD9L = parcelRequire("hFD9L");

var $d6gmi = parcelRequire("d6gmi");

var $dQVrJ = parcelRequire("dQVrJ");
var $c650876384771d45$require$gOPN = $dQVrJ.f;

var $clqre = parcelRequire("clqre");
var $c650876384771d45$require$gOPD = $clqre.f;

var $1w421 = parcelRequire("1w421");
var $c650876384771d45$require$dP = $1w421.f;

var $3JQ2K = parcelRequire("3JQ2K");
var $c650876384771d45$require$$trim = $3JQ2K.trim;
var $c650876384771d45$var$NUMBER = 'Number';
var $c650876384771d45$var$$Number = $cUEwJ[$c650876384771d45$var$NUMBER];
var $c650876384771d45$var$Base = $c650876384771d45$var$$Number;
var $c650876384771d45$var$proto = $c650876384771d45$var$$Number.prototype;

// Opera ~12 has broken Object#toString
var $c650876384771d45$var$BROKEN_COF = $8t6Im((parcelRequire("9hnGd"))($c650876384771d45$var$proto)) == $c650876384771d45$var$NUMBER;
var $c650876384771d45$var$TRIM = 'trim' in String.prototype;
// 7.1.3 ToNumber(argument)
var $c650876384771d45$var$toNumber = function(argument) {
    var it = $hFD9L(argument, false);
    if (typeof it == 'string' && it.length > 2) {
        it = $c650876384771d45$var$TRIM ? it.trim() : $c650876384771d45$require$$trim(it, 3);
        var first = it.charCodeAt(0);
        var third, radix, maxCode;
        if (first === 43 || first === 45) {
            third = it.charCodeAt(2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch(it.charCodeAt(1)){
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break; // fast equal /^0b[01]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break; // fast equal /^0o[0-7]+$/i
                default:
                    return +it;
            }
            for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
                code = digits.charCodeAt(i);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};


if (!$c650876384771d45$var$$Number(' 0o1') || !$c650876384771d45$var$$Number('0b1') || $c650876384771d45$var$$Number('+0x1')) {
    $c650876384771d45$var$$Number = function Number(value) {
        var it = arguments.length < 1 ? 0 : value;
        var that = this;
        return that instanceof $c650876384771d45$var$$Number && ($c650876384771d45$var$BROKEN_COF ? $d6gmi(function() {
            $c650876384771d45$var$proto.valueOf.call(that);
        }) : $8t6Im(that) != $c650876384771d45$var$NUMBER) ? $1EHqA(new $c650876384771d45$var$Base($c650876384771d45$var$toNumber(it)), that, $c650876384771d45$var$$Number) : $c650876384771d45$var$toNumber(it);
    };
    for(var $c650876384771d45$var$keys = (parcelRequire("gvp2l")) ? $c650876384771d45$require$gOPN($c650876384771d45$var$Base) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(','), $c650876384771d45$var$j = 0, $c650876384771d45$var$key; $c650876384771d45$var$keys.length > $c650876384771d45$var$j; $c650876384771d45$var$j++)if ($i9PqC($c650876384771d45$var$Base, $c650876384771d45$var$key = $c650876384771d45$var$keys[$c650876384771d45$var$j]) && !$i9PqC($c650876384771d45$var$$Number, $c650876384771d45$var$key)) $c650876384771d45$require$dP($c650876384771d45$var$$Number, $c650876384771d45$var$key, $c650876384771d45$require$gOPD($c650876384771d45$var$Base, $c650876384771d45$var$key));
    $c650876384771d45$var$$Number.prototype = $c650876384771d45$var$proto;
    $c650876384771d45$var$proto.constructor = $c650876384771d45$var$$Number;
    (parcelRequire("2niSg"))($cUEwJ, $c650876384771d45$var$NUMBER, $c650876384771d45$var$$Number);
}


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $lelYU = parcelRequire("lelYU");
var $151c4afcc2580561$exports = {};

var $8t6Im = parcelRequire("8t6Im");
$151c4afcc2580561$exports = function(it, msg) {
    if (typeof it != 'number' && $8t6Im(it) != 'Number') throw TypeError(msg);
    return +it;
};



var $bvdTC = parcelRequire("bvdTC");
var $c5633b3766d8cbce$var$$toFixed = 1.0.toFixed;
var $c5633b3766d8cbce$var$floor = Math.floor;
var $c5633b3766d8cbce$var$data = [
    0,
    0,
    0,
    0,
    0,
    0
];
var $c5633b3766d8cbce$var$ERROR = 'Number.toFixed: incorrect invocation!';
var $c5633b3766d8cbce$var$ZERO = '0';
var $c5633b3766d8cbce$var$multiply = function(n, c) {
    var i = -1;
    var c2 = c;
    while(++i < 6){
        c2 += n * $c5633b3766d8cbce$var$data[i];
        $c5633b3766d8cbce$var$data[i] = c2 % 1e7;
        c2 = $c5633b3766d8cbce$var$floor(c2 / 1e7);
    }
};
var $c5633b3766d8cbce$var$divide = function(n) {
    var i = 6;
    var c = 0;
    while(--i >= 0){
        c += $c5633b3766d8cbce$var$data[i];
        $c5633b3766d8cbce$var$data[i] = $c5633b3766d8cbce$var$floor(c / n);
        c = c % n * 1e7;
    }
};
var $c5633b3766d8cbce$var$numToString = function() {
    var i = 6;
    var s = '';
    while(--i >= 0)if (s !== '' || i === 0 || $c5633b3766d8cbce$var$data[i] !== 0) {
        var t = String($c5633b3766d8cbce$var$data[i]);
        s = s === '' ? t : s + $bvdTC.call($c5633b3766d8cbce$var$ZERO, 7 - t.length) + t;
    }
    return s;
};
var $c5633b3766d8cbce$var$pow = function(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? $c5633b3766d8cbce$var$pow(x, n - 1, acc * x) : $c5633b3766d8cbce$var$pow(x * x, n / 2, acc);
};
var $c5633b3766d8cbce$var$log = function(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};

$7UCsS($7UCsS.P + $7UCsS.F * (!!$c5633b3766d8cbce$var$$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !(parcelRequire("d6gmi"))(function() {
    // V8 ~ Android 4.3-
    $c5633b3766d8cbce$var$$toFixed.call({});
})), 'Number', {
    toFixed: function toFixed(fractionDigits) {
        var x = $151c4afcc2580561$exports(this, $c5633b3766d8cbce$var$ERROR);
        var f = $lelYU(fractionDigits);
        var s = '';
        var m = $c5633b3766d8cbce$var$ZERO;
        var e, z, j, k;
        if (f < 0 || f > 20) throw RangeError($c5633b3766d8cbce$var$ERROR);
        // eslint-disable-next-line no-self-compare
        if (x != x) return 'NaN';
        if (x <= -1e+21 || x >= 1e21) return String(x);
        if (x < 0) {
            s = '-';
            x = -x;
        }
        if (x > 1e-21) {
            e = $c5633b3766d8cbce$var$log(x * $c5633b3766d8cbce$var$pow(2, 69, 1)) - 69;
            z = e < 0 ? x * $c5633b3766d8cbce$var$pow(2, -e, 1) : x / $c5633b3766d8cbce$var$pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                $c5633b3766d8cbce$var$multiply(0, z);
                j = f;
                while(j >= 7){
                    $c5633b3766d8cbce$var$multiply(1e7, 0);
                    j -= 7;
                }
                $c5633b3766d8cbce$var$multiply($c5633b3766d8cbce$var$pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    $c5633b3766d8cbce$var$divide(8388608);
                    j -= 23;
                }
                $c5633b3766d8cbce$var$divide(1 << j);
                $c5633b3766d8cbce$var$multiply(1, 1);
                $c5633b3766d8cbce$var$divide(2);
                m = $c5633b3766d8cbce$var$numToString();
            } else {
                $c5633b3766d8cbce$var$multiply(0, z);
                $c5633b3766d8cbce$var$multiply(1 << -e, 0);
                m = $c5633b3766d8cbce$var$numToString() + $bvdTC.call($c5633b3766d8cbce$var$ZERO, f);
            }
        }
        if (f > 0) {
            k = m.length;
            m = s + (k <= f ? '0.' + $bvdTC.call($c5633b3766d8cbce$var$ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
        } else m = s + m;
        return m;
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $d6gmi = parcelRequire("d6gmi");

var $7fe879494bc79647$var$$toPrecision = 1.0.toPrecision;
$7UCsS($7UCsS.P + $7UCsS.F * ($d6gmi(function() {
    // IE7-
    return $7fe879494bc79647$var$$toPrecision.call(1, undefined) !== '1';
}) || !$d6gmi(function() {
    // V8 ~ Android 4.3-
    $7fe879494bc79647$var$$toPrecision.call({});
})), 'Number', {
    toPrecision: function toPrecision(precision) {
        var that = $151c4afcc2580561$exports(this, 'Number#toPrecision: incorrect invocation!');
        return precision === undefined ? $7fe879494bc79647$var$$toPrecision.call(that) : $7fe879494bc79647$var$$toPrecision.call(that, precision);
    }
});


// 20.1.2.1 Number.EPSILON

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Number', {
    EPSILON: Math.pow(2, -52)
});


// 20.1.2.2 Number.isFinite(number)

var $7UCsS = parcelRequire("7UCsS");

var $cUEwJ = parcelRequire("cUEwJ");
var $f2a57dd2964799be$require$_isFinite = $cUEwJ.isFinite;
$7UCsS($7UCsS.S, 'Number', {
    isFinite: function isFinite(it) {
        return typeof it == 'number' && $f2a57dd2964799be$require$_isFinite(it);
    }
});


// 20.1.2.3 Number.isInteger(number)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S, 'Number', {
    isInteger: (parcelRequire("3bkJs"))
});


// 20.1.2.4 Number.isNaN(number)

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Number', {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare
        return number != number;
    }
});


// 20.1.2.5 Number.isSafeInteger(number)

var $7UCsS = parcelRequire("7UCsS");

var $3bkJs = parcelRequire("3bkJs");
var $4f1251ed9c3fa317$var$abs = Math.abs;
$7UCsS($7UCsS.S, 'Number', {
    isSafeInteger: function isSafeInteger(number) {
        return $3bkJs(number) && $4f1251ed9c3fa317$var$abs(number) <= 0x1fffffffffffff;
    }
});


// 20.1.2.6 Number.MAX_SAFE_INTEGER

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Number', {
    MAX_SAFE_INTEGER: 0x1fffffffffffff
});


// 20.1.2.10 Number.MIN_SAFE_INTEGER

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Number', {
    MIN_SAFE_INTEGER: -9007199254740991
});



var $7UCsS = parcelRequire("7UCsS");

// 20.1.2.12 Number.parseFloat(string)
$7UCsS($7UCsS.S + $7UCsS.F * (Number.parseFloat != $1202c6eeef8de166$exports), 'Number', {
    parseFloat: $1202c6eeef8de166$exports
});



var $7UCsS = parcelRequire("7UCsS");

// 20.1.2.13 Number.parseInt(string, radix)
$7UCsS($7UCsS.S + $7UCsS.F * (Number.parseInt != $6e56a838ffa16dfc$exports), 'Number', {
    parseInt: $6e56a838ffa16dfc$exports
});


// 20.2.2.3 Math.acosh(x)

var $7UCsS = parcelRequire("7UCsS");

var $3zATn = parcelRequire("3zATn");
var $13d247377ec90ba0$var$sqrt = Math.sqrt;
var $13d247377ec90ba0$var$$acosh = Math.acosh;
$7UCsS($7UCsS.S + $7UCsS.F * !($13d247377ec90ba0$var$$acosh && Math.floor($13d247377ec90ba0$var$$acosh(Number.MAX_VALUE)) == 710 && $13d247377ec90ba0$var$$acosh(Infinity) == Infinity), 'Math', {
    acosh: function acosh(x) {
        return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : $3zATn(x - 1 + $13d247377ec90ba0$var$sqrt(x - 1) * $13d247377ec90ba0$var$sqrt(x + 1));
    }
});


// 20.2.2.5 Math.asinh(x)

var $7UCsS = parcelRequire("7UCsS");
var $81db389c783ed447$var$$asinh = Math.asinh;
function $81db389c783ed447$var$asinh(x) {
    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -$81db389c783ed447$var$asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}
// Tor Browser bug: Math.asinh(0) -> -0
$7UCsS($7UCsS.S + $7UCsS.F * !($81db389c783ed447$var$$asinh && 1 / $81db389c783ed447$var$$asinh(0) > 0), 'Math', {
    asinh: $81db389c783ed447$var$asinh
});


// 20.2.2.7 Math.atanh(x)

var $7UCsS = parcelRequire("7UCsS");
var $690478c097127934$var$$atanh = Math.atanh;
// Tor Browser bug: Math.atanh(-0) -> 0
$7UCsS($7UCsS.S + $7UCsS.F * !($690478c097127934$var$$atanh && 1 / $690478c097127934$var$$atanh(-0) < 0), 'Math', {
    atanh: function atanh(x) {
        return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
    }
});


// 20.2.2.9 Math.cbrt(x)

var $7UCsS = parcelRequire("7UCsS");

var $fLy9c = parcelRequire("fLy9c");
$7UCsS($7UCsS.S, 'Math', {
    cbrt: function cbrt(x) {
        return $fLy9c(x = +x) * Math.pow(Math.abs(x), 1 / 3);
    }
});


// 20.2.2.11 Math.clz32(x)

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    clz32: function clz32(x) {
        return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
    }
});


// 20.2.2.12 Math.cosh(x)

var $7UCsS = parcelRequire("7UCsS");
var $8c5714d20b5fc062$var$exp = Math.exp;
$7UCsS($7UCsS.S, 'Math', {
    cosh: function cosh(x) {
        return ($8c5714d20b5fc062$var$exp(x = +x) + $8c5714d20b5fc062$var$exp(-x)) / 2;
    }
});


// 20.2.2.14 Math.expm1(x)

var $7UCsS = parcelRequire("7UCsS");
var $16ccf38216bcd6ca$exports = {};
// 20.2.2.14 Math.expm1(x)
var $16ccf38216bcd6ca$var$$expm1 = Math.expm1;
$16ccf38216bcd6ca$exports = !$16ccf38216bcd6ca$var$$expm1 || $16ccf38216bcd6ca$var$$expm1(10) > 22025.465794806719 || $16ccf38216bcd6ca$var$$expm1(10) < 22025.4657948067165168 || $16ccf38216bcd6ca$var$$expm1(-2e-17) != -2e-17 ? function expm1(x) {
    return (x = +x) == 0 ? x : x > -0.000001 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $16ccf38216bcd6ca$var$$expm1;


$7UCsS($7UCsS.S + $7UCsS.F * ($16ccf38216bcd6ca$exports != Math.expm1), 'Math', {
    expm1: $16ccf38216bcd6ca$exports
});


// 20.2.2.16 Math.fround(x)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S, 'Math', {
    fround: (parcelRequire("3eQaZ"))
});


// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])

var $7UCsS = parcelRequire("7UCsS");
var $05a230f33f4ac930$var$abs = Math.abs;
$7UCsS($7UCsS.S, 'Math', {
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $05a230f33f4ac930$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
    }
});


// 20.2.2.18 Math.imul(x, y)

var $7UCsS = parcelRequire("7UCsS");
var $125e13976a33076a$var$$imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$7UCsS($7UCsS.S + $7UCsS.F * (parcelRequire("d6gmi"))(function() {
    return $125e13976a33076a$var$$imul(0xffffffff, 5) != -5 || $125e13976a33076a$var$$imul.length != 2;
}), 'Math', {
    imul: function imul(x, y) {
        var UINT16 = 0xffff;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
});


// 20.2.2.21 Math.log10(x)

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    log10: function log10(x) {
        return Math.log(x) * Math.LOG10E;
    }
});


// 20.2.2.20 Math.log1p(x)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S, 'Math', {
    log1p: (parcelRequire("3zATn"))
});


// 20.2.2.22 Math.log2(x)

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    log2: function log2(x) {
        return Math.log(x) / Math.LN2;
    }
});


// 20.2.2.28 Math.sign(x)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S, 'Math', {
    sign: (parcelRequire("fLy9c"))
});


// 20.2.2.30 Math.sinh(x)

var $7UCsS = parcelRequire("7UCsS");

var $c74ad7839d0038d8$var$exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$7UCsS($7UCsS.S + $7UCsS.F * (parcelRequire("d6gmi"))(function() {
    return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
    sinh: function sinh(x) {
        return Math.abs(x = +x) < 1 ? ($16ccf38216bcd6ca$exports(x) - $16ccf38216bcd6ca$exports(-x)) / 2 : ($c74ad7839d0038d8$var$exp(x - 1) - $c74ad7839d0038d8$var$exp(-x - 1)) * (Math.E / 2);
    }
});


// 20.2.2.33 Math.tanh(x)

var $7UCsS = parcelRequire("7UCsS");

var $d4a1c9166b888436$var$exp = Math.exp;
$7UCsS($7UCsS.S, 'Math', {
    tanh: function tanh(x) {
        var a = $16ccf38216bcd6ca$exports(x = +x);
        var b = $16ccf38216bcd6ca$exports(-x);
        return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / ($d4a1c9166b888436$var$exp(x) + $d4a1c9166b888436$var$exp(-x));
    }
});


// 20.2.2.34 Math.trunc(x)

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    trunc: function trunc(it) {
        return (it > 0 ? Math.floor : Math.ceil)(it);
    }
});



var $7UCsS = parcelRequire("7UCsS");

var $ktL0p = parcelRequire("ktL0p");
var $a6b5c2a70f48fd78$var$fromCharCode = String.fromCharCode;
var $a6b5c2a70f48fd78$var$$fromCodePoint = String.fromCodePoint;
// length should be 1, old FF problem
$7UCsS($7UCsS.S + $7UCsS.F * (!!$a6b5c2a70f48fd78$var$$fromCodePoint && $a6b5c2a70f48fd78$var$$fromCodePoint.length != 1), 'String', {
    // 21.1.2.2 String.fromCodePoint(...codePoints)
    fromCodePoint: function fromCodePoint(x) {
        var res = [];
        var aLen = arguments.length;
        var i = 0;
        var code;
        while(aLen > i){
            code = +arguments[i++];
            if ($ktL0p(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
            res.push(code < 0x10000 ? $a6b5c2a70f48fd78$var$fromCharCode(code) : $a6b5c2a70f48fd78$var$fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
        }
        return res.join('');
    }
});



var $7UCsS = parcelRequire("7UCsS");

var $e6Osc = parcelRequire("e6Osc");

var $75R4e = parcelRequire("75R4e");
$7UCsS($7UCsS.S, 'String', {
    // 21.1.2.4 String.raw(callSite, ...substitutions)
    raw: function raw(callSite) {
        var tpl = $e6Osc(callSite.raw);
        var len = $75R4e(tpl.length);
        var aLen = arguments.length;
        var res = [];
        var i = 0;
        while(len > i){
            res.push(String(tpl[i++]));
            if (i < aLen) res.push(String(arguments[i]));
        }
        return res.join('');
    }
});


'use strict';

// 21.1.3.25 String.prototype.trim()
(parcelRequire("3JQ2K"))('trim', function($trim) {
    return function trim() {
        return $trim(this, 3);
    };
});


'use strict';

var $5f12ea7cae5da991$var$$at = (parcelRequire("9yOH3"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("d5llS"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $5f12ea7cae5da991$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $8c454deb62ff423b$var$$at = (parcelRequire("9yOH3"))(false);
$7UCsS($7UCsS.P, 'String', {
    // 21.1.3.3 String.prototype.codePointAt(pos)
    codePointAt: function codePointAt(pos) {
        return $8c454deb62ff423b$var$$at(this, pos);
    }
});


// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $75R4e = parcelRequire("75R4e");
var $86a9076dc934070b$exports = {};
// helper for String#{startsWith, endsWith, includes}
var $9265c81d0366ca25$exports = {};
// 7.2.8 IsRegExp(argument)

var $5ehF7 = parcelRequire("5ehF7");

var $8t6Im = parcelRequire("8t6Im");

var $9265c81d0366ca25$var$MATCH = (parcelRequire("5zj8I"))('match');
$9265c81d0366ca25$exports = function(it) {
    var isRegExp;
    return $5ehF7(it) && ((isRegExp = it[$9265c81d0366ca25$var$MATCH]) !== undefined ? !!isRegExp : $8t6Im(it) == 'RegExp');
};



var $1esYK = parcelRequire("1esYK");
$86a9076dc934070b$exports = function(that, searchString, NAME) {
    if ($9265c81d0366ca25$exports(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
    return String($1esYK(that));
};


var $7c0fde54344c96be$var$ENDS_WITH = 'endsWith';
var $7c0fde54344c96be$var$$endsWith = ''[$7c0fde54344c96be$var$ENDS_WITH];

$7UCsS($7UCsS.P + $7UCsS.F * (parcelRequire("1a9F2"))($7c0fde54344c96be$var$ENDS_WITH), 'String', {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $86a9076dc934070b$exports(this, searchString, $7c0fde54344c96be$var$ENDS_WITH);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = $75R4e(that.length);
        var end = endPosition === undefined ? len : Math.min($75R4e(endPosition), len);
        var search = String(searchString);
        return $7c0fde54344c96be$var$$endsWith ? $7c0fde54344c96be$var$$endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
    }
});


// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $04c0e4a7ca002179$var$INCLUDES = 'includes';

$7UCsS($7UCsS.P + $7UCsS.F * (parcelRequire("1a9F2"))($04c0e4a7ca002179$var$INCLUDES), 'String', {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$86a9076dc934070b$exports(this, searchString, $04c0e4a7ca002179$var$INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
    }
});



var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.P, 'String', {
    // 21.1.3.13 String.prototype.repeat(count)
    repeat: (parcelRequire("bvdTC"))
});


// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $75R4e = parcelRequire("75R4e");

var $82c0d6a76f90b5a0$var$STARTS_WITH = 'startsWith';
var $82c0d6a76f90b5a0$var$$startsWith = ''[$82c0d6a76f90b5a0$var$STARTS_WITH];

$7UCsS($7UCsS.P + $7UCsS.F * (parcelRequire("1a9F2"))($82c0d6a76f90b5a0$var$STARTS_WITH), 'String', {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $86a9076dc934070b$exports(this, searchString, $82c0d6a76f90b5a0$var$STARTS_WITH);
        var index = $75R4e(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = String(searchString);
        return $82c0d6a76f90b5a0$var$$startsWith ? $82c0d6a76f90b5a0$var$$startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
    }
});


'use strict';

// B.2.3.2 String.prototype.anchor(name)
(parcelRequire("66lIJ"))('anchor', function(createHTML) {
    return function anchor(name) {
        return createHTML(this, 'a', 'name', name);
    };
});


'use strict';

// B.2.3.3 String.prototype.big()
(parcelRequire("66lIJ"))('big', function(createHTML) {
    return function big() {
        return createHTML(this, 'big', '', '');
    };
});


'use strict';

// B.2.3.4 String.prototype.blink()
(parcelRequire("66lIJ"))('blink', function(createHTML) {
    return function blink() {
        return createHTML(this, 'blink', '', '');
    };
});


'use strict';

// B.2.3.5 String.prototype.bold()
(parcelRequire("66lIJ"))('bold', function(createHTML) {
    return function bold() {
        return createHTML(this, 'b', '', '');
    };
});


'use strict';

// B.2.3.6 String.prototype.fixed()
(parcelRequire("66lIJ"))('fixed', function(createHTML) {
    return function fixed() {
        return createHTML(this, 'tt', '', '');
    };
});


'use strict';

// B.2.3.7 String.prototype.fontcolor(color)
(parcelRequire("66lIJ"))('fontcolor', function(createHTML) {
    return function fontcolor(color) {
        return createHTML(this, 'font', 'color', color);
    };
});


'use strict';

// B.2.3.8 String.prototype.fontsize(size)
(parcelRequire("66lIJ"))('fontsize', function(createHTML) {
    return function fontsize(size) {
        return createHTML(this, 'font', 'size', size);
    };
});


'use strict';

// B.2.3.9 String.prototype.italics()
(parcelRequire("66lIJ"))('italics', function(createHTML) {
    return function italics() {
        return createHTML(this, 'i', '', '');
    };
});


'use strict';

// B.2.3.10 String.prototype.link(url)
(parcelRequire("66lIJ"))('link', function(createHTML) {
    return function link(url) {
        return createHTML(this, 'a', 'href', url);
    };
});


'use strict';

// B.2.3.11 String.prototype.small()
(parcelRequire("66lIJ"))('small', function(createHTML) {
    return function small() {
        return createHTML(this, 'small', '', '');
    };
});


'use strict';

// B.2.3.12 String.prototype.strike()
(parcelRequire("66lIJ"))('strike', function(createHTML) {
    return function strike() {
        return createHTML(this, 'strike', '', '');
    };
});


'use strict';

// B.2.3.13 String.prototype.sub()
(parcelRequire("66lIJ"))('sub', function(createHTML) {
    return function sub() {
        return createHTML(this, 'sub', '', '');
    };
});


'use strict';

// B.2.3.14 String.prototype.sup()
(parcelRequire("66lIJ"))('sup', function(createHTML) {
    return function sup() {
        return createHTML(this, 'sup', '', '');
    };
});


// 20.3.3.1 / 15.9.4.4 Date.now()

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $87N8x = parcelRequire("87N8x");

var $hFD9L = parcelRequire("hFD9L");

$7UCsS($7UCsS.P + $7UCsS.F * (parcelRequire("d6gmi"))(function() {
    return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
        toISOString: function() {
            return 1;
        }
    }) !== 1;
}), 'Date', {
    // eslint-disable-next-line no-unused-vars
    toJSON: function toJSON(key) {
        var O = $87N8x(this);
        var pv = $hFD9L(O);
        return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
    }
});


// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var $7UCsS = parcelRequire("7UCsS");
var $c8bfae99ad95b14a$exports = {};
'use strict';

var $d6gmi = parcelRequire("d6gmi");
var $c8bfae99ad95b14a$var$getTime = Date.prototype.getTime;
var $c8bfae99ad95b14a$var$$toISOString = Date.prototype.toISOString;
var $c8bfae99ad95b14a$var$lz = function(num) {
    return num > 9 ? num : '0' + num;
};
// PhantomJS / old WebKit has a broken implementations
$c8bfae99ad95b14a$exports = $d6gmi(function() {
    return $c8bfae99ad95b14a$var$$toISOString.call(new Date(-50000000000000 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !$d6gmi(function() {
    $c8bfae99ad95b14a$var$$toISOString.call(new Date(NaN));
}) ? function toISOString() {
    if (!isFinite($c8bfae99ad95b14a$var$getTime.call(this))) throw RangeError('Invalid time value');
    var d = this;
    var y = d.getUTCFullYear();
    var m = d.getUTCMilliseconds();
    var s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + $c8bfae99ad95b14a$var$lz(d.getUTCMonth() + 1) + '-' + $c8bfae99ad95b14a$var$lz(d.getUTCDate()) + 'T' + $c8bfae99ad95b14a$var$lz(d.getUTCHours()) + ':' + $c8bfae99ad95b14a$var$lz(d.getUTCMinutes()) + ':' + $c8bfae99ad95b14a$var$lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + $c8bfae99ad95b14a$var$lz(m)) + 'Z';
} : $c8bfae99ad95b14a$var$$toISOString;


// PhantomJS / old WebKit has a broken implementations
$7UCsS($7UCsS.P + $7UCsS.F * (Date.prototype.toISOString !== $c8bfae99ad95b14a$exports), 'Date', {
    toISOString: $c8bfae99ad95b14a$exports
});


var $ccdd493cf8c0cb79$var$DateProto = Date.prototype;
var $ccdd493cf8c0cb79$var$INVALID_DATE = 'Invalid Date';
var $ccdd493cf8c0cb79$var$TO_STRING = 'toString';
var $ccdd493cf8c0cb79$var$$toString = $ccdd493cf8c0cb79$var$DateProto[$ccdd493cf8c0cb79$var$TO_STRING];
var $ccdd493cf8c0cb79$var$getTime = $ccdd493cf8c0cb79$var$DateProto.getTime;

if (new Date(NaN) + '' != $ccdd493cf8c0cb79$var$INVALID_DATE) (parcelRequire("2niSg"))($ccdd493cf8c0cb79$var$DateProto, $ccdd493cf8c0cb79$var$TO_STRING, function toString() {
    var value = $ccdd493cf8c0cb79$var$getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $ccdd493cf8c0cb79$var$$toString.call(this) : $ccdd493cf8c0cb79$var$INVALID_DATE;
});



var $0f54c6778f623d8f$var$TO_PRIMITIVE = (parcelRequire("5zj8I"))('toPrimitive');
var $0f54c6778f623d8f$var$proto = Date.prototype;


if (!($0f54c6778f623d8f$var$TO_PRIMITIVE in $0f54c6778f623d8f$var$proto)) (parcelRequire("6G6JS"))($0f54c6778f623d8f$var$proto, $0f54c6778f623d8f$var$TO_PRIMITIVE, (parcelRequire("7KNJF")));


// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S, 'Array', {
    isArray: (parcelRequire("8D3Ey"))
});


'use strict';

var $i2qD6 = parcelRequire("i2qD6");

var $7UCsS = parcelRequire("7UCsS");

var $87N8x = parcelRequire("87N8x");

var $g3ACS = parcelRequire("g3ACS");

var $dMVvs = parcelRequire("dMVvs");

var $75R4e = parcelRequire("75R4e");
var $7bfc6e071d4e0dc7$exports = {};
'use strict';

var $1w421 = parcelRequire("1w421");

var $jPGz2 = parcelRequire("jPGz2");
$7bfc6e071d4e0dc7$exports = function(object, index, value) {
    if (index in object) $1w421.f(object, index, $jPGz2(0, value));
    else object[index] = value;
};



var $bHyyq = parcelRequire("bHyyq");

$7UCsS($7UCsS.S + $7UCsS.F * !(parcelRequire("3YVTs"))(function(iter) {
    Array.from(iter);
}), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
        var O = $87N8x(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = $bHyyq(O);
        var length, result, step, iterator;
        if (mapping) mapfn = $i2qD6(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && $dMVvs(iterFn))) for(iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++)$7bfc6e071d4e0dc7$exports(result, index, mapping ? $g3ACS(iterator, mapfn, [
            step.value,
            index
        ], true) : step.value);
        else {
            length = $75R4e(O.length);
            for(result = new C(length); length > index; index++)$7bfc6e071d4e0dc7$exports(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
        result.length = index;
        return result;
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");


// WebKit Array.of isn't generic
$7UCsS($7UCsS.S + $7UCsS.F * (parcelRequire("d6gmi"))(function() {
    function F() {}
    return !(Array.of.call(F) instanceof F);
}), 'Array', {
    // 22.1.2.3 Array.of( ...items)
    of: function of() {
        var index = 0;
        var aLen = arguments.length;
        var result = new (typeof this == 'function' ? this : Array)(aLen);
        while(aLen > index)$7bfc6e071d4e0dc7$exports(result, index, arguments[index++]);
        result.length = aLen;
        return result;
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $e6Osc = parcelRequire("e6Osc");
var $730fcb5b3564febe$var$arrayJoin = [].join;


// fallback for not array-like strings
$7UCsS($7UCsS.P + $7UCsS.F * ((parcelRequire("5jKhD")) != Object || !(parcelRequire("cezhV"))($730fcb5b3564febe$var$arrayJoin)), 'Array', {
    join: function join(separator) {
        return $730fcb5b3564febe$var$arrayJoin.call($e6Osc(this), separator === undefined ? ',' : separator);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $e9oLT = parcelRequire("e9oLT");

var $8t6Im = parcelRequire("8t6Im");

var $ktL0p = parcelRequire("ktL0p");

var $75R4e = parcelRequire("75R4e");
var $c1f695613532ac73$var$arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$7UCsS($7UCsS.P + $7UCsS.F * (parcelRequire("d6gmi"))(function() {
    if ($e9oLT) $c1f695613532ac73$var$arraySlice.call($e9oLT);
}), 'Array', {
    slice: function slice(begin, end) {
        var len = $75R4e(this.length);
        var klass = $8t6Im(this);
        end = end === undefined ? len : end;
        if (klass == 'Array') return $c1f695613532ac73$var$arraySlice.call(this, begin, end);
        var start = $ktL0p(begin, len);
        var upTo = $ktL0p(end, len);
        var size = $75R4e(upTo - start);
        var cloned = new Array(size);
        var i = 0;
        for(; i < size; i++)cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
        return cloned;
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $ekEf9 = parcelRequire("ekEf9");

var $87N8x = parcelRequire("87N8x");

var $d6gmi = parcelRequire("d6gmi");
var $268f7e999b7fee18$var$$sort = [].sort;
var $268f7e999b7fee18$var$test = [
    1,
    2,
    3
];

$7UCsS($7UCsS.P + $7UCsS.F * ($d6gmi(function() {
    // IE8-
    $268f7e999b7fee18$var$test.sort(undefined);
}) || !$d6gmi(function() {
    // V8 bug
    $268f7e999b7fee18$var$test.sort(null);
// Old WebKit
}) || !(parcelRequire("cezhV"))($268f7e999b7fee18$var$$sort)), 'Array', {
    // 22.1.3.25 Array.prototype.sort(comparefn)
    sort: function sort(comparefn) {
        return comparefn === undefined ? $268f7e999b7fee18$var$$sort.call($87N8x(this)) : $268f7e999b7fee18$var$$sort.call($87N8x(this), $ekEf9(comparefn));
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $c85440c4fac9c989$var$$forEach = (parcelRequire("gXweJ"))(0);

var $c85440c4fac9c989$var$STRICT = (parcelRequire("cezhV"))([].forEach, true);
$7UCsS($7UCsS.P + $7UCsS.F * !$c85440c4fac9c989$var$STRICT, 'Array', {
    // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
    forEach: function forEach(callbackfn /* , thisArg */ ) {
        return $c85440c4fac9c989$var$$forEach(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $56517dab670f28a8$var$$map = (parcelRequire("gXweJ"))(1);

$7UCsS($7UCsS.P + $7UCsS.F * !(parcelRequire("cezhV"))([].map, true), 'Array', {
    // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
    map: function map(callbackfn /* , thisArg */ ) {
        return $56517dab670f28a8$var$$map(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $9f6a38c8fa52356b$var$$filter = (parcelRequire("gXweJ"))(2);

$7UCsS($7UCsS.P + $7UCsS.F * !(parcelRequire("cezhV"))([].filter, true), 'Array', {
    // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $9f6a38c8fa52356b$var$$filter(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $b8d62c3ddf80e188$var$$some = (parcelRequire("gXweJ"))(3);

$7UCsS($7UCsS.P + $7UCsS.F * !(parcelRequire("cezhV"))([].some, true), 'Array', {
    // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
    some: function some(callbackfn /* , thisArg */ ) {
        return $b8d62c3ddf80e188$var$$some(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $8da304e000818522$var$$every = (parcelRequire("gXweJ"))(4);

$7UCsS($7UCsS.P + $7UCsS.F * !(parcelRequire("cezhV"))([].every, true), 'Array', {
    // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
    every: function every(callbackfn /* , thisArg */ ) {
        return $8da304e000818522$var$$every(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");
var $124414d471f13135$exports = {};

var $ekEf9 = parcelRequire("ekEf9");

var $87N8x = parcelRequire("87N8x");

var $5jKhD = parcelRequire("5jKhD");

var $75R4e = parcelRequire("75R4e");
$124414d471f13135$exports = function(that, callbackfn, aLen, memo, isRight) {
    $ekEf9(callbackfn);
    var O = $87N8x(that);
    var self = $5jKhD(O);
    var length = $75R4e(O.length);
    var index = isRight ? length - 1 : 0;
    var i = isRight ? -1 : 1;
    if (aLen < 2) for(;;){
        if (index in self) {
            memo = self[index];
            index += i;
            break;
        }
        index += i;
        if (isRight ? index < 0 : length <= index) throw TypeError('Reduce of empty array with no initial value');
    }
    for(; isRight ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
    return memo;
};



$7UCsS($7UCsS.P + $7UCsS.F * !(parcelRequire("cezhV"))([].reduce, true), 'Array', {
    // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        return $124414d471f13135$exports(this, callbackfn, arguments.length, arguments[1], false);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");


$7UCsS($7UCsS.P + $7UCsS.F * !(parcelRequire("cezhV"))([].reduceRight, true), 'Array', {
    // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
    reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
        return $124414d471f13135$exports(this, callbackfn, arguments.length, arguments[1], true);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $23d6cd0576a227e4$var$$indexOf = (parcelRequire("i2jbf"))(false);
var $23d6cd0576a227e4$var$$native = [].indexOf;
var $23d6cd0576a227e4$var$NEGATIVE_ZERO = !!$23d6cd0576a227e4$var$$native && 1 / [
    1
].indexOf(1, -0) < 0;

$7UCsS($7UCsS.P + $7UCsS.F * ($23d6cd0576a227e4$var$NEGATIVE_ZERO || !(parcelRequire("cezhV"))($23d6cd0576a227e4$var$$native)), 'Array', {
    // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        return $23d6cd0576a227e4$var$NEGATIVE_ZERO ? $23d6cd0576a227e4$var$$native.apply(this, arguments) || 0 : $23d6cd0576a227e4$var$$indexOf(this, searchElement, arguments[1]);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $e6Osc = parcelRequire("e6Osc");

var $lelYU = parcelRequire("lelYU");

var $75R4e = parcelRequire("75R4e");
var $553dcbd7442780e0$var$$native = [].lastIndexOf;
var $553dcbd7442780e0$var$NEGATIVE_ZERO = !!$553dcbd7442780e0$var$$native && 1 / [
    1
].lastIndexOf(1, -0) < 0;

$7UCsS($7UCsS.P + $7UCsS.F * ($553dcbd7442780e0$var$NEGATIVE_ZERO || !(parcelRequire("cezhV"))($553dcbd7442780e0$var$$native)), 'Array', {
    // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
        // convert -0 to +0
        if ($553dcbd7442780e0$var$NEGATIVE_ZERO) return $553dcbd7442780e0$var$$native.apply(this, arguments) || 0;
        var O = $e6Osc(this);
        var length = $75R4e(O.length);
        var index = length - 1;
        if (arguments.length > 1) index = Math.min(index, $lelYU(arguments[1]));
        if (index < 0) index = length + index;
        for(; index >= 0; index--)if (index in O) {
            if (O[index] === searchElement) return index || 0;
        }
        return -1;
    }
});


// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.P, 'Array', {
    copyWithin: (parcelRequire("fRAkt"))
});

(parcelRequire("kz0tg"))('copyWithin');


// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.P, 'Array', {
    fill: (parcelRequire("e50fk"))
});

(parcelRequire("kz0tg"))('fill');


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $571b4f5caf2368bb$var$$find = (parcelRequire("gXweJ"))(5);
var $571b4f5caf2368bb$var$KEY = 'find';
var $571b4f5caf2368bb$var$forced = true;
// Shouldn't skip holes
if ($571b4f5caf2368bb$var$KEY in []) Array(1)[$571b4f5caf2368bb$var$KEY](function() {
    $571b4f5caf2368bb$var$forced = false;
});
$7UCsS($7UCsS.P + $7UCsS.F * $571b4f5caf2368bb$var$forced, 'Array', {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $571b4f5caf2368bb$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("kz0tg"))($571b4f5caf2368bb$var$KEY);


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $aff0cffe79b49701$var$$find = (parcelRequire("gXweJ"))(6);
var $aff0cffe79b49701$var$KEY = 'findIndex';
var $aff0cffe79b49701$var$forced = true;
// Shouldn't skip holes
if ($aff0cffe79b49701$var$KEY in []) Array(1)[$aff0cffe79b49701$var$KEY](function() {
    $aff0cffe79b49701$var$forced = false;
});
$7UCsS($7UCsS.P + $7UCsS.F * $aff0cffe79b49701$var$forced, 'Array', {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $aff0cffe79b49701$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("kz0tg"))($aff0cffe79b49701$var$KEY);



(parcelRequire("7hk0b"))('Array');


parcelRequire("7V9Gt");

var $cUEwJ = parcelRequire("cUEwJ");

var $1EHqA = parcelRequire("1EHqA");

var $1w421 = parcelRequire("1w421");
var $9d0bdc62e6e17499$require$dP = $1w421.f;

var $dQVrJ = parcelRequire("dQVrJ");
var $9d0bdc62e6e17499$require$gOPN = $dQVrJ.f;


var $lzkzv = parcelRequire("lzkzv");
var $9d0bdc62e6e17499$var$$RegExp = $cUEwJ.RegExp;
var $9d0bdc62e6e17499$var$Base = $9d0bdc62e6e17499$var$$RegExp;
var $9d0bdc62e6e17499$var$proto = $9d0bdc62e6e17499$var$$RegExp.prototype;
var $9d0bdc62e6e17499$var$re1 = /a/g;
var $9d0bdc62e6e17499$var$re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var $9d0bdc62e6e17499$var$CORRECT_NEW = new $9d0bdc62e6e17499$var$$RegExp($9d0bdc62e6e17499$var$re1) !== $9d0bdc62e6e17499$var$re1;



var $5zj8I = parcelRequire("5zj8I");

if ((parcelRequire("gvp2l")) && (!$9d0bdc62e6e17499$var$CORRECT_NEW || (parcelRequire("d6gmi"))(function() {
    $9d0bdc62e6e17499$var$re2[$5zj8I('match')] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return $9d0bdc62e6e17499$var$$RegExp($9d0bdc62e6e17499$var$re1) != $9d0bdc62e6e17499$var$re1 || $9d0bdc62e6e17499$var$$RegExp($9d0bdc62e6e17499$var$re2) == $9d0bdc62e6e17499$var$re2 || $9d0bdc62e6e17499$var$$RegExp($9d0bdc62e6e17499$var$re1, 'i') != '/a/i';
}))) {
    $9d0bdc62e6e17499$var$$RegExp = function RegExp(p, f) {
        var tiRE = this instanceof $9d0bdc62e6e17499$var$$RegExp;
        var piRE = $9265c81d0366ca25$exports(p);
        var fiU = f === undefined;
        return !tiRE && piRE && p.constructor === $9d0bdc62e6e17499$var$$RegExp && fiU ? p : $1EHqA($9d0bdc62e6e17499$var$CORRECT_NEW ? new $9d0bdc62e6e17499$var$Base(piRE && !fiU ? p.source : p, f) : $9d0bdc62e6e17499$var$Base((piRE = p instanceof $9d0bdc62e6e17499$var$$RegExp) ? p.source : p, piRE && fiU ? $lzkzv.call(p) : f), tiRE ? this : $9d0bdc62e6e17499$var$proto, $9d0bdc62e6e17499$var$$RegExp);
    };
    var $9d0bdc62e6e17499$var$proxy = function(key) {
        key in $9d0bdc62e6e17499$var$$RegExp || $9d0bdc62e6e17499$require$dP($9d0bdc62e6e17499$var$$RegExp, key, {
            configurable: true,
            get: function() {
                return $9d0bdc62e6e17499$var$Base[key];
            },
            set: function(it) {
                $9d0bdc62e6e17499$var$Base[key] = it;
            }
        });
    };
    for(var $9d0bdc62e6e17499$var$keys = $9d0bdc62e6e17499$require$gOPN($9d0bdc62e6e17499$var$Base), $9d0bdc62e6e17499$var$i = 0; $9d0bdc62e6e17499$var$keys.length > $9d0bdc62e6e17499$var$i;)$9d0bdc62e6e17499$var$proxy($9d0bdc62e6e17499$var$keys[$9d0bdc62e6e17499$var$i++]);
    $9d0bdc62e6e17499$var$proto.constructor = $9d0bdc62e6e17499$var$$RegExp;
    $9d0bdc62e6e17499$var$$RegExp.prototype = $9d0bdc62e6e17499$var$proto;
    (parcelRequire("2niSg"))($cUEwJ, 'RegExp', $9d0bdc62e6e17499$var$$RegExp);
}

(parcelRequire("7hk0b"))('RegExp');


parcelRequire("lvnpq");
'use strict';
// 21.2.5.3 get RegExp.prototype.flags()



if ((parcelRequire("gvp2l")) && /./g.flags != 'g') (parcelRequire("1w421")).f(RegExp.prototype, 'flags', {
    configurable: true,
    get: (parcelRequire("lzkzv"))
});



var $9bg2N = parcelRequire("9bg2N");

var $lzkzv = parcelRequire("lzkzv");

var $gvp2l = parcelRequire("gvp2l");
var $4ee012c555518cc8$var$TO_STRING = 'toString';
var $4ee012c555518cc8$var$$toString = /./[$4ee012c555518cc8$var$TO_STRING];

var $4ee012c555518cc8$var$define = function(fn) {
    (parcelRequire("2niSg"))(RegExp.prototype, $4ee012c555518cc8$var$TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if ((parcelRequire("d6gmi"))(function() {
    return $4ee012c555518cc8$var$$toString.call({
        source: 'a',
        flags: 'b'
    }) != '/a/b';
})) $4ee012c555518cc8$var$define(function toString() {
    var R = $9bg2N(this);
    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !$gvp2l && R instanceof RegExp ? $lzkzv.call(R) : undefined);
});
else if ($4ee012c555518cc8$var$$toString.name != $4ee012c555518cc8$var$TO_STRING) $4ee012c555518cc8$var$define(function toString() {
    return $4ee012c555518cc8$var$$toString.call(this);
});



'use strict';

var $9bg2N = parcelRequire("9bg2N");

var $75R4e = parcelRequire("75R4e");
var $26b7acb89f4d1c74$exports = {};
'use strict';

var $26b7acb89f4d1c74$var$at = (parcelRequire("9yOH3"))(true);
// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
$26b7acb89f4d1c74$exports = function(S, index, unicode) {
    return index + (unicode ? $26b7acb89f4d1c74$var$at(S, index).length : 1);
};


var $965d4a36aabedfbc$exports = {};
'use strict';

var $d4Dmo = parcelRequire("d4Dmo");
var $965d4a36aabedfbc$var$builtinExec = RegExp.prototype.exec;
// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
$965d4a36aabedfbc$exports = function(R, S) {
    var exec = R.exec;
    if (typeof exec === 'function') {
        var result = exec.call(R, S);
        if (typeof result !== 'object') throw new TypeError('RegExp exec method returned something other than an Object or null');
        return result;
    }
    if ($d4Dmo(R) !== 'RegExp') throw new TypeError('RegExp#exec called on incompatible receiver');
    return $965d4a36aabedfbc$var$builtinExec.call(R, S);
};



// @@match logic
(parcelRequire("706FM"))('match', 1, function(defined, MATCH, $match, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[MATCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
        function(regexp) {
            var res = maybeCallNative($match, regexp, this);
            if (res.done) return res.value;
            var rx = $9bg2N(regexp);
            var S = String(this);
            if (!rx.global) return $965d4a36aabedfbc$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $965d4a36aabedfbc$exports(rx, S)) !== null){
                var matchStr = String(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = $26b7acb89f4d1c74$exports(S, $75R4e(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


'use strict';

var $9bg2N = parcelRequire("9bg2N");

var $87N8x = parcelRequire("87N8x");

var $75R4e = parcelRequire("75R4e");

var $lelYU = parcelRequire("lelYU");


var $4e9558647f26e58e$var$max = Math.max;
var $4e9558647f26e58e$var$min = Math.min;
var $4e9558647f26e58e$var$floor = Math.floor;
var $4e9558647f26e58e$var$SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var $4e9558647f26e58e$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
var $4e9558647f26e58e$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};

// @@replace logic
(parcelRequire("706FM"))('replace', 2, function(defined, REPLACE, $replace, maybeCallNative) {
    return [
        // `String.prototype.replace` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = defined(this);
            var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
            return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
        function(regexp, replaceValue) {
            var res = maybeCallNative($replace, regexp, this, replaceValue);
            if (res.done) return res.value;
            var rx = $9bg2N(regexp);
            var S = String(this);
            var functionalReplace = typeof replaceValue === 'function';
            if (!functionalReplace) replaceValue = String(replaceValue);
            var global = rx.global;
            if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $965d4a36aabedfbc$exports(rx, S);
                if (result === null) break;
                results.push(result);
                if (!global) break;
                var matchStr = String(result[0]);
                if (matchStr === '') rx.lastIndex = $26b7acb89f4d1c74$exports(S, $75R4e(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = String(result[0]);
                var position = $4e9558647f26e58e$var$max($4e9558647f26e58e$var$min($lelYU(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)captures.push($4e9558647f26e58e$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = [
                        matched
                    ].concat(captures, position, S);
                    if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                    var replacement = String(replaceValue.apply(undefined, replacerArgs));
                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + S.slice(nextSourcePosition);
        }
    ];
    // https://tc39.github.io/ecma262/#sec-getsubstitution
    function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
        var tailPos = position + matched.length;
        var m = captures.length;
        var symbols = $4e9558647f26e58e$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
        if (namedCaptures !== undefined) {
            namedCaptures = $87N8x(namedCaptures);
            symbols = $4e9558647f26e58e$var$SUBSTITUTION_SYMBOLS;
        }
        return $replace.call(replacement, symbols, function(match, ch) {
            var capture;
            switch(ch.charAt(0)){
                case '$':
                    return '$';
                case '&':
                    return matched;
                case '`':
                    return str.slice(0, position);
                case "'":
                    return str.slice(tailPos);
                case '<':
                    capture = namedCaptures[ch.slice(1, -1)];
                    break;
                default:
                    var n = +ch;
                    if (n === 0) return match;
                    if (n > m) {
                        var f = $4e9558647f26e58e$var$floor(n / 10);
                        if (f === 0) return match;
                        if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                        return match;
                    }
                    capture = captures[n - 1];
            }
            return capture === undefined ? '' : capture;
        });
    }
});


'use strict';

var $9bg2N = parcelRequire("9bg2N");

var $etufX = parcelRequire("etufX");


// @@search logic
(parcelRequire("706FM"))('search', 1, function(defined, SEARCH, $search, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[SEARCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
        function(regexp) {
            var res = maybeCallNative($search, regexp, this);
            if (res.done) return res.value;
            var rx = $9bg2N(regexp);
            var S = String(this);
            var previousLastIndex = rx.lastIndex;
            if (!$etufX(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = $965d4a36aabedfbc$exports(rx, S);
            if (!$etufX(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});


'use strict';


var $9bg2N = parcelRequire("9bg2N");

var $kubSZ = parcelRequire("kubSZ");


var $75R4e = parcelRequire("75R4e");


var $fn7Kz = parcelRequire("fn7Kz");

var $d6gmi = parcelRequire("d6gmi");
var $7c3a2aa9a7b7a8e3$var$$min = Math.min;
var $7c3a2aa9a7b7a8e3$var$$push = [].push;
var $7c3a2aa9a7b7a8e3$var$$SPLIT = 'split';
var $7c3a2aa9a7b7a8e3$var$LENGTH = 'length';
var $7c3a2aa9a7b7a8e3$var$LAST_INDEX = 'lastIndex';
var $7c3a2aa9a7b7a8e3$var$MAX_UINT32 = 0xffffffff;
// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var $7c3a2aa9a7b7a8e3$var$SUPPORTS_Y = !$d6gmi(function() {
    RegExp($7c3a2aa9a7b7a8e3$var$MAX_UINT32, 'y');
});

// @@split logic
(parcelRequire("706FM"))('split', 2, function(defined, SPLIT, $split, maybeCallNative) {
    var internalSplit;
    if ('abbc'[$7c3a2aa9a7b7a8e3$var$$SPLIT](/(b)*/)[1] == 'c' || 'test'[$7c3a2aa9a7b7a8e3$var$$SPLIT](/(?:)/, -1)[$7c3a2aa9a7b7a8e3$var$LENGTH] != 4 || 'ab'[$7c3a2aa9a7b7a8e3$var$$SPLIT](/(?:ab)*/)[$7c3a2aa9a7b7a8e3$var$LENGTH] != 2 || '.'[$7c3a2aa9a7b7a8e3$var$$SPLIT](/(.?)(.?)/)[$7c3a2aa9a7b7a8e3$var$LENGTH] != 4 || '.'[$7c3a2aa9a7b7a8e3$var$$SPLIT](/()()/)[$7c3a2aa9a7b7a8e3$var$LENGTH] > 1 || ''[$7c3a2aa9a7b7a8e3$var$$SPLIT](/.?/)[$7c3a2aa9a7b7a8e3$var$LENGTH]) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = String(this);
        if (separator === undefined && limit === 0) return [];
        // If `separator` is not a regex, use native split
        if (!$9265c81d0366ca25$exports(separator)) return $split.call(string, separator, limit);
        var output = [];
        var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
        var lastLastIndex = 0;
        var splitLimit = limit === undefined ? $7c3a2aa9a7b7a8e3$var$MAX_UINT32 : limit >>> 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + 'g');
        var match, lastIndex, lastLength;
        while(match = $fn7Kz.call(separatorCopy, string)){
            lastIndex = separatorCopy[$7c3a2aa9a7b7a8e3$var$LAST_INDEX];
            if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index));
                if (match[$7c3a2aa9a7b7a8e3$var$LENGTH] > 1 && match.index < string[$7c3a2aa9a7b7a8e3$var$LENGTH]) $7c3a2aa9a7b7a8e3$var$$push.apply(output, match.slice(1));
                lastLength = match[0][$7c3a2aa9a7b7a8e3$var$LENGTH];
                lastLastIndex = lastIndex;
                if (output[$7c3a2aa9a7b7a8e3$var$LENGTH] >= splitLimit) break;
            }
            if (separatorCopy[$7c3a2aa9a7b7a8e3$var$LAST_INDEX] === match.index) separatorCopy[$7c3a2aa9a7b7a8e3$var$LAST_INDEX]++; // Avoid an infinite loop
        }
        if (lastLastIndex === string[$7c3a2aa9a7b7a8e3$var$LENGTH]) {
            if (lastLength || !separatorCopy.test('')) output.push('');
        } else output.push(string.slice(lastLastIndex));
        return output[$7c3a2aa9a7b7a8e3$var$LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
    else if ('0'[$7c3a2aa9a7b7a8e3$var$$SPLIT](undefined, 0)[$7c3a2aa9a7b7a8e3$var$LENGTH]) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
    else internalSplit = $split;
    return [
        // `String.prototype.split` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = defined(this);
            var splitter = separator == undefined ? undefined : separator[SPLIT];
            return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(regexp, limit) {
            var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
            if (res.done) return res.value;
            var rx = $9bg2N(regexp);
            var S = String(this);
            var C = $kubSZ(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + ($7c3a2aa9a7b7a8e3$var$SUPPORTS_Y ? 'y' : 'g');
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($7c3a2aa9a7b7a8e3$var$SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
            var lim = limit === undefined ? $7c3a2aa9a7b7a8e3$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $965d4a36aabedfbc$exports(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $7c3a2aa9a7b7a8e3$var$SUPPORTS_Y ? q : 0;
                var z = $965d4a36aabedfbc$exports(splitter, $7c3a2aa9a7b7a8e3$var$SUPPORTS_Y ? S : S.slice(q));
                var e;
                if (z === null || (e = $7c3a2aa9a7b7a8e3$var$$min($75R4e(splitter.lastIndex + ($7c3a2aa9a7b7a8e3$var$SUPPORTS_Y ? 0 : q)), S.length)) === p) q = $26b7acb89f4d1c74$exports(S, q, unicodeMatching);
                else {
                    A.push(S.slice(p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        A.push(z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            A.push(S.slice(p));
            return A;
        }
    ];
});


'use strict';

var $6VDEP = parcelRequire("6VDEP");

var $cUEwJ = parcelRequire("cUEwJ");

var $i2qD6 = parcelRequire("i2qD6");

var $d4Dmo = parcelRequire("d4Dmo");

var $7UCsS = parcelRequire("7UCsS");

var $5ehF7 = parcelRequire("5ehF7");

var $ekEf9 = parcelRequire("ekEf9");

var $eEs8C = parcelRequire("eEs8C");

var $2b8La = parcelRequire("2b8La");

var $kubSZ = parcelRequire("kubSZ");

var $b4G1J = parcelRequire("b4G1J");
var $bfd36ff4af13c176$require$task = $b4G1J.set;

var $bfd36ff4af13c176$var$microtask = (parcelRequire("4Je1X"))();
var $cd72c2e7e6a2be3e$exports = {};
$parcel$export($cd72c2e7e6a2be3e$exports, "f", () => $cd72c2e7e6a2be3e$export$2d1720544b23b823, (v) => $cd72c2e7e6a2be3e$export$2d1720544b23b823 = v);
var $cd72c2e7e6a2be3e$export$2d1720544b23b823;
'use strict';

var $ekEf9 = parcelRequire("ekEf9");
function $cd72c2e7e6a2be3e$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $ekEf9(resolve);
    this.reject = $ekEf9(reject);
}
$cd72c2e7e6a2be3e$export$2d1720544b23b823 = function(C) {
    return new $cd72c2e7e6a2be3e$var$PromiseCapability(C);
};


var $c22e88e9d64ad73e$exports = {};
$c22e88e9d64ad73e$exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};


var $ac95f7e5c8150107$exports = {};

var $cUEwJ = parcelRequire("cUEwJ");
var $ac95f7e5c8150107$var$navigator = $cUEwJ.navigator;
$ac95f7e5c8150107$exports = $ac95f7e5c8150107$var$navigator && $ac95f7e5c8150107$var$navigator.userAgent || '';


var $74ec2602d9f7bc46$exports = {};

var $9bg2N = parcelRequire("9bg2N");

var $5ehF7 = parcelRequire("5ehF7");

$74ec2602d9f7bc46$exports = function(C, x) {
    $9bg2N(C);
    if ($5ehF7(x) && x.constructor === C) return x;
    var promiseCapability = $cd72c2e7e6a2be3e$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $bfd36ff4af13c176$var$PROMISE = 'Promise';
var $bfd36ff4af13c176$var$TypeError = $cUEwJ.TypeError;
var $bfd36ff4af13c176$var$process = $cUEwJ.process;
var $bfd36ff4af13c176$var$versions = $bfd36ff4af13c176$var$process && $bfd36ff4af13c176$var$process.versions;
var $bfd36ff4af13c176$var$v8 = $bfd36ff4af13c176$var$versions && $bfd36ff4af13c176$var$versions.v8 || '';
var $bfd36ff4af13c176$var$$Promise = $cUEwJ[$bfd36ff4af13c176$var$PROMISE];
var $bfd36ff4af13c176$var$isNode = $d4Dmo($bfd36ff4af13c176$var$process) == 'process';
var $bfd36ff4af13c176$var$empty = function() {};
var $bfd36ff4af13c176$var$Internal, $bfd36ff4af13c176$var$newGenericPromiseCapability, $bfd36ff4af13c176$var$OwnPromiseCapability, $bfd36ff4af13c176$var$Wrapper;
var $bfd36ff4af13c176$var$newPromiseCapability = $bfd36ff4af13c176$var$newGenericPromiseCapability = $cd72c2e7e6a2be3e$export$2d1720544b23b823;

var $bfd36ff4af13c176$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $bfd36ff4af13c176$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("5zj8I"))('species')] = function(exec) {
            exec($bfd36ff4af13c176$var$empty, $bfd36ff4af13c176$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($bfd36ff4af13c176$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($bfd36ff4af13c176$var$empty) instanceof FakePromise && $bfd36ff4af13c176$var$v8.indexOf('6.6') !== 0 && $ac95f7e5c8150107$exports.indexOf('Chrome/66') === -1;
    } catch (e) {}
}();
// helpers
var $bfd36ff4af13c176$var$isThenable = function(it) {
    var then;
    return $5ehF7(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $bfd36ff4af13c176$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $bfd36ff4af13c176$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $bfd36ff4af13c176$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($bfd36ff4af13c176$var$TypeError('Promise-chain cycle'));
                    else if (then = $bfd36ff4af13c176$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $bfd36ff4af13c176$var$onUnhandled(promise);
    });
};
var $bfd36ff4af13c176$var$onUnhandled = function(promise) {
    $bfd36ff4af13c176$require$task.call($cUEwJ, function() {
        var value = promise._v;
        var unhandled = $bfd36ff4af13c176$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $c22e88e9d64ad73e$exports(function() {
                if ($bfd36ff4af13c176$var$isNode) $bfd36ff4af13c176$var$process.emit('unhandledRejection', value, promise);
                else if (handler = $cUEwJ.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $cUEwJ.console) && console.error) console.error('Unhandled promise rejection', value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $bfd36ff4af13c176$var$isNode || $bfd36ff4af13c176$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $bfd36ff4af13c176$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $bfd36ff4af13c176$var$onHandleUnhandled = function(promise) {
    $bfd36ff4af13c176$require$task.call($cUEwJ, function() {
        var handler;
        if ($bfd36ff4af13c176$var$isNode) $bfd36ff4af13c176$var$process.emit('rejectionHandled', promise);
        else if (handler = $cUEwJ.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $bfd36ff4af13c176$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $bfd36ff4af13c176$var$notify(promise, true);
};
var $bfd36ff4af13c176$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $bfd36ff4af13c176$var$TypeError("Promise can't be resolved itself");
        if (then = $bfd36ff4af13c176$var$isThenable(value)) $bfd36ff4af13c176$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $i2qD6($bfd36ff4af13c176$var$$resolve, wrapper, 1), $i2qD6($bfd36ff4af13c176$var$$reject, wrapper, 1));
            } catch (e) {
                $bfd36ff4af13c176$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $bfd36ff4af13c176$var$notify(promise, false);
        }
    } catch (e) {
        $bfd36ff4af13c176$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$bfd36ff4af13c176$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $bfd36ff4af13c176$var$$Promise = function Promise(executor) {
        $eEs8C(this, $bfd36ff4af13c176$var$$Promise, $bfd36ff4af13c176$var$PROMISE, '_h');
        $ekEf9(executor);
        $bfd36ff4af13c176$var$Internal.call(this);
        try {
            executor($i2qD6($bfd36ff4af13c176$var$$resolve, this, 1), $i2qD6($bfd36ff4af13c176$var$$reject, this, 1));
        } catch (err) {
            $bfd36ff4af13c176$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $bfd36ff4af13c176$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $bfd36ff4af13c176$var$Internal.prototype = (parcelRequire("edFiS"))($bfd36ff4af13c176$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $bfd36ff4af13c176$var$newPromiseCapability($kubSZ(this, $bfd36ff4af13c176$var$$Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $bfd36ff4af13c176$var$isNode ? $bfd36ff4af13c176$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $bfd36ff4af13c176$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $bfd36ff4af13c176$var$OwnPromiseCapability = function() {
        var promise = new $bfd36ff4af13c176$var$Internal();
        this.promise = promise;
        this.resolve = $i2qD6($bfd36ff4af13c176$var$$resolve, promise, 1);
        this.reject = $i2qD6($bfd36ff4af13c176$var$$reject, promise, 1);
    };
    $cd72c2e7e6a2be3e$exports.f = $bfd36ff4af13c176$var$newPromiseCapability = function(C) {
        return C === $bfd36ff4af13c176$var$$Promise || C === $bfd36ff4af13c176$var$Wrapper ? new $bfd36ff4af13c176$var$OwnPromiseCapability(C) : $bfd36ff4af13c176$var$newGenericPromiseCapability(C);
    };
}
$7UCsS($7UCsS.G + $7UCsS.W + $7UCsS.F * !$bfd36ff4af13c176$var$USE_NATIVE, {
    Promise: $bfd36ff4af13c176$var$$Promise
});

(parcelRequire("5MNda"))($bfd36ff4af13c176$var$$Promise, $bfd36ff4af13c176$var$PROMISE);

(parcelRequire("7hk0b"))($bfd36ff4af13c176$var$PROMISE);

$bfd36ff4af13c176$var$Wrapper = (parcelRequire("ktrQW"))[$bfd36ff4af13c176$var$PROMISE];
// statics
$7UCsS($7UCsS.S + $7UCsS.F * !$bfd36ff4af13c176$var$USE_NATIVE, $bfd36ff4af13c176$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $bfd36ff4af13c176$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$7UCsS($7UCsS.S + $7UCsS.F * ($6VDEP || !$bfd36ff4af13c176$var$USE_NATIVE), $bfd36ff4af13c176$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $74ec2602d9f7bc46$exports($6VDEP && this === $bfd36ff4af13c176$var$Wrapper ? $bfd36ff4af13c176$var$$Promise : this, x);
    }
});

$7UCsS($7UCsS.S + $7UCsS.F * !($bfd36ff4af13c176$var$USE_NATIVE && (parcelRequire("3YVTs"))(function(iter) {
    $bfd36ff4af13c176$var$$Promise.all(iter)['catch']($bfd36ff4af13c176$var$empty);
})), $bfd36ff4af13c176$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $bfd36ff4af13c176$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $c22e88e9d64ad73e$exports(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $2b8La(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $bfd36ff4af13c176$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $c22e88e9d64ad73e$exports(function() {
            $2b8La(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});


var $22bf39feac6c91d1$exports = {};
'use strict';
var $bd6afd60c987e787$exports = {};
'use strict';

var $1w421 = parcelRequire("1w421");
var $bd6afd60c987e787$require$dP = $1w421.f;

var $9hnGd = parcelRequire("9hnGd");

var $edFiS = parcelRequire("edFiS");

var $i2qD6 = parcelRequire("i2qD6");

var $eEs8C = parcelRequire("eEs8C");

var $2b8La = parcelRequire("2b8La");

var $d5llS = parcelRequire("d5llS");

var $kRzZI = parcelRequire("kRzZI");

var $7hk0b = parcelRequire("7hk0b");

var $gvp2l = parcelRequire("gvp2l");

var $7p9t8 = parcelRequire("7p9t8");
var $bd6afd60c987e787$require$fastKey = $7p9t8.fastKey;

var $i8KhX = parcelRequire("i8KhX");
var $bd6afd60c987e787$var$SIZE = $gvp2l ? '_s' : 'size';
var $bd6afd60c987e787$var$getEntry = function(that, key) {
    // fast case
    var index = $bd6afd60c987e787$require$fastKey(key);
    var entry;
    if (index !== 'F') return that._i[index];
    // frozen object case
    for(entry = that._f; entry; entry = entry.n){
        if (entry.k == key) return entry;
    }
};
$bd6afd60c987e787$exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $eEs8C(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $9hnGd(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[$bd6afd60c987e787$var$SIZE] = 0; // size
            if (iterable != undefined) $2b8La(iterable, IS_MAP, that[ADDER], that);
        });
        $edFiS(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
                for(var that = $i8KhX(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n){
                    entry.r = true;
                    if (entry.p) entry.p = entry.p.n = undefined;
                    delete data[entry.i];
                }
                that._f = that._l = undefined;
                that[$bd6afd60c987e787$var$SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            'delete': function(key) {
                var that = $i8KhX(this, NAME);
                var entry = $bd6afd60c987e787$var$getEntry(that, key);
                if (entry) {
                    var next = entry.n;
                    var prev = entry.p;
                    delete that._i[entry.i];
                    entry.r = true;
                    if (prev) prev.n = next;
                    if (next) next.p = prev;
                    if (that._f == entry) that._f = next;
                    if (that._l == entry) that._l = prev;
                    that[$bd6afd60c987e787$var$SIZE]--;
                }
                return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                $i8KhX(this, NAME);
                var f = $i2qD6(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                var entry;
                while(entry = entry ? entry.n : this._f){
                    f(entry.v, entry.k, this);
                    // revert to the last existing entry
                    while(entry && entry.r)entry = entry.p;
                }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
                return !!$bd6afd60c987e787$var$getEntry($i8KhX(this, NAME), key);
            }
        });
        if ($gvp2l) $bd6afd60c987e787$require$dP(C.prototype, 'size', {
            get: function() {
                return $i8KhX(this, NAME)[$bd6afd60c987e787$var$SIZE];
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var entry = $bd6afd60c987e787$var$getEntry(that, key);
        var prev, index;
        // change existing entry
        if (entry) entry.v = value;
        else {
            that._l = entry = {
                i: index = $bd6afd60c987e787$require$fastKey(key, true),
                k: key,
                v: value,
                p: prev = that._l,
                n: undefined,
                r: false // <- removed
            };
            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[$bd6afd60c987e787$var$SIZE]++;
            // add to index
            if (index !== 'F') that._i[index] = entry;
        }
        return that;
    },
    getEntry: $bd6afd60c987e787$var$getEntry,
    setStrong: function(C, NAME, IS_MAP) {
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        $d5llS(C, NAME, function(iterated, kind) {
            this._t = $i8KhX(iterated, NAME); // target
            this._k = kind; // kind
            this._l = undefined; // previous
        }, function() {
            var that = this;
            var kind = that._k;
            var entry = that._l;
            // revert to the last existing entry
            while(entry && entry.r)entry = entry.p;
            // get next entry
            if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return $kRzZI(1);
            }
            // return step by kind
            if (kind == 'keys') return $kRzZI(0, entry.k);
            if (kind == 'values') return $kRzZI(0, entry.v);
            return $kRzZI(0, [
                entry.k,
                entry.v
            ]);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // add [@@species], 23.1.2.2, 23.2.2.2
        $7hk0b(NAME);
    }
};



var $i8KhX = parcelRequire("i8KhX");
var $22bf39feac6c91d1$var$MAP = 'Map';

// 23.1 Map Objects
$22bf39feac6c91d1$exports = (parcelRequire("infE6"))($22bf39feac6c91d1$var$MAP, function(get) {
    return function Map() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key) {
        var entry = $bd6afd60c987e787$exports.getEntry($i8KhX(this, $22bf39feac6c91d1$var$MAP), key);
        return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value) {
        return $bd6afd60c987e787$exports.def($i8KhX(this, $22bf39feac6c91d1$var$MAP), key === 0 ? 0 : key, value);
    }
}, $bd6afd60c987e787$exports, true);


var $322928a304bc3819$exports = {};
'use strict';


var $i8KhX = parcelRequire("i8KhX");
var $322928a304bc3819$var$SET = 'Set';

// 23.2 Set Objects
$322928a304bc3819$exports = (parcelRequire("infE6"))($322928a304bc3819$var$SET, function(get) {
    return function Set() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.2.3.1 Set.prototype.add(value)
    add: function add(value) {
        return $bd6afd60c987e787$exports.def($i8KhX(this, $322928a304bc3819$var$SET), value = value === 0 ? 0 : value, value);
    }
}, $bd6afd60c987e787$exports);


parcelRequire("fvN4d");
'use strict';

var $4TFbT = parcelRequire("4TFbT");

var $i8KhX = parcelRequire("i8KhX");
var $9ce8df8e0b91aef0$var$WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
(parcelRequire("infE6"))($9ce8df8e0b91aef0$var$WEAK_SET, function(get) {
    return function WeakSet() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.4.3.1 WeakSet.prototype.add(value)
    add: function add(value) {
        return $4TFbT.def($i8KhX(this, $9ce8df8e0b91aef0$var$WEAK_SET), value, true);
    }
}, $4TFbT, false, true);


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $7W5f9 = parcelRequire("7W5f9");

var $lFMTj = parcelRequire("lFMTj");

var $9bg2N = parcelRequire("9bg2N");

var $ktL0p = parcelRequire("ktL0p");

var $75R4e = parcelRequire("75R4e");

var $5ehF7 = parcelRequire("5ehF7");

var $cUEwJ = parcelRequire("cUEwJ");
var $13fa5e1d870d1a29$require$ArrayBuffer = $cUEwJ.ArrayBuffer;

var $kubSZ = parcelRequire("kubSZ");
var $13fa5e1d870d1a29$var$$ArrayBuffer = $lFMTj.ArrayBuffer;
var $13fa5e1d870d1a29$var$$DataView = $lFMTj.DataView;
var $13fa5e1d870d1a29$var$$isView = $7W5f9.ABV && $13fa5e1d870d1a29$require$ArrayBuffer.isView;
var $13fa5e1d870d1a29$var$$slice = $13fa5e1d870d1a29$var$$ArrayBuffer.prototype.slice;
var $13fa5e1d870d1a29$var$VIEW = $7W5f9.VIEW;
var $13fa5e1d870d1a29$var$ARRAY_BUFFER = 'ArrayBuffer';
$7UCsS($7UCsS.G + $7UCsS.W + $7UCsS.F * ($13fa5e1d870d1a29$require$ArrayBuffer !== $13fa5e1d870d1a29$var$$ArrayBuffer), {
    ArrayBuffer: $13fa5e1d870d1a29$var$$ArrayBuffer
});
$7UCsS($7UCsS.S + $7UCsS.F * !$7W5f9.CONSTR, $13fa5e1d870d1a29$var$ARRAY_BUFFER, {
    // 24.1.3.1 ArrayBuffer.isView(arg)
    isView: function isView(it) {
        return $13fa5e1d870d1a29$var$$isView && $13fa5e1d870d1a29$var$$isView(it) || $5ehF7(it) && $13fa5e1d870d1a29$var$VIEW in it;
    }
});

$7UCsS($7UCsS.P + $7UCsS.U + $7UCsS.F * (parcelRequire("d6gmi"))(function() {
    return !new $13fa5e1d870d1a29$var$$ArrayBuffer(2).slice(1, undefined).byteLength;
}), $13fa5e1d870d1a29$var$ARRAY_BUFFER, {
    // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
    slice: function slice(start, end) {
        if ($13fa5e1d870d1a29$var$$slice !== undefined && end === undefined) return $13fa5e1d870d1a29$var$$slice.call($9bg2N(this), start); // FF fix
        var len = $9bg2N(this).byteLength;
        var first = $ktL0p(start, len);
        var fin = $ktL0p(end === undefined ? len : end, len);
        var result = new ($kubSZ(this, $13fa5e1d870d1a29$var$$ArrayBuffer))($75R4e(fin - first));
        var viewS = new $13fa5e1d870d1a29$var$$DataView(this);
        var viewT = new $13fa5e1d870d1a29$var$$DataView(result);
        var index = 0;
        while(first < fin)viewT.setUint8(index++, viewS.getUint8(first++));
        return result;
    }
});

(parcelRequire("7hk0b"))($13fa5e1d870d1a29$var$ARRAY_BUFFER);



var $7UCsS = parcelRequire("7UCsS");


$7UCsS($7UCsS.G + $7UCsS.W + $7UCsS.F * !(parcelRequire("7W5f9")).ABV, {
    DataView: (parcelRequire("lFMTj")).DataView
});



(parcelRequire("aFUiK"))('Int8', 1, function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("aFUiK"))('Uint8', 1, function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("aFUiK"))('Uint8', 1, function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);



(parcelRequire("aFUiK"))('Int16', 2, function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("aFUiK"))('Uint16', 2, function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("aFUiK"))('Int32', 4, function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("aFUiK"))('Uint32', 4, function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("aFUiK"))('Float32', 4, function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("aFUiK"))('Float64', 8, function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)

var $7UCsS = parcelRequire("7UCsS");

var $ekEf9 = parcelRequire("ekEf9");

var $9bg2N = parcelRequire("9bg2N");

var $5196b7ae1596470c$var$rApply = ((parcelRequire("cUEwJ")).Reflect || {}).apply;
var $5196b7ae1596470c$var$fApply = Function.apply;

// MS Edge argumentsList argument is optional
$7UCsS($7UCsS.S + $7UCsS.F * !(parcelRequire("d6gmi"))(function() {
    $5196b7ae1596470c$var$rApply(function() {});
}), 'Reflect', {
    apply: function apply(target, thisArgument, argumentsList) {
        var T = $ekEf9(target);
        var L = $9bg2N(argumentsList);
        return $5196b7ae1596470c$var$rApply ? $5196b7ae1596470c$var$rApply(T, thisArgument, L) : $5196b7ae1596470c$var$fApply.call(T, thisArgument, L);
    }
});


// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])

var $7UCsS = parcelRequire("7UCsS");

var $9hnGd = parcelRequire("9hnGd");

var $ekEf9 = parcelRequire("ekEf9");

var $9bg2N = parcelRequire("9bg2N");

var $5ehF7 = parcelRequire("5ehF7");

var $d6gmi = parcelRequire("d6gmi");

var $1iNAj = parcelRequire("1iNAj");

var $8695850558648143$var$rConstruct = ((parcelRequire("cUEwJ")).Reflect || {}).construct;
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $8695850558648143$var$NEW_TARGET_BUG = $d6gmi(function() {
    function F() {}
    return !($8695850558648143$var$rConstruct(function() {}, [], F) instanceof F);
});
var $8695850558648143$var$ARGS_BUG = !$d6gmi(function() {
    $8695850558648143$var$rConstruct(function() {});
});
$7UCsS($7UCsS.S + $7UCsS.F * ($8695850558648143$var$NEW_TARGET_BUG || $8695850558648143$var$ARGS_BUG), 'Reflect', {
    construct: function construct(Target, args /* , newTarget */ ) {
        $ekEf9(Target);
        $9bg2N(args);
        var newTarget = arguments.length < 3 ? Target : $ekEf9(arguments[2]);
        if ($8695850558648143$var$ARGS_BUG && !$8695850558648143$var$NEW_TARGET_BUG) return $8695850558648143$var$rConstruct(Target, args, newTarget);
        if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $args.push.apply($args, args);
            return new ($1iNAj.apply(Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $9hnGd($5ehF7(proto) ? proto : Object.prototype);
        var result = Function.apply.call(Target, instance, args);
        return $5ehF7(result) ? result : instance;
    }
});


// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)

var $1w421 = parcelRequire("1w421");

var $7UCsS = parcelRequire("7UCsS");

var $9bg2N = parcelRequire("9bg2N");

var $hFD9L = parcelRequire("hFD9L");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$7UCsS($7UCsS.S + $7UCsS.F * (parcelRequire("d6gmi"))(function() {
    // eslint-disable-next-line no-undef
    Reflect.defineProperty($1w421.f({}, 1, {
        value: 1
    }), 1, {
        value: 2
    });
}), 'Reflect', {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
        $9bg2N(target);
        propertyKey = $hFD9L(propertyKey, true);
        $9bg2N(attributes);
        try {
            $1w421.f(target, propertyKey, attributes);
            return true;
        } catch (e) {
            return false;
        }
    }
});


// 26.1.4 Reflect.deleteProperty(target, propertyKey)

var $7UCsS = parcelRequire("7UCsS");

var $clqre = parcelRequire("clqre");
var $add725996f290a78$require$gOPD = $clqre.f;

var $9bg2N = parcelRequire("9bg2N");
$7UCsS($7UCsS.S, 'Reflect', {
    deleteProperty: function deleteProperty(target, propertyKey) {
        var desc = $add725996f290a78$require$gOPD($9bg2N(target), propertyKey);
        return desc && !desc.configurable ? false : delete target[propertyKey];
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $9bg2N = parcelRequire("9bg2N");
var $bbf5ab810069ea0b$var$Enumerate = function(iterated) {
    this._t = $9bg2N(iterated); // target
    this._i = 0; // next index
    var keys = this._k = []; // keys
    var key;
    for(key in iterated)keys.push(key);
};

(parcelRequire("k6qlJ"))($bbf5ab810069ea0b$var$Enumerate, 'Object', function() {
    var that = this;
    var keys = that._k;
    var key;
    do {
        if (that._i >= keys.length) return {
            value: undefined,
            done: true
        };
    }while (!((key = keys[that._i++]) in that._t));
    return {
        value: key,
        done: false
    };
});
$7UCsS($7UCsS.S, 'Reflect', {
    enumerate: function enumerate(target) {
        return new $bbf5ab810069ea0b$var$Enumerate(target);
    }
});


// 26.1.6 Reflect.get(target, propertyKey [, receiver])

var $clqre = parcelRequire("clqre");

var $hQ3EZ = parcelRequire("hQ3EZ");

var $i9PqC = parcelRequire("i9PqC");

var $7UCsS = parcelRequire("7UCsS");

var $5ehF7 = parcelRequire("5ehF7");

var $9bg2N = parcelRequire("9bg2N");
function $f2c5483f4096a2f4$var$get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var desc, proto;
    if ($9bg2N(target) === receiver) return target[propertyKey];
    if (desc = $clqre.f(target, propertyKey)) return $i9PqC(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
    if ($5ehF7(proto = $hQ3EZ(target))) return $f2c5483f4096a2f4$var$get(proto, propertyKey, receiver);
}
$7UCsS($7UCsS.S, 'Reflect', {
    get: $f2c5483f4096a2f4$var$get
});


// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)

var $clqre = parcelRequire("clqre");

var $7UCsS = parcelRequire("7UCsS");

var $9bg2N = parcelRequire("9bg2N");
$7UCsS($7UCsS.S, 'Reflect', {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return $clqre.f($9bg2N(target), propertyKey);
    }
});


// 26.1.8 Reflect.getPrototypeOf(target)

var $7UCsS = parcelRequire("7UCsS");

var $hQ3EZ = parcelRequire("hQ3EZ");

var $9bg2N = parcelRequire("9bg2N");
$7UCsS($7UCsS.S, 'Reflect', {
    getPrototypeOf: function getPrototypeOf(target) {
        return $hQ3EZ($9bg2N(target));
    }
});


// 26.1.9 Reflect.has(target, propertyKey)

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Reflect', {
    has: function has(target, propertyKey) {
        return propertyKey in target;
    }
});


// 26.1.10 Reflect.isExtensible(target)

var $7UCsS = parcelRequire("7UCsS");

var $9bg2N = parcelRequire("9bg2N");
var $c56fd6daa623e95f$var$$isExtensible = Object.isExtensible;
$7UCsS($7UCsS.S, 'Reflect', {
    isExtensible: function isExtensible(target) {
        $9bg2N(target);
        return $c56fd6daa623e95f$var$$isExtensible ? $c56fd6daa623e95f$var$$isExtensible(target) : true;
    }
});


// 26.1.11 Reflect.ownKeys(target)

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S, 'Reflect', {
    ownKeys: (parcelRequire("1KRuL"))
});


// 26.1.12 Reflect.preventExtensions(target)

var $7UCsS = parcelRequire("7UCsS");

var $9bg2N = parcelRequire("9bg2N");
var $1cf148e64c5ca5cc$var$$preventExtensions = Object.preventExtensions;
$7UCsS($7UCsS.S, 'Reflect', {
    preventExtensions: function preventExtensions(target) {
        $9bg2N(target);
        try {
            if ($1cf148e64c5ca5cc$var$$preventExtensions) $1cf148e64c5ca5cc$var$$preventExtensions(target);
            return true;
        } catch (e) {
            return false;
        }
    }
});


// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])

var $1w421 = parcelRequire("1w421");

var $clqre = parcelRequire("clqre");

var $hQ3EZ = parcelRequire("hQ3EZ");

var $i9PqC = parcelRequire("i9PqC");

var $7UCsS = parcelRequire("7UCsS");

var $jPGz2 = parcelRequire("jPGz2");

var $9bg2N = parcelRequire("9bg2N");

var $5ehF7 = parcelRequire("5ehF7");
function $b275f73aef31293d$var$set(target, propertyKey, V /* , receiver */ ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDesc = $clqre.f($9bg2N(target), propertyKey);
    var existingDescriptor, proto;
    if (!ownDesc) {
        if ($5ehF7(proto = $hQ3EZ(target))) return $b275f73aef31293d$var$set(proto, propertyKey, V, receiver);
        ownDesc = $jPGz2(0);
    }
    if ($i9PqC(ownDesc, 'value')) {
        if (ownDesc.writable === false || !$5ehF7(receiver)) return false;
        if (existingDescriptor = $clqre.f(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            $1w421.f(receiver, propertyKey, existingDescriptor);
        } else $1w421.f(receiver, propertyKey, $jPGz2(0, V));
        return true;
    }
    return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}
$7UCsS($7UCsS.S, 'Reflect', {
    set: $b275f73aef31293d$var$set
});


// 26.1.14 Reflect.setPrototypeOf(target, proto)

var $7UCsS = parcelRequire("7UCsS");

var $gALmc = parcelRequire("gALmc");
if ($gALmc) $7UCsS($7UCsS.S, 'Reflect', {
    setPrototypeOf: function setPrototypeOf(target, proto) {
        $gALmc.check(target, proto);
        try {
            $gALmc.set(target, proto);
            return true;
        } catch (e) {
            return false;
        }
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $302a13b258de5676$var$$includes = (parcelRequire("i2jbf"))(true);
$7UCsS($7UCsS.P, 'Array', {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $302a13b258de5676$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("kz0tg"))('includes');


'use strict';

var $7UCsS = parcelRequire("7UCsS");
var $78c595d7765c3564$exports = {};
'use strict';

var $8D3Ey = parcelRequire("8D3Ey");

var $5ehF7 = parcelRequire("5ehF7");

var $75R4e = parcelRequire("75R4e");

var $i2qD6 = parcelRequire("i2qD6");

var $78c595d7765c3564$var$IS_CONCAT_SPREADABLE = (parcelRequire("5zj8I"))('isConcatSpreadable');
function $78c595d7765c3564$var$flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $i2qD6(mapper, thisArg, 3) : false;
    var element, spreadable;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            spreadable = false;
            if ($5ehF7(element)) {
                spreadable = element[$78c595d7765c3564$var$IS_CONCAT_SPREADABLE];
                spreadable = spreadable !== undefined ? !!spreadable : $8D3Ey(element);
            }
            if (spreadable && depth > 0) targetIndex = $78c595d7765c3564$var$flattenIntoArray(target, original, element, $75R4e(element.length), targetIndex, depth - 1) - 1;
            else {
                if (targetIndex >= 0x1fffffffffffff) throw TypeError();
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
}
$78c595d7765c3564$exports = $78c595d7765c3564$var$flattenIntoArray;



var $87N8x = parcelRequire("87N8x");

var $75R4e = parcelRequire("75R4e");

var $ekEf9 = parcelRequire("ekEf9");

var $k7f9c = parcelRequire("k7f9c");
$7UCsS($7UCsS.P, 'Array', {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $87N8x(this);
        var sourceLen, A;
        $ekEf9(callbackfn);
        sourceLen = $75R4e(O.length);
        A = $k7f9c(O, 0);
        $78c595d7765c3564$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
        return A;
    }
});

(parcelRequire("kz0tg"))('flatMap');


'use strict';

var $7UCsS = parcelRequire("7UCsS");


var $87N8x = parcelRequire("87N8x");

var $75R4e = parcelRequire("75R4e");

var $lelYU = parcelRequire("lelYU");

var $k7f9c = parcelRequire("k7f9c");
$7UCsS($7UCsS.P, 'Array', {
    flatten: function flatten() {
        var depthArg = arguments[0];
        var O = $87N8x(this);
        var sourceLen = $75R4e(O.length);
        var A = $k7f9c(O, 0);
        $78c595d7765c3564$exports(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : $lelYU(depthArg));
        return A;
    }
});

(parcelRequire("kz0tg"))('flatten');


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $9707eae9723755be$var$$at = (parcelRequire("9yOH3"))(true);

var $d6gmi = parcelRequire("d6gmi");
var $9707eae9723755be$var$FORCED = $d6gmi(function() {
    return "\uD842\uDFB7".at(0) !== "\uD842\uDFB7";
});
$7UCsS($7UCsS.P + $7UCsS.F * $9707eae9723755be$var$FORCED, 'String', {
    at: function at(pos) {
        return $9707eae9723755be$var$$at(this, pos);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");
var $91644e134a0b40d3$exports = {};
// https://github.com/tc39/proposal-string-pad-start-end

var $75R4e = parcelRequire("75R4e");

var $bvdTC = parcelRequire("bvdTC");

var $1esYK = parcelRequire("1esYK");
$91644e134a0b40d3$exports = function(that, maxLength, fillString, left) {
    var S = String($1esYK(that));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = $75R4e(maxLength);
    if (intMaxLength <= stringLength || fillStr == '') return S;
    var fillLen = intMaxLength - stringLength;
    var stringFiller = $bvdTC.call(fillStr, Math.ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return left ? stringFiller + S : S + stringFiller;
};



// https://github.com/zloirock/core-js/issues/280
var $9b033339b1a64132$var$WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test($ac95f7e5c8150107$exports);
$7UCsS($7UCsS.P + $7UCsS.F * $9b033339b1a64132$var$WEBKIT_BUG, 'String', {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $91644e134a0b40d3$exports(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");


// https://github.com/zloirock/core-js/issues/280
var $321e5fd3c32b5091$var$WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test($ac95f7e5c8150107$exports);
$7UCsS($7UCsS.P + $7UCsS.F * $321e5fd3c32b5091$var$WEBKIT_BUG, 'String', {
    padEnd: function padEnd(maxLength /* , fillString = ' ' */ ) {
        return $91644e134a0b40d3$exports(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
    }
});


'use strict';

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
(parcelRequire("3JQ2K"))('trimLeft', function($trim) {
    return function trimLeft() {
        return $trim(this, 1);
    };
}, 'trimStart');


'use strict';

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
(parcelRequire("3JQ2K"))('trimRight', function($trim) {
    return function trimRight() {
        return $trim(this, 2);
    };
}, 'trimEnd');


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $1esYK = parcelRequire("1esYK");

var $75R4e = parcelRequire("75R4e");


var $lzkzv = parcelRequire("lzkzv");
var $a66bd2904a671208$var$RegExpProto = RegExp.prototype;
var $a66bd2904a671208$var$$RegExpStringIterator = function(regexp, string) {
    this._r = regexp;
    this._s = string;
};

(parcelRequire("k6qlJ"))($a66bd2904a671208$var$$RegExpStringIterator, 'RegExp String', function next() {
    var match = this._r.exec(this._s);
    return {
        value: match,
        done: match === null
    };
});
$7UCsS($7UCsS.P, 'String', {
    matchAll: function matchAll(regexp) {
        $1esYK(this);
        if (!$9265c81d0366ca25$exports(regexp)) throw TypeError(regexp + ' is not a regexp!');
        var S = String(this);
        var flags = 'flags' in $a66bd2904a671208$var$RegExpProto ? String(regexp.flags) : $lzkzv.call(regexp);
        var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
        rx.lastIndex = $75R4e(regexp.lastIndex);
        return new $a66bd2904a671208$var$$RegExpStringIterator(rx, S);
    }
});



(parcelRequire("29gH0"))('asyncIterator');



(parcelRequire("29gH0"))('observable');


// https://github.com/tc39/proposal-object-getownpropertydescriptors

var $7UCsS = parcelRequire("7UCsS");

var $1KRuL = parcelRequire("1KRuL");

var $e6Osc = parcelRequire("e6Osc");

var $clqre = parcelRequire("clqre");

$7UCsS($7UCsS.S, 'Object', {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $e6Osc(object);
        var getDesc = $clqre.f;
        var keys = $1KRuL(O);
        var result = {};
        var i = 0;
        var key, desc;
        while(keys.length > i){
            desc = getDesc(O, key = keys[i++]);
            if (desc !== undefined) $7bfc6e071d4e0dc7$exports(result, key, desc);
        }
        return result;
    }
});


// https://github.com/tc39/proposal-object-values-entries

var $7UCsS = parcelRequire("7UCsS");

var $8dbc6ce9375cc29c$var$$values = (parcelRequire("fWpbL"))(false);
$7UCsS($7UCsS.S, 'Object', {
    values: function values(it) {
        return $8dbc6ce9375cc29c$var$$values(it);
    }
});


// https://github.com/tc39/proposal-object-values-entries

var $7UCsS = parcelRequire("7UCsS");

var $53d8154e24f25bf9$var$$entries = (parcelRequire("fWpbL"))(true);
$7UCsS($7UCsS.S, 'Object', {
    entries: function entries(it) {
        return $53d8154e24f25bf9$var$$entries(it);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $87N8x = parcelRequire("87N8x");

var $ekEf9 = parcelRequire("ekEf9");

var $1w421 = parcelRequire("1w421");


// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
(parcelRequire("gvp2l")) && $7UCsS($7UCsS.P + (parcelRequire("bDLIM")), 'Object', {
    __defineGetter__: function __defineGetter__(P, getter) {
        $1w421.f($87N8x(this), P, {
            get: $ekEf9(getter),
            enumerable: true,
            configurable: true
        });
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $87N8x = parcelRequire("87N8x");

var $ekEf9 = parcelRequire("ekEf9");

var $1w421 = parcelRequire("1w421");


// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
(parcelRequire("gvp2l")) && $7UCsS($7UCsS.P + (parcelRequire("bDLIM")), 'Object', {
    __defineSetter__: function __defineSetter__(P, setter) {
        $1w421.f($87N8x(this), P, {
            set: $ekEf9(setter),
            enumerable: true,
            configurable: true
        });
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $87N8x = parcelRequire("87N8x");

var $hFD9L = parcelRequire("hFD9L");

var $hQ3EZ = parcelRequire("hQ3EZ");

var $clqre = parcelRequire("clqre");
var $64ac1550ed710ded$require$getOwnPropertyDescriptor = $clqre.f;


// B.2.2.4 Object.prototype.__lookupGetter__(P)
(parcelRequire("gvp2l")) && $7UCsS($7UCsS.P + (parcelRequire("bDLIM")), 'Object', {
    __lookupGetter__: function __lookupGetter__(P) {
        var O = $87N8x(this);
        var K = $hFD9L(P, true);
        var D;
        do {
            if (D = $64ac1550ed710ded$require$getOwnPropertyDescriptor(O, K)) return D.get;
        }while (O = $hQ3EZ(O));
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $87N8x = parcelRequire("87N8x");

var $hFD9L = parcelRequire("hFD9L");

var $hQ3EZ = parcelRequire("hQ3EZ");

var $clqre = parcelRequire("clqre");
var $d7c2d08267503194$require$getOwnPropertyDescriptor = $clqre.f;


// B.2.2.5 Object.prototype.__lookupSetter__(P)
(parcelRequire("gvp2l")) && $7UCsS($7UCsS.P + (parcelRequire("bDLIM")), 'Object', {
    __lookupSetter__: function __lookupSetter__(P) {
        var O = $87N8x(this);
        var K = $hFD9L(P, true);
        var D;
        do {
            if (D = $d7c2d08267503194$require$getOwnPropertyDescriptor(O, K)) return D.set;
        }while (O = $hQ3EZ(O));
    }
});


// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.P + $7UCsS.R, 'Map', {
    toJSON: (parcelRequire("lQsUY"))('Map')
});


// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.P + $7UCsS.R, 'Set', {
    toJSON: (parcelRequire("lQsUY"))('Set')
});


// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of

(parcelRequire("7p3q1"))('Map');


// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of

(parcelRequire("7p3q1"))('Set');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of

(parcelRequire("7p3q1"))('WeakMap');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of

(parcelRequire("7p3q1"))('WeakSet');


// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from

(parcelRequire("8h2Oa"))('Map');


// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from

(parcelRequire("8h2Oa"))('Set');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from

(parcelRequire("8h2Oa"))('WeakMap');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from

(parcelRequire("8h2Oa"))('WeakSet');


// https://github.com/tc39/proposal-global

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.G, {
    global: (parcelRequire("cUEwJ"))
});


// https://github.com/tc39/proposal-global

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S, 'System', {
    global: (parcelRequire("cUEwJ"))
});


// https://github.com/ljharb/proposal-is-error

var $7UCsS = parcelRequire("7UCsS");

var $8t6Im = parcelRequire("8t6Im");
$7UCsS($7UCsS.S, 'Error', {
    isError: function isError(it) {
        return $8t6Im(it) === 'Error';
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    clamp: function clamp(x, lower, upper) {
        return Math.min(upper, Math.max(lower, x));
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    DEG_PER_RAD: Math.PI / 180
});


// https://rwaldron.github.io/proposal-math-extensions/

var $7UCsS = parcelRequire("7UCsS");
var $145ced435050f54d$var$RAD_PER_DEG = 180 / Math.PI;
$7UCsS($7UCsS.S, 'Math', {
    degrees: function degrees(radians) {
        return radians * $145ced435050f54d$var$RAD_PER_DEG;
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $7UCsS = parcelRequire("7UCsS");

var $9GrGy = parcelRequire("9GrGy");

var $3eQaZ = parcelRequire("3eQaZ");
$7UCsS($7UCsS.S, 'Math', {
    fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
        return $3eQaZ($9GrGy(x, inLow, inHigh, outLow, outHigh));
    }
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    iaddh: function iaddh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
    }
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    isubh: function isubh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
    }
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    imulh: function imulh(u, v) {
        var UINT16 = 0xffff;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >> 16;
        var v1 = $v >> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    RAD_PER_DEG: 180 / Math.PI
});


// https://rwaldron.github.io/proposal-math-extensions/

var $7UCsS = parcelRequire("7UCsS");
var $49b953446fd87d99$var$DEG_PER_RAD = Math.PI / 180;
$7UCsS($7UCsS.S, 'Math', {
    radians: function radians(degrees) {
        return degrees * $49b953446fd87d99$var$DEG_PER_RAD;
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $7UCsS = parcelRequire("7UCsS");

$7UCsS($7UCsS.S, 'Math', {
    scale: (parcelRequire("9GrGy"))
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    umulh: function umulh(u, v) {
        var UINT16 = 0xffff;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >>> 16;
        var v1 = $v >>> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
    }
});


// http://jfbastien.github.io/papers/Math.signbit.html

var $7UCsS = parcelRequire("7UCsS");
$7UCsS($7UCsS.S, 'Math', {
    signbit: function signbit(x) {
        // eslint-disable-next-line no-self-compare
        return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
    }
});


// https://github.com/tc39/proposal-promise-finally
'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $ktrQW = parcelRequire("ktrQW");

var $cUEwJ = parcelRequire("cUEwJ");

var $kubSZ = parcelRequire("kubSZ");

$7UCsS($7UCsS.P + $7UCsS.R, 'Promise', {
    'finally': function(onFinally) {
        var C = $kubSZ(this, $ktrQW.Promise || $cUEwJ.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $74ec2602d9f7bc46$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $74ec2602d9f7bc46$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");


$7UCsS($7UCsS.S, 'Promise', {
    'try': function(callbackfn) {
        var promiseCapability = $cd72c2e7e6a2be3e$export$2d1720544b23b823(this);
        var result = $c22e88e9d64ad73e$exports(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
    }
});


var $ce628b05be821c6e$exports = {};


var $7UCsS = parcelRequire("7UCsS");

var $ce628b05be821c6e$var$shared = (parcelRequire("7Ebfd"))('metadata');

var $ce628b05be821c6e$var$store = $ce628b05be821c6e$var$shared.store || ($ce628b05be821c6e$var$shared.store = new (parcelRequire("fvN4d"))());
var $ce628b05be821c6e$var$getOrCreateMetadataMap = function(target, targetKey, create) {
    var targetMetadata = $ce628b05be821c6e$var$store.get(target);
    if (!targetMetadata) {
        if (!create) return undefined;
        $ce628b05be821c6e$var$store.set(target, targetMetadata = new $22bf39feac6c91d1$exports());
    }
    var keyMetadata = targetMetadata.get(targetKey);
    if (!keyMetadata) {
        if (!create) return undefined;
        targetMetadata.set(targetKey, keyMetadata = new $22bf39feac6c91d1$exports());
    }
    return keyMetadata;
};
var $ce628b05be821c6e$var$ordinaryHasOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $ce628b05be821c6e$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var $ce628b05be821c6e$var$ordinaryGetOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $ce628b05be821c6e$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var $ce628b05be821c6e$var$ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P) {
    $ce628b05be821c6e$var$getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var $ce628b05be821c6e$var$ordinaryOwnMetadataKeys = function(target, targetKey) {
    var metadataMap = $ce628b05be821c6e$var$getOrCreateMetadataMap(target, targetKey, false);
    var keys = [];
    if (metadataMap) metadataMap.forEach(function(_, key) {
        keys.push(key);
    });
    return keys;
};
var $ce628b05be821c6e$var$toMetaKey = function(it) {
    return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var $ce628b05be821c6e$var$exp = function(O) {
    $7UCsS($7UCsS.S, 'Reflect', O);
};
$ce628b05be821c6e$exports = {
    store: $ce628b05be821c6e$var$store,
    map: $ce628b05be821c6e$var$getOrCreateMetadataMap,
    has: $ce628b05be821c6e$var$ordinaryHasOwnMetadata,
    get: $ce628b05be821c6e$var$ordinaryGetOwnMetadata,
    set: $ce628b05be821c6e$var$ordinaryDefineOwnMetadata,
    keys: $ce628b05be821c6e$var$ordinaryOwnMetadataKeys,
    key: $ce628b05be821c6e$var$toMetaKey,
    exp: $ce628b05be821c6e$var$exp
};



var $9bg2N = parcelRequire("9bg2N");
var $e7eefbaee85f0c3c$var$toMetaKey = $ce628b05be821c6e$exports.key;
var $e7eefbaee85f0c3c$var$ordinaryDefineOwnMetadata = $ce628b05be821c6e$exports.set;
$ce628b05be821c6e$exports.exp({
    defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
        $e7eefbaee85f0c3c$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $9bg2N(target), $e7eefbaee85f0c3c$var$toMetaKey(targetKey));
    }
});




var $9bg2N = parcelRequire("9bg2N");
var $cdf2e8e8411f6745$var$toMetaKey = $ce628b05be821c6e$exports.key;
var $cdf2e8e8411f6745$var$getOrCreateMetadataMap = $ce628b05be821c6e$exports.map;
var $cdf2e8e8411f6745$var$store = $ce628b05be821c6e$exports.store;
$ce628b05be821c6e$exports.exp({
    deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $cdf2e8e8411f6745$var$toMetaKey(arguments[2]);
        var metadataMap = $cdf2e8e8411f6745$var$getOrCreateMetadataMap($9bg2N(target), targetKey, false);
        if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
        if (metadataMap.size) return true;
        var targetMetadata = $cdf2e8e8411f6745$var$store.get(target);
        targetMetadata['delete'](targetKey);
        return !!targetMetadata.size || $cdf2e8e8411f6745$var$store['delete'](target);
    }
});




var $9bg2N = parcelRequire("9bg2N");

var $hQ3EZ = parcelRequire("hQ3EZ");
var $d00f8c775f3fdba9$var$ordinaryHasOwnMetadata = $ce628b05be821c6e$exports.has;
var $d00f8c775f3fdba9$var$ordinaryGetOwnMetadata = $ce628b05be821c6e$exports.get;
var $d00f8c775f3fdba9$var$toMetaKey = $ce628b05be821c6e$exports.key;
var $d00f8c775f3fdba9$var$ordinaryGetMetadata = function(MetadataKey, O, P) {
    var hasOwn = $d00f8c775f3fdba9$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return $d00f8c775f3fdba9$var$ordinaryGetOwnMetadata(MetadataKey, O, P);
    var parent = $hQ3EZ(O);
    return parent !== null ? $d00f8c775f3fdba9$var$ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};
$ce628b05be821c6e$exports.exp({
    getMetadata: function getMetadata(metadataKey, target /* , targetKey */ ) {
        return $d00f8c775f3fdba9$var$ordinaryGetMetadata(metadataKey, $9bg2N(target), arguments.length < 3 ? undefined : $d00f8c775f3fdba9$var$toMetaKey(arguments[2]));
    }
});




var $cjLYT = parcelRequire("cjLYT");


var $9bg2N = parcelRequire("9bg2N");

var $hQ3EZ = parcelRequire("hQ3EZ");
var $3c1d5d7418d8f8c9$var$ordinaryOwnMetadataKeys = $ce628b05be821c6e$exports.keys;
var $3c1d5d7418d8f8c9$var$toMetaKey = $ce628b05be821c6e$exports.key;
var $3c1d5d7418d8f8c9$var$ordinaryMetadataKeys = function(O, P) {
    var oKeys = $3c1d5d7418d8f8c9$var$ordinaryOwnMetadataKeys(O, P);
    var parent = $hQ3EZ(O);
    if (parent === null) return oKeys;
    var pKeys = $3c1d5d7418d8f8c9$var$ordinaryMetadataKeys(parent, P);
    return pKeys.length ? oKeys.length ? $cjLYT(new $322928a304bc3819$exports(oKeys.concat(pKeys))) : pKeys : oKeys;
};
$ce628b05be821c6e$exports.exp({
    getMetadataKeys: function getMetadataKeys(target /* , targetKey */ ) {
        return $3c1d5d7418d8f8c9$var$ordinaryMetadataKeys($9bg2N(target), arguments.length < 2 ? undefined : $3c1d5d7418d8f8c9$var$toMetaKey(arguments[1]));
    }
});




var $9bg2N = parcelRequire("9bg2N");
var $1d04f412230d796b$var$ordinaryGetOwnMetadata = $ce628b05be821c6e$exports.get;
var $1d04f412230d796b$var$toMetaKey = $ce628b05be821c6e$exports.key;
$ce628b05be821c6e$exports.exp({
    getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */ ) {
        return $1d04f412230d796b$var$ordinaryGetOwnMetadata(metadataKey, $9bg2N(target), arguments.length < 3 ? undefined : $1d04f412230d796b$var$toMetaKey(arguments[2]));
    }
});




var $9bg2N = parcelRequire("9bg2N");
var $88d5d42d67912e35$var$ordinaryOwnMetadataKeys = $ce628b05be821c6e$exports.keys;
var $88d5d42d67912e35$var$toMetaKey = $ce628b05be821c6e$exports.key;
$ce628b05be821c6e$exports.exp({
    getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */ ) {
        return $88d5d42d67912e35$var$ordinaryOwnMetadataKeys($9bg2N(target), arguments.length < 2 ? undefined : $88d5d42d67912e35$var$toMetaKey(arguments[1]));
    }
});




var $9bg2N = parcelRequire("9bg2N");

var $hQ3EZ = parcelRequire("hQ3EZ");
var $974e7add38518c18$var$ordinaryHasOwnMetadata = $ce628b05be821c6e$exports.has;
var $974e7add38518c18$var$toMetaKey = $ce628b05be821c6e$exports.key;
var $974e7add38518c18$var$ordinaryHasMetadata = function(MetadataKey, O, P) {
    var hasOwn = $974e7add38518c18$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return true;
    var parent = $hQ3EZ(O);
    return parent !== null ? $974e7add38518c18$var$ordinaryHasMetadata(MetadataKey, parent, P) : false;
};
$ce628b05be821c6e$exports.exp({
    hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */ ) {
        return $974e7add38518c18$var$ordinaryHasMetadata(metadataKey, $9bg2N(target), arguments.length < 3 ? undefined : $974e7add38518c18$var$toMetaKey(arguments[2]));
    }
});




var $9bg2N = parcelRequire("9bg2N");
var $c27720a2350b73fa$var$ordinaryHasOwnMetadata = $ce628b05be821c6e$exports.has;
var $c27720a2350b73fa$var$toMetaKey = $ce628b05be821c6e$exports.key;
$ce628b05be821c6e$exports.exp({
    hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */ ) {
        return $c27720a2350b73fa$var$ordinaryHasOwnMetadata(metadataKey, $9bg2N(target), arguments.length < 3 ? undefined : $c27720a2350b73fa$var$toMetaKey(arguments[2]));
    }
});




var $9bg2N = parcelRequire("9bg2N");

var $ekEf9 = parcelRequire("ekEf9");
var $e0f6f50aa799bb57$var$toMetaKey = $ce628b05be821c6e$exports.key;
var $e0f6f50aa799bb57$var$ordinaryDefineOwnMetadata = $ce628b05be821c6e$exports.set;
$ce628b05be821c6e$exports.exp({
    metadata: function metadata(metadataKey, metadataValue) {
        return function decorator(target, targetKey) {
            $e0f6f50aa799bb57$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? $9bg2N : $ekEf9)(target), $e0f6f50aa799bb57$var$toMetaKey(targetKey));
        };
    }
});


// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask

var $7UCsS = parcelRequire("7UCsS");

var $713219ef0c6920f7$var$microtask = (parcelRequire("4Je1X"))();

var $cUEwJ = parcelRequire("cUEwJ");
var $713219ef0c6920f7$require$process = $cUEwJ.process;

var $713219ef0c6920f7$var$isNode = (parcelRequire("8t6Im"))($713219ef0c6920f7$require$process) == 'process';
$7UCsS($7UCsS.G, {
    asap: function asap(fn) {
        var domain = $713219ef0c6920f7$var$isNode && $713219ef0c6920f7$require$process.domain;
        $713219ef0c6920f7$var$microtask(domain ? domain.bind(fn) : fn);
    }
});


'use strict';

var $7UCsS = parcelRequire("7UCsS");

var $cUEwJ = parcelRequire("cUEwJ");

var $ktrQW = parcelRequire("ktrQW");

var $dcaf84a517626da8$var$microtask = (parcelRequire("4Je1X"))();

var $dcaf84a517626da8$var$OBSERVABLE = (parcelRequire("5zj8I"))('observable');

var $ekEf9 = parcelRequire("ekEf9");

var $9bg2N = parcelRequire("9bg2N");

var $eEs8C = parcelRequire("eEs8C");

var $edFiS = parcelRequire("edFiS");

var $6G6JS = parcelRequire("6G6JS");

var $2b8La = parcelRequire("2b8La");
var $dcaf84a517626da8$var$RETURN = $2b8La.RETURN;
var $dcaf84a517626da8$var$getMethod = function(fn) {
    return fn == null ? undefined : $ekEf9(fn);
};
var $dcaf84a517626da8$var$cleanupSubscription = function(subscription) {
    var cleanup = subscription._c;
    if (cleanup) {
        subscription._c = undefined;
        cleanup();
    }
};
var $dcaf84a517626da8$var$subscriptionClosed = function(subscription) {
    return subscription._o === undefined;
};
var $dcaf84a517626da8$var$closeSubscription = function(subscription) {
    if (!$dcaf84a517626da8$var$subscriptionClosed(subscription)) {
        subscription._o = undefined;
        $dcaf84a517626da8$var$cleanupSubscription(subscription);
    }
};
var $dcaf84a517626da8$var$Subscription = function(observer, subscriber) {
    $9bg2N(observer);
    this._c = undefined;
    this._o = observer;
    observer = new $dcaf84a517626da8$var$SubscriptionObserver(this);
    try {
        var cleanup = subscriber(observer);
        var subscription = cleanup;
        if (cleanup != null) {
            if (typeof cleanup.unsubscribe === 'function') cleanup = function() {
                subscription.unsubscribe();
            };
            else $ekEf9(cleanup);
            this._c = cleanup;
        }
    } catch (e) {
        observer.error(e);
        return;
    }
    if ($dcaf84a517626da8$var$subscriptionClosed(this)) $dcaf84a517626da8$var$cleanupSubscription(this);
};
$dcaf84a517626da8$var$Subscription.prototype = $edFiS({}, {
    unsubscribe: function unsubscribe() {
        $dcaf84a517626da8$var$closeSubscription(this);
    }
});
var $dcaf84a517626da8$var$SubscriptionObserver = function(subscription) {
    this._s = subscription;
};
$dcaf84a517626da8$var$SubscriptionObserver.prototype = $edFiS({}, {
    next: function next(value) {
        var subscription = this._s;
        if (!$dcaf84a517626da8$var$subscriptionClosed(subscription)) {
            var observer = subscription._o;
            try {
                var m = $dcaf84a517626da8$var$getMethod(observer.next);
                if (m) return m.call(observer, value);
            } catch (e) {
                try {
                    $dcaf84a517626da8$var$closeSubscription(subscription);
                } finally{
                    throw e;
                }
            }
        }
    },
    error: function error(value) {
        var subscription = this._s;
        if ($dcaf84a517626da8$var$subscriptionClosed(subscription)) throw value;
        var observer = subscription._o;
        subscription._o = undefined;
        try {
            var m = $dcaf84a517626da8$var$getMethod(observer.error);
            if (!m) throw value;
            value = m.call(observer, value);
        } catch (e) {
            try {
                $dcaf84a517626da8$var$cleanupSubscription(subscription);
            } finally{
                throw e;
            }
        }
        $dcaf84a517626da8$var$cleanupSubscription(subscription);
        return value;
    },
    complete: function complete(value) {
        var subscription = this._s;
        if (!$dcaf84a517626da8$var$subscriptionClosed(subscription)) {
            var observer = subscription._o;
            subscription._o = undefined;
            try {
                var m = $dcaf84a517626da8$var$getMethod(observer.complete);
                value = m ? m.call(observer, value) : undefined;
            } catch (e) {
                try {
                    $dcaf84a517626da8$var$cleanupSubscription(subscription);
                } finally{
                    throw e;
                }
            }
            $dcaf84a517626da8$var$cleanupSubscription(subscription);
            return value;
        }
    }
});
var $dcaf84a517626da8$var$$Observable = function Observable(subscriber) {
    $eEs8C(this, $dcaf84a517626da8$var$$Observable, 'Observable', '_f')._f = $ekEf9(subscriber);
};
$edFiS($dcaf84a517626da8$var$$Observable.prototype, {
    subscribe: function subscribe(observer) {
        return new $dcaf84a517626da8$var$Subscription(observer, this._f);
    },
    forEach: function forEach(fn) {
        var that = this;
        return new ($ktrQW.Promise || $cUEwJ.Promise)(function(resolve, reject) {
            $ekEf9(fn);
            var subscription = that.subscribe({
                next: function(value) {
                    try {
                        return fn(value);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    }
});
$edFiS($dcaf84a517626da8$var$$Observable, {
    from: function from(x) {
        var C = typeof this === 'function' ? this : $dcaf84a517626da8$var$$Observable;
        var method = $dcaf84a517626da8$var$getMethod($9bg2N(x)[$dcaf84a517626da8$var$OBSERVABLE]);
        if (method) {
            var observable = $9bg2N(method.call(x));
            return observable.constructor === C ? observable : new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        return new C(function(observer) {
            var done = false;
            $dcaf84a517626da8$var$microtask(function() {
                if (!done) {
                    try {
                        if ($2b8La(x, false, function(it) {
                            observer.next(it);
                            if (done) return $dcaf84a517626da8$var$RETURN;
                        }) === $dcaf84a517626da8$var$RETURN) return;
                    } catch (e) {
                        if (done) throw e;
                        observer.error(e);
                        return;
                    }
                    observer.complete();
                }
            });
            return function() {
                done = true;
            };
        });
    },
    of: function of() {
        for(var i = 0, l = arguments.length, items = new Array(l); i < l;)items[i] = arguments[i++];
        return new (typeof this === 'function' ? this : $dcaf84a517626da8$var$$Observable)(function(observer) {
            var done = false;
            $dcaf84a517626da8$var$microtask(function() {
                if (!done) {
                    for(var j = 0; j < items.length; ++j){
                        observer.next(items[j]);
                        if (done) return;
                    }
                    observer.complete();
                }
            });
            return function() {
                done = true;
            };
        });
    }
});
$6G6JS($dcaf84a517626da8$var$$Observable.prototype, $dcaf84a517626da8$var$OBSERVABLE, function() {
    return this;
});
$7UCsS($7UCsS.G, {
    Observable: $dcaf84a517626da8$var$$Observable
});

(parcelRequire("7hk0b"))('Observable');


// ie9- setTimeout & setInterval additional parameters fix

var $cUEwJ = parcelRequire("cUEwJ");

var $7UCsS = parcelRequire("7UCsS");

var $04b10f206f653ff8$var$slice = [].slice;
var $04b10f206f653ff8$var$MSIE = /MSIE .\./.test($ac95f7e5c8150107$exports); // <- dirty ie9- check
var $04b10f206f653ff8$var$wrap = function(set) {
    return function(fn, time /* , ...args */ ) {
        var boundArgs = arguments.length > 2;
        var args = boundArgs ? $04b10f206f653ff8$var$slice.call(arguments, 2) : false;
        return set(boundArgs ? function() {
            // eslint-disable-next-line no-new-func
            (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
        } : fn, time);
    };
};
$7UCsS($7UCsS.G + $7UCsS.B + $7UCsS.F * $04b10f206f653ff8$var$MSIE, {
    setTimeout: $04b10f206f653ff8$var$wrap($cUEwJ.setTimeout),
    setInterval: $04b10f206f653ff8$var$wrap($cUEwJ.setInterval)
});



var $7UCsS = parcelRequire("7UCsS");

var $b4G1J = parcelRequire("b4G1J");
$7UCsS($7UCsS.G + $7UCsS.B, {
    setImmediate: $b4G1J.set,
    clearImmediate: $b4G1J.clear
});



var $7V9Gt = parcelRequire("7V9Gt");

var $abZqb = parcelRequire("abZqb");

var $2niSg = parcelRequire("2niSg");

var $cUEwJ = parcelRequire("cUEwJ");

var $6G6JS = parcelRequire("6G6JS");

var $llfnB = parcelRequire("llfnB");

var $5zj8I = parcelRequire("5zj8I");
var $92a94ab7f33244c7$var$ITERATOR = $5zj8I('iterator');
var $92a94ab7f33244c7$var$TO_STRING_TAG = $5zj8I('toStringTag');
var $92a94ab7f33244c7$var$ArrayValues = $llfnB.Array;
var $92a94ab7f33244c7$var$DOMIterables = {
    CSSRuleList: true,
    CSSStyleDeclaration: false,
    CSSValueList: false,
    ClientRectList: false,
    DOMRectList: false,
    DOMStringList: false,
    DOMTokenList: true,
    DataTransferItemList: false,
    FileList: false,
    HTMLAllCollection: false,
    HTMLCollection: false,
    HTMLFormElement: false,
    HTMLSelectElement: false,
    MediaList: true,
    MimeTypeArray: false,
    NamedNodeMap: false,
    NodeList: true,
    PaintRequestList: false,
    Plugin: false,
    PluginArray: false,
    SVGLengthList: false,
    SVGNumberList: false,
    SVGPathSegList: false,
    SVGPointList: false,
    SVGStringList: false,
    SVGTransformList: false,
    SourceBufferList: false,
    StyleSheetList: true,
    TextTrackCueList: false,
    TextTrackList: false,
    TouchList: false
};
for(var $92a94ab7f33244c7$var$collections = $abZqb($92a94ab7f33244c7$var$DOMIterables), $92a94ab7f33244c7$var$i = 0; $92a94ab7f33244c7$var$i < $92a94ab7f33244c7$var$collections.length; $92a94ab7f33244c7$var$i++){
    var $92a94ab7f33244c7$var$NAME = $92a94ab7f33244c7$var$collections[$92a94ab7f33244c7$var$i];
    var $92a94ab7f33244c7$var$explicit = $92a94ab7f33244c7$var$DOMIterables[$92a94ab7f33244c7$var$NAME];
    var $92a94ab7f33244c7$var$Collection = $cUEwJ[$92a94ab7f33244c7$var$NAME];
    var $92a94ab7f33244c7$var$proto = $92a94ab7f33244c7$var$Collection && $92a94ab7f33244c7$var$Collection.prototype;
    var $92a94ab7f33244c7$var$key;
    if ($92a94ab7f33244c7$var$proto) {
        if (!$92a94ab7f33244c7$var$proto[$92a94ab7f33244c7$var$ITERATOR]) $6G6JS($92a94ab7f33244c7$var$proto, $92a94ab7f33244c7$var$ITERATOR, $92a94ab7f33244c7$var$ArrayValues);
        if (!$92a94ab7f33244c7$var$proto[$92a94ab7f33244c7$var$TO_STRING_TAG]) $6G6JS($92a94ab7f33244c7$var$proto, $92a94ab7f33244c7$var$TO_STRING_TAG, $92a94ab7f33244c7$var$NAME);
        $llfnB[$92a94ab7f33244c7$var$NAME] = $92a94ab7f33244c7$var$ArrayValues;
        if ($92a94ab7f33244c7$var$explicit) {
            for($92a94ab7f33244c7$var$key in $7V9Gt)if (!$92a94ab7f33244c7$var$proto[$92a94ab7f33244c7$var$key]) $2niSg($92a94ab7f33244c7$var$proto, $92a94ab7f33244c7$var$key, $7V9Gt[$92a94ab7f33244c7$var$key], true);
        }
    }
}



$69fac9427df2972b$exports = (parcelRequire("ktrQW"));


var $9c258ff2318e7f68$exports = {};
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */ !function(global1) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var inModule = true;
    var runtime = global1.regeneratorRuntime;
    if (runtime) {
        if (inModule) // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        $9c258ff2318e7f68$exports = runtime;
        // Don't bother evaluating the rest of this file if the runtime was
        // already defined globally.
        return;
    }
    // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.
    runtime = global1.regeneratorRuntime = inModule ? $9c258ff2318e7f68$exports : {};
    function wrap(innerFn, outerFn, self1, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        generator._invoke = makeInvokeMethod(innerFn, self1, context);
        return generator;
    }
    runtime.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function() {
        return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            prototype[method] = function(arg) {
                return this._invoke(method, arg);
            };
        });
    }
    runtime.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    runtime.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            if (!(toStringTagSymbol in genFun)) genFun[toStringTagSymbol] = "GeneratorFunction";
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    runtime.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return Promise.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return Promise.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration. If the Promise is rejected, however, the
                    // result for this iteration will be rejected with the same
                    // reason. Note that rejections of yielded Promises are not
                    // thrown back into the generator function, as is the case
                    // when an awaited Promise is rejected. This difference in
                    // behavior between yield and await is important, because it
                    // allows the consumer to decide what to do with the yielded
                    // rejection (swallow it and continue, manually .throw it back
                    // into the generator, abandon iteration, whatever). With
                    // await, by contrast, there is no opportunity to examine the
                    // rejection reason outside the generator function, so the
                    // only option is to throw it from the await expression, and
                    // let the generator function handle the exception.
                    result.value = unwrapped;
                    resolve(result);
                }, reject);
            }
        }
        if (typeof global1.process === "object" && global1.process.domain) invoke = global1.process.domain.bind(invoke);
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new Promise(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function() {
        return this;
    };
    runtime.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    runtime.async = function(innerFn, outerFn, self1, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList));
        return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self1, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self1, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;
            if (context.method === "throw") {
                if (delegate.iterator.return) {
                    // If the delegate iterator has a return method, give it a
                    // chance to clean up.
                    context.method = "return";
                    context.arg = undefined;
                    maybeInvokeDelegate(delegate, context);
                    if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                }
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator";
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function() {
        return this;
    };
    Gp.toString = function() {
        return "[object Generator]";
    };
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    runtime.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    runtime.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
}(// Among the various tricks for obtaining a reference to the global
// object, this seems to be the most reliable technique that does not
// use indirect eval (which violates Content Security Policy).
typeof $parcel$global === "object" ? $parcel$global : typeof window === "object" ? window : typeof self === "object" ? self : $9c258ff2318e7f68$exports);


var $9cfd14455e27ce16$exports = {};
// https://github.com/benjamingr/RexExp.escape

var $7UCsS = parcelRequire("7UCsS");

var $8dc6dd2ef3c17825$var$$re = (parcelRequire("c3V8e"))(/[\\^$*+?.()|[\]{}]/g, '\\$&');
$7UCsS($7UCsS.S, 'RegExp', {
    escape: function escape(it) {
        return $8dc6dd2ef3c17825$var$$re(it);
    }
});



$9cfd14455e27ce16$exports = (parcelRequire("ktrQW")).RegExp.escape;


if ($parcel$global._babelPolyfill) throw new Error("only one instance of babel-polyfill is allowed");
$parcel$global._babelPolyfill = true;
var $98785cecd0d118eb$var$DEFINE_PROPERTY = "defineProperty";
function $98785cecd0d118eb$var$define(O, key, value) {
    O[key] || Object[$98785cecd0d118eb$var$DEFINE_PROPERTY](O, key, {
        writable: true,
        configurable: true,
        value: value
    });
}
$98785cecd0d118eb$var$define(String.prototype, "padLeft", "".padStart);
$98785cecd0d118eb$var$define(String.prototype, "padRight", "".padEnd);
"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function(key) {
    [][key] && $98785cecd0d118eb$var$define(Array, key, Function.call.bind([][key]));
});




if (typeof Promise === 'undefined') {
    // Rejection tracking prevents a common issue where React gets into an
    // inconsistent state due to an error, but it gets swallowed by a Promise,
    // and the user has no idea what causes React's erratic future behaviour.
    (parcelRequire("9zHsy")).enable(); // eslint-disable-line  @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
    window.Promise = (parcelRequire("dyyZn")); // eslint-disable-line  @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
}
var $df341a136d94422b$exports = {};
(function(self1) {
    'use strict';
    if (self1.fetch) return;
    var support = {
        searchParams: 'URLSearchParams' in self1,
        iterable: 'Symbol' in self1 && 'iterator' in Symbol,
        blob: 'FileReader' in self1 && 'Blob' in self1 && function() {
            try {
                new Blob();
                return true;
            } catch (e) {
                return false;
            }
        }(),
        formData: 'FormData' in self1,
        arrayBuffer: 'ArrayBuffer' in self1
    };
    if (support.arrayBuffer) {
        var viewClasses = [
            '[object Int8Array]',
            '[object Uint8Array]',
            '[object Uint8ClampedArray]',
            '[object Int16Array]',
            '[object Uint16Array]',
            '[object Int32Array]',
            '[object Uint32Array]',
            '[object Float32Array]',
            '[object Float64Array]'
        ];
        var isDataView = function(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        };
        var isArrayBufferView = ArrayBuffer.isView || function(obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
        };
    }
    function normalizeName(name) {
        if (typeof name !== 'string') name = String(name);
        if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) throw new TypeError('Invalid character in header field name');
        return name.toLowerCase();
    }
    function normalizeValue(value) {
        if (typeof value !== 'string') value = String(value);
        return value;
    }
    // Build a destructive iterator for the value list
    function iteratorFor(items) {
        var iterator = {
            next: function() {
                var value = items.shift();
                return {
                    done: value === undefined,
                    value: value
                };
            }
        };
        if (support.iterable) iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    }
    function Headers(headers) {
        this.map = {};
        if (headers instanceof Headers) headers.forEach(function(value, name) {
            this.append(name, value);
        }, this);
        else if (Array.isArray(headers)) headers.forEach(function(header) {
            this.append(header[0], header[1]);
        }, this);
        else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
            this.append(name, headers[name]);
        }, this);
    }
    Headers.prototype.append = function(name, value) {
        name = normalizeName(name);
        value = normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + ',' + value : value;
    };
    Headers.prototype['delete'] = function(name) {
        delete this.map[normalizeName(name)];
    };
    Headers.prototype.get = function(name) {
        name = normalizeName(name);
        return this.has(name) ? this.map[name] : null;
    };
    Headers.prototype.has = function(name) {
        return this.map.hasOwnProperty(normalizeName(name));
    };
    Headers.prototype.set = function(name, value) {
        this.map[normalizeName(name)] = normalizeValue(value);
    };
    Headers.prototype.forEach = function(callback, thisArg) {
        for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
    };
    Headers.prototype.keys = function() {
        var items = [];
        this.forEach(function(value, name) {
            items.push(name);
        });
        return iteratorFor(items);
    };
    Headers.prototype.values = function() {
        var items = [];
        this.forEach(function(value) {
            items.push(value);
        });
        return iteratorFor(items);
    };
    Headers.prototype.entries = function() {
        var items = [];
        this.forEach(function(value, name) {
            items.push([
                name,
                value
            ]);
        });
        return iteratorFor(items);
    };
    if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
    function consumed(body) {
        if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
        body.bodyUsed = true;
    }
    function fileReaderReady(reader) {
        return new Promise(function(resolve, reject) {
            reader.onload = function() {
                resolve(reader.result);
            };
            reader.onerror = function() {
                reject(reader.error);
            };
        });
    }
    function readBlobAsArrayBuffer(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsArrayBuffer(blob);
        return promise;
    }
    function readBlobAsText(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsText(blob);
        return promise;
    }
    function readArrayBufferAsText(buf) {
        var view = new Uint8Array(buf);
        var chars = new Array(view.length);
        for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
        return chars.join('');
    }
    function bufferClone(buf) {
        if (buf.slice) return buf.slice(0);
        else {
            var view = new Uint8Array(buf.byteLength);
            view.set(new Uint8Array(buf));
            return view.buffer;
        }
    }
    function Body() {
        this.bodyUsed = false;
        this._initBody = function(body) {
            this._bodyInit = body;
            if (!body) this._bodyText = '';
            else if (typeof body === 'string') this._bodyText = body;
            else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
            else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
            else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
            else if (support.arrayBuffer && support.blob && isDataView(body)) {
                this._bodyArrayBuffer = bufferClone(body.buffer);
                // IE 10-11 can't handle a DataView body.
                this._bodyInit = new Blob([
                    this._bodyArrayBuffer
                ]);
            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
            else throw new Error('unsupported BodyInit type');
            if (!this.headers.get('content-type')) {
                if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
        };
        if (support.blob) {
            this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                else return this.blob().then(readBlobAsArrayBuffer);
            };
        }
        this.text = function() {
            var rejected = consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
            else if (this._bodyFormData) throw new Error('could not read FormData body as text');
            else return Promise.resolve(this._bodyText);
        };
        if (support.formData) this.formData = function() {
            return this.text().then(decode);
        };
        this.json = function() {
            return this.text().then(JSON.parse);
        };
        return this;
    }
    // HTTP methods whose capitalization should be normalized
    var methods = [
        'DELETE',
        'GET',
        'HEAD',
        'OPTIONS',
        'POST',
        'PUT'
    ];
    function normalizeMethod(method) {
        var upcased = method.toUpperCase();
        return methods.indexOf(upcased) > -1 ? upcased : method;
    }
    function Request(input, options) {
        options = options || {};
        var body = options.body;
        if (input instanceof Request) {
            if (input.bodyUsed) throw new TypeError('Already read');
            this.url = input.url;
            this.credentials = input.credentials;
            if (!options.headers) this.headers = new Headers(input.headers);
            this.method = input.method;
            this.mode = input.mode;
            if (!body && input._bodyInit != null) {
                body = input._bodyInit;
                input.bodyUsed = true;
            }
        } else this.url = String(input);
        this.credentials = options.credentials || this.credentials || 'omit';
        if (options.headers || !this.headers) this.headers = new Headers(options.headers);
        this.method = normalizeMethod(options.method || this.method || 'GET');
        this.mode = options.mode || this.mode || null;
        this.referrer = null;
        if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
        this._initBody(body);
    }
    Request.prototype.clone = function() {
        return new Request(this, {
            body: this._bodyInit
        });
    };
    function decode(body) {
        var form = new FormData();
        body.trim().split('&').forEach(function(bytes) {
            if (bytes) {
                var split = bytes.split('=');
                var name = split.shift().replace(/\+/g, ' ');
                var value = split.join('=').replace(/\+/g, ' ');
                form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
        });
        return form;
    }
    function parseHeaders(rawHeaders) {
        var headers = new Headers();
        // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
        // https://tools.ietf.org/html/rfc7230#section-3.2
        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
        preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
            var parts = line.split(':');
            var key = parts.shift().trim();
            if (key) {
                var value = parts.join(':').trim();
                headers.append(key, value);
            }
        });
        return headers;
    }
    Body.call(Request.prototype);
    function Response(bodyInit, options) {
        if (!options) options = {};
        this.type = 'default';
        this.status = options.status === undefined ? 200 : options.status;
        this.ok = this.status >= 200 && this.status < 300;
        this.statusText = 'statusText' in options ? options.statusText : 'OK';
        this.headers = new Headers(options.headers);
        this.url = options.url || '';
        this._initBody(bodyInit);
    }
    Body.call(Response.prototype);
    Response.prototype.clone = function() {
        return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url
        });
    };
    Response.error = function() {
        var response = new Response(null, {
            status: 0,
            statusText: ''
        });
        response.type = 'error';
        return response;
    };
    var redirectStatuses = [
        301,
        302,
        303,
        307,
        308
    ];
    Response.redirect = function(url, status) {
        if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
        return new Response(null, {
            status: status,
            headers: {
                location: url
            }
        });
    };
    self1.Headers = Headers;
    self1.Request = Request;
    self1.Response = Response;
    self1.fetch = function(input, init) {
        return new Promise(function(resolve, reject) {
            var request = new Request(input, init);
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var options = {
                    status: xhr.status,
                    statusText: xhr.statusText,
                    headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                };
                options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                var body = 'response' in xhr ? xhr.response : xhr.responseText;
                resolve(new Response(body, options));
            };
            xhr.onerror = function() {
                reject(new TypeError('Network request failed'));
            };
            xhr.ontimeout = function() {
                reject(new TypeError('Network request failed'));
            };
            xhr.open(request.method, request.url, true);
            if (request.credentials === 'include') xhr.withCredentials = true;
            else if (request.credentials === 'omit') xhr.withCredentials = false;
            if ('responseType' in xhr && support.blob) xhr.responseType = 'blob';
            request.headers.forEach(function(value, name) {
                xhr.setRequestHeader(name, value);
            });
            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
        });
    };
    self1.fetch.polyfill = true;
})(typeof self !== 'undefined' ? self : $df341a136d94422b$exports);


// Suppress known React warnings from third-party dependencies that are not actionable.
// - styled-components v3/v4 uses the legacy context API (childContextTypes/contextTypes)
// - @atlaskit/dropdown-menu passes `triggerRef` through react-popper which leaks onto DOM elements
// TODO: Remove these suppressions once the underlying dependencies are upgraded.
const $1175b73683a0b2b4$var$originalConsoleError = console.error;
console.error = (...args)=>{
    if (typeof args[0] === 'string' && (args[0].includes('uses the legacy childContextTypes API') || args[0].includes('uses the legacy contextTypes API') || args[0].includes('React does not recognize the `triggerRef` prop on a DOM element'))) return;
    $1175b73683a0b2b4$var$originalConsoleError.apply(console, args);
};



var $gjpYn = parcelRequire("gjpYn");
// Note: Dangerously set the style of the document body
// It's not recommended to use these functions unless very needed
const $5cc51ae9eefcb80d$export$2cf8f63eb3b48542 = ()=>{
    document.body.style.visibility = 'hidden';
    document.body.style.pointerEvents = 'none';
};
const $5cc51ae9eefcb80d$export$43093ecb33b96906 = ()=>{
    document.body.style.visibility = '';
    document.body.style.pointerEvents = 'auto';
};



var $4EIqd = parcelRequire("4EIqd");
(async function preload() {
    const currentURL = window?.location?.pathname;
    // PRE REACTIONS
    // - growth need to hide site admin loading (#SUPERNOVA-267)
    // - Growth ticket (https://hello.atlassian.net/browse/PBAU-45)
    // PC Ticket - https://hello.atlassian.net/browse/PC-12359
    // this is done to smooth out the experience for user
    // the user in growth exp should only see either white screen or opened focusedTask
    if ((0, $gjpYn.matchPath)({
        path: '/s/:cloudId/upflow/paymentdetails'
    }, currentURL)) (0, $5cc51ae9eefcb80d$export$2cf8f63eb3b48542)();
    // find top match
    // TODO: what if more that one?
    const topMatch = Object.keys((0, $4EIqd.ROOT_ROUTES)).filter((route)=>{
        const routeConfig = (0, $4EIqd.ROOT_ROUTES)[route];
        const pattern = {
            path: route,
            // In React Router v6, routes are exact by default (end: true).
            // The `exact` option from v5 is removed. Use `end: false` for non-exact matching.
            // If routeConfig.exact is false, we want non-exact matching (end: false)
            // Otherwise, use default exact matching (end: true or omit it)
            ...routeConfig?.exact === false ? {
                end: false
            } : {}
        };
        return (0, $gjpYn.matchPath)(pattern, currentURL);
    })[0];
    if (topMatch === undefined) return;
    /* eslint-disable  no-console */ const blockName = `\u{1F69B} preloading ${topMatch}`;
    console.time(blockName);
    try {
        // Loadable has broken definitions
        await (0, $4EIqd.ROOT_ROUTES)[topMatch].importer.preload();
    } finally{
        console.timeEnd(blockName);
    }
/* eslint-enable */ })();



var $hBZYs = parcelRequire("hBZYs");

// the idea of the following construction is to preload "next" js chunk
// and let it load while browser would execute "the rest" JS
/* eslint-disable */ (async ()=>{
    // load the rest of application after "two ticks" to let
    // browser start network requests.
    await 1;
    await 2;
    (0, $hBZYs.initSentry)();
    // we are using import in "eager" mode - it does not cause code splitting
    // we are just deffering the code executing, nothing more
    await (parcelRequire("7Yxfg"));
})(); /* eslint-enable */ 


//# sourceMappingURL=index.f8651c74.js.map
